webpackJsonp([0],Array(21).concat([
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// /* global gettext */

var HSPLITTER = exports.HSPLITTER = Math.min(650, $(window).width() / 2); // position of splitter without aggregate
var WSPLITTER = exports.WSPLITTER = $(window).height() / 2; // position of splitter without aggregate

var DEFAULT_MODE = exports.DEFAULT_MODE = 'explore';
var DEFAULT_DRILL = exports.DEFAULT_DRILL = 'agent_time@ymdh:hour';
var DEFAULT_FILTERS = exports.DEFAULT_FILTERS = []; //
var DEFAULT_STAT_LIMIT = exports.DEFAULT_STAT_LIMIT = 5000;
var DEFAULT_FEEDBACK_URL = exports.DEFAULT_FEEDBACK_URL = '';

var DEFAULT_MEASURES = exports.DEFAULT_MEASURES = {
  'call_duration_sum': gettext('Время разговора'),
  'activity_time_sum': gettext('Время активности'),
  'record_count': gettext('Количество событий'),
  'file_size_sum': gettext('Размер файла')
};

var IS_IE_BROWSER = exports.IS_IE_BROWSER = function () {
  var uAgent = window.navigator.userAgent;
  return !!uAgent.match(/Trident.*rv\:11\./) || !!uAgent.match(/MSIE/);
}();

var USE_CACHE = exports.USE_CACHE = true;
var HARD_LIMIT = exports.HARD_LIMIT = 100;
var DEFAULT_FILTER_LIMIT = exports.DEFAULT_FILTER_LIMIT = 50;
var PATH_STRING_SEPARATOR = exports.PATH_STRING_SEPARATOR = 'ʻ'; // inverted comma

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

var _datetime = __webpack_require__(61);

var _typeDimensions = __webpack_require__(147);

var _filterMode = __webpack_require__(88);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FILTER_COUNT = 1;
var DEFAULT_NAME = gettext('Фильтр');

var Filter = exports.Filter = function () {
  function Filter(name) {
    _classCallCheck(this, Filter);

    this.name = name || DEFAULT_NAME + ' ' + FILTER_COUNT;
    this.drilldown = window.defaultDimension ? [defaultDimension] : [];
  }

  /**
   * Set subview type
   * one of: explore, series, chart
   */

  _createClass(Filter, [{
    key: 'setMode',
    value: function setMode(mode) {
      if (this.measure === 'total_elements' && mode !== 'summ-stat') delete this.measure;
      if (this.mode !== mode) {
        if (this.isDashboard) this.content_type = 'filter';
        this.changed();
      }
      this.mode = mode;
    }
  }, {
    key: 'getIcon',
    value: function getIcon() {
      return (0, _filterMode.getFilterIcon)(this);
    }
  }, {
    key: 'getFilterError',
    value: function getFilterError() {
      var MAX_SAFE_INTEGER = 9007199254740991;
      if (this.content_type === 'policy' || this.isAnalyticPolitic) {
        if (this.filters && !this.filters.length && !this.hasQuery) return gettext('Пожалуйста, ограничьте обьем обрабатываемых данных создав фильтр в конструкторе.');
      }
      if (this.send_threshold) {
        if (this.threshold_period < 0 || this.threshold_period >= MAX_SAFE_INTEGER) return gettext('Неверное значение "Период порога срабатывания"!');
        if (this.threshold < 0 || this.threshold >= MAX_SAFE_INTEGER) return gettext('Неверное значение "Достижение порога срабатывания"!');
      }
      // let errDim = '';
      // if (this.filters && this.filters.some(f => {
      //     errDim = f.dimension;
      //     return f.value === '';
      //   })) return gettext('Неверное значение измерения') + `: "${errDim}"`;
      return this.getQueryError();
    }
  }, {
    key: 'getQueryError',
    value: function getQueryError() {
      if (!this.hasQuery) return null;
      // if (this.filters.length &&
      //   !angular.equals(this.query, {
      //     operator: 'AND',
      //     rules: []
      //   })) return gettext('У вас уже выбраны параметры фильтра через конструктор. Совместное использование такого фильтра с условиями сложного запроса работать не будет!');
      if (this.query.operator !== 'AND' && this.query.operator !== 'OR') return gettext('неправильный оператор ("operator")');
      var _isStrictDimention = _typeDimensions.isStrictDimention;
      var getRuleError = function getRuleError(rule) {
        var allowSameValueLabel = function allowSameValueLabel(dim, hier) {
          var allow = {
            agent_time: {
              hour: true,
              time_zone: true,
              y: true
            }
          };
          return allow[dim] && allow[dim][hier];
        };

        if (rule.group) return rule.group.operator === 'AND' || rule.group.operator === 'OR' ? null : gettext('неправильный оператор ("operator")');
        if (!rule.condition) return gettext('отсутсвует условие ("condition")');
        if (rule.condition !== '=' && rule.condition !== '!' && rule.condition !== '^' && rule.condition !== '!^') return gettext('неправильное условие ("condition")');
        if (!rule.dimension) return gettext('отсутсвует "dimension"');
        if (!rule.hierarchy) return gettext('отсутсвует "hierarchy"');
        // if (!rule.value) return gettext('неверное значение') + ' ("value")';
        if (_isStrictDimention(rule.dimension, rule.hierarchy)) {
          if (!rule.label) return gettext('отсутствует значение');
          if (rule.value === rule.label && !allowSameValueLabel(rule.dimension, rule.hierarchy)) return gettext('неверное значение') + (' "' + rule.label + '"');
        }
        // if (_isStrictDimention(rule.dimension, rule.hierarchy) && !rule.label && rule.value === rule.label) return gettext('неверное значение') + ` "${rule.label}"`;
        // if ((rule.condition === '=' || rule.condition === '!') && !rule.label) return gettext('неверное значение "label"');
        return null;
      };

      var errMessage = null;
      var iter = function iter(rules) {
        if (!rules.length) return null;
        rules.some(function (rule) {
          errMessage = getRuleError(rule);
          if (errMessage) return true;
          if (rule.group && rule.group.rules && rule.group.rules.length) return iter(rule.group.rules);
          return false;
        });
        return errMessage;
      };
      iter(this.query.rules);

      return errMessage;
    }
  }, {
    key: 'setList',
    value: function setList(mode) {
      this.setMode('explore');
      this.listType = mode;
    }
  }, {
    key: 'toggleSkipStat',
    value: function toggleSkipStat() {
      this.skipStat = !this.skipStat;
    }

    /**
     * Add drilldown (X) dimension
     */

  }, {
    key: 'addDrilldown',
    value: function addDrilldown(dimension) {
      if (!this.drilldown || !this.drilldown.length) {
        this.drilldown = [dimension];
      } else {
        this.drilldown.push(dimension);
      }
    }

    /**
     * Set drilldown (X) dimension
     */

  }, {
    key: 'replaceDrilldown',
    value: function replaceDrilldown(newDim, oldDim) {
      var ax = this.drilldown.indexOf(oldDim);
      if (ax !== -1) {
        this.drilldown[ax] = newDim;
      }
    }
  }, {
    key: 'setDrilldown',
    value: function setDrilldown(dimension) {
      //             console.log('Set drilldown', dimension);
      this.drilldown = [dimension];
      this.setOrder(dimension);
    }

    /**
     * Remove drilldown (X) dimension
     */

  }, {
    key: 'removeDrilldown',
    value: function removeDrilldown(name) {
      var ax = void 0;
      if ((ax = this.drilldown.indexOf(name)) !== -1) {
        this.drilldown.splice(ax, 1);
      }
      this.order = null;
      this.orderDim = this.order;
      this.orders.splice(0, this.orders.length);
      this.orders.push('measure');
      this.orderDirs.splice(0, this.orderDirs.length);
      this.orderDirs.push('desc');
    }

    /* True if filters has drilldown */

  }, {
    key: 'hasDrilldown',
    value: function hasDrilldown(name) {
      return this.drilldown.indexOf(name) !== -1;
    }

    /* add child filter */

  }, {
    key: 'addChild',
    value: function addChild(filter) {
      this.removeChild(filter);
      this.children.push(filter);
    }

    /* Remove child filter */

  }, {
    key: 'removeChild',
    value: function removeChild(filter) {
      this.children = (this.children || []).filter(function (e) {
        return e.id != filter.id;
      });
    }
  }, {
    key: 'find',
    value: function find(predicate) {
      if (predicate(this)) {
        return this;
      }
      for (var i = 0; i < this.children.length; ++i) {
        var child = this.children[i];
        var f = child.find(predicate);
        if (f) {
          return f;
        }
      }
    }
  }, {
    key: 'typize',
    value: function typize(path) {
      if (!path) {
        path = this.name;
      } else {
        path = path + ' | ' + this.name;
      }
      this.saved = true;
      this._changed = undefined;
      this.path = path;
      // this.orders = ['measure'];
      // this.orderDirs = ['desc'];
      this.children = this.children.map(function (child) {
        child = Object.setPrototypeOf(child, Filter.prototype);
        child.typize(path);
        return child;
      });
    }
  }, {
    key: 'getPathName',
    value: function getPathName() {
      return this.path || this.name;
    }
  }, {
    key: 'isActive',
    value: function isActive(drilldown_name) {
      var active = this.drilldown.indexOf(drilldown_name) >= 0;
      return active;
    }
  }, {
    key: 'isParent',
    value: function isParent(drilldown_name) {
      for (var index in this.drilldown) {
        var drill = this.drilldown[index];
        if (drill.split('@')[0] === drilldown_name.split('@')[0]) return true;
      }
      return false;
    }
  }, {
    key: 'hasFilters',
    value: function hasFilters() {
      return this.drilldown.length || this.filters.length || this.xaxis != null;
    }
  }, {
    key: 'hasFilter',
    value: function hasFilter(filter) {
      return this.filters.some(function (item) {
        return item.dimension === filter.dimension && (item.value === filter.value || item.dimension === 'agent_agent@computer_name:computer_name' && filter.value.split(_config.PATH_STRING_SEPARATOR)[0] === item.value);
      });
    }
  }, {
    key: 'setOrder',
    value: function setOrder(dimension, attr) {
      this.orderDim = dimension;
      if (Filter.isTimeDimension(dimension)) {
        this.orderDir = 'desc';
        this.order = Filter.orderForTimeDimension(dimension);
      } else if (dimension === 'agent_time@hour:hour') {
        this.orderDir = 'asc';
        this.order = 'agent_time.hour';
      } else if (dimension === 'agent_time@weekday:weekday') {
        this.orderDir = 'asc';
        this.order = 'agent_time.weekday';
      } else {
        this.orderDir = 'desc';
        this.order = attr || 'record_count';
      }
      this.changed();
    }
  }, {
    key: 'addKeyword',
    value: function addKeyword(keyword) {
      this.filters = $.grep(this.filters, function (e) {
        return e.value == keyword;
      }, true);
      this.filters.push({
        'dimension': 'keyword',
        'value': keyword,
        'label': keyword
      });
      this.changed();
    }
  }, {
    key: 'setKeyword',
    value: function setKeyword(keyword) {
      this.filters = $.grep(this.filters, function (e) {
        return e.dimension === 'keyword';
      }, true);
      keyword && this.filters.push({
        'dimension': 'keyword',
        'value': keyword,
        'label': keyword
      });
      this.changed();
    }
  }, {
    key: 'copyFrom',
    value: function copyFrom(srcFilter, skipActive) {
      var _this = this;

      if (!skipActive) {
        angular.copy(srcFilter, this);
      } else {
        this.filters = srcFilter.filters.filter(function (filter) {
          return !_this.isActive(filter.dimension);
        });
        ['id', 'mode', 'listType', 'xaxis', 'charttype', 'name', 'timeFrom', 'timeTo'].forEach(function (property) {
          _this[property] = srcFilter[property];
        });
      }
    }
  }, {
    key: 'addTimeFilter',
    value: function addTimeFilter(date, level, isUTCtime) {
      if (!date) return;
      if (!isUTCtime) date = Filter.toUTCTime(date);
      this.addFilter(Filter.timeDimensionForLevel(level), Filter.valueForTime(date, level, true), Filter.labelForTime(date, level));
    }
  }, {
    key: 'setTimeFilter',
    value: function setTimeFilter(date, level, isUTCtime) {
      if (!isUTCtime) date = Filter.toUTCTime(date);
      this.setFilter(Filter.timeDimensionForLevel(level), Filter.valueForTime(date, level), Filter.labelForTime(date, level));
    }
  }, {
    key: 'cleanFilter',
    value: function cleanFilter(dimension) {
      if (!dimension) return;
      if ((typeof dimension === 'undefined' ? 'undefined' : _typeof(dimension)) === 'object') {
        dimension = dimension.dimension;
      }
      //             console.log('removeFilter', dimension, value );
      this.filters = this.filters.filter(function (filter) {
        return filter.dimension !== dimension;
      });
      this.changed();
    }
  }, {
    key: 'addFilter',
    value: function addFilter(dimension, value, label, predicates) {
      if (!dimension) return;
      if (dimension instanceof Date) return this.addTimeFilter(dimension, value, true);
      this.removeFilter(dimension, value);
      if (dimension === 'agent_time@weekday:weekday') {
        label = _datetime.WEEKDAYS[value];
      }
      this.filters.push({
        'dimension': dimension,
        'value': value,
        'label': label,
        'predicates': predicates ? predicates : []
      });
      this.changed();
    }
  }, {
    key: 'changed',
    value: function changed() {
      this._changed = true;
    }
  }, {
    key: 'setFilter',
    value: function setFilter(dimension, value, label) {
      if (!dimension) return;
      if (dimension instanceof Date) return this.setTimeFilter(dimension, value, label);
      this.setOrder(dimension);
      this.filters = [{
        'dimension': dimension,
        'value': value,
        'label': label
      }];
      this.changed();
    }
  }, {
    key: 'removeFilter',
    value: function removeFilter(dimension, value) {
      if ((typeof dimension === 'undefined' ? 'undefined' : _typeof(dimension)) === 'object') {
        value = dimension.value;
        dimension = dimension.dimension;
      }
      if (!dimension) return;
      //             console.log('removeFilter', dimension, value );
      this.filters = this.filters.filter(function (filter) {
        return filter.dimension !== dimension || filter.value !== value && !(dimension === 'agent_agent@computer_name:computer_name' && value.split(_config.PATH_STRING_SEPARATOR)[0] === filter.value);
      });
      this.changed();
    }
  }, {
    key: 'invertFilter',
    value: function invertFilter(dimension, value) {
      if ((typeof dimension === 'undefined' ? 'undefined' : _typeof(dimension)) === 'object') {
        value = dimension.value;
        dimension = dimension.dimension;
      }
      if (!dimension) return;
      this.filters.forEach(function (e) {
        if (e.dimension === dimension && e.value == value) {
          if (!e.predicates) {
            e.predicates = [];
          }
          if (~e.predicates.indexOf('!')) {
            e.predicates.pop('!');
          } else e.predicates.push('!');
        }
      });
      this.changed();
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(filter) {
      if (this.hasFilter(filter)) {
        this.removeFilter(filter.dimension, filter.value);
      } else {
        // if (this.isViewChat && filter.dimension === 'agent_dialog@members:members' ) {
        //   this.filters = this.filters.filter(f => f.dimension !== filter.dimension);
        // }
        this.addFilter(filter.dimension, filter.value, filter.label);
      }
    }
  }, {
    key: 'reSetFilter',
    value: function reSetFilter(filter) {
      this.cleanFilter(filter.dimension);
      this.addFilter(filter.dimension, filter.value, filter.label);
    }
  }, {
    key: 'addCut',
    value: function addCut(cut) {
      if (!this.hasFilter(cut)) {
        this.addFilter(cut.dimension, cut.value, cut.label);
      }
    }
  }, {
    key: 'viewModeType',
    value: function viewModeType() {
      var params = this.buildQueryParams();
      var eventtype = '';
      var c = 0;
      if (params && params.dim && params.dim.length) {
        for (var i = 0; i < params.dim.length; i++) {
          if (params.dim[i] === 'agent_eventtype@default:agent_eventtype') {
            eventtype = params.filter[i];
            c++;
            if (c === 2) {
              break;
            }
          }
        }
      }
      return c == 1 ? eventtype : null;
    }
  }, {
    key: 'count',
    value: function count(fieldName) {
      if (this.children && this.children.length) {
        return this.children.reduce(function (prev, child) {
          return prev + (child.count ? child.count(fieldName) : 0);
        }, this[fieldName]);
      }
      return this[fieldName];
    }
  }, {
    key: 'hasProp',
    value: function hasProp(fieldName) {
      if (this.children && this.children.length) {
        return this.children.some(function (f) {
          return f.hasProp(fieldName);
        });
      }
      return !!this[fieldName];
    }

    /**
     * Builds Server query parameters based on current values.
     */

  }, {
    key: 'buildQueryParams',
    value: function buildQueryParams() {
      var params = {};
      var drilldown = this.drilldown.slice(0);

      // Include drilldown array
      if (drilldown.length > 0) {
        params['drill'] = drilldown;
      }

      // Include filters
      var dims = [];
      var filters = [];

      if (this.isChartArea) {
        params['chartAreaType'] = this.chartAreaType;
        params['chartAreaIsStacked'] = this.chartAreaIsStacked;
      }

      if (this.isGraph) {
        params['measure'] = this.measure;
      }

      this.filters.forEach(function (e) {
        dims.push(e.dimension);
        filters.push((e.predicates ? e.predicates.join('') : '') + e.value);
      });

      if (dims.length) {
        params['dim'] = dims;
        params['filter'] = filters;
      }

      if (this.order) {
        params['order'] = this.order;
        params['dir'] = this.orderDir;
      }

      if (this.isAnomaly || this.threshold) {
        params['threshold'] = this.threshold;
      }

      if (!this.facts_count) {
        if (this.timeFrom) {
          params['time_from'] = Filter.dateToUrl(this.timeFrom);
        }
        if (this.timeTo) {
          params['time_to'] = Filter.dateToUrl(this.timeTo);
        }
      }

      if (this.top_len) {
        params.top_len = this.top_len;
      }

      params.page = this.page;
      if (this.facts_count) {
        if (this.facts_count < _config.HARD_LIMIT) {
          params.limit = this.facts_count;
        } else {
          params.limit = _config.HARD_LIMIT;
        }
      } else {
        params.limit = this.limit;
      }

      if (this.lookup) {
        params.lookup = this.lookup;
      }

      if (this.simular) {
        params.simular = this.simular;
      }

      params.id = this.id;
      if (this.hasQuery) {
        params.query = JSON.stringify(this.query);
      }

      if (window.BACKEND) params.backend = window.BACKEND;

      return params;
    }
  }, {
    key: 'as_text',
    value: function as_text() {
      return this.filters.reduce(function (previousValue, currentItem) {
        var predicates_value = currentItem.predicates ? currentItem.predicates.reduce(function (p, c) {
          return c + p;
        }, '') : '';
        var line = currentItem.dimension + '=' + predicates_value + currentItem.value;
        if (currentItem.value != currentItem.label) {
          line += '#' + currentItem.label;
        }
        return previousValue + line + '\n';
      }, '');
    }
  }, {
    key: 'from_text',
    value: function from_text(text) {
      var new_filters = text.split('\n').filter(function (s) {
        return !!s;
      }).map(function (f) {
        var label = '';
        var value = void 0;
        var dim = void 0;
        var valpart = void 0;
        if (f.indexOf('=') >= 0) {
          dim = f.split('=')[0];
          valpart = f.split('=')[1];
          if (valpart.indexOf('#') >= 0) {
            value = valpart.split('#')[0];
            label = valpart.split('#')[1];
          } else {
            value = valpart;
          }
        } else {
          dim = 'keyword';
          value = '+' + f;
          label = f;
        }
        var predicates_list = ['~', '+', '&', '!'];
        var predicates = [];
        var i = 0;
        while (predicates_list.indexOf(value[i]) >= 0 && i < value.length) {
          predicates.push(value[i]);
          i += 1;
        }
        value = value.substr(i);
        // for (const i in predicates_list) {
        //   const p = predicates_list[i];
        //   if (value.indexOf(p) >= 0) {
        //     predicates.push(p);
        //     value = value.replace(p, '');
        //   }
        // }
        if (!label) label = value;
        return {
          'dimension': dim,
          'value': value,
          'label': label,
          'predicates': predicates
        };
      });
      this.filters = new_filters;
      this.changed();
    }
  }, {
    key: 'getPath',
    value: function getPath(filter) {
      if (this.id === filter.id) {
        return [];
      }
      for (var i = 0; i < this.children.length; ++i) {
        var f = this.children[i];
        var path = f.getPath(filter);
        if (path) {
          return [this].concat(_toConsumableArray(path));
        }
      }
    }
  }, {
    key: 'customLimit',
    get: function get() {
      return this.hasOwnProperty('limit') ? this.limit : 0;
    },
    set: function set(limit) {
      var l = parseInt(limit, 10);
      if (isNaN(l) || !l) delete this.limit;else this.limit = l;
    }
  }, {
    key: 'isContainer',
    get: function get() {
      return this.content_type === 'folder' || this.isCard || this.isDashboard;
    }
  }, {
    key: 'isPolitic',
    get: function get() {
      // return this.content_type !== 'filter' && !this.isContainer && !this.isAnalyticPolitic;
      return this.content_type !== 'filter' && !this.isContainer && this.content_type !== 'filteraggregatealertfilter';
    }
  }, {
    key: 'isAnalyticPolitic',
    get: function get() {
      return this.content_type === 'corpusprocessfilter';
    }
  }, {
    key: 'isExplore',
    get: function get() {
      return this.mode === 'explore';
    }
  }, {
    key: 'isChart',
    get: function get() {
      return this.mode === 'chart';
    }
  }, {
    key: 'isChartArea',
    get: function get() {
      return this.mode === 'chart-area';
    }
  }, {
    key: 'isRadar',
    get: function get() {
      return this.mode === 'radar';
    }
  }, {
    key: 'isEventRiver',
    get: function get() {
      return this.mode === 'event-river';
    }
  }, {
    key: 'isViewChat',
    get: function get() {
      return this.isExplore && this.listType === 'chat-viewer';
    }
  }, {
    key: 'isStat',
    get: function get() {
      return this.mode === 'stat';
    }
  }, {
    key: 'isSummStat',
    get: function get() {
      return this.mode === 'summ-stat';
    }
  }, {
    key: 'isReport',
    get: function get() {
      return this.mode === 'report';
    }
  }, {
    key: 'isReports',
    get: function get() {
      return this.mode === 'reports';
    }

    // isFilterEdit() {
    //   return this.modal === 'filter-edit';
    // }


  }, {
    key: 'isTree',
    get: function get() {
      return this.mode === 'tree';
    }
  }, {
    key: 'isGraph',
    get: function get() {
      return this.isReports && this.url === '/analytics/report/graph/wizard/';
    }
  }, {
    key: 'isAnalysis',
    get: function get() {
      return this.isReport || this.isStat || this.isSummStat || this.isChartArea || this.isChart || this.isTree || this.isRadar || this.isEventRiver;
    }
  }, {
    key: 'isAnomaly',
    get: function get() {
      return this.isReports && this.url === '/analytics/report/anomaly/';
    }
  }, {
    key: 'isCatalog',
    get: function get() {
      return this.children.length && this.isExplore && this.content_type === 'folder';
    }
  }, {
    key: 'isCard',
    get: function get() {
      return this.isReports && this.url === '/analytics/card/' || this.content_type === 'dimensioncardfilter' || this.mode === 'card';
    }
  }, {
    key: 'isCardFilter',
    get: function get() {
      var _this2 = this;

      return this.isCard && !!this.filters && this.filters[0] && this.filters.filter(function (f) {
        return f.dimension === _this2.filters[0].dimension;
      }).length === 1;
    }
  }, {
    key: 'isDashboard',
    get: function get() {
      return this.mode === 'dashboard' || this.content_type === 'dashboard' || this.isDimensionCard;
    }
  }, {
    key: 'isCardOrDashboard',
    get: function get() {
      return this.isDashboard || this.isCard;
    }
  }, {
    key: 'isCardAccount',
    get: function get() {
      return this.isCard && this.drilldow && this.drilldow[0] && this.drilldown[0].startsWith('agent_account@');
    }
  }, {
    key: 'isDimensionCard',
    get: function get() {
      return this.content_type === 'dimensioncardfilter' && !this.cardFilter;
    }
  }, {
    key: 'isViewFacts',
    get: function get() {
      return this.isExplore && (this.listType === 'table' || this.listType === 'brief' || this.listType === 'thumblist') || this.isReport;
    }
  }, {
    key: 'isViewStat',
    get: function get() {
      return this.isStat || this.isChartArea || this.isChart || this.isGraph || this.isTree;
    }
  }, {
    key: 'isViewReport',
    get: function get() {
      return this.isReports && !this.isGraph;
    }
  }, {
    key: 'hasQuery',
    get: function get() {
      return this.query && this.query.rules && this.query.rules.length;
    }
  }, {
    key: 'isChanged',
    get: function get() {
      return !!this._changed;
    },
    set: function set(bool) {
      this._changed = bool ? true : undefined;
    }
  }], [{
    key: 'locLabel',
    value: function locLabel(filter) {
      return filter.dimension === 'agent_agent@last_report:last_report' ? gettext(filter.label) : filter.label;
    }
  }, {
    key: 'orderForTimeDimension',
    value: function orderForTimeDimension(dimension) {
      var levels = {
        'agent_time@hour:hour': 'agent_time.hour',
        'agent_time@y:year': 'agent_time.year',
        'agent_time@ym:month': 'agent_time.year,agent_time.month',
        'agent_time@ymd:day': 'agent_time.year,agent_time.month,agent_time.day',
        'agent_time@ymdh:hour': 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour',
        'agent_time@ymdhm:minute': 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour,agent_time.minute'
      };
      return levels[dimension];
    }
  }, {
    key: 'isTimeDimension',
    value: function isTimeDimension(dimension) {
      return dimension && dimension !== 'agent_time@time_zone:time_zone' && dimension !== 'agent_time@hour:hour' && dimension !== 'agent_time@weekday:weekday' && dimension.indexOf('agent_time') === 0;
    }
  }, {
    key: 'timeDimensionForLevel',
    value: function timeDimensionForLevel(level) {
      var levels = ['agent_time@y:year', 'agent_time@ym:month', 'agent_time@ymd:day', 'agent_time@ymdh:hour', 'agent_time@ymdhm:minute'];
      return levels[level - 1];
    }
  }, {
    key: 'levelsToTime',
    value: function levelsToTime(levels) {
      if (levels.length === 1) {
        var date = new Date();
        date.setFullYear(levels[0]);
        return date;
      }
      levels[1]--;

      function applyToConstructor(constructor, argArray) {
        var args = [null].concat(argArray);
        var FactoryFunction = constructor.bind.apply(constructor, args);
        return new FactoryFunction();
      }

      //             return new Date( Date.UTC.apply( Date, levels ) );
      return applyToConstructor(Date, levels);
    }
  }, {
    key: 'valueForTime',
    value: function valueForTime(date, level, isUTCtime) {
      if (!isUTCtime) {
        date = Filter.toUTCTime(date);
      }
      var levels = [date.getFullYear(), date.getMonth() + 1, date.getDate(), date.getHours(), date.getMinutes()];
      return levels.splice(0, level).join(_config.PATH_STRING_SEPARATOR); // inverted comma
    }
  }, {
    key: 'toUTCTime',
    value: function toUTCTime(date, level) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    }

    // static labelForTimeOld(date, level) {
    //   let format = [
    //     'yyyy', 'MMM-yyyy', 'dd-MMM-yyyy',
    //     'dd-MMM-yyyy HH:00-HH:59', 'dd-MMM-yyyy HH:mm',
    //   ][level - 1];
    //   return Filter.formatDate(date, format);
    // }

  }, {
    key: 'labelForTime',
    value: function labelForTime(date, level) {
      var format = ['YYYY', 'MMM-YYYY', 'DD-MMM-YYYY', 'DD-MMM-YYYY HH:00-HH:59', 'DD-MMM-YYYY HH:mm'][level - 1];
      return (0, _moment2.default)(date).format(format);
    }
  }, {
    key: 'dateToUrl',
    value: function dateToUrl(date) {
      // if (!(date instanceof Date)) return date;
      if (!date.getFullYear) return date;
      return date.getFullYear() + '-' + ('0' + String(date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + 'T' + ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2) + ':' + ('0' + date.getSeconds()).slice(-2) + '.' + ('00' + date.getMilliseconds()).slice(-3);
    }
  }, {
    key: 'urlToDate',
    value: function urlToDate(text) {
      var date = new Date(Date.parse(text));
      if (isNaN(date.getTime())) {
        // carry about html2pdf
        date = new Date(Date.parse(text + 'Z'));
        if (isNaN(date.getTime())) {
          return null;
        }
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
      }
      return date;
    }
  }]);

  return Filter;
}();

// GUI state


Filter.prototype.id = 0;
Filter.prototype.mode = _config.DEFAULT_MODE; // explore, chart, report, stat
Filter.prototype.listType = 'table'; // full or brief or table
Filter.prototype.url = '/analytics/report/aggregate/index/';
Filter.prototype.content_type = 'filter';
Filter.prototype.threshold = 10;

// Cube slice
Filter.prototype.drilldown = [];
Filter.prototype.filters = _config.DEFAULT_FILTERS;

Filter.prototype.children = [];

Filter.prototype.dimension = _config.DEFAULT_DRILL;

Filter.prototype.measure = 'record_count';

// Time range
Filter.prototype.timeFrom = null;
Filter.prototype.timeTo = null;

// Paginator
Filter.prototype.page = 0;
Filter.prototype.limit = _config.DEFAULT_FILTER_LIMIT;

Filter.prototype.order = 'record_count';
Filter.prototype.orderDim = null;
Filter.prototype.orderDir = 'desc';

Filter.prototype.shared = false;
Filter.prototype.saved = false;

Filter.prototype.category = 'neutral';
Filter.prototype.cardWidth = 12;
Filter.prototype.cardHeight = 0;

Filter.prototype.orders = ['measure'];
Filter.prototype.orderDirs = ['desc'];

Filter.prototype.chartAreaType = 'bar';

Filter.prototype.apply_users = [];
Filter.prototype.do_scan = false;
Filter.prototype.email_body_template = '';
Filter.prototype.email_subject_template = '';
Filter.prototype.emails = '';
Filter.prototype.facts_count = 0;
Filter.prototype.mail_login = '';
Filter.prototype.mail_password = '';
Filter.prototype.mail_server = '';
Filter.prototype.notify = false;
Filter.prototype.orientation = false;
Filter.prototype.record_count = false;
Filter.prototype.reporting_schedule_type = '';
Filter.prototype.save_on_disk = false;
Filter.prototype.send_threshold = false;
Filter.prototype.split_by_user = false;
Filter.prototype.threshold_period = null;
Filter.prototype.threshold_type = '';
Filter.prototype.notifyIsHtml = false;
Filter.prototype.notifyIsPdf = false;

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TYPE2CLASS = exports.TYPE2CLASS = {
  'Ping': 'icon-ping',
  'Keyboard': 'icon-keyboard',
  'Run': 'icon-publish',
  'Exit': 'icon-cancel',
  'Activity': 'icon-reload',
  'Screenshot': 'icon-picture',
  'WebcamSnapshot': 'icon-camera',
  'NetworkConnection': 'icon-network',
  'AppInstallation': 'icon-install',
  'Web': 'icon-globe',
  'Im': 'icon-dialog',
  'Mail': 'icon-mail',
  'Message': 'icon-dialog',
  'FTP': 'icon-folder',
  'PrintDoc': 'icon-print',
  'UserLogon': 'icon-login',
  'Clipboard': 'icon-clipboard',
  'Device': 'icon-device',
  'DiskDrive': 'icon-hdd',
  'FileOperation': 'icon-file',
  'UserLoggedOn': 'icon-login',
  'UserLoggedOff': 'icon-logout',
  'UserSessionLocked': 'icon-logout',
  'UserSessionUnlocked': 'icon-login',
  'Install': 'icon-install',
  'Deinstall': 'icon-trash',
  'SystemLog': 'icon-temperatire',
  'InterceptedFile': 'icon-attach',
  'Stat': 'icon-ok-circled',
  'UserTorturer': 'icon-money',
  'MicRecording': 'icon-mic',
  'DevInventory': 'icon-device',
  'AppInventory': 'icon-install',
  'UserActivity': 'icon-bell',
  'WebSearch': 'icon-search',
  'DesktopVideo': 'icon-video',
  'FormData': 'icon-wpforms',
  'WLan': 'icon-wifi',
  'TTY': 'icon-desktop'
};

var DIM2CLASS = exports.DIM2CLASS = {
  'agent_eventtype': 'icon-right-hand',
  'agent_agent': 'icon-laptop',
  'agent_account': 'icon-user',
  'agent_application': 'icon-window',
  'agent_web': 'icon-globe',
  'agent_networkconnection': 'icon-network',
  'agent_attachedfile': 'icon-docs',
  'agent_fileoperationtype': 'icon-floppy',
  'agent_dialog': 'icon-dialog',
  'agent_time': 'icon-calendar',
  'agent_appinstallation': 'icon-install',
  'agent_device': 'icon-device',
  'analytics_filter': 'icon-lightbulb',
  'agent_feedbacktype': 'icon-bell',
  'analytics_tag': 'icon-tag'
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Measure = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

var _datetime = __webpack_require__(61);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Measure = exports.Measure = function () {
  function Measure() {
    _classCallCheck(this, Measure);
  }

  _createClass(Measure, null, [{
    key: 'bytesToHuman',
    value: function bytesToHuman(bytes, si) {
      if (!bytes) bytes = 0;
      var thresh = si ? 1000 : 1024;
      if (bytes < thresh) return bytes + ' B';
      var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
      var u = -1;
      do {
        bytes /= thresh;
        ++u;
      } while (bytes >= thresh);
      return bytes.toFixed(1) + ' ' + units[u];
    }
  }, {
    key: 'getMeasure',
    value: function getMeasure(cell, name) {
      var val = (typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object' ? cell && cell[name] || 0 : cell;
      if (name === 'activity_time_sum') {
        return (0, _datetime.ticksFormat)(val);
      } else if (name === 'call_duration_sum') {
        return (0, _datetime.formatCallDuration)(val);
      } else {
        return val;
      } //bytesToHuman(val, true );
    }
  }, {
    key: 'getMeasureLabel',
    value: function getMeasureLabel(name) {
      return _config.DEFAULT_MEASURES[name];
    }
  }, {
    key: 'getMeasures',
    value: function getMeasures() {
      return Object.keys(_config.DEFAULT_MEASURES);
    }
  }]);

  return Measure;
}();

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scCoreModule = undefined;

var _localStorage = __webpack_require__(87);

var _filterResource = __webpack_require__(734);

var _modelResource = __webpack_require__(735);

var _aggregateResource = __webpack_require__(736);

var _timeUtil = __webpack_require__(737);

var _cache = __webpack_require__(738);

var _currentFilter = __webpack_require__(742);

var _datetime = __webpack_require__(61);

var _cancelers = __webpack_require__(743);

var _filterData = __webpack_require__(744);

var _currentModel = __webpack_require__(745);

var _router = __webpack_require__(746);

var _filters = __webpack_require__(747);

var _aggregateData = __webpack_require__(748);

var _errorHandler = __webpack_require__(749);

var _permission = __webpack_require__(752);

var _currentFilterData = __webpack_require__(753);

var _layout = __webpack_require__(754);

var _frameLoad = __webpack_require__(762);

var _statusChecker = __webpack_require__(763);

var _serverInformation = __webpack_require__(764);

var _alertModal = __webpack_require__(765);

var scCoreModule = exports.scCoreModule = 'sc-core';

angular.module(scCoreModule, []).service('LocalStorageService', _localStorage.LocalStorageService).filter('gettext', function () {
  return gettext;
}).filter('timeSpan', function () {
  return _datetime.formatTimeSpan;
}).service('FilterResource', _filterResource.FilterResource).service('Models', _modelResource.Models).factory('Aggregates', _aggregateResource.Aggregates).factory('TimeUtil', _timeUtil.TimeUtil).factory('loadWithCache', _cache.loadWithCache).service('CurrentFilterService', _currentFilter.CurrentFilterService).service('CurrentModelService', _currentModel.CurrentModelService).service('CancelersService', _cancelers.CancelersService).factory('FilterDataFactory', _filterData.FilterDataFactory).service('RouterService', _router.RouterService).service('FiltersService', _filters.FiltersService).service('AggregateDataService', _aggregateData.AggregateDataService).service('ErrorHandlerService', _errorHandler.ErrorHandlerService).service('PermissionService', _permission.PermissionService).service('CurrentFilterDataService', _currentFilterData.CurrentFilterDataService).service('LayoutService', _layout.LayoutService).service('FrameLoadService', _frameLoad.FrameLoadService).service('StatusCheckerService', _statusChecker.StatusCheckerService).service('ServerInformationService', _serverInformation.ServerInformationService).service('AlertModalService', _alertModal.AlertModalService);

angular.module(scCoreModule).factory('globalAlert', ["$timeout", function ($timeout) {
  return function (message, timeout) {
    if (!timeout) timeout = 1000;
    $timeout(function () {
      $('#global-alert').fadeOut(200);
    }, timeout);
    $('#global-alert-message').html(message);
    $('#global-alert').show();
  };
}]);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WEEKDAYS = exports.WEEKDAYS = [gettext('Понедельник'), gettext('Вторник'), gettext('Среда'), gettext('Четверг'), gettext('Пятница'), gettext('Суббота'), gettext('Воскресенье')];

var ticksToHours = exports.ticksToHours = 36000000000;

var addNull = function addNull(n) {
  return n < 10 ? '0' + n : '' + n;
};

var secondsFormat = function secondsFormat(sec_num, hideZero) {
  var format = window.report_time_format;
  if (format === 'SECONDS') {
    return sec_num + gettext(' с');
  }
  if (format === 'MINUTES') {
    return Math.floor(sec_num / 60) + gettext(' м');
  }
  if (hideZero && sec_num === 0) return '';

  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);

  if (format === 'PART_TIME_SEPARATE') {
    //ЧЧ:MM
    return addNull(hours) + ':' + addNull(minutes);
  }
  var seconds = sec_num - hours * 3600 - minutes * 60;
  if (format === 'FULL_TIME_SEPARATE') {
    //ЧЧ:ММ:CC
    return addNull(hours) + ':' + addNull(minutes) + ':' + addNull(seconds);
  }

  var days = Math.floor(hours / 24);
  var years = Math.floor(days / 365);
  hours -= days * 24;
  days -= years * 365;

  var time = (years ? years + gettext(' г ') : '') + (days ? days + gettext(' д ') : '') + addNull(hours) + gettext(' ч ') + addNull(minutes) + gettext(' м ') + addNull(seconds) + gettext(' с');
  return time;
};

var ticksFormat = exports.ticksFormat = function ticksFormat(ticks, hideZero) {
  var sec_num = Math.ceil(ticks / 10000000);
  return secondsFormat(sec_num, hideZero);
};

// export const ticksFormat = function(ticks, hideZero) {
//   console.log(format);
//
//   const sec_num = Math.ceil(ticks / 10000000);
//   if (format === 'SECONDS') {
//     return sec_num + gettext(' с');
//   }
//   if (format === 'MINUTES') {
//     return Math.floor(sec_num / 60) + gettext(' м');
//   }
//   if (hideZero && sec_num === 0) return '';
//
//   let hours = Math.floor(sec_num / 3600);
//   const minutes = Math.floor((sec_num - (hours * 3600)) / 60);
//
//   if (format === 'PART_TIME_SEPARATE') { //ЧЧ:MM
//     return `${addNull(hours)}:${addNull(minutes)}`;
//   }
//   const seconds = sec_num - (hours * 3600) - (minutes * 60);
//   if (format === 'FULL_TIME_SEPARATE') { //ЧЧ:ММ:CC
//     return `${addNull(hours)}:${addNull(minutes)}:${addNull(seconds)}`;
//   }
//
//   let days = Math.floor(hours / 24);
//   const years = Math.floor(days / 365);
//   hours -= days * 24;
//   days -= years * 365;
//
//   const time = (years ? years + gettext(' г ') : '') +
//     (days ? days + gettext(' д ') : '') +
//     addNull(hours) + gettext(' ч ') +
//     addNull(minutes) + gettext(' м ') +
//     addNull(seconds) + gettext(' с');
//   return time;
// };

var hoursToTime = exports.hoursToTime = function hoursToTime(hours) {
  var days = Math.floor(hours / 24);
  hours %= 24;
  if (hours < 10) {
    hours = '0' + hours;
  }
  var time = (days ? days + gettext(' д ') : '') + hours + gettext(' ч ');
  return time;
};

var formatTimeSpan = exports.formatTimeSpan = function formatTimeSpan(seconds) {
  return isNaN(seconds) || !isFinite(seconds) ? '?' : String(Math.floor(seconds / 60)) + ':' + ('0' + String(Math.floor(seconds % 60))).slice(-2);
};

var formatCallDuration = exports.formatCallDuration = function formatCallDuration(seconds) {
  if (isNaN(seconds) || !isFinite(seconds)) {
    return '?';
  }
  return secondsFormat(seconds, null);
};

// export const formatCallDuration = (seconds) => {
//   if (isNaN(seconds) || !isFinite(seconds)) {
//     return '?';
//   }
//   const hours = Math.floor(seconds / 3600);
//   const minutes = Math.floor((seconds - (hours * 3600)) / 60);
//   const sec = seconds - (hours * 3600) - (minutes * 60);
//   const formatTime = (value) => value >= 10 ? value : `0${value}`;
//   return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(sec)}`;
// };

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetFromProp = exports.makeFilterAttrs = exports.makeIcon = exports.dateFiler = exports.ATTR2PROP = exports.localTimeProperty = exports.TextProperty = exports.AttachedFileProperty = exports.setShowSystemKeys = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.buildWidget = buildWidget;
exports.getTableViewByType = getTableViewByType;
exports.getBottomComponentHtml = getBottomComponentHtml;

var _config = __webpack_require__(21);

var _iconClass = __webpack_require__(38);

var _datetime = __webpack_require__(61);

var _fact = __webpack_require__(89);

var _decodeFact = __webpack_require__(336);

var _faceService = __webpack_require__(340);

var layout = {};

var unsortableFields = ['agent_dialog.contact', 'agent_dialog.domain', 'analytics_filter.name', 'analytics_filter.category', 'analytics_filter.syscat'];

var entityMap = {
  '"': '&quot;',
  // '&': '&amp;', // с бакенда факты идут уже заменой "<" и ">" на '&lt;' и '&gt;'
  //  поэтому если подменять сивол '&' то ломается отображение "<" и ">"
  '\'': '&#39;',
  '/': '&#x2F;',
  '<': '&lt;',
  '>': '&gt;',
  '{': '{&#8205;',
  '}': '&#8205;}'
};

var setShowSystemKeys = exports.setShowSystemKeys = function setShowSystemKeys(options) {
  return layout.options = options;
};

var UserLogonEvents = {
  'UserLoggedOn': gettext('Вход в систему'),
  'UserLoggedOff': gettext('Выход из системы'),
  'UserSessionLocked': gettext('Сессия заблокирована'),
  'UserSessionUnlocked': gettext('Сессия разблокирована')
};

var AppInstallationEvents = {
  'Install': gettext('Установка приложения'),
  'Deinstall': gettext('Удаление приложения'),
  'Inventory': gettext('Инвентаризация')
};

function escapeHtml(string) {

  if (string === null || string && string.trim && string.trim() === 'null') return '';
  var shifr1 = 'fgksdroptipmhgasterte4589e5';
  var shifr2 = '439gke5thggbvdfgf056f5hddf4';
  var allow1 = '<b style="background-color: yellow">';
  var allow2 = '</b>';
  string = String(string);
  string = string.replace(allow1, shifr1);
  string = string.replace(allow2, shifr2);
  string = string.replace(/[\{\}<>"'\/]/g, function (s, i) {
    return entityMap[s];
  });
  string = string.replace(shifr1, allow1);
  string = string.replace(shifr2, allow2);
  return string;
}

// Property widgets
var AttachedFileProperty = exports.AttachedFileProperty = function AttachedFileProperty(fact) {

  var decorateNotExistsFiles = function decorateNotExistsFiles(val, fileName) {
    var currentFilename = fileName || escapeHtml(fact['agent_attachedfile.file_name']) || '';
    if (currentFilename === 'null') {
      currentFilename = '';
    }
    var isFileExist = fact['agent_attachedfile.file_exist'];
    if (isFileExist) {
      return val;
    } else {
      var mimeType = fact['agent_attachedfile.mime'];
      var isLoaded = mimeType === 'not_loaded';
      var mainSpanClass = isLoaded ? 'unlinked' : 'broken';
      var iconClass = isLoaded ? 'icon-unlink' : 'icon-content-broken';
      var titleText = isLoaded ? gettext('Файл еще не загружен') : gettext('Файл удален');
      return '<span class="attfilelink ' + mainSpanClass + '" title="' + titleText + '">' + currentFilename + ' <i class="icon ' + iconClass + '"></i></span>';
    }
  };

  var eventName = fact['agent_eventtype.name'];
  if (eventName == 'Screenshot' || eventName == 'WebcamSnapshot' || fact['parentName'] == 'Screenshot') {
    var val = '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] + '" err-src="/static/img/default.png" ng-click="openImage(fact)" class="screenshot_thumb" />';
    val = decorateNotExistsFiles(val);
    val = (0, _faceService.decorateFaces)(val, fact);
    return {
      key: gettext('Снимок'),
      val: val,
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'SystemLog') {
    var file_name = 'Debug_' + escapeHtml(fact['agent_agent.computer_name']) + '.zip';

    var _val = '<span class="attfilelink">' + gettext('Скачать') + ' <a href="/media/' + fact['agent_attachedfile.data'] + '" target="_blank" download="' + file_name + '">' + file_name + ' <i class="icon icon-download"></i></a></span>';
    _val = decorateNotExistsFiles(_val, file_name);
    return {
      key: gettext('Контент'),
      val: _val,
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'DesktopVideo') {
    var _val2 = '<a class="btn" target="_new" href="/remote/?play=' + fact['agent_attachedfile.guid'] + '">' + '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] + '" err-src="/static/img/default.png" class="screenshot_thumb" />' + '</a>';

    var _file_name = 'video' + fact['id'] + '.mp4';
    _val2 = _val2 + '<br><span class="attfilelink">' + gettext('Скачать') + ' <a href="/media/' + fact['agent_attachedfile.data'] + '" target="_blank" download="' + _file_name + '" onclick="this.parentNode.remove()">' + _file_name + ' <i class="icon icon-download"></i></a></span>';

    _val2 = decorateNotExistsFiles(_val2);
    return {
      key: gettext('Контент'),
      val: _val2,
      fdim: 'agent_attachedfile@file_name:file_name',
      fval: fact['agent_attachedfile.file_name'],
      flbl: fact['agent_attachedfile.file_name'],
      class: 'important',
      bindable: true
    };
  }

  if (eventName == 'MicRecording' || fact['parentName'] == 'MicRecording') {
    var _val3 = '';
    if (_config.IS_IE_BROWSER) {
      _val3 = '<sc-audio-file fact="fact" src="\'/media/\' + fact[\'agent_attachedfile.data\']"></sc-audio-file>';
    } else {
      _val3 = '<sc-audio-waves fact="fact" src="\'/media/\' + fact[\'agent_attachedfile.data\']"></sc-audio-waves>';
    }
    _val3 = decorateNotExistsFiles(_val3);
    return {
      key: gettext('Контент'),
      val: _val3,
      fdim: '',
      fval: '',
      flbl: '',
      class: 'important',
      bindable: true
    };
  } else {
    var _file_name2 = escapeHtml(fact['agent_attachedfile.file_name']);
    // --------------------------------
    var _val4 = '';
    if (_fact.Fact.isImage(fact)) {
      _val4 = '<img ng-src="/analytics/thumb/' + fact['agent_attachedfile.data'] + '" err-src="/static/img/default.png" ng-click="openImage(fact)" class="screenshot_thumb" /><br/>';
    }
    // --------------------------------
    _val4 += '<span class="attfilelink">' + gettext('Скачать') + ' <a href="/media/' + fact['agent_attachedfile.data'] + '" target="_blank" download="' + _file_name2 + '">' + _file_name2 + ' <i class="icon icon-download"></i></a></span>';
    _val4 = decorateNotExistsFiles(_val4);
    return {
      key: gettext('Контент'),
      val: _val4,
      fdim: 'agent_attachedfile@file_name:file_name',
      fval: fact['agent_attachedfile.file_name'],
      flbl: fact['agent_attachedfile.file_name'],
      class: 'important',
      bindable: true
    };
  }
};

var AttachedFileName = function AttachedFileName(fact) {
  return {
    key: gettext('Имя файла'),
    val: fact['agent_attachedfile.file_name'],
    fdim: 'agent_attachedfile@file_name:file_name',
    fval: fact['agent_attachedfile.file_name'],
    flbl: fact['agent_attachedfile.file_name'],
    class: 'important'
  };
};

var AttachedFilePath = function AttachedFilePath(fact) {
  return {
    key: gettext('Путь'),
    val: fact['agent_attachedfile.file_path'],
    fdim: 'agent_attachedfile@file_path:file_path',
    fval: fact['agent_attachedfile.file_path'],
    flbl: fact['agent_attachedfile.file_path'],
    class: 'important'
  };
};

var SenderProperty = function SenderProperty(fact) {
  var sender = fact['agent_dialog.sender'];
  var dim = 'agent_dialog@sender:sender';
  var account = AccountHTML(escapeHtml(sender), fact, dim);
  return {
    key: gettext('Отправитель'),
    // val: escapeHtml(sender),
    val: account,
    fdim: dim,
    fval: sender,
    flbl: sender,
    bindable: true
  };
};

var AccountHTML = function AccountHTML(accountKey, fact, dim) {
  return fact.accounts && fact.accounts[accountKey] && fact.accounts[accountKey].length ? '<sc-account account-key="\'' + accountKey + '\'" dkey="\'' + dim + '\'" fact="fact"></sc-account>' : '<span data-key="' + dim + '" >' + accountKey + '</span>';
};

var RecipientsProperty = function RecipientsProperty(fact) {
  var recipients = fact['agent_dialog.recipients'];
  var dim = 'agent_dialog@recipients:recipients';
  return {
    key: gettext('Получатели'),
    // val: escapeHtml(recipients),
    val: escapeHtml(recipients).split(' ').map(function (a) {
      return AccountHTML(a, fact, dim);
    }).join(' '),
    fdim: dim,
    fval: recipients,
    flbl: recipients,
    bindable: true
  };
};
var MembersProperty = function MembersProperty(fact) {
  var members = fact['agent_dialog.members'];
  var sender = fact['agent_dialog.sender'];
  var recipients = fact['agent_dialog.recipients'];
  var dim = 'agent_dialog@members:members';
  var account = AccountHTML(escapeHtml(sender), fact, dim);
  return {
    key: gettext('Участники'),
    val: account && recipients ? account + ' ➤ ' + escapeHtml(recipients).split(' ').map(function (a) {
      return AccountHTML(a, fact, dim);
    }).join(' ') : '',
    fdim: dim,
    fval: members,
    flbl: members,
    class: 'important',
    bindable: true
  };
};
var NetworkConnectionProperty = function NetworkConnectionProperty(fact) {
  var remote_address = fact['agent_networkconnection.remote_address'];
  if (!remote_address) remote_address = '';
  var remote_port = fact['agent_networkconnection.remote_port'];
  if (!remote_port) remote_port = '';
  return {
    key: gettext('Сетевая активность'),
    val: remote_address && remote_port ? remote_address + ':' + remote_port : '',
    fdim: 'agent_networkconnection@remote_address:remote_address',
    fval: remote_address,
    flbl: remote_address,
    class: 'important'
  };
};
var CallDurationProperty = function CallDurationProperty(fact) {
  var key = gettext('Длительность');
  if (fact['agent_eventtype.id'] === 11 || fact['agent_eventtype.id'] === 0) key = gettext('Страниц');
  if (fact['agent_eventtype.id'] === 19) key = gettext('Количество');
  return {
    key: key,
    val: fact['call_duration'],
    class: 'important'
  };
};
var MessageFormatProperty = function MessageFormatProperty(fact) {
  return {
    key: gettext('Формат'),
    val: fact['agent_dialog.message_format']
  };
};

var fixedString = function fixedString(s, wl) {
  var l = s.length;
  return l > wl + 5 ? s.slice(0, wl / 2) + '.. ..' + s.slice(l - wl / 2, l) : s;
};

var rewriteXML = function rewriteXML(text) {
  var startXML = text.match(/&lt;.xml\s+version\s*=.*&gt;/i);
  // console.log('startXML=', startXML);

  if (!startXML) return text;
  var endXML = text.match(/&gt;.*$/i);
  // console.log(startXML.index, endXML.index);
  // const xmlText = text.match(/&lt.*&gt;/gi);
  return text.substring(0, startXML.index) + '<div ng-click="showxml=!showxml" ><span class="pointer">' + gettext('Техническая информация (XML)') + '</span> <i ng-class="{\'icon-collapse\': !showxml, \'icon-uncollapse\': showxml, }"></i> <div ng-show="showxml">' + text.substring(startXML.index, endXML.index + 4) + '</div> </div>' + text.substring(endXML.index + 5);
};

var TextProperty = exports.TextProperty = function TextProperty(fact, additionalElement) {

  var eventName = fact['agent_eventtype.name'];

  var textData = fact['text_data'].replace(/^[\s\n\r]*/gm, '');
  var bindable = true;
  var sval = void 0;
  if (eventName === 'FileOperation') {
    var wl = 40;
    textData = escapeHtml(textData);
    bindable = false;
    sval = textData.split('\n').reduce(function (a, b, c) {
      return a + (c == 0 && textData.indexOf('\n') != -1 ? '<b>' + gettext('Из') + '</b> ' : '') + (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + fixedString(b, wl) + (c === 0 ? ' ' : '');
    }, '');
    textData = textData.split('\n').reduce(function (a, b, c) {
      return a + (c == 0 && textData.indexOf('\n') != -1 ? '<b>' + gettext('Из') + '</b> ' : '') + (c === 1 ? '<b>' + gettext('В') + '</b> ' : '') + b + (c === 0 ? ' ' : '');
    }, '');
  } else {
    if (!layout || !layout.options || !layout.options.showSystemKeys || !layout.options.showSystemKeys.value) textData = textData.replace(/<badge>(?:.|\n)*?>/gm, '');
    sval = textData;
  }

  return {
    key: gettext('Содержимое'),
    val: (additionalElement ? additionalElement : '') + '  <div class="fact-text">' + textData + ' </div>',
    sval: sval,
    textFactId: fact.id,
    class: 'important',
    bindable: bindable
  };
};

var WebProperty = function WebProperty(fact) {
  // const url = decodeURIComponent(fact['agent_web.url']);
  var url = fact['agent_web.url'];
  if (url === null || url === undefined) {
    return '';
  }
  return {
    key: gettext('Посещение сайта'),
    val: escapeHtml(url),
    fdim: 'agent_web@url:url',
    fval: url,
    flbl: url,
    // class: 'details',
    class: 'important'
  };
};
var SiteProperty = function SiteProperty(fact) {
  var domain = fact['agent_web.site'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key: gettext('Домен'),
    val: escapeHtml(domain),
    fdim: 'agent_web@site:site',
    fval: domain,
    flbl: domain,
    class: 'details'
  };
};

var FileSizeProperty = function FileSizeProperty(fact) {
  var bytes = fact['file_size'];
  var size = '';
  if (bytes >= 1000000) size = Math.round(bytes / 100000) / 10 + ' Mb';else if (bytes >= 1000) size = Math.round(bytes / 100) / 10 + ' Kb';else size = bytes + ' B';

  return {
    key: gettext('Размер'),
    val: escapeHtml(size),
    fval: size,
    flbl: size,
    class: 'important'
  };
};

var DomainProperty = function DomainProperty(fact) {
  var domain = fact['agent_web.domain'];
  if (domain === null || domain === undefined) {
    return '';
  }
  return {
    key: gettext('Сайт'),
    val: escapeHtml(domain),
    fdim: 'agent_web@domain:domain',
    fval: domain,
    flbl: domain,
    class: 'details'
  };
};
var TypeProperty = function TypeProperty(fact) {
  var eventName = fact['agent_eventtype.name'];
  var propClass = 'details';
  if (eventName === 'Stat') {
    propClass = 'important';
  }
  return {
    key: gettext('Тип события'),
    val: fact['agent_eventtype.description'],
    fdim: 'agent_eventtype@default:agent_eventtype',
    fval: fact['agent_eventtype.id'],
    flbl: fact['agent_eventtype.description'],
    class: propClass,
    icon: _iconClass.TYPE2CLASS[fact['agent_eventtype.name']]
  };
};

var InstallationProductProperty = function InstallationProductProperty(fact) {
  return {
    key: gettext('Продукт'),
    val: escapeHtml(fact['agent_appinstallation.product_name'] || ''),
    fdim: 'agent_appinstallation@product_name:product_name',
    fval: fact['agent_appinstallation.product_name'],
    flbl: fact['agent_appinstallation.product_name'],
    class: 'important'
  };
};

var InstallationPublisher = function InstallationPublisher(fact) {
  return {
    key: gettext('Поставщик'),
    val: escapeHtml(fact['agent_appinstallation.publisher'] || ''),
    fdim: 'agent_appinstallation@publisher:publisher',
    fval: fact['agent_appinstallation.publisher'],
    flbl: fact['agent_appinstallation.publisher'],
    class: 'important'
  };
};

var InstallationVersion = function InstallationVersion(fact) {
  return {
    key: gettext('Версия'),
    val: escapeHtml(fact['agent_appinstallation.version'] || ''),
    fdim: 'agent_appinstallation@version:version',
    fval: fact['agent_appinstallation.version'],
    flbl: fact['agent_appinstallation.version'],
    class: 'important'
  };
};

var InstallationEventProperty = function InstallationEventProperty(fact) {
  return {
    key: gettext('Операция'),
    val: AppInstallationEvents[fact['agent_appinstallation.install_event']],
    fdim: 'agent_appinstallation@install_event:install_event',
    fval: fact['agent_appinstallation.install_event'],
    flbl: fact['agent_appinstallation.install_event'],
    class: 'important'
  };
};
var FileOperationProperty = function FileOperationProperty(fact) {
  return {
    key: gettext('Операция'),
    val: fact['agent_attachedfile.file_operation'],
    fdim: 'agent_attachedfile@file_operation:file_operation',
    fval: fact['agent_attachedfile.file_operation'],
    flbl: fact['agent_attachedfile.file_operation'],
    class: 'important'
  };
};
var LogonProperty = function LogonProperty(fact) {
  return {
    key: gettext('Действие'),
    val: UserLogonEvents[fact['logon_event']],
    fdim: 'logon_event@default:logon_event',
    fval: fact['logon_event'],
    flbl: UserLogonEvents[fact['logon_event']],
    class: 'important',
    icon: _iconClass.TYPE2CLASS[fact['logon_event']]
  };
};
var WindowTitleProperty = function WindowTitleProperty(fact) {
  return {
    key: gettext('Заголовок окна'),
    val: fact['window_title'],
    fval: fact['window_title'],
    flbl: fact['window_title'],
    fdim: 'agent_application@window_title:window_title',
    class: 'window-title'
  };
};
var ComputerProperty = function ComputerProperty(fact) {
  return {
    key: gettext('Агент'),
    val: escapeHtml(fact['agent_agent.computer_name']),
    fdim: 'agent_agent@computer_name:computer_name',
    fval: fact['agent_agent.id'],
    flbl: fact['agent_agent.computer_name']
  };
};

var AccountProperty = function AccountProperty(fact) {
  return {
    key: gettext('Пользователь'),
    val: escapeHtml(fact['agent_account.user_name']),
    fdim: 'agent_account@user_name:user_name',
    fval: fact['agent_account.user_name'],
    flbl: fact['agent_account.user_name']
  };
};

var DeviceManufacturerProperty = function DeviceManufacturerProperty(fact) {
  return {
    key: gettext('Тип устройства'),
    val: escapeHtml(fact['agent_device.manufacturer']),
    fdim: 'agent_device@manufacturer:manufacturer',
    fval: fact['agent_device.manufacturer'],
    flbl: fact['agent_device.manufacturer'],
    class: 'important'
  };
};
var DeviceDescriptionProperty = function DeviceDescriptionProperty(fact) {
  return {
    key: gettext('Устройство'),
    val: escapeHtml(fact['agent_device.description']),
    fdim: 'agent_device@description:description',
    fval: fact['agent_device.description'],
    flbl: fact['agent_device.description']
  };
};
var DeviceHWIDProperty = function DeviceHWIDProperty(fact) {
  return {
    key: gettext('HardwareId'),
    val: escapeHtml(fact['agent_device.hwid']),
    fdim: 'agent_device@hwid:hwid',
    fval: fact['agent_device.hwid'],
    flbl: fact['agent_device.hwid']
  };
};
var DriveTypeProperty = function DriveTypeProperty(fact) {
  return {
    key: gettext('Тип диска'),
    val: escapeHtml(fact['agent_device.drive_type']),
    fdim: 'agent_device@drive_type:drive_type',
    fval: fact['agent_device.drive_type'],
    flbl: fact['agent_device.drive_type']
  };
};
var FeedbackProperty = function FeedbackProperty(fact) {
  return {
    key: gettext('Статус'),
    val: escapeHtml(fact['agent_feedbacktype.name']),
    fdim: 'agent_feedbacktype@default:agent_feedbacktype',
    fval: fact['agent_feedbacktype.id'],
    flbl: fact['agent_feedbacktype.name']
  };
};
var ParentProperty = function ParentProperty(fact) {
  return {
    key: gettext('Источник'),
    val: fact['parent.event_type_name'] + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['parent_id'],
    flbl: fact['parent_id'],
    bindable: true
  };
};
var ChildrenProperty = function ChildrenProperty(fact) {
  return {
    key: gettext('Источник'),
    val: fact['agent_eventtype.name'] + ' <i class="icon-login"></i>',
    fdim: 'id@default:id',
    fval: fact['id'],
    flbl: fact['id'],
    bindable: true
  };
};
var TriggeredFilterProperty = function TriggeredFilterProperty(fact) {
  var value_value = fact ? fact['analytics_filter.name'] ? escapeHtml(fact['analytics_filter.name']) : gettext('Все события') : '';
  return {
    key: gettext('Фильтр'),
    val: value_value,
    fdim: 'analytics_filter@name:name',
    fval: value_value,
    flbl: value_value,
    class: 'important'
  };
};
var CommentProperty = function CommentProperty(fact) {
  var val = fact['agent_account.comment'];
  return {
    key: gettext('Комментарий'),
    val: escapeHtml(val),
    class: 'important'
  };
};
var FeedbackDescriptionProperty = function FeedbackDescriptionProperty(fact) {
  return {
    key: gettext('Алерт'),
    val: fact['agent_feedbacktype.description'],
    fdim: 'agent_feedbacktype@default:agent_feedbacktype',
    fval: fact['agent_feedbacktype.id'],
    flbl: fact['agent_feedbacktype.description'],
    class: 'important'
  };
};

var UserActiveColProperty = function UserActiveColProperty(fact) {
  var val = (0, _datetime.ticksFormat)(fact['activity_time'], true);
  if (val) return {
    key: gettext('Длительность'),
    val: val,
    fval: val,
    flbl: val
  };else return null;
};

var localTimeProperty = exports.localTimeProperty = function localTimeProperty(fact) {
  var val = dateFiler(fact['local_time'], 'yyyy-MM-dd HH:mm:ss') + ' ' + timezone(fact);

  return {
    key: gettext('Время'),
    val: val,
    fval: fact.id,
    flbl: fact.id,
    fdim: 'id@default:id',
    class: 'important'
  };
};

var applicationProperty = function applicationProperty(fact) {
  return {
    key: gettext('Приложение'),
    val: escapeHtml(fact['agent_application.app_name']),
    fval: fact['agent_application.app_name'],
    flbl: fact['agent_application.app_description'],
    fdim: 'agent_application@app_name:app_name',
    icon: '/analytics/icon/' + fact['agent_application.app_icon_id']
  };
};

var ProcessIdProperty = function ProcessIdProperty(fact) {
  var val = fact['process_id'];
  return {
    key: gettext('PID'),
    val: val,
    class: 'important'
  };
};

var UserSessionIdProperty = function UserSessionIdProperty(fact) {
  var val = fact['user_session_id'];
  return {
    key: gettext('UID'),
    val: val,
    class: 'important'
  };
};

var ClipboardFormatProperty = function ClipboardFormatProperty(fact) {
  var val = fact['clipboard_format'];
  var format = {
    0: gettext('Не определен'),
    1: gettext('Текст'),
    2: gettext('Изображение'),
    3: gettext('Файл')
  };
  return {
    key: gettext('Формат буфера обмена'),
    val: format[val],
    class: 'important'
  };
};

var ATTR2PROP = exports.ATTR2PROP = {
  'local_time': localTimeProperty,
  'agent_application.app_name': applicationProperty,
  'analytics_filter.name': TriggeredFilterProperty,
  'agent_feedbacktype.name': FeedbackProperty,
  'agent_eventtype.description': TypeProperty,
  'agent_agent.computer_name': ComputerProperty,
  'agent_account.user_name': AccountProperty,
  'agent_attachedfile.data': AttachedFileProperty,
  'agent_attachedfile.file_name': AttachedFileName,
  'agent_attachedfile.file_path': AttachedFilePath,
  'agent_attachedfile.file_operation': FileOperationProperty,
  'agent_networkconnection.remote_address': NetworkConnectionProperty,
  'agent_dialog.sender': SenderProperty,
  'agent_dialog.recipients': RecipientsProperty,
  'agent_dialog.members': MembersProperty,
  'call_duration': CallDurationProperty,
  'agent_dialog.message_format': MessageFormatProperty,
  'agent_web.url': WebProperty,
  'agent_web.site': SiteProperty,
  'agent_web.domain': DomainProperty,
  'logon_event': LogonProperty,
  'agent_appinstallation.install_event': InstallationEventProperty,
  'agent_appinstallation.product_name': InstallationProductProperty,
  'agent_appinstallation.publisher': InstallationPublisher,
  'agent_appinstallation.version': InstallationVersion,
  'window_title': WindowTitleProperty,
  'agent_device.manufacturer': DeviceManufacturerProperty,
  'agent_device.description': DeviceDescriptionProperty,
  'agent_device.hwid': DeviceHWIDProperty,
  'agent_device.drive_type': DriveTypeProperty,
  'parent_id': ParentProperty,
  'children_id': ChildrenProperty,
  'agent_feedbacktype.description': FeedbackDescriptionProperty,
  'activity_time': UserActiveColProperty,
  'agent_account.comment': CommentProperty,
  'text_data': TextProperty,
  'process_id': ProcessIdProperty,
  'user_session_id': UserSessionIdProperty,
  'clipboard_format': ClipboardFormatProperty,
  'file_size': FileSizeProperty
};

var IMPATTR2PROP = ['analytics_filter.name', 'window_title', 'agent_attachedfile.file_operation', 'agent_attachedfile.file_name', 'agent_attachedfile.data', 'agent_networkconnection.remote_address', 'agent_dialog.sender', 'agent_feedbacktype.description',
//   'call_duration',
'text_data',
//   'agent_dialog.message_format',
//   'agent_web.url',
'logon_event', 'agent_appinstallation.install_event', 'agent_appinstallation.product_name', 'agent_device.drive_type', 'agent_device.description', 'parent_id'];

// ///////////////////
// For Table View !!!

var dateFiler = exports.dateFiler = function dateFiler(x, y) {
  if (x == undefined) return '';
  return x.toString().replace('T', ' ').substring(0, 19);
};

// Build Icon
var makeIcon = exports.makeIcon = function makeIcon(icon) {
  if (icon && icon[0] == '/') {
    icon = '<img class="widget-icon" src="' + icon + '"/>';
  } else if (icon) {
    icon += ' widget-icon';
    icon = icon && '<span class="' + icon + '"></span>';
  } else {
    icon = '';
  }
  return icon;
};
// Build filter attrs
var makeFilterAttrs = exports.makeFilterAttrs = function makeFilterAttrs(dimension, dim_key, dim_label) {
  var filterAttrs = '';
  if (dimension) {
    var fdim = dimension;
    var fval = dim_key == undefined | dim_key == null ? '' : dim_key;
    var flbl = dim_label ? dim_label : '';
    filterAttrs = ' class="widget-filter" data-key="' + fdim + '" data-value="' + fval + '" data-label="' + flbl + '"';
  } else {
    filterAttrs = ' class="widget-data"';
  }
  return filterAttrs;
};

// Build cell from property
var cellFromProp = function cellFromProp(prop, mode) {
  if (!prop) return '';
  var icon = makeIcon(prop.icon);
  var bindable = prop.bindable ? '' : ' ng-non-bindable ';
  if (mode === 'extended') {
    return '<span' + bindable + makeFilterAttrs(prop.fdim, prop.fval, escapeHtml(prop.flbl)) + ' ng-bind-html="trustAsHtml(textData)"></span>';
  }
  var valueText = (mode === 'short' && prop.sval ? prop.sval : prop.val) || '';
  return '<span' + bindable + makeFilterAttrs(prop.fdim, prop.fval, escapeHtml(prop.flbl)) + '>' + icon + ' ' + valueText + '</span>';
};

var widgetFromProp = exports.widgetFromProp = function widgetFromProp(prop) {
  if (!prop) return '';
  var icon = makeIcon(prop.icon);
  var prop_class = prop.class ? prop.class : 'details';
  var bindable = prop.bindable ? '' : ' ng-non-bindable ';
  return '\
          <div class="row-fluid widget-property ' + prop_class + '">\
            <span class="widget-label">' + prop.key + '</span>\
            <span class="widget-value">' + icon + '<span' + bindable + makeFilterAttrs(prop.fdim, prop.fval, escapeHtml(prop.flbl)) + '>' + prop.val + '</span><span class="copy-clippboard " title="' + gettext('Скопировать в буфер обмена') + '">' + '<span class="icon-docs widget-icon" ng-click="copyToClippboard($event)">' + '</span>' + (prop.textFactId ? '<a target="_new" href="/analytics/text/?id=' + prop.textFactId.toString() + '" title="' + gettext('Перейти к тексту факта') + '"><i class="icon-download-1"></i></a>' : '') + '</span></span></div>';
};

function buildWidget(fact) {
  if (!fact) return;

  // Event widget start
  var widget = '<div ng-click="collapse()" class="widget-body"><div class="widget-properties">';
  // Build properties
  for (var k in ATTR2PROP) {
    if (fact && fact[k]) {
      widget += widgetFromProp(ATTR2PROP[k](fact));
    }
  }

  if (fact && fact.children) {
    widget += fact.children.map(function (ch) {
      ch['parentName'] = fact['agent_eventtype.name'];
      return ch['agent_attachedfile.data'] ? widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
    }).join('');
  }

  widget += '</div>';
  widget += '<div class="widget-menu"><i ng-class="{\'icon-collapse\': isCollapsed, \'icon-uncollapse\': !isCollapsed}"></i></div>';
  widget += '<div class="clearfix"/></div>';
  return widget;
}

// //////////////////////////////////////////////////////////////////////////
// Build data
var parseMinutesTz = function parseMinutesTz(tz) {
  if (!tz) return 0;
  var i = tz.indexOf('UTC');
  if (i !== -1) tz = tz.substring(i + 3);
  var min = 0;
  var hours = 0;
  var arrTz = tz.split(':');
  hours = parseInt(arrTz[0], 10);
  min = arrTz[1] ? parseInt(arrTz[1], 10) : 0;

  if (isNaN(hours)) hours = 0;
  if (isNaN(min)) min = 0;
  var sign = hours < 0 ? -1 : 1;
  return hours * 60 + min * sign;
};

var timezone = function timezone(fact) {
  if (!fact['local_time']) return 0;
  // console.log(fact['local_time']);
  var agentTz = parseMinutesTz(fact['agent_time.time_zone']);
  var localTime = fact['local_time'];
  var localTz = parseMinutesTz(localTime.substring(localTime.length - 6));
  if (agentTz === localTz) return '';
  var sign = agentTz > localTz ? 1 : -1;
  var dif = (agentTz - localTz) * sign;
  var hours = (sign == 1 ? '+' : '-') + ~~(dif / 60);
  var minutes = dif % 60;
  minutes = minutes ? ':' + minutes : '';

  return hours + minutes;
};

var TimeCol = {
  factKey: 'local_time',
  'label': gettext('Время'),
  'cssClass': 'fact-time',
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['local_time'](fact)) : '';
    // return fact ? dateFiler(fact['local_time'], 'yyyy-MM-dd HH:mm:ss') + ' ' + timezone(fact) : '';
  },
  sortable: true
};
var TypeCol = {
  factKey: 'agent_eventtype.description',
  'label': gettext('Тип'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_eventtype.description'](fact)) : '';
  },
  'dim': 'agent_eventtype@default:agent_eventtype',
  sortable: true
};
var ComputerCol = {
  factKey: 'agent_agent.computer_name',
  'label': gettext('Компьютер'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact)) : '';
  },
  'dim': 'agent_agent@computer_name:computer_name',
  sortable: true
};

var OwnerCol = {
  factKey: 'agent_agent.computer_name',
  'label': gettext('Владелец'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_agent.computer_name'](fact)) : '';
  },
  'dim': 'agent_agent@computer_name:computer_name',
  sortable: true
};

var UserCol = {
  factKey: 'agent_account.user_name',
  'label': gettext('Пользователь'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_account.user_name'](fact)) : '';
  },
  'dim': 'agent_account@user_name:user_name',
  sortable: true
};

var UserSessionIdCol = {
  factKey: 'user_session_id',
  'label': gettext('ID пользовательской сессии '),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['user_session_id'](fact)) : '';
  },
  sortable: false
};

var ProcessIdCol = {
  factKey: 'process_id',
  'label': gettext('ID процесса'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['process_id'](fact)) : '';
  },
  sortable: false
};

var ClipboardFormatCol = {
  factKey: 'clipboard_format',
  'label': gettext('Формат буфера обмена'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['clipboard_format'](fact)) : '';
  },
  sortable: true
};

var WebCol = {
  factKey: 'agent_web.url',
  'label': gettext('Ссылка'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.url'](fact)) : '';
  },
  sortable: true
};

var SiteCol = {
  factKey: 'agent_web.site',
  'label': gettext('Домен'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.site'](fact)) : '';
  },
  sortable: true
};
var DomainCol = {
  factKey: 'agent_web.domain',
  'label': gettext('Сайт'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_web.domain'](fact)) : '';
  },
  sortable: true
};
var AppCol = {
  factKey: 'agent_application.app_name',
  'label': gettext('Приложение'),
  'parse': function parse(fact) {

    var app_icon = makeIcon('/analytics/icon/' + (fact ? fact['agent_application.app_icon_id'] : ''));
    var app_name = fact ? fact['agent_application.app_name'] : '';
    return app_name ? '<span' + makeFilterAttrs('agent_application@app_name:app_name', app_name, app_name) + '>' + app_icon + app_name + '</span>' : '';
  },
  'dim': 'agent_application@app_name:app_name',
  sortable: true
};
var TitleCol = {
  factKey: 'window_title',
  'label': gettext('Заголовок'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact) {
    return fact ? fact['window_title'] ? cellFromProp(ATTR2PROP['window_title'](fact)) : '' : '';
  },
  sortable: true
};
var FileOperationTypeCol = {
  factKey: 'agent_attachedfile.file_operation',
  'label': gettext('Операция'),
  'parse': function parse(fact) {
    return fact ? fact['agent_attachedfile.file_operation'] ? cellFromProp(ATTR2PROP['agent_attachedfile.file_operation'](fact)) : '' : '';
  },
  sortable: true
};
var FileOperationCol = {
  factKey: 'text_data',
  'label': gettext('Описание'),
  'parse': function parse(fact) {
    return !fact['agent_attachedfile.file_path'] || fact['text_data'] && fact['text_data'].indexOf('\n') != -1 ? cellFromProp(ATTR2PROP['text_data'](fact)) : '';
  },
  sortable: false
};
var ExtraCol = {
  factKey: 'text_data',
  'label': gettext('Дополнительно'),
  'parse': function parse(fact) {
    return fact ? fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact)) : '' : '';
  },
  sortable: false
};

var TextCol = {
  factKey: 'text_data',
  'label': gettext('Текст'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact, mode) {
    return fact ? fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '' : '';
  },
  sortable: false
};

var KeyboardTextCol = {
  factKey: 'text_data',
  'label': gettext('Текст'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact, mode) {
    return fact ? cellFromProp(ATTR2PROP['text_data'](fact, mode)) : '';
  },
  sortable: false
};

var NetCol = {
  factKey: 'agent_networkconnection.remote_address',
  'label': gettext('Сокет'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_networkconnection.remote_address'](fact)) : '';
  },
  sortable: true
};

var SenderCol = {
  factKey: 'agent_dialog.sender',
  'label': gettext('Отправитель'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_dialog.sender'](fact)) : '';
  },
  sortable: true
};
var RecipientsCol = {
  factKey: 'agent_dialog.recipients',
  'label': gettext('Получатели'),
  'parse': function parse(fact) {
    if (!fact) return '';
    var recipients = fact['agent_dialog.recipients'] ? cellFromProp(ATTR2PROP['agent_dialog.recipients'](fact)) : '';
    var breakLine = fact['agent_dialog.recipients'] && fact['agent_web.url'] ? '<br>' : '';
    var url = fact['agent_web.url'] ? cellFromProp(ATTR2PROP['agent_web.url'](fact)) : '';
    return '' + recipients + breakLine + url;
  },
  sortable: true
};
var ImMessageCol = {
  factKey: 'text_data',
  'label': gettext('Сообщение'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact, mode) {
    return fact ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '';
  },
  sortable: false
};
var InstallEventCol = {
  factKey: 'agent_appinstallation.install_event',
  'label': gettext('Операция'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.install_event'](fact)) : '';
  },
  'dim': 'agent_appinstallation@install_event:install_event',
  sortable: true
};
var InstallProductCol = {
  factKey: 'agent_appinstallation.install_event',
  'label': gettext('Продукт'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.product_name'](fact)) : '';
  },
  'dim': 'agent_appinstallation@product_name:product_name',
  sortable: true
};

var InstallPublisherCol = {
  factKey: 'agent_appinstallation.publisher',
  'label': gettext('Поставщик'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.publisher'](fact)) : '';
  },
  'dim': 'agent_appinstallation@publisher:publisher',
  sortable: true
};

var InstallVersionCol = {
  factKey: 'agent_appinstallation.version',
  'label': gettext('Версия'),
  'parse': function parse(fact) {
    return fact ? cellFromProp(ATTR2PROP['agent_appinstallation.version'](fact)) : '';
  },
  'dim': 'agent_appinstallation@version:version',
  sortable: true
};

var AttachedFileNameCol = {
  factKey: 'agent_attachedfile.file_name',
  'label': gettext('Имя файла'),
  'parse': function parse(fact) {
    return fact ? fact['agent_attachedfile.file_name'] ? cellFromProp(ATTR2PROP['agent_attachedfile.file_name'](fact)) : '' : '';
  },
  sortable: true
};

var AttachedFilePathCol = {
  factKey: 'agent_attachedfile.file_path',
  'label': gettext('Путь'),
  'parse': function parse(fact) {
    return fact ? fact['agent_attachedfile.file_path'] ? cellFromProp(ATTR2PROP['agent_attachedfile.file_path'](fact)) : '' : '';
  },
  sortable: true
};

var AttachedFileCol = {
  factKey: 'agent_attachedfile.data',
  'label': gettext('Контент'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact) {
    if (fact && fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact && fact.children) {
      return fact.children.map(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        var linkToChildren = ch['id'] ? cellFromProp(ATTR2PROP['children_id'](ch)) : '';
        return ch['agent_attachedfile.data'] ? cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) + linkToChildren : '';
      }).join('');
    }
    return '';
  },
  sortable: true
};

var ScreenshotCol = {
  factKey: 'agent_attachedfile.data',
  'label': gettext('Снимок'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact) {
    if (fact && fact['agent_attachedfile.data']) {
      return cellFromProp(ATTR2PROP['agent_attachedfile.data'](fact));
    }
    if (fact && fact.children) {
      return fact.children.map(function (ch) {
        ch['parentName'] = fact['agent_eventtype.name'];
        return ch['agent_attachedfile.data'] ? cellFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) : '';
      }).join('');
    }
    return '';
  },
  sortable: true
};

var DeviceManufacturerCol = {
  factKey: 'agent_device.manufacturer',
  'label': gettext('Тип'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_device.manufacturer'](fact));
  },
  sortable: true
};

var DeviceDescriptionCol = {
  factKey: 'agent_device.description',
  'label': gettext('Устройство'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return fact['agent_device.description'] ? cellFromProp(ATTR2PROP['agent_device.description'](fact)) : '';
  },
  sortable: true
};

var DeviceHWIDCol = {
  factKey: 'agent_device.hwid',
  'label': gettext('ID'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return fact['agent_device.hwid'] ? cellFromProp(ATTR2PROP['agent_device.hwid'](fact)) : '';
  },
  sortable: true
};

var DriveTypeCol = {
  factKey: 'agent_device.drive_type',
  'label': gettext('Тип диска'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return fact['agent_device.drive_type'] ? cellFromProp(ATTR2PROP['agent_device.drive_type'](fact)) : '';
  },
  sortable: true
};

var LogonCol = {
  factKey: 'logon_event',
  'label': gettext('Событие'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['logon_event'](fact));
  },
  'dim': 'logon_event@default:logon_event',
  sortable: true
};

var AmountCol = {
  factKey: 'call_duration',
  'label': gettext('Количество'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return fact['call_duration'];
  },
  sortable: true
};

var PriceCol = {
  factKey: 'activity_time',
  'label': gettext('Цена'),
  'parse': function parse(fact) {
    return fact['activity_time'];
  },
  sortable: true
};

var TotalPagesCol = {
  factKey: 'call_duration',
  'label': gettext('Страницы'),
  'cssClass': 'fact-center',
  'parse': function parse(fact) {
    return cellFromProp(ATTR2PROP['call_duration'](fact));
  },
  sortable: true
};

var FileSizeCol = {
  factKey: 'file_size',
  'label': gettext('Размер'),
  'cssClass': 'fact-center',
  'parse': function parse(fact) {
    return cellFromProp(ATTR2PROP['file_size'](fact));
  },
  sortable: true
};

var EventCol = {
  factKey: 'text_data',
  // factKey:'agent_eventtype.name',
  'label': gettext('Событие'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact) {
    var w = IMPATTR2PROP.map(function (attr) {
      return fact ? fact[attr] ? cellFromProp(ATTR2PROP[attr](fact)) : '' : '';
    }).join('');

    fact && fact.children ? fact.children.forEach(function (ch) {
      ch['parentName'] = fact['agent_eventtype.name'];
      w += IMPATTR2PROP.map(function (attr) {
        return ch[attr] ? cellFromProp(ATTR2PROP[attr](ch)) : '';
      }).join('');
    }) : null;
    return w;
  },
  sortable: false
};

var UserActiveCol = {
  factKey: 'activity_time',
  'cssClass': 'fact-time',
  'label': gettext('Длительность'),
  'parse': function parse(fact) {
    return fact ? (0, _datetime.ticksFormat)(fact['activity_time'], true) : '';
  },
  sortable: true
};

var FeedbackCol = {
  factKey: 'agent_feedbacktype.name',
  'label': gettext('Статус'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_feedbacktype.name'](fact));
  },
  sortable: true
};

var BacklinkCol = {
  factKey: 'window_title',
  'label': gettext('Ссылка'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return '<a href=\'' + _config.DEFAULT_FEEDBACK_URL + fact['window_title'] + '\' target=\'_new\'>' + fact['window_title'] + '</a>';
  },
  sortable: true
};

var CommentCol = {
  factKey: 'agent_account.comment',
  'label': gettext('Комментарий'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_account.comment'](fact));
  },
  sortable: true
};

var ParentCol = {
  factKey: 'parent_id',
  'label': gettext('Связано с'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return fact['parent_id'] ? cellFromProp(ATTR2PROP['parent_id'](fact)) : '';
  },
  sortable: true
};

var IdleTimeCol = {
  factKey: 'idle_time',
  'label': gettext('Время'),
  'cssClass': 'fact-time',
  'parse': function parse(fact) {
    return fact ? (0, _datetime.ticksFormat)(fact['idle_time']) : '';
  },
  sortable: true
};

var FeedbackDescriptionCol = {
  factKey: 'agent_feedbacktype.description',
  'label': gettext('Алерт'),
  'parse': function parse(fact) {
    if (!fact) return '';
    return cellFromProp(ATTR2PROP['agent_feedbacktype.description'](fact));
  },
  sortable: true
};

var WLanCol = {
  factKey: 'text_data',
  'label': gettext('SSID'),
  'cssClass': 'fact-wide',
  'parse': function parse(fact, mode) {
    return fact ? fact['text_data'] ? cellFromProp(ATTR2PROP['text_data'](fact), mode) : '' : '';
  },
  sortable: false
};
// TableViews

var tableViews = [{
  'name': 'BaseTable',
  'columns': [TimeCol, TypeCol, ComputerCol, UserCol, AppCol, EventCol],
  'important': [EventCol],
  'colwidths': [.1, .1, .1, .1, .1, .5]
}, {
  'name': 'Keyboard',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, TitleCol, TextCol],
  'important': [AppCol, TitleCol, WebCol, KeyboardTextCol]
}, {
  'name': 'AppRun',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, ProcessIdCol, UserSessionIdCol],
  'important': [AppCol, TitleCol, ProcessIdCol, UserSessionIdCol]
}, {
  'name': 'AppActiv',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, TitleCol, ProcessIdCol, UserSessionIdCol],
  'important': [AppCol, TitleCol, TextCol, DomainCol, WebCol, ProcessIdCol, UserSessionIdCol]
}, {
  'name': 'Screenshot',
  'columns': [TimeCol, ComputerCol, UserCol, TitleCol, ScreenshotCol],
  'important': [AppCol, TitleCol, WebCol, ScreenshotCol],
  'colwidths': [.1, .1, .1, .2, .3]
}, {
  'name': 'WebcamSnapshot',
  'columns': [TimeCol, ComputerCol, UserCol, ScreenshotCol],
  'important': [UserCol, ScreenshotCol],
  'colwidths': [.1, .1, .1, .7]
}, {
  'name': 'MicRecording',
  'columns': [TimeCol, ComputerCol, UserCol, DeviceDescriptionCol, AttachedFileCol],
  'important': [DeviceDescriptionCol, AttachedFileCol],
  'colwidths': [.1, .1, .1, .1, .3]
}, {
  'name': 'Net',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, NetCol],
  'important': [NetCol, AppCol]
}, {
  'name': 'Install',
  'columns': [TimeCol, ComputerCol, InstallEventCol, InstallProductCol, InstallPublisherCol, InstallVersionCol],
  'important': [InstallEventCol, InstallProductCol]
}, {
  'name': 'Web',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, WebCol],
  'important': [AppCol, DomainCol, TitleCol, WebCol, AttachedFileCol],
  'colwidths': [.1, .1, .1, .1, .3]
}, {
  'name': 'Im',
  'columns': [TimeCol, ComputerCol, UserCol, SenderCol, RecipientsCol, ImMessageCol, AttachedFileCol],
  'important': [SenderCol, RecipientsCol, TitleCol, AttachedFileCol, ImMessageCol],
  'colwidths': [.1, .1, .1, .1, .1, .4, .3]
}, {
  'name': 'Mail',
  'columns': [TimeCol, ComputerCol, UserCol, SenderCol, RecipientsCol, TitleCol, AttachedFileCol],
  'important': [SenderCol, RecipientsCol, TitleCol, AttachedFileCol, ImMessageCol],
  'colwidths': [.1, .1, .1, .1, .1, .4, .3]
}, {
  'name': 'PrintDoc',
  'columns': [TimeCol, ComputerCol, UserCol, TotalPagesCol, TextCol, AttachedFileCol],
  'important': [TextCol, AttachedFileCol, TotalPagesCol],
  'colwidths': [.1, .1, .1, .1, .3, .3]
}, {
  'name': 'Clipboard',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, TextCol, AttachedFileCol, ClipboardFormatCol],
  'important': [TextCol, AttachedFileCol],
  'colwidths': [.1, .1, .1, .1, .1, .3, .1]
}, {
  'name': 'Logon',
  'columns': [TimeCol, ComputerCol, UserCol, LogonCol],
  'important': [LogonCol]
}, {
  'name': 'Device',
  'columns': [TimeCol, ComputerCol, UserCol, DeviceManufacturerCol, DeviceDescriptionCol, DeviceHWIDCol, ExtraCol],
  'important': [DeviceManufacturerCol, DeviceDescriptionCol, DeviceHWIDCol, ExtraCol]
}, {
  'name': 'DevInventory',
  'columns': [TimeCol, ComputerCol, DeviceManufacturerCol, DeviceDescriptionCol, DeviceHWIDCol],
  'important': [DeviceManufacturerCol, DeviceDescriptionCol, DeviceHWIDCol, ExtraCol]
}, {
  'name': 'FileOperation',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, FileOperationTypeCol, AttachedFileNameCol, DeviceDescriptionCol, DriveTypeCol],
  'important': [FileOperationTypeCol, AttachedFileNameCol, AttachedFilePathCol, DeviceDescriptionCol, DriveTypeCol, FileOperationCol, ParentCol]
}, {
  'name': 'Stat',
  'columns': [TimeCol, TypeCol, ComputerCol, UserCol, UserActiveCol, AppCol, DomainCol, TitleCol],
  'important': [AppCol, TitleCol, DomainCol, WebCol, UserActiveCol],
  'colwidths': [.1, .1, .1, .1, .1, .1, .1, .3]
}, {
  'name': 'UserFeedback',
  'columns': [BacklinkCol, TimeCol, FeedbackCol, OwnerCol, UserCol, AmountCol, PriceCol, CommentCol],
  'important': [BacklinkCol, TimeCol, FeedbackCol, OwnerCol, UserCol, AmountCol, PriceCol, CommentCol]
}, {
  'name': 'AttachedFile',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, AttachedFileCol, ParentCol, TotalPagesCol, FileSizeCol, RecipientsCol],
  'important': [AttachedFileCol, ParentCol, RecipientsCol, FileSizeCol, FileOperationTypeCol, DeviceDescriptionCol, AttachedFileNameCol, AttachedFilePathCol, TextCol, DriveTypeCol],
  'colwidths': [.1, .1, .1, .1, .3, .1, .05, .1, .3]
}, {
  'name': 'SystemLog',
  'columns': [TimeCol, TypeCol, ComputerCol, TextCol, AttachedFileCol],
  'important': [AppCol, TextCol, AttachedFileCol]
}, {
  'name': 'FrameBuffer',
  'columns': [TimeCol, ComputerCol, UserCol, AttachedFileCol],
  'important': [AttachedFileCol],
  'colwidths': [.1, .1, .1, .1, .3]
}, {
  'name': 'SearchQuery',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, SiteCol, TextCol],
  'important': [AppCol, SiteCol, TextCol, WebCol]
}, {
  'name': 'FormData',
  'columns': [TimeCol, ComputerCol, UserCol, AppCol, AttachedFileCol, DomainCol, ParentCol],
  'important': [AttachedFileCol, ParentCol, RecipientsCol, FileOperationTypeCol, DeviceDescriptionCol, DomainCol, TextCol, DriveTypeCol],
  'colwidths': [.1, .1, .1, .1, .3, .1, .1]
}, {
  'name': 'WLan',
  'columns': [TimeCol, ComputerCol, WLanCol],
  'important': [WLanCol]
}, {
  'name': 'Activty',
  'columns': [TimeCol, TypeCol, ComputerCol, UserCol, IdleTimeCol, FeedbackDescriptionCol, TextCol],
  'important': [ComputerCol, UserCol, IdleTimeCol, FeedbackDescriptionCol, TextCol]
}];

var tableViewByType = {
  '0': 'AttachedFile',
  '1': 'Keyboard',
  '2': 'AppRun',
  '3': 'AppActiv',
  '4': 'Screenshot',
  '5': 'Net',
  '6': 'Install',
  '7': 'Web',
  '8': 'Im',
  '9': 'Mail',
  '11': 'PrintDoc',
  '12': 'Logon',
  '13': 'Clipboard',
  '14': 'Device',
  '15': 'Device',
  '16': 'FileOperation',
  '17': 'SystemLog',
  '18': 'Activty',
  '19': 'UserFeedback',
  '20': 'WebcamSnapshot',
  '21': 'MicRecording',
  '22': 'FrameBuffer',
  '23': 'DevInventory',
  '24': 'Install',
  '25': 'SearchQuery',
  '27': 'FormData',
  '28': 'WLan',
  '100500': 'Stat'
};

var otherColProperty = function otherColProperty(field, dim, fact) {
  var value = escapeHtml(fact[field]);
  return {
    fdim: dim,
    key: field,
    val: value,
    fval: value,
    flbl: value
  };
};

var getColFromDims = function getColFromDims(field, dims) {
  var _field$split = field.split('.'),
      _field$split2 = _slicedToArray(_field$split, 2),
      pField = _field$split2[0],
      cField = _field$split2[1];

  var label = false;
  var dimension = false;
  dims.some(function (dim) {
    if (dim.name === pField) {
      if (!cField) {
        dimension = pField + '@default:' + pField;
        label = dim.label;
        return label;
      }
      return dim.levels.some(function (l) {
        if (l.attributes && l.attributes.length > 1) {
          return l.attributes.some(function (attr) {
            if (attr.name === cField) {
              dimension = pField + '@default:' + pField;
              label = attr.label;
            }
            return label;
          });
        }
        if (l.key === cField) {
          label = l.label;
          dim.hierarchies.some(function (h) {
            return h.levels.some(function (hl) {
              if (hl === cField) {
                dimension = pField + '@' + h.name + ':' + cField;
                return true;
              }
            });
          });
        }
        return label;
      });
    }
    return false;
  });
  if (label) {
    var parse = ATTR2PROP[field] ? function (fact) {
      return cellFromProp(ATTR2PROP[field](fact));
    } : function (fact) {
      return cellFromProp(otherColProperty(field, dimension, fact));
    };
    return {
      factKey: field,
      label: label,
      parse: parse,
      sortable: unsortableFields.indexOf(field) === -1
    };
  } else return null;
};

function getTableViewByType(eventTypeId, filters, colFields, dims) {
  var tableView = void 0;
  if (colFields && colFields.length) {
    tableView = colFields.reduce(function (res, f) {
      if (!tableViews.some(function (tw) {
        var i = tw.columns.findIndex(function (c) {
          return c.factKey === f;
        });
        if (i === -1) return false;
        // console.log(tw.columns[i]);
        res.columns.push(tw.columns[i]);
        res.colwidths.push(tw.colwidths ? tw.colwidths[i] : 0.1);
        return true;
      })) {
        var col = getColFromDims(f, dims);
        if (col) {
          res.columns.push(col);
          res.colwidths.push(0.1);
        }
      }
      return res;
    }, {
      name: 'SelectedFields',
      columns: [],
      colwidths: [],
      important: []
    });
  } else {
    var viewTypeName = tableViewByType[eventTypeId] ? tableViewByType[eventTypeId] : 'BaseTable';
    tableView = $.grep(tableViews, function (tv) {
      return tv.name === viewTypeName;
    })[0];
  }

  if (filters) {
    var skipCols = filters.reduce(function (p, f) {
      if (f.dimension === 'agent_eventtype@default:agent_eventtype') {
        return p;
      }
      if (f.predicates && f.predicates.length) {
        return p;
      }
      p = p.concat(tableView.columns.filter(function (c) {
        return c.dim === f.dimension && filters.reduce(function (cl, cf) {
          return cl + (f.dimension === cf.dimension ? 1 : 0);
        }, 0) === 1;
      }));
      return p;
    }, []);

    if (skipCols.length > 0) {
      var replaceTableView = {
        'name': tableView.name,
        'columns': tableView.columns.map(function (c) {
          return c;
        }),
        'important': tableView.important,
        'colwidths': tableView.colwidths ? tableView.colwidths.map(function (c) {
          return c;
        }) : undefined
      };
      for (var s in skipCols) {
        var i = replaceTableView.columns.indexOf(skipCols[s]);
        replaceTableView.columns.splice(i, 1);
        if (replaceTableView.colwidths) {
          replaceTableView.colwidths.splice(i, 1);
        }
      }
      return replaceTableView;
    }
  }
  return tableView;
}

function getBottomComponentHtml(fact) {
  var attrs2prop = ATTR2PROP;
  var widget2 = '<div id="id_bottom_' + fact.id + '" class="widget-properties show-waves">';
  widget2 += Object.keys(attrs2prop).map(function (k) {
    if (fact && fact[k]) {
      var additionalElement = fact['agent_eventtype.name'] === 'InterceptedFile' && k == 'text_data' ? (0, _decodeFact.decoderElement)() : '';
      return widgetFromProp(attrs2prop[k](fact, additionalElement));
    }
  }).join('', '');

  if (fact && fact.children) {
    widget2 += fact.children.map(function (ch) {
      ch['parentName'] = fact['agent_eventtype.name'];
      var linkToChildren = ch['id'] ? widgetFromProp(ATTR2PROP['children_id'](ch)) : '';
      return ch['agent_attachedfile.data'] ? widgetFromProp(ATTR2PROP['agent_attachedfile.data'](ch)) + linkToChildren : '';
    }).join('');
  }

  widget2 += '</div>';
  return widget2;
}

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var boolDialogCtrl = exports.boolDialogCtrl = function boolDialogCtrl($scope, $modalInstance, $timeout) {
  $scope.close = function () {
    $modalInstance.close(false);
  };
  $scope.ok = function () {
    $modalInstance.close(true);
  };
};

/* ---------------------------------------------- */
/* helloDialogCtrl */

var helloDialogCtrl = exports.helloDialogCtrl = function helloDialogCtrl($scope, $modalInstance, $cookies) {
  $scope.close = function () {
    $cookies.put('notShowHello', $scope.notShowHello);
    $modalInstance.close();
  };
  $scope.change = function () {
    $scope.notShowHello = !$scope.notShowHello;
  };
};

var configureAccountCtrl = exports.configureAccountCtrl = function configureAccountCtrl($http, $scope, $modalInstance, accountCell, accountData) {

  $scope.accountCell = accountCell;
  $scope.accountData = accountData['data'];
  $scope.formErrors = accountData['errors'];

  $scope.ok = function () {
    if ($scope.accountData.email == '') {
      $scope.formErrors['email'] = [gettext('Введите емэйл!')];
      return;
    }

    $http.post('/accounts/configacc/' + $scope.accountCell['agent_account.id'], $scope.accountData).then(function (_ref) {
      var data = _ref.data;

      console.log('Saved profile: ' + data);
      if (!data['errors'] || data['errors'].length == 0) {
        $modalInstance.close(gettext('Пароль для ') + $scope.accountData['email'] + gettext(' отправлен.'));
      }
      $scope.formErrors = data['errors'];
    }).catch(function (_ref2) {
      var data = _ref2.data,
          status = _ref2.status,
          headers = _ref2.headers,
          config = _ref2.config;

      console.log(status, data);
    });

    //     $modalInstance.close($scope.accountData);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };
};

/* ---------------------------------------------- */
/* showImageDialogCtrl */

var updatesCtrl = exports.updatesCtrl = function updatesCtrl($scope, $modalInstance, $http, PermissionService) {
  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.ok = function (action) {
    $modalInstance.close(action);
  };
  $scope.fromData = function (data) {
    if (PermissionService.selectedLang === 'ru') {
      $scope.changeListUrl = 'https://docs.staffcop.ru/update/changelog.html';
    } else {
      $scope.changeListUrl = 'https://docs.staffcop.ru/update/changelog_en.html';
    }
    $scope.settings_server_version = data['settings_server_version'];
    $scope.settings_agent_version = data['settings_agent_version'];
    $scope.settings_linux_agent_version = data['settings_linux_agent_version'];
    $scope.agent_update_required = data['agent_update_required'];
    $scope.clickhouse_available = data['clickhouse_available'];
    $scope.message = data['message'];
  };
  $scope.init = function () {
    $scope.fromData({});
    $http.get('/analytics/update_agent/').then(function (_ref3) {
      var data = _ref3.data;

      $scope.fromData(data);
    }).catch(function (_ref4) {
      var data = _ref4.data,
          status = _ref4.status,
          headers = _ref4.headers,
          config = _ref4.config;

      console.log(status, data);
    });
  };
  $scope.update_agent = function () {
    $http.post('/analytics/update_agent/').then(function (_ref5) {
      var data = _ref5.data;

      $scope.fromData(data);
    }).catch(function (_ref6) {
      var data = _ref6.data,
          status = _ref6.status,
          headers = _ref6.headers,
          config = _ref6.config;

      console.log(status, data);
    });
  };
  $scope.init();
};

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AUDIO_DOWNLOAD_TYPE = exports.AUDIO_DOWNLOAD_TYPE = 'AUDIO_DOWNLOAD_TYPE';
var BACKEND = exports.BACKEND = 'BACKEND';

var LocalStorageService = exports.LocalStorageService = function () {
  function LocalStorageService() {
    _classCallCheck(this, LocalStorageService);
  }

  _createClass(LocalStorageService, [{
    key: 'getItem',

    // constructor() {
    // }

    value: function getItem(key, def) {
      if (!localStorage) return null;
      var value = localStorage.getItem(key);
      return value === null || value === 'null' ? def || value : value;
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      return localStorage && localStorage.setItem(key, value);
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      return localStorage && localStorage.removeItem(key);
    }
  }, {
    key: 'hasItem',
    value: function hasItem(key) {
      return this.getItem(key) !== null;
    }
  }, {
    key: 'isTrue',
    value: function isTrue(key) {
      return localStorage && localStorage.getItem(key) && localStorage.getItem(key).toLowerCase() === 'true';
    }

    //*******************************************************

  }, {
    key: 'copyTextToClipboard',
    value: function copyTextToClipboard(text) {
      var copyTextToClipboardChrome = function copyTextToClipboardChrome(text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
        } catch (err) {
          console.error('unable copy to clipboard', err);
        }
        document.body.removeChild(textArea);
      };

      if (!navigator.hasOwnProperty('clipboard')) {
        copyTextToClipboardChrome(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {}, function (err) {
        console.error('unable copy to clipboard', err);
      });
    }
  }]);

  return LocalStorageService;
}();

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var filterMode = exports.filterMode = {
  'explore': 'icon-explore',
  'chart': 'icon-chart',
  'chart-area': 'icon-chart-bar',
  'stat': 'icon-table',
  'report': 'icon-grid',
  'reports': 'icon-reports',
  'tree': 'icon-flow-split',
  'radar': 'icon-radar',
  'summ-stat': 'icon-summ',
  'event-river': 'icon-river'
};

var listMode = exports.listMode = {
  'table': 'icon-table',
  'brief': 'icon-th-list',
  'thumblist': 'icon-file-image',
  'chat-viewer': 'icon-mail'
};

var typeIcons = exports.typeIcons = {
  'folder': 'icon-folder-open-empty',
  'policy': 'icon-hammer',
  'uncategorized': 'icon-hammer',
  'ocrparser': 'icon-doc-text',
  'sessionprocessfilter': 'icon-reports',
  'syslogprocessfilter': 'icon-temperatire',
  'extractextprocessfilter': 'icon-file-pdf',
  'dashboard': 'icon-vcard',
  'corpusprocessfilter': 'icon-search',
  'dimensioncardfilter': 'icon-stat',
  'backupfilter': 'icon-content-broken',
  'filearchivefilter': 'icon-file-archive',
  'lateagentfilter': 'icon-attention',
  'inactiveagentfilter': 'icon-attention',
  'lateuploadfilter': 'icon-attention',
  'letteryourself': 'icon-hammer',
  'contactconnect': 'icon-chat',
  'mailgrabber': 'icon-mail',
  'filteraggregatealertfilter': 'icon-attention',
  'msgraphgrabber': 'icon-globe',
  'graphicobjectsdetector': 'icon-file-image',
  'facedetector': ' icon-emo-happy'
};

var getFilterIcon = exports.getFilterIcon = function getFilterIcon(filter) {
  var icon = typeIcons[filter.content_type];
  if (icon) return icon;
  if (filter.mode == 'explore') return listMode[filter.listType];
  if (filter.isGraph) return 'icon-share';
  return filterMode[filter.mode] ? filterMode[filter.mode] : 'icon-wrench';
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isImg = function isImg(f) {
  return f['agent_attachedfile.mime'] && f['agent_attachedfile.mime'].indexOf('image/') == 0;
};

var getImgFileName = function getImgFileName(fact) {
  if (!fact) return false;
  if (isImg(fact)) return fact['agent_attachedfile.data'];
  var child = fact.children && fact.children.find(isImg);
  if (!child) return false;
  var imageFileName = child['agent_attachedfile.data'];
  if (!fact['agent_attachedfile.data'] && !fact['agent_attachedfile.mime']) {
    fact['agent_attachedfile.data'] = imageFileName;
    fact['agent_attachedfile.mime'] = child['agent_attachedfile.mime'];
  }
  return imageFileName;
};

var Fact = exports.Fact = function () {
  function Fact() {
    _classCallCheck(this, Fact);
  }

  _createClass(Fact, null, [{
    key: 'isImage',
    value: function isImage(fact) {
      return !!getImgFileName(fact);
    }
  }, {
    key: 'getImageFileName',
    value: function getImageFileName(fact) {
      return getImgFileName(fact);
    }
  }]);

  return Fact;
}();

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASIC_DIMS = ['analytics_filter', 'agent_time', 'agent_eventtype', 'agent_agent', 'agent_account'];

var TYPE_DIMENSIONS = exports.TYPE_DIMENSIONS = {
  '0': BASIC_DIMS.concat(['agent_application', 'agent_attachedfile', 'agent_device', 'agent_dialog', 'agent_web']),
  '1': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '2': BASIC_DIMS.concat(['agent_application']),
  '3': BASIC_DIMS.concat(['agent_application']),
  '4': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '5': BASIC_DIMS.concat(['agent_application', 'agent_networkconnection']),
  '6': BASIC_DIMS.concat(['agent_application', 'agent_appinstallation']),
  '7': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '8': BASIC_DIMS.concat(['agent_application', 'agent_dialog']),
  '9': BASIC_DIMS.concat(['agent_application', 'agent_dialog']),
  '10': BASIC_DIMS.concat(['agent_application', 'agent_networkconnection', 'agent_attachedfile']),
  '11': BASIC_DIMS.concat(['agent_attachedfile']),
  '12': BASIC_DIMS,
  '13': BASIC_DIMS.concat(['agent_application']),
  '14': BASIC_DIMS.concat(['agent_device']),
  '15': BASIC_DIMS.concat(['agent_attachedfile', 'agent_device']),
  '16': BASIC_DIMS.concat(['agent_application', 'agent_attachedfile', 'agent_device']),
  '17': BASIC_DIMS,
  '18': BASIC_DIMS.concat(['agent_feedbacktype']),
  '19': BASIC_DIMS.concat(['agent_feedbacktype']),
  '20': BASIC_DIMS,
  '21': BASIC_DIMS.concat(['agent_attachedfile', 'agent_device', 'agent_application']),
  '22': BASIC_DIMS,
  '23': BASIC_DIMS.concat(['agent_device']),
  '24': BASIC_DIMS.concat(['agent_appinstallation']),
  '25': BASIC_DIMS.concat(['agent_application', 'agent_web']),
  '26': BASIC_DIMS.concat(['agent_attachedfile']),
  '27': BASIC_DIMS.concat(['agent_application', 'agent_attachedfile', 'agent_device', 'agent_dialog', 'agent_web']),
  '100500': BASIC_DIMS.concat(['agent_application', 'agent_web'])
};

var isStrictDimention = exports.isStrictDimention = function isStrictDimention(dimension, hierarchy) {
  if (dimension === 'agent_eventtype') return true;
  // if (dimension === 'agent_agent' && hierarchy === 'computer_name') return true;
  if (dimension === 'agent_feedbacktype') return true;
  // if (dimension === 'agent_attachedfile' && hierarchy === 'file_operation') return true;
  if (dimension === 'agent_dialog' && hierarchy === 'direction') return true;
  if (dimension === 'agent_time') return true;
  return false;
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Level = exports.Level = function () {
  function Level() {
    _classCallCheck(this, Level);
  }

  _createClass(Level, [{
    key: 'buildModel',


    // constructor() {
    // }

    value: function buildModel() {}

    /*
     * Get a attribute by name.
     * Accepts dimension level in the input string.
     */

  }, {
    key: 'getAttribute',
    value: function getAttribute(attribute) {

      var attr = $.grep(this.attributes, function (el) {
        return el.name == attribute;
      })[0];

      return attr;
    }

    /*
     * Processes a cell and returns an object with a stable information:
     * o.key
     * o.label
     * o.info[]
     */

  }, {
    key: 'readCell',
    value: function readCell(cell) {

      if (!cell || !(this.getAttribute(this.key).full_name in cell)) return null;

      var result = {};
      result.key = cell[this.getAttribute(this.key).full_name];
      result.label = cell[this.getAttribute(this.label_attribute).full_name];
      result.info = {};
      this.attributes.forEach(function (attribute) {
        result.info[attribute.name] = cell[attribute.full_name];
      });
      return result;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.dimension.toString().split(':')[0] + ':' + this.name;
    }
  }]);

  return Level;
}();

/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Model = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.buildModel = buildModel;

var _dimension = __webpack_require__(739);

var _cube = __webpack_require__(741);

var _filter = __webpack_require__(28);

var _datetime = __webpack_require__(61);

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DIALOG_DIRECTIONS = {
  'Incoming': gettext('Входящие'),
  'Outgoing': gettext('Исходящие')
};

/* OLAP cubes models */

var Model = exports.Model = function () {
  function Model() {
    _classCallCheck(this, Model);
  }

  _createClass(Model, [{
    key: 'buildModel',


    // constructor() {
    // }

    value: function buildModel() {
      $(this.dimensions).each(function (idx, dimension) {
        Object.setPrototypeOf(dimension, _dimension.Dimension.prototype);
        dimension.buildModel();
      });
      $(this.cubes).each(function (idx, cube) {
        Object.setPrototypeOf(cube, _cube.Cube.prototype);
        cube.buildModel();
      });
    }

    /*
     * Return a cube by name.
     */

  }, {
    key: 'getCube',
    value: function getCube(cubename) {
      var cube = $.grep(this.cubes, function (e) {
        return e.name == cubename;
      })[0];

      return cube;
    }

    /*
     * Get a dimension by name.
     * Accepts dimension level in the input string.
     */

  }, {
    key: 'getDimension',
    value: function getDimension(dimension) {
      var dimname = dimension;
      if (dimension.indexOf('@') > 0) {
        dimname = dimension.split('@')[0];
      } else if (dimension.indexOf(':') > 0) {
        dimname = dimension.split(':')[0];
      }
      var dim = this._dimensions.find(function (ed) {
        return ed.name === dimname;
      });
      return dim;
    }

    /*
     * Get a hierarchy by name.
     * Accepts dimension level in the input string.
     */

  }, {
    key: 'getHierarchy',
    value: function getHierarchy(dimension, hierarchy) {
      var dim = this.getDimension(dimension);
      if (hierarchy) {
        return dim.getHierarchy(hierarchy);
      }
      if (dimension.indexOf('@') > 0) {
        var hierarchyName = dimension.split('@')[1].split(':')[0];
        return dim.getHierarchy(hierarchyName);
      }
      return dim.getDefaultHierarchy();
    }
  }, {
    key: 'isNumDimensionValue',
    value: function isNumDimensionValue(dimensionString) {
      var parts = this.getDimensionParts(dimensionString);
      return !!parts.hierarchy && parts.hierarchy.name === 'default' && parts.level.key === 'id';
    }
  }, {
    key: 'checkIsFilterCutsValueAllowed',
    value: function checkIsFilterCutsValueAllowed(filter) {
      var _this = this;

      var dim = void 0;
      return filter.filters.every(function (cut) {
        dim = cut.dimension;
        return !_this.isNumDimensionValue(dim) || !isNaN(parseInt(cut.value, 0));
      }) ? '' : gettext('Неверное значение измерения') + (': "' + dim + '"');
    }
  }, {
    key: 'getDimensionParts',
    value: function getDimensionParts(dimensionString) {

      if (dimensionString === 'keyword') {
        return {
          label: gettext('Ключевое слово')
        };
      }

      var dim = this.getDimension(dimensionString);
      if (!dim) return {};
      var lev = null;
      if (dimensionString.indexOf(':') > 0) {
        var levelname = dimensionString.split(':')[1];
        lev = dim.getLevel(levelname);
      } else lev = dim.levels[0];

      var hie = dim.hierarchies[0];
      if (dimensionString.indexOf('@') > 0) {
        var hierarchyName = dimensionString.split('@')[1].split(':')[0];
        hie = dim.getHierarchy(hierarchyName);
      }

      return {
        dimension: dim,
        level: lev,
        hierarchy: hie,
        label: dim.label + (lev != null && lev.label != dim.label ? ': ' + lev.label : '')
      };
    }

    /* constnstnst
     * Get drilldown label
     */

  }, {
    key: 'getDrillLabel',
    value: function getDrillLabel(dimString) {
      if (dimString === 'id@default:id') return 'ID';
      return this.getDimensionParts(dimString).label;
    }

    /*
     * Get drilldown table attribute
     */

  }, {
    key: 'getDrillAttr',
    value: function getDrillAttr(dimString) {
      var info = this.getDimensionParts(dimString);
      return info.dimension.name + '.' + info.level.label_attribute;
    }
  }, {
    key: 'getCellFilter',
    value: function getCellFilter(drill, cell) {
      var parts = this.getDimensionParts(drill);
      var infos = parts.hierarchy.readCell(cell, parts.level);
      var drilldown_level_values = [];
      var drilldown_level_labels = [];
      infos.forEach(function (info) {
        drilldown_level_values.push(info.key);
        drilldown_level_labels.push(info.info.description || info.label);
      });
      var dim = drill.toString();
      var label = void 0;
      if (dim === 'agent_dialog@direction:direction') {
        label = DIALOG_DIRECTIONS[drilldown_level_values[0]];
      } else if (['agent_agent@computer_name:computer_name'].indexOf(dim) >= 0) {
        label = drilldown_level_values[2];
      } else if (dim === 'agent_time@weekday:weekday') {
        label = _datetime.WEEKDAYS[drilldown_level_values[0]];
      } else {
        label = _filter.Filter.isTimeDimension(dim) ? _filter.Filter.labelForTime(_filter.Filter.levelsToTime(drilldown_level_values), drilldown_level_values.length) : drilldown_level_labels.join(' / ');
      }
      if (_filter.Filter.isTimeDimension(dim) && drilldown_level_values.length > 1) {
        drilldown_level_values[1]++;
      }
      var value = drilldown_level_values.join(_config.PATH_STRING_SEPARATOR); // inverted comma
      return {
        dimension: dim,
        value: value,
        label: label
      };
    }
  }, {
    key: 'getCellLabel',
    value: function getCellLabel(drill, cell) {
      var filter = this.getCellFilter(drill, cell);
      if (!filter.label) {
        return gettext('Значение не указано');
      }
      if (filter.dimension === 'agent_agent@last_report:last_report') {
        return gettext(filter.label);
      }
      return filter.label;
    }
  }]);

  return Model;
}();

function buildModel(model) {
  Object.setPrototypeOf(model, Model.prototype);
  model.buildModel();
  return model;
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
__webpack_require__(750);

var AlertModalController = exports.AlertModalController = function AlertModalController($scope, $modalInstance, errorStatus, errorText, errorConfig, $http, PermissionService, RouterService) {
  $scope.errorStatus = errorStatus;

  $scope.errorText = errorConfig ? errorText + '\n\n  Location:\n  ' + RouterService.$location.url() + '\n\n  Ajax:\n  ' + (errorConfig ? JSON.stringify({
    method: errorConfig.method,
    url: errorConfig.url,
    params: errorConfig.params
  }, null, 4) : '') : errorText;

  $scope.cancel = function () {
    return $modalInstance.close();
  };
  $scope.is500 = function () {
    return $scope.errorStatus == 500;
  };
  $scope.isErrConfig = function () {
    return !!errorConfig;
  };
  $scope.titleText = $scope.is500() ? gettext('Ошибка сервера') + ' : 500' : $scope.errorStatus;
  $scope.textButton = $scope.is500() ? gettext('Закрыть') : gettext('Ок');

  $scope.sendErr = function () {
    var url = '//staffcop.ru/crashreport/';
    var message = {
      url: url,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: $.param({
        version: PermissionService.serverVersion,
        serial: PermissionService.serial,
        body: $scope.errorText
      })
    };

    $http(message).then(function (res) {
      if (errorConfig) {
        errorConfig.resultData = res.data;
        errorConfig.resultError = false;
      }
      console.log('Sent message:', message, 'Ticket number:', res.data);
      $modalInstance.close();
    }, function (err) {
      if (errorConfig) {
        errorConfig.resultData = false;
        errorConfig.resultError = err;
      }
      console.error('Cannot sent message:', err);
      $modalInstance.close();
    });
  };

  // $modalInstance.dismiss('cancel');
};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{ titleText }}</h4></div><div class=\"modal-body alert-body\" ng-bind-html=\"errorText\"></div><div class=\"modal-footer\"><button ng-if=\"isErrConfig()\" class=\"btn\" ng-click=\"sendErr()\">{{:: 'Cообщить о проблеме' | gettext}}</button> <button class=\"btn\" ng-click=\"cancel()\">{{ textButton }}</button></div>"

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scFilterModule = undefined;

var _core = __webpack_require__(60);

var _datePicker = __webpack_require__(766);

var _filterDimension = __webpack_require__(770);

var _filterDimensionNode = __webpack_require__(773);

var _filterEditorModal = __webpack_require__(776);

var _catalog = __webpack_require__(778);

var _catalogNode = __webpack_require__(781);

var _catalogSearch = __webpack_require__(784);

var _filterSearch = __webpack_require__(787);

var _filterDimensions = __webpack_require__(789);

var _filterDrilldownDraggable = __webpack_require__(792);

var _filterCardEditorModal = __webpack_require__(795);

var _filtersCutEditorModalService = __webpack_require__(799);

var _rulesEditorModalService = __webpack_require__(803);

var _dlpBuilder = __webpack_require__(807);

var _queryBuilder = __webpack_require__(810);

var _valueBuilder = __webpack_require__(813);

var _filterValueInput = __webpack_require__(816);

var _queryBuilderNode = __webpack_require__(819);

var _filterEditor = __webpack_require__(822);

var _filterCardEditorCell = __webpack_require__(823);

var _ocrFilterEditor = __webpack_require__(826);

var _catalogNodeDrag = __webpack_require__(829);

var _emailTemplete = __webpack_require__(830);

var _threshold = __webpack_require__(833);

var _userSearch = __webpack_require__(836);

var _incidentTab = __webpack_require__(839);

var _filtersTab = __webpack_require__(842);

var _notifyTab = __webpack_require__(844);

var scFilterModule = exports.scFilterModule = 'sc-filter';

angular.module(scFilterModule, [_core.scCoreModule]).service('CatalogNodeDragService', _catalogNodeDrag.CatalogNodeDragService).service('FilterEditorService', _filterEditor.FilterEditorService).service('FilterEditorModalService', _filterEditorModal.FilterEditorModalService).service('FilterCardEditorModalService', _filterCardEditorModal.FilterCardEditorModalService).service('FiltersCutEditorModalService', _filtersCutEditorModalService.FiltersCutEditorModalService).service('RulesEditorModalService', _rulesEditorModalService.RulesEditorModalService)
// .service('CataloSearchService', CataloSearchService)
.component('scOcrFilterEditor', _ocrFilterEditor.OcrFilterEditorComponent).component('scCatalogSearch', _catalogSearch.CatalogSearchComponent).component('scDatePicker', _datePicker.DatePickerComponent).component('scCatalog', _catalog.CatalogComponent).component('scCatalogNode', _catalogNode.CatalogNodeComponent).component('scFilterDimension', _filterDimension.FilterDimensionComponent).component('scFilterDimensionNode', _filterDimensionNode.FilterDimensionNodeComponent).directive('scFilterDimensions', _filterDimensions.FilterDimensionsComponent).directive('scFilterSearch', _filterSearch.FilterSearchComponent)
// .component('scFilterDrilldown', FilterDrilldownComponent)
.component('scFilterDrillDownDraggable', _filterDrilldownDraggable.FilterDrillDownDraggableComponent).component('scQueryBuilder', _queryBuilder.QueryBuilderComponent).component('scDlpBuilder', _dlpBuilder.DLPBuilderComponent).component('scQueryBuilderNode', _queryBuilderNode.QueryBuilderNodeComponent).component('scValueBuilder', _valueBuilder.ValueBuilderComponent).component('scFilterValueInput', _filterValueInput.FilterValueInputComponent).component('scFilterCardEditorCell', _filterCardEditorCell.FilterCardEditorCellComponent).component('scUserSearch', _userSearch.UserSearchComponent).directive('scEmailTemplete', _emailTemplete.EmailTempleteComponent).directive('scThreshold', _threshold.ThresholdComponent).directive('scIncidentTab', _incidentTab.IncidentTabComponent).directive('scFiltersTab', _filtersTab.FiltersTabComponent).directive('scNotifyTab', _notifyTab.NotifyTabComponent);

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scFactsModule = undefined;

var _account = __webpack_require__(847);

var _audioFile = __webpack_require__(850);

var _audio = __webpack_require__(853);

var _wavesurferComponent = __webpack_require__(854);

var _audioWaves = __webpack_require__(855);

var _audioWaves2 = __webpack_require__(858);

var _core = __webpack_require__(60);

__webpack_require__(859);

var _factThumb = __webpack_require__(861);

var _factsSlider = __webpack_require__(863);

var _facts = __webpack_require__(866);

var _factWidget = __webpack_require__(896);

var _factTableRow = __webpack_require__(898);

var _factBottom = __webpack_require__(902);

var _factInfo = __webpack_require__(904);

var _colresize = __webpack_require__(905);

var _heatmap = __webpack_require__(906);

var _factsMenu = __webpack_require__(910);

var _factsSliderTimeline = __webpack_require__(913);

var _factsSliderView = __webpack_require__(916);

var _factsTable = __webpack_require__(919);

var scFactsModule = exports.scFactsModule = 'sc-facts';

angular.module(scFactsModule, [_core.scCoreModule]).service('AudioService', _audio.AudioService).service('AudioWavesService', _audioWaves2.AudioWavesService).component('scAudioFile', _audioFile.AudioFileComponent).component('scAudioWaves', _audioWaves.AudioWavesComponent).component('scAccount', _account.AccountComponent).component('scFactThumb', _factThumb.FactThumbComponent).component('scFactSlider', _factsSlider.FactSliderComponent).directive('scWavesurfer', _wavesurferComponent.WavesurferComponent).directive('scFacts', _facts.FactsComponent).directive('scFactsTable', _factsTable.FactsTableComponent).directive('scFactWidget', _factWidget.FactsWidgetComponent).directive('scFactTableRow', _factTableRow.FactTableRowComponent).directive('scFactBottom', _factBottom.FactBottomComponent).directive('scFactInfo', _factInfo.FactInfoComponent).directive('colResize', _colresize.ColumnResizeComponent).directive('scHeatmap', _heatmap.HeatmapComponent).component('scFactsMenu', _factsMenu.FactsMenuComponent).directive('scFactsSliderTimeline', _factsSliderTimeline.FactsSliderTimelineComponent).component('scFactsSliderView', _factsSliderView.FactsSliderViewComponent).directive('errSrc', function () {
  return {
    link: function link(scope, element, attrs) {
      element.bind('error', function () {
        element.attr('src', attrs.errSrc);
      });
    }
  };
}).directive('thumbonload', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('load', function (fact) {
        var thumbId = attrs.id;
        $('#' + thumbId + '_preloader').hide();
      });
    }
  };
}).directive('thumblistonload', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('load', function (event) {
        var thumbId = attrs.id;
        $('#' + thumbId + '_preloader').hide();
        if ($('#facts-container').height() > $('.fact-thumbnail-list').height()) {
          var parent = scope.$parent;
          while (!parent.more) {
            parent = parent.$parent;
          }
          parent.more();
        }
      });
    }
  };
}).directive('thumbonerror', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('error', function () {
        var thumbId = attrs.id;
        $('#' + thumbId + '_preloader').hide();
      });
    }
  };
});

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decoderElement = exports.decoders = undefined;

var _iconvLite = __webpack_require__(868);

var _iconvLite2 = _interopRequireDefault(_iconvLite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decoders = exports.decoders = {
  'big5': decodeByTextDecoder('big5'),
  'gbk': decodeByTextDecoder('gbk'),
  'gb18030': decodeByTextDecoder('gb18030'),
  'iso-8859-1': decodeByTextDecoder('iso-8859-1'),
  'iso-8859-2': decodeByTextDecoder('iso-8859-2'),
  'iso-8859-3': decodeByTextDecoder('iso-8859-3'),
  'iso-8859-4': decodeByTextDecoder('iso-8859-4'),
  'iso-8859-5': decodeByTextDecoder('iso-8859-5'),
  'iso-8859-6': decodeByTextDecoder('iso-8859-6'),
  'iso-8859-7': decodeByTextDecoder('iso-8859-7'),
  'iso-8859-8': decodeByTextDecoder('iso-8859-8'),
  'iso-8859-10': decodeByTextDecoder('iso-8859-10'),
  'iso-8859-13': decodeByTextDecoder('iso-8859-13'),
  'iso-8859-14': decodeByTextDecoder('iso-8859-14'),
  'iso-8859-15': decodeByTextDecoder('iso-8859-15'),
  'iso-8859-16': decodeByTextDecoder('iso-8859-16'),
  'koi8-r': decodeByTextDecoder('koi8-r'),
  'koi8-u': decodeByTextDecoder('koi8-u'),
  'macintosh': decodeByTextDecoder('macintosh'),
  'ibm866': decodeByTextDecoder('ibm866'),
  // 'utf-8': text => {
  //   const utf = utf8;
  //   try {
  //     return utf8.decode(text);
  //   } catch (err) {
  //     console.error('utf-8', 'не действительный тип кодировки');
  //     return text;
  //   }
  // },
  'url': function url(text) {
    return decodeURIComponent(text);
  },
  'windows-874': decodeByTextDecoder('windows-874'),
  'windows-1250': decodeByTextDecoder('windows-1250'),
  'windows-1251': decodeByTextDecoder('windows-1251'),
  'windows-1252': decodeByTextDecoder('windows-1252'),
  'windows-1253': decodeByTextDecoder('windows-1253'),
  'windows-1254': decodeByTextDecoder('windows-1254'),
  'windows-1255': decodeByTextDecoder('windows-1255'),
  'windows-1256': decodeByTextDecoder('windows-1256'),
  'windows-1257': decodeByTextDecoder('windows-1257'),
  'windows-1258': decodeByTextDecoder('windows-1258'),
  'x-mac-cyrillic': decodeByTextDecoder('x-mac-cyrillic')

}; // import utf8 from 'utf8';


function decodeByTextDecoder(type) {
  var decoder = void 0;
  try {
    decoder = new TextDecoder(type);
  } catch (e) {
    console.error(type, 'не действительный тип кодировки');
    return function (text) {
      return text;
    };
  }

  return function (text) {

    var bufer = _iconvLite2.default.encode(text, type);
    try {
      // const decoded = iconv.decode(bufer, k);
      return _iconvLite2.default.decode(bufer, 'utf-8');
    } catch (err) {
      console.error(type, 'не вылшо');
      return text;
    }
  };
}

var liElement = function liElement(type) {
  return '<li >\n    <a ng-click="decodeText($event,\'' + type + '\')">' + type + '</a>\n  </li>';
};

var decoderElement = exports.decoderElement = function decoderElement() {
  var list = '';
  Object.keys(decoders).forEach(function (d) {
    list += liElement(d);
  });

  return '\n  <span class="dropdown decoder-element">\n    <i data-toggle="dropdown"\n      class="icon-cogs dropdown-toggle"\n      style="color: gray;"\n    ></i>\n    <ul class="dropdown-menu pull-right"  >' + list + '</ul>\n  </span>\n  ';
};

/***/ }),
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var drawFace = function drawFace(face, size, max_width, index, account) {
    var ratio = max_width / size["width"];
    var top = Math.round(face["top"] * ratio);
    var bottom = Math.round(face["bottom"] * ratio);
    var left = Math.round(face["left"] * ratio);
    var right = Math.round(face["right"] * ratio);
    var height = right - left;
    var width = bottom - top;
    var color = "red";
    if (account) {
        color = "green";
    } else {
        account = gettext("Неизвестный");
    }
    return "<div ng-click=\"openFace(fact, " + index + ")\" style='position: absolute; cursor: pointer; border: 2px solid " + color + "; top: " + top + "px; left: " + left + "px; height: " + height + "px; width: " + width + "px;'></div>" + ("<div style='position: absolute; background-color: " + color + "; color: white; font-size: 150%; top: " + (top + height) + "px; left: " + left + "px;'> " + account + " </div>");
};

var decorateFaces = exports.decorateFaces = function decorateFaces(val, fact) {
    var faces = fact["faces"];
    if (!faces) return val;

    var bounds = faces["bounds"];
    if (!bounds || !bounds.length) return val;

    var accounts = faces["accounts"];

    val = "<div style='position: relative' width='480px'>" + val;
    for (var index = 0; index < bounds.length; index++) {
        val = val + drawFace(bounds[index], faces["size"], 480, index, accounts[index]);
    }
    return val + "</div>";
};

var AssignDialogCtrl = exports.AssignDialogCtrl = function AssignDialogCtrl($scope, $rootScope, $modalInstance, $http, $cookies, fact, index) {

    $scope.user_name = fact["agent_account.user_name"];

    $scope.ok = function (state) {
        $scope.loading = true;
        var data = {
            'account_id': fact['agent_account.id'],
            'fact_id': fact['id'],
            'assigned': state,
            'index': index,
            'faces': fact['faces']
        };
        $http({
            url: '/face/assign/',
            method: "POST",
            data: data,
            headers: {
                "X-CSRFToken": $cookies.get('csrftoken')
            }
        }).then(function () {
            $scope.loading = false;
            $modalInstance.close('ok');
            $rootScope.$broadcast('reload');
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };
};

var FaceService = exports.FaceService = function () {
    function FaceService($modal) {
        _classCallCheck(this, FaceService);

        this.$modal = $modal;
    }

    _createClass(FaceService, [{
        key: "openFace",
        value: function openFace(_fact, _index) {
            this.$modal.open({
                template: __webpack_require__(892),
                controller: AssignDialogCtrl,
                scope: this.$scope,
                resolve: {
                    fact: function fact() {
                        return _fact;
                    },
                    index: function index() {
                        return _index;
                    }
                }
            }).result.catch(function (err) {
                console.error(err);
            });
        }
    }]);

    return FaceService;
}();

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scStatModule = undefined;

var _statTable = __webpack_require__(921);

var _summStat = __webpack_require__(924);

var _core = __webpack_require__(60);

var _pie = __webpack_require__(927);

var _tree = __webpack_require__(930);

var _tree2 = __webpack_require__(931);

var _chart = __webpack_require__(932);

var _radar = __webpack_require__(935);

var _eventRiver = __webpack_require__(937);

var _statMenu = __webpack_require__(939);

var _statHeader = __webpack_require__(942);

var scStatModule = exports.scStatModule = 'sc-stat';

angular.module(scStatModule, [_core.scCoreModule]).service('TreeService', _tree2.TreeService).component('scStatTable', _statTable.StatTableComponent).component('scSummStat', _summStat.SummStatComponent).component('scPie', _pie.PieComponent).component('scChart', _chart.ChartComponent).component('scRadar', _radar.RadarComponent).component('scEventRiver', _eventRiver.EventRiverComponent).component('scTree', _tree.TreeComponent).component('scStatMenu', _statMenu.StatMenuComponent).directive('scStatHeader', _statHeader.StatHeaderComponent);

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scSharedModule = undefined;

var _ref = __webpack_require__(945);

var _ul = __webpack_require__(949);

var _iframe = __webpack_require__(950);

var _xref = __webpack_require__(953);

var _spinner = __webpack_require__(954);

var _hspinner = __webpack_require__(957);

var _filterStampComponent = __webpack_require__(960);

var scSharedModule = exports.scSharedModule = 'sc-shared';

angular.module(scSharedModule, []).directive('scRef', _ref.RefDirective).directive('scXref', _xref.XRefDirective).directive('scUl', _ul.UlComponent).component('scIframe', _iframe.IFrameComponent).component('scSpinner', _spinner.SpinnerComponent).component('scHspinner', _hspinner.HSpinnerComponent).component('scFilterStamp', _filterStampComponent.SilterStampComponent);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TerminalCommandModal = exports.TerminalCommandModal = function TerminalCommandModal($scope, $modalInstance, $http, $timeout, $q, command, commandText) {
  _classCallCheck(this, TerminalCommandModal);

  $scope.restarting = false;
  $scope.restartFailed = false;
  $scope.command = command;
  $scope.commandText = commandText;

  var sendCommandSignal = function sendCommandSignal() {
    var deferred = $q.defer();
    $http({
      method: 'POST',
      url: '/analytics/do_terminal_command/',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: $.param({
        terminal_command: command
      })
    }).then(function (_ref) {
      var data = _ref.data;

      deferred.resolve('Command executed');
    }).catch(function (_ref2) {
      var data = _ref2.data,
          headers = _ref2.headers,
          config = _ref2.config;

      console.log(data);
      console.log(headers);
      console.log(config);
      deferred.reject('Command not executed');
      $scope.restarting = false;
      $scope.restartFailed = true;
    });
    return deferred.promise;
  };

  var checkServer = function checkServer(deferred) {
    $http.get('/analytics/do_terminal_command/').then(function () {
      deferred.resolve('Staffcop is up');
    }).catch(function () {
      deferred.notify('Staffcop is not up');
    });
  };

  $scope.fromData = function (data) {
    $scope.message = command;
  };

  $scope.init = function () {
    $scope.fromData({});
  };

  $scope.ok = function (action) {
    $scope.restarting = true;
    sendCommandSignal().then(function (result) {
      $timeout(function () {
        var deferred = $q.defer();
        checkServer(deferred);
        deferred.promise.then(function (result) {
          window.location = '/';
        }, function (result) {
          // console.log(result);
        }, function (result) {
          if (result === 'Staffcop is not up') $timeout(function () {
            checkServer(deferred);
          }, 1000);
        });
      }, 1000);
    }).catch(function (err) {
      console.error(err);
    });
  };

  $scope.close = function () {
    $modalInstance.close();
  };
};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//require('./debug-info-modal.component.scss');

var DebugInfoModal = exports.DebugInfoModal = function DebugInfoModal($scope, $modalInstance) {
  _classCallCheck(this, DebugInfoModal);

  $scope.ok = function () {
    $modalInstance.close();
  };

  $scope.cancel = function () {
    $modalInstance.close();
  };

  $scope.options = {
    log: true,
    agent_config: true,
    agent_acl: true,
    analytics_filters: true
  };

  $scope.isOptions = function () {
    return Object.keys($scope.options).some(function (k) {
      return $scope.options[k];
    });
  };

  $scope.getLink = function () {
    return '/analytics/debug?' + Object.keys($scope.options).filter(function (key) {
      return $scope.options[key];
    }).join('&');
  };
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(347);

__webpack_require__(715);

__webpack_require__(716);

__webpack_require__(717);

__webpack_require__(1049);

//import 'webpack/hot/dev-server';

__webpack_require__(1050);

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(348);

(function () {
  // проверяем поддержку
  if (!Element.prototype.matches) {
    // определяем свойство
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
  }
})(); // import 'core-js/fn/array/find';
// import 'core-js/fn/array/find-index';
// import 'core-js/fn/array/includes';
// import 'core-js/fn/array/from';
// import 'core-js/fn/object/assign';
// import 'core-js/fn/object/set-prototype-of';
// import 'core-js/fn/object/get-prototype-of';
// import 'core-js/fn/object/values';
// import 'core-js/fn/string/starts-with';
// import 'core-js/fn/string/includes';
// import 'core-js/fn/string/ends-with';
// import 'core-js/es6/symbol';
// import 'core-js/es6/promise';


(function () {
  // проверяем поддержку
  if (!Element.prototype.closest) {
    // реализуем
    Element.prototype.closest = function (css) {
      var node = this;

      while (node) {
        if (node.matches(css)) return node;else node = node.parentElement;
      }
      return null;
    };
  }
})();

(function () {
  // проверяем поддержку
  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function value(callback, type, quality) {
        var canvas = this;
        setTimeout(function () {
          var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
          var len = binStr.length;
          var arr = new Uint8Array(len);

          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }

          callback(new Blob([arr], { type: type || 'image/png' }));
        });
      }
    });
  }
})();

/***/ }),
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(199);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ = _jquery2.default;
window.jQuery = _jquery2.default;

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* ===================================================
 * bootstrap-transition.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#transitions
 * ===================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* CSS TRANSITION SUPPORT (http://www.modernizr.com/)
   * ======================================================= */

  $(function () {

    $.support.transition = function () {

      var transitionEnd = function () {

        var el = document.createElement('bootstrap'),
            transEndEventNames = {
          'WebkitTransition': 'webkitTransitionEnd',
          'MozTransition': 'transitionend',
          'OTransition': 'oTransitionEnd otransitionend',
          'transition': 'transitionend'
        },
            name;

        for (name in transEndEventNames) {
          if (el.style[name] !== undefined) {
            return transEndEventNames[name];
          }
        }
      }();

      return transitionEnd && {
        end: transitionEnd
      };
    }();
  });
}(window.jQuery);
/* ==========================================================
 * bootstrap-alert.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#alerts
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* ALERT CLASS DEFINITION
   * ====================== */

  var dismiss = '[data-dismiss="alert"]',
      Alert = function Alert(el) {
    $(el).on('click', dismiss, this.close);
  };

  Alert.prototype.close = function (e) {
    var $this = $(this),
        selector = $this.attr('data-target'),
        $parent;

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
    }

    $parent = $(selector);

    e && e.preventDefault();

    $parent.length || ($parent = $this.hasClass('alert') ? $this : $this.parent());

    $parent.trigger(e = $.Event('close'));

    if (e.isDefaultPrevented()) return;

    $parent.removeClass('in');

    function removeElement() {
      $parent.trigger('closed').remove();
    }

    $.support.transition && $parent.hasClass('fade') ? $parent.on($.support.transition.end, removeElement) : removeElement();
  };

  /* ALERT PLUGIN DEFINITION
   * ======================= */

  var old = $.fn.alert;

  $.fn.alert = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('alert');
      if (!data) $this.data('alert', data = new Alert(this));
      if (typeof option == 'string') data[option].call($this);
    });
  };

  $.fn.alert.Constructor = Alert;

  /* ALERT NO CONFLICT
   * ================= */

  $.fn.alert.noConflict = function () {
    $.fn.alert = old;
    return this;
  };

  /* ALERT DATA-API
   * ============== */

  $(document).on('click.alert.data-api', dismiss, Alert.prototype.close);
}(window.jQuery);
/* ============================================================
 * bootstrap-button.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#buttons
 * ============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */

!function ($) {

  "use strict"; // jshint ;_;


  /* BUTTON PUBLIC CLASS DEFINITION
   * ============================== */

  var Button = function Button(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, $.fn.button.defaults, options);
  };

  Button.prototype.setState = function (state) {
    var d = 'disabled',
        $el = this.$element,
        data = $el.data(),
        val = $el.is('input') ? 'val' : 'html';

    state = state + 'Text';
    data.resetText || $el.data('resetText', $el[val]());

    $el[val](data[state] || this.options[state]);

    // push to event loop to allow forms to submit
    setTimeout(function () {
      state == 'loadingText' ? $el.addClass(d).attr(d, d) : $el.removeClass(d).removeAttr(d);
    }, 0);
  };

  Button.prototype.toggle = function () {
    var $parent = this.$element.closest('[data-toggle="buttons-radio"]');

    $parent && $parent.find('.active').removeClass('active');

    this.$element.toggleClass('active');
  };

  /* BUTTON PLUGIN DEFINITION
   * ======================== */

  var old = $.fn.button;

  $.fn.button = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('button'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('button', data = new Button(this, options));
      if (option == 'toggle') data.toggle();else if (option) data.setState(option);
    });
  };

  $.fn.button.defaults = {
    loadingText: 'loading...'
  };

  $.fn.button.Constructor = Button;

  /* BUTTON NO CONFLICT
   * ================== */

  $.fn.button.noConflict = function () {
    $.fn.button = old;
    return this;
  };

  /* BUTTON DATA-API
   * =============== */

  $(document).on('click.button.data-api', '[data-toggle^=button]', function (e) {
    var $btn = $(e.target);
    if (!$btn.hasClass('btn')) $btn = $btn.closest('.btn');
    $btn.button('toggle');
  });
}(window.jQuery);
/* ==========================================================
 * bootstrap-carousel.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#carousel
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* CAROUSEL CLASS DEFINITION
   * ========================= */

  var Carousel = function Carousel(element, options) {
    this.$element = $(element);
    this.$indicators = this.$element.find('.carousel-indicators');
    this.options = options;
    this.options.pause == 'hover' && this.$element.on('mouseenter', $.proxy(this.pause, this)).on('mouseleave', $.proxy(this.cycle, this));
  };

  Carousel.prototype = {

    cycle: function cycle(e) {
      if (!e) this.paused = false;
      if (this.interval) clearInterval(this.interval);
      this.options.interval && !this.paused && (this.interval = setInterval($.proxy(this.next, this), this.options.interval));
      return this;
    },

    getActiveIndex: function getActiveIndex() {
      this.$active = this.$element.find('.item.active');
      this.$items = this.$active.parent().children();
      return this.$items.index(this.$active);
    },

    to: function to(pos) {
      var activeIndex = this.getActiveIndex(),
          that = this;

      if (pos > this.$items.length - 1 || pos < 0) return;

      if (this.sliding) {
        return this.$element.one('slid', function () {
          that.to(pos);
        });
      }

      if (activeIndex == pos) {
        return this.pause().cycle();
      }

      return this.slide(pos > activeIndex ? 'next' : 'prev', $(this.$items[pos]));
    },

    pause: function pause(e) {
      if (!e) this.paused = true;
      if (this.$element.find('.next, .prev').length && $.support.transition.end) {
        this.$element.trigger($.support.transition.end);
        this.cycle(true);
      }
      clearInterval(this.interval);
      this.interval = null;
      return this;
    },

    next: function next() {
      if (this.sliding) return;
      return this.slide('next');
    },

    prev: function prev() {
      if (this.sliding) return;
      return this.slide('prev');
    },

    slide: function slide(type, next) {
      var $active = this.$element.find('.item.active'),
          $next = next || $active[type](),
          isCycling = this.interval,
          direction = type == 'next' ? 'left' : 'right',
          fallback = type == 'next' ? 'first' : 'last',
          that = this,
          e;

      this.sliding = true;

      isCycling && this.pause();

      $next = $next.length ? $next : this.$element.find('.item')[fallback]();

      e = $.Event('slide', {
        relatedTarget: $next[0],
        direction: direction
      });

      if ($next.hasClass('active')) return;

      if (this.$indicators.length) {
        this.$indicators.find('.active').removeClass('active');
        this.$element.one('slid', function () {
          var $nextIndicator = $(that.$indicators.children()[that.getActiveIndex()]);
          $nextIndicator && $nextIndicator.addClass('active');
        });
      }

      if ($.support.transition && this.$element.hasClass('slide')) {
        this.$element.trigger(e);
        if (e.isDefaultPrevented()) return;
        $next.addClass(type);
        $next[0].offsetWidth; // force reflow
        $active.addClass(direction);
        $next.addClass(direction);
        this.$element.one($.support.transition.end, function () {
          $next.removeClass([type, direction].join(' ')).addClass('active');
          $active.removeClass(['active', direction].join(' '));
          that.sliding = false;
          setTimeout(function () {
            that.$element.trigger('slid');
          }, 0);
        });
      } else {
        this.$element.trigger(e);
        if (e.isDefaultPrevented()) return;
        $active.removeClass('active');
        $next.addClass('active');
        this.sliding = false;
        this.$element.trigger('slid');
      }

      isCycling && this.cycle();

      return this;
    }

    /* CAROUSEL PLUGIN DEFINITION
     * ========================== */

  };var old = $.fn.carousel;

  $.fn.carousel = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('carousel'),
          options = $.extend({}, $.fn.carousel.defaults, (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option),
          action = typeof option == 'string' ? option : options.slide;
      if (!data) $this.data('carousel', data = new Carousel(this, options));
      if (typeof option == 'number') data.to(option);else if (action) data[action]();else if (options.interval) data.pause().cycle();
    });
  };

  $.fn.carousel.defaults = {
    interval: 5000,
    pause: 'hover'
  };

  $.fn.carousel.Constructor = Carousel;

  /* CAROUSEL NO CONFLICT
   * ==================== */

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old;
    return this;
  };

  /* CAROUSEL DATA-API
   * ================= */

  $(document).on('click.carousel.data-api', '[data-slide], [data-slide-to]', function (e) {
    var $this = $(this),
        href,
        $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
    ,
        options = $.extend({}, $target.data(), $this.data()),
        slideIndex;

    $target.carousel(options);

    if (slideIndex = $this.attr('data-slide-to')) {
      $target.data('carousel').pause().to(slideIndex).cycle();
    }

    e.preventDefault();
  });
}(window.jQuery);
/* =============================================================
 * bootstrap-collapse.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#collapse
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */

!function ($) {

  "use strict"; // jshint ;_;


  /* COLLAPSE PUBLIC CLASS DEFINITION
   * ================================ */

  var Collapse = function Collapse(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, $.fn.collapse.defaults, options);

    if (this.options.parent) {
      this.$parent = $(this.options.parent);
    }

    this.options.toggle && this.toggle();
  };

  Collapse.prototype = {

    constructor: Collapse,

    dimension: function dimension() {
      var hasWidth = this.$element.hasClass('width');
      return hasWidth ? 'width' : 'height';
    },

    show: function show() {
      var dimension, scroll, actives, hasData;

      if (this.transitioning || this.$element.hasClass('in')) return;

      dimension = this.dimension();
      scroll = $.camelCase(['scroll', dimension].join('-'));
      actives = this.$parent && this.$parent.find('> .accordion-group > .in');

      if (actives && actives.length) {
        hasData = actives.data('collapse');
        if (hasData && hasData.transitioning) return;
        actives.collapse('hide');
        hasData || actives.data('collapse', null);
      }

      this.$element[dimension](0);
      this.transition('addClass', $.Event('show'), 'shown');
      $.support.transition && this.$element[dimension](this.$element[0][scroll]);
    },

    hide: function hide() {
      var dimension;
      if (this.transitioning || !this.$element.hasClass('in')) return;
      dimension = this.dimension();
      this.reset(this.$element[dimension]());
      this.transition('removeClass', $.Event('hide'), 'hidden');
      this.$element[dimension](0);
    },

    reset: function reset(size) {
      var dimension = this.dimension();

      this.$element.removeClass('collapse')[dimension](size || 'auto')[0].offsetWidth;

      this.$element[size !== null ? 'addClass' : 'removeClass']('collapse');

      return this;
    },

    transition: function transition(method, startEvent, completeEvent) {
      var that = this,
          complete = function complete() {
        if (startEvent.type == 'show') that.reset();
        that.transitioning = 0;
        that.$element.trigger(completeEvent);
      };

      this.$element.trigger(startEvent);

      if (startEvent.isDefaultPrevented()) return;

      this.transitioning = 1;

      this.$element[method]('in');

      $.support.transition && this.$element.hasClass('collapse') ? this.$element.one($.support.transition.end, complete) : complete();
    },

    toggle: function toggle() {
      this[this.$element.hasClass('in') ? 'hide' : 'show']();
    }

    /* COLLAPSE PLUGIN DEFINITION
     * ========================== */

  };var old = $.fn.collapse;

  $.fn.collapse = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('collapse'),
          options = $.extend({}, $.fn.collapse.defaults, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
      if (!data) $this.data('collapse', data = new Collapse(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.collapse.defaults = {
    toggle: true
  };

  $.fn.collapse.Constructor = Collapse;

  /* COLLAPSE NO CONFLICT
   * ==================== */

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old;
    return this;
  };

  /* COLLAPSE DATA-API
   * ================= */

  $(document).on('click.collapse.data-api', '[data-toggle=collapse]', function (e) {
    var $this = $(this),
        href,
        target = $this.attr('data-target') || e.preventDefault() || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
    ,
        option = $(target).data('collapse') ? 'toggle' : $this.data();
    $this[$(target).hasClass('in') ? 'addClass' : 'removeClass']('collapsed');
    $(target).collapse(option);
  });
}(window.jQuery);
/* ============================================================
 * bootstrap-dropdown.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#dropdowns
 * ============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */

!function ($) {

  "use strict"; // jshint ;_;


  /* DROPDOWN CLASS DEFINITION
   * ========================= */

  var toggle = '[data-toggle=dropdown]',
      Dropdown = function Dropdown(element) {
    var $el = $(element).on('click.dropdown.data-api', this.toggle);
    $('html').on('click.dropdown.data-api', function () {
      $el.parent().removeClass('open');
    });
  };

  Dropdown.prototype = {

    constructor: Dropdown,

    toggle: function toggle(e) {
      var $this = $(this),
          $parent,
          isActive;

      if ($this.is('.disabled, :disabled')) return;

      $parent = getParent($this);

      isActive = $parent.hasClass('open');

      clearMenus();

      if (!isActive) {
        $parent.toggleClass('open');
      }

      $this.focus();

      return false;
    },

    keydown: function keydown(e) {
      var $this, $items, $active, $parent, isActive, index;

      if (!/(38|40|27)/.test(e.keyCode)) return;

      $this = $(this);

      e.preventDefault();
      e.stopPropagation();

      if ($this.is('.disabled, :disabled')) return;

      $parent = getParent($this);

      isActive = $parent.hasClass('open');

      if (!isActive || isActive && e.keyCode == 27) {
        if (e.which == 27) $parent.find(toggle).focus();
        return $this.click();
      }

      $items = $('[role=menu] li:not(.divider):visible a', $parent);

      if (!$items.length) return;

      index = $items.index($items.filter(':focus'));

      if (e.keyCode == 38 && index > 0) index--; // up
      if (e.keyCode == 40 && index < $items.length - 1) index++; // down
      if (!~index) index = 0;

      $items.eq(index).focus();
    }

  };

  function clearMenus() {
    $(toggle).each(function () {
      getParent($(this)).removeClass('open');
    });
  }

  function getParent($this) {
    var selector = $this.attr('data-target'),
        $parent;

    if (!selector) {
      selector = $this.attr('href');
      selector = selector && /#/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
    }

    $parent = selector && $(selector);

    if (!$parent || !$parent.length) $parent = $this.parent();

    return $parent;
  }

  /* DROPDOWN PLUGIN DEFINITION
   * ========================== */

  var old = $.fn.dropdown;

  $.fn.dropdown = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('dropdown');
      if (!data) $this.data('dropdown', data = new Dropdown(this));
      if (typeof option == 'string') data[option].call($this);
    });
  };

  $.fn.dropdown.Constructor = Dropdown;

  /* DROPDOWN NO CONFLICT
   * ==================== */

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old;
    return this;
  };

  /* APPLY TO STANDARD DROPDOWN ELEMENTS
   * =================================== */

  $(document).on('click.dropdown.data-api', clearMenus).on('click.dropdown.data-api', '.dropdown form', function (e) {
    e.stopPropagation();
  }).on('click.dropdown-menu', function (e) {
    e.stopPropagation();
  }).on('click.dropdown.data-api', toggle, Dropdown.prototype.toggle).on('keydown.dropdown.data-api', toggle + ', [role=menu]', Dropdown.prototype.keydown);
}(window.jQuery);
/* =========================================================
 * bootstrap-modal.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#modals
 * =========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

!function ($) {

  "use strict"; // jshint ;_;


  /* MODAL CLASS DEFINITION
   * ====================== */

  var Modal = function Modal(element, options) {
    this.options = options;
    this.$element = $(element).delegate('[data-dismiss="modal"]', 'click.dismiss.modal', $.proxy(this.hide, this));
    this.options.remote && this.$element.find('.modal-body').load(this.options.remote);
  };

  Modal.prototype = {

    constructor: Modal,

    toggle: function toggle() {
      return this[!this.isShown ? 'show' : 'hide']();
    },

    show: function show() {
      var that = this,
          e = $.Event('show');

      this.$element.trigger(e);

      if (this.isShown || e.isDefaultPrevented()) return;

      this.isShown = true;

      this.escape();

      this.backdrop(function () {
        var transition = $.support.transition && that.$element.hasClass('fade');

        if (!that.$element.parent().length) {
          that.$element.appendTo(document.body); //don't move modals dom position
        }

        that.$element.show();

        if (transition) {
          that.$element[0].offsetWidth; // force reflow
        }

        that.$element.addClass('in').attr('aria-hidden', false);

        that.enforceFocus();

        transition ? that.$element.one($.support.transition.end, function () {
          that.$element.focus().trigger('shown');
        }) : that.$element.focus().trigger('shown');
      });
    },

    hide: function hide(e) {
      e && e.preventDefault();

      var that = this;

      e = $.Event('hide');

      this.$element.trigger(e);

      if (!this.isShown || e.isDefaultPrevented()) return;

      this.isShown = false;

      this.escape();

      $(document).off('focusin.modal');

      this.$element.removeClass('in').attr('aria-hidden', true);

      $.support.transition && this.$element.hasClass('fade') ? this.hideWithTransition() : this.hideModal();
    },

    enforceFocus: function enforceFocus() {
      var that = this;
      $(document).on('focusin.modal', function (e) {
        if (that.$element[0] !== e.target && !that.$element.has(e.target).length) {
          that.$element.focus();
        }
      });
    },

    escape: function escape() {
      var that = this;
      if (this.isShown && this.options.keyboard) {
        this.$element.on('keyup.dismiss.modal', function (e) {
          e.which == 27 && that.hide();
        });
      } else if (!this.isShown) {
        this.$element.off('keyup.dismiss.modal');
      }
    },

    hideWithTransition: function hideWithTransition() {
      var that = this,
          timeout = setTimeout(function () {
        that.$element.off($.support.transition.end);
        that.hideModal();
      }, 500);

      this.$element.one($.support.transition.end, function () {
        clearTimeout(timeout);
        that.hideModal();
      });
    },

    hideModal: function hideModal() {
      var that = this;
      this.$element.hide();
      this.backdrop(function () {
        that.removeBackdrop();
        that.$element.trigger('hidden');
      });
    },

    removeBackdrop: function removeBackdrop() {
      this.$backdrop && this.$backdrop.remove();
      this.$backdrop = null;
    },

    backdrop: function backdrop(callback) {
      var that = this,
          animate = this.$element.hasClass('fade') ? 'fade' : '';

      if (this.isShown && this.options.backdrop) {
        var doAnimate = $.support.transition && animate;

        this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />').appendTo(document.body);

        this.$backdrop.click(this.options.backdrop == 'static' ? $.proxy(this.$element[0].focus, this.$element[0]) : $.proxy(this.hide, this));

        if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

        this.$backdrop.addClass('in');

        if (!callback) return;

        doAnimate ? this.$backdrop.one($.support.transition.end, callback) : callback();
      } else if (!this.isShown && this.$backdrop) {
        this.$backdrop.removeClass('in');

        $.support.transition && this.$element.hasClass('fade') ? this.$backdrop.one($.support.transition.end, callback) : callback();
      } else if (callback) {
        callback();
      }
    }

    /* MODAL PLUGIN DEFINITION
     * ======================= */

  };var old = $.fn.modal;

  $.fn.modal = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('modal'),
          options = $.extend({}, $.fn.modal.defaults, $this.data(), (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option);
      if (!data) $this.data('modal', data = new Modal(this, options));
      if (typeof option == 'string') data[option]();else if (options.show) data.show();
    });
  };

  $.fn.modal.defaults = {
    backdrop: true,
    keyboard: true,
    show: true
  };

  $.fn.modal.Constructor = Modal;

  /* MODAL NO CONFLICT
   * ================= */

  $.fn.modal.noConflict = function () {
    $.fn.modal = old;
    return this;
  };

  /* MODAL DATA-API
   * ============== */

  $(document).on('click.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this),
        href = $this.attr('href'),
        $target = $($this.attr('data-target') || href && href.replace(/.*(?=#[^\s]+$)/, '')) //strip for ie7
    ,
        option = $target.data('modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

    e.preventDefault();

    $target.modal(option).one('hide', function () {
      $this.focus();
    });
  });
}(window.jQuery);
/* ===========================================================
 * bootstrap-tooltip.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#tooltips
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ===========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* TOOLTIP PUBLIC CLASS DEFINITION
   * =============================== */

  var Tooltip = function Tooltip(element, options) {
    this.init('tooltip', element, options);
  };

  Tooltip.prototype = {

    constructor: Tooltip,

    init: function init(type, element, options) {
      var eventIn, eventOut, triggers, trigger, i;

      this.type = type;
      this.$element = $(element);
      this.options = this.getOptions(options);
      this.enabled = true;

      triggers = this.options.trigger.split(' ');

      for (i = triggers.length; i--;) {
        trigger = triggers[i];
        if (trigger == 'click') {
          this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this));
        } else if (trigger != 'manual') {
          eventIn = trigger == 'hover' ? 'mouseenter' : 'focus';
          eventOut = trigger == 'hover' ? 'mouseleave' : 'blur';
          this.$element.on(eventIn + '.' + this.type, this.options.selector, $.proxy(this.enter, this));
          this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this));
        }
      }

      this.options.selector ? this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' }) : this.fixTitle();
    },

    getOptions: function getOptions(options) {
      options = $.extend({}, $.fn[this.type].defaults, this.$element.data(), options);

      if (options.delay && typeof options.delay == 'number') {
        options.delay = {
          show: options.delay,
          hide: options.delay
        };
      }

      return options;
    },

    enter: function enter(e) {
      var defaults = $.fn[this.type].defaults,
          options = {},
          self;

      this._options && $.each(this._options, function (key, value) {
        if (defaults[key] != value) options[key] = value;
      }, this);

      self = $(e.currentTarget)[this.type](options).data(this.type);

      if (!self.options.delay || !self.options.delay.show) return self.show();

      clearTimeout(this.timeout);
      self.hoverState = 'in';
      this.timeout = setTimeout(function () {
        if (self.hoverState == 'in') self.show();
      }, self.options.delay.show);
    },

    leave: function leave(e) {
      var self = $(e.currentTarget)[this.type](this._options).data(this.type);

      if (this.timeout) clearTimeout(this.timeout);
      if (!self.options.delay || !self.options.delay.hide) return self.hide();

      self.hoverState = 'out';
      this.timeout = setTimeout(function () {
        if (self.hoverState == 'out') self.hide();
      }, self.options.delay.hide);
    },

    show: function show() {
      var $tip,
          pos,
          actualWidth,
          actualHeight,
          placement,
          tp,
          e = $.Event('show');

      if (this.hasContent() && this.enabled) {
        this.$element.trigger(e);
        if (e.isDefaultPrevented()) return;
        $tip = this.tip();
        this.setContent();

        if (this.options.animation) {
          $tip.addClass('fade');
        }

        placement = typeof this.options.placement == 'function' ? this.options.placement.call(this, $tip[0], this.$element[0]) : this.options.placement;

        $tip.detach().css({ top: 0, left: 0, display: 'block' });

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);

        pos = this.getPosition();

        actualWidth = $tip[0].offsetWidth;
        actualHeight = $tip[0].offsetHeight;

        switch (placement) {
          case 'bottom':
            tp = { top: pos.top + pos.height, left: pos.left + pos.width / 2 - actualWidth / 2 };
            break;
          case 'top':
            tp = { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 };
            break;
          case 'left':
            tp = { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth };
            break;
          case 'right':
            tp = { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width };
            break;
        }

        this.applyPlacement(tp, placement);
        this.$element.trigger('shown');
      }
    },

    applyPlacement: function applyPlacement(offset, placement) {
      var $tip = this.tip(),
          width = $tip[0].offsetWidth,
          height = $tip[0].offsetHeight,
          actualWidth,
          actualHeight,
          delta,
          replace;

      $tip.offset(offset).addClass(placement).addClass('in');

      actualWidth = $tip[0].offsetWidth;
      actualHeight = $tip[0].offsetHeight;

      if (placement == 'top' && actualHeight != height) {
        offset.top = offset.top + height - actualHeight;
        replace = true;
      }

      if (placement == 'bottom' || placement == 'top') {
        delta = 0;

        if (offset.left < 0) {
          delta = offset.left * -2;
          offset.left = 0;
          $tip.offset(offset);
          actualWidth = $tip[0].offsetWidth;
          actualHeight = $tip[0].offsetHeight;
        }

        this.replaceArrow(delta - width + actualWidth, actualWidth, 'left');
      } else {
        this.replaceArrow(actualHeight - height, actualHeight, 'top');
      }

      if (replace) $tip.offset(offset);
    },

    replaceArrow: function replaceArrow(delta, dimension, position) {
      this.arrow().css(position, delta ? 50 * (1 - delta / dimension) + "%" : '');
    },

    setContent: function setContent() {
      var $tip = this.tip(),
          title = this.getTitle();

      $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title);
      $tip.removeClass('fade in top bottom left right');
    },

    hide: function hide() {
      var that = this,
          $tip = this.tip(),
          e = $.Event('hide');

      this.$element.trigger(e);
      if (e.isDefaultPrevented()) return;

      $tip.removeClass('in');

      function removeWithAnimation() {
        var timeout = setTimeout(function () {
          $tip.off($.support.transition.end).detach();
        }, 500);

        $tip.one($.support.transition.end, function () {
          clearTimeout(timeout);
          $tip.detach();
        });
      }

      $.support.transition && this.$tip.hasClass('fade') ? removeWithAnimation() : $tip.detach();

      this.$element.trigger('hidden');

      return this;
    },

    fixTitle: function fixTitle() {
      var $e = this.$element;
      if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '').attr('title', '');
      }
    },

    hasContent: function hasContent() {
      return this.getTitle();
    },

    getPosition: function getPosition() {
      var el = this.$element[0];
      return $.extend({}, typeof el.getBoundingClientRect == 'function' ? el.getBoundingClientRect() : {
        width: el.offsetWidth,
        height: el.offsetHeight
      }, this.$element.offset());
    },

    getTitle: function getTitle() {
      var title,
          $e = this.$element,
          o = this.options;

      title = $e.attr('data-original-title') || (typeof o.title == 'function' ? o.title.call($e[0]) : o.title);

      return title;
    },

    tip: function tip() {
      return this.$tip = this.$tip || $(this.options.template);
    },

    arrow: function arrow() {
      return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow");
    },

    validate: function validate() {
      if (!this.$element[0].parentNode) {
        this.hide();
        this.$element = null;
        this.options = null;
      }
    },

    enable: function enable() {
      this.enabled = true;
    },

    disable: function disable() {
      this.enabled = false;
    },

    toggleEnabled: function toggleEnabled() {
      this.enabled = !this.enabled;
    },

    toggle: function toggle(e) {
      var self = e ? $(e.currentTarget)[this.type](this._options).data(this.type) : this;
      self.tip().hasClass('in') ? self.hide() : self.show();
    },

    destroy: function destroy() {
      this.hide().$element.off('.' + this.type).removeData(this.type);
    }

    /* TOOLTIP PLUGIN DEFINITION
     * ========================= */

  };var old = $.fn.tooltip;

  $.fn.tooltip = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('tooltip'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('tooltip', data = new Tooltip(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.tooltip.Constructor = Tooltip;

  $.fn.tooltip.defaults = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false

    /* TOOLTIP NO CONFLICT
     * =================== */

  };$.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old;
    return this;
  };
}(window.jQuery);
/* ===========================================================
 * bootstrap-popover.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#popovers
 * ===========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* POPOVER PUBLIC CLASS DEFINITION
   * =============================== */

  var Popover = function Popover(element, options) {
    this.init('popover', element, options);
  };

  /* NOTE: POPOVER EXTENDS BOOTSTRAP-TOOLTIP.js
   ========================================== */

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype, {

    constructor: Popover,

    setContent: function setContent() {
      var $tip = this.tip(),
          title = this.getTitle(),
          content = this.getContent();

      $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);
      $tip.find('.popover-content')[this.options.html ? 'html' : 'text'](content);

      $tip.removeClass('fade top bottom left right in');
    },

    hasContent: function hasContent() {
      return this.getTitle() || this.getContent();
    },

    getContent: function getContent() {
      var content,
          $e = this.$element,
          o = this.options;

      content = (typeof o.content == 'function' ? o.content.call($e[0]) : o.content) || $e.attr('data-content');

      return content;
    },

    tip: function tip() {
      if (!this.$tip) {
        this.$tip = $(this.options.template);
      }
      return this.$tip;
    },

    destroy: function destroy() {
      this.hide().$element.off('.' + this.type).removeData(this.type);
    }

  });

  /* POPOVER PLUGIN DEFINITION
   * ======================= */

  var old = $.fn.popover;

  $.fn.popover = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('popover'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('popover', data = new Popover(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.popover.Constructor = Popover;

  $.fn.popover.defaults = $.extend({}, $.fn.tooltip.defaults, {
    placement: 'right',

    trigger: 'click',

    content: '',

    template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  });

  /* POPOVER NO CONFLICT
   * =================== */

  $.fn.popover.noConflict = function () {
    $.fn.popover = old;
    return this;
  };
}(window.jQuery);
/* =============================================================
 * bootstrap-scrollspy.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#scrollspy
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* SCROLLSPY CLASS DEFINITION
   * ========================== */

  function ScrollSpy(element, options) {
    var process = $.proxy(this.process, this),
        $element = $(element).is('body') ? $(window) : $(element),
        href;
    this.options = $.extend({}, $.fn.scrollspy.defaults, options);
    this.$scrollElement = $element.on('scroll.scroll-spy.data-api', process);
    this.selector = (this.options.target || (href = $(element).attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') //strip for ie7
    || '') + ' .nav li > a';
    this.$body = $('body');
    this.refresh();
    this.process();
  }

  ScrollSpy.prototype = {

    constructor: ScrollSpy,

    refresh: function refresh() {
      var self = this,
          $targets;

      this.offsets = $([]);
      this.targets = $([]);

      $targets = this.$body.find(this.selector).map(function () {
        var $el = $(this),
            href = $el.data('target') || $el.attr('href'),
            $href = /^#\w/.test(href) && $(href);
        return $href && $href.length && [[$href.position().top + (!$.isWindow(self.$scrollElement.get(0)) && self.$scrollElement.scrollTop()), href]] || null;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).each(function () {
        self.offsets.push(this[0]);
        self.targets.push(this[1]);
      });
    },

    process: function process() {
      var scrollTop = this.$scrollElement.scrollTop() + this.options.offset,
          scrollHeight = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight,
          maxScroll = scrollHeight - this.$scrollElement.height(),
          offsets = this.offsets,
          targets = this.targets,
          activeTarget = this.activeTarget,
          i;

      if (scrollTop >= maxScroll) {
        return activeTarget != (i = targets.last()[0]) && this.activate(i);
      }

      for (i = offsets.length; i--;) {
        activeTarget != targets[i] && scrollTop >= offsets[i] && (!offsets[i + 1] || scrollTop <= offsets[i + 1]) && this.activate(targets[i]);
      }
    },

    activate: function activate(target) {
      var active, selector;

      this.activeTarget = target;

      $(this.selector).parent('.active').removeClass('active');

      selector = this.selector + '[data-target="' + target + '"],' + this.selector + '[href="' + target + '"]';

      active = $(selector).parent('li').addClass('active');

      if (active.parent('.dropdown-menu').length) {
        active = active.closest('li.dropdown').addClass('active');
      }

      active.trigger('activate');
    }

    /* SCROLLSPY PLUGIN DEFINITION
     * =========================== */

  };var old = $.fn.scrollspy;

  $.fn.scrollspy = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('scrollspy'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('scrollspy', data = new ScrollSpy(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.scrollspy.Constructor = ScrollSpy;

  $.fn.scrollspy.defaults = {
    offset: 10

    /* SCROLLSPY NO CONFLICT
     * ===================== */

  };$.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old;
    return this;
  };

  /* SCROLLSPY DATA-API
   * ================== */

  $(window).on('load', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this);
      $spy.scrollspy($spy.data());
    });
  });
}(window.jQuery);
/* ========================================================
 * bootstrap-tab.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#tabs
 * ========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ======================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* TAB CLASS DEFINITION
   * ==================== */

  var Tab = function Tab(element) {
    this.element = $(element);
  };

  Tab.prototype = {

    constructor: Tab,

    show: function show() {
      var $this = this.element,
          $ul = $this.closest('ul:not(.dropdown-menu)'),
          selector = $this.attr('data-target'),
          previous,
          $target,
          e;

      if (!selector) {
        selector = $this.attr('href');
        selector = selector && selector.replace(/.*(?=#[^\s]*$)/, ''); //strip for ie7
      }

      if ($this.parent('li').hasClass('active')) return;

      previous = $ul.find('.active:last a')[0];

      e = $.Event('show', {
        relatedTarget: previous
      });

      $this.trigger(e);

      if (e.isDefaultPrevented()) return;

      $target = $(selector);

      this.activate($this.parent('li'), $ul);
      this.activate($target, $target.parent(), function () {
        $this.trigger({
          type: 'shown',
          relatedTarget: previous
        });
      });
    },

    activate: function activate(element, container, callback) {
      var $active = container.find('> .active'),
          transition = callback && $.support.transition && $active.hasClass('fade');

      function next() {
        $active.removeClass('active').find('> .dropdown-menu > .active').removeClass('active');

        element.addClass('active');

        if (transition) {
          element[0].offsetWidth; // reflow for transition
          element.addClass('in');
        } else {
          element.removeClass('fade');
        }

        if (element.parent('.dropdown-menu')) {
          element.closest('li.dropdown').addClass('active');
        }

        callback && callback();
      }

      transition ? $active.one($.support.transition.end, next) : next();

      $active.removeClass('in');
    }

    /* TAB PLUGIN DEFINITION
     * ===================== */

  };var old = $.fn.tab;

  $.fn.tab = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('tab');
      if (!data) $this.data('tab', data = new Tab(this));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.tab.Constructor = Tab;

  /* TAB NO CONFLICT
   * =============== */

  $.fn.tab.noConflict = function () {
    $.fn.tab = old;
    return this;
  };

  /* TAB DATA-API
   * ============ */

  $(document).on('click.tab.data-api', '[data-toggle="tab"], [data-toggle="pill"]', function (e) {
    e.preventDefault();
    $(this).tab('show');
  });
}(window.jQuery);
/* =============================================================
 * bootstrap-typeahead.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#typeahead
 * =============================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ============================================================ */

!function ($) {

  "use strict"; // jshint ;_;


  /* TYPEAHEAD PUBLIC CLASS DEFINITION
   * ================================= */

  var Typeahead = function Typeahead(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, $.fn.typeahead.defaults, options);
    this.matcher = this.options.matcher || this.matcher;
    this.sorter = this.options.sorter || this.sorter;
    this.highlighter = this.options.highlighter || this.highlighter;
    this.updater = this.options.updater || this.updater;
    this.source = this.options.source;
    this.$menu = $(this.options.menu);
    this.shown = false;
    this.listen();
  };

  Typeahead.prototype = {

    constructor: Typeahead,

    select: function select() {
      var val = this.$menu.find('.active').attr('data-value');
      this.$element.val(this.updater(val)).change();
      return this.hide();
    },

    updater: function updater(item) {
      return item;
    },

    show: function show() {
      var pos = $.extend({}, this.$element.position(), {
        height: this.$element[0].offsetHeight
      });

      this.$menu.insertAfter(this.$element).css({
        top: pos.top + pos.height,
        left: pos.left
      }).show();

      this.shown = true;
      return this;
    },

    hide: function hide() {
      this.$menu.hide();
      this.shown = false;
      return this;
    },

    lookup: function lookup(event) {
      var items;

      this.query = this.$element.val();

      if (!this.query || this.query.length < this.options.minLength) {
        return this.shown ? this.hide() : this;
      }

      items = $.isFunction(this.source) ? this.source(this.query, $.proxy(this.process, this)) : this.source;

      return items ? this.process(items) : this;
    },

    process: function process(items) {
      var that = this;

      items = $.grep(items, function (item) {
        return that.matcher(item);
      });

      items = this.sorter(items);

      if (!items.length) {
        return this.shown ? this.hide() : this;
      }

      return this.render(items.slice(0, this.options.items)).show();
    },

    matcher: function matcher(item) {
      return ~item.toLowerCase().indexOf(this.query.toLowerCase());
    },

    sorter: function sorter(items) {
      var beginswith = [],
          caseSensitive = [],
          caseInsensitive = [],
          item;

      while (item = items.shift()) {
        if (!item.toLowerCase().indexOf(this.query.toLowerCase())) beginswith.push(item);else if (~item.indexOf(this.query)) caseSensitive.push(item);else caseInsensitive.push(item);
      }

      return beginswith.concat(caseSensitive, caseInsensitive);
    },

    highlighter: function highlighter(item) {
      var query = this.query.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
      return item.replace(new RegExp('(' + query + ')', 'ig'), function ($1, match) {
        return '<strong>' + match + '</strong>';
      });
    },

    render: function render(items) {
      var that = this;

      items = $(items).map(function (i, item) {
        i = $(that.options.item).attr('data-value', item);
        i.find('a').html(that.highlighter(item));
        return i[0];
      });

      items.first().addClass('active');
      this.$menu.html(items);
      return this;
    },

    next: function next(event) {
      var active = this.$menu.find('.active').removeClass('active'),
          next = active.next();

      if (!next.length) {
        next = $(this.$menu.find('li')[0]);
      }

      next.addClass('active');
    },

    prev: function prev(event) {
      var active = this.$menu.find('.active').removeClass('active'),
          prev = active.prev();

      if (!prev.length) {
        prev = this.$menu.find('li').last();
      }

      prev.addClass('active');
    },

    listen: function listen() {
      this.$element.on('focus', $.proxy(this.focus, this)).on('blur', $.proxy(this.blur, this)).on('keypress', $.proxy(this.keypress, this)).on('keyup', $.proxy(this.keyup, this));

      if (this.eventSupported('keydown')) {
        this.$element.on('keydown', $.proxy(this.keydown, this));
      }

      this.$menu.on('click', $.proxy(this.click, this)).on('mouseenter', 'li', $.proxy(this.mouseenter, this)).on('mouseleave', 'li', $.proxy(this.mouseleave, this));
    },

    eventSupported: function eventSupported(eventName) {
      var isSupported = eventName in this.$element;
      if (!isSupported) {
        this.$element.setAttribute(eventName, 'return;');
        isSupported = typeof this.$element[eventName] === 'function';
      }
      return isSupported;
    },

    move: function move(e) {
      if (!this.shown) return;

      switch (e.keyCode) {
        case 9: // tab
        case 13: // enter
        case 27:
          // escape
          e.preventDefault();
          break;

        case 38:
          // up arrow
          e.preventDefault();
          this.prev();
          break;

        case 40:
          // down arrow
          e.preventDefault();
          this.next();
          break;
      }

      e.stopPropagation();
    },

    keydown: function keydown(e) {
      this.suppressKeyPressRepeat = ~$.inArray(e.keyCode, [40, 38, 9, 13, 27]);
      this.move(e);
    },

    keypress: function keypress(e) {
      if (this.suppressKeyPressRepeat) return;
      this.move(e);
    },

    keyup: function keyup(e) {
      switch (e.keyCode) {
        case 40: // down arrow
        case 38: // up arrow
        case 16: // shift
        case 17: // ctrl
        case 18:
          // alt
          break;

        case 9: // tab
        case 13:
          // enter
          if (!this.shown) return;
          this.select();
          break;

        case 27:
          // escape
          if (!this.shown) return;
          this.hide();
          break;

        default:
          this.lookup();
      }

      e.stopPropagation();
      e.preventDefault();
    },

    focus: function focus(e) {
      this.focused = true;
    },

    blur: function blur(e) {
      this.focused = false;
      if (!this.mousedover && this.shown) this.hide();
    },

    click: function click(e) {
      e.stopPropagation();
      e.preventDefault();
      this.select();
      this.$element.focus();
    },

    mouseenter: function mouseenter(e) {
      this.mousedover = true;
      this.$menu.find('.active').removeClass('active');
      $(e.currentTarget).addClass('active');
    },

    mouseleave: function mouseleave(e) {
      this.mousedover = false;
      if (!this.focused && this.shown) this.hide();
    }

    /* TYPEAHEAD PLUGIN DEFINITION
     * =========================== */

  };var old = $.fn.typeahead;

  $.fn.typeahead = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('typeahead'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('typeahead', data = new Typeahead(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.typeahead.defaults = {
    source: [],
    items: 8,
    menu: '<ul class="typeahead dropdown-menu"></ul>',
    item: '<li><a href="#"></a></li>',
    minLength: 1
  };

  $.fn.typeahead.Constructor = Typeahead;

  /* TYPEAHEAD NO CONFLICT
   * =================== */

  $.fn.typeahead.noConflict = function () {
    $.fn.typeahead = old;
    return this;
  };

  /* TYPEAHEAD DATA-API
   * ================== */

  $(document).on('focus.typeahead.data-api', '[data-provide="typeahead"]', function (e) {
    var $this = $(this);
    if ($this.data('typeahead')) return;
    $this.typeahead($this.data());
  });
}(window.jQuery);
/* ==========================================================
 * bootstrap-affix.js v2.3.1
 * http://twitter.github.com/bootstrap/javascript.html#affix
 * ==========================================================
 * Copyright 2012 Twitter, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================== */

!function ($) {

  "use strict"; // jshint ;_;


  /* AFFIX CLASS DEFINITION
   * ====================== */

  var Affix = function Affix(element, options) {
    this.options = $.extend({}, $.fn.affix.defaults, options);
    this.$window = $(window).on('scroll.affix.data-api', $.proxy(this.checkPosition, this)).on('click.affix.data-api', $.proxy(function () {
      setTimeout($.proxy(this.checkPosition, this), 1);
    }, this));
    this.$element = $(element);
    this.checkPosition();
  };

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return;

    var scrollHeight = $(document).height(),
        scrollTop = this.$window.scrollTop(),
        position = this.$element.offset(),
        offset = this.options.offset,
        offsetBottom = offset.bottom,
        offsetTop = offset.top,
        reset = 'affix affix-top affix-bottom',
        affix;

    if ((typeof offset === 'undefined' ? 'undefined' : _typeof(offset)) != 'object') offsetBottom = offsetTop = offset;
    if (typeof offsetTop == 'function') offsetTop = offset.top();
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom();

    affix = this.unpin != null && scrollTop + this.unpin <= position.top ? false : offsetBottom != null && position.top + this.$element.height() >= scrollHeight - offsetBottom ? 'bottom' : offsetTop != null && scrollTop <= offsetTop ? 'top' : false;

    if (this.affixed === affix) return;

    this.affixed = affix;
    this.unpin = affix == 'bottom' ? position.top - scrollTop : null;

    this.$element.removeClass(reset).addClass('affix' + (affix ? '-' + affix : ''));
  };

  /* AFFIX PLUGIN DEFINITION
   * ======================= */

  var old = $.fn.affix;

  $.fn.affix = function (option) {
    return this.each(function () {
      var $this = $(this),
          data = $this.data('affix'),
          options = (typeof option === 'undefined' ? 'undefined' : _typeof(option)) == 'object' && option;
      if (!data) $this.data('affix', data = new Affix(this, options));
      if (typeof option == 'string') data[option]();
    });
  };

  $.fn.affix.Constructor = Affix;

  $.fn.affix.defaults = {
    offset: 0

    /* AFFIX NO CONFLICT
     * ================= */

  };$.fn.affix.noConflict = function () {
    $.fn.affix = old;
    return this;
  };

  /* AFFIX DATA-API
   * ============== */

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this),
          data = $spy.data();

      data.offset = data.offset || {};

      data.offsetBottom && (data.offset.bottom = data.offsetBottom);
      data.offsetTop && (data.offset.top = data.offsetTop);

      $spy.affix(data);
    });
  });
}(window.jQuery);

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(200);

var _angular2 = _interopRequireDefault(_angular);

var _angularRoute = __webpack_require__(719);

var _angularRoute2 = _interopRequireDefault(_angularRoute);

__webpack_require__(721);

var _angularCookies = __webpack_require__(722);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularSanitize = __webpack_require__(724);

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _rxAngular = __webpack_require__(726);

var _rxAngular2 = _interopRequireDefault(_rxAngular);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(730);

__webpack_require__(731);

__webpack_require__(732);

var _layout = __webpack_require__(733);

var _filter = __webpack_require__(28);

__webpack_require__(1046);

var _angularMd = __webpack_require__(1048);

var _angularMd2 = _interopRequireDefault(_angularMd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global gettext */

_angular2.default.module('staffcop', [_layout.scLayoutModule, 'dndLists', _angularRoute2.default, _angularCookies2.default, _angularSanitize2.default, 'rx', 'ui.bootstrap', 'infinite-scrollfork', 'bgDirectives', 'ui.select', _angularMd2.default]).config(['$routeProvider', function ($routeProvider) {
  $routeProvider.when('/', {
    template: ' ',
    controller: 'RootCtrl',
    reloadOnSearch: false
  });
}]).config(function () {
  // Init moment.js locale
  var locale = window.navigator.userLanguage || window.navigator.language;
  _moment2.default.locale(locale);
}).config(function ($compileProvider) {
  // configure compiler
  // $compileProvider.preAssignBindingsEnabled(true);
  $compileProvider.commentDirectivesEnabled(false);
  // $compileProvider.cssClassDirectivesEnabled(false);
  $compileProvider.debugInfoEnabled(true);
}).config(function ($qProvider) {
  // unhandled rejection
  // $qProvider.errorOnUnhandledRejections(false);
}).run(function (rx, $q) {
  rx.config.Promise = $q;
}).run(function ($rootScope) {
  // localization helpers
  $rootScope.interpolate = interpolate;
  $rootScope.gettext = gettext;
}).filter('trusted', ['$sce', function ($sce) {
  return function (url) {
    return $sce.trustAsResourceUrl(url);
  };
}]).run(function ($filter) {
  _filter.Filter.formatDate = function (date, format) {
    return $filter('date')(date, format);
  };
});

/***/ }),
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 201,
	"./af.js": 201,
	"./ar": 202,
	"./ar-dz": 203,
	"./ar-dz.js": 203,
	"./ar-kw": 204,
	"./ar-kw.js": 204,
	"./ar-ly": 205,
	"./ar-ly.js": 205,
	"./ar-ma": 206,
	"./ar-ma.js": 206,
	"./ar-sa": 207,
	"./ar-sa.js": 207,
	"./ar-tn": 208,
	"./ar-tn.js": 208,
	"./ar.js": 202,
	"./az": 209,
	"./az.js": 209,
	"./be": 210,
	"./be.js": 210,
	"./bg": 211,
	"./bg.js": 211,
	"./bm": 212,
	"./bm.js": 212,
	"./bn": 213,
	"./bn.js": 213,
	"./bo": 214,
	"./bo.js": 214,
	"./br": 215,
	"./br.js": 215,
	"./bs": 216,
	"./bs.js": 216,
	"./ca": 217,
	"./ca.js": 217,
	"./cs": 218,
	"./cs.js": 218,
	"./cv": 219,
	"./cv.js": 219,
	"./cy": 220,
	"./cy.js": 220,
	"./da": 221,
	"./da.js": 221,
	"./de": 222,
	"./de-at": 223,
	"./de-at.js": 223,
	"./de-ch": 224,
	"./de-ch.js": 224,
	"./de.js": 222,
	"./dv": 225,
	"./dv.js": 225,
	"./el": 226,
	"./el.js": 226,
	"./en-SG": 227,
	"./en-SG.js": 227,
	"./en-au": 228,
	"./en-au.js": 228,
	"./en-ca": 229,
	"./en-ca.js": 229,
	"./en-gb": 230,
	"./en-gb.js": 230,
	"./en-ie": 231,
	"./en-ie.js": 231,
	"./en-il": 232,
	"./en-il.js": 232,
	"./en-nz": 233,
	"./en-nz.js": 233,
	"./eo": 234,
	"./eo.js": 234,
	"./es": 235,
	"./es-do": 236,
	"./es-do.js": 236,
	"./es-us": 237,
	"./es-us.js": 237,
	"./es.js": 235,
	"./et": 238,
	"./et.js": 238,
	"./eu": 239,
	"./eu.js": 239,
	"./fa": 240,
	"./fa.js": 240,
	"./fi": 241,
	"./fi.js": 241,
	"./fo": 242,
	"./fo.js": 242,
	"./fr": 243,
	"./fr-ca": 244,
	"./fr-ca.js": 244,
	"./fr-ch": 245,
	"./fr-ch.js": 245,
	"./fr.js": 243,
	"./fy": 246,
	"./fy.js": 246,
	"./ga": 247,
	"./ga.js": 247,
	"./gd": 248,
	"./gd.js": 248,
	"./gl": 249,
	"./gl.js": 249,
	"./gom-latn": 250,
	"./gom-latn.js": 250,
	"./gu": 251,
	"./gu.js": 251,
	"./he": 252,
	"./he.js": 252,
	"./hi": 253,
	"./hi.js": 253,
	"./hr": 254,
	"./hr.js": 254,
	"./hu": 255,
	"./hu.js": 255,
	"./hy-am": 256,
	"./hy-am.js": 256,
	"./id": 257,
	"./id.js": 257,
	"./is": 258,
	"./is.js": 258,
	"./it": 259,
	"./it-ch": 260,
	"./it-ch.js": 260,
	"./it.js": 259,
	"./ja": 261,
	"./ja.js": 261,
	"./jv": 262,
	"./jv.js": 262,
	"./ka": 263,
	"./ka.js": 263,
	"./kk": 264,
	"./kk.js": 264,
	"./km": 265,
	"./km.js": 265,
	"./kn": 266,
	"./kn.js": 266,
	"./ko": 267,
	"./ko.js": 267,
	"./ku": 268,
	"./ku.js": 268,
	"./ky": 269,
	"./ky.js": 269,
	"./lb": 270,
	"./lb.js": 270,
	"./lo": 271,
	"./lo.js": 271,
	"./lt": 272,
	"./lt.js": 272,
	"./lv": 273,
	"./lv.js": 273,
	"./me": 274,
	"./me.js": 274,
	"./mi": 275,
	"./mi.js": 275,
	"./mk": 276,
	"./mk.js": 276,
	"./ml": 277,
	"./ml.js": 277,
	"./mn": 278,
	"./mn.js": 278,
	"./mr": 279,
	"./mr.js": 279,
	"./ms": 280,
	"./ms-my": 281,
	"./ms-my.js": 281,
	"./ms.js": 280,
	"./mt": 282,
	"./mt.js": 282,
	"./my": 283,
	"./my.js": 283,
	"./nb": 284,
	"./nb.js": 284,
	"./ne": 285,
	"./ne.js": 285,
	"./nl": 286,
	"./nl-be": 287,
	"./nl-be.js": 287,
	"./nl.js": 286,
	"./nn": 288,
	"./nn.js": 288,
	"./pa-in": 289,
	"./pa-in.js": 289,
	"./pl": 290,
	"./pl.js": 290,
	"./pt": 291,
	"./pt-br": 292,
	"./pt-br.js": 292,
	"./pt.js": 291,
	"./ro": 293,
	"./ro.js": 293,
	"./ru": 294,
	"./ru.js": 294,
	"./sd": 295,
	"./sd.js": 295,
	"./se": 296,
	"./se.js": 296,
	"./si": 297,
	"./si.js": 297,
	"./sk": 298,
	"./sk.js": 298,
	"./sl": 299,
	"./sl.js": 299,
	"./sq": 300,
	"./sq.js": 300,
	"./sr": 301,
	"./sr-cyrl": 302,
	"./sr-cyrl.js": 302,
	"./sr.js": 301,
	"./ss": 303,
	"./ss.js": 303,
	"./sv": 304,
	"./sv.js": 304,
	"./sw": 305,
	"./sw.js": 305,
	"./ta": 306,
	"./ta.js": 306,
	"./te": 307,
	"./te.js": 307,
	"./tet": 308,
	"./tet.js": 308,
	"./tg": 309,
	"./tg.js": 309,
	"./th": 310,
	"./th.js": 310,
	"./tl-ph": 311,
	"./tl-ph.js": 311,
	"./tlh": 312,
	"./tlh.js": 312,
	"./tr": 313,
	"./tr.js": 313,
	"./tzl": 314,
	"./tzl.js": 314,
	"./tzm": 315,
	"./tzm-latn": 316,
	"./tzm-latn.js": 316,
	"./tzm.js": 315,
	"./ug-cn": 317,
	"./ug-cn.js": 317,
	"./uk": 318,
	"./uk.js": 318,
	"./ur": 319,
	"./ur.js": 319,
	"./uz": 320,
	"./uz-latn": 321,
	"./uz-latn.js": 321,
	"./uz.js": 320,
	"./vi": 322,
	"./vi.js": 322,
	"./x-pseudo": 323,
	"./x-pseudo.js": 323,
	"./yo": 324,
	"./yo.js": 324,
	"./zh-cn": 325,
	"./zh-cn.js": 325,
	"./zh-hk": 326,
	"./zh-hk.js": 326,
	"./zh-tw": 327,
	"./zh-tw.js": 327
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 729;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.transition", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.bindHtml", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.dropdownToggle", "ui.bootstrap.modal", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]), angular.module("ui.bootstrap.tpls", ["template/accordion/accordion-group.html", "template/accordion/accordion.html", "template/alert/alert.html", "template/carousel/carousel.html", "template/carousel/slide.html", "template/datepicker/datepicker.html", "template/datepicker/popup.html", "template/modal/backdrop.html", "template/modal/window.html", "template/pagination/pager.html", "template/pagination/pagination.html", "template/tooltip/tooltip-html-unsafe-popup.html", "template/tooltip/tooltip-popup.html", "template/popover/popover.html", "template/progressbar/bar.html", "template/progressbar/progress.html", "template/rating/rating.html", "template/tabs/tab.html", "template/tabs/tabset-titles.html", "template/tabs/tabset.html", "template/timepicker/timepicker.html", "template/typeahead/typeahead-match.html", "template/typeahead/typeahead-popup.html"]), angular.module("ui.bootstrap.transition", []).factory("$transition", ["$q", "$timeout", "$rootScope", function (e, t, n) {
  function a(e) {
    for (var t in e) {
      if (void 0 !== r.style[t]) return e[t];
    }
  }var i = function i(a, r, o) {
    o = o || {};var l = e.defer(),
        s = i[o.animation ? "animationEndEventName" : "transitionEndEventName"],
        c = function c() {
      n.$apply(function () {
        a.unbind(s, c), l.resolve(a);
      });
    };return s && a.bind(s, c), t(function () {
      angular.isString(r) ? a.addClass(r) : angular.isFunction(r) ? r(a) : angular.isObject(r) && a.css(r), s || l.resolve(a);
    }), l.promise.cancel = function () {
      s && a.unbind(s, c), l.reject("Transition cancelled");
    }, l.promise;
  },
      r = document.createElement("trans"),
      o = { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" },
      l = { WebkitTransition: "webkitAnimationEnd", MozTransition: "animationend", OTransition: "oAnimationEnd", transition: "animationend" };return i.transitionEndEventName = a(o), i.animationEndEventName = a(l), i;
}]), angular.module("ui.bootstrap.collapse", ["ui.bootstrap.transition"]).directive("collapse", ["$transition", function (e) {
  var t = function t(e, _t, n) {
    _t.removeClass("collapse"), _t.css({ height: n }), _t[0].offsetWidth, _t.addClass("collapse");
  };return { link: function link(n, a, i) {
      var r,
          o = !0;n.$watch(function () {
        return a[0].scrollHeight;
      }, function () {
        0 !== a[0].scrollHeight && (r || (o ? t(n, a, a[0].scrollHeight + "px") : t(n, a, "auto")));
      }), n.$watch(i.collapse, function (e) {
        e ? u() : c();
      });var l,
          s = function s(t) {
        return l && l.cancel(), l = e(a, t), l.then(function () {
          l = void 0;
        }, function () {
          l = void 0;
        }), l;
      },
          c = function c() {
        o ? (o = !1, r || t(n, a, "auto")) : s({ height: a[0].scrollHeight + "px" }).then(function () {
          r || t(n, a, "auto");
        }), r = !1;
      },
          u = function u() {
        r = !0, o ? (o = !1, t(n, a, 0)) : (t(n, a, a[0].scrollHeight + "px"), s({ height: "0" }));
      };
    } };
}]), angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse"]).constant("accordionConfig", { closeOthers: !0 }).controller("AccordionController", ["$scope", "$attrs", "accordionConfig", function (e, t, n) {
  this.groups = [], this.closeOthers = function (a) {
    var i = angular.isDefined(t.closeOthers) ? e.$eval(t.closeOthers) : n.closeOthers;i && angular.forEach(this.groups, function (e) {
      e !== a && (e.isOpen = !1);
    });
  }, this.addGroup = function (e) {
    var t = this;this.groups.push(e), e.$on("$destroy", function () {
      t.removeGroup(e);
    });
  }, this.removeGroup = function (e) {
    var t = this.groups.indexOf(e);-1 !== t && this.groups.splice(this.groups.indexOf(e), 1);
  };
}]).directive("accordion", function () {
  return { restrict: "EA", controller: "AccordionController", transclude: !0, replace: !1, templateUrl: "template/accordion/accordion.html" };
}).directive("accordionGroup", ["$parse", "$transition", "$timeout", function (e) {
  return { require: "^accordion", restrict: "EA", transclude: !0, replace: !0, templateUrl: "template/accordion/accordion-group.html", scope: { heading: "@" }, controller: ["$scope", function () {
      this.setHeading = function (e) {
        this.heading = e;
      };
    }], link: function link(t, n, a, i) {
      var r, o;i.addGroup(t), t.isOpen = !1, a.isOpen && (r = e(a.isOpen), o = r.assign, t.$watch(function () {
        return r(t.$parent);
      }, function (e) {
        t.isOpen = e;
      }), t.isOpen = r ? r(t.$parent) : !1), t.$watch("isOpen", function (e) {
        e && i.closeOthers(t), o && o(t.$parent, e);
      });
    } };
}]).directive("accordionHeading", function () {
  return { restrict: "EA", transclude: !0, template: "", replace: !0, require: "^accordionGroup", compile: function compile(e, t, n) {
      return function (e, t, a, i) {
        i.setHeading(n(e, function () {}));
      };
    } };
}).directive("accordionTransclude", function () {
  return { require: "^accordionGroup", link: function link(e, t, n, a) {
      e.$watch(function () {
        return a[n.accordionTransclude];
      }, function (e) {
        e && (t.html(""), t.append(e));
      });
    } };
}), angular.module("ui.bootstrap.alert", []).directive("alert", function () {
  return { restrict: "EA", templateUrl: "template/alert/alert.html", transclude: !0, replace: !0, scope: { type: "=", close: "&" }, link: function link(e, t, n) {
      e.closeable = "close" in n;
    } };
}), angular.module("ui.bootstrap.bindHtml", []).directive("bindHtmlUnsafe", function () {
  return function (e, t, n) {
    t.addClass("ng-binding").data("$binding", n.bindHtmlUnsafe), e.$watch(n.bindHtmlUnsafe, function (e) {
      t.html(e || "");
    });
  };
}), angular.module("ui.bootstrap.buttons", []).constant("buttonConfig", { activeClass: "active", toggleEvent: "click" }).directive("btnRadio", ["buttonConfig", function (e) {
  var t = e.activeClass || "active",
      n = e.toggleEvent || "click";return { require: "ngModel", link: function link(e, a, i, r) {
      r.$render = function () {
        a.toggleClass(t, angular.equals(r.$modelValue, e.$eval(i.btnRadio)));
      }, a.bind(n, function () {
        a.hasClass(t) || e.$apply(function () {
          r.$setViewValue(e.$eval(i.btnRadio)), r.$render();
        });
      });
    } };
}]).directive("btnCheckbox", ["buttonConfig", function (e) {
  var t = e.activeClass || "active",
      n = e.toggleEvent || "click";return { require: "ngModel", link: function link(e, a, i, r) {
      function o() {
        var t = e.$eval(i.btnCheckboxTrue);return angular.isDefined(t) ? t : !0;
      }function l() {
        var t = e.$eval(i.btnCheckboxFalse);return angular.isDefined(t) ? t : !1;
      }r.$render = function () {
        a.toggleClass(t, angular.equals(r.$modelValue, o()));
      }, a.bind(n, function () {
        e.$apply(function () {
          r.$setViewValue(a.hasClass(t) ? l() : o()), r.$render();
        });
      });
    } };
}]), angular.module("ui.bootstrap.carousel", ["ui.bootstrap.transition"]).controller("CarouselController", ["$scope", "$timeout", "$transition", "$q", function (e, t, n) {
  function a() {
    function n() {
      r ? (e.next(), a()) : e.pause();
    }i && t.cancel(i);var o = +e.interval;!isNaN(o) && o >= 0 && (i = t(n, o));
  }var i,
      r,
      o = this,
      l = o.slides = [],
      s = -1;o.currentSlide = null, o.select = function (i, r) {
    function c() {
      o.currentSlide && angular.isString(r) && !e.noTransition && i.$element ? (i.$element.addClass(r), i.$element[0].offsetWidth, angular.forEach(l, function (e) {
        angular.extend(e, { direction: "", entering: !1, leaving: !1, active: !1 });
      }), angular.extend(i, { direction: r, active: !0, entering: !0 }), angular.extend(o.currentSlide || {}, { direction: r, leaving: !0 }), e.$currentTransition = n(i.$element, {}), function (t, n) {
        e.$currentTransition.then(function () {
          u(t, n);
        }, function () {
          u(t, n);
        });
      }(i, o.currentSlide)) : u(i, o.currentSlide), o.currentSlide = i, s = p, a();
    }function u(t, n) {
      angular.extend(t, { direction: "", active: !0, leaving: !1, entering: !1 }), angular.extend(n || {}, { direction: "", active: !1, leaving: !1, entering: !1 }), e.$currentTransition = null;
    }var p = l.indexOf(i);void 0 === r && (r = p > s ? "next" : "prev"), i && i !== o.currentSlide && (e.$currentTransition ? (e.$currentTransition.cancel(), t(c)) : c());
  }, o.indexOfSlide = function (e) {
    return l.indexOf(e);
  }, e.next = function () {
    var t = (s + 1) % l.length;return e.$currentTransition ? void 0 : o.select(l[t], "next");
  }, e.prev = function () {
    var t = 0 > s - 1 ? l.length - 1 : s - 1;return e.$currentTransition ? void 0 : o.select(l[t], "prev");
  }, e.select = function (e) {
    o.select(e);
  }, e.isActive = function (e) {
    return o.currentSlide === e;
  }, e.slides = function () {
    return l;
  }, e.$watch("interval", a), e.play = function () {
    r || (r = !0, a());
  }, e.pause = function () {
    e.noPause || (r = !1, i && t.cancel(i));
  }, o.addSlide = function (t, n) {
    t.$element = n, l.push(t), 1 === l.length || t.active ? (o.select(l[l.length - 1]), 1 == l.length && e.play()) : t.active = !1;
  }, o.removeSlide = function (e) {
    var t = l.indexOf(e);l.splice(t, 1), l.length > 0 && e.active ? t >= l.length ? o.select(l[t - 1]) : o.select(l[t]) : s > t && s--;
  };
}]).directive("carousel", [function () {
  return { restrict: "EA", transclude: !0, replace: !0, controller: "CarouselController", require: "carousel", templateUrl: "template/carousel/carousel.html", scope: { interval: "=", noTransition: "=", noPause: "=" } };
}]).directive("slide", ["$parse", function (e) {
  return { require: "^carousel", restrict: "EA", transclude: !0, replace: !0, templateUrl: "template/carousel/slide.html", scope: {}, link: function link(t, n, a, i) {
      if (a.active) {
        var r = e(a.active),
            o = r.assign,
            l = t.active = r(t.$parent);t.$watch(function () {
          var e = r(t.$parent);return e !== t.active && (e !== l ? l = t.active = e : o(t.$parent, e = l = t.active)), e;
        });
      }i.addSlide(t, n), t.$on("$destroy", function () {
        i.removeSlide(t);
      }), t.$watch("active", function (e) {
        e && i.select(t);
      });
    } };
}]), angular.module("ui.bootstrap.position", []).factory("$position", ["$document", "$window", function (e, t) {
  function n(e, n) {
    return e.currentStyle ? e.currentStyle[n] : t.getComputedStyle ? t.getComputedStyle(e)[n] : e.style[n];
  }function a(e) {
    return "static" === (n(e, "position") || "static");
  }var i = function i(t) {
    for (var n = e[0], i = t.offsetParent || n; i && i !== n && a(i);) {
      i = i.offsetParent;
    }return i || n;
  };return { position: function position(t) {
      var n = this.offset(t),
          a = { top: 0, left: 0 },
          r = i(t[0]);return r != e[0] && (a = this.offset(angular.element(r)), a.top += r.clientTop - r.scrollTop, a.left += r.clientLeft - r.scrollLeft), { width: t.prop("offsetWidth"), height: t.prop("offsetHeight"), top: n.top - a.top, left: n.left - a.left };
    }, offset: function offset(n) {
      var a = n[0].getBoundingClientRect();return { width: n.prop("offsetWidth"), height: n.prop("offsetHeight"), top: a.top + (t.pageYOffset || e[0].body.scrollTop || e[0].documentElement.scrollTop), left: a.left + (t.pageXOffset || e[0].body.scrollLeft || e[0].documentElement.scrollLeft) };
    } };
}]), angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.position"]).constant("datepickerConfig", { dayFormat: "dd", monthFormat: "MMMM", yearFormat: "yyyy", dayHeaderFormat: "EEE", dayTitleFormat: "MMMM yyyy", monthTitleFormat: "yy", showWeeks: !0, startingDay: 0, yearRange: 20, minDate: null, maxDate: null }).controller("DatepickerController", ["$scope", "$attrs", "dateFilter", "datepickerConfig", function (e, t, n, a) {
  function i(t, n) {
    return angular.isDefined(t) ? e.$parent.$eval(t) : n;
  }function r(e, t) {
    return new Date(e, t, 0).getDate();
  }function o(e, t) {
    for (var n = Array(t), a = e, i = 0; t > i;) {
      n[i++] = new Date(a), a.setDate(a.getDate() + 1);
    }return n;
  }function l(e, t, a, i) {
    return { date: e, label: n(e, t), selected: !!a, secondary: !!i };
  }var s = { day: i(t.dayFormat, a.dayFormat), month: i(t.monthFormat, a.monthFormat), year: i(t.yearFormat, a.yearFormat), dayHeader: i(t.dayHeaderFormat, a.dayHeaderFormat), dayTitle: i(t.dayTitleFormat, a.dayTitleFormat), monthTitle: i(t.monthTitleFormat, a.monthTitleFormat) },
      c = i(t.startingDay, a.startingDay),
      u = i(t.yearRange, a.yearRange);this.minDate = a.minDate ? new Date(a.minDate) : null, this.maxDate = a.maxDate ? new Date(a.maxDate) : null, this.modes = [{ name: "day", getVisibleDates: function getVisibleDates(e, t) {
      var a = e.getFullYear(),
          i = e.getMonth(),
          u = new Date(a, i, 1),
          p = c - u.getDay(),
          d = p > 0 ? 7 - p : -p,
          f = new Date(u),
          m = 0;d > 0 && (f.setDate(-d + 1), m += d), m += r(a, i + 1), m += (7 - m % 7) % 7;for (var g = o(f, m), h = Array(7), v = 0; m > v; v++) {
        var b = new Date(g[v]);g[v] = l(b, s.day, t && t.getDate() === b.getDate() && t.getMonth() === b.getMonth() && t.getFullYear() === b.getFullYear(), b.getMonth() !== i);
      }for (var $ = 0; 7 > $; $++) {
        h[$] = n(g[$].date, s.dayHeader);
      }return { objects: g, title: n(e, s.dayTitle), labels: h };
    }, compare: function compare(e, t) {
      return new Date(e.getFullYear(), e.getMonth(), e.getDate()) - new Date(t.getFullYear(), t.getMonth(), t.getDate());
    }, split: 7, step: { months: 1 } }, { name: "month", getVisibleDates: function getVisibleDates(e, t) {
      for (var a = Array(12), i = e.getFullYear(), r = 0; 12 > r; r++) {
        var o = new Date(i, r, 1);a[r] = l(o, s.month, t && t.getMonth() === r && t.getFullYear() === i);
      }return { objects: a, title: n(e, s.monthTitle) };
    }, compare: function compare(e, t) {
      return new Date(e.getFullYear(), e.getMonth()) - new Date(t.getFullYear(), t.getMonth());
    }, split: 3, step: { years: 1 } }, { name: "year", getVisibleDates: function getVisibleDates(e, t) {
      for (var n = Array(u), a = e.getFullYear(), i = parseInt((a - 1) / u, 10) * u + 1, r = 0; u > r; r++) {
        var o = new Date(i + r, 0, 1);n[r] = l(o, s.year, t && t.getFullYear() === o.getFullYear());
      }return { objects: n, title: [n[0].label, n[u - 1].label].join(" - ") };
    }, compare: function compare(e, t) {
      return e.getFullYear() - t.getFullYear();
    }, split: 5, step: { years: u } }], this.isDisabled = function (t, n) {
    var a = this.modes[n || 0];return this.minDate && 0 > a.compare(t, this.minDate) || this.maxDate && a.compare(t, this.maxDate) > 0 || e.dateDisabled && e.dateDisabled({ date: t, mode: a.name });
  };
}]).directive("datepicker", ["dateFilter", "$parse", "datepickerConfig", "$log", function (e, t, n, a) {
  return { restrict: "EA", replace: !0, templateUrl: "template/datepicker/datepicker.html", scope: { dateDisabled: "&" }, require: ["datepicker", "?^ngModel"], controller: "DatepickerController", link: function link(e, i, r, o) {
      function l() {
        e.showWeekNumbers = 0 === m && h;
      }function s(e, t) {
        for (var n = []; e.length > 0;) {
          n.push(e.splice(0, t));
        }return n;
      }function c(t) {
        var n = null,
            i = !0;f.$modelValue && (n = new Date(f.$modelValue), isNaN(n) ? (i = !1, a.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')) : t && (g = n)), f.$setValidity("date", i);var r = d.modes[m],
            o = r.getVisibleDates(g, n);angular.forEach(o.objects, function (e) {
          e.disabled = d.isDisabled(e.date, m);
        }), f.$setValidity("date-disabled", !n || !d.isDisabled(n)), e.rows = s(o.objects, r.split), e.labels = o.labels || [], e.title = o.title;
      }function u(e) {
        m = e, l(), c();
      }function p(e) {
        var t = new Date(e);t.setDate(t.getDate() + 4 - (t.getDay() || 7));var n = t.getTime();return t.setMonth(0), t.setDate(1), Math.floor(Math.round((n - t) / 864e5) / 7) + 1;
      }var d = o[0],
          f = o[1];if (f) {
        var m = 0,
            g = new Date(),
            h = n.showWeeks;r.showWeeks ? e.$parent.$watch(t(r.showWeeks), function (e) {
          h = !!e, l();
        }) : l(), r.min && e.$parent.$watch(t(r.min), function (e) {
          d.minDate = e ? new Date(e) : null, c();
        }), r.max && e.$parent.$watch(t(r.max), function (e) {
          d.maxDate = e ? new Date(e) : null, c();
        }), f.$render = function () {
          c(!0);
        }, e.select = function (e) {
          if (0 === m) {
            var t = new Date(f.$modelValue);t.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), f.$setViewValue(t), c(!0);
          } else g = e, u(m - 1);
        }, e.move = function (e) {
          var t = d.modes[m].step;g.setMonth(g.getMonth() + e * (t.months || 0)), g.setFullYear(g.getFullYear() + e * (t.years || 0)), c();
        }, e.toggleMode = function () {
          u((m + 1) % d.modes.length);
        }, e.getWeekNumber = function (t) {
          return 0 === m && e.showWeekNumbers && 7 === t.length ? p(t[0].date) : null;
        };
      }
    } };
}]).constant("datepickerPopupConfig", { dateFormat: "yyyy-MM-dd", closeOnDateSelection: !0 }).directive("datepickerPopup", ["$compile", "$parse", "$document", "$position", "dateFilter", "datepickerPopupConfig", function (e, t, n, a, i, r) {
  return { restrict: "EA", require: "ngModel", link: function link(o, l, s, c) {
      function u(e) {
        $ ? $(o, !!e) : v.isOpen = !!e;
      }function p(e) {
        if (e) {
          if (angular.isDate(e)) return c.$setValidity("date", !0), e;if (angular.isString(e)) {
            var t = new Date(e);return isNaN(t) ? (c.$setValidity("date", !1), void 0) : (c.$setValidity("date", !0), t);
          }return c.$setValidity("date", !1), void 0;
        }return c.$setValidity("date", !0), null;
      }function d() {
        v.date = c.$modelValue, m();
      }function f(e, n, a) {
        e && (o.$watch(t(e), function (e) {
          v[n] = e;
        }), D.attr(a || n, n));
      }function m() {
        v.position = a.position(l), v.position.top = v.position.top + l.prop("offsetHeight");
      }var g = angular.isDefined(s.closeOnDateSelection) ? v.$eval(s.closeOnDateSelection) : r.closeOnDateSelection,
          h = s.datepickerPopup || r.dateFormat,
          v = o.$new();o.$on("$destroy", function () {
        v.$destroy();
      });var b, $;s.isOpen && (b = t(s.isOpen), $ = b.assign, o.$watch(b, function (e) {
        v.isOpen = !!e;
      })), v.isOpen = b ? b(o) : !1;var y = function y(e) {
        v.isOpen && e.target !== l[0] && v.$apply(function () {
          u(!1);
        });
      },
          w = function w() {
        v.$apply(function () {
          u(!0);
        });
      },
          k = angular.element("<datepicker-popup-wrap><datepicker></datepicker></datepicker-popup-wrap>");k.attr({ "ng-model": "date", "ng-change": "dateSelection()" });var D = k.find("datepicker");s.datepickerOptions && D.attr(angular.extend({}, o.$eval(s.datepickerOptions))), c.$parsers.unshift(p), v.dateSelection = function () {
        c.$setViewValue(v.date), c.$render(), g && u(!1);
      }, l.bind("input change keyup", function () {
        v.$apply(function () {
          d();
        });
      }), c.$render = function () {
        var e = c.$viewValue ? i(c.$viewValue, h) : "";l.val(e), d();
      }, f(s.min, "min"), f(s.max, "max"), s.showWeeks ? f(s.showWeeks, "showWeeks", "show-weeks") : (v.showWeeks = !0, D.attr("show-weeks", "showWeeks")), s.dateDisabled && D.attr("date-disabled", s.dateDisabled);var x = !1,
          T = !1;v.$watch("isOpen", function (e) {
        e ? (m(), n.bind("click", y), T && l.unbind("focus", w), l[0].focus(), x = !0) : (x && n.unbind("click", y), l.bind("focus", w), T = !0), $ && $(o, e);
      });var C = t(s.ngModel).assign;v.today = function () {
        C(o, new Date());
      }, v.clear = function () {
        C(o, null);
      }, l.after(e(k)(v));
    } };
}]).directive("datepickerPopupWrap", [function () {
  return { restrict: "E", replace: !0, transclude: !0, templateUrl: "template/datepicker/popup.html", link: function link(e, t) {
      t.bind("click", function (e) {
        e.preventDefault(), e.stopPropagation();
      });
    } };
}]), angular.module("ui.bootstrap.dropdownToggle", []).directive("dropdownToggle", ["$document", "$location", function (e) {
  var t = null,
      _n = angular.noop;return { restrict: "CA", link: function link(a, i) {
      a.$watch("$location.path", function () {
        _n();
      }), i.parent().bind("click", function () {
        _n();
      }), i.bind("click", function (a) {
        var r = i === t;a.preventDefault(), a.stopPropagation(), t && _n(), r || (i.parent().addClass("open"), t = i, _n = function n(a) {
          a && (a.preventDefault(), a.stopPropagation()), e.unbind("click", _n), i.parent().removeClass("open"), _n = angular.noop, t = null;
        }, e.bind("click", _n));
      });
    } };
}]), angular.module("ui.bootstrap.modal", []).factory("$$stackedMap", function () {
  return { createNew: function createNew() {
      var e = [];return { add: function add(t, n) {
          e.push({ key: t, value: n });
        }, get: function get(t) {
          for (var n = 0; e.length > n; n++) {
            if (t == e[n].key) return e[n];
          }
        }, keys: function keys() {
          for (var t = [], n = 0; e.length > n; n++) {
            t.push(e[n].key);
          }return t;
        }, top: function top() {
          return e[e.length - 1];
        }, remove: function remove(t) {
          for (var n = -1, a = 0; e.length > a; a++) {
            if (t == e[a].key) {
              n = a;break;
            }
          }return e.splice(n, 1)[0];
        }, removeTop: function removeTop() {
          return e.splice(e.length - 1, 1)[0];
        }, length: function length() {
          return e.length;
        } };
    } };
}).directive("modalBackdrop", ["$modalStack", "$timeout", function (e, t) {
  return { restrict: "EA", replace: !0, templateUrl: "template/modal/backdrop.html", link: function link(n) {
      t(function () {
        n.animate = !0;
      }), n.close = function (t) {
        var n = e.getTop();n && n.value.backdrop && "static" != n.value.backdrop && (t.preventDefault(), t.stopPropagation(), e.dismiss(n.key, "backdrop click"));
      };
    } };
}]).directive("modalWindow", ["$timeout", function (e) {
  return { restrict: "EA", scope: { index: "@" }, replace: !0, transclude: !0, templateUrl: "template/modal/window.html", link: function link(t, n, a) {
      t.windowClass = a.windowClass || "", e(function () {
        t.animate = !0;
      });
    } };
}]).factory("$modalStack", ["$document", "$compile", "$rootScope", "$$stackedMap", function (e, t, n, a) {
  function i() {
    for (var e = -1, t = u.keys(), n = 0; t.length > n; n++) {
      u.get(t[n]).value.backdrop && (e = n);
    }return e;
  }function r(e) {
    var t = u.get(e).value;u.remove(e), t.modalDomEl.remove(), -1 == i() && (l.remove(), l = void 0), t.modalScope.$destroy();
  }var o,
      l,
      s = n.$new(!0),
      c = e.find("body").eq(0),
      u = a.createNew(),
      p = {};return n.$watch(i, function (e) {
    s.index = e;
  }), e.bind("keydown", function (e) {
    var t;27 === e.which && (t = u.top(), t && t.value.keyboard && n.$apply(function () {
      p.dismiss(t.key);
    }));
  }), p.open = function (e, n) {
    u.add(e, { deferred: n.deferred, modalScope: n.scope, backdrop: n.backdrop, keyboard: n.keyboard });var a = angular.element("<div modal-window></div>");a.attr("window-class", n.windowClass), a.attr("index", u.length() - 1), a.html(n.content);var r = t(a)(n.scope);u.top().value.modalDomEl = r, c.append(r), i() >= 0 && !l && (o = angular.element("<div modal-backdrop></div>"), l = t(o)(s), c.append(l));
  }, p.close = function (e, t) {
    var n = u.get(e);n && (n.value.deferred.resolve(t), r(e));
  }, p.dismiss = function (e, t) {
    var n = u.get(e).value;n && (n.deferred.reject(t), r(e));
  }, p.getTop = function () {
    return u.top();
  }, p;
}]).provider("$modal", function () {
  var e = { options: { backdrop: !0, keyboard: !0 }, $get: ["$injector", "$rootScope", "$q", "$http", "$templateCache", "$controller", "$modalStack", function (t, n, a, i, r, o, l) {
      function s(e) {
        return e.template ? a.when(e.template) : i.get(e.templateUrl, { cache: r }).then(function (e) {
          return e.data;
        });
      }function c(e) {
        var n = [];return angular.forEach(e, function (e) {
          (angular.isFunction(e) || angular.isArray(e)) && n.push(a.when(t.invoke(e)));
        }), n;
      }var u = {};return u.open = function (t) {
        var i = a.defer(),
            r = a.defer(),
            u = { result: i.promise, opened: r.promise, close: function close(e) {
            l.close(u, e);
          }, dismiss: function dismiss(e) {
            l.dismiss(u, e);
          } };if (t = angular.extend({}, e.options, t), t.resolve = t.resolve || {}, !t.template && !t.templateUrl) throw Error("One of template or templateUrl options is required.");var p = a.all([s(t)].concat(c(t.resolve)));return p.then(function (e) {
          var a = (t.scope || n).$new();a.$close = u.close, a.$dismiss = u.dismiss;var r,
              s = {},
              c = 1;t.controller && (s.$scope = a, s.$modalInstance = u, angular.forEach(t.resolve, function (t, n) {
            s[n] = e[c++];
          }), r = o(t.controller, s)), l.open(u, { scope: a, deferred: i, content: e[0], backdrop: t.backdrop, keyboard: t.keyboard, windowClass: t.windowClass });
        }, function (e) {
          i.reject(e);
        }), p.then(function () {
          r.resolve(!0);
        }, function () {
          r.reject(!1);
        }), u;
      }, u;
    }] };return e;
}), angular.module("ui.bootstrap.pagination", []).controller("PaginationController", ["$scope", "$attrs", "$parse", "$interpolate", function (e, t, n, a) {
  var i = this;this.init = function (a) {
    t.itemsPerPage ? e.$parent.$watch(n(t.itemsPerPage), function (t) {
      i.itemsPerPage = parseInt(t, 10), e.totalPages = i.calculateTotalPages();
    }) : this.itemsPerPage = a;
  }, this.noPrevious = function () {
    return 1 === this.page;
  }, this.noNext = function () {
    return this.page === e.totalPages;
  }, this.isActive = function (e) {
    return this.page === e;
  }, this.calculateTotalPages = function () {
    return 1 > this.itemsPerPage ? 1 : Math.ceil(e.totalItems / this.itemsPerPage);
  }, this.getAttributeValue = function (t, n, i) {
    return angular.isDefined(t) ? i ? a(t)(e.$parent) : e.$parent.$eval(t) : n;
  }, this.render = function () {
    this.page = parseInt(e.page, 10) || 1, e.pages = this.getPages(this.page, e.totalPages);
  }, e.selectPage = function (t) {
    !i.isActive(t) && t > 0 && e.totalPages >= t && (e.page = t, e.onSelectPage({ page: t }));
  }, e.$watch("totalItems", function () {
    e.totalPages = i.calculateTotalPages();
  }), e.$watch("totalPages", function (n) {
    t.numPages && (e.numPages = n), i.page > n ? e.selectPage(n) : i.render();
  }), e.$watch("page", function () {
    i.render();
  });
}]).constant("paginationConfig", { itemsPerPage: 10, boundaryLinks: !1, directionLinks: !0, firstText: "First", previousText: "Previous", nextText: "Next", lastText: "Last", rotate: !0 }).directive("pagination", ["$parse", "paginationConfig", function (e, t) {
  return { restrict: "EA", scope: { page: "=", totalItems: "=", onSelectPage: " &", numPages: "=" }, controller: "PaginationController", templateUrl: "template/pagination/pagination.html", replace: !0, link: function link(n, a, i, r) {
      function o(e, t, n, a) {
        return { number: e, text: t, active: n, disabled: a };
      }var l,
          s = r.getAttributeValue(i.boundaryLinks, t.boundaryLinks),
          c = r.getAttributeValue(i.directionLinks, t.directionLinks),
          u = r.getAttributeValue(i.firstText, t.firstText, !0),
          p = r.getAttributeValue(i.previousText, t.previousText, !0),
          d = r.getAttributeValue(i.nextText, t.nextText, !0),
          f = r.getAttributeValue(i.lastText, t.lastText, !0),
          m = r.getAttributeValue(i.rotate, t.rotate);r.init(t.itemsPerPage), i.maxSize && n.$parent.$watch(e(i.maxSize), function (e) {
        l = parseInt(e, 10), r.render();
      }), r.getPages = function (e, t) {
        var n = [],
            a = 1,
            i = t,
            g = angular.isDefined(l) && t > l;g && (m ? (a = Math.max(e - Math.floor(l / 2), 1), i = a + l - 1, i > t && (i = t, a = i - l + 1)) : (a = (Math.ceil(e / l) - 1) * l + 1, i = Math.min(a + l - 1, t)));for (var h = a; i >= h; h++) {
          var v = o(h, h, r.isActive(h), !1);n.push(v);
        }if (g && !m) {
          if (a > 1) {
            var b = o(a - 1, "...", !1, !1);n.unshift(b);
          }if (t > i) {
            var $ = o(i + 1, "...", !1, !1);n.push($);
          }
        }if (c) {
          var y = o(e - 1, p, !1, r.noPrevious());n.unshift(y);var w = o(e + 1, d, !1, r.noNext());n.push(w);
        }if (s) {
          var k = o(1, u, !1, r.noPrevious());n.unshift(k);var D = o(t, f, !1, r.noNext());n.push(D);
        }return n;
      };
    } };
}]).constant("pagerConfig", { itemsPerPage: 10, previousText: "« Previous", nextText: "Next »", align: !0 }).directive("pager", ["pagerConfig", function (e) {
  return { restrict: "EA", scope: { page: "=", totalItems: "=", onSelectPage: " &", numPages: "=" }, controller: "PaginationController", templateUrl: "template/pagination/pager.html", replace: !0, link: function link(t, n, a, i) {
      function r(e, t, n, a, i) {
        return { number: e, text: t, disabled: n, previous: s && a, next: s && i };
      }var o = i.getAttributeValue(a.previousText, e.previousText, !0),
          l = i.getAttributeValue(a.nextText, e.nextText, !0),
          s = i.getAttributeValue(a.align, e.align);i.init(e.itemsPerPage), i.getPages = function (e) {
        return [r(e - 1, o, i.noPrevious(), !0, !1), r(e + 1, l, i.noNext(), !1, !0)];
      };
    } };
}]), angular.module("ui.bootstrap.tooltip", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).provider("$tooltip", function () {
  function e(e) {
    var t = /[A-Z]/g,
        n = "-";return e.replace(t, function (e, t) {
      return (t ? n : "") + e.toLowerCase();
    });
  }var t = { placement: "top", animation: !0, popupDelay: 0 },
      n = { mouseenter: "mouseleave", click: "click", focus: "blur" },
      a = {};this.options = function (e) {
    angular.extend(a, e);
  }, this.setTriggers = function (e) {
    angular.extend(n, e);
  }, this.$get = ["$window", "$compile", "$timeout", "$parse", "$document", "$position", "$interpolate", function (i, r, o, l, s, c, u) {
    return function (i, p, d) {
      function f(e) {
        var t = e || m.trigger || d,
            a = n[t] || t;return { show: t, hide: a };
      }var m = angular.extend({}, t, a),
          g = e(i),
          h = u.startSymbol(),
          v = u.endSymbol(),
          b = "<" + g + "-popup " + 'title="' + h + "tt_title" + v + '" ' + 'content="' + h + "tt_content" + v + '" ' + 'placement="' + h + "tt_placement" + v + '" ' + 'animation="tt_animation()" ' + 'is-open="tt_isOpen"' + ">" + "</" + g + "-popup>";return { restrict: "EA", scope: !0, link: function link(e, t, n) {
          function a() {
            e.tt_isOpen ? d() : u();
          }function u() {
            e.tt_popupDelay ? $ = o(g, e.tt_popupDelay) : e.$apply(g);
          }function d() {
            e.$apply(function () {
              h();
            });
          }function g() {
            var n, a, i, r;if (e.tt_content) {
              switch (v && o.cancel(v), w.css({ top: 0, left: 0, display: "block" }), k ? (y = y || s.find("body"), y.append(w)) : t.after(w), n = k ? c.offset(t) : c.position(t), a = w.prop("offsetWidth"), i = w.prop("offsetHeight"), e.tt_placement) {case "right":
                  r = { top: n.top + n.height / 2 - i / 2, left: n.left + n.width };break;case "bottom":
                  r = { top: n.top + n.height, left: n.left + n.width / 2 - a / 2 };break;case "left":
                  r = { top: n.top + n.height / 2 - i / 2, left: n.left - a };break;default:
                  r = { top: n.top - i, left: n.left + n.width / 2 - a / 2 };}r.top += "px", r.left += "px", w.css(r), e.tt_isOpen = !0;
            }
          }function h() {
            e.tt_isOpen = !1, o.cancel($), angular.isDefined(e.tt_animation) && e.tt_animation() ? v = o(function () {
              w.remove();
            }, 500) : w.remove();
          }var v,
              $,
              y,
              w = r(b)(e),
              k = angular.isDefined(m.appendToBody) ? m.appendToBody : !1,
              D = f(void 0),
              x = !1;e.tt_isOpen = !1, n.$observe(i, function (t) {
            e.tt_content = t;
          }), n.$observe(p + "Title", function (t) {
            e.tt_title = t;
          }), n.$observe(p + "Placement", function (t) {
            e.tt_placement = angular.isDefined(t) ? t : m.placement;
          }), n.$observe(p + "Animation", function (t) {
            e.tt_animation = angular.isDefined(t) ? l(t) : function () {
              return m.animation;
            };
          }), n.$observe(p + "PopupDelay", function (t) {
            var n = parseInt(t, 10);e.tt_popupDelay = isNaN(n) ? m.popupDelay : n;
          }), n.$observe(p + "Trigger", function (e) {
            x && (t.unbind(D.show, u), t.unbind(D.hide, d)), D = f(e), D.show === D.hide ? t.bind(D.show, a) : (t.bind(D.show, u), t.bind(D.hide, d)), x = !0;
          }), n.$observe(p + "AppendToBody", function (t) {
            k = angular.isDefined(t) ? l(t)(e) : k;
          }), k && e.$on("$locationChangeSuccess", function () {
            e.tt_isOpen && h();
          }), e.$on("$destroy", function () {
            e.tt_isOpen ? h() : w.remove();
          });
        } };
    };
  }];
}).directive("tooltipPopup", function () {
  return { restrict: "E", replace: !0, scope: { content: "@", placement: "@", animation: "&", isOpen: "&" }, templateUrl: "template/tooltip/tooltip-popup.html" };
}).directive("tooltip", ["$tooltip", function (e) {
  return e("tooltip", "tooltip", "mouseenter");
}]).directive("tooltipHtmlUnsafePopup", function () {
  return { restrict: "E", replace: !0, scope: { content: "@", placement: "@", animation: "&", isOpen: "&" }, templateUrl: "template/tooltip/tooltip-html-unsafe-popup.html" };
}).directive("tooltipHtmlUnsafe", ["$tooltip", function (e) {
  return e("tooltipHtmlUnsafe", "tooltip", "mouseenter");
}]), angular.module("ui.bootstrap.popover", ["ui.bootstrap.tooltip"]).directive("popoverPopup", function () {
  return { restrict: "EA", replace: !0, scope: { title: "@", content: "@", placement: "@", animation: "&", isOpen: "&" }, templateUrl: "template/popover/popover.html" };
}).directive("popover", ["$compile", "$timeout", "$parse", "$window", "$tooltip", function (e, t, n, a, i) {
  return i("popover", "popover", "click");
}]), angular.module("ui.bootstrap.progressbar", ["ui.bootstrap.transition"]).constant("progressConfig", { animate: !0, autoType: !1, stackedTypes: ["success", "info", "warning", "danger"] }).controller("ProgressBarController", ["$scope", "$attrs", "progressConfig", function (e, t, n) {
  function a(e) {
    return o[e];
  }var i = angular.isDefined(t.animate) ? e.$eval(t.animate) : n.animate,
      r = angular.isDefined(t.autoType) ? e.$eval(t.autoType) : n.autoType,
      o = angular.isDefined(t.stackedTypes) ? e.$eval("[" + t.stackedTypes + "]") : n.stackedTypes;this.makeBar = function (e, t, n) {
    var o = angular.isObject(e) ? e.value : e || 0,
        l = angular.isObject(t) ? t.value : t || 0,
        s = angular.isObject(e) && angular.isDefined(e.type) ? e.type : r ? a(n || 0) : null;return { from: l, to: o, type: s, animate: i };
  }, this.addBar = function (t) {
    e.bars.push(t), e.totalPercent += t.to;
  }, this.clearBars = function () {
    e.bars = [], e.totalPercent = 0;
  }, this.clearBars();
}]).directive("progress", function () {
  return { restrict: "EA", replace: !0, controller: "ProgressBarController", scope: { value: "=percent", onFull: "&", onEmpty: "&" }, templateUrl: "template/progressbar/progress.html", link: function link(e, t, n, a) {
      e.$watch("value", function (e, t) {
        if (a.clearBars(), angular.isArray(e)) for (var n = 0, i = e.length; i > n; n++) {
          a.addBar(a.makeBar(e[n], t[n], n));
        } else a.addBar(a.makeBar(e, t));
      }, !0), e.$watch("totalPercent", function (t) {
        t >= 100 ? e.onFull() : 0 >= t && e.onEmpty();
      }, !0);
    } };
}).directive("progressbar", ["$transition", function (e) {
  return { restrict: "EA", replace: !0, scope: { width: "=", old: "=", type: "=", animate: "=" }, templateUrl: "template/progressbar/bar.html", link: function link(t, n) {
      t.$watch("width", function (a) {
        t.animate ? (n.css("width", t.old + "%"), e(n, { width: a + "%" })) : n.css("width", a + "%");
      });
    } };
}]), angular.module("ui.bootstrap.rating", []).constant("ratingConfig", { max: 5, stateOn: null, stateOff: null }).controller("RatingController", ["$scope", "$attrs", "$parse", "ratingConfig", function (e, t, n, a) {
  this.maxRange = angular.isDefined(t.max) ? e.$parent.$eval(t.max) : a.max, this.stateOn = angular.isDefined(t.stateOn) ? e.$parent.$eval(t.stateOn) : a.stateOn, this.stateOff = angular.isDefined(t.stateOff) ? e.$parent.$eval(t.stateOff) : a.stateOff, this.createDefaultRange = function (e) {
    for (var t = { stateOn: this.stateOn, stateOff: this.stateOff }, n = Array(e), a = 0; e > a; a++) {
      n[a] = t;
    }return n;
  }, this.normalizeRange = function (e) {
    for (var t = 0, n = e.length; n > t; t++) {
      e[t].stateOn = e[t].stateOn || this.stateOn, e[t].stateOff = e[t].stateOff || this.stateOff;
    }return e;
  }, e.range = angular.isDefined(t.ratingStates) ? this.normalizeRange(angular.copy(e.$parent.$eval(t.ratingStates))) : this.createDefaultRange(this.maxRange), e.rate = function (t) {
    e.readonly || e.value === t || (e.value = t);
  }, e.enter = function (t) {
    e.readonly || (e.val = t), e.onHover({ value: t });
  }, e.reset = function () {
    e.val = angular.copy(e.value), e.onLeave();
  }, e.$watch("value", function (t) {
    e.val = t;
  }), e.readonly = !1, t.readonly && e.$parent.$watch(n(t.readonly), function (t) {
    e.readonly = !!t;
  });
}]).directive("rating", function () {
  return { restrict: "EA", scope: { value: "=", onHover: "&", onLeave: "&" }, controller: "RatingController", templateUrl: "template/rating/rating.html", replace: !0 };
}), angular.module("ui.bootstrap.tabs", []).directive("tabs", function () {
  return function () {
    throw Error("The `tabs` directive is deprecated, please migrate to `tabset`. Instructions can be found at http://github.com/angular-ui/bootstrap/tree/master/CHANGELOG.md");
  };
}).controller("TabsetController", ["$scope", "$element", function (e) {
  var t = this,
      n = t.tabs = e.tabs = [];t.select = function (e) {
    angular.forEach(n, function (e) {
      e.active = !1;
    }), e.active = !0;
  }, t.addTab = function (e) {
    n.push(e), (1 === n.length || e.active) && t.select(e);
  }, t.removeTab = function (e) {
    var a = n.indexOf(e);if (e.active && n.length > 1) {
      var i = a == n.length - 1 ? a - 1 : a + 1;t.select(n[i]);
    }n.splice(a, 1);
  };
}]).directive("tabset", function () {
  return { restrict: "EA", transclude: !0, replace: !0, require: "^tabset", scope: {}, controller: "TabsetController", templateUrl: "template/tabs/tabset.html", compile: function compile(e, t, n) {
      return function (e, t, a, i) {
        e.vertical = angular.isDefined(a.vertical) ? e.$parent.$eval(a.vertical) : !1, e.type = angular.isDefined(a.type) ? e.$parent.$eval(a.type) : "tabs", e.direction = angular.isDefined(a.direction) ? e.$parent.$eval(a.direction) : "top", e.tabsAbove = "below" != e.direction, i.$scope = e, i.$transcludeFn = n;
      };
    } };
}).directive("tab", ["$parse", "$http", "$templateCache", "$compile", function (e) {
  return { require: "^tabset", restrict: "EA", replace: !0, templateUrl: "template/tabs/tab.html", transclude: !0, scope: { heading: "@", onSelect: "&select", onDeselect: "&deselect" }, controller: function controller() {}, compile: function compile(t, n, a) {
      return function (t, n, i, r) {
        var o, l;
        i.active ? (o = e(i.active), l = o.assign, t.$parent.$watch(o, function (e) {
          t.active = !!e;
        }), t.active = o(t.$parent)) : l = o = angular.noop, t.$watch("active", function (e) {
          l(t.$parent, e), e ? (r.select(t), t.onSelect()) : t.onDeselect();
        }), t.disabled = !1, i.disabled && t.$parent.$watch(e(i.disabled), function (e) {
          t.disabled = !!e;
        }), t.select = function () {
          t.disabled || (t.active = !0);
        }, r.addTab(t), t.$on("$destroy", function () {
          r.removeTab(t);
        }), t.active && l(t.$parent, !0), t.$transcludeFn = a;
      };
    } };
}]).directive("tabHeadingTransclude", [function () {
  return { restrict: "A", require: "^tab", link: function link(e, t) {
      e.$watch("headingElement", function (e) {
        e && (t.html(""), t.append(e));
      });
    } };
}]).directive("tabContentTransclude", ["$compile", "$parse", function () {
  function e(e) {
    return e.tagName && (e.hasAttribute("tab-heading") || e.hasAttribute("data-tab-heading") || "tab-heading" === e.tagName.toLowerCase() || "data-tab-heading" === e.tagName.toLowerCase());
  }return { restrict: "A", require: "^tabset", link: function link(t, n, a) {
      var i = t.$eval(a.tabContentTransclude);i.$transcludeFn(i.$parent, function (t) {
        angular.forEach(t, function (t) {
          e(t) ? i.headingElement = t : n.append(t);
        });
      });
    } };
}]).directive("tabsetTitles", ["$http", function () {
  return { restrict: "A", require: "^tabset", templateUrl: "template/tabs/tabset-titles.html", replace: !0, link: function link(e, t, n, a) {
      e.$eval(n.tabsetTitles) ? a.$transcludeFn(a.$scope.$parent, function (e) {
        t.append(e);
      }) : t.remove();
    } };
}]), angular.module("ui.bootstrap.timepicker", []).constant("timepickerConfig", { hourStep: 1, minuteStep: 1, showMeridian: !0, meridians: ["AM", "PM"], readonlyInput: !1, mousewheel: !0 }).directive("timepicker", ["$parse", "$log", "timepickerConfig", function (e, t, n) {
  return { restrict: "EA", require: "?^ngModel", replace: !0, scope: {}, templateUrl: "template/timepicker/timepicker.html", link: function link(a, i, r, o) {
      function l() {
        var e = parseInt(a.hours, 10),
            t = a.showMeridian ? e > 0 && 13 > e : e >= 0 && 24 > e;return t ? (a.showMeridian && (12 === e && (e = 0), a.meridian === g[1] && (e += 12)), e) : void 0;
      }function s() {
        var e = parseInt(a.minutes, 10);return e >= 0 && 60 > e ? e : void 0;
      }function c(e) {
        return angular.isDefined(e) && 2 > ("" + e).length ? "0" + e : e;
      }function u(e) {
        p(), o.$setViewValue(new Date(m)), d(e);
      }function p() {
        o.$setValidity("time", !0), a.invalidHours = !1, a.invalidMinutes = !1;
      }function d(e) {
        var t = m.getHours(),
            n = m.getMinutes();a.showMeridian && (t = 0 === t || 12 === t ? 12 : t % 12), a.hours = "h" === e ? t : c(t), a.minutes = "m" === e ? n : c(n), a.meridian = 12 > m.getHours() ? g[0] : g[1];
      }function f(e) {
        var t = new Date(m.getTime() + 6e4 * e);m.setHours(t.getHours(), t.getMinutes()), u();
      }if (o) {
        var m = new Date(),
            g = n.meridians,
            h = n.hourStep;r.hourStep && a.$parent.$watch(e(r.hourStep), function (e) {
          h = parseInt(e, 10);
        });var v = n.minuteStep;r.minuteStep && a.$parent.$watch(e(r.minuteStep), function (e) {
          v = parseInt(e, 10);
        }), a.showMeridian = n.showMeridian, r.showMeridian && a.$parent.$watch(e(r.showMeridian), function (e) {
          if (a.showMeridian = !!e, o.$error.time) {
            var t = l(),
                n = s();angular.isDefined(t) && angular.isDefined(n) && (m.setHours(t), u());
          } else d();
        });var b = i.find("input"),
            $ = b.eq(0),
            y = b.eq(1),
            w = angular.isDefined(r.mousewheel) ? a.$eval(r.mousewheel) : n.mousewheel;if (w) {
          var k = function k(e) {
            e.originalEvent && (e = e.originalEvent);var t = e.wheelDelta ? e.wheelDelta : -e.deltaY;return e.detail || t > 0;
          };$.bind("mousewheel wheel", function (e) {
            a.$apply(k(e) ? a.incrementHours() : a.decrementHours()), e.preventDefault();
          }), y.bind("mousewheel wheel", function (e) {
            a.$apply(k(e) ? a.incrementMinutes() : a.decrementMinutes()), e.preventDefault();
          });
        }if (a.readonlyInput = angular.isDefined(r.readonlyInput) ? a.$eval(r.readonlyInput) : n.readonlyInput, a.readonlyInput) a.updateHours = angular.noop, a.updateMinutes = angular.noop;else {
          var D = function D(e, t) {
            o.$setViewValue(null), o.$setValidity("time", !1), angular.isDefined(e) && (a.invalidHours = e), angular.isDefined(t) && (a.invalidMinutes = t);
          };a.updateHours = function () {
            var e = l();angular.isDefined(e) ? (m.setHours(e), u("h")) : D(!0);
          }, $.bind("blur", function () {
            !a.validHours && 10 > a.hours && a.$apply(function () {
              a.hours = c(a.hours);
            });
          }), a.updateMinutes = function () {
            var e = s();angular.isDefined(e) ? (m.setMinutes(e), u("m")) : D(void 0, !0);
          }, y.bind("blur", function () {
            !a.invalidMinutes && 10 > a.minutes && a.$apply(function () {
              a.minutes = c(a.minutes);
            });
          });
        }o.$render = function () {
          var e = o.$modelValue ? new Date(o.$modelValue) : null;isNaN(e) ? (o.$setValidity("time", !1), t.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')) : (e && (m = e), p(), d());
        }, a.incrementHours = function () {
          f(60 * h);
        }, a.decrementHours = function () {
          f(60 * -h);
        }, a.incrementMinutes = function () {
          f(v);
        }, a.decrementMinutes = function () {
          f(-v);
        }, a.toggleMeridian = function () {
          f(720 * (12 > m.getHours() ? 1 : -1));
        };
      }
    } };
}]), angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.position", "ui.bootstrap.bindHtml"]).factory("typeaheadParser", ["$parse", function (e) {
  var t = /^\s*(.*?)(?:\s+as\s+(.*?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+(.*)$/;return { parse: function parse(n) {
      var a = n.match(t);if (!a) throw Error("Expected typeahead specification in form of '_modelValue_ (as _label_)? for _item_ in _collection_' but got '" + n + "'.");return { itemName: a[3], source: e(a[4]), viewMapper: e(a[2] || a[1]), modelMapper: e(a[1]) };
    } };
}]).directive("typeahead", ["$compile", "$parse", "$q", "$timeout", "$document", "$position", "typeaheadParser", function (e, t, n, a, i, r, o) {
  var l = [9, 13, 27, 38, 40];return { require: "ngModel", link: function link(s, c, u, p) {
      var d = s.$eval(u.typeaheadMinLength) || 1,
          f = s.$eval(u.typeaheadWaitMs) || 0,
          m = s.$eval(u.typeaheadEditable) !== !1,
          g = t(u.typeaheadLoading).assign || angular.noop,
          h = t(u.typeaheadOnSelect),
          v = u.typeaheadInputFormatter ? t(u.typeaheadInputFormatter) : void 0,
          b = t(u.ngModel).assign,
          $ = o.parse(u.typeahead),
          y = angular.element("<typeahead-popup></typeahead-popup>");y.attr({ matches: "matches", active: "activeIdx", select: "select(activeIdx)", query: "query", position: "position" }), angular.isDefined(u.typeaheadTemplateUrl) && y.attr("template-url", u.typeaheadTemplateUrl);var w = s.$new();s.$on("$destroy", function () {
        w.$destroy();
      });var k = function k() {
        w.matches = [], w.activeIdx = -1;
      },
          D = function D(e) {
        var t = { $viewValue: e };g(s, !0), n.when($.source(w, t)).then(function (n) {
          if (e === p.$viewValue) {
            if (n.length > 0) {
              w.activeIdx = 0, w.matches.length = 0;for (var a = 0; n.length > a; a++) {
                t[$.itemName] = n[a], w.matches.push({ label: $.viewMapper(w, t), model: n[a] });
              }w.query = e, w.position = r.position(c), w.position.top = w.position.top + c.prop("offsetHeight");
            } else k();g(s, !1);
          }
        }, function () {
          k(), g(s, !1);
        });
      };k(), w.query = void 0;var x;p.$parsers.unshift(function (e) {
        return k(), e && e.length >= d && (f > 0 ? (x && a.cancel(x), x = a(function () {
          D(e);
        }, f)) : D(e)), m ? e : (p.$setValidity("editable", !1), void 0);
      }), p.$formatters.push(function (e) {
        var t,
            n,
            a = {};return v ? (a.$model = e, v(s, a)) : (a[$.itemName] = e, t = $.viewMapper(s, a), a[$.itemName] = void 0, n = $.viewMapper(s, a), t !== n ? t : e);
      }), w.select = function (e) {
        var t,
            n,
            a = {};a[$.itemName] = n = w.matches[e].model, t = $.modelMapper(s, a), b(s, t), p.$setValidity("editable", !0), h(s, { $item: n, $model: t, $label: $.viewMapper(s, a) }), k(), c[0].focus();
      }, c.bind("keydown", function (e) {
        0 !== w.matches.length && -1 !== l.indexOf(e.which) && (e.preventDefault(), 40 === e.which ? (w.activeIdx = (w.activeIdx + 1) % w.matches.length, w.$digest()) : 38 === e.which ? (w.activeIdx = (w.activeIdx ? w.activeIdx : w.matches.length) - 1, w.$digest()) : 13 === e.which || 9 === e.which ? w.$apply(function () {
          w.select(w.activeIdx);
        }) : 27 === e.which && (e.stopPropagation(), k(), w.$digest()));
      });var T = function T(e) {
        c[0] !== e.target && (k(), w.$digest());
      };i.bind("click", T), s.$on("$destroy", function () {
        i.unbind("click", T);
      }), c.after(e(y)(w));
    } };
}]).directive("typeaheadPopup", function () {
  return { restrict: "E", scope: { matches: "=", query: "=", active: "=", position: "=", select: "&" }, replace: !0, templateUrl: "template/typeahead/typeahead-popup.html", link: function link(e, t, n) {
      e.templateUrl = n.templateUrl, e.isOpen = function () {
        return e.matches.length > 0;
      }, e.isActive = function (t) {
        return e.active == t;
      }, e.selectActive = function (t) {
        e.active = t;
      }, e.selectMatch = function (t) {
        e.select({ activeIdx: t });
      };
    } };
}).directive("typeaheadMatch", ["$http", "$templateCache", "$compile", "$parse", function (e, t, n, a) {
  return { restrict: "E", scope: { index: "=", match: "=", query: "=" }, link: function link(i, r, o) {
      var l = a(o.templateUrl)(i.$parent) || "template/typeahead/typeahead-match.html";e.get(l, { cache: t }).success(function (e) {
        r.replaceWith(n(e.trim())(i));
      });
    } };
}]).filter("typeaheadHighlight", function () {
  function e(e) {
    return e.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
  }return function (t, n) {
    return n ? t.replace(RegExp(e(n), "gi"), "<strong>$&</strong>") : t;
  };
}), angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function (e) {
  e.put("template/accordion/accordion-group.html", '<div class="accordion-group">\n  <div class="accordion-heading" ><a class="accordion-toggle" ng-click="isOpen = !isOpen" accordion-transclude="heading">{{heading}}</a></div>\n  <div class="accordion-body" collapse="!isOpen">\n    <div class="accordion-inner" ng-transclude></div>  </div>\n</div>');
}]), angular.module("template/accordion/accordion.html", []).run(["$templateCache", function (e) {
  e.put("template/accordion/accordion.html", '<div class="accordion" ng-transclude></div>');
}]), angular.module("template/alert/alert.html", []).run(["$templateCache", function (e) {
  e.put("template/alert/alert.html", "<div class='alert' ng-class='type && \"alert-\" + type'>\n    <button ng-show='closeable' type='button' class='close' ng-click='close()'>&times;</button>\n    <div ng-transclude></div>\n</div>\n");
}]), angular.module("template/carousel/carousel.html", []).run(["$templateCache", function (e) {
  e.put("template/carousel/carousel.html", '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel">\n    <ol class="carousel-indicators" ng-show="slides().length > 1">\n        <li ng-repeat="slide in slides()" ng-class="{active: isActive(slide)}" ng-click="select(slide)"></li>\n    </ol>\n    <div class="carousel-inner" ng-transclude></div>\n    <a ng-click="prev()" class="carousel-control left" ng-show="slides().length > 1">&lsaquo;</a>\n    <a ng-click="next()" class="carousel-control right" ng-show="slides().length > 1">&rsaquo;</a>\n</div>\n');
}]), angular.module("template/carousel/slide.html", []).run(["$templateCache", function (e) {
  e.put("template/carousel/slide.html", "<div ng-class=\"{\n    'active': leaving || (active && !entering),\n    'prev': (next || active) && direction=='prev',\n    'next': (next || active) && direction=='next',\n    'right': direction=='prev',\n    'left': direction=='next'\n  }\" class=\"item\" ng-transclude></div>\n");
}]), angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function (e) {
  e.put("template/datepicker/datepicker.html", '<table>\n  <thead>\n    <tr class="text-center">\n      <th><button type="button" class="btn pull-left" ng-click="move(-1)"><i class="icon-chevron-left"></i></button></th>\n      <th colspan="{{rows[0].length - 2 + showWeekNumbers}}"><button type="button" class="btn btn-block" ng-click="toggleMode()"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn pull-right" ng-click="move(1)"><i class="icon-chevron-right"></i></button></th>\n    </tr>\n    <tr class="text-center" ng-show="labels.length > 0">\n      <th ng-show="showWeekNumbers">#</th>\n      <th ng-repeat="label in labels">{{label}}</th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr ng-repeat="row in rows">\n      <td ng-show="showWeekNumbers" class="text-center"><em>{{ getWeekNumber(row) }}</em></td>\n      <td ng-repeat="dt in row" class="text-center">\n        <button type="button" style="width:100%;" class="btn" ng-class="{\'btn-info\': dt.selected}" ng-click="select(dt.date)" ng-disabled="dt.disabled"><span ng-class="{muted: dt.secondary}">{{dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
}]), angular.module("template/datepicker/popup.html", []).run(["$templateCache", function (e) {
  e.put("template/datepicker/popup.html", '<ul class="dropdown-menu" ng-style="{display: (isOpen && \'block\') || \'none\', top: position.top+\'px\', left: position.left+\'px\'}" class="dropdown-menu">\n	<li ng-transclude></li>\n	<li class="divider"></li>\n	<li style="padding: 0px 6px;">\n		<span class="btn-group">\n			<button class="btn btn-small btn-inverse" ng-click="today()">' + gettext("Сегодня") + '</button>\n			<button class="btn btn-small btn-info" ng-click="showWeeks = ! showWeeks" ng-class="{active: showWeeks}">' + gettext("Недели") + '</button>\n			<button class="btn btn-small btn-danger" ng-click="clear()">' + gettext("Сброс") + '</button>\n		</span>\n		<button class="btn btn-small btn-success pull-right" ng-click="isOpen = false">' + gettext("Закрыть") + '</button>\n	</li>\n</ul>');
}]), angular.module("template/modal/backdrop.html", []).run(["$templateCache", function (e) {
  e.put("template/modal/backdrop.html", '<div class="modal-backdrop fade" ng-class="{in: animate}" ng-style="{\'z-index\': 1040 + index*10}" ng-click="close($event)"></div>');
}]), angular.module("template/modal/window.html", []).run(["$templateCache", function (e) {
  e.put("template/modal/window.html", '<div class="modal fade {{ windowClass }}" ng-class="{in: animate}" ng-style="{\'z-index\': 1050 + index*10}" ng-transclude></div>');
}]), angular.module("template/pagination/pager.html", []).run(["$templateCache", function (e) {
  e.put("template/pagination/pager.html", '<div class="pager">\n  <ul>\n    <li ng-repeat="page in pages" ng-class="{disabled: page.disabled, previous: page.previous, next: page.next}"><a ng-click="selectPage(page.number)">{{page.text}}</a></li>\n  </ul>\n</div>\n');
}]), angular.module("template/pagination/pagination.html", []).run(["$templateCache", function (e) {
  e.put("template/pagination/pagination.html", '<div class="pagination"><ul>\n  <li ng-repeat="page in pages" ng-class="{active: page.active, disabled: page.disabled}"><a ng-click="selectPage(page.number)">{{page.text}}</a></li>\n  </ul>\n</div>\n');
}]), angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function (e) {
  e.put("template/tooltip/tooltip-html-unsafe-popup.html", '<div class="tooltip {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html-unsafe="content"></div>\n</div>\n');
}]), angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function (e) {
  e.put("template/tooltip/tooltip-popup.html", '<div class="tooltip {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n');
}]), angular.module("template/popover/popover.html", []).run(["$templateCache", function (e) {
  e.put("template/popover/popover.html", '<div class="popover {{placement}}" ng-class="{ in: isOpen(), fade: animation() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-show="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n');
}]), angular.module("template/progressbar/bar.html", []).run(["$templateCache", function (e) {
  e.put("template/progressbar/bar.html", '<div class="bar" ng-class=\'type && "bar-" + type\'></div>');
}]), angular.module("template/progressbar/progress.html", []).run(["$templateCache", function (e) {
  e.put("template/progressbar/progress.html", '<div class="progress"><progressbar ng-repeat="bar in bars" width="bar.to" old="bar.from" animate="bar.animate" type="bar.type"></progressbar></div>');
}]), angular.module("template/rating/rating.html", []).run(["$templateCache", function (e) {
  e.put("template/rating/rating.html", '<span ng-mouseleave="reset()">\n	<i ng-repeat="r in range" ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" ng-class="$index < val && (r.stateOn || \'icon-star\') || (r.stateOff || \'icon-star-empty\')"></i>\n</span>');
}]), angular.module("template/tabs/pane.html", []).run(["$templateCache", function (e) {
  e.put("template/tabs/pane.html", '<div class="tab-pane" ng-class="{active: selected}" ng-show="selected" ng-transclude></div>\n');
}]), angular.module("template/tabs/tab.html", []).run(["$templateCache", function (e) {
  e.put("template/tabs/tab.html", '<li ng-class="{active: active, disabled: disabled}">\n  <a ng-click="select()" tab-heading-transclude>{{heading}}</a>\n</li>\n');
}]), angular.module("template/tabs/tabs.html", []).run(["$templateCache", function (e) {
  e.put("template/tabs/tabs.html", '<div class="tabbable">\n  <ul class="nav nav-tabs">\n    <li ng-repeat="pane in panes" ng-class="{active:pane.selected}">\n      <a ng-click="select(pane)">{{pane.heading}}</a>\n    </li>\n  </ul>\n  <div class="tab-content" ng-transclude></div>\n</div>\n');
}]), angular.module("template/tabs/tabset-titles.html", []).run(["$templateCache", function (e) {
  e.put("template/tabs/tabset-titles.html", "<ul class=\"nav {{type && 'nav-' + type}}\" ng-class=\"{'nav-stacked': vertical}\">\n</ul>\n");
}]), angular.module("template/tabs/tabset.html", []).run(["$templateCache", function (e) {
  e.put("template/tabs/tabset.html", '\n<div class="tabbable" ng-class="{\'tabs-right\': direction == \'right\', \'tabs-left\': direction == \'left\', \'tabs-below\': direction == \'below\'}">\n  <div tabset-titles="tabsAbove"></div>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         tab-content-transclude="tab">\n    </div>\n  </div>\n  <div tabset-titles="!tabsAbove"></div>\n</div>\n');
}]), angular.module("template/timepicker/timepicker.html", []).run(["$templateCache", function (e) {
  e.put("template/timepicker/timepicker.html", '<table class="form-inline">\n	<tr class="text-center">\n		<td><a ng-click="incrementHours()" class="btn btn-link"><i class="icon-chevron-up"></i></a></td>\n		<td>&nbsp;</td>\n		<td><a ng-click="incrementMinutes()" class="btn btn-link"><i class="icon-chevron-up"></i></a></td>\n		<td ng-show="showMeridian"></td>\n	</tr>\n	<tr>\n		<td class="control-group" ng-class="{\'error\': invalidHours}"><input type="text" ng-model="hours" ng-change="updateHours()" class="span1 text-center" ng-mousewheel="incrementHours()" ng-readonly="readonlyInput" maxlength="2" /></td>\n		<td>:</td>\n		<td class="control-group" ng-class="{\'error\': invalidMinutes}"><input type="text" ng-model="minutes" ng-change="updateMinutes()" class="span1 text-center" ng-readonly="readonlyInput" maxlength="2"></td>\n		<td ng-show="showMeridian"><button type="button" ng-click="toggleMeridian()" class="btn text-center">{{meridian}}</button></td>\n	</tr>\n	<tr class="text-center">\n		<td><a ng-click="decrementHours()" class="btn btn-link"><i class="icon-chevron-down"></i></a></td>\n		<td>&nbsp;</td>\n		<td><a ng-click="decrementMinutes()" class="btn btn-link"><i class="icon-chevron-down"></i></a></td>\n		<td ng-show="showMeridian"></td>\n	</tr>\n</table>');
}]), angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function (e) {
  e.put("template/typeahead/typeahead-match.html", '<a tabindex="-1" bind-html-unsafe="match.label | typeaheadHighlight:query"></a>');
}]), angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function (e) {
  e.put("template/typeahead/typeahead-popup.html", '<ul class="typeahead dropdown-menu" ng-style="{display: isOpen()&&\'block\' || \'none\', top: position.top+\'px\', left: position.left+\'px\'}">\n    <li ng-repeat="match in matches" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index)">\n        <typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></typeahead-match>\n    </li>\n</ul>');
}]), angular.module("template/typeahead/typeahead.html", []).run(["$templateCache", function (e) {
  e.put("template/typeahead/typeahead.html", '<ul class="typeahead dropdown-menu" ng-style="{display: isOpen()&&\'block\' || \'none\', top: position.top+\'px\', left: position.left+\'px\'}">\n    <li ng-repeat="match in matches" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)">\n        <a tabindex="-1" ng-click="selectMatch($index)" ng-bind-html-unsafe="match.label | typeaheadHighlight:query"></a>\n    </li>\n</ul>');
}]);

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (a) {
  "use strict";
  function b(a) {
    this.owner = a;
  }function c(a, b) {
    if (Object.create) b.prototype = Object.create(a.prototype);else {
      var c = function c() {};c.prototype = a.prototype, b.prototype = new c();
    }return b.prototype.constructor = b, b;
  }function d(a) {
    var b = this.internal = new e(this);b.loadConfig(a), b.init(), function c(a, b, d) {
      Object.keys(a).forEach(function (e) {
        b[e] = a[e].bind(d), Object.keys(a[e]).length > 0 && c(a[e], b[e], d);
      });
    }(h, this, this);
  }function e(b) {
    var c = this;c.d3 = a.d3 ? a.d3 :  true ? __webpack_require__(86) : void 0, c.api = b, c.config = c.getDefaultConfig(), c.data = {}, c.cache = {}, c.axes = {};
  }function f(a) {
    b.call(this, a);
  }function g(a, b) {
    function c(a, b) {
      a.attr("transform", function (a) {
        return "translate(" + Math.ceil(b(a) + u) + ", 0)";
      });
    }function d(a, b) {
      a.attr("transform", function (a) {
        return "translate(0," + Math.ceil(b(a)) + ")";
      });
    }function e(a) {
      var b = a[0],
          c = a[a.length - 1];return c > b ? [b, c] : [c, b];
    }function f(a) {
      var b,
          c,
          d = [];if (a.ticks) return a.ticks.apply(a, n);for (c = a.domain(), b = Math.ceil(c[0]); b < c[1]; b++) {
        d.push(b);
      }return d.length > 0 && d[0] > 0 && d.unshift(d[0] - (d[1] - d[0])), d;
    }function g() {
      var a,
          c = p.copy();return b.isCategory && (a = p.domain(), c.domain([a[0], a[1] - 1])), c;
    }function h(a) {
      var b = m ? m(a) : a;return "undefined" != typeof b ? b : "";
    }function i(a) {
      if (z) return z;var b = { h: 11.5, w: 5.5 };return a.select("text").text(h).each(function (a) {
        var c = this.getBoundingClientRect(),
            d = h(a),
            e = c.height,
            f = d ? c.width / d.length : void 0;e && f && (b.h = e, b.w = f);
      }).text(""), z = b, b;
    }function j(c) {
      return b.withoutTransition ? c : a.transition(c);
    }function k(m) {
      m.each(function () {
        function m(a, c) {
          function d(a, b) {
            f = void 0;for (var h = 1; h < b.length; h++) {
              if (" " === b.charAt(h) && (f = h), e = b.substr(0, h + 1), g = U.w * e.length, g > c) return d(a.concat(b.substr(0, f ? f : h)), b.slice(f ? f + 1 : h));
            }return a.concat(b);
          }var e,
              f,
              g,
              i = h(a),
              j = [];return "[object Array]" === Object.prototype.toString.call(i) ? i : ((!c || 0 >= c) && (c = X ? 95 : b.isCategory ? Math.ceil(F(G[1]) - F(G[0])) - 12 : 110), d(j, i + ""));
        }function n(a, b) {
          var c = U.h;return 0 === b && (c = "left" === q || "right" === q ? -((V[a.index] - 1) * (U.h / 2) - 3) : ".71em"), c;
        }function v(a) {
          var b = p(a) + (o ? 0 : u);return L[0] < b && b < L[1] ? r : 0;
        }function w(a) {
          return a ? a > 0 ? "start" : "end" : "middle";
        }function x(a) {
          return a ? "rotate(" + a + ")" : "";
        }function y(a) {
          return a ? 8 * Math.sin(Math.PI * (a / 180)) : 0;
        }function z(a) {
          return a ? 11.5 - 2.5 * (a / 15) * (a > 0 ? 1 : -1) : W;
        }var A,
            B,
            C,
            D = k.g = a.select(this),
            E = this.__chart__ || p,
            F = this.__chart__ = g(),
            G = t ? t : f(F),
            H = D.selectAll(".tick").data(G, F),
            I = H.enter().insert("g", ".domain").attr("class", "tick").style("opacity", 1e-6),
            J = H.exit().remove(),
            K = j(H).style("opacity", 1),
            L = p.rangeExtent ? p.rangeExtent() : e(p.range()),
            M = D.selectAll(".domain").data([0]),
            N = (M.enter().append("path").attr("class", "domain"), j(M));I.append("line"), I.append("text");var O = I.select("line"),
            P = K.select("line"),
            Q = I.select("text"),
            R = K.select("text");b.isCategory ? (u = Math.ceil((F(1) - F(0)) / 2), B = o ? 0 : u, C = o ? u : 0) : u = B = 0;var S,
            T,
            U = i(D.select(".tick")),
            V = [],
            W = Math.max(r, 0) + s,
            X = "left" === q || "right" === q;S = H.select("text"), T = S.selectAll("tspan").data(function (a, c) {
          var d = b.tickMultiline ? m(a, b.tickWidth) : [].concat(h(a));return V[c] = d.length, d.map(function (a) {
            return { index: c, splitted: a };
          });
        }), T.enter().append("tspan"), T.exit().remove(), T.text(function (a) {
          return a.splitted;
        });var Y = b.tickTextRotate;switch (q) {case "bottom":
            A = c, O.attr("y2", r), Q.attr("y", W), P.attr("x1", B).attr("x2", B).attr("y2", v), R.attr("x", 0).attr("y", z(Y)).style("text-anchor", w(Y)).attr("transform", x(Y)), T.attr("x", 0).attr("dy", n).attr("dx", y(Y)), N.attr("d", "M" + L[0] + "," + l + "V0H" + L[1] + "V" + l);break;case "top":
            A = c, O.attr("y2", -r), Q.attr("y", -W), P.attr("x2", 0).attr("y2", -r), R.attr("x", 0).attr("y", -W), S.style("text-anchor", "middle"), T.attr("x", 0).attr("dy", "0em"), N.attr("d", "M" + L[0] + "," + -l + "V0H" + L[1] + "V" + -l);break;case "left":
            A = d, O.attr("x2", -r), Q.attr("x", -W), P.attr("x2", -r).attr("y1", C).attr("y2", C), R.attr("x", -W).attr("y", u), S.style("text-anchor", "end"), T.attr("x", -W).attr("dy", n), N.attr("d", "M" + -l + "," + L[0] + "H0V" + L[1] + "H" + -l);break;case "right":
            A = d, O.attr("x2", r), Q.attr("x", W), P.attr("x2", r).attr("y2", 0), R.attr("x", W).attr("y", 0), S.style("text-anchor", "start"), T.attr("x", W).attr("dy", n), N.attr("d", "M" + l + "," + L[0] + "H0V" + L[1] + "H" + l);}if (F.rangeBand) {
          var Z = F,
              $ = Z.rangeBand() / 2;E = F = function F(a) {
            return Z(a) + $;
          };
        } else E.rangeBand ? E = F : J.call(A, F);I.call(A, E), K.call(A, F);
      });
    }var l,
        m,
        n,
        o,
        p = a.scale.linear(),
        q = "bottom",
        r = 6,
        s = 3,
        t = null,
        u = 0,
        v = !0;return b = b || {}, l = b.withOuterTick ? 6 : 0, k.scale = function (a) {
      return arguments.length ? (p = a, k) : p;
    }, k.orient = function (a) {
      return arguments.length ? (q = a in { top: 1, right: 1, bottom: 1, left: 1 } ? a + "" : "bottom", k) : q;
    }, k.tickFormat = function (a) {
      return arguments.length ? (m = a, k) : m;
    }, k.tickCentered = function (a) {
      return arguments.length ? (o = a, k) : o;
    }, k.tickOffset = function () {
      return u;
    }, k.tickInterval = function () {
      var a, c;return b.isCategory ? a = 2 * u : (c = k.g.select("path.domain").node().getTotalLength() - 2 * l, a = c / k.g.selectAll("line").size()), 1 / 0 === a ? 0 : a;
    }, k.ticks = function () {
      return arguments.length ? (n = arguments, k) : n;
    }, k.tickCulling = function (a) {
      return arguments.length ? (v = a, k) : v;
    }, k.tickValues = function (a) {
      if ("function" == typeof a) t = function t() {
        return a(p.domain());
      };else {
        if (!arguments.length) return t;t = a;
      }return k;
    }, k;
  }var h,
      i,
      j,
      k = { version: "0.4.10" };k.generate = function (a) {
    return new d(a);
  }, k.chart = { fn: d.prototype, internal: { fn: e.prototype, axis: { fn: f.prototype } } }, h = k.chart.fn, i = k.chart.internal.fn, j = k.chart.internal.axis.fn, i.init = function () {
    var a = this,
        b = a.config;if (a.initParams(), b.data_url) a.convertUrlToData(b.data_url, b.data_mimeType, b.data_keys, a.initWithData);else if (b.data_json) a.initWithData(a.convertJsonToData(b.data_json, b.data_keys));else if (b.data_rows) a.initWithData(a.convertRowsToData(b.data_rows));else {
      if (!b.data_columns) throw Error("url or json or rows or columns is required.");a.initWithData(a.convertColumnsToData(b.data_columns));
    }
  }, i.initParams = function () {
    var a = this,
        b = a.d3,
        c = a.config;a.clipId = "c3-" + +new Date() + "-clip", a.clipIdForXAxis = a.clipId + "-xaxis", a.clipIdForYAxis = a.clipId + "-yaxis", a.clipIdForGrid = a.clipId + "-grid", a.clipIdForSubchart = a.clipId + "-subchart", a.clipPath = a.getClipPath(a.clipId), a.clipPathForXAxis = a.getClipPath(a.clipIdForXAxis), a.clipPathForYAxis = a.getClipPath(a.clipIdForYAxis), a.clipPathForGrid = a.getClipPath(a.clipIdForGrid), a.clipPathForSubchart = a.getClipPath(a.clipIdForSubchart), a.dragStart = null, a.dragging = !1, a.flowing = !1, a.cancelClick = !1, a.mouseover = !1, a.transiting = !1, a.color = a.generateColor(), a.levelColor = a.generateLevelColor(), a.dataTimeFormat = c.data_xLocaltime ? b.time.format : b.time.format.utc, a.axisTimeFormat = c.axis_x_localtime ? b.time.format : b.time.format.utc, a.defaultAxisTimeFormat = a.axisTimeFormat.multi([[".%L", function (a) {
      return a.getMilliseconds();
    }], [":%S", function (a) {
      return a.getSeconds();
    }], ["%I:%M", function (a) {
      return a.getMinutes();
    }], ["%I %p", function (a) {
      return a.getHours();
    }], ["%-m/%-d", function (a) {
      return a.getDay() && 1 !== a.getDate();
    }], ["%-m/%-d", function (a) {
      return 1 !== a.getDate();
    }], ["%-m/%-d", function (a) {
      return a.getMonth();
    }], ["%Y/%-m/%-d", function () {
      return !0;
    }]]), a.hiddenTargetIds = [], a.hiddenLegendIds = [], a.focusedTargetIds = [], a.defocusedTargetIds = [], a.xOrient = c.axis_rotated ? "left" : "bottom", a.yOrient = c.axis_rotated ? c.axis_y_inner ? "top" : "bottom" : c.axis_y_inner ? "right" : "left", a.y2Orient = c.axis_rotated ? c.axis_y2_inner ? "bottom" : "top" : c.axis_y2_inner ? "left" : "right", a.subXOrient = c.axis_rotated ? "left" : "bottom", a.isLegendRight = "right" === c.legend_position, a.isLegendInset = "inset" === c.legend_position, a.isLegendTop = "top-left" === c.legend_inset_anchor || "top-right" === c.legend_inset_anchor, a.isLegendLeft = "top-left" === c.legend_inset_anchor || "bottom-left" === c.legend_inset_anchor, a.legendStep = 0, a.legendItemWidth = 0, a.legendItemHeight = 0, a.currentMaxTickWidths = { x: 0, y: 0, y2: 0 }, a.rotated_padding_left = 30, a.rotated_padding_right = c.axis_rotated && !c.axis_x_show ? 0 : 30, a.rotated_padding_top = 5, a.withoutFadeIn = {}, a.intervalForObserveInserted = void 0, a.axes.subx = b.selectAll([]);
  }, i.initChartElements = function () {
    this.initBar && this.initBar(), this.initLine && this.initLine(), this.initArc && this.initArc(), this.initGauge && this.initGauge(), this.initText && this.initText();
  }, i.initWithData = function (b) {
    var c,
        d,
        e = this,
        g = e.d3,
        h = e.config,
        i = !0;e.axis = new f(e), e.initPie && e.initPie(), e.initBrush && e.initBrush(), e.initZoom && e.initZoom(), e.selectChart = h.bindto ? "function" == typeof h.bindto.node ? h.bindto : g.select(h.bindto) : g.selectAll([]), e.selectChart.empty() && (e.selectChart = g.select(document.createElement("div")).style("opacity", 0), e.observeInserted(e.selectChart), i = !1), e.selectChart.html("").classed("c3", !0), e.data.xs = {}, e.data.targets = e.convertDataToTargets(b), h.data_filter && (e.data.targets = e.data.targets.filter(h.data_filter)), h.data_hide && e.addHiddenTargetIds(h.data_hide === !0 ? e.mapToIds(e.data.targets) : h.data_hide), h.legend_hide && e.addHiddenLegendIds(h.legend_hide === !0 ? e.mapToIds(e.data.targets) : h.legend_hide), e.hasType("gauge") && (h.legend_show = !1), e.updateSizes(), e.updateScales(), e.x.domain(g.extent(e.getXDomain(e.data.targets))), e.y.domain(e.getYDomain(e.data.targets, "y")), e.y2.domain(e.getYDomain(e.data.targets, "y2")), e.subX.domain(e.x.domain()), e.subY.domain(e.y.domain()), e.subY2.domain(e.y2.domain()), e.orgXDomain = e.x.domain(), e.brush && e.brush.scale(e.subX), h.zoom_enabled && e.zoom.scale(e.x), e.svg = e.selectChart.append("svg").style("overflow", "hidden").on("mouseenter", function () {
      return h.onmouseover.call(e);
    }).on("mouseleave", function () {
      return h.onmouseout.call(e);
    }), c = e.svg.append("defs"), e.clipChart = e.appendClip(c, e.clipId), e.clipXAxis = e.appendClip(c, e.clipIdForXAxis), e.clipYAxis = e.appendClip(c, e.clipIdForYAxis), e.clipGrid = e.appendClip(c, e.clipIdForGrid), e.clipSubchart = e.appendClip(c, e.clipIdForSubchart), e.updateSvgSize(), d = e.main = e.svg.append("g").attr("transform", e.getTranslate("main")), e.initSubchart && e.initSubchart(), e.initTooltip && e.initTooltip(), e.initLegend && e.initLegend(), d.append("text").attr("class", l.text + " " + l.empty).attr("text-anchor", "middle").attr("dominant-baseline", "middle"), e.initRegion(), e.initGrid(), d.append("g").attr("clip-path", e.clipPath).attr("class", l.chart), h.grid_lines_front && e.initGridLines(), e.initEventRect(), e.initChartElements(), d.insert("rect", h.zoom_privileged ? null : "g." + l.regions).attr("class", l.zoomRect).attr("width", e.width).attr("height", e.height).style("opacity", 0).on("dblclick.zoom", null), h.axis_x_extent && e.brush.extent(e.getDefaultExtent()), e.axis.init(), e.updateTargets(e.data.targets), i && (e.updateDimension(), e.config.oninit.call(e), e.redraw({ withTransition: !1, withTransform: !0, withUpdateXDomain: !0, withUpdateOrgXDomain: !0, withTransitionForAxis: !1 })), null == a.onresize && (a.onresize = e.generateResize()), a.onresize.add && (a.onresize.add(function () {
      h.onresize.call(e);
    }), a.onresize.add(function () {
      e.api.flush();
    }), a.onresize.add(function () {
      h.onresized.call(e);
    })), e.api.element = e.selectChart.node();
  }, i.smoothLines = function (a, b) {
    var c = this;"grid" === b && a.each(function () {
      var a = c.d3.select(this),
          b = a.attr("x1"),
          d = a.attr("x2"),
          e = a.attr("y1"),
          f = a.attr("y2");a.attr({ x1: Math.ceil(b), x2: Math.ceil(d), y1: Math.ceil(e), y2: Math.ceil(f) });
    });
  }, i.updateSizes = function () {
    var a = this,
        b = a.config,
        c = a.legend ? a.getLegendHeight() : 0,
        d = a.legend ? a.getLegendWidth() : 0,
        e = a.isLegendRight || a.isLegendInset ? 0 : c,
        f = a.hasArcType(),
        g = b.axis_rotated || f ? 0 : a.getHorizontalAxisHeight("x"),
        h = b.subchart_show && !f ? b.subchart_size_height + g : 0;a.currentWidth = a.getCurrentWidth(), a.currentHeight = a.getCurrentHeight(), a.margin = b.axis_rotated ? { top: a.getHorizontalAxisHeight("y2") + a.getCurrentPaddingTop(), right: f ? 0 : a.getCurrentPaddingRight(), bottom: a.getHorizontalAxisHeight("y") + e + a.getCurrentPaddingBottom(), left: h + (f ? 0 : a.getCurrentPaddingLeft()) } : { top: 4 + a.getCurrentPaddingTop(), right: f ? 0 : a.getCurrentPaddingRight(), bottom: g + h + e + a.getCurrentPaddingBottom(), left: f ? 0 : a.getCurrentPaddingLeft() }, a.margin2 = b.axis_rotated ? { top: a.margin.top, right: 0 / 0, bottom: 20 + e, left: a.rotated_padding_left } : { top: a.currentHeight - h - e, right: 0 / 0, bottom: g + e, left: a.margin.left }, a.margin3 = { top: 0, right: 0 / 0, bottom: 0, left: 0 }, a.updateSizeForLegend && a.updateSizeForLegend(c, d), a.width = a.currentWidth - a.margin.left - a.margin.right, a.height = a.currentHeight - a.margin.top - a.margin.bottom, a.width < 0 && (a.width = 0), a.height < 0 && (a.height = 0), a.width2 = b.axis_rotated ? a.margin.left - a.rotated_padding_left - a.rotated_padding_right : a.width, a.height2 = b.axis_rotated ? a.height : a.currentHeight - a.margin2.top - a.margin2.bottom, a.width2 < 0 && (a.width2 = 0), a.height2 < 0 && (a.height2 = 0), a.arcWidth = a.width - (a.isLegendRight ? d + 10 : 0), a.arcHeight = a.height - (a.isLegendRight ? 0 : 10), a.hasType("gauge") && (a.arcHeight += a.height - a.getGaugeLabelHeight()), a.updateRadius && a.updateRadius(), a.isLegendRight && f && (a.margin3.left = a.arcWidth / 2 + 1.1 * a.radiusExpanded);
  }, i.updateTargets = function (a) {
    var b = this;b.updateTargetsForText(a), b.updateTargetsForBar(a), b.updateTargetsForLine(a), b.hasArcType() && b.updateTargetsForArc && b.updateTargetsForArc(a), b.updateTargetsForSubchart && b.updateTargetsForSubchart(a), b.showTargets();
  }, i.showTargets = function () {
    var a = this;a.svg.selectAll("." + l.target).filter(function (b) {
      return a.isTargetToShow(b.id);
    }).transition().duration(a.config.transition_duration).style("opacity", 1);
  }, i.redraw = function (a, b) {
    var c,
        d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        m,
        n,
        o,
        p,
        q,
        r,
        s,
        t,
        u,
        v,
        x,
        y,
        z,
        A,
        B,
        C,
        D,
        E,
        F,
        G,
        H = this,
        I = H.main,
        J = H.d3,
        K = H.config,
        L = H.getShapeIndices(H.isAreaType),
        M = H.getShapeIndices(H.isBarType),
        N = H.getShapeIndices(H.isLineType),
        O = H.hasArcType(),
        P = H.filterTargetsToShow(H.data.targets),
        Q = H.xv.bind(H);if (a = a || {}, c = w(a, "withY", !0), d = w(a, "withSubchart", !0), e = w(a, "withTransition", !0), h = w(a, "withTransform", !1), i = w(a, "withUpdateXDomain", !1), j = w(a, "withUpdateOrgXDomain", !1), k = w(a, "withTrimXDomain", !0), p = w(a, "withUpdateXAxis", i), m = w(a, "withLegend", !1), n = w(a, "withEventRect", !0), o = w(a, "withDimension", !0), f = w(a, "withTransitionForExit", e), g = w(a, "withTransitionForAxis", e), v = e ? K.transition_duration : 0, x = f ? v : 0, y = g ? v : 0, b = b || H.axis.generateTransitions(y), m && K.legend_show ? H.updateLegend(H.mapToIds(H.data.targets), a, b) : o && H.updateDimension(!0), H.isCategorized() && 0 === P.length && H.x.domain([0, H.axes.x.selectAll(".tick").size()]), P.length ? (H.updateXDomain(P, i, j, k), K.axis_x_tick_values || (B = H.axis.updateXAxisTickValues(P))) : (H.xAxis.tickValues([]), H.subXAxis.tickValues([])), K.zoom_rescale && !a.flow && (E = H.x.orgDomain()), H.y.domain(H.getYDomain(P, "y", E)), H.y2.domain(H.getYDomain(P, "y2", E)), !K.axis_y_tick_values && K.axis_y_tick_count && H.yAxis.tickValues(H.axis.generateTickValues(H.y.domain(), K.axis_y_tick_count)), !K.axis_y2_tick_values && K.axis_y2_tick_count && H.y2Axis.tickValues(H.axis.generateTickValues(H.y2.domain(), K.axis_y2_tick_count)), H.axis.redraw(b, O), H.axis.updateLabels(e), (i || p) && P.length) if (K.axis_x_tick_culling && B) {
      for (C = 1; C < B.length; C++) {
        if (B.length / C < K.axis_x_tick_culling_max) {
          D = C;break;
        }
      }H.svg.selectAll("." + l.axisX + " .tick text").each(function (a) {
        var b = B.indexOf(a);b >= 0 && J.select(this).style("display", b % D ? "none" : "block");
      });
    } else H.svg.selectAll("." + l.axisX + " .tick text").style("display", "block");q = H.generateDrawArea ? H.generateDrawArea(L, !1) : void 0, r = H.generateDrawBar ? H.generateDrawBar(M) : void 0, s = H.generateDrawLine ? H.generateDrawLine(N, !1) : void 0, t = H.generateXYForText(L, M, N, !0), u = H.generateXYForText(L, M, N, !1), c && (H.subY.domain(H.getYDomain(P, "y")), H.subY2.domain(H.getYDomain(P, "y2"))), H.tooltip.style("display", "none"), H.updateXgridFocus(), I.select("text." + l.text + "." + l.empty).attr("x", H.width / 2).attr("y", H.height / 2).text(K.data_empty_label_text).transition().style("opacity", P.length ? 0 : 1), H.updateGrid(v), H.updateRegion(v), H.updateBar(x), H.updateLine(x), H.updateArea(x), H.updateCircle(), H.hasDataLabel() && H.updateText(x), H.redrawArc && H.redrawArc(v, x, h), H.redrawSubchart && H.redrawSubchart(d, b, v, x, L, M, N), I.selectAll("." + l.selectedCircles).filter(H.isBarType.bind(H)).selectAll("circle").remove(), K.interaction_enabled && !a.flow && n && (H.redrawEventRect(), H.updateZoom && H.updateZoom()), H.updateCircleY(), F = (H.config.axis_rotated ? H.circleY : H.circleX).bind(H), G = (H.config.axis_rotated ? H.circleX : H.circleY).bind(H), a.flow && (A = H.generateFlow({ targets: P, flow: a.flow, duration: a.flow.duration, drawBar: r, drawLine: s, drawArea: q, cx: F, cy: G, xv: Q, xForText: t, yForText: u })), (v || A) && H.isTabVisible() ? J.transition().duration(v).each(function () {
      var b = [];[H.redrawBar(r, !0), H.redrawLine(s, !0), H.redrawArea(q, !0), H.redrawCircle(F, G, !0), H.redrawText(t, u, a.flow, !0), H.redrawRegion(!0), H.redrawGrid(!0)].forEach(function (a) {
        a.forEach(function (a) {
          b.push(a);
        });
      }), z = H.generateWait(), b.forEach(function (a) {
        z.add(a);
      });
    }).call(z, function () {
      A && A(), K.onrendered && K.onrendered.call(H);
    }) : (H.redrawBar(r), H.redrawLine(s), H.redrawArea(q), H.redrawCircle(F, G), H.redrawText(t, u, a.flow), H.redrawRegion(), H.redrawGrid(), K.onrendered && K.onrendered.call(H)), H.mapToIds(H.data.targets).forEach(function (a) {
      H.withoutFadeIn[a] = !0;
    });
  }, i.updateAndRedraw = function (a) {
    var b,
        c = this,
        d = c.config;a = a || {}, a.withTransition = w(a, "withTransition", !0), a.withTransform = w(a, "withTransform", !1), a.withLegend = w(a, "withLegend", !1), a.withUpdateXDomain = !0, a.withUpdateOrgXDomain = !0, a.withTransitionForExit = !1, a.withTransitionForTransform = w(a, "withTransitionForTransform", a.withTransition), c.updateSizes(), a.withLegend && d.legend_show || (b = c.axis.generateTransitions(a.withTransitionForAxis ? d.transition_duration : 0), c.updateScales(), c.updateSvgSize(), c.transformAll(a.withTransitionForTransform, b)), c.redraw(a, b);
  }, i.redrawWithoutRescale = function () {
    this.redraw({ withY: !1, withSubchart: !1, withEventRect: !1, withTransitionForAxis: !1 });
  }, i.isTimeSeries = function () {
    return "timeseries" === this.config.axis_x_type;
  }, i.isCategorized = function () {
    return this.config.axis_x_type.indexOf("categor") >= 0;
  }, i.isCustomX = function () {
    var a = this,
        b = a.config;return !a.isTimeSeries() && (b.data_x || v(b.data_xs));
  }, i.isTimeSeriesY = function () {
    return "timeseries" === this.config.axis_y_type;
  }, i.getTranslate = function (a) {
    var b,
        c,
        d = this,
        e = d.config;return "main" === a ? (b = s(d.margin.left), c = s(d.margin.top)) : "context" === a ? (b = s(d.margin2.left), c = s(d.margin2.top)) : "legend" === a ? (b = d.margin3.left, c = d.margin3.top) : "x" === a ? (b = 0, c = e.axis_rotated ? 0 : d.height) : "y" === a ? (b = 0, c = e.axis_rotated ? d.height : 0) : "y2" === a ? (b = e.axis_rotated ? 0 : d.width, c = e.axis_rotated ? 1 : 0) : "subx" === a ? (b = 0, c = e.axis_rotated ? 0 : d.height2) : "arc" === a && (b = d.arcWidth / 2, c = d.arcHeight / 2), "translate(" + b + "," + c + ")";
  }, i.initialOpacity = function (a) {
    return null !== a.value && this.withoutFadeIn[a.id] ? 1 : 0;
  }, i.initialOpacityForCircle = function (a) {
    return null !== a.value && this.withoutFadeIn[a.id] ? this.opacityForCircle(a) : 0;
  }, i.opacityForCircle = function (a) {
    var b = this.config.point_show ? 1 : 0;return m(a.value) ? this.isScatterType(a) ? .5 : b : 0;
  }, i.opacityForText = function () {
    return this.hasDataLabel() ? 1 : 0;
  }, i.xx = function (a) {
    return a ? this.x(a.x) : null;
  }, i.xv = function (a) {
    var b = this,
        c = a.value;return b.isTimeSeries() ? c = b.parseDate(a.value) : b.isCategorized() && "string" == typeof a.value && (c = b.config.axis_x_categories.indexOf(a.value)), Math.ceil(b.x(c));
  }, i.yv = function (a) {
    var b = this,
        c = a.axis && "y2" === a.axis ? b.y2 : b.y;return Math.ceil(c(a.value));
  }, i.subxx = function (a) {
    return a ? this.subX(a.x) : null;
  }, i.transformMain = function (a, b) {
    var c,
        d,
        e,
        f = this;b && b.axisX ? c = b.axisX : (c = f.main.select("." + l.axisX), a && (c = c.transition())), b && b.axisY ? d = b.axisY : (d = f.main.select("." + l.axisY), a && (d = d.transition())), b && b.axisY2 ? e = b.axisY2 : (e = f.main.select("." + l.axisY2), a && (e = e.transition())), (a ? f.main.transition() : f.main).attr("transform", f.getTranslate("main")), c.attr("transform", f.getTranslate("x")), d.attr("transform", f.getTranslate("y")), e.attr("transform", f.getTranslate("y2")), f.main.select("." + l.chartArcs).attr("transform", f.getTranslate("arc"));
  }, i.transformAll = function (a, b) {
    var c = this;c.transformMain(a, b), c.config.subchart_show && c.transformContext(a, b), c.legend && c.transformLegend(a);
  }, i.updateSvgSize = function () {
    var a = this,
        b = a.svg.select(".c3-brush .background");a.svg.attr("width", a.currentWidth).attr("height", a.currentHeight), a.svg.selectAll(["#" + a.clipId, "#" + a.clipIdForGrid]).select("rect").attr("width", a.width).attr("height", a.height), a.svg.select("#" + a.clipIdForXAxis).select("rect").attr("x", a.getXAxisClipX.bind(a)).attr("y", a.getXAxisClipY.bind(a)).attr("width", a.getXAxisClipWidth.bind(a)).attr("height", a.getXAxisClipHeight.bind(a)), a.svg.select("#" + a.clipIdForYAxis).select("rect").attr("x", a.getYAxisClipX.bind(a)).attr("y", a.getYAxisClipY.bind(a)).attr("width", a.getYAxisClipWidth.bind(a)).attr("height", a.getYAxisClipHeight.bind(a)), a.svg.select("#" + a.clipIdForSubchart).select("rect").attr("width", a.width).attr("height", b.size() ? b.attr("height") : 0), a.svg.select("." + l.zoomRect).attr("width", a.width).attr("height", a.height), a.selectChart.style("max-height", a.currentHeight + "px");
  }, i.updateDimension = function (a) {
    var b = this;a || (b.config.axis_rotated ? (b.axes.x.call(b.xAxis), b.axes.subx.call(b.subXAxis)) : (b.axes.y.call(b.yAxis), b.axes.y2.call(b.y2Axis))), b.updateSizes(), b.updateScales(), b.updateSvgSize(), b.transformAll(!1);
  }, i.observeInserted = function (b) {
    var c,
        d = this;return "undefined" == typeof MutationObserver ? void a.console.error("MutationObserver not defined.") : (c = new MutationObserver(function (e) {
      e.forEach(function (e) {
        "childList" === e.type && e.previousSibling && (c.disconnect(), d.intervalForObserveInserted = a.setInterval(function () {
          b.node().parentNode && (a.clearInterval(d.intervalForObserveInserted), d.updateDimension(), d.config.oninit.call(d), d.redraw({ withTransform: !0, withUpdateXDomain: !0, withUpdateOrgXDomain: !0, withTransition: !1, withTransitionForTransform: !1, withLegend: !0 }), b.transition().style("opacity", 1));
        }, 10));
      });
    }), void c.observe(b.node(), { attributes: !0, childList: !0, characterData: !0 }));
  }, i.generateResize = function () {
    function a() {
      b.forEach(function (a) {
        a();
      });
    }var b = [];return a.add = function (a) {
      b.push(a);
    }, a;
  }, i.endall = function (a, b) {
    var c = 0;a.each(function () {
      ++c;
    }).each("end", function () {
      --c || b.apply(this, arguments);
    });
  }, i.generateWait = function () {
    var a = [],
        b = function b(_b, c) {
      var d = setInterval(function () {
        var b = 0;a.forEach(function (a) {
          if (a.empty()) return void (b += 1);try {
            a.transition();
          } catch (c) {
            b += 1;
          }
        }), b === a.length && (clearInterval(d), c && c());
      }, 10);
    };return b.add = function (b) {
      a.push(b);
    }, b;
  }, i.parseDate = function (b) {
    var c,
        d = this;return b instanceof Date ? c = b : "string" == typeof b ? c = d.dataTimeFormat(d.config.data_xFormat).parse(b) : "number" != typeof b && isNaN(b) || (c = new Date(+b)), (!c || isNaN(+c)) && a.console.error("Failed to parse x '" + b + "' to Date object"), c;
  }, i.isTabVisible = function () {
    var a;return "undefined" != typeof document.hidden ? a = "hidden" : "undefined" != typeof document.mozHidden ? a = "mozHidden" : "undefined" != typeof document.msHidden ? a = "msHidden" : "undefined" != typeof document.webkitHidden && (a = "webkitHidden"), document[a] ? !1 : !0;
  }, i.getDefaultConfig = function () {
    var a = { bindto: "#chart", size_width: void 0, size_height: void 0, padding_left: void 0, padding_right: void 0, padding_top: void 0, padding_bottom: void 0, zoom_enabled: !1, zoom_extent: void 0, zoom_privileged: !1, zoom_rescale: !1, zoom_onzoom: function zoom_onzoom() {}, zoom_onzoomstart: function zoom_onzoomstart() {}, zoom_onzoomend: function zoom_onzoomend() {}, interaction_enabled: !0, onmouseover: function onmouseover() {}, onmouseout: function onmouseout() {}, onresize: function onresize() {}, onresized: function onresized() {}, oninit: function oninit() {}, onrendered: function onrendered() {}, transition_duration: 350, data_x: void 0, data_xs: {}, data_xFormat: "%Y-%m-%d", data_xLocaltime: !0, data_xSort: !0, data_idConverter: function data_idConverter(a) {
        return a;
      }, data_names: {}, data_classes: {}, data_groups: [], data_axes: {}, data_type: void 0, data_types: {}, data_labels: {}, data_order: "desc", data_regions: {}, data_color: void 0, data_colors: {}, data_hide: !1, data_filter: void 0, data_selection_enabled: !1, data_selection_grouped: !1, data_selection_isselectable: function data_selection_isselectable() {
        return !0;
      }, data_selection_multiple: !0, data_selection_draggable: !1, data_onclick: function data_onclick() {}, data_onmouseover: function data_onmouseover() {}, data_onmouseout: function data_onmouseout() {}, data_onselected: function data_onselected() {}, data_onunselected: function data_onunselected() {}, data_url: void 0, data_json: void 0, data_rows: void 0, data_columns: void 0, data_mimeType: void 0, data_keys: void 0, data_empty_label_text: "", subchart_show: !1, subchart_size_height: 60, subchart_onbrush: function subchart_onbrush() {}, color_pattern: [], color_threshold: {}, legend_show: !0, legend_hide: !1, legend_position: "bottom", legend_inset_anchor: "top-left", legend_inset_x: 10, legend_inset_y: 0, legend_inset_step: void 0, legend_item_onclick: void 0, legend_item_onmouseover: void 0, legend_item_onmouseout: void 0, legend_equally: !1, axis_rotated: !1, axis_x_show: !0, axis_x_type: "indexed", axis_x_localtime: !0, axis_x_categories: [], axis_x_tick_centered: !1, axis_x_tick_format: void 0, axis_x_tick_culling: {}, axis_x_tick_culling_max: 10, axis_x_tick_count: void 0, axis_x_tick_fit: !0, axis_x_tick_values: null, axis_x_tick_rotate: 0, axis_x_tick_outer: !0, axis_x_tick_multiline: !0, axis_x_tick_width: null, axis_x_max: void 0, axis_x_min: void 0, axis_x_padding: {}, axis_x_height: void 0, axis_x_extent: void 0, axis_x_label: {}, axis_y_show: !0, axis_y_type: void 0, axis_y_max: void 0, axis_y_min: void 0, axis_y_inverted: !1, axis_y_center: void 0, axis_y_inner: void 0, axis_y_label: {}, axis_y_tick_format: void 0, axis_y_tick_outer: !0, axis_y_tick_values: null, axis_y_tick_count: void 0, axis_y_tick_time_value: void 0, axis_y_tick_time_interval: void 0, axis_y_padding: {}, axis_y_default: void 0, axis_y2_show: !1, axis_y2_max: void 0, axis_y2_min: void 0, axis_y2_inverted: !1, axis_y2_center: void 0, axis_y2_inner: void 0, axis_y2_label: {}, axis_y2_tick_format: void 0, axis_y2_tick_outer: !0, axis_y2_tick_values: null, axis_y2_tick_count: void 0, axis_y2_padding: {}, axis_y2_default: void 0, grid_x_show: !1, grid_x_type: "tick", grid_x_lines: [], grid_y_show: !1, grid_y_lines: [], grid_y_ticks: 10, grid_focus_show: !0, grid_lines_front: !0, point_show: !0, point_r: 2.5, point_focus_expand_enabled: !0, point_focus_expand_r: void 0, point_select_r: void 0, line_connectNull: !1, line_step_type: "step", bar_width: void 0, bar_width_ratio: .6, bar_width_max: void 0, bar_zerobased: !0, area_zerobased: !0, pie_label_show: !0, pie_label_format: void 0, pie_label_threshold: .05, pie_expand: !0, gauge_label_show: !0, gauge_label_format: void 0, gauge_expand: !0, gauge_min: 0, gauge_max: 100, gauge_units: void 0, gauge_width: void 0, donut_label_show: !0, donut_label_format: void 0, donut_label_threshold: .05, donut_width: void 0, donut_expand: !0, donut_title: "", regions: [], tooltip_show: !0, tooltip_grouped: !0, tooltip_format_title: void 0, tooltip_format_name: void 0, tooltip_format_value: void 0, tooltip_position: void 0, tooltip_contents: function tooltip_contents(a, b, c, d) {
        return this.getTooltipContent ? this.getTooltipContent(a, b, c, d) : "";
      }, tooltip_init_show: !1, tooltip_init_x: 0, tooltip_init_position: { top: "0px", left: "50px" } };return Object.keys(this.additionalConfig).forEach(function (b) {
      a[b] = this.additionalConfig[b];
    }, this), a;
  }, i.additionalConfig = {}, i.loadConfig = function (a) {
    function b() {
      var a = d.shift();return a && c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && a in c ? (c = c[a], b()) : a ? void 0 : c;
    }var c,
        d,
        e,
        f = this.config;Object.keys(f).forEach(function (g) {
      c = a, d = g.split("_"), e = b(), q(e) && (f[g] = e);
    });
  }, i.getScale = function (a, b, c) {
    return (c ? this.d3.time.scale() : this.d3.scale.linear()).range([a, b]);
  }, i.getX = function (a, b, c, d) {
    var e,
        f = this,
        g = f.getScale(a, b, f.isTimeSeries()),
        h = c ? g.domain(c) : g;f.isCategorized() ? (d = d || function () {
      return 0;
    }, g = function g(a, b) {
      var c = h(a) + d(a);return b ? c : Math.ceil(c);
    }) : g = function g(a, b) {
      var c = h(a);return b ? c : Math.ceil(c);
    };for (e in h) {
      g[e] = h[e];
    }return g.orgDomain = function () {
      return h.domain();
    }, f.isCategorized() && (g.domain = function (a) {
      return arguments.length ? (h.domain(a), g) : (a = this.orgDomain(), [a[0], a[1] + 1]);
    }), g;
  }, i.getY = function (a, b, c) {
    var d = this.getScale(a, b, this.isTimeSeriesY());return c && d.domain(c), d;
  }, i.getYScale = function (a) {
    return "y2" === this.axis.getId(a) ? this.y2 : this.y;
  }, i.getSubYScale = function (a) {
    return "y2" === this.axis.getId(a) ? this.subY2 : this.subY;
  }, i.updateScales = function () {
    var a = this,
        b = a.config,
        c = !a.x;a.xMin = b.axis_rotated ? 1 : 0, a.xMax = b.axis_rotated ? a.height : a.width, a.yMin = b.axis_rotated ? 0 : a.height, a.yMax = b.axis_rotated ? a.width : 1, a.subXMin = a.xMin, a.subXMax = a.xMax, a.subYMin = b.axis_rotated ? 0 : a.height2, a.subYMax = b.axis_rotated ? a.width2 : 1, a.x = a.getX(a.xMin, a.xMax, c ? void 0 : a.x.orgDomain(), function () {
      return a.xAxis.tickOffset();
    }), a.y = a.getY(a.yMin, a.yMax, c ? b.axis_y_default : a.y.domain()), a.y2 = a.getY(a.yMin, a.yMax, c ? b.axis_y2_default : a.y2.domain()), a.subX = a.getX(a.xMin, a.xMax, a.orgXDomain, function (b) {
      return b % 1 ? 0 : a.subXAxis.tickOffset();
    }), a.subY = a.getY(a.subYMin, a.subYMax, c ? b.axis_y_default : a.subY.domain()), a.subY2 = a.getY(a.subYMin, a.subYMax, c ? b.axis_y2_default : a.subY2.domain()), a.xAxisTickFormat = a.axis.getXAxisTickFormat(), a.xAxisTickValues = a.axis.getXAxisTickValues(), a.yAxisTickValues = a.axis.getYAxisTickValues(), a.y2AxisTickValues = a.axis.getY2AxisTickValues(), a.xAxis = a.axis.getXAxis(a.x, a.xOrient, a.xAxisTickFormat, a.xAxisTickValues, b.axis_x_tick_outer), a.subXAxis = a.axis.getXAxis(a.subX, a.subXOrient, a.xAxisTickFormat, a.xAxisTickValues, b.axis_x_tick_outer), a.yAxis = a.axis.getYAxis(a.y, a.yOrient, b.axis_y_tick_format, a.yAxisTickValues, b.axis_y_tick_outer), a.y2Axis = a.axis.getYAxis(a.y2, a.y2Orient, b.axis_y2_tick_format, a.y2AxisTickValues, b.axis_y2_tick_outer), c || (a.brush && a.brush.scale(a.subX), b.zoom_enabled && a.zoom.scale(a.x)), a.updateArc && a.updateArc();
  }, i.getYDomainMin = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h = this,
        i = h.config,
        j = h.mapToIds(a),
        k = h.getValuesAsIdKeyed(a);if (i.data_groups.length > 0) for (g = h.hasNegativeValueInTargets(a), b = 0; b < i.data_groups.length; b++) {
      if (e = i.data_groups[b].filter(function (a) {
        return j.indexOf(a) >= 0;
      }), 0 !== e.length) for (d = e[0], g && k[d] && k[d].forEach(function (a, b) {
        k[d][b] = 0 > a ? a : 0;
      }), c = 1; c < e.length; c++) {
        f = e[c], k[f] && k[f].forEach(function (a, b) {
          h.axis.getId(f) !== h.axis.getId(d) || !k[d] || g && +a > 0 || (k[d][b] += +a);
        });
      }
    }return h.d3.min(Object.keys(k).map(function (a) {
      return h.d3.min(k[a]);
    }));
  }, i.getYDomainMax = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h = this,
        i = h.config,
        j = h.mapToIds(a),
        k = h.getValuesAsIdKeyed(a);if (i.data_groups.length > 0) for (g = h.hasPositiveValueInTargets(a), b = 0; b < i.data_groups.length; b++) {
      if (e = i.data_groups[b].filter(function (a) {
        return j.indexOf(a) >= 0;
      }), 0 !== e.length) for (d = e[0], g && k[d] && k[d].forEach(function (a, b) {
        k[d][b] = a > 0 ? a : 0;
      }), c = 1; c < e.length; c++) {
        f = e[c], k[f] && k[f].forEach(function (a, b) {
          h.axis.getId(f) !== h.axis.getId(d) || !k[d] || g && 0 > +a || (k[d][b] += +a);
        });
      }
    }return h.d3.max(Object.keys(k).map(function (a) {
      return h.d3.max(k[a]);
    }));
  }, i.getYDomain = function (a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        n,
        o,
        p = this,
        q = p.config,
        r = a.filter(function (a) {
      return p.axis.getId(a.id) === b;
    }),
        s = c ? p.filterByXDomain(r, c) : r,
        u = "y2" === b ? q.axis_y2_min : q.axis_y_min,
        w = "y2" === b ? q.axis_y2_max : q.axis_y_max,
        x = p.getYDomainMin(s),
        y = p.getYDomainMax(s),
        z = "y2" === b ? q.axis_y2_center : q.axis_y_center,
        A = p.hasType("bar", s) && q.bar_zerobased || p.hasType("area", s) && q.area_zerobased,
        B = "y2" === b ? q.axis_y2_inverted : q.axis_y_inverted,
        C = p.hasDataLabel() && q.axis_rotated,
        D = p.hasDataLabel() && !q.axis_rotated;return x = m(u) ? u : m(w) ? w > x ? x : w - 10 : x, y = m(w) ? w : m(u) ? y > u ? y : u + 10 : y, 0 === s.length ? "y2" === b ? p.y2.domain() : p.y.domain() : (isNaN(x) && (x = 0), isNaN(y) && (y = x), x === y && (0 > x ? y = 0 : x = 0), n = x >= 0 && y >= 0, o = 0 >= x && 0 >= y, (m(u) && n || m(w) && o) && (A = !1), A && (n && (x = 0), o && (y = 0)), e = Math.abs(y - x), f = g = h = .1 * e, "undefined" != typeof z && (i = Math.max(Math.abs(x), Math.abs(y)), y = z + i, x = z - i), C ? (j = p.getDataLabelLength(x, y, "width"), k = t(p.y.range()), l = [j[0] / k, j[1] / k], g += e * (l[1] / (1 - l[0] - l[1])), h += e * (l[0] / (1 - l[0] - l[1]))) : D && (j = p.getDataLabelLength(x, y, "height"), g += p.axis.convertPixelsToAxisPadding(j[1], e), h += p.axis.convertPixelsToAxisPadding(j[0], e)), "y" === b && v(q.axis_y_padding) && (g = p.axis.getPadding(q.axis_y_padding, "top", g, e), h = p.axis.getPadding(q.axis_y_padding, "bottom", h, e)), "y2" === b && v(q.axis_y2_padding) && (g = p.axis.getPadding(q.axis_y2_padding, "top", g, e), h = p.axis.getPadding(q.axis_y2_padding, "bottom", h, e)), A && (n && (h = x), o && (g = -y)), d = [x - h, y + g], B ? d.reverse() : d);
  }, i.getXDomainMin = function (a) {
    var b = this,
        c = b.config;return q(c.axis_x_min) ? b.isTimeSeries() ? this.parseDate(c.axis_x_min) : c.axis_x_min : b.d3.min(a, function (a) {
      return b.d3.min(a.values, function (a) {
        return a.x;
      });
    });
  }, i.getXDomainMax = function (a) {
    var b = this,
        c = b.config;return q(c.axis_x_max) ? b.isTimeSeries() ? this.parseDate(c.axis_x_max) : c.axis_x_max : b.d3.max(a, function (a) {
      return b.d3.max(a.values, function (a) {
        return a.x;
      });
    });
  }, i.getXDomainPadding = function (a) {
    var b,
        c,
        d,
        e,
        f = this,
        g = f.config,
        h = a[1] - a[0];return f.isCategorized() ? c = 0 : f.hasType("bar") ? (b = f.getMaxDataCount(), c = b > 1 ? h / (b - 1) / 2 : .5) : c = .01 * h, "object" == _typeof(g.axis_x_padding) && v(g.axis_x_padding) ? (d = m(g.axis_x_padding.left) ? g.axis_x_padding.left : c, e = m(g.axis_x_padding.right) ? g.axis_x_padding.right : c) : d = e = "number" == typeof g.axis_x_padding ? g.axis_x_padding : c, { left: d, right: e };
  }, i.getXDomain = function (a) {
    var b = this,
        c = [b.getXDomainMin(a), b.getXDomainMax(a)],
        d = c[0],
        e = c[1],
        f = b.getXDomainPadding(c),
        g = 0,
        h = 0;
    return d - e !== 0 || b.isCategorized() || (b.isTimeSeries() ? (d = new Date(.5 * d.getTime()), e = new Date(1.5 * e.getTime())) : (d = 0 === d ? 1 : .5 * d, e = 0 === e ? -1 : 1.5 * e)), (d || 0 === d) && (g = b.isTimeSeries() ? new Date(d.getTime() - f.left) : d - f.left), (e || 0 === e) && (h = b.isTimeSeries() ? new Date(e.getTime() + f.right) : e + f.right), [g, h];
  }, i.updateXDomain = function (a, b, c, d, e) {
    var f = this,
        g = f.config;return c && (f.x.domain(e ? e : f.d3.extent(f.getXDomain(a))), f.orgXDomain = f.x.domain(), g.zoom_enabled && f.zoom.scale(f.x).updateScaleExtent(), f.subX.domain(f.x.domain()), f.brush && f.brush.scale(f.subX)), b && (f.x.domain(e ? e : !f.brush || f.brush.empty() ? f.orgXDomain : f.brush.extent()), g.zoom_enabled && f.zoom.scale(f.x).updateScaleExtent()), d && f.x.domain(f.trimXDomain(f.x.orgDomain())), f.x.domain();
  }, i.trimXDomain = function (a) {
    var b = this;return a[0] <= b.orgXDomain[0] && (a[1] = +a[1] + (b.orgXDomain[0] - a[0]), a[0] = b.orgXDomain[0]), b.orgXDomain[1] <= a[1] && (a[0] = +a[0] - (a[1] - b.orgXDomain[1]), a[1] = b.orgXDomain[1]), a;
  }, i.isX = function (a) {
    var b = this,
        c = b.config;return c.data_x && a === c.data_x || v(c.data_xs) && x(c.data_xs, a);
  }, i.isNotX = function (a) {
    return !this.isX(a);
  }, i.getXKey = function (a) {
    var b = this,
        c = b.config;return c.data_x ? c.data_x : v(c.data_xs) ? c.data_xs[a] : null;
  }, i.getXValuesOfXKey = function (a, b) {
    var c,
        d = this,
        e = b && v(b) ? d.mapToIds(b) : [];return e.forEach(function (b) {
      d.getXKey(b) === a && (c = d.data.xs[b]);
    }), c;
  }, i.getIndexByX = function (a) {
    var b = this,
        c = b.filterByX(b.data.targets, a);return c.length ? c[0].index : null;
  }, i.getXValue = function (a, b) {
    var c = this;return a in c.data.xs && c.data.xs[a] && m(c.data.xs[a][b]) ? c.data.xs[a][b] : b;
  }, i.getOtherTargetXs = function () {
    var a = this,
        b = Object.keys(a.data.xs);return b.length ? a.data.xs[b[0]] : null;
  }, i.getOtherTargetX = function (a) {
    var b = this.getOtherTargetXs();return b && a < b.length ? b[a] : null;
  }, i.addXs = function (a) {
    var b = this;Object.keys(a).forEach(function (c) {
      b.config.data_xs[c] = a[c];
    });
  }, i.hasMultipleX = function (a) {
    return this.d3.set(Object.keys(a).map(function (b) {
      return a[b];
    })).size() > 1;
  }, i.isMultipleX = function () {
    return v(this.config.data_xs) || !this.config.data_xSort || this.hasType("scatter");
  }, i.addName = function (a) {
    var b,
        c = this;return a && (b = c.config.data_names[a.id], a.name = b ? b : a.id), a;
  }, i.getValueOnIndex = function (a, b) {
    var c = a.filter(function (a) {
      return a.index === b;
    });return c.length ? c[0] : null;
  }, i.updateTargetX = function (a, b) {
    var c = this;a.forEach(function (a) {
      a.values.forEach(function (d, e) {
        d.x = c.generateTargetX(b[e], a.id, e);
      }), c.data.xs[a.id] = b;
    });
  }, i.updateTargetXs = function (a, b) {
    var c = this;a.forEach(function (a) {
      b[a.id] && c.updateTargetX([a], b[a.id]);
    });
  }, i.generateTargetX = function (a, b, c) {
    var d,
        e = this;return d = e.isTimeSeries() ? e.parseDate(a ? a : e.getXValue(b, c)) : e.isCustomX() && !e.isCategorized() ? m(a) ? +a : e.getXValue(b, c) : c;
  }, i.cloneTarget = function (a) {
    return { id: a.id, id_org: a.id_org, values: a.values.map(function (a) {
        return { x: a.x, value: a.value, id: a.id };
      }) };
  }, i.updateXs = function () {
    var a = this;a.data.targets.length && (a.xs = [], a.data.targets[0].values.forEach(function (b) {
      a.xs[b.index] = b.x;
    }));
  }, i.getPrevX = function (a) {
    var b = this.xs[a - 1];return "undefined" != typeof b ? b : null;
  }, i.getNextX = function (a) {
    var b = this.xs[a + 1];return "undefined" != typeof b ? b : null;
  }, i.getMaxDataCount = function () {
    var a = this;return a.d3.max(a.data.targets, function (a) {
      return a.values.length;
    });
  }, i.getMaxDataCountTarget = function (a) {
    var b,
        c = a.length,
        d = 0;return c > 1 ? a.forEach(function (a) {
      a.values.length > d && (b = a, d = a.values.length);
    }) : b = c ? a[0] : null, b;
  }, i.getEdgeX = function (a) {
    var b = this;return a.length ? [b.d3.min(a, function (a) {
      return a.values[0].x;
    }), b.d3.max(a, function (a) {
      return a.values[a.values.length - 1].x;
    })] : [0, 0];
  }, i.mapToIds = function (a) {
    return a.map(function (a) {
      return a.id;
    });
  }, i.mapToTargetIds = function (a) {
    var b = this;return a ? o(a) ? [a] : a : b.mapToIds(b.data.targets);
  }, i.hasTarget = function (a, b) {
    var c,
        d = this.mapToIds(a);for (c = 0; c < d.length; c++) {
      if (d[c] === b) return !0;
    }return !1;
  }, i.isTargetToShow = function (a) {
    return this.hiddenTargetIds.indexOf(a) < 0;
  }, i.isLegendToShow = function (a) {
    return this.hiddenLegendIds.indexOf(a) < 0;
  }, i.filterTargetsToShow = function (a) {
    var b = this;return a.filter(function (a) {
      return b.isTargetToShow(a.id);
    });
  }, i.mapTargetsToUniqueXs = function (a) {
    var b = this,
        c = b.d3.set(b.d3.merge(a.map(function (a) {
      return a.values.map(function (a) {
        return +a.x;
      });
    }))).values();return c.map(b.isTimeSeries() ? function (a) {
      return new Date(+a);
    } : function (a) {
      return +a;
    });
  }, i.addHiddenTargetIds = function (a) {
    this.hiddenTargetIds = this.hiddenTargetIds.concat(a);
  }, i.removeHiddenTargetIds = function (a) {
    this.hiddenTargetIds = this.hiddenTargetIds.filter(function (b) {
      return a.indexOf(b) < 0;
    });
  }, i.addHiddenLegendIds = function (a) {
    this.hiddenLegendIds = this.hiddenLegendIds.concat(a);
  }, i.removeHiddenLegendIds = function (a) {
    this.hiddenLegendIds = this.hiddenLegendIds.filter(function (b) {
      return a.indexOf(b) < 0;
    });
  }, i.getValuesAsIdKeyed = function (a) {
    var b = {};return a.forEach(function (a) {
      b[a.id] = [], a.values.forEach(function (c) {
        b[a.id].push(c.value);
      });
    }), b;
  }, i.checkValueInTargets = function (a, b) {
    var c,
        d,
        e,
        f = Object.keys(a);for (c = 0; c < f.length; c++) {
      for (e = a[f[c]].values, d = 0; d < e.length; d++) {
        if (b(e[d].value)) return !0;
      }
    }return !1;
  }, i.hasNegativeValueInTargets = function (a) {
    return this.checkValueInTargets(a, function (a) {
      return 0 > a;
    });
  }, i.hasPositiveValueInTargets = function (a) {
    return this.checkValueInTargets(a, function (a) {
      return a > 0;
    });
  }, i.isOrderDesc = function () {
    var a = this.config;return "string" == typeof a.data_order && "desc" === a.data_order.toLowerCase();
  }, i.isOrderAsc = function () {
    var a = this.config;return "string" == typeof a.data_order && "asc" === a.data_order.toLowerCase();
  }, i.orderTargets = function (a) {
    var b = this,
        c = b.config,
        d = b.isOrderAsc(),
        e = b.isOrderDesc();return d || e ? a.sort(function (a, b) {
      var c = function c(a, b) {
        return a + Math.abs(b.value);
      },
          e = a.values.reduce(c, 0),
          f = b.values.reduce(c, 0);return d ? f - e : e - f;
    }) : n(c.data_order) && a.sort(c.data_order), a;
  }, i.filterByX = function (a, b) {
    return this.d3.merge(a.map(function (a) {
      return a.values;
    })).filter(function (a) {
      return a.x - b === 0;
    });
  }, i.filterRemoveNull = function (a) {
    return a.filter(function (a) {
      return m(a.value);
    });
  }, i.filterByXDomain = function (a, b) {
    return a.map(function (a) {
      return { id: a.id, id_org: a.id_org, values: a.values.filter(function (a) {
          return b[0] <= a.x && a.x <= b[1];
        }) };
    });
  }, i.hasDataLabel = function () {
    var a = this.config;return "boolean" == typeof a.data_labels && a.data_labels ? !0 : "object" == _typeof(a.data_labels) && v(a.data_labels) ? !0 : !1;
  }, i.getDataLabelLength = function (a, b, c) {
    var d = this,
        e = [0, 0],
        f = 1.3;return d.selectChart.select("svg").selectAll(".dummy").data([a, b]).enter().append("text").text(function (a) {
      return d.dataLabelFormat(a.id)(a);
    }).each(function (a, b) {
      e[b] = this.getBoundingClientRect()[c] * f;
    }).remove(), e;
  }, i.isNoneArc = function (a) {
    return this.hasTarget(this.data.targets, a.id);
  }, i.isArc = function (a) {
    return "data" in a && this.hasTarget(this.data.targets, a.data.id);
  }, i.findSameXOfValues = function (a, b) {
    var c,
        d = a[b].x,
        e = [];for (c = b - 1; c >= 0 && d === a[c].x; c--) {
      e.push(a[c]);
    }for (c = b; c < a.length && d === a[c].x; c++) {
      e.push(a[c]);
    }return e;
  }, i.findClosestFromTargets = function (a, b) {
    var c,
        d = this;return c = a.map(function (a) {
      return d.findClosest(a.values, b);
    }), d.findClosest(c, b);
  }, i.findClosest = function (a, b) {
    var c,
        d = this,
        e = 100;return a.filter(function (a) {
      return a && d.isBarType(a.id);
    }).forEach(function (a) {
      var b = d.main.select("." + l.bars + d.getTargetSelectorSuffix(a.id) + " ." + l.bar + "-" + a.index).node();!c && d.isWithinBar(b) && (c = a);
    }), a.filter(function (a) {
      return a && !d.isBarType(a.id);
    }).forEach(function (a) {
      var f = d.dist(a, b);e > f && (e = f, c = a);
    }), c;
  }, i.dist = function (a, b) {
    var c = this,
        d = c.config,
        e = d.axis_rotated ? 1 : 0,
        f = d.axis_rotated ? 0 : 1,
        g = c.circleY(a, a.index),
        h = c.x(a.x);return Math.pow(h - b[e], 2) + Math.pow(g - b[f], 2);
  }, i.convertValuesToStep = function (a) {
    var b,
        c = [].concat(a);if (!this.isCategorized()) return a;for (b = a.length + 1; b > 0; b--) {
      c[b] = c[b - 1];
    }return c[0] = { x: c[0].x - 1, value: c[0].value, id: c[0].id }, c[a.length + 1] = { x: c[a.length].x + 1, value: c[a.length].value, id: c[a.length].id }, c;
  }, i.updateDataAttributes = function (a, b) {
    var c = this,
        d = c.config,
        e = d["data_" + a];return "undefined" == typeof b ? e : (Object.keys(b).forEach(function (a) {
      e[a] = b[a];
    }), c.redraw({ withLegend: !0 }), e);
  }, i.convertUrlToData = function (a, b, c, d) {
    var e = this,
        f = b ? b : "csv";e.d3.xhr(a, function (a, b) {
      var g;if (!b) throw new Error(a.responseURL + " " + a.status + " (" + a.statusText + ")");g = "json" === f ? e.convertJsonToData(JSON.parse(b.response), c) : "tsv" === f ? e.convertTsvToData(b.response) : e.convertCsvToData(b.response), d.call(e, g);
    });
  }, i.convertXsvToData = function (a, b) {
    var c,
        d = b.parseRows(a);return 1 === d.length ? (c = [{}], d[0].forEach(function (a) {
      c[0][a] = null;
    })) : c = b.parse(a), c;
  }, i.convertCsvToData = function (a) {
    return this.convertXsvToData(a, this.d3.csv);
  }, i.convertTsvToData = function (a) {
    return this.convertXsvToData(a, this.d3.tsv);
  }, i.convertJsonToData = function (a, b) {
    var c,
        d,
        e = this,
        f = [];return b ? (b.x ? (c = b.value.concat(b.x), e.config.data_x = b.x) : c = b.value, f.push(c), a.forEach(function (a) {
      var b = [];c.forEach(function (c) {
        var d = p(a[c]) ? null : a[c];b.push(d);
      }), f.push(b);
    }), d = e.convertRowsToData(f)) : (Object.keys(a).forEach(function (b) {
      f.push([b].concat(a[b]));
    }), d = e.convertColumnsToData(f)), d;
  }, i.convertRowsToData = function (a) {
    var b,
        c,
        d = a[0],
        e = {},
        f = [];for (b = 1; b < a.length; b++) {
      for (e = {}, c = 0; c < a[b].length; c++) {
        if (p(a[b][c])) throw new Error("Source data is missing a component at (" + b + "," + c + ")!");e[d[c]] = a[b][c];
      }f.push(e);
    }return f;
  }, i.convertColumnsToData = function (a) {
    var b,
        c,
        d,
        e = [];for (b = 0; b < a.length; b++) {
      for (d = a[b][0], c = 1; c < a[b].length; c++) {
        if (p(e[c - 1]) && (e[c - 1] = {}), p(a[b][c])) throw new Error("Source data is missing a component at (" + b + "," + c + ")!");e[c - 1][d] = a[b][c];
      }
    }return e;
  }, i.convertDataToTargets = function (a, b) {
    var c,
        d = this,
        e = d.config,
        f = d.d3.keys(a[0]).filter(d.isNotX, d),
        g = d.d3.keys(a[0]).filter(d.isX, d);return f.forEach(function (c) {
      var f = d.getXKey(c);d.isCustomX() || d.isTimeSeries() ? g.indexOf(f) >= 0 ? d.data.xs[c] = (b && d.data.xs[c] ? d.data.xs[c] : []).concat(a.map(function (a) {
        return a[f];
      }).filter(m).map(function (a, b) {
        return d.generateTargetX(a, c, b);
      })) : e.data_x ? d.data.xs[c] = d.getOtherTargetXs() : v(e.data_xs) && (d.data.xs[c] = d.getXValuesOfXKey(f, d.data.targets)) : d.data.xs[c] = a.map(function (a, b) {
        return b;
      });
    }), f.forEach(function (a) {
      if (!d.data.xs[a]) throw new Error('x is not defined for id = "' + a + '".');
    }), c = f.map(function (b, c) {
      var f = e.data_idConverter(b);return { id: f, id_org: b, values: a.map(function (a, g) {
          var h = d.getXKey(b),
              i = a[h],
              j = d.generateTargetX(i, b, g);return d.isCustomX() && d.isCategorized() && 0 === c && i && (0 === g && (e.axis_x_categories = []), e.axis_x_categories.push(i)), (p(a[b]) || d.data.xs[b].length <= g) && (j = void 0), { x: j, value: null === a[b] || isNaN(a[b]) ? null : +a[b], id: f };
        }).filter(function (a) {
          return q(a.x);
        }) };
    }), c.forEach(function (a) {
      var b;e.data_xSort && (a.values = a.values.sort(function (a, b) {
        var c = a.x || 0 === a.x ? a.x : 1 / 0,
            d = b.x || 0 === b.x ? b.x : 1 / 0;return c - d;
      })), b = 0, a.values.forEach(function (a) {
        a.index = b++;
      }), d.data.xs[a.id].sort(function (a, b) {
        return a - b;
      });
    }), e.data_type && d.setTargetType(d.mapToIds(c).filter(function (a) {
      return !(a in e.data_types);
    }), e.data_type), c.forEach(function (a) {
      d.addCache(a.id_org, a);
    }), c;
  }, i.load = function (a, b) {
    var c = this;a && (b.filter && (a = a.filter(b.filter)), (b.type || b.types) && a.forEach(function (a) {
      var d = b.types && b.types[a.id] ? b.types[a.id] : b.type;c.setTargetType(a.id, d);
    }), c.data.targets.forEach(function (b) {
      for (var c = 0; c < a.length; c++) {
        if (b.id === a[c].id) {
          b.values = a[c].values, a.splice(c, 1);break;
        }
      }
    }), c.data.targets = c.data.targets.concat(a)), c.updateTargets(c.data.targets), c.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0, withLegend: !0 }), b.done && b.done();
  }, i.loadFromArgs = function (a) {
    var b = this;a.data ? b.load(b.convertDataToTargets(a.data), a) : a.url ? b.convertUrlToData(a.url, a.mimeType, a.keys, function (c) {
      b.load(b.convertDataToTargets(c), a);
    }) : a.json ? b.load(b.convertDataToTargets(b.convertJsonToData(a.json, a.keys)), a) : a.rows ? b.load(b.convertDataToTargets(b.convertRowsToData(a.rows)), a) : a.columns ? b.load(b.convertDataToTargets(b.convertColumnsToData(a.columns)), a) : b.load(null, a);
  }, i.unload = function (a, b) {
    var c = this;return b || (b = function b() {}), a = a.filter(function (a) {
      return c.hasTarget(c.data.targets, a);
    }), a && 0 !== a.length ? (c.svg.selectAll(a.map(function (a) {
      return c.selectorTarget(a);
    })).transition().style("opacity", 0).remove().call(c.endall, b), void a.forEach(function (a) {
      c.withoutFadeIn[a] = !1, c.legend && c.legend.selectAll("." + l.legendItem + c.getTargetSelectorSuffix(a)).remove(), c.data.targets = c.data.targets.filter(function (b) {
        return b.id !== a;
      });
    })) : void b();
  }, i.categoryName = function (a) {
    var b = this.config;return a < b.axis_x_categories.length ? b.axis_x_categories[a] : a;
  }, i.initEventRect = function () {
    var a = this;a.main.select("." + l.chart).append("g").attr("class", l.eventRects).style("fill-opacity", 0);
  }, i.redrawEventRect = function () {
    var a,
        b,
        c = this,
        d = c.config,
        e = c.isMultipleX(),
        f = c.main.select("." + l.eventRects).style("cursor", d.zoom_enabled ? d.axis_rotated ? "ns-resize" : "ew-resize" : null).classed(l.eventRectsMultiple, e).classed(l.eventRectsSingle, !e);f.selectAll("." + l.eventRect).remove(), c.eventRect = f.selectAll("." + l.eventRect), e ? (a = c.eventRect.data([0]), c.generateEventRectsForMultipleXs(a.enter()), c.updateEventRect(a)) : (b = c.getMaxDataCountTarget(c.data.targets), f.datum(b ? b.values : []), c.eventRect = f.selectAll("." + l.eventRect), a = c.eventRect.data(function (a) {
      return a;
    }), c.generateEventRectsForSingleX(a.enter()), c.updateEventRect(a), a.exit().remove());
  }, i.updateEventRect = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h = this,
        i = h.config;a = a || h.eventRect.data(function (a) {
      return a;
    }), h.isMultipleX() ? (b = 0, c = 0, d = h.width, e = h.height) : (!h.isCustomX() && !h.isTimeSeries() || h.isCategorized() ? (f = h.getEventRectWidth(), g = function g(a) {
      return h.x(a.x) - f / 2;
    }) : (h.updateXs(), f = function f(a) {
      var b = h.getPrevX(a.index),
          c = h.getNextX(a.index);return null === b && null === c ? i.axis_rotated ? h.height : h.width : (null === b && (b = h.x.domain()[0]), null === c && (c = h.x.domain()[1]), Math.max(0, (h.x(c) - h.x(b)) / 2));
    }, g = function g(a) {
      var b = h.getPrevX(a.index),
          c = h.getNextX(a.index),
          d = h.data.xs[a.id][a.index];return null === b && null === c ? 0 : (null === b && (b = h.x.domain()[0]), (h.x(d) + h.x(b)) / 2);
    }), b = i.axis_rotated ? 0 : g, c = i.axis_rotated ? g : 0, d = i.axis_rotated ? h.width : f, e = i.axis_rotated ? f : h.height), a.attr("class", h.classEvent.bind(h)).attr("x", b).attr("y", c).attr("width", d).attr("height", e);
  }, i.generateEventRectsForSingleX = function (a) {
    var b = this,
        c = b.d3,
        d = b.config;a.append("rect").attr("class", b.classEvent.bind(b)).style("cursor", d.data_selection_enabled && d.data_selection_grouped ? "pointer" : null).on("mouseover", function (a) {
      var c = a.index;b.dragging || b.flowing || b.hasArcType() || (d.point_focus_expand_enabled && b.expandCircles(c, null, !0), b.expandBars(c, null, !0), b.main.selectAll("." + l.shape + "-" + c).each(function (a) {
        d.data_onmouseover.call(b.api, a);
      }));
    }).on("mouseout", function (a) {
      var c = a.index;b.config && (b.hasArcType() || (b.hideXGridFocus(), b.hideTooltip(), b.unexpandCircles(), b.unexpandBars(), b.main.selectAll("." + l.shape + "-" + c).each(function (a) {
        d.data_onmouseout.call(b.api, a);
      })));
    }).on("mousemove", function (a) {
      var e,
          f = a.index,
          g = b.svg.select("." + l.eventRect + "-" + f);b.dragging || b.flowing || b.hasArcType() || (b.isStepType(a) && "step-after" === b.config.line_step_type && c.mouse(this)[0] < b.x(b.getXValue(a.id, f)) && (f -= 1), e = b.filterTargetsToShow(b.data.targets).map(function (a) {
        return b.addName(b.getValueOnIndex(a.values, f));
      }), d.tooltip_grouped && (b.showTooltip(e, this), b.showXGridFocus(e)), (!d.tooltip_grouped || d.data_selection_enabled && !d.data_selection_grouped) && b.main.selectAll("." + l.shape + "-" + f).each(function () {
        c.select(this).classed(l.EXPANDED, !0), d.data_selection_enabled && g.style("cursor", d.data_selection_grouped ? "pointer" : null), d.tooltip_grouped || (b.hideXGridFocus(), b.hideTooltip(), d.data_selection_grouped || (b.unexpandCircles(f), b.unexpandBars(f)));
      }).filter(function (a) {
        return b.isWithinShape(this, a);
      }).each(function (a) {
        d.data_selection_enabled && (d.data_selection_grouped || d.data_selection_isselectable(a)) && g.style("cursor", "pointer"), d.tooltip_grouped || (b.showTooltip([a], this), b.showXGridFocus([a]), d.point_focus_expand_enabled && b.expandCircles(f, a.id, !0), b.expandBars(f, a.id, !0));
      }));
    }).on("click", function (a) {
      var e = a.index;if (!b.hasArcType() && b.toggleShape) {
        if (b.cancelClick) return void (b.cancelClick = !1);b.isStepType(a) && "step-after" === d.line_step_type && c.mouse(this)[0] < b.x(b.getXValue(a.id, e)) && (e -= 1), b.main.selectAll("." + l.shape + "-" + e).each(function (a) {
          (d.data_selection_grouped || b.isWithinShape(this, a)) && (b.toggleShape(this, a, e), b.config.data_onclick.call(b.api, a, this));
        });
      }
    }).call(d.data_selection_draggable && b.drag ? c.behavior.drag().origin(Object).on("drag", function () {
      b.drag(c.mouse(this));
    }).on("dragstart", function () {
      b.dragstart(c.mouse(this));
    }).on("dragend", function () {
      b.dragend();
    }) : function () {});
  }, i.generateEventRectsForMultipleXs = function (a) {
    function b() {
      c.svg.select("." + l.eventRect).style("cursor", null), c.hideXGridFocus(), c.hideTooltip(), c.unexpandCircles(), c.unexpandBars();
    }var c = this,
        d = c.d3,
        e = c.config;a.append("rect").attr("x", 0).attr("y", 0).attr("width", c.width).attr("height", c.height).attr("class", l.eventRect).on("mouseout", function () {
      c.config && (c.hasArcType() || b());
    }).on("mousemove", function () {
      var a,
          f,
          g,
          h,
          i = c.filterTargetsToShow(c.data.targets);if (!c.dragging && !c.hasArcType(i)) {
        if (a = d.mouse(this), f = c.findClosestFromTargets(i, a), !c.mouseover || f && f.id === c.mouseover.id || (e.data_onmouseout.call(c.api, c.mouseover), c.mouseover = void 0), !f) return void b();g = c.isScatterType(f) || !e.tooltip_grouped ? [f] : c.filterByX(i, f.x), h = g.map(function (a) {
          return c.addName(a);
        }), c.showTooltip(h, this), e.point_focus_expand_enabled && c.expandCircles(f.index, f.id, !0), c.expandBars(f.index, f.id, !0), c.showXGridFocus(h), (c.isBarType(f.id) || c.dist(f, a) < 100) && (c.svg.select("." + l.eventRect).style("cursor", "pointer"), c.mouseover || (e.data_onmouseover.call(c.api, f), c.mouseover = f));
      }
    }).on("click", function () {
      var a,
          b,
          f = c.filterTargetsToShow(c.data.targets);c.hasArcType(f) || (a = d.mouse(this), b = c.findClosestFromTargets(f, a), b && (c.isBarType(b.id) || c.dist(b, a) < 100) && c.main.selectAll("." + l.shapes + c.getTargetSelectorSuffix(b.id)).selectAll("." + l.shape + "-" + b.index).each(function () {
        (e.data_selection_grouped || c.isWithinShape(this, b)) && (c.toggleShape(this, b, b.index), c.config.data_onclick.call(c.api, b, this));
      }));
    }).call(e.data_selection_draggable && c.drag ? d.behavior.drag().origin(Object).on("drag", function () {
      c.drag(d.mouse(this));
    }).on("dragstart", function () {
      c.dragstart(d.mouse(this));
    }).on("dragend", function () {
      c.dragend();
    }) : function () {});
  }, i.dispatchEvent = function (b, c, d) {
    var e = this,
        f = "." + l.eventRect + (e.isMultipleX() ? "" : "-" + c),
        g = e.main.select(f).node(),
        h = g.getBoundingClientRect(),
        i = h.left + (d ? d[0] : 0),
        j = h.top + (d ? d[1] : 0),
        k = document.createEvent("MouseEvents");k.initMouseEvent(b, !0, !0, a, 0, i, j, i, j, !1, !1, !1, !1, 0, null), g.dispatchEvent(k);
  }, i.getCurrentWidth = function () {
    var a = this,
        b = a.config;return b.size_width ? b.size_width : a.getParentWidth();
  }, i.getCurrentHeight = function () {
    var a = this,
        b = a.config,
        c = b.size_height ? b.size_height : a.getParentHeight();return c > 0 ? c : 320 / (a.hasType("gauge") ? 2 : 1);
  }, i.getCurrentPaddingTop = function () {
    var a = this.config;return m(a.padding_top) ? a.padding_top : 0;
  }, i.getCurrentPaddingBottom = function () {
    var a = this.config;return m(a.padding_bottom) ? a.padding_bottom : 0;
  }, i.getCurrentPaddingLeft = function (a) {
    var b = this,
        c = b.config;return m(c.padding_left) ? c.padding_left : c.axis_rotated ? c.axis_x_show ? Math.max(r(b.getAxisWidthByAxisId("x", a)), 40) : 1 : !c.axis_y_show || c.axis_y_inner ? b.axis.getYAxisLabelPosition().isOuter ? 30 : 1 : r(b.getAxisWidthByAxisId("y", a));
  }, i.getCurrentPaddingRight = function () {
    var a = this,
        b = a.config,
        c = 10,
        d = a.isLegendRight ? a.getLegendWidth() + 20 : 0;return m(b.padding_right) ? b.padding_right + 1 : b.axis_rotated ? c + d : !b.axis_y2_show || b.axis_y2_inner ? 2 + d + (a.axis.getY2AxisLabelPosition().isOuter ? 20 : 0) : r(a.getAxisWidthByAxisId("y2")) + d;
  }, i.getParentRectValue = function (a) {
    for (var b, c = this.selectChart.node(); c && "BODY" !== c.tagName;) {
      try {
        b = c.getBoundingClientRect()[a];
      } catch (d) {
        "width" === a && (b = c.offsetWidth);
      }if (b) break;c = c.parentNode;
    }return b;
  }, i.getParentWidth = function () {
    return this.getParentRectValue("width");
  }, i.getParentHeight = function () {
    var a = this.selectChart.style("height");return a.indexOf("px") > 0 ? +a.replace("px", "") : 0;
  }, i.getSvgLeft = function (a) {
    var b = this,
        c = b.config,
        d = c.axis_rotated || !c.axis_rotated && !c.axis_y_inner,
        e = c.axis_rotated ? l.axisX : l.axisY,
        f = b.main.select("." + e).node(),
        g = f && d ? f.getBoundingClientRect() : { right: 0 },
        h = b.selectChart.node().getBoundingClientRect(),
        i = b.hasArcType(),
        j = g.right - h.left - (i ? 0 : b.getCurrentPaddingLeft(a));return j > 0 ? j : 0;
  }, i.getAxisWidthByAxisId = function (a, b) {
    var c = this,
        d = c.axis.getLabelPositionById(a);return c.axis.getMaxTickWidth(a, b) + (d.isInner ? 20 : 40);
  }, i.getHorizontalAxisHeight = function (a) {
    var b = this,
        c = b.config,
        d = 30;return "x" !== a || c.axis_x_show ? "x" === a && c.axis_x_height ? c.axis_x_height : "y" !== a || c.axis_y_show ? "y2" !== a || c.axis_y2_show ? ("x" === a && !c.axis_rotated && c.axis_x_tick_rotate && (d = 30 + b.axis.getMaxTickWidth(a) * Math.cos(Math.PI * (90 - c.axis_x_tick_rotate) / 180)), d + (b.axis.getLabelPositionById(a).isInner ? 0 : 10) + ("y2" === a ? -10 : 0)) : b.rotated_padding_top : !c.legend_show || b.isLegendRight || b.isLegendInset ? 1 : 10 : 8;
  }, i.getEventRectWidth = function () {
    return Math.max(0, this.xAxis.tickInterval());
  }, i.getShapeIndices = function (a) {
    var b,
        c,
        d = this,
        e = d.config,
        f = {},
        g = 0;return d.filterTargetsToShow(d.data.targets.filter(a, d)).forEach(function (a) {
      for (b = 0; b < e.data_groups.length; b++) {
        if (!(e.data_groups[b].indexOf(a.id) < 0)) for (c = 0; c < e.data_groups[b].length; c++) {
          if (e.data_groups[b][c] in f) {
            f[a.id] = f[e.data_groups[b][c]];break;
          }
        }
      }p(f[a.id]) && (f[a.id] = g++);
    }), f.__max__ = g - 1, f;
  }, i.getShapeX = function (a, b, c, d) {
    var e = this,
        f = d ? e.subX : e.x;return function (d) {
      var e = d.id in c ? c[d.id] : 0;return d.x || 0 === d.x ? f(d.x) - a * (b / 2 - e) : 0;
    };
  }, i.getShapeY = function (a) {
    var b = this;return function (c) {
      var d = a ? b.getSubYScale(c.id) : b.getYScale(c.id);return d(c.value);
    };
  }, i.getShapeOffset = function (a, b, c) {
    var d = this,
        e = d.orderTargets(d.filterTargetsToShow(d.data.targets.filter(a, d))),
        f = e.map(function (a) {
      return a.id;
    });return function (a, g) {
      var h = c ? d.getSubYScale(a.id) : d.getYScale(a.id),
          i = h(0),
          j = i;return e.forEach(function (c) {
        var e = d.isStepType(a) ? d.convertValuesToStep(c.values) : c.values;c.id !== a.id && b[c.id] === b[a.id] && f.indexOf(c.id) < f.indexOf(a.id) && e[g].value * a.value >= 0 && (j += h(e[g].value) - i);
      }), j;
    };
  }, i.isWithinShape = function (a, b) {
    var c,
        d = this,
        e = d.d3.select(a);return d.isTargetToShow(b.id) ? "circle" === a.nodeName ? c = d.isStepType(b) ? d.isWithinStep(a, d.getYScale(b.id)(b.value)) : d.isWithinCircle(a, 1.5 * d.pointSelectR(b)) : "path" === a.nodeName && (c = e.classed(l.bar) ? d.isWithinBar(a) : !0) : c = !1, c;
  }, i.getInterpolate = function (a) {
    var b = this;return b.isSplineType(a) ? "cardinal" : b.isStepType(a) ? b.config.line_step_type : "linear";
  }, i.initLine = function () {
    var a = this;a.main.select("." + l.chart).append("g").attr("class", l.chartLines);
  }, i.updateTargetsForLine = function (a) {
    var b,
        c,
        d = this,
        e = d.config,
        f = d.classChartLine.bind(d),
        g = d.classLines.bind(d),
        h = d.classAreas.bind(d),
        i = d.classCircles.bind(d),
        j = d.classFocus.bind(d);b = d.main.select("." + l.chartLines).selectAll("." + l.chartLine).data(a).attr("class", function (a) {
      return f(a) + j(a);
    }), c = b.enter().append("g").attr("class", f).style("opacity", 0).style("pointer-events", "none"), c.append("g").attr("class", g), c.append("g").attr("class", h), c.append("g").attr("class", function (a) {
      return d.generateClass(l.selectedCircles, a.id);
    }), c.append("g").attr("class", i).style("cursor", function (a) {
      return e.data_selection_isselectable(a) ? "pointer" : null;
    }), a.forEach(function (a) {
      d.main.selectAll("." + l.selectedCircles + d.getTargetSelectorSuffix(a.id)).selectAll("." + l.selectedCircle).each(function (b) {
        b.value = a.values[b.index].value;
      });
    });
  }, i.updateLine = function (a) {
    var b = this;b.mainLine = b.main.selectAll("." + l.lines).selectAll("." + l.line).data(b.lineData.bind(b)), b.mainLine.enter().append("path").attr("class", b.classLine.bind(b)).style("stroke", b.color), b.mainLine.style("opacity", b.initialOpacity.bind(b)).style("shape-rendering", function (a) {
      return b.isStepType(a) ? "crispEdges" : "";
    }).attr("transform", null), b.mainLine.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawLine = function (a, b) {
    return [(b ? this.mainLine.transition() : this.mainLine).attr("d", a).style("stroke", this.color).style("opacity", 1)];
  }, i.generateDrawLine = function (a, b) {
    var c = this,
        d = c.config,
        e = c.d3.svg.line(),
        f = c.generateGetLinePoints(a, b),
        g = b ? c.getSubYScale : c.getYScale,
        h = function h(a) {
      return (b ? c.subxx : c.xx).call(c, a);
    },
        i = function i(a, b) {
      return d.data_groups.length > 0 ? f(a, b)[0][1] : g.call(c, a.id)(a.value);
    };return e = d.axis_rotated ? e.x(i).y(h) : e.x(h).y(i), d.line_connectNull || (e = e.defined(function (a) {
      return null != a.value;
    })), function (a) {
      var f,
          h = d.line_connectNull ? c.filterRemoveNull(a.values) : a.values,
          i = b ? c.x : c.subX,
          j = g.call(c, a.id),
          k = 0,
          l = 0;return c.isLineType(a) ? d.data_regions[a.id] ? f = c.lineWithRegions(h, i, j, d.data_regions[a.id]) : (c.isStepType(a) && (h = c.convertValuesToStep(h)), f = e.interpolate(c.getInterpolate(a))(h)) : (h[0] && (k = i(h[0].x), l = j(h[0].value)), f = d.axis_rotated ? "M " + l + " " + k : "M " + k + " " + l), f ? f : "M 0 0";
    };
  }, i.generateGetLinePoints = function (a, b) {
    var c = this,
        d = c.config,
        e = a.__max__ + 1,
        f = c.getShapeX(0, e, a, !!b),
        g = c.getShapeY(!!b),
        h = c.getShapeOffset(c.isLineType, a, !!b),
        i = b ? c.getSubYScale : c.getYScale;return function (a, b) {
      var e = i.call(c, a.id)(0),
          j = h(a, b) || e,
          k = f(a),
          l = g(a);return d.axis_rotated && (0 < a.value && e > l || a.value < 0 && l > e) && (l = e), [[k, l - (e - j)], [k, l - (e - j)], [k, l - (e - j)], [k, l - (e - j)]];
    };
  }, i.lineWithRegions = function (a, b, c, d) {
    function e(a, b) {
      var c;for (c = 0; c < b.length; c++) {
        if (b[c].start < a && a <= b[c].end) return !0;
      }return !1;
    }function f(a) {
      return "M" + a[0][0] + " " + a[0][1] + " " + a[1][0] + " " + a[1][1];
    }var g,
        h,
        i,
        j,
        k,
        l,
        m,
        n,
        o,
        r,
        s,
        t,
        u = this,
        v = u.config,
        w = -1,
        x = "M",
        y = u.isCategorized() ? .5 : 0,
        z = [];if (q(d)) for (g = 0; g < d.length; g++) {
      z[g] = {}, z[g].start = p(d[g].start) ? a[0].x : u.isTimeSeries() ? u.parseDate(d[g].start) : d[g].start, z[g].end = p(d[g].end) ? a[a.length - 1].x : u.isTimeSeries() ? u.parseDate(d[g].end) : d[g].end;
    }for (s = v.axis_rotated ? function (a) {
      return c(a.value);
    } : function (a) {
      return b(a.x);
    }, t = v.axis_rotated ? function (a) {
      return b(a.x);
    } : function (a) {
      return c(a.value);
    }, i = u.isTimeSeries() ? function (a, d, e, g) {
      var h,
          i = a.x.getTime(),
          j = d.x - a.x,
          l = new Date(i + j * e),
          m = new Date(i + j * (e + g));return h = v.axis_rotated ? [[c(k(e)), b(l)], [c(k(e + g)), b(m)]] : [[b(l), c(k(e))], [b(m), c(k(e + g))]], f(h);
    } : function (a, d, e, g) {
      var h;return h = v.axis_rotated ? [[c(k(e), !0), b(j(e))], [c(k(e + g), !0), b(j(e + g))]] : [[b(j(e), !0), c(k(e))], [b(j(e + g), !0), c(k(e + g))]], f(h);
    }, g = 0; g < a.length; g++) {
      if (p(z) || !e(a[g].x, z)) x += " " + s(a[g]) + " " + t(a[g]);else for (j = u.getScale(a[g - 1].x + y, a[g].x + y, u.isTimeSeries()), k = u.getScale(a[g - 1].value, a[g].value), l = b(a[g].x) - b(a[g - 1].x), m = c(a[g].value) - c(a[g - 1].value), n = Math.sqrt(Math.pow(l, 2) + Math.pow(m, 2)), o = 2 / n, r = 2 * o, h = o; 1 >= h; h += r) {
        x += i(a[g - 1], a[g], h, o);
      }w = a[g].x;
    }return x;
  }, i.updateArea = function (a) {
    var b = this,
        c = b.d3;b.mainArea = b.main.selectAll("." + l.areas).selectAll("." + l.area).data(b.lineData.bind(b)), b.mainArea.enter().append("path").attr("class", b.classArea.bind(b)).style("fill", b.color).style("opacity", function () {
      return b.orgAreaOpacity = +c.select(this).style("opacity"), 0;
    }), b.mainArea.style("opacity", b.orgAreaOpacity), b.mainArea.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawArea = function (a, b) {
    return [(b ? this.mainArea.transition() : this.mainArea).attr("d", a).style("fill", this.color).style("opacity", this.orgAreaOpacity)];
  }, i.generateDrawArea = function (a, b) {
    var c = this,
        d = c.config,
        e = c.d3.svg.area(),
        f = c.generateGetAreaPoints(a, b),
        g = b ? c.getSubYScale : c.getYScale,
        h = function h(a) {
      return (b ? c.subxx : c.xx).call(c, a);
    },
        i = function i(a, b) {
      return d.data_groups.length > 0 ? f(a, b)[0][1] : g.call(c, a.id)(c.getAreaBaseValue(a.id));
    },
        j = function j(a, b) {
      return d.data_groups.length > 0 ? f(a, b)[1][1] : g.call(c, a.id)(a.value);
    };return e = d.axis_rotated ? e.x0(i).x1(j).y(h) : e.x(h).y0(i).y1(j), d.line_connectNull || (e = e.defined(function (a) {
      return null !== a.value;
    })), function (a) {
      var b,
          f = d.line_connectNull ? c.filterRemoveNull(a.values) : a.values,
          g = 0,
          h = 0;return c.isAreaType(a) ? (c.isStepType(a) && (f = c.convertValuesToStep(f)), b = e.interpolate(c.getInterpolate(a))(f)) : (f[0] && (g = c.x(f[0].x), h = c.getYScale(a.id)(f[0].value)), b = d.axis_rotated ? "M " + h + " " + g : "M " + g + " " + h), b ? b : "M 0 0";
    };
  }, i.getAreaBaseValue = function () {
    return 0;
  }, i.generateGetAreaPoints = function (a, b) {
    var c = this,
        d = c.config,
        e = a.__max__ + 1,
        f = c.getShapeX(0, e, a, !!b),
        g = c.getShapeY(!!b),
        h = c.getShapeOffset(c.isAreaType, a, !!b),
        i = b ? c.getSubYScale : c.getYScale;return function (a, b) {
      var e = i.call(c, a.id)(0),
          j = h(a, b) || e,
          k = f(a),
          l = g(a);return d.axis_rotated && (0 < a.value && e > l || a.value < 0 && l > e) && (l = e), [[k, j], [k, l - (e - j)], [k, l - (e - j)], [k, j]];
    };
  }, i.updateCircle = function () {
    var a = this;a.mainCircle = a.main.selectAll("." + l.circles).selectAll("." + l.circle).data(a.lineOrScatterData.bind(a)), a.mainCircle.enter().append("circle").attr("class", a.classCircle.bind(a)).attr("r", a.pointR.bind(a)).style("fill", a.color), a.mainCircle.style("opacity", a.initialOpacityForCircle.bind(a)), a.mainCircle.exit().remove();
  }, i.redrawCircle = function (a, b, c) {
    var d = this.main.selectAll("." + l.selectedCircle);return [(c ? this.mainCircle.transition() : this.mainCircle).style("opacity", this.opacityForCircle.bind(this)).style("fill", this.color).attr("cx", a).attr("cy", b), (c ? d.transition() : d).attr("cx", a).attr("cy", b)];
  }, i.circleX = function (a) {
    return a.x || 0 === a.x ? this.x(a.x) : null;
  }, i.updateCircleY = function () {
    var a,
        b,
        c = this;c.config.data_groups.length > 0 ? (a = c.getShapeIndices(c.isLineType), b = c.generateGetLinePoints(a), c.circleY = function (a, c) {
      return b(a, c)[0][1];
    }) : c.circleY = function (a) {
      return c.getYScale(a.id)(a.value);
    };
  }, i.getCircles = function (a, b) {
    var c = this;return (b ? c.main.selectAll("." + l.circles + c.getTargetSelectorSuffix(b)) : c.main).selectAll("." + l.circle + (m(a) ? "-" + a : ""));
  }, i.expandCircles = function (a, b, c) {
    var d = this,
        e = d.pointExpandedR.bind(d);c && d.unexpandCircles(), d.getCircles(a, b).classed(l.EXPANDED, !0).attr("r", e);
  }, i.unexpandCircles = function (a) {
    var b = this,
        c = b.pointR.bind(b);b.getCircles(a).filter(function () {
      return b.d3.select(this).classed(l.EXPANDED);
    }).classed(l.EXPANDED, !1).attr("r", c);
  }, i.pointR = function (a) {
    var b = this,
        c = b.config;return b.isStepType(a) ? 0 : n(c.point_r) ? c.point_r(a) : c.point_r;
  }, i.pointExpandedR = function (a) {
    var b = this,
        c = b.config;return c.point_focus_expand_enabled ? c.point_focus_expand_r ? c.point_focus_expand_r : 1.75 * b.pointR(a) : b.pointR(a);
  }, i.pointSelectR = function (a) {
    var b = this,
        c = b.config;return c.point_select_r ? c.point_select_r : 4 * b.pointR(a);
  }, i.isWithinCircle = function (a, b) {
    var c = this.d3,
        d = c.mouse(a),
        e = c.select(a),
        f = +e.attr("cx"),
        g = +e.attr("cy");return Math.sqrt(Math.pow(f - d[0], 2) + Math.pow(g - d[1], 2)) < b;
  }, i.isWithinStep = function (a, b) {
    return Math.abs(b - this.d3.mouse(a)[1]) < 30;
  }, i.initBar = function () {
    var a = this;a.main.select("." + l.chart).append("g").attr("class", l.chartBars);
  }, i.updateTargetsForBar = function (a) {
    var b,
        c,
        d = this,
        e = d.config,
        f = d.classChartBar.bind(d),
        g = d.classBars.bind(d),
        h = d.classFocus.bind(d);b = d.main.select("." + l.chartBars).selectAll("." + l.chartBar).data(a).attr("class", function (a) {
      return f(a) + h(a);
    }), c = b.enter().append("g").attr("class", f).style("opacity", 0).style("pointer-events", "none"), c.append("g").attr("class", g).style("cursor", function (a) {
      return e.data_selection_isselectable(a) ? "pointer" : null;
    });
  }, i.updateBar = function (a) {
    var b = this,
        c = b.barData.bind(b),
        d = b.classBar.bind(b),
        e = b.initialOpacity.bind(b),
        f = function f(a) {
      return b.color(a.id);
    };b.mainBar = b.main.selectAll("." + l.bars).selectAll("." + l.bar).data(c), b.mainBar.enter().append("path").attr("class", d).style("stroke", f).style("fill", f), b.mainBar.style("opacity", e), b.mainBar.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawBar = function (a, b) {
    return [(b ? this.mainBar.transition() : this.mainBar).attr("d", a).style("fill", this.color).style("opacity", 1)];
  }, i.getBarW = function (a, b) {
    var c = this,
        d = c.config,
        e = "number" == typeof d.bar_width ? d.bar_width : b ? a.tickInterval() * d.bar_width_ratio / b : 0;return d.bar_width_max && e > d.bar_width_max ? d.bar_width_max : e;
  }, i.getBars = function (a, b) {
    var c = this;return (b ? c.main.selectAll("." + l.bars + c.getTargetSelectorSuffix(b)) : c.main).selectAll("." + l.bar + (m(a) ? "-" + a : ""));
  }, i.expandBars = function (a, b, c) {
    var d = this;c && d.unexpandBars(), d.getBars(a, b).classed(l.EXPANDED, !0);
  }, i.unexpandBars = function (a) {
    var b = this;b.getBars(a).classed(l.EXPANDED, !1);
  }, i.generateDrawBar = function (a, b) {
    var c = this,
        d = c.config,
        e = c.generateGetBarPoints(a, b);return function (a, b) {
      var c = e(a, b),
          f = d.axis_rotated ? 1 : 0,
          g = d.axis_rotated ? 0 : 1,
          h = "M " + c[0][f] + "," + c[0][g] + " L" + c[1][f] + "," + c[1][g] + " L" + c[2][f] + "," + c[2][g] + " L" + c[3][f] + "," + c[3][g] + " z";return h;
    };
  }, i.generateGetBarPoints = function (a, b) {
    var c = this,
        d = b ? c.subXAxis : c.xAxis,
        e = a.__max__ + 1,
        f = c.getBarW(d, e),
        g = c.getShapeX(f, e, a, !!b),
        h = c.getShapeY(!!b),
        i = c.getShapeOffset(c.isBarType, a, !!b),
        j = b ? c.getSubYScale : c.getYScale;
    return function (a, b) {
      var d = j.call(c, a.id)(0),
          e = i(a, b) || d,
          k = g(a),
          l = h(a);return c.config.axis_rotated && (0 < a.value && d > l || a.value < 0 && l > d) && (l = d), [[k, e], [k, l - (d - e)], [k + f, l - (d - e)], [k + f, e]];
    };
  }, i.isWithinBar = function (a) {
    var b = this.d3.mouse(a),
        c = a.getBoundingClientRect(),
        d = a.pathSegList.getItem(0),
        e = a.pathSegList.getItem(1),
        f = Math.min(d.x, e.x),
        g = Math.min(d.y, e.y),
        h = c.width,
        i = c.height,
        j = 2,
        k = f - j,
        l = f + h + j,
        m = g + i + j,
        n = g - j;return k < b[0] && b[0] < l && n < b[1] && b[1] < m;
  }, i.initText = function () {
    var a = this;a.main.select("." + l.chart).append("g").attr("class", l.chartTexts), a.mainText = a.d3.selectAll([]);
  }, i.updateTargetsForText = function (a) {
    var b,
        c,
        d = this,
        e = d.classChartText.bind(d),
        f = d.classTexts.bind(d),
        g = d.classFocus.bind(d);b = d.main.select("." + l.chartTexts).selectAll("." + l.chartText).data(a).attr("class", function (a) {
      return e(a) + g(a);
    }), c = b.enter().append("g").attr("class", e).style("opacity", 0).style("pointer-events", "none"), c.append("g").attr("class", f);
  }, i.updateText = function (a) {
    var b = this,
        c = b.config,
        d = b.barOrLineData.bind(b),
        e = b.classText.bind(b);b.mainText = b.main.selectAll("." + l.texts).selectAll("." + l.text).data(d), b.mainText.enter().append("text").attr("class", e).attr("text-anchor", function (a) {
      return c.axis_rotated ? a.value < 0 ? "end" : "start" : "middle";
    }).style("stroke", "none").style("fill", function (a) {
      return b.color(a);
    }).style("fill-opacity", 0), b.mainText.text(function (a, c, d) {
      return b.dataLabelFormat(a.id)(a.value, a.id, c, d);
    }), b.mainText.exit().transition().duration(a).style("fill-opacity", 0).remove();
  }, i.redrawText = function (a, b, c, d) {
    return [(d ? this.mainText.transition() : this.mainText).attr("x", a).attr("y", b).style("fill", this.color).style("fill-opacity", c ? 0 : this.opacityForText.bind(this))];
  }, i.getTextRect = function (a, b) {
    var c,
        d = this.d3.select("body").append("div").classed("c3", !0),
        e = d.append("svg").style("visibility", "hidden").style("position", "fixed").style("top", 0).style("left", 0);return e.selectAll(".dummy").data([a]).enter().append("text").classed(b ? b : "", !0).text(a).each(function () {
      c = this.getBoundingClientRect();
    }), d.remove(), c;
  }, i.generateXYForText = function (a, b, c, d) {
    var e = this,
        f = e.generateGetAreaPoints(a, !1),
        g = e.generateGetBarPoints(b, !1),
        h = e.generateGetLinePoints(c, !1),
        i = d ? e.getXForText : e.getYForText;return function (a, b) {
      var c = e.isAreaType(a) ? f : e.isBarType(a) ? g : h;return i.call(e, c(a, b), a, this);
    };
  }, i.getXForText = function (a, b, c) {
    var d,
        e,
        f = this,
        g = c.getBoundingClientRect();return f.config.axis_rotated ? (e = f.isBarType(b) ? 4 : 6, d = a[2][1] + e * (b.value < 0 ? -1 : 1)) : d = f.hasType("bar") ? (a[2][0] + a[0][0]) / 2 : a[0][0], null === b.value && (d > f.width ? d = f.width - g.width : 0 > d && (d = 4)), d;
  }, i.getYForText = function (a, b, c) {
    var d,
        e = this,
        f = c.getBoundingClientRect();return e.config.axis_rotated ? d = (a[0][0] + a[2][0] + .6 * f.height) / 2 : (d = a[2][1], b.value < 0 ? (d += f.height, e.isBarType(b) && e.isSafari() ? d -= 3 : !e.isBarType(b) && e.isChrome() && (d += 3)) : d += e.isBarType(b) ? -3 : -6), null !== b.value || e.config.axis_rotated || (d < f.height ? d = f.height : d > this.height && (d = this.height - 4)), d;
  }, i.setTargetType = function (a, b) {
    var c = this,
        d = c.config;c.mapToTargetIds(a).forEach(function (a) {
      c.withoutFadeIn[a] = b === d.data_types[a], d.data_types[a] = b;
    }), a || (d.data_type = b);
  }, i.hasType = function (a, b) {
    var c = this,
        d = c.config.data_types,
        e = !1;return b = b || c.data.targets, b && b.length ? b.forEach(function (b) {
      var c = d[b.id];(c && c.indexOf(a) >= 0 || !c && "line" === a) && (e = !0);
    }) : Object.keys(d).length ? Object.keys(d).forEach(function (b) {
      d[b] === a && (e = !0);
    }) : e = c.config.data_type === a, e;
  }, i.hasArcType = function (a) {
    return this.hasType("pie", a) || this.hasType("donut", a) || this.hasType("gauge", a);
  }, i.isLineType = function (a) {
    var b = this.config,
        c = o(a) ? a : a.id;return !b.data_types[c] || ["line", "spline", "area", "area-spline", "step", "area-step"].indexOf(b.data_types[c]) >= 0;
  }, i.isStepType = function (a) {
    var b = o(a) ? a : a.id;return ["step", "area-step"].indexOf(this.config.data_types[b]) >= 0;
  }, i.isSplineType = function (a) {
    var b = o(a) ? a : a.id;return ["spline", "area-spline"].indexOf(this.config.data_types[b]) >= 0;
  }, i.isAreaType = function (a) {
    var b = o(a) ? a : a.id;return ["area", "area-spline", "area-step"].indexOf(this.config.data_types[b]) >= 0;
  }, i.isBarType = function (a) {
    var b = o(a) ? a : a.id;return "bar" === this.config.data_types[b];
  }, i.isScatterType = function (a) {
    var b = o(a) ? a : a.id;return "scatter" === this.config.data_types[b];
  }, i.isPieType = function (a) {
    var b = o(a) ? a : a.id;return "pie" === this.config.data_types[b];
  }, i.isGaugeType = function (a) {
    var b = o(a) ? a : a.id;return "gauge" === this.config.data_types[b];
  }, i.isDonutType = function (a) {
    var b = o(a) ? a : a.id;return "donut" === this.config.data_types[b];
  }, i.isArcType = function (a) {
    return this.isPieType(a) || this.isDonutType(a) || this.isGaugeType(a);
  }, i.lineData = function (a) {
    return this.isLineType(a) ? [a] : [];
  }, i.arcData = function (a) {
    return this.isArcType(a.data) ? [a] : [];
  }, i.barData = function (a) {
    return this.isBarType(a) ? a.values : [];
  }, i.lineOrScatterData = function (a) {
    return this.isLineType(a) || this.isScatterType(a) ? a.values : [];
  }, i.barOrLineData = function (a) {
    return this.isBarType(a) || this.isLineType(a) ? a.values : [];
  }, i.initGrid = function () {
    var a = this,
        b = a.config,
        c = a.d3;a.grid = a.main.append("g").attr("clip-path", a.clipPathForGrid).attr("class", l.grid), b.grid_x_show && a.grid.append("g").attr("class", l.xgrids), b.grid_y_show && a.grid.append("g").attr("class", l.ygrids), b.grid_focus_show && a.grid.append("g").attr("class", l.xgridFocus).append("line").attr("class", l.xgridFocus), a.xgrid = c.selectAll([]), b.grid_lines_front || a.initGridLines();
  }, i.initGridLines = function () {
    var a = this,
        b = a.d3;a.gridLines = a.main.append("g").attr("clip-path", a.clipPathForGrid).attr("class", l.grid + " " + l.gridLines), a.gridLines.append("g").attr("class", l.xgridLines), a.gridLines.append("g").attr("class", l.ygridLines), a.xgridLines = b.selectAll([]);
  }, i.updateXGrid = function (a) {
    var b = this,
        c = b.config,
        d = b.d3,
        e = b.generateGridData(c.grid_x_type, b.x),
        f = b.isCategorized() ? b.xAxis.tickOffset() : 0;b.xgridAttr = c.axis_rotated ? { x1: 0, x2: b.width, y1: function y1(a) {
        return b.x(a) - f;
      }, y2: function y2(a) {
        return b.x(a) - f;
      } } : { x1: function x1(a) {
        return b.x(a) + f;
      }, x2: function x2(a) {
        return b.x(a) + f;
      }, y1: 0, y2: b.height }, b.xgrid = b.main.select("." + l.xgrids).selectAll("." + l.xgrid).data(e), b.xgrid.enter().append("line").attr("class", l.xgrid), a || b.xgrid.attr(b.xgridAttr).style("opacity", function () {
      return +d.select(this).attr(c.axis_rotated ? "y1" : "x1") === (c.axis_rotated ? b.height : 0) ? 0 : 1;
    }), b.xgrid.exit().remove();
  }, i.updateYGrid = function () {
    var a = this,
        b = a.config,
        c = a.yAxis.tickValues() || a.y.ticks(b.grid_y_ticks);a.ygrid = a.main.select("." + l.ygrids).selectAll("." + l.ygrid).data(c), a.ygrid.enter().append("line").attr("class", l.ygrid), a.ygrid.attr("x1", b.axis_rotated ? a.y : 0).attr("x2", b.axis_rotated ? a.y : a.width).attr("y1", b.axis_rotated ? 0 : a.y).attr("y2", b.axis_rotated ? a.height : a.y), a.ygrid.exit().remove(), a.smoothLines(a.ygrid, "grid");
  }, i.gridTextAnchor = function (a) {
    return a.position ? a.position : "end";
  }, i.gridTextDx = function (a) {
    return "start" === a.position ? 4 : "middle" === a.position ? 0 : -4;
  }, i.xGridTextX = function (a) {
    return "start" === a.position ? -this.height : "middle" === a.position ? -this.height / 2 : 0;
  }, i.yGridTextX = function (a) {
    return "start" === a.position ? 0 : "middle" === a.position ? this.width / 2 : this.width;
  }, i.updateGrid = function (a) {
    var b,
        c,
        d,
        e = this,
        f = e.main,
        g = e.config;e.grid.style("visibility", e.hasArcType() ? "hidden" : "visible"), f.select("line." + l.xgridFocus).style("visibility", "hidden"), g.grid_x_show && e.updateXGrid(), e.xgridLines = f.select("." + l.xgridLines).selectAll("." + l.xgridLine).data(g.grid_x_lines), b = e.xgridLines.enter().append("g").attr("class", function (a) {
      return l.xgridLine + (a["class"] ? " " + a["class"] : "");
    }), b.append("line").style("opacity", 0), b.append("text").attr("text-anchor", e.gridTextAnchor).attr("transform", g.axis_rotated ? "" : "rotate(-90)").attr("dx", e.gridTextDx).attr("dy", -5).style("opacity", 0), e.xgridLines.exit().transition().duration(a).style("opacity", 0).remove(), g.grid_y_show && e.updateYGrid(), e.ygridLines = f.select("." + l.ygridLines).selectAll("." + l.ygridLine).data(g.grid_y_lines), c = e.ygridLines.enter().append("g").attr("class", function (a) {
      return l.ygridLine + (a["class"] ? " " + a["class"] : "");
    }), c.append("line").style("opacity", 0), c.append("text").attr("text-anchor", e.gridTextAnchor).attr("transform", g.axis_rotated ? "rotate(-90)" : "").attr("dx", e.gridTextDx).attr("dy", -5).style("opacity", 0), d = e.yv.bind(e), e.ygridLines.select("line").transition().duration(a).attr("x1", g.axis_rotated ? d : 0).attr("x2", g.axis_rotated ? d : e.width).attr("y1", g.axis_rotated ? 0 : d).attr("y2", g.axis_rotated ? e.height : d).style("opacity", 1), e.ygridLines.select("text").transition().duration(a).attr("x", g.axis_rotated ? e.xGridTextX.bind(e) : e.yGridTextX.bind(e)).attr("y", d).text(function (a) {
      return a.text;
    }).style("opacity", 1), e.ygridLines.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawGrid = function (a) {
    var b = this,
        c = b.config,
        d = b.xv.bind(b),
        e = b.xgridLines.select("line"),
        f = b.xgridLines.select("text");return [(a ? e.transition() : e).attr("x1", c.axis_rotated ? 0 : d).attr("x2", c.axis_rotated ? b.width : d).attr("y1", c.axis_rotated ? d : 0).attr("y2", c.axis_rotated ? d : b.height).style("opacity", 1), (a ? f.transition() : f).attr("x", c.axis_rotated ? b.yGridTextX.bind(b) : b.xGridTextX.bind(b)).attr("y", d).text(function (a) {
      return a.text;
    }).style("opacity", 1)];
  }, i.showXGridFocus = function (a) {
    var b = this,
        c = b.config,
        d = a.filter(function (a) {
      return a && m(a.value);
    }),
        e = b.main.selectAll("line." + l.xgridFocus),
        f = b.xx.bind(b);c.tooltip_show && (b.hasType("scatter") || b.hasArcType() || (e.style("visibility", "visible").data([d[0]]).attr(c.axis_rotated ? "y1" : "x1", f).attr(c.axis_rotated ? "y2" : "x2", f), b.smoothLines(e, "grid")));
  }, i.hideXGridFocus = function () {
    this.main.select("line." + l.xgridFocus).style("visibility", "hidden");
  }, i.updateXgridFocus = function () {
    var a = this,
        b = a.config;a.main.select("line." + l.xgridFocus).attr("x1", b.axis_rotated ? 0 : -10).attr("x2", b.axis_rotated ? a.width : -10).attr("y1", b.axis_rotated ? -10 : 0).attr("y2", b.axis_rotated ? -10 : a.height);
  }, i.generateGridData = function (a, b) {
    var c,
        d,
        e,
        f,
        g = this,
        h = [],
        i = g.main.select("." + l.axisX).selectAll(".tick").size();if ("year" === a) for (c = g.getXDomain(), d = c[0].getFullYear(), e = c[1].getFullYear(), f = d; e >= f; f++) {
      h.push(new Date(f + "-01-01 00:00:00"));
    } else h = b.ticks(10), h.length > i && (h = h.filter(function (a) {
      return ("" + a).indexOf(".") < 0;
    }));return h;
  }, i.getGridFilterToRemove = function (a) {
    return a ? function (b) {
      var c = !1;return [].concat(a).forEach(function (a) {
        ("value" in a && b.value === a.value || "class" in a && b["class"] === a["class"]) && (c = !0);
      }), c;
    } : function () {
      return !0;
    };
  }, i.removeGridLines = function (a, b) {
    var c = this,
        d = c.config,
        e = c.getGridFilterToRemove(a),
        f = function f(a) {
      return !e(a);
    },
        g = b ? l.xgridLines : l.ygridLines,
        h = b ? l.xgridLine : l.ygridLine;c.main.select("." + g).selectAll("." + h).filter(e).transition().duration(d.transition_duration).style("opacity", 0).remove(), b ? d.grid_x_lines = d.grid_x_lines.filter(f) : d.grid_y_lines = d.grid_y_lines.filter(f);
  }, i.initTooltip = function () {
    var a,
        b = this,
        c = b.config;if (b.tooltip = b.selectChart.style("position", "relative").append("div").attr("class", l.tooltipContainer).style("position", "absolute").style("pointer-events", "none").style("display", "none"), c.tooltip_init_show) {
      if (b.isTimeSeries() && o(c.tooltip_init_x)) {
        for (c.tooltip_init_x = b.parseDate(c.tooltip_init_x), a = 0; a < b.data.targets[0].values.length && b.data.targets[0].values[a].x - c.tooltip_init_x !== 0; a++) {}c.tooltip_init_x = a;
      }b.tooltip.html(c.tooltip_contents.call(b, b.data.targets.map(function (a) {
        return b.addName(a.values[c.tooltip_init_x]);
      }), b.axis.getXAxisTickFormat(), b.getYFormat(b.hasArcType()), b.color)), b.tooltip.style("top", c.tooltip_init_position.top).style("left", c.tooltip_init_position.left).style("display", "block");
    }
  }, i.getTooltipContent = function (a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j,
        k = this,
        m = k.config,
        n = m.tooltip_format_title || b,
        o = m.tooltip_format_name || function (a) {
      return a;
    },
        p = m.tooltip_format_value || c;for (f = 0; f < a.length; f++) {
      a[f] && (a[f].value || 0 === a[f].value) && (e || (g = n ? n(a[f].x) : a[f].x, e = "<table class='" + l.tooltip + "'>" + (g || 0 === g ? "<tr><th colspan='2'>" + g + "</th></tr>" : "")), h = p(a[f].value, a[f].ratio, a[f].id, a[f].index), void 0 !== h && (i = o(a[f].name, a[f].ratio, a[f].id, a[f].index), j = k.levelColor ? k.levelColor(a[f].value) : d(a[f].id), e += "<tr class='" + l.tooltipName + "-" + a[f].id + "'>", e += "<td class='name'><span style='background-color:" + j + "'></span>" + i + "</td>", e += "<td class='value'>" + h + "</td>", e += "</tr>"));
    }return e + "</table>";
  }, i.tooltipPosition = function (a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j = this,
        k = j.config,
        l = j.d3,
        m = j.hasArcType(),
        n = l.mouse(d);return m ? (f = (j.width - (j.isLegendRight ? j.getLegendWidth() : 0)) / 2 + n[0], h = j.height / 2 + n[1] + 20) : (e = j.getSvgLeft(!0), k.axis_rotated ? (f = e + n[0] + 100, g = f + b, i = j.currentWidth - j.getCurrentPaddingRight(), h = j.x(a[0].x) + 20) : (f = e + j.getCurrentPaddingLeft(!0) + j.x(a[0].x) + 20, g = f + b, i = e + j.currentWidth - j.getCurrentPaddingRight(), h = n[1] + 15), g > i && (f -= g - i + 20), h + c > j.currentHeight && (h -= c + 30)), 0 > h && (h = 0), { top: h, left: f };
  }, i.showTooltip = function (a, b) {
    var c,
        d,
        e,
        f = this,
        g = f.config,
        h = f.hasArcType(),
        j = a.filter(function (a) {
      return a && m(a.value);
    }),
        k = g.tooltip_position || i.tooltipPosition;0 !== j.length && g.tooltip_show && (f.tooltip.html(g.tooltip_contents.call(f, a, f.axis.getXAxisTickFormat(), f.getYFormat(h), f.color)).style("display", "block"), c = f.tooltip.property("offsetWidth"), d = f.tooltip.property("offsetHeight"), e = k.call(this, j, c, d, b), f.tooltip.style("top", e.top + "px").style("left", e.left + "px"));
  }, i.hideTooltip = function () {
    this.tooltip.style("display", "none");
  }, i.initLegend = function () {
    var a = this;return a.legendItemTextBox = {}, a.legendHasRendered = !1, a.legend = a.svg.append("g").attr("transform", a.getTranslate("legend")), a.config.legend_show ? void a.updateLegendWithDefaults() : (a.legend.style("visibility", "hidden"), void (a.hiddenLegendIds = a.mapToIds(a.data.targets)));
  }, i.updateLegendWithDefaults = function () {
    var a = this;a.updateLegend(a.mapToIds(a.data.targets), { withTransform: !1, withTransitionForTransform: !1, withTransition: !1 });
  }, i.updateSizeForLegend = function (a, b) {
    var c = this,
        d = c.config,
        e = { top: c.isLegendTop ? c.getCurrentPaddingTop() + d.legend_inset_y + 5.5 : c.currentHeight - a - c.getCurrentPaddingBottom() - d.legend_inset_y, left: c.isLegendLeft ? c.getCurrentPaddingLeft() + d.legend_inset_x + .5 : c.currentWidth - b - c.getCurrentPaddingRight() - d.legend_inset_x + .5 };c.margin3 = { top: c.isLegendRight ? 0 : c.isLegendInset ? e.top : c.currentHeight - a, right: 0 / 0, bottom: 0, left: c.isLegendRight ? c.currentWidth - b : c.isLegendInset ? e.left : 0 };
  }, i.transformLegend = function (a) {
    var b = this;(a ? b.legend.transition() : b.legend).attr("transform", b.getTranslate("legend"));
  }, i.updateLegendStep = function (a) {
    this.legendStep = a;
  }, i.updateLegendItemWidth = function (a) {
    this.legendItemWidth = a;
  }, i.updateLegendItemHeight = function (a) {
    this.legendItemHeight = a;
  }, i.getLegendWidth = function () {
    var a = this;return a.config.legend_show ? a.isLegendRight || a.isLegendInset ? a.legendItemWidth * (a.legendStep + 1) : a.currentWidth : 0;
  }, i.getLegendHeight = function () {
    var a = this,
        b = 0;return a.config.legend_show && (b = a.isLegendRight ? a.currentHeight : Math.max(20, a.legendItemHeight) * (a.legendStep + 1)), b;
  }, i.opacityForLegend = function (a) {
    return a.classed(l.legendItemHidden) ? null : 1;
  }, i.opacityForUnfocusedLegend = function (a) {
    return a.classed(l.legendItemHidden) ? null : .3;
  }, i.toggleFocusLegend = function (a, b) {
    var c = this;a = c.mapToTargetIds(a), c.legend.selectAll("." + l.legendItem).filter(function (b) {
      return a.indexOf(b) >= 0;
    }).classed(l.legendItemFocused, b).transition().duration(100).style("opacity", function () {
      var a = b ? c.opacityForLegend : c.opacityForUnfocusedLegend;return a.call(c, c.d3.select(this));
    });
  }, i.revertLegend = function () {
    var a = this,
        b = a.d3;a.legend.selectAll("." + l.legendItem).classed(l.legendItemFocused, !1).transition().duration(100).style("opacity", function () {
      return a.opacityForLegend(b.select(this));
    });
  }, i.showLegend = function (a) {
    var b = this,
        c = b.config;c.legend_show || (c.legend_show = !0, b.legend.style("visibility", "visible"), b.legendHasRendered || b.updateLegendWithDefaults()), b.removeHiddenLegendIds(a), b.legend.selectAll(b.selectorLegends(a)).style("visibility", "visible").transition().style("opacity", function () {
      return b.opacityForLegend(b.d3.select(this));
    });
  }, i.hideLegend = function (a) {
    var b = this,
        c = b.config;c.legend_show && u(a) && (c.legend_show = !1, b.legend.style("visibility", "hidden")), b.addHiddenLegendIds(a), b.legend.selectAll(b.selectorLegends(a)).style("opacity", 0).style("visibility", "hidden");
  }, i.clearLegendItemTextBoxCache = function () {
    this.legendItemTextBox = {};
  }, i.updateLegend = function (a, b, c) {
    function d(a, b) {
      return u.legendItemTextBox[b] || (u.legendItemTextBox[b] = u.getTextRect(a.textContent, l.legendItem)), u.legendItemTextBox[b];
    }function e(b, c, e) {
      function f(a, b) {
        b || (g = (o - D - n) / 2, B > g && (g = (o - n) / 2, D = 0, J++)), I[a] = J, H[J] = u.isLegendInset ? 10 : g, E[a] = D, D += n;
      }var g,
          h,
          i = 0 === e,
          j = e === a.length - 1,
          k = d(b, c),
          l = k.width + C + (!j || u.isLegendRight || u.isLegendInset ? y : 0),
          m = k.height + x,
          n = u.isLegendRight || u.isLegendInset ? m : l,
          o = u.isLegendRight || u.isLegendInset ? u.getLegendHeight() : u.getLegendWidth();return i && (D = 0, J = 0, z = 0, A = 0), v.legend_show && !u.isLegendToShow(c) ? void (F[c] = G[c] = I[c] = E[c] = 0) : (F[c] = l, G[c] = m, (!z || l >= z) && (z = l), (!A || m >= A) && (A = m), h = u.isLegendRight || u.isLegendInset ? A : z, void (v.legend_equally ? (Object.keys(F).forEach(function (a) {
        F[a] = z;
      }), Object.keys(G).forEach(function (a) {
        G[a] = A;
      }), g = (o - h * a.length) / 2, B > g ? (D = 0, J = 0, a.forEach(function (a) {
        f(a);
      })) : f(c, !0)) : f(c)));
    }var f,
        g,
        h,
        i,
        j,
        k,
        m,
        n,
        o,
        p,
        r,
        s,
        t,
        u = this,
        v = u.config,
        x = 4,
        y = 10,
        z = 0,
        A = 0,
        B = 10,
        C = 15,
        D = 0,
        E = {},
        F = {},
        G = {},
        H = [0],
        I = {},
        J = 0;b = b || {}, n = w(b, "withTransition", !0), o = w(b, "withTransitionForTransform", !0), u.isLegendInset && (J = v.legend_inset_step ? v.legend_inset_step : a.length, u.updateLegendStep(J)), u.isLegendRight ? (f = function f(a) {
      return z * I[a];
    }, i = function i(a) {
      return H[I[a]] + E[a];
    }) : u.isLegendInset ? (f = function f(a) {
      return z * I[a] + 10;
    }, i = function i(a) {
      return H[I[a]] + E[a];
    }) : (f = function f(a) {
      return H[I[a]] + E[a];
    }, i = function i(a) {
      return A * I[a];
    }), g = function g(a, b) {
      return f(a, b) + 14;
    }, j = function j(a, b) {
      return i(a, b) + 9;
    }, h = function h(a, b) {
      return f(a, b);
    }, k = function k(a, b) {
      return i(a, b) - 5;
    }, m = u.legend.selectAll("." + l.legendItem).data(a).enter().append("g").attr("class", function (a) {
      return u.generateClass(l.legendItem, a);
    }).style("visibility", function (a) {
      return u.isLegendToShow(a) ? "visible" : "hidden";
    }).style("cursor", "pointer").on("click", function (a) {
      v.legend_item_onclick ? v.legend_item_onclick.call(u, a) : u.d3.event.altKey ? (u.api.hide(), u.api.show(a)) : (u.api.toggle(a), u.isTargetToShow(a) ? u.api.focus(a) : u.api.revert());
    }).on("mouseover", function (a) {
      u.d3.select(this).classed(l.legendItemFocused, !0), !u.transiting && u.isTargetToShow(a) && u.api.focus(a), v.legend_item_onmouseover && v.legend_item_onmouseover.call(u, a);
    }).on("mouseout", function (a) {
      u.d3.select(this).classed(l.legendItemFocused, !1), u.api.revert(), v.legend_item_onmouseout && v.legend_item_onmouseout.call(u, a);
    }), m.append("text").text(function (a) {
      return q(v.data_names[a]) ? v.data_names[a] : a;
    }).each(function (a, b) {
      e(this, a, b);
    }).style("pointer-events", "none").attr("x", u.isLegendRight || u.isLegendInset ? g : -200).attr("y", u.isLegendRight || u.isLegendInset ? -200 : j), m.append("rect").attr("class", l.legendItemEvent).style("fill-opacity", 0).attr("x", u.isLegendRight || u.isLegendInset ? h : -200).attr("y", u.isLegendRight || u.isLegendInset ? -200 : k), m.append("rect").attr("class", l.legendItemTile).style("pointer-events", "none").style("fill", u.color).attr("x", u.isLegendRight || u.isLegendInset ? g : -200).attr("y", u.isLegendRight || u.isLegendInset ? -200 : i).attr("width", 10).attr("height", 10), t = u.legend.select("." + l.legendBackground + " rect"), u.isLegendInset && z > 0 && 0 === t.size() && (t = u.legend.insert("g", "." + l.legendItem).attr("class", l.legendBackground).append("rect")), p = u.legend.selectAll("text").data(a).text(function (a) {
      return q(v.data_names[a]) ? v.data_names[a] : a;
    }).each(function (a, b) {
      e(this, a, b);
    }), (n ? p.transition() : p).attr("x", g).attr("y", j), r = u.legend.selectAll("rect." + l.legendItemEvent).data(a), (n ? r.transition() : r).attr("width", function (a) {
      return F[a];
    }).attr("height", function (a) {
      return G[a];
    }).attr("x", h).attr("y", k), s = u.legend.selectAll("rect." + l.legendItemTile).data(a), (n ? s.transition() : s).style("fill", u.color).attr("x", f).attr("y", i), t && (n ? t.transition() : t).attr("height", u.getLegendHeight() - 12).attr("width", z * (J + 1) + 10), u.legend.selectAll("." + l.legendItem).classed(l.legendItemHidden, function (a) {
      return !u.isTargetToShow(a);
    }), u.updateLegendItemWidth(z), u.updateLegendItemHeight(A), u.updateLegendStep(J), u.updateSizes(), u.updateScales(), u.updateSvgSize(), u.transformAll(o, c), u.legendHasRendered = !0;
  }, c(b, f), f.prototype.init = function () {
    var a = this.owner,
        b = a.config,
        c = a.main;a.axes.x = c.append("g").attr("class", l.axis + " " + l.axisX).attr("clip-path", a.clipPathForXAxis).attr("transform", a.getTranslate("x")).style("visibility", b.axis_x_show ? "visible" : "hidden"), a.axes.x.append("text").attr("class", l.axisXLabel).attr("transform", b.axis_rotated ? "rotate(-90)" : "").style("text-anchor", this.textAnchorForXAxisLabel.bind(this)), a.axes.y = c.append("g").attr("class", l.axis + " " + l.axisY).attr("clip-path", b.axis_y_inner ? "" : a.clipPathForYAxis).attr("transform", a.getTranslate("y")).style("visibility", b.axis_y_show ? "visible" : "hidden"), a.axes.y.append("text").attr("class", l.axisYLabel).attr("transform", b.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForYAxisLabel.bind(this)), a.axes.y2 = c.append("g").attr("class", l.axis + " " + l.axisY2).attr("transform", a.getTranslate("y2")).style("visibility", b.axis_y2_show ? "visible" : "hidden"), a.axes.y2.append("text").attr("class", l.axisY2Label).attr("transform", b.axis_rotated ? "" : "rotate(-90)").style("text-anchor", this.textAnchorForY2AxisLabel.bind(this));
  }, f.prototype.getXAxis = function (a, b, c, d, e, f, h) {
    var i = this.owner,
        j = i.config,
        k = { isCategory: i.isCategorized(), withOuterTick: e, tickMultiline: j.axis_x_tick_multiline, tickWidth: j.axis_x_tick_width, tickTextRotate: h ? 0 : j.axis_x_tick_rotate, withoutTransition: f },
        l = g(i.d3, k).scale(a).orient(b);return i.isTimeSeries() && d && (d = d.map(function (a) {
      return i.parseDate(a);
    })), l.tickFormat(c).tickValues(d), i.isCategorized() && (l.tickCentered(j.axis_x_tick_centered), u(j.axis_x_tick_culling) && (j.axis_x_tick_culling = !1)), l;
  }, f.prototype.updateXAxisTickValues = function (a, b) {
    var c,
        d = this.owner,
        e = d.config;return (e.axis_x_tick_fit || e.axis_x_tick_count) && (c = this.generateTickValues(d.mapTargetsToUniqueXs(a), e.axis_x_tick_count, d.isTimeSeries())), b ? b.tickValues(c) : (d.xAxis.tickValues(c), d.subXAxis.tickValues(c)), c;
  }, f.prototype.getYAxis = function (a, b, c, d, e, f) {
    var h = { withOuterTick: e, withoutTransition: f },
        i = this.owner,
        j = i.d3,
        k = i.config,
        l = g(j, h).scale(a).orient(b).tickFormat(c);return i.isTimeSeriesY() ? l.ticks(j.time[k.axis_y_tick_time_value], k.axis_y_tick_time_interval) : l.tickValues(d), l;
  }, f.prototype.getId = function (a) {
    var b = this.owner.config;return a in b.data_axes ? b.data_axes[a] : "y";
  }, f.prototype.getXAxisTickFormat = function () {
    var a = this.owner,
        b = a.config,
        c = a.isTimeSeries() ? a.defaultAxisTimeFormat : a.isCategorized() ? a.categoryName : function (a) {
      return 0 > a ? a.toFixed(0) : a;
    };return b.axis_x_tick_format && (n(b.axis_x_tick_format) ? c = b.axis_x_tick_format : a.isTimeSeries() && (c = function c(_c) {
      return _c ? a.axisTimeFormat(b.axis_x_tick_format)(_c) : "";
    })), n(c) ? function (b) {
      return c.call(a, b);
    } : c;
  }, f.prototype.getTickValues = function (a, b) {
    return a ? a : b ? b.tickValues() : void 0;
  }, f.prototype.getXAxisTickValues = function () {
    return this.getTickValues(this.owner.config.axis_x_tick_values, this.owner.xAxis);
  }, f.prototype.getYAxisTickValues = function () {
    return this.getTickValues(this.owner.config.axis_y_tick_values, this.owner.yAxis);
  }, f.prototype.getY2AxisTickValues = function () {
    return this.getTickValues(this.owner.config.axis_y2_tick_values, this.owner.y2Axis);
  }, f.prototype.getLabelOptionByAxisId = function (a) {
    var b,
        c = this.owner,
        d = c.config;return "y" === a ? b = d.axis_y_label : "y2" === a ? b = d.axis_y2_label : "x" === a && (b = d.axis_x_label), b;
  }, f.prototype.getLabelText = function (a) {
    var b = this.getLabelOptionByAxisId(a);return o(b) ? b : b ? b.text : null;
  }, f.prototype.setLabelText = function (a, b) {
    var c = this.owner,
        d = c.config,
        e = this.getLabelOptionByAxisId(a);o(e) ? "y" === a ? d.axis_y_label = b : "y2" === a ? d.axis_y2_label = b : "x" === a && (d.axis_x_label = b) : e && (e.text = b);
  }, f.prototype.getLabelPosition = function (a, b) {
    var c = this.getLabelOptionByAxisId(a),
        d = c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c)) && c.position ? c.position : b;return { isInner: d.indexOf("inner") >= 0, isOuter: d.indexOf("outer") >= 0, isLeft: d.indexOf("left") >= 0, isCenter: d.indexOf("center") >= 0, isRight: d.indexOf("right") >= 0, isTop: d.indexOf("top") >= 0, isMiddle: d.indexOf("middle") >= 0, isBottom: d.indexOf("bottom") >= 0 };
  }, f.prototype.getXAxisLabelPosition = function () {
    return this.getLabelPosition("x", this.owner.config.axis_rotated ? "inner-top" : "inner-right");
  }, f.prototype.getYAxisLabelPosition = function () {
    return this.getLabelPosition("y", this.owner.config.axis_rotated ? "inner-right" : "inner-top");
  }, f.prototype.getY2AxisLabelPosition = function () {
    return this.getLabelPosition("y2", this.owner.config.axis_rotated ? "inner-right" : "inner-top");
  }, f.prototype.getLabelPositionById = function (a) {
    return "y2" === a ? this.getY2AxisLabelPosition() : "y" === a ? this.getYAxisLabelPosition() : this.getXAxisLabelPosition();
  }, f.prototype.textForXAxisLabel = function () {
    return this.getLabelText("x");
  }, f.prototype.textForYAxisLabel = function () {
    return this.getLabelText("y");
  }, f.prototype.textForY2AxisLabel = function () {
    return this.getLabelText("y2");
  }, f.prototype.xForAxisLabel = function (a, b) {
    var c = this.owner;return a ? b.isLeft ? 0 : b.isCenter ? c.width / 2 : c.width : b.isBottom ? -c.height : b.isMiddle ? -c.height / 2 : 0;
  }, f.prototype.dxForAxisLabel = function (a, b) {
    return a ? b.isLeft ? "0.5em" : b.isRight ? "-0.5em" : "0" : b.isTop ? "-0.5em" : b.isBottom ? "0.5em" : "0";
  }, f.prototype.textAnchorForAxisLabel = function (a, b) {
    return a ? b.isLeft ? "start" : b.isCenter ? "middle" : "end" : b.isBottom ? "start" : b.isMiddle ? "middle" : "end";
  }, f.prototype.xForXAxisLabel = function () {
    return this.xForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
  }, f.prototype.xForYAxisLabel = function () {
    return this.xForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
  }, f.prototype.xForY2AxisLabel = function () {
    return this.xForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
  }, f.prototype.dxForXAxisLabel = function () {
    return this.dxForAxisLabel(!this.owner.config.axis_rotated, this.getXAxisLabelPosition());
  }, f.prototype.dxForYAxisLabel = function () {
    return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getYAxisLabelPosition());
  }, f.prototype.dxForY2AxisLabel = function () {
    return this.dxForAxisLabel(this.owner.config.axis_rotated, this.getY2AxisLabelPosition());
  }, f.prototype.dyForXAxisLabel = function () {
    var a = this.owner,
        b = a.config,
        c = this.getXAxisLabelPosition();return b.axis_rotated ? c.isInner ? "1.2em" : -25 - this.getMaxTickWidth("x") : c.isInner ? "-0.5em" : b.axis_x_height ? b.axis_x_height - 10 : "3em";
  }, f.prototype.dyForYAxisLabel = function () {
    var a = this.owner,
        b = this.getYAxisLabelPosition();return a.config.axis_rotated ? b.isInner ? "-0.5em" : "3em" : b.isInner ? "1.2em" : -10 - (a.config.axis_y_inner ? 0 : this.getMaxTickWidth("y") + 10);
  }, f.prototype.dyForY2AxisLabel = function () {
    var a = this.owner,
        b = this.getY2AxisLabelPosition();return a.config.axis_rotated ? b.isInner ? "1.2em" : "-2.2em" : b.isInner ? "-0.5em" : 15 + (a.config.axis_y2_inner ? 0 : this.getMaxTickWidth("y2") + 15);
  }, f.prototype.textAnchorForXAxisLabel = function () {
    var a = this.owner;return this.textAnchorForAxisLabel(!a.config.axis_rotated, this.getXAxisLabelPosition());
  }, f.prototype.textAnchorForYAxisLabel = function () {
    var a = this.owner;return this.textAnchorForAxisLabel(a.config.axis_rotated, this.getYAxisLabelPosition());
  }, f.prototype.textAnchorForY2AxisLabel = function () {
    var a = this.owner;return this.textAnchorForAxisLabel(a.config.axis_rotated, this.getY2AxisLabelPosition());
  }, f.prototype.getMaxTickWidth = function (a, b) {
    var c,
        d,
        e,
        f,
        g,
        h = this.owner,
        i = h.config,
        j = 0;return b && h.currentMaxTickWidths[a] ? h.currentMaxTickWidths[a] : (h.svg && (c = h.filterTargetsToShow(h.data.targets), "y" === a ? (d = h.y.copy().domain(h.getYDomain(c, "y")), e = this.getYAxis(d, h.yOrient, i.axis_y_tick_format, h.yAxisTickValues, !1, !0)) : "y2" === a ? (d = h.y2.copy().domain(h.getYDomain(c, "y2")), e = this.getYAxis(d, h.y2Orient, i.axis_y2_tick_format, h.y2AxisTickValues, !1, !0)) : (d = h.x.copy().domain(h.getXDomain(c)), e = this.getXAxis(d, h.xOrient, h.xAxisTickFormat, h.xAxisTickValues, !1, !0, !0), this.updateXAxisTickValues(c, e)), f = h.d3.select("body").append("div").classed("c3", !0), g = f.append("svg").style("visibility", "hidden").style("position", "fixed").style("top", 0).style("left", 0), g.append("g").call(e).each(function () {
      h.d3.select(this).selectAll("text").each(function () {
        var a = this.getBoundingClientRect();j < a.width && (j = a.width);
      }), f.remove();
    })), h.currentMaxTickWidths[a] = 0 >= j ? h.currentMaxTickWidths[a] : j, h.currentMaxTickWidths[a]);
  }, f.prototype.updateLabels = function (a) {
    var b = this.owner,
        c = b.main.select("." + l.axisX + " ." + l.axisXLabel),
        d = b.main.select("." + l.axisY + " ." + l.axisYLabel),
        e = b.main.select("." + l.axisY2 + " ." + l.axisY2Label);(a ? c.transition() : c).attr("x", this.xForXAxisLabel.bind(this)).attr("dx", this.dxForXAxisLabel.bind(this)).attr("dy", this.dyForXAxisLabel.bind(this)).text(this.textForXAxisLabel.bind(this)), (a ? d.transition() : d).attr("x", this.xForYAxisLabel.bind(this)).attr("dx", this.dxForYAxisLabel.bind(this)).attr("dy", this.dyForYAxisLabel.bind(this)).text(this.textForYAxisLabel.bind(this)), (a ? e.transition() : e).attr("x", this.xForY2AxisLabel.bind(this)).attr("dx", this.dxForY2AxisLabel.bind(this)).attr("dy", this.dyForY2AxisLabel.bind(this)).text(this.textForY2AxisLabel.bind(this));
  }, f.prototype.getPadding = function (a, b, c, d) {
    return m(a[b]) ? "ratio" === a.unit ? a[b] * d : this.convertPixelsToAxisPadding(a[b], d) : c;
  }, f.prototype.convertPixelsToAxisPadding = function (a, b) {
    var c = this.owner,
        d = c.config.axis_rotated ? c.width : c.height;return b * (a / d);
  }, f.prototype.generateTickValues = function (a, b, c) {
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k = a;if (b) if (d = n(b) ? b() : b, 1 === d) k = [a[0]];else if (2 === d) k = [a[0], a[a.length - 1]];else if (d > 2) {
      for (g = d - 2, e = a[0], f = a[a.length - 1], h = (f - e) / (g + 1), k = [e], i = 0; g > i; i++) {
        j = +e + h * (i + 1), k.push(c ? new Date(j) : j);
      }k.push(f);
    }return c || (k = k.sort(function (a, b) {
      return a - b;
    })), k;
  }, f.prototype.generateTransitions = function (a) {
    var b = this.owner,
        c = b.axes;return { axisX: a ? c.x.transition().duration(a) : c.x, axisY: a ? c.y.transition().duration(a) : c.y, axisY2: a ? c.y2.transition().duration(a) : c.y2, axisSubX: a ? c.subx.transition().duration(a) : c.subx };
  }, f.prototype.redraw = function (a, b) {
    var c = this.owner;c.axes.x.style("opacity", b ? 0 : 1), c.axes.y.style("opacity", b ? 0 : 1), c.axes.y2.style("opacity", b ? 0 : 1), c.axes.subx.style("opacity", b ? 0 : 1), a.axisX.call(c.xAxis), a.axisY.call(c.yAxis), a.axisY2.call(c.y2Axis), a.axisSubX.call(c.subXAxis);
  }, i.getClipPath = function (b) {
    var c = a.navigator.appVersion.toLowerCase().indexOf("msie 9.") >= 0;return "url(" + (c ? "" : document.URL.split("#")[0]) + "#" + b + ")";
  }, i.appendClip = function (a, b) {
    return a.append("clipPath").attr("id", b).append("rect");
  }, i.getAxisClipX = function (a) {
    var b = Math.max(30, this.margin.left);return a ? -(1 + b) : -(b - 1);
  }, i.getAxisClipY = function (a) {
    return a ? -20 : -this.margin.top;
  }, i.getXAxisClipX = function () {
    var a = this;return a.getAxisClipX(!a.config.axis_rotated);
  }, i.getXAxisClipY = function () {
    var a = this;return a.getAxisClipY(!a.config.axis_rotated);
  }, i.getYAxisClipX = function () {
    var a = this;return a.config.axis_y_inner ? -1 : a.getAxisClipX(a.config.axis_rotated);
  }, i.getYAxisClipY = function () {
    var a = this;return a.getAxisClipY(a.config.axis_rotated);
  }, i.getAxisClipWidth = function (a) {
    var b = this,
        c = Math.max(30, b.margin.left),
        d = Math.max(30, b.margin.right);return a ? b.width + 2 + c + d : b.margin.left + 20;
  }, i.getAxisClipHeight = function (a) {
    return (a ? this.margin.bottom : this.margin.top + this.height) + 20;
  }, i.getXAxisClipWidth = function () {
    var a = this;return a.getAxisClipWidth(!a.config.axis_rotated);
  }, i.getXAxisClipHeight = function () {
    var a = this;return a.getAxisClipHeight(!a.config.axis_rotated);
  }, i.getYAxisClipWidth = function () {
    var a = this;return a.getAxisClipWidth(a.config.axis_rotated) + (a.config.axis_y_inner ? 20 : 0);
  }, i.getYAxisClipHeight = function () {
    var a = this;return a.getAxisClipHeight(a.config.axis_rotated);
  }, i.initPie = function () {
    var a = this,
        b = a.d3,
        c = a.config;a.pie = b.layout.pie().value(function (a) {
      return a.values.reduce(function (a, b) {
        return a + b.value;
      }, 0);
    }), c.data_order || a.pie.sort(null);
  }, i.updateRadius = function () {
    var a = this,
        b = a.config,
        c = b.gauge_width || b.donut_width;a.radiusExpanded = Math.min(a.arcWidth, a.arcHeight) / 2, a.radius = .95 * a.radiusExpanded, a.innerRadiusRatio = c ? (a.radius - c) / a.radius : .6, a.innerRadius = a.hasType("donut") || a.hasType("gauge") ? a.radius * a.innerRadiusRatio : 0;
  }, i.updateArc = function () {
    var a = this;a.svgArc = a.getSvgArc(), a.svgArcExpanded = a.getSvgArcExpanded(), a.svgArcExpandedSub = a.getSvgArcExpanded(.98);
  }, i.updateAngle = function (a) {
    var b,
        c,
        d = this,
        e = d.config,
        f = !1,
        g = 0,
        h = e.gauge_min,
        i = e.gauge_max;
    return d.pie(d.filterTargetsToShow(d.data.targets)).forEach(function (b) {
      f || b.data.id !== a.data.id || (f = !0, a = b, a.index = g), g++;
    }), isNaN(a.startAngle) && (a.startAngle = 0), isNaN(a.endAngle) && (a.endAngle = a.startAngle), d.isGaugeType(a.data) && (b = Math.PI / (i - h), c = a.value < h ? 0 : a.value < i ? a.value - h : i - h, a.startAngle = -1 * (Math.PI / 2), a.endAngle = a.startAngle + b * c), f ? a : null;
  }, i.getSvgArc = function () {
    var a = this,
        b = a.d3.svg.arc().outerRadius(a.radius).innerRadius(a.innerRadius),
        c = function c(_c2, d) {
      var e;return d ? b(_c2) : (e = a.updateAngle(_c2), e ? b(e) : "M 0 0");
    };return c.centroid = b.centroid, c;
  }, i.getSvgArcExpanded = function (a) {
    var b = this,
        c = b.d3.svg.arc().outerRadius(b.radiusExpanded * (a ? a : 1)).innerRadius(b.innerRadius);return function (a) {
      var d = b.updateAngle(a);return d ? c(d) : "M 0 0";
    };
  }, i.getArc = function (a, b, c) {
    return c || this.isArcType(a.data) ? this.svgArc(a, b) : "M 0 0";
  }, i.transformForArcLabel = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g = this,
        h = g.updateAngle(a),
        i = "";return h && !g.hasType("gauge") && (b = this.svgArc.centroid(h), c = isNaN(b[0]) ? 0 : b[0], d = isNaN(b[1]) ? 0 : b[1], e = Math.sqrt(c * c + d * d), f = g.radius && e ? (36 / g.radius > .375 ? 1.175 - 36 / g.radius : .8) * g.radius / e : 0, i = "translate(" + c * f + "," + d * f + ")"), i;
  }, i.getArcRatio = function (a) {
    var b = this,
        c = b.hasType("gauge") ? Math.PI : 2 * Math.PI;return a ? (a.endAngle - a.startAngle) / c : null;
  }, i.convertToArcData = function (a) {
    return this.addName({ id: a.data.id, value: a.value, ratio: this.getArcRatio(a), index: a.index });
  }, i.textForArcLabel = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g = this;return g.shouldShowArcLabel() ? (b = g.updateAngle(a), c = b ? b.value : null, d = g.getArcRatio(b), e = a.data.id, g.hasType("gauge") || g.meetsArcLabelThreshold(d) ? (f = g.getArcLabelFormat(), f ? f(c, d, e) : g.defaultArcValueFormat(c, d)) : "") : "";
  }, i.expandArc = function (b) {
    var c,
        d = this;return d.transiting ? void (c = a.setInterval(function () {
      d.transiting || (a.clearInterval(c), d.legend.selectAll(".c3-legend-item-focused").size() > 0 && d.expandArc(b));
    }, 10)) : (b = d.mapToTargetIds(b), void d.svg.selectAll(d.selectorTargets(b, "." + l.chartArc)).each(function (a) {
      d.shouldExpand(a.data.id) && d.d3.select(this).selectAll("path").transition().duration(50).attr("d", d.svgArcExpanded).transition().duration(100).attr("d", d.svgArcExpandedSub).each(function (a) {
        d.isDonutType(a.data);
      });
    }));
  }, i.unexpandArc = function (a) {
    var b = this;b.transiting || (a = b.mapToTargetIds(a), b.svg.selectAll(b.selectorTargets(a, "." + l.chartArc)).selectAll("path").transition().duration(50).attr("d", b.svgArc), b.svg.selectAll("." + l.arc).style("opacity", 1));
  }, i.shouldExpand = function (a) {
    var b = this,
        c = b.config;return b.isDonutType(a) && c.donut_expand || b.isGaugeType(a) && c.gauge_expand || b.isPieType(a) && c.pie_expand;
  }, i.shouldShowArcLabel = function () {
    var a = this,
        b = a.config,
        c = !0;return a.hasType("donut") ? c = b.donut_label_show : a.hasType("pie") && (c = b.pie_label_show), c;
  }, i.meetsArcLabelThreshold = function (a) {
    var b = this,
        c = b.config,
        d = b.hasType("donut") ? c.donut_label_threshold : c.pie_label_threshold;return a >= d;
  }, i.getArcLabelFormat = function () {
    var a = this,
        b = a.config,
        c = b.pie_label_format;return a.hasType("gauge") ? c = b.gauge_label_format : a.hasType("donut") && (c = b.donut_label_format), c;
  }, i.getArcTitle = function () {
    var a = this;return a.hasType("donut") ? a.config.donut_title : "";
  }, i.updateTargetsForArc = function (a) {
    var b,
        c,
        d = this,
        e = d.main,
        f = d.classChartArc.bind(d),
        g = d.classArcs.bind(d),
        h = d.classFocus.bind(d);b = e.select("." + l.chartArcs).selectAll("." + l.chartArc).data(d.pie(a)).attr("class", function (a) {
      return f(a) + h(a.data);
    }), c = b.enter().append("g").attr("class", f), c.append("g").attr("class", g), c.append("text").attr("dy", d.hasType("gauge") ? "-.1em" : ".35em").style("opacity", 0).style("text-anchor", "middle").style("pointer-events", "none");
  }, i.initArc = function () {
    var a = this;a.arcs = a.main.select("." + l.chart).append("g").attr("class", l.chartArcs).attr("transform", a.getTranslate("arc")), a.arcs.append("text").attr("class", l.chartArcsTitle).style("text-anchor", "middle").text(a.getArcTitle());
  }, i.redrawArc = function (a, b, c) {
    var d,
        e = this,
        f = e.d3,
        g = e.config,
        h = e.main;d = h.selectAll("." + l.arcs).selectAll("." + l.arc).data(e.arcData.bind(e)), d.enter().append("path").attr("class", e.classArc.bind(e)).style("fill", function (a) {
      return e.color(a.data);
    }).style("cursor", function (a) {
      return g.interaction_enabled && g.data_selection_isselectable(a) ? "pointer" : null;
    }).style("opacity", 0).each(function (a) {
      e.isGaugeType(a.data) && (a.startAngle = a.endAngle = -1 * (Math.PI / 2)), this._current = a;
    }), d.attr("transform", function (a) {
      return !e.isGaugeType(a.data) && c ? "scale(0)" : "";
    }).style("opacity", function (a) {
      return a === this._current ? 0 : 1;
    }).on("mouseover", g.interaction_enabled ? function (a) {
      var b, c;e.transiting || (b = e.updateAngle(a), c = e.convertToArcData(b), e.expandArc(b.data.id), e.api.focus(b.data.id), e.toggleFocusLegend(b.data.id, !0), e.config.data_onmouseover(c, this));
    } : null).on("mousemove", g.interaction_enabled ? function (a) {
      var b = e.updateAngle(a),
          c = e.convertToArcData(b),
          d = [c];e.showTooltip(d, this);
    } : null).on("mouseout", g.interaction_enabled ? function (a) {
      var b, c;e.transiting || (b = e.updateAngle(a), c = e.convertToArcData(b), e.unexpandArc(b.data.id), e.api.revert(), e.revertLegend(), e.hideTooltip(), e.config.data_onmouseout(c, this));
    } : null).on("click", g.interaction_enabled ? function (a, b) {
      var c = e.updateAngle(a),
          d = e.convertToArcData(c);e.toggleShape && e.toggleShape(this, d, b), e.config.data_onclick.call(e.api, d, this);
    } : null).each(function () {
      e.transiting = !0;
    }).transition().duration(a).attrTween("d", function (a) {
      var b,
          c = e.updateAngle(a);return c ? (isNaN(this._current.startAngle) && (this._current.startAngle = 0), isNaN(this._current.endAngle) && (this._current.endAngle = this._current.startAngle), b = f.interpolate(this._current, c), this._current = b(0), function (c) {
        var d = b(c);return d.data = a.data, e.getArc(d, !0);
      }) : function () {
        return "M 0 0";
      };
    }).attr("transform", c ? "scale(1)" : "").style("fill", function (a) {
      return e.levelColor ? e.levelColor(a.data.values[0].value) : e.color(a.data.id);
    }).style("opacity", 1).call(e.endall, function () {
      e.transiting = !1;
    }), d.exit().transition().duration(b).style("opacity", 0).remove(), h.selectAll("." + l.chartArc).select("text").style("opacity", 0).attr("class", function (a) {
      return e.isGaugeType(a.data) ? l.gaugeValue : "";
    }).text(e.textForArcLabel.bind(e)).attr("transform", e.transformForArcLabel.bind(e)).style("font-size", function (a) {
      return e.isGaugeType(a.data) ? Math.round(e.radius / 5) + "px" : "";
    }).transition().duration(a).style("opacity", function (a) {
      return e.isTargetToShow(a.data.id) && e.isArcType(a.data) ? 1 : 0;
    }), h.select("." + l.chartArcsTitle).style("opacity", e.hasType("donut") || e.hasType("gauge") ? 1 : 0), e.hasType("gauge") && (e.arcs.select("." + l.chartArcsBackground).attr("d", function () {
      var a = { data: [{ value: g.gauge_max }], startAngle: -1 * (Math.PI / 2), endAngle: Math.PI / 2 };return e.getArc(a, !0, !0);
    }), e.arcs.select("." + l.chartArcsGaugeUnit).attr("dy", ".75em").text(g.gauge_label_show ? g.gauge_units : ""), e.arcs.select("." + l.chartArcsGaugeMin).attr("dx", -1 * (e.innerRadius + (e.radius - e.innerRadius) / 2) + "px").attr("dy", "1.2em").text(g.gauge_label_show ? g.gauge_min : ""), e.arcs.select("." + l.chartArcsGaugeMax).attr("dx", e.innerRadius + (e.radius - e.innerRadius) / 2 + "px").attr("dy", "1.2em").text(g.gauge_label_show ? g.gauge_max : ""));
  }, i.initGauge = function () {
    var a = this.arcs;this.hasType("gauge") && (a.append("path").attr("class", l.chartArcsBackground), a.append("text").attr("class", l.chartArcsGaugeUnit).style("text-anchor", "middle").style("pointer-events", "none"), a.append("text").attr("class", l.chartArcsGaugeMin).style("text-anchor", "middle").style("pointer-events", "none"), a.append("text").attr("class", l.chartArcsGaugeMax).style("text-anchor", "middle").style("pointer-events", "none"));
  }, i.getGaugeLabelHeight = function () {
    return this.config.gauge_label_show ? 20 : 0;
  }, i.initRegion = function () {
    var a = this;a.region = a.main.append("g").attr("clip-path", a.clipPath).attr("class", l.regions);
  }, i.updateRegion = function (a) {
    var b = this,
        c = b.config;b.region.style("visibility", b.hasArcType() ? "hidden" : "visible"), b.mainRegion = b.main.select("." + l.regions).selectAll("." + l.region).data(c.regions), b.mainRegion.enter().append("g").attr("class", b.classRegion.bind(b)).append("rect").style("fill-opacity", 0), b.mainRegion.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawRegion = function (a) {
    var b = this,
        c = b.mainRegion.selectAll("rect"),
        d = b.regionX.bind(b),
        e = b.regionY.bind(b),
        f = b.regionWidth.bind(b),
        g = b.regionHeight.bind(b);return [(a ? c.transition() : c).attr("x", d).attr("y", e).attr("width", f).attr("height", g).style("fill-opacity", function (a) {
      return m(a.opacity) ? a.opacity : .1;
    })];
  }, i.regionX = function (a) {
    var b,
        c = this,
        d = c.config,
        e = "y" === a.axis ? c.y : c.y2;return b = "y" === a.axis || "y2" === a.axis ? d.axis_rotated && "start" in a ? e(a.start) : 0 : d.axis_rotated ? 0 : "start" in a ? c.x(c.isTimeSeries() ? c.parseDate(a.start) : a.start) : 0;
  }, i.regionY = function (a) {
    var b,
        c = this,
        d = c.config,
        e = "y" === a.axis ? c.y : c.y2;return b = "y" === a.axis || "y2" === a.axis ? d.axis_rotated ? 0 : "end" in a ? e(a.end) : 0 : d.axis_rotated && "start" in a ? c.x(c.isTimeSeries() ? c.parseDate(a.start) : a.start) : 0;
  }, i.regionWidth = function (a) {
    var b,
        c = this,
        d = c.config,
        e = c.regionX(a),
        f = "y" === a.axis ? c.y : c.y2;return b = "y" === a.axis || "y2" === a.axis ? d.axis_rotated && "end" in a ? f(a.end) : c.width : d.axis_rotated ? c.width : "end" in a ? c.x(c.isTimeSeries() ? c.parseDate(a.end) : a.end) : c.width, e > b ? 0 : b - e;
  }, i.regionHeight = function (a) {
    var b,
        c = this,
        d = c.config,
        e = this.regionY(a),
        f = "y" === a.axis ? c.y : c.y2;return b = "y" === a.axis || "y2" === a.axis ? d.axis_rotated ? c.height : "start" in a ? f(a.start) : c.height : d.axis_rotated && "end" in a ? c.x(c.isTimeSeries() ? c.parseDate(a.end) : a.end) : c.height, e > b ? 0 : b - e;
  }, i.isRegionOnX = function (a) {
    return !a.axis || "x" === a.axis;
  }, i.drag = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j = this,
        k = j.config,
        m = j.main,
        n = j.d3;j.hasArcType() || k.data_selection_enabled && (!k.zoom_enabled || j.zoom.altDomain) && k.data_selection_multiple && (b = j.dragStart[0], c = j.dragStart[1], d = a[0], e = a[1], f = Math.min(b, d), g = Math.max(b, d), h = k.data_selection_grouped ? j.margin.top : Math.min(c, e), i = k.data_selection_grouped ? j.height : Math.max(c, e), m.select("." + l.dragarea).attr("x", f).attr("y", h).attr("width", g - f).attr("height", i - h), m.selectAll("." + l.shapes).selectAll("." + l.shape).filter(function (a) {
      return k.data_selection_isselectable(a);
    }).each(function (a, b) {
      var c,
          d,
          e,
          k,
          m,
          o,
          p = n.select(this),
          q = p.classed(l.SELECTED),
          r = p.classed(l.INCLUDED),
          s = !1;if (p.classed(l.circle)) c = 1 * p.attr("cx"), d = 1 * p.attr("cy"), m = j.togglePoint, s = c > f && g > c && d > h && i > d;else {
        if (!p.classed(l.bar)) return;o = y(this), c = o.x, d = o.y, e = o.width, k = o.height, m = j.togglePath, s = !(c > g || f > c + e || d > i || h > d + k);
      }s ^ r && (p.classed(l.INCLUDED, !r), p.classed(l.SELECTED, !q), m.call(j, !q, p, a, b));
    }));
  }, i.dragstart = function (a) {
    var b = this,
        c = b.config;b.hasArcType() || c.data_selection_enabled && (b.dragStart = a, b.main.select("." + l.chart).append("rect").attr("class", l.dragarea).style("opacity", .1), b.dragging = !0);
  }, i.dragend = function () {
    var a = this,
        b = a.config;a.hasArcType() || b.data_selection_enabled && (a.main.select("." + l.dragarea).transition().duration(100).style("opacity", 0).remove(), a.main.selectAll("." + l.shape).classed(l.INCLUDED, !1), a.dragging = !1);
  }, i.selectPoint = function (a, b, c) {
    var d = this,
        e = d.config,
        f = (e.axis_rotated ? d.circleY : d.circleX).bind(d),
        g = (e.axis_rotated ? d.circleX : d.circleY).bind(d),
        h = d.pointSelectR.bind(d);e.data_onselected.call(d.api, b, a.node()), d.main.select("." + l.selectedCircles + d.getTargetSelectorSuffix(b.id)).selectAll("." + l.selectedCircle + "-" + c).data([b]).enter().append("circle").attr("class", function () {
      return d.generateClass(l.selectedCircle, c);
    }).attr("cx", f).attr("cy", g).attr("stroke", function () {
      return d.color(b);
    }).attr("r", function (a) {
      return 1.4 * d.pointSelectR(a);
    }).transition().duration(100).attr("r", h);
  }, i.unselectPoint = function (a, b, c) {
    var d = this;d.config.data_onunselected(b, a.node()), d.main.select("." + l.selectedCircles + d.getTargetSelectorSuffix(b.id)).selectAll("." + l.selectedCircle + "-" + c).transition().duration(100).attr("r", 0).remove();
  }, i.togglePoint = function (a, b, c, d) {
    a ? this.selectPoint(b, c, d) : this.unselectPoint(b, c, d);
  }, i.selectPath = function (a, b) {
    var c = this;c.config.data_onselected.call(c, b, a.node()), a.transition().duration(100).style("fill", function () {
      return c.d3.rgb(c.color(b)).brighter(.75);
    });
  }, i.unselectPath = function (a, b) {
    var c = this;c.config.data_onunselected.call(c, b, a.node()), a.transition().duration(100).style("fill", function () {
      return c.color(b);
    });
  }, i.togglePath = function (a, b, c, d) {
    a ? this.selectPath(b, c, d) : this.unselectPath(b, c, d);
  }, i.getToggle = function (a, b) {
    var c,
        d = this;return "circle" === a.nodeName ? c = d.isStepType(b) ? function () {} : d.togglePoint : "path" === a.nodeName && (c = d.togglePath), c;
  }, i.toggleShape = function (a, b, c) {
    var d = this,
        e = d.d3,
        f = d.config,
        g = e.select(a),
        h = g.classed(l.SELECTED),
        i = d.getToggle(a, b).bind(d);f.data_selection_enabled && f.data_selection_isselectable(b) && (f.data_selection_multiple || d.main.selectAll("." + l.shapes + (f.data_selection_grouped ? d.getTargetSelectorSuffix(b.id) : "")).selectAll("." + l.shape).each(function (a, b) {
      var c = e.select(this);c.classed(l.SELECTED) && i(!1, c.classed(l.SELECTED, !1), a, b);
    }), g.classed(l.SELECTED, !h), i(!h, g, b, c));
  }, i.initBrush = function () {
    var a = this,
        b = a.d3;a.brush = b.svg.brush().on("brush", function () {
      a.redrawForBrush();
    }), a.brush.update = function () {
      return a.context && a.context.select("." + l.brush).call(this), this;
    }, a.brush.scale = function (b) {
      return a.config.axis_rotated ? this.y(b) : this.x(b);
    };
  }, i.initSubchart = function () {
    var a = this,
        b = a.config,
        c = a.context = a.svg.append("g").attr("transform", a.getTranslate("context"));c.style("visibility", b.subchart_show ? "visible" : "hidden"), c.append("g").attr("clip-path", a.clipPathForSubchart).attr("class", l.chart), c.select("." + l.chart).append("g").attr("class", l.chartBars), c.select("." + l.chart).append("g").attr("class", l.chartLines), c.append("g").attr("clip-path", a.clipPath).attr("class", l.brush).call(a.brush), a.axes.subx = c.append("g").attr("class", l.axisX).attr("transform", a.getTranslate("subx")).attr("clip-path", b.axis_rotated ? "" : a.clipPathForXAxis);
  }, i.updateTargetsForSubchart = function (a) {
    var b,
        c,
        d,
        e,
        f = this,
        g = f.context,
        h = f.config,
        i = f.classChartBar.bind(f),
        j = f.classBars.bind(f),
        k = f.classChartLine.bind(f),
        m = f.classLines.bind(f),
        n = f.classAreas.bind(f);h.subchart_show && (e = g.select("." + l.chartBars).selectAll("." + l.chartBar).data(a).attr("class", i), d = e.enter().append("g").style("opacity", 0).attr("class", i), d.append("g").attr("class", j), c = g.select("." + l.chartLines).selectAll("." + l.chartLine).data(a).attr("class", k), b = c.enter().append("g").style("opacity", 0).attr("class", k), b.append("g").attr("class", m), b.append("g").attr("class", n), g.selectAll("." + l.brush + " rect").attr(h.axis_rotated ? "width" : "height", h.axis_rotated ? f.width2 : f.height2));
  }, i.updateBarForSubchart = function (a) {
    var b = this;b.contextBar = b.context.selectAll("." + l.bars).selectAll("." + l.bar).data(b.barData.bind(b)), b.contextBar.enter().append("path").attr("class", b.classBar.bind(b)).style("stroke", "none").style("fill", b.color), b.contextBar.style("opacity", b.initialOpacity.bind(b)), b.contextBar.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawBarForSubchart = function (a, b, c) {
    (b ? this.contextBar.transition().duration(c) : this.contextBar).attr("d", a).style("opacity", 1);
  }, i.updateLineForSubchart = function (a) {
    var b = this;b.contextLine = b.context.selectAll("." + l.lines).selectAll("." + l.line).data(b.lineData.bind(b)), b.contextLine.enter().append("path").attr("class", b.classLine.bind(b)).style("stroke", b.color), b.contextLine.style("opacity", b.initialOpacity.bind(b)), b.contextLine.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawLineForSubchart = function (a, b, c) {
    (b ? this.contextLine.transition().duration(c) : this.contextLine).attr("d", a).style("opacity", 1);
  }, i.updateAreaForSubchart = function (a) {
    var b = this,
        c = b.d3;b.contextArea = b.context.selectAll("." + l.areas).selectAll("." + l.area).data(b.lineData.bind(b)), b.contextArea.enter().append("path").attr("class", b.classArea.bind(b)).style("fill", b.color).style("opacity", function () {
      return b.orgAreaOpacity = +c.select(this).style("opacity"), 0;
    }), b.contextArea.style("opacity", 0), b.contextArea.exit().transition().duration(a).style("opacity", 0).remove();
  }, i.redrawAreaForSubchart = function (a, b, c) {
    (b ? this.contextArea.transition().duration(c) : this.contextArea).attr("d", a).style("fill", this.color).style("opacity", this.orgAreaOpacity);
  }, i.redrawSubchart = function (a, b, c, d, e, f, g) {
    var h,
        i,
        j,
        k = this,
        l = k.d3,
        m = k.config;k.context.style("visibility", m.subchart_show ? "visible" : "hidden"), m.subchart_show && (l.event && "zoom" === l.event.type && k.brush.extent(k.x.orgDomain()).update(), a && (k.brush.empty() || k.brush.extent(k.x.orgDomain()).update(), h = k.generateDrawArea(e, !0), i = k.generateDrawBar(f, !0), j = k.generateDrawLine(g, !0), k.updateBarForSubchart(c), k.updateLineForSubchart(c), k.updateAreaForSubchart(c), k.redrawBarForSubchart(i, c, c), k.redrawLineForSubchart(j, c, c), k.redrawAreaForSubchart(h, c, c)));
  }, i.redrawForBrush = function () {
    var a = this,
        b = a.x;a.redraw({ withTransition: !1, withY: a.config.zoom_rescale, withSubchart: !1, withUpdateXDomain: !0, withDimension: !1 }), a.config.subchart_onbrush.call(a.api, b.orgDomain());
  }, i.transformContext = function (a, b) {
    var c,
        d = this;b && b.axisSubX ? c = b.axisSubX : (c = d.context.select("." + l.axisX), a && (c = c.transition())), d.context.attr("transform", d.getTranslate("context")), c.attr("transform", d.getTranslate("subx"));
  }, i.getDefaultExtent = function () {
    var a = this,
        b = a.config,
        c = n(b.axis_x_extent) ? b.axis_x_extent(a.getXDomain(a.data.targets)) : b.axis_x_extent;return a.isTimeSeries() && (c = [a.parseDate(c[0]), a.parseDate(c[1])]), c;
  }, i.initZoom = function () {
    var a,
        b = this,
        c = b.d3,
        d = b.config;b.zoom = c.behavior.zoom().on("zoomstart", function () {
      a = c.event.sourceEvent, b.zoom.altDomain = c.event.sourceEvent.altKey ? b.x.orgDomain() : null, d.zoom_onzoomstart.call(b.api, c.event.sourceEvent);
    }).on("zoom", function () {
      b.redrawForZoom.call(b);
    }).on("zoomend", function () {
      var e = c.event.sourceEvent;e && a.clientX === e.clientX && a.clientY === e.clientY || (b.redrawEventRect(), b.updateZoom(), d.zoom_onzoomend.call(b.api, b.x.orgDomain()));
    }), b.zoom.scale = function (a) {
      return d.axis_rotated ? this.y(a) : this.x(a);
    }, b.zoom.orgScaleExtent = function () {
      var a = d.zoom_extent ? d.zoom_extent : [1, 10];return [a[0], Math.max(b.getMaxDataCount() / a[1], a[1])];
    }, b.zoom.updateScaleExtent = function () {
      var a = t(b.x.orgDomain()) / t(b.orgXDomain),
          c = this.orgScaleExtent();return this.scaleExtent([c[0] * a, c[1] * a]), this;
    };
  }, i.updateZoom = function () {
    var a = this,
        b = a.config.zoom_enabled ? a.zoom : function () {};a.main.select("." + l.zoomRect).call(b).on("dblclick.zoom", null), a.main.selectAll("." + l.eventRect).call(b).on("dblclick.zoom", null);
  }, i.redrawForZoom = function () {
    var a = this,
        b = a.d3,
        c = a.config,
        d = a.zoom,
        e = a.x;if (c.zoom_enabled && 0 !== a.filterTargetsToShow(a.data.targets).length) {
      if ("mousemove" === b.event.sourceEvent.type && d.altDomain) return e.domain(d.altDomain), void d.scale(e).updateScaleExtent();a.isCategorized() && e.orgDomain()[0] === a.orgXDomain[0] && e.domain([a.orgXDomain[0] - 1e-10, e.orgDomain()[1]]), a.redraw({ withTransition: !1, withY: c.zoom_rescale, withSubchart: !1, withEventRect: !1, withDimension: !1 }), "mousemove" === b.event.sourceEvent.type && (a.cancelClick = !0), c.zoom_onzoom.call(a.api, e.orgDomain());
    }
  }, i.generateColor = function () {
    var a = this,
        b = a.config,
        c = a.d3,
        d = b.data_colors,
        e = v(b.color_pattern) ? b.color_pattern : c.scale.category10().range(),
        f = b.data_color,
        g = [];return function (a) {
      var b,
          c = a.id || a.data && a.data.id || a;return d[c] instanceof Function ? b = d[c](a) : d[c] ? b = d[c] : (g.indexOf(c) < 0 && g.push(c), b = e[g.indexOf(c) % e.length], d[c] = b), f instanceof Function ? f(b, a) : b;
    };
  }, i.generateLevelColor = function () {
    var a = this,
        b = a.config,
        c = b.color_pattern,
        d = b.color_threshold,
        e = "value" === d.unit,
        f = d.values && d.values.length ? d.values : [],
        g = d.max || 100;return v(b.color_threshold) ? function (a) {
      var b,
          d,
          h = c[c.length - 1];for (b = 0; b < f.length; b++) {
        if (d = e ? a : 100 * a / g, d < f[b]) {
          h = c[b];break;
        }
      }return h;
    } : null;
  }, i.getYFormat = function (a) {
    var b = this,
        c = a && !b.hasType("gauge") ? b.defaultArcValueFormat : b.yFormat,
        d = a && !b.hasType("gauge") ? b.defaultArcValueFormat : b.y2Format;return function (a, e, f) {
      var g = "y2" === b.axis.getId(f) ? d : c;return g.call(b, a, e);
    };
  }, i.yFormat = function (a) {
    var b = this,
        c = b.config,
        d = c.axis_y_tick_format ? c.axis_y_tick_format : b.defaultValueFormat;return d(a);
  }, i.y2Format = function (a) {
    var b = this,
        c = b.config,
        d = c.axis_y2_tick_format ? c.axis_y2_tick_format : b.defaultValueFormat;return d(a);
  }, i.defaultValueFormat = function (a) {
    return m(a) ? +a : "";
  }, i.defaultArcValueFormat = function (a, b) {
    return (100 * b).toFixed(1) + "%";
  }, i.dataLabelFormat = function (a) {
    var b,
        c = this,
        d = c.config.data_labels,
        e = function e(a) {
      return m(a) ? +a : "";
    };return b = "function" == typeof d.format ? d.format : "object" == _typeof(d.format) ? d.format[a] ? d.format[a] === !0 ? e : d.format[a] : function () {
      return "";
    } : e;
  }, i.hasCaches = function (a) {
    for (var b = 0; b < a.length; b++) {
      if (!(a[b] in this.cache)) return !1;
    }return !0;
  }, i.addCache = function (a, b) {
    this.cache[a] = this.cloneTarget(b);
  }, i.getCaches = function (a) {
    var b,
        c = [];for (b = 0; b < a.length; b++) {
      a[b] in this.cache && c.push(this.cloneTarget(this.cache[a[b]]));
    }return c;
  };var l = i.CLASS = { target: "c3-target", chart: "c3-chart", chartLine: "c3-chart-line", chartLines: "c3-chart-lines", chartBar: "c3-chart-bar", chartBars: "c3-chart-bars", chartText: "c3-chart-text", chartTexts: "c3-chart-texts", chartArc: "c3-chart-arc", chartArcs: "c3-chart-arcs", chartArcsTitle: "c3-chart-arcs-title", chartArcsBackground: "c3-chart-arcs-background", chartArcsGaugeUnit: "c3-chart-arcs-gauge-unit", chartArcsGaugeMax: "c3-chart-arcs-gauge-max", chartArcsGaugeMin: "c3-chart-arcs-gauge-min", selectedCircle: "c3-selected-circle", selectedCircles: "c3-selected-circles", eventRect: "c3-event-rect", eventRects: "c3-event-rects", eventRectsSingle: "c3-event-rects-single", eventRectsMultiple: "c3-event-rects-multiple", zoomRect: "c3-zoom-rect", brush: "c3-brush", focused: "c3-focused", defocused: "c3-defocused", region: "c3-region", regions: "c3-regions", tooltipContainer: "c3-tooltip-container", tooltip: "c3-tooltip", tooltipName: "c3-tooltip-name", shape: "c3-shape", shapes: "c3-shapes", line: "c3-line", lines: "c3-lines", bar: "c3-bar", bars: "c3-bars", circle: "c3-circle", circles: "c3-circles", arc: "c3-arc", arcs: "c3-arcs", area: "c3-area", areas: "c3-areas", empty: "c3-empty", text: "c3-text", texts: "c3-texts", gaugeValue: "c3-gauge-value", grid: "c3-grid", gridLines: "c3-grid-lines", xgrid: "c3-xgrid", xgrids: "c3-xgrids", xgridLine: "c3-xgrid-line", xgridLines: "c3-xgrid-lines", xgridFocus: "c3-xgrid-focus", ygrid: "c3-ygrid", ygrids: "c3-ygrids", ygridLine: "c3-ygrid-line", ygridLines: "c3-ygrid-lines", axis: "c3-axis", axisX: "c3-axis-x", axisXLabel: "c3-axis-x-label", axisY: "c3-axis-y", axisYLabel: "c3-axis-y-label", axisY2: "c3-axis-y2", axisY2Label: "c3-axis-y2-label", legendBackground: "c3-legend-background", legendItem: "c3-legend-item", legendItemEvent: "c3-legend-item-event", legendItemTile: "c3-legend-item-tile", legendItemHidden: "c3-legend-item-hidden", legendItemFocused: "c3-legend-item-focused", dragarea: "c3-dragarea", EXPANDED: "_expanded_", SELECTED: "_selected_", INCLUDED: "_included_" };i.generateClass = function (a, b) {
    return " " + a + " " + a + this.getTargetSelectorSuffix(b);
  }, i.classText = function (a) {
    return this.generateClass(l.text, a.index);
  }, i.classTexts = function (a) {
    return this.generateClass(l.texts, a.id);
  }, i.classShape = function (a) {
    return this.generateClass(l.shape, a.index);
  }, i.classShapes = function (a) {
    return this.generateClass(l.shapes, a.id);
  }, i.classLine = function (a) {
    return this.classShape(a) + this.generateClass(l.line, a.id);
  }, i.classLines = function (a) {
    return this.classShapes(a) + this.generateClass(l.lines, a.id);
  }, i.classCircle = function (a) {
    return this.classShape(a) + this.generateClass(l.circle, a.index);
  }, i.classCircles = function (a) {
    return this.classShapes(a) + this.generateClass(l.circles, a.id);
  }, i.classBar = function (a) {
    return this.classShape(a) + this.generateClass(l.bar, a.index);
  }, i.classBars = function (a) {
    return this.classShapes(a) + this.generateClass(l.bars, a.id);
  }, i.classArc = function (a) {
    return this.classShape(a.data) + this.generateClass(l.arc, a.data.id);
  }, i.classArcs = function (a) {
    return this.classShapes(a.data) + this.generateClass(l.arcs, a.data.id);
  }, i.classArea = function (a) {
    return this.classShape(a) + this.generateClass(l.area, a.id);
  }, i.classAreas = function (a) {
    return this.classShapes(a) + this.generateClass(l.areas, a.id);
  }, i.classRegion = function (a, b) {
    return this.generateClass(l.region, b) + " " + ("class" in a ? a["class"] : "");
  }, i.classEvent = function (a) {
    return this.generateClass(l.eventRect, a.index);
  }, i.classTarget = function (a) {
    var b = this,
        c = b.config.data_classes[a],
        d = "";return c && (d = " " + l.target + "-" + c), b.generateClass(l.target, a) + d;
  }, i.classFocus = function (a) {
    return this.classFocused(a) + this.classDefocused(a);
  }, i.classFocused = function (a) {
    return " " + (this.focusedTargetIds.indexOf(a.id) >= 0 ? l.focused : "");
  }, i.classDefocused = function (a) {
    return " " + (this.defocusedTargetIds.indexOf(a.id) >= 0 ? l.defocused : "");
  }, i.classChartText = function (a) {
    return l.chartText + this.classTarget(a.id);
  }, i.classChartLine = function (a) {
    return l.chartLine + this.classTarget(a.id);
  }, i.classChartBar = function (a) {
    return l.chartBar + this.classTarget(a.id);
  }, i.classChartArc = function (a) {
    return l.chartArc + this.classTarget(a.data.id);
  }, i.getTargetSelectorSuffix = function (a) {
    return a || 0 === a ? ("-" + a).replace(/[\s?!@#$%^&*()_=+,.<>'":;\[\]\/|~`{}\\]/g, "-") : "";
  }, i.selectorTarget = function (a, b) {
    return (b || "") + "." + l.target + this.getTargetSelectorSuffix(a);
  }, i.selectorTargets = function (a, b) {
    var c = this;return a = a || [], a.length ? a.map(function (a) {
      return c.selectorTarget(a, b);
    }) : null;
  }, i.selectorLegend = function (a) {
    return "." + l.legendItem + this.getTargetSelectorSuffix(a);
  }, i.selectorLegends = function (a) {
    var b = this;return a && a.length ? a.map(function (a) {
      return b.selectorLegend(a);
    }) : null;
  };var m = i.isValue = function (a) {
    return a || 0 === a;
  },
      n = i.isFunction = function (a) {
    return "function" == typeof a;
  },
      o = i.isString = function (a) {
    return "string" == typeof a;
  },
      p = i.isUndefined = function (a) {
    return "undefined" == typeof a;
  },
      q = i.isDefined = function (a) {
    return "undefined" != typeof a;
  },
      r = i.ceil10 = function (a) {
    return 10 * Math.ceil(a / 10);
  },
      s = i.asHalfPixel = function (a) {
    return Math.ceil(a) + .5;
  },
      t = i.diffDomain = function (a) {
    return a[1] - a[0];
  },
      u = i.isEmpty = function (a) {
    return !a || o(a) && 0 === a.length || "object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) && 0 === Object.keys(a).length;
  },
      v = i.notEmpty = function (a) {
    return Object.keys(a).length > 0;
  },
      w = i.getOption = function (a, b, c) {
    return q(a[b]) ? a[b] : c;
  },
      x = i.hasValue = function (a, b) {
    var c = !1;return Object.keys(a).forEach(function (d) {
      a[d] === b && (c = !0);
    }), c;
  },
      y = i.getPathBox = function (a) {
    var b = a.getBoundingClientRect(),
        c = [a.pathSegList.getItem(0), a.pathSegList.getItem(1)],
        d = c[0].x,
        e = Math.min(c[0].y, c[1].y);return { x: d, y: e, width: b.width, height: b.height };
  };h.focus = function (a) {
    var b,
        c = this.internal;a = c.mapToTargetIds(a), b = c.svg.selectAll(c.selectorTargets(a.filter(c.isTargetToShow, c))), this.revert(), this.defocus(), b.classed(l.focused, !0).classed(l.defocused, !1), c.hasArcType() && c.expandArc(a), c.toggleFocusLegend(a, !0), c.focusedTargetIds = a, c.defocusedTargetIds = c.defocusedTargetIds.filter(function (b) {
      return a.indexOf(b) < 0;
    });
  }, h.defocus = function (a) {
    var b,
        c = this.internal;a = c.mapToTargetIds(a), b = c.svg.selectAll(c.selectorTargets(a.filter(c.isTargetToShow, c))), b.classed(l.focused, !1).classed(l.defocused, !0), c.hasArcType() && c.unexpandArc(a), c.toggleFocusLegend(a, !1), c.focusedTargetIds = c.focusedTargetIds.filter(function (b) {
      return a.indexOf(b) < 0;
    }), c.defocusedTargetIds = a;
  }, h.revert = function (a) {
    var b,
        c = this.internal;a = c.mapToTargetIds(a), b = c.svg.selectAll(c.selectorTargets(a)), b.classed(l.focused, !1).classed(l.defocused, !1), c.hasArcType() && c.unexpandArc(a), c.config.legend_show && (c.showLegend(a.filter(c.isLegendToShow.bind(c))), c.legend.selectAll(c.selectorLegends(a)).filter(function () {
      return c.d3.select(this).classed(l.legendItemFocused);
    }).classed(l.legendItemFocused, !1)), c.focusedTargetIds = [], c.defocusedTargetIds = [];
  }, h.show = function (a, b) {
    var c,
        d = this.internal;a = d.mapToTargetIds(a), b = b || {}, d.removeHiddenTargetIds(a), c = d.svg.selectAll(d.selectorTargets(a)), c.transition().style("opacity", 1, "important").call(d.endall, function () {
      c.style("opacity", null).style("opacity", 1);
    }), b.withLegend && d.showLegend(a), d.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0, withLegend: !0 });
  }, h.hide = function (a, b) {
    var c,
        d = this.internal;a = d.mapToTargetIds(a), b = b || {}, d.addHiddenTargetIds(a), c = d.svg.selectAll(d.selectorTargets(a)), c.transition().style("opacity", 0, "important").call(d.endall, function () {
      c.style("opacity", null).style("opacity", 0);
    }), b.withLegend && d.hideLegend(a), d.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0, withLegend: !0 });
  }, h.toggle = function (a, b) {
    var c = this,
        d = this.internal;d.mapToTargetIds(a).forEach(function (a) {
      d.isTargetToShow(a) ? c.hide(a, b) : c.show(a, b);
    });
  }, h.zoom = function (a) {
    var b = this.internal;return a && (b.isTimeSeries() && (a = a.map(function (a) {
      return b.parseDate(a);
    })), b.brush.extent(a), b.redraw({ withUpdateXDomain: !0, withY: b.config.zoom_rescale }), b.config.zoom_onzoom.call(this, b.x.orgDomain())), b.brush.extent();
  }, h.zoom.enable = function (a) {
    var b = this.internal;b.config.zoom_enabled = a, b.updateAndRedraw();
  }, h.unzoom = function () {
    var a = this.internal;a.brush.clear().update(), a.redraw({ withUpdateXDomain: !0 });
  }, h.load = function (a) {
    var b = this.internal,
        c = b.config;return a.xs && b.addXs(a.xs), "classes" in a && Object.keys(a.classes).forEach(function (b) {
      c.data_classes[b] = a.classes[b];
    }), "categories" in a && b.isCategorized() && (c.axis_x_categories = a.categories), "axes" in a && Object.keys(a.axes).forEach(function (b) {
      c.data_axes[b] = a.axes[b];
    }), "colors" in a && Object.keys(a.colors).forEach(function (b) {
      c.data_colors[b] = a.colors[b];
    }), "cacheIds" in a && b.hasCaches(a.cacheIds) ? void b.load(b.getCaches(a.cacheIds), a.done) : void ("unload" in a ? b.unload(b.mapToTargetIds("boolean" == typeof a.unload && a.unload ? null : a.unload), function () {
      b.loadFromArgs(a);
    }) : b.loadFromArgs(a));
  }, h.unload = function (a) {
    var b = this.internal;a = a || {}, a instanceof Array ? a = { ids: a } : "string" == typeof a && (a = { ids: [a] }), b.unload(b.mapToTargetIds(a.ids), function () {
      b.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0, withLegend: !0 }), a.done && a.done();
    });
  }, h.flow = function (a) {
    var b,
        c,
        d,
        e,
        f,
        g,
        h,
        i,
        j = this.internal,
        k = [],
        l = j.getMaxDataCount(),
        n = 0,
        o = 0;if (a.json) c = j.convertJsonToData(a.json, a.keys);else if (a.rows) c = j.convertRowsToData(a.rows);else {
      if (!a.columns) return;c = j.convertColumnsToData(a.columns);
    }b = j.convertDataToTargets(c, !0), j.data.targets.forEach(function (a) {
      var c,
          d,
          e = !1;for (c = 0; c < b.length; c++) {
        if (a.id === b[c].id) {
          for (e = !0, a.values[a.values.length - 1] && (o = a.values[a.values.length - 1].index + 1), n = b[c].values.length, d = 0; n > d; d++) {
            b[c].values[d].index = o + d, j.isTimeSeries() || (b[c].values[d].x = o + d);
          }a.values = a.values.concat(b[c].values), b.splice(c, 1);break;
        }
      }e || k.push(a.id);
    }), j.data.targets.forEach(function (a) {
      var b, c;for (b = 0; b < k.length; b++) {
        if (a.id === k[b]) for (o = a.values[a.values.length - 1].index + 1, c = 0; n > c; c++) {
          a.values.push({ id: a.id, index: o + c, x: j.isTimeSeries() ? j.getOtherTargetX(o + c) : o + c, value: null });
        }
      }
    }), j.data.targets.length && b.forEach(function (a) {
      var b,
          c = [];for (b = j.data.targets[0].values[0].index; o > b; b++) {
        c.push({ id: a.id, index: b, x: j.isTimeSeries() ? j.getOtherTargetX(b) : b, value: null });
      }a.values.forEach(function (a) {
        a.index += o, j.isTimeSeries() || (a.x += o);
      }), a.values = c.concat(a.values);
    }), j.data.targets = j.data.targets.concat(b), d = j.getMaxDataCount(), f = j.data.targets[0], g = f.values[0], q(a.to) ? (n = 0, i = j.isTimeSeries() ? j.parseDate(a.to) : a.to, f.values.forEach(function (a) {
      a.x < i && n++;
    })) : q(a.length) && (n = a.length), l ? 1 === l && j.isTimeSeries() && (h = (f.values[f.values.length - 1].x - g.x) / 2, e = [new Date(+g.x - h), new Date(+g.x + h)], j.updateXDomain(null, !0, !0, !1, e)) : (h = j.isTimeSeries() ? f.values.length > 1 ? f.values[f.values.length - 1].x - g.x : g.x - j.getXDomain(j.data.targets)[0] : 1, e = [g.x - h, g.x], j.updateXDomain(null, !0, !0, !1, e)), j.updateTargets(j.data.targets), j.redraw({ flow: { index: g.index, length: n, duration: m(a.duration) ? a.duration : j.config.transition_duration, done: a.done, orgDataCount: l }, withLegend: !0, withTransition: l > 1, withTrimXDomain: !1, withUpdateXAxis: !0 });
  }, i.generateFlow = function (a) {
    var b = this,
        c = b.config,
        d = b.d3;return function () {
      var e,
          f,
          g,
          h = a.targets,
          i = a.flow,
          j = a.drawBar,
          k = a.drawLine,
          m = a.drawArea,
          n = a.cx,
          o = a.cy,
          p = a.xv,
          q = a.xForText,
          r = a.yForText,
          s = a.duration,
          u = 1,
          v = i.index,
          w = i.length,
          x = b.getValueOnIndex(b.data.targets[0].values, v),
          y = b.getValueOnIndex(b.data.targets[0].values, v + w),
          z = b.x.domain(),
          A = i.duration || s,
          B = i.done || function () {},
          C = b.generateWait(),
          D = b.xgrid || d.selectAll([]),
          E = b.xgridLines || d.selectAll([]),
          F = b.mainRegion || d.selectAll([]),
          G = b.mainText || d.selectAll([]),
          H = b.mainBar || d.selectAll([]),
          I = b.mainLine || d.selectAll([]),
          J = b.mainArea || d.selectAll([]),
          K = b.mainCircle || d.selectAll([]);b.flowing = !0, b.data.targets.forEach(function (a) {
        a.values.splice(0, w);
      }), g = b.updateXDomain(h, !0, !0), b.updateXGrid && b.updateXGrid(!0), i.orgDataCount ? e = 1 === i.orgDataCount || x.x === y.x ? b.x(z[0]) - b.x(g[0]) : b.isTimeSeries() ? b.x(z[0]) - b.x(g[0]) : b.x(x.x) - b.x(y.x) : 1 !== b.data.targets[0].values.length ? e = b.x(z[0]) - b.x(g[0]) : b.isTimeSeries() ? (x = b.getValueOnIndex(b.data.targets[0].values, 0), y = b.getValueOnIndex(b.data.targets[0].values, b.data.targets[0].values.length - 1), e = b.x(x.x) - b.x(y.x)) : e = t(g) / 2, u = t(z) / t(g), f = "translate(" + e + ",0) scale(" + u + ",1)", b.hideXGridFocus(), b.hideTooltip(), d.transition().ease("linear").duration(A).each(function () {
        C.add(b.axes.x.transition().call(b.xAxis)), C.add(H.transition().attr("transform", f)), C.add(I.transition().attr("transform", f)), C.add(J.transition().attr("transform", f)), C.add(K.transition().attr("transform", f)), C.add(G.transition().attr("transform", f)), C.add(F.filter(b.isRegionOnX).transition().attr("transform", f)), C.add(D.transition().attr("transform", f)), C.add(E.transition().attr("transform", f));
      }).call(C, function () {
        var a,
            d = [],
            e = [],
            f = [];if (w) {
          for (a = 0; w > a; a++) {
            d.push("." + l.shape + "-" + (v + a)), e.push("." + l.text + "-" + (v + a)), f.push("." + l.eventRect + "-" + (v + a));
          }b.svg.selectAll("." + l.shapes).selectAll(d).remove(), b.svg.selectAll("." + l.texts).selectAll(e).remove(), b.svg.selectAll("." + l.eventRects).selectAll(f).remove(), b.svg.select("." + l.xgrid).remove();
        }D.attr("transform", null).attr(b.xgridAttr), E.attr("transform", null), E.select("line").attr("x1", c.axis_rotated ? 0 : p).attr("x2", c.axis_rotated ? b.width : p), E.select("text").attr("x", c.axis_rotated ? b.width : 0).attr("y", p), H.attr("transform", null).attr("d", j), I.attr("transform", null).attr("d", k), J.attr("transform", null).attr("d", m), K.attr("transform", null).attr("cx", n).attr("cy", o), G.attr("transform", null).attr("x", q).attr("y", r).style("fill-opacity", b.opacityForText.bind(b)), F.attr("transform", null), F.select("rect").filter(b.isRegionOnX).attr("x", b.regionX.bind(b)).attr("width", b.regionWidth.bind(b)), c.interaction_enabled && b.redrawEventRect(), B(), b.flowing = !1;
      });
    };
  }, h.selected = function (a) {
    var b = this.internal,
        c = b.d3;return c.merge(b.main.selectAll("." + l.shapes + b.getTargetSelectorSuffix(a)).selectAll("." + l.shape).filter(function () {
      return c.select(this).classed(l.SELECTED);
    }).map(function (a) {
      return a.map(function (a) {
        var b = a.__data__;return b.data ? b.data : b;
      });
    }));
  }, h.select = function (a, b, c) {
    var d = this.internal,
        e = d.d3,
        f = d.config;f.data_selection_enabled && d.main.selectAll("." + l.shapes).selectAll("." + l.shape).each(function (g, h) {
      var i = e.select(this),
          j = g.data ? g.data.id : g.id,
          k = d.getToggle(this, g).bind(d),
          m = f.data_selection_grouped || !a || a.indexOf(j) >= 0,
          n = !b || b.indexOf(h) >= 0,
          o = i.classed(l.SELECTED);i.classed(l.line) || i.classed(l.area) || (m && n ? f.data_selection_isselectable(g) && !o && k(!0, i.classed(l.SELECTED, !0), g, h) : q(c) && c && o && k(!1, i.classed(l.SELECTED, !1), g, h));
    });
  }, h.unselect = function (a, b) {
    var c = this.internal,
        d = c.d3,
        e = c.config;e.data_selection_enabled && c.main.selectAll("." + l.shapes).selectAll("." + l.shape).each(function (f, g) {
      var h = d.select(this),
          i = f.data ? f.data.id : f.id,
          j = c.getToggle(this, f).bind(c),
          k = e.data_selection_grouped || !a || a.indexOf(i) >= 0,
          m = !b || b.indexOf(g) >= 0,
          n = h.classed(l.SELECTED);h.classed(l.line) || h.classed(l.area) || k && m && e.data_selection_isselectable(f) && n && j(!1, h.classed(l.SELECTED, !1), f, g);
    });
  }, h.transform = function (a, b) {
    var c = this.internal,
        d = ["pie", "donut"].indexOf(a) >= 0 ? { withTransform: !0 } : null;c.transformTo(b, a, d);
  }, i.transformTo = function (a, b, c) {
    var d = this,
        e = !d.hasArcType(),
        f = c || { withTransitionForAxis: e };f.withTransitionForTransform = !1, d.transiting = !1, d.setTargetType(a, b), d.updateTargets(d.data.targets), d.updateAndRedraw(f);
  }, h.groups = function (a) {
    var b = this.internal,
        c = b.config;return p(a) ? c.data_groups : (c.data_groups = a, b.redraw(), c.data_groups);
  }, h.xgrids = function (a) {
    var b = this.internal,
        c = b.config;return a ? (c.grid_x_lines = a, b.redrawWithoutRescale(), c.grid_x_lines) : c.grid_x_lines;
  }, h.xgrids.add = function (a) {
    var b = this.internal;return this.xgrids(b.config.grid_x_lines.concat(a ? a : []));
  }, h.xgrids.remove = function (a) {
    var b = this.internal;b.removeGridLines(a, !0);
  }, h.ygrids = function (a) {
    var b = this.internal,
        c = b.config;return a ? (c.grid_y_lines = a, b.redrawWithoutRescale(), c.grid_y_lines) : c.grid_y_lines;
  }, h.ygrids.add = function (a) {
    var b = this.internal;return this.ygrids(b.config.grid_y_lines.concat(a ? a : []));
  }, h.ygrids.remove = function (a) {
    var b = this.internal;b.removeGridLines(a, !1);
  }, h.regions = function (a) {
    var b = this.internal,
        c = b.config;return a ? (c.regions = a, b.redrawWithoutRescale(), c.regions) : c.regions;
  }, h.regions.add = function (a) {
    var b = this.internal,
        c = b.config;return a ? (c.regions = c.regions.concat(a), b.redrawWithoutRescale(), c.regions) : c.regions;
  }, h.regions.remove = function (a) {
    var b,
        c,
        d,
        e = this.internal,
        f = e.config;return a = a || {}, b = e.getOption(a, "duration", f.transition_duration), c = e.getOption(a, "classes", [l.region]), d = e.main.select("." + l.regions).selectAll(c.map(function (a) {
      return "." + a;
    })), (b ? d.transition().duration(b) : d).style("opacity", 0).remove(), f.regions = f.regions.filter(function (a) {
      var b = !1;return a["class"] ? (a["class"].split(" ").forEach(function (a) {
        c.indexOf(a) >= 0 && (b = !0);
      }), !b) : !0;
    }), f.regions;
  }, h.data = function (a) {
    var b = this.internal.data.targets;return "undefined" == typeof a ? b : b.filter(function (b) {
      return [].concat(a).indexOf(b.id) >= 0;
    });
  }, h.data.shown = function (a) {
    return this.internal.filterTargetsToShow(this.data(a));
  }, h.data.values = function (a) {
    var b,
        c = null;return a && (b = this.data(a), c = b[0] ? b[0].values.map(function (a) {
      return a.value;
    }) : null), c;
  }, h.data.names = function (a) {
    return this.internal.clearLegendItemTextBoxCache(), this.internal.updateDataAttributes("names", a);
  }, h.data.colors = function (a) {
    return this.internal.updateDataAttributes("colors", a);
  }, h.data.axes = function (a) {
    return this.internal.updateDataAttributes("axes", a);
  }, h.category = function (a, b) {
    var c = this.internal,
        d = c.config;return arguments.length > 1 && (d.axis_x_categories[a] = b, c.redraw()), d.axis_x_categories[a];
  }, h.categories = function (a) {
    var b = this.internal,
        c = b.config;return arguments.length ? (c.axis_x_categories = a, b.redraw(), c.axis_x_categories) : c.axis_x_categories;
  }, h.color = function (a) {
    var b = this.internal;return b.color(a);
  }, h.x = function (a) {
    var b = this.internal;return arguments.length && (b.updateTargetX(b.data.targets, a), b.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0 })), b.data.xs;
  }, h.xs = function (a) {
    var b = this.internal;return arguments.length && (b.updateTargetXs(b.data.targets, a), b.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0 })), b.data.xs;
  }, h.axis = function () {}, h.axis.labels = function (a) {
    var b = this.internal;arguments.length && (Object.keys(a).forEach(function (c) {
      b.axis.setLabelText(c, a[c]);
    }), b.axis.updateLabels());
  }, h.axis.max = function (a) {
    var b = this.internal,
        c = b.config;return arguments.length ? ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) ? (m(a.x) && (c.axis_x_max = a.x), m(a.y) && (c.axis_y_max = a.y), m(a.y2) && (c.axis_y2_max = a.y2)) : c.axis_y_max = c.axis_y2_max = a, void b.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0 })) : { x: c.axis_x_max, y: c.axis_y_max, y2: c.axis_y2_max };
  }, h.axis.min = function (a) {
    var b = this.internal,
        c = b.config;return arguments.length ? ("object" == (typeof a === "undefined" ? "undefined" : _typeof(a)) ? (m(a.x) && (c.axis_x_min = a.x), m(a.y) && (c.axis_y_min = a.y), m(a.y2) && (c.axis_y2_min = a.y2)) : c.axis_y_min = c.axis_y2_min = a, void b.redraw({ withUpdateOrgXDomain: !0, withUpdateXDomain: !0 })) : { x: c.axis_x_min, y: c.axis_y_min, y2: c.axis_y2_min };
  }, h.axis.range = function (a) {
    return arguments.length ? (q(a.max) && this.axis.max(a.max), void (q(a.min) && this.axis.min(a.min))) : { max: this.axis.max(), min: this.axis.min() };
  }, h.legend = function () {}, h.legend.show = function (a) {
    var b = this.internal;b.showLegend(b.mapToTargetIds(a)), b.updateAndRedraw({ withLegend: !0 });
  }, h.legend.hide = function (a) {
    var b = this.internal;b.hideLegend(b.mapToTargetIds(a)), b.updateAndRedraw({ withLegend: !0 });
  }, h.resize = function (a) {
    var b = this.internal,
        c = b.config;c.size_width = a ? a.width : null, c.size_height = a ? a.height : null, this.flush();
  }, h.flush = function () {
    var a = this.internal;a.updateAndRedraw({ withLegend: !0, withTransition: !1, withTransitionForTransform: !1 });
  }, h.destroy = function () {
    var b = this.internal;return a.clearInterval(b.intervalForObserveInserted), a.onresize = null, b.selectChart.classed("c3", !1).html(""), Object.keys(b).forEach(function (a) {
      b[a] = null;
    }), null;
  }, h.tooltip = function () {}, h.tooltip.show = function (a) {
    var b,
        c,
        d = this.internal;a.mouse && (c = a.mouse), a.data ? d.isMultipleX() ? (c = [d.x(a.data.x), d.getYScale(a.data.id)(a.data.value)], b = null) : b = m(a.data.index) ? a.data.index : d.getIndexByX(a.data.x) : "undefined" != typeof a.x ? b = d.getIndexByX(a.x) : "undefined" != typeof a.index && (b = a.index), d.dispatchEvent("mouseover", b, c), d.dispatchEvent("mousemove", b, c);
  }, h.tooltip.hide = function () {
    this.internal.dispatchEvent("mouseout", 0);
  };var z;i.isSafari = function () {
    var b = a.navigator.userAgent;return b.indexOf("Safari") >= 0 && b.indexOf("Chrome") < 0;
  }, i.isChrome = function () {
    var b = a.navigator.userAgent;return b.indexOf("Chrome") >= 0;
  }, Function.prototype.bind || (Function.prototype.bind = function (a) {
    if ("function" != typeof this) throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");var b = Array.prototype.slice.call(arguments, 1),
        c = this,
        d = function d() {},
        e = function e() {
      return c.apply(this instanceof d ? this : a, b.concat(Array.prototype.slice.call(arguments)));
    };return d.prototype = this.prototype, e.prototype = new d(), e;
  }),  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(86)], __WEBPACK_AMD_DEFINE_FACTORY__ = (k),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "undefined" != typeof exports && "undefined" != typeof module ? module.exports = k : a.c3 = k;
}(window);

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* ng-infinite-scroll - v1.0.0 - 2013-02-23 */
// let mod;

var mod = angular.module('infinite-scrollfork', []);

mod.directive('infiniteScrollfork', ['$rootScope', '$window', '$timeout', function ($rootScope, $window, $timeout) {
  return {
    link: function link(scope, elem, attrs) {
      var checkWhenEnabled = void 0;
      var handler = null;
      var scrollDistance = void 0;
      var scrollEnabled = void 0;
      $window = angular.element($window);
      scrollDistance = 0;
      if (attrs.infiniteScrollDistance != null) {
        scope.$watch(attrs.infiniteScrollDistance, function (value) {
          return scrollDistance = parseInt(value, 10);
        });
      }
      scrollEnabled = true;
      checkWhenEnabled = false;
      if (attrs.infiniteScrollDisabled != null) {
        scope.$watch(attrs.infiniteScrollDisabled, function (value) {
          scrollEnabled = !value;
          if (scrollEnabled && checkWhenEnabled) {
            checkWhenEnabled = false;
            return $timeout(handler);
          }
        });
      }
      handler = function handler() {
        var elementBottom = elem.prop('scrollHeight');
        var position = elem.scrollTop() + elem.height();
        var remaining = elementBottom - position;
        var shouldScroll = remaining <= elem.height() * scrollDistance;
        if (shouldScroll && scrollEnabled) {
          if ($rootScope.$$phase) {
            return scope.$eval(attrs.infiniteScrollfork);
          } else {
            return scope.$apply(attrs.infiniteScrollfork);
          }
        } else if (shouldScroll) {
          return checkWhenEnabled = true;
        }
      };
      elem.on('scroll', handler);
      scope.$on('$destroy', function () {
        return elem.off('scroll', handler);
      });
      return $timeout(function () {
        if (attrs.infiniteScrollImmediateCheck) {
          if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
            return handler();
          }
        } else {
          return handler();
        }
      }, 0);
    }
  };
}]);

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scLayoutModule = undefined;

var _core = __webpack_require__(60);

var _filter = __webpack_require__(331);

var _facts = __webpack_require__(333);

var _stat = __webpack_require__(341);

var _shared = __webpack_require__(343);

var _root = __webpack_require__(963);

var _sidebar = __webpack_require__(965);

var _view = __webpack_require__(968);

var _sidebarLeft = __webpack_require__(1021);

var _sidebarToggle = __webpack_require__(1023);

var _header = __webpack_require__(1026);

var _footer = __webpack_require__(1029);

var _admin = __webpack_require__(1032);

var _fieldsModalService = __webpack_require__(1041);

var _face = __webpack_require__(1045);

var scLayoutModule = exports.scLayoutModule = 'sc-layout';

angular.module(scLayoutModule, [_facts.scFactsModule, _stat.scStatModule, _core.scCoreModule, _filter.scFilterModule, _shared.scSharedModule, _view.scViewModule, _admin.scAdminModule, _face.scFaceModule]).service('FieldsModalService', _fieldsModalService.FieldsModalService).controller('RootCtrl', _root.RootCtrl).directive('scSidebar', _sidebar.SidebarComponent).directive('scSidebarLeft', _sidebarLeft.SidebarLeftComponent).component('scSidebarToggle', _sidebarToggle.SidebarToggleComponent).component('scHeader', _header.HeaderComponent).component('scFooter', _footer.FooterComponent);

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterResource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterResource = exports.FilterResource = function () {
  function FilterResource($http, $q) {
    _classCallCheck(this, FilterResource);

    this.$http = $http;
    this.$q = $q;
  }

  // Delete saved filter (ID should be set)


  _createClass(FilterResource, [{
    key: 'delete',
    value: function _delete(filter) {
      return this.$http.post('/analytics/filter/delete/', {
        id: filter.id
      }).then(function (_ref) {
        var data = _ref.data,
            status = _ref.status;

        return {
          data: data,
          status: status
        };
      }).catch(function (_ref2) {
        var data = _ref2.data,
            status = _ref2.status;

        new Error('HTTP error: ' + status);
      });
    }

    // Save filter to server, get ID

  }, {
    key: 'save',
    value: function save(filter, callback) {
      var filterData = Object.assign({}, filter);
      filterData.content_type = filter.content_type;
      filterData.category = filter.category;
      delete filterData.isNodeOpen;
      return this.$http.post('/analytics/filter/save/', filterData).then(function (_ref3) {
        var data = _ref3.data,
            status = _ref3.status;

        filter.saved = true;
        filter.isChanged = false;
        filter.id = data.id;
        if (!filter.children || !filter.children.length) filter.children = data.children;else data.children = filter.children;
        callback && callback(status, filter, null);
        return {
          data: data,
          status: status
        };
      }).catch(function (_ref4) {
        var data = _ref4.data,
            status = _ref4.status;

        if (status === 422) {
          callback && callback(status, data, null);
        } else {
          callback && callback(status, data, new Error('HTTP error: ' + status));
        }
      });
    }

    // id: position.id,
    // prev_id: position.prev_id,
    // parent_id: position.parent_id,

  }, {
    key: 'changePosition',
    value: function changePosition(id, prev_id, parent_id) {
      return this.$http.post('/analytics/filter/update_position/', {
        id: id,
        prev_id: prev_id,
        parent_id: parent_id
      });
    }

    // Return list of all filters

  }, {
    key: 'list',
    value: function list() {
      return this.$http.get('/analytics/filter/list/', {}).then(function (_ref5) {
        var data = _ref5.data;

        var result = data.map(function (f) {
          f.timeTo = null;
          f.timeFrom = f.timeTo;
          f.record_count = 0;
          // f = Object.setPrototypeOf(f, Filter.prototype);
          Object.setPrototypeOf(f, _filter.Filter.prototype);
          f.typize();
          return f;
        });
        return result;
      }).catch(function (_ref6) {
        var status = _ref6.status;

        new Error('HTTP error: ' + status);
      });
    }
  }]);

  return FilterResource;
}();

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* Data models metadata service */

var Models = exports.Models = function () {
  function Models(loadWithCache) {
    _classCallCheck(this, Models);

    this.loadWithCache = loadWithCache;
  }

  _createClass(Models, [{
    key: 'load',
    value: function load() {
      return this.loadWithCache('/analytics/model/', {});
    }
  }]);

  return Models;
}();

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Aggregates = Aggregates;
function Aggregates($http, loadWithCache, $timeout) {
  return {
    load: function load(cubeName, filters, resetCache, canceler) {
      var requestUrl = filters.skipStat ? '/analytics/values/' + cubeName + '/' : '/analytics/aggregate/' + cubeName + '/';
      return loadWithCache(requestUrl, filters.buildQueryParams(), canceler, resetCache)
      // delay response for debug
      // .then((result) => $timeout(50000).then(() => result))
      ;
    }
  };
}

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeUtil = TimeUtil;
function TimeUtil() {
  return {
    periods: {
      'minute': 60000,
      'hour': 3.6e+6,
      'day': 8.64e+7,
      'week': 6.048e+8,
      '2week': 2 * 6.048e+8,
      'month': 2.62974e9,
      'quarter': 2.62974e9 * 4,
      'year': 3.156e+10,
      'all': 3.156e+12
    },

    formats: ['HH:mm:ss', 'HH:mm', 'HH:mm', 'EEE dd', 'dd EEE', 'MMM yyyy', 'MMM yyyy', 'yyyy'],

    formatForRange: function formatForRange(timeFrom, timeTo) {
      var ms = timeTo.getTime() - timeFrom.getTime();
      var i = 0;
      angular.forEach(this.periods, function (value) {
        if (ms <= value) return;
        i++;
      });
      return this.formats[i];
    }
  };
}

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadWithCache = loadWithCache;

var _config = __webpack_require__(21);

var _model = __webpack_require__(328);

/* Cache */
var Cache = function Cache() {
  this.cache = {};
  this.reset = function () {
    this.cache = {};
  };
  this.cleanup = function () {

    var cacheMinutes = 1;
    var cacheSize = 32;
    var oldestTime = new Date().getTime() - 1000 * 60 * cacheMinutes;

    var elements = [];
    for (var element in this.cache) {
      if (this.cache[element].time < oldestTime) {
        delete this.cache[element];
      } else {
        elements.push(element);
      }
    }
    var c = this.cache;
    elements.sort(function (a, b) {
      return c[a].time - c[b].time;
    });
    if (elements.length >= cacheSize) {
      for (var i = 0; i < elements.length - cacheSize; i++) {
        delete this.cache[elements[i]];
      }
    }
  };
};

var cache = new Cache();
window.CACHE = cache;

function loadWithCache($http, $q, $cookies, $httpParamSerializer) {
  return function (path, params, canceler, resetCache) {
    var requestHash = path + (params ? '?' + $.param(params) : '');
    cache.cleanup();
    if (_config.USE_CACHE && !resetCache && requestHash in cache.cache) {
      var timediff = Math.round((new Date().getTime() - cache.cache[requestHash].time) / 1000 / 60);
      var result = cache.cache[requestHash].data;
      return $q.when(result);
    }
    var req_params = {};
    if (canceler) {
      req_params['timeout'] = canceler.promise;
    }

    req_params['headers'] = {
      'X-CSRFToken': $cookies.get('csrftoken'),
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    return $http.post(path, $httpParamSerializer(params), req_params).then(function (_ref) {
      var data = _ref.data,
          status = _ref.status,
          headers = _ref.headers,
          config = _ref.config;

      var model = data;
      cache.cache[requestHash] = {
        'time': new Date().getTime(),
        'data': model
      };
      return model;
    });
  };
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dimension = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _level = __webpack_require__(148);

var _hierarchy = __webpack_require__(740);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Dimension = exports.Dimension = function () {
  function Dimension() {
    _classCallCheck(this, Dimension);
  }

  _createClass(Dimension, [{
    key: 'buildModel',


    // constructor() {
    // }

    value: function buildModel() {
      var dim = this;
      this.levels.forEach(function (level) {
        Object.setPrototypeOf(level, _level.Level.prototype);
        level.dimension = dim;
        level.buildModel();
      });
      // Remove system 'all' hierarchy
      this.hierarchies = this.hierarchies.filter(function (h) {
        return h.name !== 'all';
      });
      this.hierarchies.forEach(function (hierarchy) {
        Object.setPrototypeOf(hierarchy, _hierarchy.Hierarchy.prototype);
        hierarchy.dimension = dim;
        hierarchy.buildModel();
      });
      var hie = this.getDefaultHierarchy();
    }

    /*
     * Get a level by name.
     */

  }, {
    key: 'getLevel',
    value: function getLevel(level) {
      return this.levels.find(function (ed) {
        return ed.name === level;
      });
    }

    /*
     * Get a hierarchy by name.
     */

  }, {
    key: 'getHierarchy',
    value: function getHierarchy(hierarchy) {
      return this.hierarchies.find(function (ed) {
        return ed.name === hierarchy;
      });
    }
  }, {
    key: 'getDefaultHierarchy',
    value: function getDefaultHierarchy() {
      if (this.hierarchies) {
        if (this.default_hierarchy_name) {
          return this.getHierarchy(this.default_hierarchy_name);
        }
        return this.hierarchies[0];
      }
      return null;
    }
  }, {
    key: 'toString',
    value: function toString() {
      var hie = this.getDefaultHierarchy();
      return hie ? hie.toString() : this.name;
    }
  }]);

  return Dimension;
}();

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hierarchy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _level = __webpack_require__(148);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hierarchy = exports.Hierarchy = function (_Level) {
  _inherits(Hierarchy, _Level);

  function Hierarchy() {
    _classCallCheck(this, Hierarchy);

    return _possibleConstructorReturn(this, (Hierarchy.__proto__ || Object.getPrototypeOf(Hierarchy)).apply(this, arguments));
  }

  _createClass(Hierarchy, [{
    key: 'buildModel',
    value: function buildModel() {}

    /*
     * Processes a cell and returns an array of objects with info and label.
     */

  }, {
    key: 'readCell',
    value: function readCell(cell, level_limit) {

      var result = [];
      var hie = this;

      for (var i = 0; i < this.levels.length; i++) {
        var levname = this.levels[i];
        var level = hie.dimension.getLevel(levname);
        var info = level.readCell(cell);
        if (info != null) result.push(info);

        // Stop if we reach level_limit
        if (level_limit != undefined && level_limit != null) {
          if (level_limit.name == levname) break;
        }
      }
      return result;
    }
  }, {
    key: 'toString',
    value: function toString() {
      var id = this.dimension.name + '@' + this.name;
      if (this.levels) id = id + ':' + this.levels[this.levels.length - 1];
      return id;
    }
  }]);

  return Hierarchy;
}(_level.Level);

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cube = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _level = __webpack_require__(148);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cube = exports.Cube = function (_Level) {
  _inherits(Cube, _Level);

  function Cube() {
    _classCallCheck(this, Cube);

    return _possibleConstructorReturn(this, (Cube.__proto__ || Object.getPrototypeOf(Cube)).apply(this, arguments));
  }

  _createClass(Cube, [{
    key: 'buildModel',
    value: function buildModel() {}
  }]);

  return Cube;
}(_level.Level);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentFilterService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

var _typeDimensions = __webpack_require__(147);

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrentFilterService = exports.CurrentFilterService = function () {
  function CurrentFilterService(PermissionService, FiltersService, CurrentModelService) {
    _classCallCheck(this, CurrentFilterService);

    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.defaultDimension = window.defaultDimension || 'agent_account@user_name:user_name';
    this.filterBar = new _filter.Filter('Bar');
    this.filterBar.setDrilldown(this.defaultDimension);
    this.filter = null;

    this.PermissionService = PermissionService;

    this.timeFrom = new Date();
    this.timeTo = new Date(this.timeFrom.valueOf());
    this.timeFrom.setHours(0, 0, 0, 0);
    this.timeTo.setHours(23, 59, 59, 999);

    this.updatePanel();

    this.visibleDimensions = [];
  }

  _createClass(CurrentFilterService, [{
    key: 'createNewFilter',
    value: function createNewFilter(name, type) {

      var filterName = name ? name : type ? this.PermissionService.types[type].name + ' 1' : null;
      var filter = new _filter.Filter(filterName);
      this.setFilterName(filter);
      if (type) filter.content_type = type;
      return filter;
    }
  }, {
    key: 'setFilterName',
    value: function setFilterName(filter) {
      var setFilterName = function setFilterName() {
        var parts = filter.name.split(' ');
        if (parts.length > 1) {
          var idx = '1';
          if (parseInt(parts[parts.length - 1], 10)) {
            idx = parseInt(parts[parts.length - 1], 10) + 1;
            parts.pop();
          }
          filter.name = parts.join(' ') + ' ' + idx;
        } else {
          filter.name = parts[0] + ' 1';
        }
      };
      while (this.FiltersService.find(function (f) {
        return f.name === filter.name && f.id !== filter.id;
      })) {
        setFilterName();
      }
      while (this.filter && this.filter.children && this.filter.children.find(function (f) {
        return f.name === filter.name && f.id !== filter.id;
      })) {
        setFilterName();
      }
    }
  }, {
    key: 'newFilter',
    value: function newFilter(name, type) {
      this.filter = this.createNewFilter(name, type);
      if (type) {
        this.filter.content_type = type;
        if (this.filter.isDashboard || this.filter.isCard) this.filter.mode = type;
      }
    }
  }, {
    key: 'rebuildVisibleDimensions',
    value: function rebuildVisibleDimensions() {
      var dims = void 0;
      if (this.filter && this.filter.filters && this.filter.filters.length > 0) {
        var selected = this.filter.filters.filter(function (f) {
          return f['dimension'] === 'agent_eventtype@default:agent_eventtype' && !f.predicates.filter(function (p) {
            return p === '!';
          }).length;
        }).map(function (f) {
          return f['value'];
        });
        dims = selected.map(function (key_selected) {
          return _typeDimensions.TYPE_DIMENSIONS[key_selected];
        }).reduce(function (prev, curr) {
          return prev.concat(curr ? curr.filter(function (dim) {
            return prev.indexOf(dim) === -1;
          }) : []);
        }, []);
      }
      if (dims && dims.length) {
        this.visibleDimensions = this.CurrentModelService.model.dimensions.filter(function (dim) {
          return dims.indexOf(dim['name']) !== -1;
        });
      } else {
        this.visibleDimensions = this.CurrentModelService.model ? this.CurrentModelService.model.dimensions : [];
      }
    }
  }, {
    key: 'setOrderBar',
    value: function setOrderBar(dimension) {
      switch (this.filterBar.aggrOrder) {
        case 'nameAsc':
          this.filterBar.orderDir = 'asc';
          if (_filter.Filter.isTimeDimension(dimension)) {
            this.filterBar.order = _filter.Filter.orderForTimeDimension(dimension);
          } else this.filterBar.order = this.aggregateBarOrderName;
          break;
        case 'nameDesc':
          this.filterBar.orderDir = 'desc';
          if (_filter.Filter.isTimeDimension(dimension)) {
            this.filterBar.order = _filter.Filter.orderForTimeDimension(dimension);
          } else this.filterBar.order = this.aggregateBarOrderName;
          break;
        case 'statAsc':
          this.filterBar.order = 'record_count';
          this.filterBar.orderDir = 'asc';
          break;
        case 'statDesc':
          this.filterBar.order = 'record_count';
          this.filterBar.orderDir = 'desc';
          break;
        default:
          if (_filter.Filter.isTimeDimension(dimension)) {
            this.filterBar.orderDir = 'asc';
            this.filterBar.order = _filter.Filter.orderForTimeDimension(dimension);
          } else {
            this.filterBar.orderDir = 'desc';
            this.filterBar.order = 'record_count';
          }
      }

      this.filterBar.changed();
    }
  }, {
    key: 'selectBarDim',
    value: function selectBarDim(dim) {
      this.filterBar.copyFrom(this.filter, true);
      this.filterBar.setDrilldown(dim.toString());
      this.setOrderBar(dim.toString());
      this.filterBar.setKeyword('');
      this.filterBar.page = 0;
      this.filterBar.lookup = null;
    }
  }, {
    key: 'getReportQuery',
    value: function getReportQuery(filterBase) {
      var filter = new _filter.Filter('Report');
      var srcFilter = filterBase || this.filter;
      filter.copyFrom(srcFilter);
      filter.filters = srcFilter.filters.slice(0);
      filter.timeFrom = this.timeFrom;
      filter.timeTo = this.timeTo;
      filter.timePeriod = this.timePeriod;
      var obj = filter.buildQueryParams();

      if (this.filter.isCardOrDashboard) {
        obj.inDashboard = 1;
      }

      if (filter.isReports) {
        delete obj.order;
        delete obj.dir;
        if (filter.repOrderDirs) obj.repOrderDirs = filter.repOrderDirs;
        if (filter.repOrders) obj.repOrders = filter.repOrders;
      }
      obj['limit'] = srcFilter.customLimit ? srcFilter.customLimit : _config.DEFAULT_STAT_LIMIT;

      var serialize = function serialize(obj) {
        var str = [];
        for (var p in obj) {
          if (obj.hasOwnProperty(p)) {
            var v = obj[p];
            if (v instanceof Date) {
              v = v.toISOString();
            }
            if (v instanceof Array) {
              for (var idx in v) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v[idx]));
              }
            } else str.push(encodeURIComponent(p) + '=' + encodeURIComponent(v));
          }
        }
        return str.join('&');
      };

      return serialize(obj);
    }
  }, {
    key: 'getReportUrl',
    value: function getReportUrl(filter) {
      if (!filter || !filter.url) {
        return null;
      }
      var base = filter.url;
      if (base.indexOf('?') < 0) {
        return base + '?' + this.getReportQuery(filter);
      } else {
        return base + '&' + this.getReportQuery(filter);
      }
    }
  }, {
    key: 'generateReport',
    value: function generateReport(url) {
      this.filter.setMode('reports');
      this.filter.url = url;
    }
  }, {
    key: 'openFrame',
    value: function openFrame(url) {
      this.frameUrl = url;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.frameUrl = null;
    }
  }, {
    key: 'buildCardFilter',
    value: function buildCardFilter() {
      var _this = this;

      if (this.filter.isDimensionCard) return;
      var criterion = this.filter.filters[0];

      if (!criterion || this.filter.filters.filter(function (f) {
        return f.dimension === criterion.dimension;
      }).length !== 1) {
        console.error('card filter should have at least one criterion');
        this.filter.children = [];
        return;
      }
      // let cardFilter = this.FiltersService.getCardFilter(criterion.dimension);
      this.filter.cardFilter = this.FiltersService.getCardFilter(criterion.dimension);
      if (this.filter.cardFilter) {
        // this.filter.children = angular.copy(this.filter.cardFilter.children);

        this.filter.children = this.filter.cardFilter.children.map(function (f) {
          return Object.assign(new _filter.Filter(), f, {
            filters: _this.filter.filters.concat(f.filters)
          });
        });
        this.filter.name = this.filter.cardFilter.name;
      } else {
        this.filter.children = [];
      }
      this.filter.saved = true;
    }
  }, {
    key: 'getTimeFrom',
    value: function getTimeFrom() {
      return _filter.Filter.dateToUrl(this.timeFrom);
    }
  }, {
    key: 'getTimeTo',
    value: function getTimeTo() {
      return _filter.Filter.dateToUrl(this.timeTo);
    }
  }, {
    key: 'updatePanel',
    value: function updatePanel() {
      this.panel = this.PermissionService.filterConstructor ? 'constructor' : 'catalog';
      this.filterBar.skipStat = !this.PermissionService.aggregate_show_stat;
    }
  }, {
    key: 'aggregateBarOrderName',
    get: function get() {
      var dimension = this.CurrentModelService.model.getDimensionParts(this.filterBar.drilldown[0]);
      return dimension.dimension.name + '.' + dimension.level.label_attribute;
    }
  }]);

  return CurrentFilterService;
}();

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CancelersService = exports.CancelersService = function () {
  function CancelersService($q) {
    _classCallCheck(this, CancelersService);

    this.cancelers = {};
    this.$q = $q;
  }

  _createClass(CancelersService, [{
    key: 'get',
    value: function get(key) {
      var cancelers = this.cancelers;
      var old_canceler = cancelers[key];
      if (old_canceler) {
        // console.log('Another request started');
        old_canceler.resolve('Another request started');
      }
      var new_canceler = this.$q.defer();
      cancelers[key] = new_canceler;
      return new_canceler;
    }
  }, {
    key: 'cancel',
    value: function cancel(key) {
      if (key) {
        if (this.cancelers[key]) {
          this.cancelers[key].resolve('Aborted');
          delete this.cancelers[key];
        }
      } else {
        var keys = Object.getOwnPropertySymbols(this.cancelers);
        for (var i = 0; i < keys.length; ++i) {
          this.cancelers[keys[i]].resolve('Aborted');
        }
        this.cancelers = {};
      }
    }
  }, {
    key: 'reset',
    value: function reset(key) {
      if (this.cancelers[key]) {
        delete this.cancelers[key];
      }
    }
  }]);

  return CancelersService;
}();

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.FilterDataFactory = FilterDataFactory;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(21);

var _filter = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterDataService = function () {
  function FilterDataService(_ref) {
    var _this = this;

    var CurrentFilterService = _ref.CurrentFilterService,
        CurrentModelService = _ref.CurrentModelService,
        $q = _ref.$q,
        $rootScope = _ref.$rootScope,
        $http = _ref.$http,
        $timeout = _ref.$timeout,
        $cookies = _ref.$cookies,
        $httpParamSerializer = _ref.$httpParamSerializer,
        ErrorHandlerService = _ref.ErrorHandlerService,
        rx = _ref.rx,
        isModalEditor = _ref.isModalEditor;

    _classCallCheck(this, FilterDataService);

    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.isModalEditor = isModalEditor;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.ErrorHandlerService = ErrorHandlerService;
    this.$cookies = $cookies;
    this.$httpParamSerializer = $httpParamSerializer;

    this.filter = null;
    this.$rootScope = $rootScope;
    this.actualFilter = null;
    this.filterData = null;
    this.loading = false;
    this.loadingMore = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.frameLoad = null;
    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();
    this.loadingSubject = new rx.Subject();
    this.loading$ = this.loadingSubject.asObservable();
    this.filterData$ = this.filterSubject.asObservable().filter(function () {
      _this.currentFilterId = CurrentFilterService.filter ? CurrentFilterService.filter.id : 0;
      if (!_this.CurrentModelService.cube) {
        console.error('model is not defined');
        return false;
      }
      return true;
    }).map(function (filter) {
      if (!filter) return null;
      var errMessage = filter.getFilterError();
      if (!errMessage) errMessage = _this.CurrentModelService.model.checkIsFilterCutsValueAllowed(filter);
      _this.setErrorMessage(errMessage);
      if (errMessage) {
        console.error(errMessage);
        return null;
      }

      _this.filter = filter;
      _this.actualFilter = _this.getActualFilter(filter);
      var params = _this.actualFilter.buildQueryParams();
      if (_this.CurrentFilterService.lastScreenshots) {
        params.lastScreenshotsTimeFrom = _this.CurrentFilterService.lastScreenshots.timeFrom;
        params.lastScreenshotsEventTp = _this.CurrentFilterService.lastScreenshots.eventTp ? _this.CurrentFilterService.lastScreenshots.eventTp : '4';
      }

      return {
        filter: _this.actualFilter,
        url: _this.getUrl(_this.actualFilter),
        params: params
      };
    }).distinctUntilChanged(null, function (params1, params2) {
      return !_this.cancelled && params1 && params2 && params1.url === params2.url && angular.equals(params1.params, params2.params);
    }).filter(function (params) {
      return params;
    }).switchMap(function (params) {
      if (_this.loading || _this.loadingMore) {
        _this.onCancel();
      }
      _this.filterData = null;
      _this.page = 0;
      params.params.page = _this.page;
      _this.beforeLoad();
      var loadPromise = _this.load(params);
      _this.loadingSubject.onNext(true);
      return rx.Observable.amb(_this.cancelSubject.asObservable().do(function () {
        return _this.onCancel();
      }).first(), rx.Observable.fromPromise(loadPromise).do(function (data) {
        return _this.afterLoad(data);
      }).catch(function (error) {
        _this.onError(error);
        _this.error = error;
        return rx.Observable.of(null);
      })).flatMap(function (data) {
        _this.loadingSubject.onNext(false);
        if (data === null) {
          return rx.Observable.of(data);
        }
        if (!_this.filter.isExplore) {
          return rx.Observable.of(data);
        }
        return rx.Observable.of(data).concat(_this.loadMoreSubject.asObservable().exhaustMap(function () {
          return rx.Observable.of(null).flatMap(function () {
            if (_this.isComplete) {
              return rx.Observable.of(null);
            }
            _this.page += 1;
            var nextPageParams = {
              filter: params.filter,
              url: params.url,
              params: Object.assign({}, params.params)
            };
            nextPageParams.params.page = _this.page;
            _this.beforeLoad();
            return rx.Observable.amb(_this.cancelSubject.asObservable().do(function () {
              return _this.onCancel();
            }).first(), rx.Observable.fromPromise(_this.load(nextPageParams)).do(function (data) {
              return _this.afterLoad(data);
            }).catch(function (error) {
              _this.onError(error);
              return rx.Observable.of(null);
            }));
          });
        }));
      });
    }).share();
    this.subscription = this.filterData$.subscribe(function () {
      _this.$rootScope.$evalAsync(function () {
        _this.$timeout(function () {
          _this.$rootScope.$root.$broadcast('factsLoaded');
        }, 10);
      });
    });
  }

  _createClass(FilterDataService, [{
    key: 'setErrorMessage',
    value: function setErrorMessage(message) {
      if (!this.ErrorHandlerService.filterErrorMessage) this.ErrorHandlerService.filterErrorMessage = {};
      this.ErrorHandlerService.filterErrorMessage.sourse = 'filter-data';
      this.ErrorHandlerService.filterErrorMessage.text = message;
    }
  }, {
    key: 'update',
    value: function update(filter, force) {
      var result = this.filterData$.first().toPromise();
      if (force) {
        this.filterSubject.onNext(null);
      }
      this.filterSubject.onNext(filter);
      return result;
    }
  }, {
    key: 'moreFacts',
    value: function moreFacts() {
      this.loadMoreSubject.onNext(null);
    }
  }, {
    key: 'load',
    value: function load(_ref2) {
      var filter = _ref2.filter,
          url = _ref2.url,
          params = _ref2.params;

      // console.log('load:', filter.name, filter.id, filter.dIndex);
      if (filter.isReports && !filter.isCard) {
        this.frameLoad = this.$q.defer();
        return this.frameLoad.promise;
      }
      return this.$http.post(url, this.$httpParamSerializer(params), {
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'X-CSRFToken': this.$cookies.get('csrftoken'),
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        timeout: this.canceller.promise
      }).then(function (_ref3) {
        var data = _ref3.data;
        return data;
      });
    }
  }, {
    key: 'getActualFilter',
    value: function getActualFilter(filter) {
      var actualFilter = new _filter.Filter('Facts');
      actualFilter.copyFrom(filter);
      if (!this.isModalEditor || !actualFilter.isAnalysis || actualFilter.isEventRiver || !actualFilter.send_threshold || !actualFilter.threshold_period || !actualFilter.threshold) {
        actualFilter.timeFrom = this.CurrentFilterService.timeFrom;
        actualFilter.timeTo = this.CurrentFilterService.timeTo;
      }

      if (actualFilter.isExplore) {
        if (!actualFilter.hasOwnProperty('order') || actualFilter.order === 'record_count') actualFilter.order = 'local_time';
      } else if (actualFilter.isReport || actualFilter.isEventRiver) {
        var timeTo = (0, _moment2.default)(new Date()) > (0, _moment2.default)(actualFilter.timeTo) ? (0, _moment2.default)(actualFilter.timeTo) : (0, _moment2.default)(new Date());
        var days = timeTo.diff((0, _moment2.default)(actualFilter.timeFrom), 'days') + 1;
        if (days < 1) days = 1;
        actualFilter.days = days;
        var activity_dimension = void 0;
        if (!actualFilter.customLimit) actualFilter.limit = _config.DEFAULT_STAT_LIMIT;

        if (days > 1) {
          if (actualFilter.isEventRiver) activity_dimension = 'agent_time@ymd:day';
          if (actualFilter.isReport) activity_dimension = 'agent_time@ymdh:hour';
        } else {
          if (actualFilter.isEventRiver) activity_dimension = 'agent_time@ymdh:hour';
          if (actualFilter.isReport) activity_dimension = 'agent_time@ymdhm:minute';
        }

        // if (days > 1 || actualFilter.isEventRiver) {
        //   activity_dimension = 'agent_time@ymdh:hour';
        //   // if (!actualFilter.customLimit) actualFilter.limit = days * 24;
        // } else {
        //   activity_dimension = 'agent_time@ymdhm:minute';
        //   // if (!actualFilter.customLimit) actualFilter.limit = 24 * 60;
        // }
        if (actualFilter.isEventRiver) {
          actualFilter.drilldown.push(activity_dimension);
          actualFilter.order = actualFilter.measure;
        } else {
          actualFilter.drilldown = [activity_dimension];
          actualFilter.setOrder(activity_dimension);
        }
      } else if (actualFilter.isChartArea || actualFilter.isRadar || actualFilter.isChart || actualFilter.isTree) {
        actualFilter.order = actualFilter.measure;
        actualFilter.orderDir = 'desc';
        actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
        if (!actualFilter.customLimit) actualFilter.limit = _config.DEFAULT_STAT_LIMIT;
        // actualFilter.chartAreaType = actualFilter.chartAreaType;
      } else if (actualFilter.isSummStat) {
        // actualFilter.order = actualFilter.orders.map(e => e === 'measure' ? filter.measure : e);
        // actualFilter.orderDir = actualFilter.orderDirs.slice();
        actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
        if (!actualFilter.customLimit) actualFilter.limit = _config.DEFAULT_STAT_LIMIT;
      } else if (actualFilter.isStat || actualFilter.isSummStat) {
        actualFilter.order = actualFilter.orders.map(function (e) {
          return e === 'measure' ? filter.measure : e;
        });
        actualFilter.orderDir = actualFilter.orderDirs.slice();
        actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
        if (!actualFilter.customLimit) actualFilter.limit = _config.DEFAULT_STAT_LIMIT;
      } else if (actualFilter.isCardFilter) {
        actualFilter.order = actualFilter.measure;
        actualFilter.orderDir = 'desc';
        actualFilter.timePeriod = this.CurrentFilterService.timePeriod;
        if (!actualFilter.customLimit) actualFilter.limit = _config.DEFAULT_STAT_LIMIT;
      } else if (actualFilter.isReports || actualFilter.isDashboard || actualFilter.isCard) {
        //
      } else {
        console.error('unknown filter mode');
      }
      return actualFilter;
    }
  }, {
    key: 'getUrl',
    value: function getUrl(filter) {
      if (this.CurrentFilterService.lastScreenshots) {
        return 'analytics/last_screenshots/';
      } else if (filter.isExplore) {
        return '/analytics/facts/' + this.cube.name + '/';
      } else if (filter.isAnalysis) {
        return filter.skipStat ? '/analytics/values/' + this.cube.name + '/' : '/analytics/aggregate/' + this.cube.name + '/';
      } else if (filter.isCardFilter) {
        return '/analytics/card/';
      } else if (filter.isReports) {
        return filter.url;
      } else if (filter.isDashboard || filter.isCard) {
        return '';
      }
      console.error('unknown filter mode');
    }
  }, {
    key: 'formatDate',
    value: function formatDate(text) {
      return _filter.Filter.formatDate(new Date(text), 'dd MMM yyyy HH:mm');
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.cancelSubject.onNext(null);
      if (this.CurrentFilterService.filter.toExcel) {
        if (!this.filter.customLimit) this.filter.customLimit = this.filter.toExcel.normalLimit;
        delete this.filter.toExcel;
        this.$rootScope.$broadcast('reload');
      }
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      if (!this.loading && !this.loadingMore || !this.canceller) {
        console.error('nothing to cancel');
        return;
      }
      this.canceller.resolve('abort');
      this.canceller = null;
      this.loading = false;
      this.loadingMore = false;
      this.isComplete = false;
      this.frameLoad = null;
      if (this.page > 0) {
        this.page -= 1;
        this.cancelledMore = true;
      } else {
        this.cancelled = true;
      }
      this.$rootScope.$evalAsync(function () {});
      // console.log('cancel filter page', this.page);
    }
  }, {
    key: 'beforeLoad',
    value: function beforeLoad() {
      if (this.loading || this.loadingMore || this.canceller) {
        console.error('load filter already in progress');
      }
      this.canceller = this.$q.defer();
      this.loadTime = null;
      this.startLoad = new Date().getTime();
      this.loading = this.page === 0;
      this.loadingMore = this.page !== 0;
      this.cancelled = false;
      this.cancelledMore = false;
      this.isComplete = false;
      this.error = null;
      this.$rootScope.$evalAsync(function () {});
      // console.log('load filter page', this.page);
    }
  }, {
    key: 'afterLoad',
    value: function afterLoad(data) {
      var _this2 = this;

      if (!this.loading && !this.loadingMore) {
        console.error('load filter not in progress');
      }

      this.loading = false;
      this.loadingMore = false;
      this.canceller = null;
      this.frameLoad = null;
      if (this.page === 0) {
        if (this.filter.isExplore || this.CurrentFilterService.lastScreenshots) {
          this.isComplete = this.filter.customLimit || data.object_list.length < this.filter.limit;
          this.filterData = data.object_list;
        } else {
          this.isComplete = true;
          this.filterData = data;
          if (this.filter.isAnalysis) {
            data.filter = this.actualFilter;
            if (data.filter.isStat) {
              var measureValues = data.cells.map(function (e) {
                return e[data.filter.measure];
              });
              data.maxMeasure = Math.max.apply(null, measureValues);
            }
          } else if (this.filter.isCardFilter) {
            data.items = data.items || [];
            for (var i = 0; i < data.items.length; ++i) {
              var item = data.items[i];
              item['agent_account.last_report_time'] = this.formatDate(item['agent_account.last_report_time']);
              item['agent_account.last_activity_time'] = this.formatDate(item['agent_account.last_activity_time']);
            }
          }
        }
      } else {
        if (this.filter.isExplore) {
          // this.isComplete = data.object_list.length == 0; ?? FIXED IN CUBE ?
          this.isComplete = data.object_list.length < this.filter.limit;
          this.filterData = this.filterData.concat(data.object_list);
        } else {
          this.isComplete = true;
          this.filterData = data;
        }
      }
      this.$timeout(function () {
        _this2.$rootScope.$broadcast('FilterDataLoaded');
        // this.$rootScope.$digest();
        if (_this2.startLoad) {
          _this2.finishLoad = new Date().getTime();
        }
      }, 10);
    }
  }, {
    key: 'onError',
    value: function onError(error) {
      this.loading = false;
      this.loadingMore = false;
      this.canceller = null;
      this.isComplete = false;
      this.frameLoad = null;
      if (this.page > 0) {
        this.page -= 1;
      }
      this.ErrorHandlerService.handle(error);
      this.$rootScope.$evalAsync(function () {});
      console.error('load filter page', this.page, error);
    }
  }, {
    key: 'cube',
    get: function get() {
      return this.CurrentModelService.cube;
    }
  }]);

  return FilterDataService;
}();

function FilterDataFactory(CurrentFilterService, CurrentModelService, $q, $rootScope, $http, $timeout, $cookies, $httpParamSerializer, ErrorHandlerService, rx) {
  return function (isModalEditor) {
    return new FilterDataService({
      CurrentFilterService: CurrentFilterService,
      CurrentModelService: CurrentModelService,
      $q: $q,
      $rootScope: $rootScope,
      $http: $http,
      $timeout: $timeout,
      $cookies: $cookies,
      $httpParamSerializer: $httpParamSerializer,
      ErrorHandlerService: ErrorHandlerService,
      rx: rx,
      isModalEditor: isModalEditor
    });
  };
}

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentModelService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _model = __webpack_require__(328);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HIDE_DIMENSIONS = ['filters', 'tags', 'local_time', 'text_data', 'window_title', 'logon_event', 'install_event', 'children_count', 'parent_id', 'id', 'filters_data', 'time_registered', 'process_id', 'user_session_id', 'clipboard_format', 'tag'];

var CUBE_INDEX = 0;

var CurrentModelService = exports.CurrentModelService = function () {
  function CurrentModelService(Models, $q) {
    _classCallCheck(this, CurrentModelService);

    this.Models = Models;
    this.$q = $q;
    this.loading = false;
  }

  _createClass(CurrentModelService, [{
    key: 'load',
    value: function load() {
      var _this = this;

      return this.$q.resolve().then(function () {
        _this.loading = true;
        return _this.Models.load();
      }).then(function (model) {
        model = (0, _model.buildModel)(model);
        model._dimensions = model.dimensions;
        HIDE_DIMENSIONS.forEach(function (key) {
          model.dimensions = model.dimensions.filter(function (dim) {
            return key !== dim.name;
          });
          model.cubes[CUBE_INDEX].dimensions = model.cubes[CUBE_INDEX].dimensions.filter(function (dim) {
            return key !== dim.name;
          });
        });
        // Sort time dimensions
        if (model.dimensions && model.dimensions.length) {
          model.dimensions.forEach(function (d) {
            if (d.name === 'agent_time') {
              d.hierarchies = d.hierarchies.filter(function (h) {
                return h.name !== 'ymdhq';
              });
              // modify?
              d.hierarchies.sort();
            }
            if (d.name == "agent_account") {
              d.hierarchies = d.hierarchies.filter(function (h) {
                return h.name !== 'id';
              });
            }
          });
        }
        _this.model = model;
        _this.cube = model.cubes[CUBE_INDEX];
      }).finally(function () {
        _this.loading = false;
      });
    }
  }]);

  return CurrentModelService;
}();

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // /* global angular */


var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _filter = __webpack_require__(28);

var _config = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RouterService = exports.RouterService = function () {
  function RouterService($location, $rootScope, $timeout, CurrentFilterService, FiltersService, PermissionService, CurrentModelService, $q, $http, ErrorHandlerService, CurrentFilterDataService, FrameLoadService, LayoutService, LocalStorageService, AggregateDataService, md5) {
    var _this = this;

    _classCallCheck(this, RouterService);

    this.$location = $location;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$http = $http;
    this.$timeout = $timeout;
    this.CurrentFilterService = CurrentFilterService;
    this.FiltersService = FiltersService;
    this.PermissionService = PermissionService;
    this.CurrentModelService = CurrentModelService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.FrameLoadService = FrameLoadService;
    this.AggregateDataService = AggregateDataService;
    // this.isEditDasboard = false;
    this.layout = LayoutService;
    this.LocalStorageService = LocalStorageService;
    this.md5 = md5;

    this.$rootScope.$on('$routeUpdate', function (event) {
      if (_this.layout.options.saveInterface.value) _this.LocalStorageService.setItem('locationUrl', _this.$location.url());
      _this.update();
      _this.CurrentFilterDataService.reload();
    });
    this.initialized = false;
  }

  _createClass(RouterService, [{
    key: 'goToSavedUrl',
    value: function goToSavedUrl() {
      var url = this.$location.url();
      if (this.$location.url() === '/') {
        if (this.layout.options.saveInterface.value) {
          url = this.LocalStorageService.getItem('locationUrl');
          if (url) {
            this.$location.url(url);
            return true;
          }
        }
        if (this.layout.options.defaultLense.value) {
          var lenseUrl = this.layout.options.defaultLense.value;
          this.$location.search(lenseUrl);
          return true;
        }
      }
      if (this.layout.options.saveInterface.value) this.LocalStorageService.setItem('locationUrl', url);
      return false;
    }
  }, {
    key: 'waitSeconds',
    value: function waitSeconds(sec) {
      this.$http.get('analytics/wait_seconds/?sec=' + sec).then(function (resp) {
        console.log(resp.data);
      });
    }
  }, {
    key: 'init',
    value: function init() {
      var _this2 = this;

      if (this.initialized) {
        console.error('initialize already in progress');
        return;
      }
      this.initialized = false;
      return this.$q.all([this.PermissionService.load(), this.CurrentModelService.load(), this.FiltersService.load()]).then(function () {
        _this2.CurrentFilterService.updatePanel();
        if (_this2.search().id) {
          var id = _this2.search().id;
          _this2.layout.openedFilters = _this2.FiltersService.searchFilters(function (f) {
            return f.id == id;
          });
        } else if (_this2.PermissionService.has_filter_limit) {
          var filter = _this2.FiltersService.find(function (f) {
            return f.content_type !== 'folder';
          });
          if (!filter) filter = _this2.FiltersService.find(function (f) {
            return true;
          });
          if (filter) _this2.filter = filter;
        }
        _this2.goToSavedUrl();
        _this2.update();
        // this.waitSeconds(8);
        return _this2.CurrentFilterDataService.reload();
      }).then(function () {
        if (window.first_start) {
          _this2.openFrame('/analytics/welcome/');
          window.first_start = false;
        }
      }).then(function () {
        _this2.$rootScope.$broadcast('init');
      }).then(function () {
        return _this2.FrameLoadService.waitUntilLoad();
      }).catch(function (error) {
        _this2.ErrorHandlerService.handle(error);
      }).finally(function () {
        _this2.initialized = true;
        setTimeout(function () {
          // notify html2pdf that document is ready
          window.status = 'INIT_COMPLETE';
          console.log('staffcop init complete');
        }, 1000);
      });
    }
  }, {
    key: 'home',
    value: function home() {
      this.LocalStorageService.setItem('locationUrl', '/');
      this.LocalStorageService.setItem('STATE', '{}');
      window.location = '/';
    }

    // /**
    //  * update state from url
    //  */

  }, {
    key: 'update',
    value: function update() {
      var state = this.search();
      this.validate(state);

      if (state.timeFrom) {
        this.CurrentFilterService.timeFrom = state.timeFrom;
      } else {
        this.CurrentFilterService.timeFrom = new Date();
        this.CurrentFilterService.timeFrom.setHours(0, 0, 0, 0);
      }

      if (state.lastScreenshots) {
        this.CurrentFilterService.lastScreenshots = {
          timeFrom: this.CurrentFilterService.timeFrom,
          eventTp: state.lastScreenshotsEventTp
        };
      } else {
        delete this.CurrentFilterService.lastScreenshots;
      }

      if (state.timeTo) {
        this.CurrentFilterService.timeTo = state.timeTo;
      } else {
        this.CurrentFilterService.timeTo = new Date(this.CurrentFilterService.timeFrom.valueOf());
        this.CurrentFilterService.timeTo.setHours(23, 59, 59, 999);
      }
      if (state.panel) {
        this.CurrentFilterService.panel = state.panel;
      }

      if (state.modal) {
        this.CurrentFilterService.modal = state.modal;
      }

      this.switchPane();

      var setFilter = false;
      if (typeof state.id !== 'undefined') {
        var id = Number(state.id);

        // const noChange = this.CurrentFilterService.filter && this.CurrentFilterService.filter.isDashboard && this.CurrentFilterService.filter.isChanged;
        // if (noChange) setFilter = true;

        // if (id && !isNaN(id) && !noChange) {
        if (id && !isNaN(id)) {
          var filter = this.FiltersService.findById(id);
          if (filter) {
            if (this.CurrentFilterService.filter && this.CurrentFilterService.filter.isDashboard) this.dashboardChildren = this.CurrentFilterService.filter.children;
            this.CurrentFilterService.filter = angular.copy(filter);
            if (filter.isAnalyticPolitic) {
              this.CurrentFilterService.filter.setFilter('analytics_filter@name:name', filter.name, filter.name);
              this.CurrentFilterService.filter.isChanged = false;
            }
            this.CurrentFilterService.protoFilter = filter;
            setFilter = true;
          }
        }
      }
      if (!this.CurrentFilterService.filter) {
        if (this.CurrentFilterService.panel === 'constructor' || !this.FiltersService.filters.length) {
          this.CurrentFilterService.newFilter(null, this.type);
        } else {
          if (this.FiltersService.filters.length) {
            this.CurrentFilterService.filter = angular.copy(this.FiltersService.filters[0]);
          } else {
            console.error('no one filter found');
          }
        }
      } else {
        if (!setFilter) {
          // this.CurrentFilterService.newFilter(null, this.type);
          this.CurrentFilterService.newFilter(null);
        }
      }
      if (this.CurrentFilterService.filter) {
        this.updateFilter(state);

        this.updateFilterChildren(this.CurrentFilterService.filter);
        if (setFilter && !this.CurrentFilterService.filter.isChanged && !state.panel) {
          this.CurrentFilterService.panel = 'catalog';
        }
      }
      this.CurrentFilterService.selectBarDim(state.barDim || this.CurrentFilterService.defaultDimension);
      if (state.lookup) {
        this.CurrentFilterService.filterBar.lookup = state.lookup;
      } else {
        this.CurrentFilterService.filterBar.lookup = '';
      }
      if (state.frameUrl) {
        this.cleanRemoteUsers();
        this.CurrentFilterService.openFrame(state.frameUrl);
      } else {
        this.CurrentFilterService.reset();
      }

      if (state.remoteUsers) {
        if (!this.AggregateDataService.allRemoteUsers || this.AggregateDataService.allRemoteUsers.length < 1) {
          this.cleanRemoteUsers();
        } else {
          this.AggregateDataService.updateRemoteUsers();
          if (!this.isRemoteUsers) this.cleanRemoteUsers();
        }
      }
    }
  }, {
    key: 'updateFilter',
    value: function updateFilter(state) {
      var _this3 = this;

      var changed = false;

      if (state.modal) {
        this.openModal();
      } else {
        this.closeModal();
      }

      if (state.chartAreaType != undefined && this.CurrentFilterService.filter.chartAreaType !== state.chartAreaType) {
        this.CurrentFilterService.filter.chartAreaType = state.chartAreaType;
        changed = true;
      }

      if (state.chartAreaIsStacked != undefined && this.CurrentFilterService.filter.chartAreaIsStacked !== (state.chartAreaIsStacked === 'true')) {
        this.CurrentFilterService.filter.chartAreaIsStacked = state.chartAreaIsStacked === 'true';
        changed = true;
      }

      if (state.drilldown) {
        this.CurrentFilterService.filter.drilldown = state.drilldown.split(',');
        changed = true;
      }

      if (state.fields) {
        this.CurrentFilterService.filter.fields = state.fields.split(',');
        changed = true;
      }

      if (state.filters) {
        try {
          this.CurrentFilterService.filter.filters = JSON.parse(state.filters);
          changed = true;
        } catch (error) {
          console.error('parse filters route parameter');
        }
      }
      if (state.query) {
        try {
          this.CurrentFilterService.filter.query = JSON.parse(state.query);
          changed = true;
        } catch (error) {
          console.error('parse query route parameter');
        }
      }
      if (state.measure) {
        this.CurrentFilterService.filter.measure = state.measure;
        changed = true;
      }
      if (state.limit || state.limit === 0) {
        this.CurrentFilterService.filter.customLimit = state.limit;
        // if (!this.CurrentFilterService.filter.customLimit) this.search('limit', null);
        changed = true;
      }
      if (state.mode) {
        this.CurrentFilterService.filter.setMode(state.mode);
        changed = true;
      }
      if (state.contentType) {
        this.CurrentFilterService.filter.content_type = state.contentType;
        changed = true;
      }
      if (state.threshold) {
        this.CurrentFilterService.filter.threshold = state.threshold;
        changed = true;
      }
      if (state.url) {
        this.CurrentFilterService.filter.url = state.url;
        changed = true;
      }

      if (state.listType) {
        this.CurrentFilterService.filter.listType = state.listType;
        changed = true;
      }

      if (state.orders) {
        var orders = state.orders.split(',');
        if (!angular.equals(this.CurrentFilterService.filter.orders, orders)) {
          changed = true;
          this.CurrentFilterService.filter.orders = orders;
        }
      }

      if (state.top_len) {
        this.CurrentFilterService.filter.top_len = state.top_len;
        changed = true;
      }

      if (state.repOrders) {
        var repOrders = state.repOrders.split(',');
        if (!angular.equals(this.CurrentFilterService.filter.repOrders, repOrders)) {
          changed = true;
          this.CurrentFilterService.filter.repOrders = repOrders;
        }
      }
      if (state.repOrderDirs) {
        var repOrderDirs = state.repOrderDirs.split(',');
        if (!angular.equals(this.CurrentFilterService.filter.repOrderDirs, repOrderDirs)) {
          changed = true;
          this.CurrentFilterService.filter.repOrderDirs = repOrderDirs;
        }
      }

      if (state.orderDirs) {
        var orderDirs = state.orderDirs.split(',');
        if (!angular.equals(this.CurrentFilterService.filter.orderDirs, orderDirs)) {
          changed = true;
          this.CurrentFilterService.filter.orderDirs = orderDirs;
        }
      }

      if (state.order) {
        var order = state.order;
        if (this.CurrentFilterService.filter.order !== order) {
          this.CurrentFilterService.filter.order = order;
          changed = true;
        }
      }

      if (state.orderDir) {
        var orderDir = state.orderDir;
        if (this.CurrentFilterService.filter.orderDir !== orderDir) {
          this.CurrentFilterService.filter.orderDir = orderDir;
          changed = true;
        }
      }

      if (state.aggrOrder) this.CurrentFilterService.filterBar.aggrOrder = state.aggrOrder;else delete this.CurrentFilterService.filterBar.aggrOrder;

      if (state.simular) {
        this.CurrentFilterService.filter.simular = state.simular;
        changed = true;
      }
      if ('children' in state && this.dashboardChildren) {
        if (this.CurrentFilterService.filter.children && this.CurrentFilterService.filter.isCardOrDashboard) {
          var children = state.children ? state.children.split(',') : [];
          changed = true;
          this.CurrentFilterService.filter.children = children.map(function (id) {
            if (id === '0') return _this3.dashboardChildren.find(function (f) {
              return !f.id && !f.dIndex;
            });
            return _this3.dashboardChildren.find(function (f) {
              return id === '' + f.id || id === f.dIndex;
            }) || (id.indexOf('_') == -1 ? _this3.FiltersService.findById(parseInt(id, 0)) : null);
          }).filter(function (f) {
            return f;
          }).concat(this.dashboardChildren.filter(function (f) {
            return children.indexOf('' + f.id) == -1 && children.indexOf('' + f.dIndex) == -1;
          }));
          delete this.dashboardChildren;
        } else delete state.children;
      }

      this.CurrentFilterService.filter.isChanged = changed && !this.CurrentFilterService.filter.isAnalyticPolitic && !this.CurrentFilterService.filter.isCardFilter;
      if (this.CurrentFilterService.filter.isCardFilter && this.CurrentFilterService.filter.hasFilters()) {
        this.CurrentFilterService.buildCardFilter();
      }
    }
  }, {
    key: 'updateFilterChildren',
    value: function updateFilterChildren(filter) {
      var _this4 = this;

      filter.children.forEach(function (child) {
        return _this4.updateFilterChild(filter, child);
      });
    }
  }, {
    key: 'updateFilterChild',
    value: function updateFilterChild(parent, child) {
      if (!child) return;
      child.timeFrom = parent.timeFrom;
      child.timeTo = parent.timeTo;
      if (this.CurrentFilterService.filter.isCard) {
        parent.filters.forEach(function (f) {
          return child.removeFilter(f.dimension, f.value);
        });
        child.filters = child.filters.concat(parent.filters);
      }
      this.updateFilterChildren(child);
    }

    /**
     * filter out invalid keys
     * @param state
     */

  }, {
    key: 'validate',
    value: function validate(state) {
      // state.timeFrom = Filter.urlToDate(state.timeFrom);
      // state.timeTo = Filter.urlToDate(state.timeTo);
      if (!this.PermissionService.filterConstructor) {
        if (state.panel === 'constructor') {
          state.panel = 'catalog';
        }
      }
    }
  }, {
    key: 'setFilter',
    value: function setFilter(dimension, value, label) {
      this.CurrentFilterService.filter.setFilter(dimension, value, label);
      this.CurrentFilterService.filter.mode = 'explore';
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(filter) {
      this.CurrentFilterService.filter.toggleFilter(filter);
      this.CurrentFilterService.filter.mode = 'explore';
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }
  }, {
    key: 'removeConditions',
    value: function removeConditions() {
      this.search('query', 'null');
    }
  }, {
    key: 'changeCut',
    value: function changeCut(dimension, value, modal) {
      this.FilterEditorService.cut = {
        dimension: dimension,
        value: value
      };
      this.modal = modal;
    }
  }, {
    key: 'drilldownFilter2',
    value: function drilldownFilter2(dimension, value, label, mode) {
      var _this5 = this;

      if (!dimension) return;
      this.$timeout(function () {
        if (_this5.isFilterEditModal) return;
        if (!value && !label && value !== '' && label !== '') {
          _this5.CurrentFilterService.filter.reSetFilter(dimension);
        } else {
          _this5.CurrentFilterService.filter.reSetFilter({
            dimension: dimension,
            value: value,
            label: label
          });
        }
        _this5.CurrentFilterService.filter.mode = mode ? mode : 'explore';
        delete _this5.CurrentFilterService.filter.id;
        _this5.CurrentFilterService.rebuildVisibleDimensions();
        _this5.filterChanged();
      }, 10);
    }
  }, {
    key: 'drilldownFilter',
    value: function drilldownFilter(dimension, value, label, mode) {
      var _this6 = this;

      if (!dimension) return;
      this.$timeout(function () {
        if (_this6.isFilterEditModal) return;
        if (!value && !label) {
          _this6.CurrentFilterService.filter.toggleFilter(dimension);
        } else {
          _this6.CurrentFilterService.filter.toggleFilter({
            dimension: dimension,
            value: value,
            label: label
          });
        }
        _this6.CurrentFilterService.filter.mode = mode ? mode : 'explore';
        delete _this6.CurrentFilterService.filter.id;
        _this6.CurrentFilterService.rebuildVisibleDimensions();
        _this6.filterChanged();
      }, 10);
    }
  }, {
    key: 'drilldownFilterHTML',
    value: function drilldownFilterHTML(cuts, isCurrFilterCuts) {
      var _this7 = this;

      this.$timeout(function () {
        if (isCurrFilterCuts) {
          _this7.CurrentFilterService.filter.filters.map(function (cut) {
            console.log(_this7.CurrentModelService.model.getDimension(cut.dimension).name);
            if (cuts.every(function (c) {
              return _this7.CurrentModelService.model.getDimension(c.dimension).name != _this7.CurrentModelService.model.getDimension(cut.dimension).name;
            })) cuts.push(cut);
          });
        }
        if (_this7.isFilterEditModal) return;
        // const filter = angular.copy(this.CurrentFilterService.filter);
        var filter = new _filter.Filter();
        cuts.map(function (c) {
          return filter.toggleFilter(c);
        });
        filter.mode = 'explore';
        delete filter.id;
        filter.url = '/analytics/report/facts/';
        if (filter.order === 'record_count') {
          filter.order = 'local_time';
        }
        var src = _this7.CurrentFilterService.getReportUrl(filter);
        window.open(src, '_blank');
      }, 10);
    }
  }, {
    key: 'drilldownCut',
    value: function drilldownCut(dimension, value, label, mode) {
      if (!dimension || this.isFilterEditModal) return;
      if (!value && !label) {
        this.CurrentFilterService.filter.addCut(dimension);
      } else {
        this.CurrentFilterService.filter.addCut({
          dimension: dimension,
          value: value,
          label: label
        });
      }
      this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
      delete this.CurrentFilterService.filter.id;
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }
  }, {
    key: 'drilldownCuts',
    value: function drilldownCuts(cuts) {
      var _this8 = this;

      if (this.isFilterEditModal) return;
      cuts.map(function (cut) {
        if (!cut.dimension) return null;
        if (!cut.value && !cut.label) {
          _this8.CurrentFilterService.filter.addCut(cut.dimension);
        } else {
          _this8.CurrentFilterService.filter.addCut(cut);
        }
      });

      this.CurrentFilterService.filter.mode = 'explore';
      delete this.CurrentFilterService.filter.id;
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.$timeout(function () {
        _this8.filterChanged();
      }, 10);
    }
  }, {
    key: 'removeCut',
    value: function removeCut(dimension, value, label, mode) {
      if (!dimension) return;
      this.CurrentFilterService.filter.mode = mode ? mode : 'explore';
      this.CurrentFilterService.filter.removeFilter(dimension, value, label, mode);
      delete this.CurrentFilterService.filter.id;
      this.CurrentFilterService.rebuildVisibleDimensions();
      this.filterChanged();
    }
  }, {
    key: 'cleanFilter',
    value: function cleanFilter(dimension) {
      if (!dimension || this.isFilterEditModal) return;
      this.CurrentFilterService.filter.cleanFilter(dimension);
      this.filterChanged();
    }
  }, {
    key: 'addFilter',
    value: function addFilter() {
      var _CurrentFilterService;

      (_CurrentFilterService = this.CurrentFilterService.filter).addFilter.apply(_CurrentFilterService, arguments);
      this.filterChanged();
    }
  }, {
    key: 'addTimeFilter',
    value: function addTimeFilter() {
      var _CurrentFilterService2;

      (_CurrentFilterService2 = this.CurrentFilterService.filter).addTimeFilter.apply(_CurrentFilterService2, arguments);
      this.filterChanged();
    }
  }, {
    key: 'removeFilter',
    value: function removeFilter() {
      var _CurrentFilterService3;

      (_CurrentFilterService3 = this.CurrentFilterService.filter).removeFilter.apply(_CurrentFilterService3, arguments);
      this.filterChanged();
    }
  }, {
    key: 'invertFilter',
    value: function invertFilter() {
      var _CurrentFilterService4;

      (_CurrentFilterService4 = this.CurrentFilterService.filter).invertFilter.apply(_CurrentFilterService4, arguments);
      this.filterChanged();
    }
  }, {
    key: 'addKeyword',
    value: function addKeyword(keywords) {
      if (this.isFilterEditModal) return;
      this.CurrentFilterService.filter.addKeyword(keywords);
      this.filterChanged();
    }
  }, {
    key: 'removeModal',
    value: function removeModal() {
      this.search('modal', null);
      this.CurrentFilterService.modal = null;
    }
  }, {
    key: 'setPane',
    value: function setPane(isPane) {
      if (isPane) this.search('paneClose', null);else this.search('paneClose', true);
    }
  }, {
    key: 'switchPane',
    value: function switchPane() {
      if (window.isPaneOpen !== this.getPane()) {
        angular.element(document).trigger('showDimensions');
      }
    }
  }, {
    key: 'getPane',
    value: function getPane() {
      return !this.search().paneClose;
    }
  }, {
    key: 'setMeasure',
    value: function setMeasure(measure) {
      this.CurrentFilterService.filter.measure = measure;
      this.filterChanged();
    }
  }, {
    key: 'setLimit',
    value: function setLimit(limit) {
      if (this.CurrentFilterService.filter.customLimit === limit) return;
      this.CurrentFilterService.filter.customLimit = limit;
      this.filterChanged();
    }
  }, {
    key: 'selectFilter',
    value: function selectFilter(id, force) {
      this.isEditDasboard = false;
      var query = Object.assign({}, this.search());
      this.clearFilter(query);
      query.id = id;
      if (angular.equals(this.search(), query)) {
        var filter = this.FiltersService.findById(id);
        this.CurrentFilterService.filter = angular.copy(filter);

        if (filter.isAnalyticPolitic) {
          this.CurrentFilterService.filter.setFilter('analytics_filter@name:name', filter.name, filter.name);
          this.CurrentFilterService.filter.isChanged = false;
        }
        // this.CurrentFilterService.filter = filter;
        if (filter.isCardFilter && !filter.children[0]) {
          this.CurrentFilterService.buildCardFilter();
        }
        this.CurrentFilterDataService.reload(force);
        return;
      }
      this.search(query);
      if (force) this.CurrentFilterDataService.reload(force);
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter(query) {
      delete query.id;
      delete query.allFilters;
      delete query.chartAreaType;
      delete query.chartAreaIsStacked;
      delete query.drilldown;
      delete query.filters;
      delete query.query;
      delete query.measure;
      delete query.mode;
      delete query.url;
      delete query.listType;
      delete query.frameUrl;
      delete query.repOrders;
      delete query.repOrderDirs;
      delete query.orders;
      delete query.top_len;
      delete query.orderDirs;
      delete query.repOrders;
      delete query.repOrderDirs;
      delete query.order;
      delete query.orderDir;
      delete query.type;
      delete query.limit;
      delete query.modal;
      delete query.simular;
      delete query.fields;
      delete query.childrenMinimized;
      delete query.children;
      delete query.contentType;
      delete query.threshold;
    }
  }, {
    key: 'resetFilter',
    value: function resetFilter() {
      var query = this.search();
      var id = query.id;
      this.clearFilter(query);
      if (id) {
        query.id = id;
      }
      this.search(query);
    }
  }, {
    key: 'onDeleteFilter',
    value: function onDeleteFilter() {
      var query = this.search();
      this.clearFilter(query);
      this.search(query);
    }
  }, {
    key: 'replaceDim',
    value: function replaceDim(newDim, oldDim) {
      if (this.CurrentFilterService.filter.hasDrilldown(newDim.toString())) {
        return;
      }
      this.CurrentFilterService.filter.replaceDrilldown(newDim.toString(), oldDim.toString());
      this.CurrentFilterService.filter.changed();
      this.search('frameUrl', null);
      this.cleanRemoteUsers();
      this.search('editDasboard', null);
      this.filterChanged();
    }
  }, {
    key: 'selectDim',
    value: function selectDim(dim) {
      if (this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.CurrentFilterService.filter.addDrilldown(dim.toString());
      this.CurrentFilterService.filter.changed();
      this.search('frameUrl', null);
      this.cleanRemoteUsers();
      this.search('editDasboard', null);
      this.filterChanged();
    }
  }, {
    key: 'removeDim',
    value: function removeDim(dim) {
      if (!this.CurrentFilterService.filter.hasDrilldown(dim.toString())) {
        return;
      }
      this.CurrentFilterService.filter.removeDrilldown(dim.toString());
      this.CurrentFilterService.filter.changed();
      this.filterChanged();
    }
  }, {
    key: 'drilldown',
    value: function drilldown(dim) {
      if (dim.dimension || dim.is_flat) {
        this.CurrentFilterService.filterBar.drill = dim.toString();
        this.filterChanged();
      }
    }
  }, {
    key: 'lookup',
    value: function lookup(value) {
      this.search('lookup', value || null);
    }
  }, {
    key: 'generateReport',
    value: function generateReport() {
      var _CurrentFilterService5;

      (_CurrentFilterService5 = this.CurrentFilterService).generateReport.apply(_CurrentFilterService5, arguments);
      this.filterChanged();
      this.search('frameUrl', null);
      this.cleanRemoteUsers();
      this.search('editDasboard', null);
    }
  }, {
    key: 'openFrame',
    value: function openFrame(url) {
      this.search('frameUrl', url);
      this.search('editDasboard', null);
    }
  }, {
    key: 'openNewWindow',
    value: function openNewWindow(more) {
      if (typeof more !== 'string') {
        more = '';
      }
      var src = this.CurrentFilterService.frameUrl || this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
      window.open(src + more, '_blank');
    }
  }, {
    key: 'filterChanged',
    value: function filterChanged() {
      this.filter = this.CurrentFilterService.filter;
    }
  }, {
    key: 'frameChanged',
    value: function frameChanged() {
      if (this.CurrentFilterService.frameUrl) {
        this.search('frameUrl', this.CurrentFilterService.frameUrl);
      } else {
        this.search('frameUrl', null);
      }
    }
  }, {
    key: 'newFilter',
    value: function newFilter(type) {
      // this.panel = 'constructor';
      this.search('editDasboard', null);
      this.modal = 'new-filter';
      // this.CurrentFilterService.frameUrl = null;
      // this.CurrentFilterService.createNewFilter(null, type);
      var filter = this.CurrentFilterService.createNewFilter(null, type);
      if (type === 'filteraggregatealertfilter') {
        filter.setMode('stat');
        filter.send_threshold = true;
      }

      this.FilterEditorService.editModal({
        filter: filter,
        asNew: false,
        selectFilter: true,
        type: type
      });
    }
  }, {
    key: 'openCard',
    value: function openCard(filterCut) {
      var query = this.search();
      query.mode = 'reports';
      query.url = '/analytics/card/';
      query.filters = angular.toJson([filterCut]);
      query.drilldown = [filterCut.dimension].join(',');
      delete query.frameUrl;
      delete query.allFilters;
      delete query.id;
      this.search(query);
    }
  }, {
    key: 'openModal',
    value: function openModal() {
      if (this.modal) {
        if (this.modal === 'new-filter') {
          this.FilterEditorService.editModal({
            filter: this.CurrentFilterService.createNewFilter(null, this.type),
            asNew: false,
            selectFilter: true,
            type: this.type
          });
        } else if (this.modal === 'filter-edit') {
          this.FilterEditorService.editModal({
            filter: this.CurrentFilterService.filter,
            asNew: false,
            selectFilter: true,
            type: this.type
          });
        } else if (this.modal === 'cut-edit' && this.FilterEditorService.cut) {
          this.FilterEditorService.editModal({
            filter: this.CurrentFilterService.filter,
            asNew: false,
            selectFilter: true
          });
        } else if (this.modal === 'rules-edit') {
          this.FilterEditorService.editModal({
            // filter: this.CurrentFilterService.filter,
            asNew: false
            // selectFilter: true,
          });
        } else this.removeModal();
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      if (!this.FilterEditorService) return;
      this.FilterEditorService.cancel();
      this.CurrentFilterService.modal = null;
      if (this.imageDialog) this.imageDialog.close();
    }
  }, {
    key: 'cleanRemoteUsers',
    value: function cleanRemoteUsers() {
      this.search('remoteUsers', null);
      if (this.CurrentFilterService && this.CurrentFilterService.lastScreenshots) {
        this.search('lastScreenshots', null);
        this.search('lastScreenshotsEventTp', null);
        delete this.CurrentFilterService.lastScreenshots;
      }
    }
  }, {
    key: 'setRemoteUsers',
    value: function setRemoteUsers() {
      if (!this.AggregateDataService.remoteUsers && this.AggregateDataService.remoteUsers.length < 1) return;
      this.search('frameUrl', null);
      this.search('url', null);
      this.search('mode', null);
      this.setPane(false);
      this.search('remoteUsers', true);
      this.search('lastScreenshots', null);
      this.search('lastScreenshotsEventTp', null);
      delete this.CurrentFilterService.lastScreenshots;
    }
  }, {
    key: 'setLastScreenshots',
    value: function setLastScreenshots(eventType) {
      this.search('frameUrl', null);
      this.search('remoteUsers', null);
      this.search('url', null);
      this.search('mode', null);
      this.search('lastScreenshots', true);
      this.search('lastScreenshotsEventTp', eventType);
    }
  }, {
    key: 'findSimular',
    value: function findSimular(factId) {
      this.search('simular', factId);
    }
  }, {
    key: 'toNeighbourEvents',
    value: function toNeighbourEvents() {
      var queryCanged = false;
      if (!this.needToShowFact || !this.needToShowFact.fact) return;

      var currentFact = this.needToShowFact.fact;
      var dateFact = (0, _moment2.default)(currentFact.local_time.substr(0, 19));
      if (!dateFact.isValid()) return;
      var minutes = this.layout.options.toNeighboursMinutes.value;
      var dateStart = (0, _moment2.default)(dateFact).subtract(minutes, 'minutes');
      var dateEnd = (0, _moment2.default)(dateFact).add(minutes, 'minutes');
      if (new Date(this.search().timeFrom).getTime() !== dateStart.toDate().getTime()) {
        this.timeFrom = dateStart.toDate();
        queryCanged = true;
      }
      if (new Date(this.search().timeTo).getTime() !== dateEnd.toDate().getTime()) {
        this.timeTo = dateEnd.toDate();
        queryCanged = true;
      }

      var filters = [];
      if (currentFact['agent_agent.id'] && currentFact['agent_agent.guid'] && currentFact['agent_agent.computer_name']) {
        filters.push({
          'dimension': 'agent_agent@computer_name:computer_name',
          'value': currentFact['agent_agent.id'] + _config.PATH_STRING_SEPARATOR + currentFact['agent_agent.guid'] + _config.PATH_STRING_SEPARATOR + currentFact['agent_agent.computer_name'],
          'label': currentFact['agent_agent.computer_name'],
          'predicates': []
        });
      }
      if (currentFact['agent_account.user_name']) {
        filters.push({
          'dimension': 'agent_account@user_name:user_name',
          'value': currentFact['agent_account.user_name'],
          'label': currentFact['agent_account.user_name'],
          'predicates': []
        });

        var limit = minutes * 100;
        if (!angular.equals(this.CurrentFilterService.filter.filters, filters) || this.CurrentFilterService.filter.customLimit !== limit) {
          this.CurrentFilterService.filter.customLimit = limit;
          this.CurrentFilterService.filter.filters = filters;
          queryCanged = true;
        }
      }

      this.needToShowFact = {
        needShowtoNeighbours: true,
        fact: currentFact
      };

      if (queryCanged) {
        this.filterChanged();
      } else {
        // this.$rootScope.$broadcast('factsLoaded');
      }
    }
  }, {
    key: 'toUserNearestScreenshot',
    value: function toUserNearestScreenshot() {
      var queryCanged = false;
      var currentFact = this.needToShowFact ? this.needToShowFact.fact : null;
      if (currentFact) {
        var dateFact = (0, _moment2.default)(currentFact.local_time.substr(0, 19));
        if (!dateFact.isValid()) return;
        var dateStart = (0, _moment2.default)(dateFact).subtract(1, 'hour');
        var dateEnd = (0, _moment2.default)(dateFact).add(1, 'hour');
        if (new Date(this.search().timeFrom).getTime() !== dateStart.toDate().getTime()) {
          this.timeFrom = dateStart.toDate();
          queryCanged = true;
        }
        if (new Date(this.search().timeTo).getTime() !== dateEnd.toDate().getTime()) {
          this.timeTo = dateEnd.toDate();
          queryCanged = true;
        }

        var filters = [{
          'dimension': 'agent_eventtype@default:agent_eventtype',
          'value': '4',
          'label': gettext('Снимок экрана'),
          'predicates': []
        }];
        if (currentFact['agent_agent.id'] && currentFact['agent_agent.guid'] && currentFact['agent_agent.computer_name']) {
          filters.push({
            'dimension': 'agent_agent@computer_name:computer_name',
            'value': currentFact['agent_agent.id'] + _config.PATH_STRING_SEPARATOR + currentFact['agent_agent.guid'] + _config.PATH_STRING_SEPARATOR + currentFact['agent_agent.computer_name'],
            'label': currentFact['agent_agent.computer_name'],
            'predicates': []
          });
        }
        if (currentFact['agent_account.user_name']) {
          filters.push({
            'dimension': 'agent_account@user_name:user_name',
            'value': currentFact['agent_account.user_name'],
            'label': currentFact['agent_account.user_name'],
            'predicates': []
          });
        }

        var limit = 600;
        if (!angular.equals(this.CurrentFilterService.filter.filters, filters) || this.CurrentFilterService.filter.customLimit !== limit) {
          this.CurrentFilterService.filter.customLimit = limit;
          this.CurrentFilterService.filter.filters = filters;
          queryCanged = true;
        }
      } else {
        var _filters = angular.copy(this.CurrentFilterService.filter.filters);
        this.CurrentFilterService.filter.cleanFilter('agent_eventtype@default:agent_eventtype');
        this.CurrentFilterService.filter.addFilter('agent_eventtype@default:agent_eventtype', '4', gettext('Снимок экрана'), []);
        if (!angular.equals(this.CurrentFilterService.filter.filters, _filters)) {
          queryCanged = true;
        }
      }

      this.needToShowFact = {
        needShowScreenshot: true,
        fact: null,
        date: currentFact ? currentFact.local_time : null
      };

      if (queryCanged) {
        this.filterChanged();
      } else {
        this.$rootScope.$broadcast('factsLoaded');
      }
    }
  }, {
    key: 'search',
    value: function search() {

      if (_config.IS_IE_BROWSER) {

        var hash = this.$location.search()['hash'] || '';

        var history = window.HISTORY;
        if (!history) {
          history = JSON.parse(this.LocalStorageService.getItem('HISTORY') || '{}');
        }

        var state = angular.copy(history[hash] || {});

        if (!arguments.length) return state;

        var param = arguments.length <= 0 ? undefined : arguments[0];
        var value = arguments.length <= 1 ? undefined : arguments[1];

        var oldState = JSON.stringify(state);

        if (param && !value) {
          if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
            state = param;
          } else {
            delete state[param];
          }
        } else state[param] = value;

        var newState = JSON.stringify(state);

        if (oldState !== newState) {
          var newHash = this.md5.createHash(newState);
          history[newHash] = state;
          window.HISTORY = history;
          this.LocalStorageService.setItem('HISTORY', JSON.stringify(history));
          this.$location.search('hash', newHash);
        }
        return state;
      } else {
        var _$location;

        return (_$location = this.$location).search.apply(_$location, arguments);
      }
    }
  }, {
    key: 'frameUrl',
    get: function get() {
      return this.search().frameUrl;
    }
  }, {
    key: 'url',
    get: function get() {
      return this.search().url;
    }
  }, {
    key: 'mode',
    get: function get() {
      return this.search().mode;
    }

    // require fot expotr to pdf
    ,
    set: function set(mode) {
      if (this.isFilterEditModal) return;
      this.panel = 'constructor';
      this.search('mode', mode);
      this.search('frameUrl', null);
      this.cleanRemoteUsers();
      this.search('editDasboard', null);
      if (mode !== 'reports') {
        this.search('repOrders', null);
        this.search('repOrderDirs', null);
      }
    }

    // aggregateOrder == 'statAsc','statDesc','nameAsc',  nameDesc'

  }, {
    key: 'pdf',
    get: function get() {
      return this.search().pdf;
    }
  }, {
    key: 'chartAreaType',
    set: function set(chartAreaType) {
      if (this.isFilterEditModal) return;
      this.search('chartAreaType', chartAreaType);
    }
  }, {
    key: 'chartAreaIsStacked',
    set: function set(chartAreaIsStacked) {
      if (this.isFilterEditModal) return;
      this.search('chartAreaIsStacked', chartAreaIsStacked ? 'true' : 'false');
    }
  }, {
    key: 'filterId',
    set: function set(id) {
      if (this.isFilterEditModal) return;
      this.search('id', id);
    }
  }, {
    key: 'panel',
    set: function set(panel) {
      if (this.isFilterEditModal) return;
      this.search('panel', panel);
    }
  }, {
    key: 'timeTo',
    set: function set(timeTo) {
      if (this.isFilterEditModal) return;
      this.search('timeTo', _filter.Filter.dateToUrl(timeTo));
    }
  }, {
    key: 'timeFrom',
    set: function set(timeFrom) {
      if (this.isFilterEditModal) return;
      this.search('timeFrom', _filter.Filter.dateToUrl(timeFrom));
    }
  }, {
    key: 'threshold',
    set: function set(threshold) {
      if (this.isFilterEditModal) return;
      this.search('threshold', threshold);
    }
  }, {
    key: 'filter',
    set: function set(filter) {
      var _this9 = this;

      if (this.isFilterEditModal) return;
      var query = this.search();
      this.clearFilter(query);
      if (filter.id) {
        query.id = filter.id;
        this.originalFilter = this.FiltersService.findById(filter.id);
      }
      if (!this.originalFilter) {
        this.originalFilter = new _filter.Filter();
      }
      if (filter.threshold !== this.originalFilter.threshold) {
        query.threshold = filter.threshold;
      } else {
        delete query.threshold;
      }
      if (!angular.equals(filter.drilldown, this.originalFilter.drilldown)) {
        query.drilldown = filter.drilldown.join(',');
      }

      if (!angular.equals(filter.fields, this.originalFilter.fields)) {
        if (filter.fields) query.fields = filter.fields.join(',');else delete query.fields;
      }

      if ((!filter.filters || !filter.filters.length) && this.originalFilter.filters && this.originalFilter.filters.length || (!this.originalFilter.filters || !this.originalFilter.filters.length) && filter.filters && filter.filters.length || filter.filters && filter.filters.length && this.originalFilter.filters && this.originalFilter.filters.length && !angular.equals(filter.filters, this.originalFilter.filters)) {
        query.filters = angular.toJson(filter.filters);
      }
      if (filter.hasQuery !== this.originalFilter.hasQuery || !angular.equals(filter.query, this.originalFilter.query)) {
        query.query = angular.toJson(filter.query);
      }
      if (filter.measure !== this.originalFilter.measure) {
        query.measure = filter.measure;
      }
      if (filter.customLimit !== this.originalFilter.customLimit) {
        query.limit = filter.customLimit;
      }
      if (filter.isReports && filter.url !== this.originalFilter.url) {
        query.url = filter.url;
      }
      if (filter.mode !== this.originalFilter.mode) {
        query.mode = filter.mode;
      }
      if (filter.isExplore && filter.listType !== this.originalFilter.listType) {
        query.listType = filter.listType;
      }

      if (filter.content_type !== this.originalFilter.content_type) {
        query.contentType = filter.content_type;
      }

      if (this.CurrentFilterService.frameUrl) {
        query.frameUrl = this.CurrentFilterService.frameUrl;
      }
      if (filter.isChartArea) {
        if (filter.chartAreaType !== this.originalFilter.chartAreaType) query.chartAreaType = filter.chartAreaType;
        if (filter.chartAreaIsStacked !== this.originalFilter.chartAreaIsStacked) query.chartAreaIsStacked = filter.chartAreaIsStacked ? 'true' : 'false';
      }
      if (!angular.equals(filter.orderDirs, this.originalFilter.orderDirs)) {
        query.orderDirs = filter.orderDirs.join(',');
      }
      if (!angular.equals(filter.orders, this.originalFilter.orders)) {
        query.orders = filter.orders.join(',');
      }

      if (filter.isReports) {
        delete query.orderDirs;
        delete query.orders;

        if (filter.top_len !== this.originalFilter.top_len) {
          query.top_len = filter.top_len;
        }
        if (!angular.equals(filter.repOrders, this.originalFilter.repOrders)) {
          if (filter.repOrders) query.repOrders = filter.repOrders.join(',');
        }
        if (!angular.equals(filter.repOrderDirs, this.originalFilter.repOrderDirs)) {
          if (filter.repOrderDirs) query.repOrderDirs = filter.repOrderDirs.join(',');
        }
      } else {
        delete query.repOrderDirs;
        delete query.repOrders;
      }

      if (filter.order !== this.originalFilter.order) {
        query.orderDir = filter.orderDir;
        query.order = filter.order;
      }

      if (this.CurrentFilterService.modal) {
        query.modal = this.CurrentFilterService.modal;
      }

      if (filter.isDashboard) {
        var childrenChanged = false;
        filter.children.map(function (f, i) {
          var fChanged = false;
          if (i >= _this9.originalFilter.children.length) fChanged = true;else {
            var f2 = _this9.originalFilter.children[i];
            fChanged = !Object.keys(f).every(function (k) {
              var chang = k !== 'dIndex' && k !== 'children' && k !== '_changed' && !angular.equals(f[k], f2[k]);
              // if (chang) console.log(f.id, chang, k, f[k], f2[k]);
              return !chang;
            });
          }
          if (fChanged) {
            // console.log(i, 'Изменен фильтр:', fChanged, f.id, f.name);
            f.isChanged = true;
            childrenChanged = true;
          }
        });
        // this.CurrentFilterService.filter.isChanged = childrenChanged;
        if (childrenChanged) {
          var ids = filter.children.reduce(function (o, f, i) {
            if (!f.deleted) o[f.id ? f.id : f.dIndex ? f.dIndex : 0] = i;
            return o;
          }, {});
          if (filter.children) query.children = Object.keys(ids).sort(function (a, b) {
            return ids[a] - ids[b];
          }).join(',');
        }
      }
      this.search(query);
    }
  }, {
    key: 'barDim',
    set: function set(dim) {
      if (this.isFilterEditModal) return;
      this.search('barDim', dim);
      this.search('lookup', null);
    }
  }, {
    key: 'aggregateOrder',
    set: function set(order) {
      this.search('aggrOrder', order);
    },
    get: function get() {
      return this.search().aggrOrder;
    }
  }, {
    key: 'fields',
    set: function set(fields) {
      this.search('fields', fields);
    },
    get: function get() {
      return this.search().fields;
    }
  }, {
    key: 'type',
    set: function set(type) {
      this.search('type', type);
    },
    get: function get() {
      return this.search().type;
    }

    // modal window

  }, {
    key: 'modal',
    set: function set(modal) {
      if (this.isFilterEditModal) return;
      this.search('modal', modal);
    },
    get: function get() {
      return this.search().modal;
    }
  }, {
    key: 'isFilterEditModal',
    get: function get() {
      return this.modal === 'filter-edit' || this.modal === 'new-filter';
    }
  }, {
    key: 'listType',
    set: function set(mode) {
      if (this.isFilterEditModal) return;
      this.search('listType', mode);
    },
    get: function get() {
      return this.search().listType;
    }
  }, {
    key: 'isLastScreenshots',
    get: function get() {
      return this.search().lastScreenshots;
    }
  }, {
    key: 'isRemoteUsers',
    get: function get() {
      return this.search().remoteUsers && this.AggregateDataService.remoteUsers && this.AggregateDataService.remoteUsers.length > 0;
    }
  }]);

  return RouterService;
}();

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * holds filters tree
 */
var FiltersService = exports.FiltersService = function () {
  function FiltersService($q, FilterResource, globalAlert) {
    _classCallCheck(this, FiltersService);

    this.$q = $q;
    this.FilterResource = FilterResource;
    this.globalAlert = globalAlert;
    this.filters = [];
    this.loading = false;
  }

  _createClass(FiltersService, [{
    key: 'searchFilters',
    value: function searchFilters(predicate) {
      var searchedFilters = {
        all: !predicate
      };
      if (!predicate) return searchedFilters;

      var findIter = function findIter(filters) {
        var foundFilter = false;
        filters.map(function (f) {
          if (predicate(f)) {
            searchedFilters[f.id] = true;
            foundFilter = true;
          }
          if (f.children && f.children.length) {
            if (findIter(f.children)) {
              searchedFilters[f.id] = true;
              foundFilter = true;
            }
          }
        });
        return foundFilter;
      };
      findIter(this.filters);
      return searchedFilters;
    }
  }, {
    key: 'load',
    value: function load() {
      var _this = this;

      return this.$q.resolve().then(function () {
        _this.loading = true;
        return _this.FilterResource.list();
      }).then(function (filters) {
        _this.filters = filters;
      }).finally(function () {
        _this.loading = false;
      });
    }
  }, {
    key: 'save',
    value: function save(filter) {
      var _this2 = this;

      var flt = angular.copy(filter);
      delete flt.dIndex;
      return this.FilterResource.save(flt).then(function (_ref) {
        var status = _ref.status,
            data = _ref.data,
            error = _ref.error;

        if (error) {
          _this2.globalAlert(error.message);
          return;
        }
        var originalFilter = _this2.findById(data.id);
        Object.assign(filter, data);
        if (originalFilter) {
          Object.keys(originalFilter).map(function (k) {
            return delete originalFilter[k];
          });
          Object.assign(originalFilter, data);
        } else if (!filter.dIndex) _this2.filters.push(filter);

        filter.isChanged = false;
        return data;
      });
    }
  }, {
    key: 'find',
    value: function find(predicate) {
      for (var i = 0; i < this.filters.length; ++i) {
        var filter = this.filters[i];
        var f = filter.find(predicate);
        if (f) {
          return f;
        }
      }
    }
  }, {
    key: 'findById',
    value: function findById(id) {
      return this.find(function (f) {
        return f.id === id;
      });
    }
  }, {
    key: 'getPath',
    value: function getPath(filter) {
      for (var i = 0; i < this.filters.length; ++i) {
        var f = this.filters[i];
        var path = f.getPath(filter);
        if (path) {
          return path;
        }
      }
      return [];
    }
  }, {
    key: 'getCardFilter',
    value: function getCardFilter(dim) {
      return this.find(function (filter) {
        return filter.isDimensionCard && filter.dimension === dim;
      }) || this.getDefaultCardFilter(dim);
    }
  }, {
    key: 'getDefaultCardFilter',
    value: function getDefaultCardFilter(dim) {
      dim = dim.split('@')[0];
      return this.find(function (filter) {
        return filter.isDimensionCard && filter.dimension.startsWith(dim);
      });
    }
  }, {
    key: 'onDeleteFilter',
    value: function onDeleteFilter(filter) {
      var path = this.getPath(filter);
      if (path.length) {
        path.pop().removeChild(filter);
      } else {
        this.filters = this.filters.filter(function (f) {
          return f.id != filter.id;
        });
      }
    }
  }, {
    key: 'delete',
    value: function _delete(filter) {
      var _this3 = this;

      return this.FilterResource.delete(filter).then(function (_ref2) {
        var status = _ref2.status,
            data = _ref2.data,
            error = _ref2.error;

        if (error) {
          _this3.globalAlert(error.message);
          // return;
        }
        _this3.onDeleteFilter(filter);
        // this.filters = this.filters.filter((f) => f.id != filter.id);
      }).catch(function (error) {
        _this3.globalAlert(error);
      });
    }
  }]);

  return FiltersService;
}();

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AggregateDataService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AggregateDataService = exports.AggregateDataService = function () {
  function AggregateDataService(Aggregates, CurrentModelService, CurrentFilterService, $rootScope, $q, ErrorHandlerService, rx, loadWithCache, FilterResource) {
    var _this = this;

    _classCallCheck(this, AggregateDataService);

    this.Aggregates = Aggregates;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.loadWithCache = loadWithCache;
    this.FilterResource = FilterResource;

    this.prevLetter = '';
    this.aggregate = null;
    this.loading = false;
    this.loadingMore = false;
    this.isComplete = false;
    this.cancelled = false;
    this.cancelledMore = false;
    this.canceller = null;
    this.error = null;
    this.allRemoteUsers = null;
    this.remoteUsers = null;
    this.aggregareInsexObj = {};

    this.cancelSubject = new rx.Subject();
    this.loadMoreSubject = new rx.Subject();
    this.filterSubject = new rx.Subject();
    this.loadCheckSubject = new rx.Subject();

    this.filterData$ = this.filterSubject.asObservable().filter(function () {
      if (!_this.CurrentModelService.cube) {
        console.error('model is not defined');
        return false;
      }
      return true;
    }).map(function (filter) {
      if (!filter) {
        return null;
      }
      _this.filter = filter;
      _this.actualFilter = filter;
      var params = _this.actualFilter.buildQueryParams();
      params.aggregate_order = _this.CurrentFilterService.aggregateOrder;
      return {
        filter: _this.actualFilter,
        url: _this.getUrl(_this.actualFilter),
        params: params,
        lookup: _this.actualFilter.lookup
      };
    }).distinctUntilChanged(null, function (params1, params2) {
      var eqParams = !_this.cancelled && params1 && params2 && params1.url === params2.url;
      if (!eqParams) return false;
      eqParams = Object.keys(params1.params).every(function (k) {
        if (k == 'page') return true;
        return angular.equals(params1.params[k], params2.params[k]);
      });
      if (params1.lookup != params2.lookup) eqParams = false;
      if (!eqParams) _this.aggregate = null;
      return eqParams;
    }).filter(function (params) {
      return params;
    }).switchMap(function (params) {
      if (_this.loading || _this.loadingMore) {
        _this.onCancel();
      } else {
        _this.page = 0;
        params.params.page = _this.page;
      }
      _this.beforeLoad();
      return rx.Observable.amb(_this.cancelSubject.asObservable().do(function () {
        return _this.onCancel();
      }).first(), rx.Observable.fromPromise(_this.load(params))
      // .delay(10000)
      .do(function (data) {
        return _this.afterLoad(data);
      }).catch(function (error) {
        _this.onError(error);
        _this.error = error;
        return rx.Observable.of(null);
      })).flatMap(function (data) {
        if (data === null) {
          return rx.Observable.of(null);
        }
        return rx.Observable.merge(rx.Observable.of(data).concat(_this.loadMoreSubject.asObservable().exhaustMap(function () {
          return rx.Observable.of(null).flatMap(function () {
            if (_this.isComplete) {
              return rx.Observable.of(null);
            }
            _this.page += 1;
            params.params.page = _this.page;
            _this.beforeLoad();
            return rx.Observable.amb(_this.cancelSubject.asObservable().do(function () {
              return _this.onCancelrx.Observable.combineLatest();
            }).first(), rx.Observable.fromPromise(_this.load(params)).do(function (data) {
              return _this.afterLoad(data);
            }).catch(function (error) {
              _this.onError(error);
              return rx.Observable.of(null);
            }));
          });
        })), rx.Observable.of(data).concat(_this.loadCheckSubject.asObservable().exhaustMap(function (start) {
          var drill = params.params.drill[0];
          if (drill !== 'agent_agent@computer_name:computer_name' && drill !== 'agent_account@user_name:user_name') return rx.Observable.of(null);

          var newParams = angular.copy(params);
          newParams.params.page = Math.floor(start / params.params.limit);
          return rx.Observable.amb(_this.cancelSubject.asObservable().do(function () {
            return _this.onCancel();
          }).first(), rx.Observable.fromPromise(_this.load(newParams, true)).do(function (data) {
            return _this.updateData(data);
          }).catch(function (error) {
            _this.onError(error);
            return rx.Observable.of(null);
          }));
        }))).debounce(1000).exhaustMap(function () {
          return rx.Observable.fromPromise(_this.loadRemoteUsers()).do(function (data) {
            _this.allRemoteUsers = data.map(function (rm) {
              if (rm.user === rm.sid) {
                if (rm.user.match(/\.\.\d+$/g)) rm.user = rm.user.match(/^.+?(?=\.\.\d+$)/g)[0];
              }
              return rm;
            });
            _this.markRemoteCells();
          }).catch(function (error) {
            // this.onError(error);
            _this.allRemoteUsers = [];
            return rx.Observable.of([]);
            // return [];
          });
        });
      });
    }).share();

    this.subscription = this.filterData$.subscribe(function () {});
  }

  _createClass(AggregateDataService, [{
    key: 'init',
    value: function init(force) {
      if (this.loading || this.loadingMore) return;
      var result = this.filterData$.first().toPromise();
      this.CurrentFilterService.filterBar.copyFrom(this.CurrentFilterService.filter, true);
      this.CurrentFilterService.filterBar.timeFrom = this.CurrentFilterService.timeFrom;
      this.CurrentFilterService.filterBar.timeTo = this.CurrentFilterService.timeTo;
      if (force) {
        this.filterSubject.onNext(null);
      }
      this.filterSubject.onNext(this.CurrentFilterService.filterBar);
      return result;
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.cancelSubject.onNext(null);
    }
  }, {
    key: 'aggregate_more',
    value: function aggregate_more() {
      // console.log('aggregate_more', this.page, this.aggregate.cells.length);
      this.loadMoreSubject.onNext(null);
    }
  }, {
    key: 'aggregateCheck',
    value: function aggregateCheck(index) {
      // console.log('aggregateCheck', this.page, this.aggregate.cells.length);
      this.loadCheckSubject.onNext(index);
    }
  }, {
    key: 'load',
    value: function load(params, resetCache) {
      return this.loadWithCache(params.url, params.params, this.canceller, resetCache);
    }
  }, {
    key: 'getUrl',
    value: function getUrl(filter) {
      return filter.skipStat ? '/analytics/values/' + this.CurrentModelService.cube.name + '/' : '/analytics/aggregate/' + this.CurrentModelService.cube.name + '/';
    }
  }, {
    key: 'onCancel',
    value: function onCancel() {
      if (!this.loading && !this.loadingMore || !this.canceller) {
        console.error('nothing to cancel');
        return;
      }
      this.canceller.resolve('abort');
      this.canceller = null;
      this.loading = false;
      this.loadingMore = false;
      this.isComplete = false;
      if (this.page > 0) {
        this.page -= 1;
        this.cancelledMore = true;
      } else {
        this.cancelled = true;
      }
      // this.$rootScope.$evalAsync(() => {});
      // console.log('cancel aggregate page', this.page);
    }
  }, {
    key: 'beforeLoad',
    value: function beforeLoad() {
      if (this.loading || this.loadingMore || this.canceller) {
        console.error('load already in progress');
      }

      this.canceller = this.$q.defer();
      this.loading = this.page === 0;
      this.loadingMore = this.page !== 0;
      this.cancelled = false;
      this.cancelledMore = false;
      this.isComplete = false;
      this.error = null;
      this.$rootScope.$evalAsync(function () {});
    }
  }, {
    key: 'calcEvents',
    value: function calcEvents() {
      this.events = this.aggregate.cells.reduce(function (events, cell) {
        var count = cell.record_count ? cell.record_count : 0;
        return {
          total: events.total + count,
          max: Math.max(events.max, count)
        };
      }, {
        total: 0,
        max: 0
      });
    }
  }, {
    key: 'afterLoad',
    value: function afterLoad(data) {
      if (!this.loading && !this.loadingMore) {
        console.error('load not in progress');
      }
      this.loading = false;
      this.loadingMore = false;
      this.canceller = null;
      //this.isComplete = data.cells.length == 0; ?? FIXED IN CUBE
      this.isComplete = data.cells.length < this.filter.limit;

      if (this.page === 0) {
        this.aggregareInsexObj = {};
        this.aggregate = data;
        this.buildIndexObj(data, 0);
      } else {
        // this.aggregate.cells = this.aggregate.cells.concat(data.cells);
        this.updateData(data);
      }
      this.calcEvents();
      this.$rootScope.$broadcast('aggregare-loaded');
    }
  }, {
    key: 'setCellLabel',
    value: function setCellLabel(cell) {
      cell.cellLabel = this.CurrentModelService.model.getCellLabel(this.CurrentFilterService.filterBar.drilldown[0], cell);
      var letter = cell.cellLabel[0];
      cell.isFirstLetter = this.prevLetter !== letter;
      if (cell.isFirstLetter) {
        this.prevLetter = letter;
      }
    }
  }, {
    key: 'getAggregateDataKey',
    value: function getAggregateDataKey(data) {
      if (!data.levels) {
        if (!data.cells[0]) return 'unknownKey';
        return Object.keys(data.cells[0])[0];
      }
      var p1 = Object.keys(data.levels)[0];
      if (!p1) return 'unknownKey';
      var p2 = data.levels[p1][0];
      if (!p2) return 'unknownKey';
      return p1 + '.' + p2;
    }
  }, {
    key: 'buildIndexObj',
    value: function buildIndexObj(data, startIndex) {
      var _this2 = this;

      var key = this.getAggregateDataKey(data);
      this.prevLetter = '';
      data.cells.map(function (c, i) {
        var k = c[key];
        _this2.setCellLabel(c);
        _this2.aggregareInsexObj[k] = startIndex + i;
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(data) {
      var _this3 = this;

      var key = this.getAggregateDataKey(data);
      this.prevLetter = '';
      data.cells.map(function (c) {
        _this3.setCellLabel(c);
        var i = _this3.aggregareInsexObj[c[key]];
        if (i === undefined) {
          i = _this3.aggregate.cells.length;
          _this3.aggregate.cells.push(c);
          _this3.aggregareInsexObj[c[key]] = i;
        } else _this3.aggregate.cells[i] = c;
      });
      // console.log('finish',  this.page, this.aggregate.cells.length);
    }
  }, {
    key: 'isAgentComputerName',
    value: function isAgentComputerName(val) {
      return val === 'agent_agent@computer_name:computer_name';
    }
  }, {
    key: 'isAccountUserName',
    value: function isAccountUserName(val) {
      return val === 'agent_account@user_name:user_name';
    }
  }, {
    key: 'isAccountFullName',
    value: function isAccountFullName(val) {
      return val === 'agent_account@full_name:full_name';
    }
  }, {
    key: 'loadRemoteUsers',
    value: function loadRemoteUsers() {
      if (this.isAgentComputerName(this.filter.drilldown['0']) || this.isAccountUserName(this.filter.drilldown['0']) || this.isAccountFullName(this.filter.drilldown['0'])) return this.loadWithCache('/staffcop/remote/', null, null, true);
      return this.$q.defer();
    }
  }, {
    key: 'markRemoteCells',
    value: function markRemoteCells() {
      var _this4 = this;

      if (!this.aggregate || !this.aggregate.cells) return;
      var predicate = void 0;
      if (this.isAccountUserName(this.filter.drilldown['0'])) predicate = function predicate(cell) {
        return function (r) {
          return cell['agent_account.user_name'] === r.user;
        };
      };else if (this.isAgentComputerName(this.filter.drilldown['0'])) predicate = function predicate(cell) {
        return function (r) {
          return cell['agent_agent.guid'] === r.hwid;
        };
      };else if (this.isAccountFullName(this.filter.drilldown['0'])) predicate = function predicate(cell) {
        return function (r) {
          return cell['agent_account.full_name'] === r['full_name'];
        };
      };else return;

      this.aggregate.cells.map(function (cell) {
        var rem = _this4.allRemoteUsers.filter(predicate(cell));
        if (rem && rem.length > 0) {
          cell.remote = rem.map(function (rm) {
            return {
              hwid: rm.hwid,
              sid: rm.sid,
              user: rm.full_name ? rm.full_name : rm.user
            };
          });
        }
      });
    }
  }, {
    key: 'updateRemoteUsers',
    value: function updateRemoteUsers() {
      var _this5 = this;

      this.remoteUsers = this.allRemoteUsers.filter(function (u) {
        return _this5.CurrentFilterService.filter.filters.some(function (f) {
          var res = false;
          if (_this5.isAgentComputerName(f.dimension)) {
            var values = f.value.split(_config.PATH_STRING_SEPARATOR);
            res = values[1] === u.hwid;
            if (res && values[2]) u.computer = values[2];
          } else if (_this5.isAccountUserName(f.dimension)) {
            res = f.value === u.user;
          } else if (_this5.isAccountFullName(f.dimension)) {
            res = f.value === u['full_name'];
          }
          return res;
        });
      });
    }
  }, {
    key: 'onError',
    value: function onError(error) {
      this.loading = false;
      this.loadingMore = false;
      this.canceller = null;
      this.isComplete = false;
      if (this.page > 0) {
        this.page -= 1;
      }
      this.ErrorHandlerService.handle(error);
      // this.$rootScope.$evalAsync(() => {});
      console.error('load aggregate page', this.page, error);
    }
  }]);

  return AggregateDataService;
}();

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorHandlerService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alertModal = __webpack_require__(329);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ErrorHandlerService = exports.ErrorHandlerService = function () {
  function ErrorHandlerService(globalAlert, $modal, PermissionService, LocalStorageService, LayoutService) {
    _classCallCheck(this, ErrorHandlerService);

    this.globalAlert = globalAlert;
    this.$modal = $modal;
    this.modalOpened = false;
    this.LayoutService = LayoutService;
    this.LocalStorageService = LocalStorageService;
    this.PermissionService = PermissionService;
    this.notShowErrorMessageBox = false;
    this.wrongCuts = [];
  }

  _createClass(ErrorHandlerService, [{
    key: '$showErrorMessageBox',
    value: function $showErrorMessageBox(_errorStatus, _errorText, _errorConfig) {
      var _this = this;

      if (this.modalOpened) return;
      this.modalOpened = true;
      var inst = this.$modal.open({
        template: __webpack_require__(330),
        controller: _alertModal.AlertModalController,
        resolve: {
          errorStatus: function errorStatus() {
            return _errorStatus;
          },
          errorText: function errorText() {
            return _errorText;
          },
          errorConfig: function errorConfig() {
            return _errorConfig;
          }
        }
      });
      inst.result.then(function (res) {
        return _this.modalOpened = false;
      });
      return inst;
    }
  }, {
    key: 'isWrongCuts',
    value: function isWrongCuts(cuts) {
      return this.wrongCuts.some(function (w) {
        return cuts.every(function (c) {
          return !(c.dimension in w && w[c.dimension] === c.value);
        });
      });
    }
  }, {
    key: 'showErrorMessageBox',
    value: function showErrorMessageBox(errorStatus, errorText, errorConfig, notReload) {
      var _this2 = this;

      var home = function home() {
        if (notReload || window.location.hash === '#!/') return;
        if (_this2.LayoutService.options.saveInterface.value) _this2.LocalStorageService.setItem('locationUrl', '/');
        window.location = '/';
      };

      var errMsg = this.$showErrorMessageBox(errorStatus, errorText, errorConfig);
      if (!errMsg) return;
      errMsg.result.then(function (res) {
        _this2.modalOpened = false;

        var support = ' <a target="_blank" class="blue-link" href="https://help.staffcop.ru/?lang=' + _this2.PermissionService.selectedLang + '">' + gettext('службу поддержки') + '</a>.';

        if (errorConfig && errorConfig.resultData && !errorConfig.resultError) {
          var htmlText = gettext('Сообщение об ошибке зарегистрировано под номером') + ' <b>#' + errorConfig.resultData + '</b>\n' + gettext('Вы можете узнать его статус, обратившись в') + support;

          var inst = _this2.$showErrorMessageBox(gettext('Спасибо, что помогаете cтать нам лучше'), htmlText);
          if (!inst) return;
          inst.result.then(function () {
            return home();
          }, function () {
            return home();
          });
        } else if (errorConfig && !errorConfig.resultData && errorConfig.resultError) {
          var text = gettext('Обратитесь, пожалуйста, в') + support + '\n\n' + errorText;
          var _inst = _this2.$showErrorMessageBox(gettext('Ошибка отправки'), text);
          if (!_inst) return;
          _inst.result.then(function () {
            return home();
          }, function () {
            return home();
          });
        } else {
          home();
        }
      }, function () {
        return home();
      });
    }
  }, {
    key: 'handle',
    value: function handle(error) {
      if (error.status) {
        return this.handleServerError(error);
      }
      console.error(error);
      var message = error.message || gettext('Неизвестная ошибка');
      if (message) {
        this.globalAlert(message, 3000);
      }
    }
  }, {
    key: 'handleServerError',
    value: function handleServerError(_ref) {
      var status = _ref.status,
          data = _ref.data,
          config = _ref.config;

      if (status === -1 || status === 502) {
        this.showErrorMessageBox(gettext('Ошибка сервера '), gettext('Cервер недоступен или отсутствует интернет-соединение'));
        return;
      } else if (status === 403) {
        this.showErrorMessageBox(gettext('Ошибка сервера ') + status, gettext('Нет доступа или сессия пользователя была завершена'));
        return;
      }
      if (status === 422) {
        this.globalAlert(data, 3000);
        return;
      }
      if (status === 500) {
        if (this.filterErrorMessage) this.filterErrorMessage.text = gettext('Ошибка') + ': ' + data.match(/^(.*)$/m)[0];
        if (config && config.params && config.params.dim && config.params.filter) {
          this.wrongCuts.push(config.params.dim.reduce(function (res, d, i) {
            res[d] = config.params.filter[i];
            return res;
          }, {}));
        }
        if (!this.notShowErrorMessageBox) this.showErrorMessageBox(status, data, config, this.filterErrorMessage && this.filterErrorMessage.notReload);
        return;
      }

      console.error(data);
      this.globalAlert(gettext('Ошибка сервера ') + status + gettext('. Попробуйте повторить последнюю операцию или перезагрузите страницу'), 3000);
    }
  }]);

  return ErrorHandlerService;
}();

/***/ }),
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */,
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localStorage = __webpack_require__(87);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PermissionService = exports.PermissionService = function () {
  function PermissionService($http, LocalStorageService) {
    _classCallCheck(this, PermissionService);

    this.$http = $http;
    this.host = window.HOST;
    this.defaultLang = 'en';
    this.localStorage = LocalStorageService;
  }

  _createClass(PermissionService, [{
    key: 'load',
    value: function load() {
      var _this = this;

      return this.$http.post('/analytics/get_permissions/').then(function (_ref) {
        var data = _ref.data,
            status = _ref.status;

        for (var permission in data) {
          _this[permission] = data[permission];
        }
        window.BACKEND = _this.getBackend(); // Used by Filter.buildQueryParams
        window.report_time_format = _this.report_time_format;
      });
    }
  }, {
    key: 'getBackend',
    value: function getBackend() {
      var backend = this.localStorage.getItem(_localStorage.BACKEND);
      if (this.backends.indexOf(backend) >= 0) return backend;
      return this.backends[0];
    }
  }, {
    key: 'selectBackend',
    value: function selectBackend(backend) {
      this.localStorage.setItem(_localStorage.BACKEND, backend);
      location.reload();
    }
  }]);

  return PermissionService;
}();

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentFilterDataService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CurrentFilterDataService = exports.CurrentFilterDataService = function () {
  function CurrentFilterDataService($q, FilterDataFactory, FiltersService, CurrentModelService, AggregateDataService, ErrorHandlerService, CurrentFilterService, $timeout, $rootScope) {
    _classCallCheck(this, CurrentFilterDataService);

    this.FiltersService = FiltersService;
    this.CurrentModelService = CurrentModelService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentFilterService = CurrentFilterService;
    this.$q = $q;
    this.FilterDataFactory = FilterDataFactory;
    this.filterData = FilterDataFactory();
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.autoUpdate = true;
    this.needReload = false;
  }

  _createClass(CurrentFilterDataService, [{
    key: 'reload',
    value: function reload(force) {
      var _this = this;

      //    console.log("reload, cache: " + force);
      var reload = [];
      if (this.autoUpdate || force || this.CurrentFilterService.filterBar.drilldown[0] !== this.AggregateDataService.barDim) {
        reload.push(this.AggregateDataService.init(force));
      }
      if ((this.autoUpdate || force) && !this.CurrentFilterService.frameUrl) {
        reload.push(this.filterData.update(this.filter, force));
        if (this.filter.isDashboard) {
          if (!this.dashboardData) this.dashboardData = {};

          this.filter.children.forEach(function (f) {
            var dIndex = f.dIndex || f.id;
            if (!_this.dashboardData[dIndex]) _this.dashboardData[dIndex] = _this.FilterDataFactory();
            if (!f.cardMinimazed) {
              reload.push(_this.dashboardData[dIndex].update(Object.assign(new _filter.Filter(), f, {
                'filters': _this.filter.filters.concat(f.filters)
              })));
            }
          });
        }
        this.needReload = false;
      } else {
        this.needReload = true;
      }
      return this.$q.all(reload).catch(function (error) {
        _this.ErrorHandlerService.handle(error);
      });
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.CurrentFilterService.filter;
    }
  }, {
    key: 'filterBar',
    get: function get() {
      return this.CurrentFilterService.filterBar;
    }
  }]);

  return CurrentFilterDataService;
}();

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LayoutService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _config = __webpack_require__(21);

var _optionsModal = __webpack_require__(755);

var _serverInfoModalComponent = __webpack_require__(757);

var _html2canvas = __webpack_require__(759);

var _html2canvas2 = _interopRequireDefault(_html2canvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getElementChange = function getElementChange(element, styles) {
  return {
    element: element,
    // initStyle: angular.copy(element.style)
    initStyle: styles.reduce(function (acc, k) {
      if (_typeof(element.style[k]) === 'object' || typeof element.style[k] === 'function') return acc;
      acc[k] = element.style[k];
      return acc;
    }, {})
  };
};

var LayoutService = exports.LayoutService = function () {
  function LayoutService($modal, $timeout, $window, $rootScope, LocalStorageService, CurrentFilterService, TreeService, CurrentModelService) {
    var _this = this;

    _classCallCheck(this, LayoutService);

    this.$modal = $modal;
    this.$timeout = $timeout;
    this.$window = $window;
    this.CurrentFilterService = CurrentFilterService;
    this.$rootScope = $rootScope;
    this.LocalStorageService = LocalStorageService;
    this.CurrentModelService = CurrentModelService;

    this.TreeService = TreeService;
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (this.isFirefox) {
      window.onbeforeprint = function () {
        _this.beforePrint();
      };
      window.onafterprint = function () {
        _this.afterPrint();
      };
    } else {
      this.mediaQueryPrint = window.matchMedia('print');
      this.mediaQueryPrint.addListener(function (e) {
        return _this.printHandler(e);
      });
    }

    this.openedFilters = {
      all: false
    };

    this.searchedFilters = {
      all: true,
      searchTrim: ''
    };

    this.options = {
      showSystemKeys: {
        value: this.LocalStorageService.getItem('showSystemKeys', 'false') === 'true',
        type: 'boolean',
        label: gettext('Отображать системные клавиши в кейлогере')
      },
      saveInterface: {
        value: this.LocalStorageService.getItem('saveInterface', 'false') === 'true',
        type: 'boolean',
        label: gettext('Сохранять последнее состояние интерфейса')
      },
      defaultLense: {
        value: this.LocalStorageService.getItem('defaultLense', ''),
        type: 'string',
        label: gettext('Линза по умолчанию')
      },
      toNeighboursMinutes: {
        value: parseInt(this.LocalStorageService.getItem('toNeighboursMinutes', 10), 10),
        type: 'number',
        max: 200,
        min: 1,
        label: gettext('Количество минут для "События рядом" (max=200)')
      },
      renewAggregateSeconds: {
        value: parseInt(this.LocalStorageService.getItem('renewAggregateSeconds', 240), 10),
        type: 'number',
        is0: true,
        min: 30,
        label: gettext('Период обновления агрегат бара в секундах, 0 - не обновлять')
      }
    };
  }

  _createClass(LayoutService, [{
    key: 'beforePrint',
    value: function beforePrint(e) {
      this.isPrint = true;
      this.$printWidth = document.body.clientWidth + 'px';
      this.LocalStorageService.setItem('printWidth', this.$printWidth);

      if (!this.$rootScope.$$phase) this.$rootScope.$digest();
      this.$rootScope.$broadcast('splitter1Changed');
      this.$rootScope.$broadcast('beforePrint');
    }
  }, {
    key: 'afterPrint',
    value: function afterPrint() {
      this.isPrint = false;
      if (!this.$rootScope.$$phase) this.$rootScope.$digest();
      this.$rootScope.$broadcast('splitter1Changed');
      this.$rootScope.$broadcast('afterPrint');
    }
  }, {
    key: 'printHandler',
    value: function printHandler(e) {
      if (this.mediaQueryPrint.matches) {
        this.beforePrint(e);
      } else {
        this.afterPrint(e);
      }
    }
  }, {
    key: 'openOptions',
    value: function openOptions() {
      var _this2 = this;

      return this.$modal.open({
        template: __webpack_require__(760),
        controller: _optionsModal.OptionsModalController,
        resolve: {
          options: function options() {
            return angular.copy(_this2.options);
          }
        }
      }).result.then(function (options) {
        Object.keys(options).map(function (key) {
          _this2.options[key].value = options[key].value;
          _this2.LocalStorageService.setItem(key, options[key].value);
        });
        _this2.$rootScope.$broadcast('optionsChanged');

        if (_this2.options.saveInterface != options.saveInterface) {
          var listType = _this2.CurrentFilterService.filter.listType;
          _this2.CurrentFilterService.filter.listType = '';
          _this2.$timeout(function () {
            _this2.CurrentFilterService.filter.listType = listType;
          });
        }
      }).catch(function (res) {
        return res;
      });
    }
  }, {
    key: 'openServerInfo',
    value: function openServerInfo() {
      var _this3 = this;

      var updateModalSize = function updateModalSize() {
        $('.modal.fade.in').css({
          width: '90%',
          left: '5%',
          height: '90%',
          top: '5%',
          margin: 0
        });

        $('.modal-body2').height(window.innerHeight * 0.9 - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight() - 20);
      };

      return this.$modal.open({
        template: __webpack_require__(761),
        controller: _serverInfoModalComponent.ServerInfoModalController,
        resolve: {
          layout: function layout() {
            _this3.$timeout(function () {
              updateModalSize();
            }, 100);
          }
        }
      }).result.then().catch(function (res) {
        return res;
      });
    }
  }, {
    key: 'getMainFrame',
    value: function getMainFrame() {
      if (this.CurrentFilterService && (this.CurrentFilterService.frameUrl || this.CurrentFilterService.filter && !this.CurrentFilterService.filter.isCard && !this.CurrentFilterService.filter.isDashboard)) {
        return document.querySelector('sc-frame-view iframe');
      } else {
        return null;
      }
    }
  }, {
    key: 'preparePrint',
    value: function preparePrint(data, isAsImage, errFunction, element) {
      var _this4 = this;

      var isResized = !isAsImage; // id some resize happend

      var setLoading = new Promise(function (resolve) {
        _this4.CurrentFilterService.imageLoading = true;
        if (!_this4.$rootScope.$$phase) _this4.$rootScope.$apply();
        _this4.$timeout(function () {
          resolve();
        }, 100);
      });

      return setLoading.then(function () {
        var source = {
          element: null,
          changes: [],
          timeout: 200,
          elementResizedEvent: true, //if false "elementResized" event is pushed by elemet's controller (see heatmap.component)
          isNeedCloneSource: _config.IS_IE_BROWSER && isAsImage && !document.querySelector('sc-frame-view iframe') && (document.querySelector('sc-facts-table') || document.querySelector('sc-fact-widget') || document.querySelector('sc-chat-viewer') || document.querySelector('sc-fact-thumb')),
          restoreScViewSize: function restoreScViewSize(source) {
            if (source.isNeedCloneSource) {
              document.body.removeChild(source.element);
            }

            _this4.CurrentFilterService.imageLoading = false;
            if (!source || !source.changes || !source.changes.length) return;
            source.changes.map(function (chEl) {
              // chEl.element.removeAttribute('style');
              Object.keys(chEl.initStyle).map(function (k) {
                if (chEl.element.style[k] !== chEl.initStyle[k]) {
                  chEl.element.style[k] = chEl.initStyle[k];
                }
              });
            });
            _this4.$rootScope.$broadcast('resize');
          }
        };

        if (!element) element = document.querySelector('sc-view');

        var resizedScView = function () {
          var change = getElementChange(element, ['width', 'height']);

          // const k = scView.clientHeight / scView.clientWidth;
          // scView.style.width = isAsImage ? ((window.document.body.clientWidth * 1) + 'px') : this.printWidth;
          if (!isAsImage) element.style.width = _this4.printWidth;
          var width = element.clientWidth;
          // let height = (60 + width * k) + 'px';
          if (element.querySelector('sc-tree') && !element.querySelector('sc-dashboard')) {
            isResized = true;
            source.timeout = 750;
            element.style.height = 60 + _this4.TreeService.getHeight(_this4.CurrentModelService.model, data) + 'px';
          }
          return change;
        }();

        if (isResized) source.changes.push(resizedScView);

        //removing sc-view-tabs
        if (isAsImage) {
          var tabs = element.querySelector('sc-view-tabs');
          if (tabs) {
            source.changes.push(function () {
              var change = getElementChange(tabs, ['display']);
              tabs.style.display = 'none';
              return change;
            }());
          }
        }

        var getElement = function getElement() {
          if (_this4.CurrentFilterService.filter.isGraph) {
            return element;
          }
          var desiredEl = _this4.getMainFrame();
          if (desiredEl) {
            if (isResized) {
              var event = void 0;
              if (typeof Event === 'function') {
                event = new Event('resizeBeforePrint');
              } else {
                event = document.createEvent('Event');
                event.initEvent('resizeBeforePrint', false, true);
              }
              document.body.dispatchEvent(event);
            }
            if (isAsImage) {

              return desiredEl.contentDocument.querySelector('html>body');
            } else {
              return desiredEl;
            }
          }

          desiredEl = element.querySelector('.for-save-as-image');

          if (desiredEl) {
            if (desiredEl.tagName.toLowerCase() === 'sc-heatmap' || desiredEl.querySelector('sc-heatmap')) {
              isResized = true;
              source.elementResizedEvent = false;
            }
            source.changes.push(getElementChange(desiredEl, ['position', 'overflow', 'height']));

            desiredEl.style.position = 'static';
            desiredEl.style.overflow = 'visible';
            desiredEl.style.height = 'unset';
            return desiredEl;
          }

          desiredEl = element.querySelector('#datatable');
          if (desiredEl) {
            // source.timeout = 10000;
            source.changes.push(getElementChange(desiredEl, ['position', 'overflow', 'height']));
            desiredEl.style.position = 'static';
            desiredEl.style.overflow = 'visible';
            desiredEl.style.height = 'unset';
            var tBody = desiredEl.querySelector('tBody');
            source.changes.push(getElementChange(tBody, ['position', 'overflow', 'height']));
            tBody.style.position = 'static';
            tBody.style.overflow = 'visible';
            tBody.style.height = 'unset';
            return desiredEl;
          } else return element;
        };

        source.element = getElement();
        if (source.isNeedCloneSource) {
          source.element = source.element.cloneNode(true);
          source.element.querySelectorAll('.dropdown').forEach(function (e) {
            e.style.display = 'none';
          });
          document.body.appendChild(source.element);
        }
        if (isResized) {
          _this4.$rootScope.$broadcast('resizeBeforePrint');
          if (source.elementResizedEvent) {
            angular.element(source.element).ready(function () {
              _this4.$timeout(function () {
                return _this4.$rootScope.$broadcast('elementResized');
              }, source.timeout);
            });
          }
        }

        var promice = new Promise(function (resolve, reject) {
          var isEvent = false;
          if (isResized) {
            var deregister = _this4.$rootScope.$on('elementResized', function () {
              isEvent = true;
              resolve(source);
            });

            _this4.$timeout(function () {
              if (!isEvent) {
                _this4.$rootScope.$on('$destroy', deregister());
                reject(gettext('Изображение не может быть получено. Уменьшите количество загружаемых данных.'), source);
              }
            }, 15000);
          } else {
            _this4.$timeout(function () {
              resolve(source);
            }, 100);
          }
        });
        return promice;
      });
    }
  }, {
    key: 'printContainer',
    value: function printContainer(data, errFunction) {
      var _this5 = this;

      this.preparePrint(data, false).then(function (source) {
        if (source.element.tagName.toUpperCase() === 'IFRAME') source.element.contentWindow.print();else _this5.$window.print();
        _this5.$timeout(function () {
          source.restoreScViewSize(source);
        });
      }).catch(function (message, source) {
        errFunction(message);
        source.restoreScViewSize(source);
      });
      // .finally(() => this.CurrentFilterService.imageLoading = false);
    }
  }, {
    key: 'saveAsPicture',
    value: function saveAsPicture(data, errFunction, element) {
      var _this6 = this;

      var saveAsImage = function saveAsImage(canvas, filename) {
        canvas.toBlob(function (blob) {
          if (!blob) {
            errFunction(gettext('Изображение не может быть получено. Уменьшите количество загружаемых данных.'));
            return;
          }
          if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var dt = URL.createObjectURL(blob);
            dt = dt.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');
            dt = dt.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=image.svg');
            var link = document.createElement('a');
            link.setAttribute('href', dt);
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }
        });
      };

      var final = function final(source) {
        _this6.CurrentFilterService.imageLoading = false;
        source.restoreScViewSize(source);
        if (!_this6.$rootScope.$$phase) _this6.$rootScope.$apply();
      };

      this.preparePrint(data, true, errFunction, element).then(function (source) {
        _this6.$timeout(function () {
          (0, _html2canvas2.default)(source.element, {
            onclone: function onclone(el) {
              console.log('cloned element: .html2canvas-container');
            }
          }).then(function (canvas) {
            saveAsImage(canvas, 'image.png');
            final(source);
          }).catch(function (message) {
            errFunction(message);
            var tmpContainer = source.element.querySelector('.html2canvas-container');
            if (tmpContainer) source.element.removeChild(tmpContainer);
            final(source);
          });
        }, 500);
      }).catch(function (message) {
        errFunction(message);
        final();
      });
    }
  }, {
    key: 'printWidth',
    get: function get() {
      if (!this.$printWidth) {
        this.$printWidth = this.LocalStorageService.getItem('printWidth');
        if (!this.$printWidth) {
          this.$printWidth = '1424px'; //'210mm';
        }
      }
      return this.$printWidth;
    }
  }]);

  return LayoutService;
}();

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
__webpack_require__(756);

var OptionsModalController = exports.OptionsModalController = function OptionsModalController($scope, CurrentFilterService, $modalInstance, options, RouterService, $timeout) {
  $scope.options = Object.keys(options).map(function (k) {
    options[k].key = k;
    return options[k];
  });
  $scope.filter = CurrentFilterService.filter;

  $scope.onChange = function (opt) {
    var err = false;
    if (opt.type === 'number') {
      if (opt.min && opt.value < opt.min && (opt.is0 && opt.value !== 0 || !opt.is0) || opt.value == undefined) err = true;else if (opt.max && opt.value > opt.max) err = true;
      if (err) {
        opt.errMsg = gettext('Введите значение');
        if (opt.min) {
          opt.errMsg += gettext(' от ');
          opt.errMsg += opt.min;
        }
        if (opt.max) {
          opt.errMsg += gettext(' до ');
          opt.errMsg += opt.max;
        }
        if (opt.is0) {
          opt.errMsg += gettext(' или 0 ');
        }
      } else delete opt.errMsg;
    }
  };

  $scope.onBlur = function (opt) {
    if (opt.type === 'number') {
      if (opt.min && opt.value < opt.min && (opt.is0 && opt.value !== 0 || !opt.is0) || opt.value == undefined) opt.value = opt.min;
      if (opt.max && opt.value > opt.max) opt.value = opt.max;
    }
    delete opt.errMsg;
  };

  $scope.setLenseValue = function () {
    var search = angular.copy(RouterService.search());
    delete search.timeFrom;
    delete search.timeTo;
    options.defaultLense.value = Object.keys(search).map(function (k) {
      return k + '=' + search[k];
    }).join('&');
    if (options.defaultLense.value) options.saveInterface.value = false;
  };

  $scope.isDiasbled = function (opt, i) {
    return opt.key === 'saveInterface' && options.defaultLense.value;
  };

  $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
  $scope.save = function () {
    $modalInstance.close(options);
  };
};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
__webpack_require__(758);

var ServerInfoModalController = exports.ServerInfoModalController = function ServerInfoModalController($scope, $modalInstance, $timeout, $http) {
  var _this = this;

  this.$http = $http;
  $scope.loadData = function () {
    $scope.options = [];
    _this.$http.get('/common-info-about-server/', {}).then(function (res) {
      $scope.options = res.data;
    });
  };
  $scope.cancel = function () {
    return $modalInstance.dismiss('cancel');
  };
  $scope.loadData();
};

/***/ }),
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */,
/* 760 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button> <span class=\"keys-open\">(Ctrl-Shift-L)</span><h4 class=\"modal-title\">{{:: 'Локальные настройки' | gettext}}</h4></div><div class=\"modal-body options-body\"><div class=\"control-group\" ng-repeat=\"opt in options\"><label class=\"control-label\">{{ opt.label }}:</label><div class=\"controls\"><input ng-if=\"opt.type === 'boolean'\" type=\"checkbox\" ng-model=\"opt.value\" ng-true-value=\"true\" ng-false-value=\"false\" ng-disabled=\"isDiasbled(opt, $index)\"> <span ng-if=\"opt.type === 'string' && opt.key === 'defaultLense' && !opt.value\" class=\"btn\" ng-click=\"setLenseValue()\">{{:: 'Назначить' | gettext}}</span><div ng-if=\"opt.type === 'string' && opt.value\" class=\"lense-value\"><i>{{ opt.value }}</i></div><div ng-if=\"opt.type === 'string' && opt.key === 'defaultLense'  && opt.value\" class=\"clear-btn\"><span class=\"btn\" ng-click=\"opt.value = ''\">{{:: 'Очистить' | gettext}}</span></div><span ng-if=\"opt.type === 'number'\" class=\"\"><input type=\"number\" ng-model=\"opt.value\" ng-blur=\"onBlur(opt)\" ng-change=\"onChange(opt)\"> <span ng-if=\"opt.key === 'toNeighboursMinutes' && opt.value \">{{:: ' Лимит событий: ' | gettext}} {{opt.value * 100}}</span><div ng-show=\"opt.errMsg\" class=\"alarm-message\">{{ opt.errMsg }}</div></span></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"save()\">{{:: 'Сохранить' | gettext}}</button> <button class=\"btn\" ng-click=\"cancel()\">{{:: 'Отменить' | gettext}}</button></div></div>"

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button> <span class=\"keys-open\">(Ctrl-Shift-S)</span><h4 class=\"modal-title\">{{:: 'Общая информация о сервере' | gettext}}</h4></div><div class=\"modal-body2 options-body\"><div ng-if=\"!options.length\" class=\"loading-data\"><i class=\"icon-loading animate-spin\"></i> Загружаем...</div><div class=\"control-group\" ng-repeat=\"opt in options\"><label class=\"control-label\">{{ opt.description }}:</label><div class=\"controls\"><b>{{opt.command}}</b></div><div class=\"controls\"><pre>\n            {{opt.output}}\n          </pre></div></div></div><div class=\"modal-footer\"><button class=\"btn\" ng-click=\"loadData()\">{{:: 'Обновить' | gettext}}</button> <a ng-href=\"/common-info-about-server/download/\" class=\"btn\">{{:: 'Скачать' | gettext}}</a> <button class=\"btn\" ng-click=\"cancel()\">{{:: 'Отменить' | gettext}}</button></div></div>"

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FrameLoadService = exports.FrameLoadService = function () {
  function FrameLoadService($q) {
    _classCallCheck(this, FrameLoadService);

    this.$q = $q;
    this.frames = [];
  }

  _createClass(FrameLoadService, [{
    key: 'addFrame',
    value: function addFrame(frame) {
      this.frames.push(frame);
    }
  }, {
    key: 'removeFrame',
    value: function removeFrame(frame) {
      this.frames = this.frames.filter(function (f) {
        return f !== frame;
      });
    }
  }, {
    key: 'waitUntilLoad',
    value: function waitUntilLoad() {
      var _this = this;

      return this.$q(function (resolve, reject) {
        var check = function check() {
          setTimeout(function () {
            if (_this.isReady) {
              return resolve();
            }
            check();
          }, 1000);
        };
        check();
      });
    }
  }, {
    key: 'isReady',
    get: function get() {
      return this.frames.every(function (frame) {
        return FrameLoadService.frameIsReady(frame);
      });
    }
  }], [{
    key: 'frameIsReady',
    value: function frameIsReady(frame) {
      // Check if loading is complete
      // This would fail if it is on a different domain
      // const document = frame.contentDocument || frame.contentWindow.document;
      // return !!(document && document.readyState === 'complete');
      return !!frame.getAttribute('sc-loaded');
    }
  }]);

  return FrameLoadService;
}();

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatusCheckerService = exports.StatusCheckerService = function () {
  function StatusCheckerService() {
    _classCallCheck(this, StatusCheckerService);

    this.unknownStatus = {
      name: 'unknownStatus',
      cssClass: 'icon-dot-circled unknownStatus',
      text: gettext('Нет данных от агента более 10 минут')
    };
    this.onlineStatus = {
      name: 'onlineStatus',
      cssClass: 'icon-clock-circled onlineStatus',
      text: gettext('Пользователь активен')
    };
    this.awayStatus = {
      name: 'awayStatus',
      cssClass: 'icon-clock-circled awayStatus',
      text: gettext('Пользователь неактивен более 5 минут')
    };
    var hour = 3600000;
    this.onlineInterval = hour / 12;
    this.awayInterval = hour / 6;
  }

  _createClass(StatusCheckerService, [{
    key: 'check',
    value: function check(cell) {
      var last_activity_time = void 0;
      var last_report_time = void 0;
      if (cell['agent_agent.id']) {
        last_activity_time = cell['agent_agent.last_activity_time'];
        last_report_time = cell['agent_agent.last_report_time'];
      }
      if (cell['agent_account.user_name']) {
        last_activity_time = cell['agent_account.last_activity_time'];
        last_report_time = cell['agent_account.last_report_time'];
      }
      if (!last_report_time) {
        return this.unknownStatus;
      }
      var now = new Date();
      if (last_activity_time) {
        var lat_date = new Date(last_activity_time);
        if (now - lat_date < this.onlineInterval) {
          return this.onlineStatus;
        }
      }
      var lrt_date = new Date(last_report_time);
      if (now - lrt_date < this.awayInterval) {
        return this.awayStatus;
      }
      return this.unknownStatus;
    }
  }]);

  return StatusCheckerService;
}();

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var serverInformationUpdateInterval = 300000;
var serverInformationUpdateFirstTime = 5000;

var ServerInformationService = exports.ServerInformationService = function () {
  function ServerInformationService($http) {
    _classCallCheck(this, ServerInformationService);

    this.$http = $http;
    this.usage = null;
    this.scheduleUpdate(serverInformationUpdateFirstTime);
  }

  _createClass(ServerInformationService, [{
    key: 'update',
    value: function update() {
      var _this = this;

      return this.$http.get('/analytics/server-information').then(function (result) {
        _this.databaseUsage = result.data.databaseUsage;
        _this.databasePath = result.data.databasePath;
        _this.databaseAlarm = result.data.databaseAlarm;
        _this.hddUsage = result.data.hddUsage;
        _this.hddAlarm = result.data.hddAlarm;
        _this.hddHardLimit = result.data.hddHardLimit;
      }).catch(function (err) {
        console.error(err);
      }).then(function () {
        _this.scheduleUpdate();
      });
    }
  }, {
    key: 'scheduleUpdate',
    value: function scheduleUpdate(timeout) {
      var _this2 = this;

      setTimeout(function () {
        return _this2.update();
      }, timeout || serverInformationUpdateInterval);
    }
  }]);

  return ServerInformationService;
}();

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlertModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _alertModal = __webpack_require__(329);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlertModalService = exports.AlertModalService = function () {
  function AlertModalService($timeout, $modal) {
    _classCallCheck(this, AlertModalService);

    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  _createClass(AlertModalService, [{
    key: 'open',
    value: function open(status, text) {
      return this.$modal.open({
        template: __webpack_require__(330),
        controller: _alertModal.AlertModalController,
        resolve: {
          errorStatus: function errorStatus() {
            return status;
          },
          errorText: function errorText() {
            return text;
          },
          errorConfig: function errorConfig() {
            return null;
          }
        }
      }).result;
    }
  }]);

  return AlertModalService;
}();

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(767);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatePickerController = function () {
  function DatePickerController($scope, RouterService, $rootScope, PermissionService, $cookies, $timeout) {
    var _this = this;

    _classCallCheck(this, DatePickerController);

    var DP_LOCALES = {
      'ru': {
        applyLabel: 'ОК',
        cancelLabel: 'Отмена',
        fromLabel: 'С',
        toLabel: 'по',
        weekLabel: 'нед',
        format: 'DD/MM/YYYY'
      },
      'en': {}
    };

    this.loaded = false;

    this.PermissionService = PermissionService;

    $timeout(function () {
      var selectedLang = $cookies.get('django_language') || _this.PermissionService.selectedLang || _this.PermissionService.defaulLang;
      var dp_locale = DP_LOCALES[selectedLang] ? DP_LOCALES[selectedLang] : DP_LOCALES['en'];
      _this.picker = $('#reportrange').daterangepicker({
        startDate: (0, _moment2.default)(_this.timeFrom),
        endDate: (0, _moment2.default)(_this.timeTo),
        minDate: (0, _moment2.default)().year(2000),
        // dateLimit          : {days: 365},
        showDropdowns: false,
        showWeekNumbers: true,
        timePicker: false,
        timePickerIncrement: 1,
        timePicker24Hour: true,
        ranges: _this.ranges,
        opens: 'right',
        drops: 'down',
        alwaysShowCalendars: true,
        linkedCalendars: true,
        buttonClasses: ['btn', 'btn-lg'],
        separator: ' to ',
        timeZone: 0,
        locale: dp_locale,
        autoApply: true,
        selectedLang: selectedLang
      }, function (start, end, label) {
        _this.timeFrom = start.toDate();
        RouterService.timeFrom = _this.timeFrom;
        _this.timeTo = end.toDate();
        RouterService.timeTo = _this.timeTo;
        $rootScope.$digest();
      }).data('daterangepicker');
      _this.loaded = true;
    }, 10);

    $scope.$watch('$ctrl.timeFrom', function (newValue) {
      if (_this.picker) _this.picker.setStartDate(newValue);
    });
    $scope.$watch('$ctrl.timeTo', function (newValue) {
      if (_this.picker) _this.picker.setEndDate(newValue);
    });
  }

  _createClass(DatePickerController, [{
    key: 'setInitRanges',
    value: function setInitRanges() {
      if (this.PermissionService.selectedLang === 'ru') this.picker.ranges = this.ranges;
    }
  }, {
    key: 'ranges',
    get: function get() {
      return {
        'Сегодня': [(0, _moment2.default)().startOf('day'), (0, _moment2.default)().endOf('day')],
        'Вчера': [(0, _moment2.default)().startOf('day').subtract(1, 'days'), (0, _moment2.default)().endOf('day').subtract(1, 'days')],
        '7 дней': [(0, _moment2.default)().startOf('day').subtract(6, 'days'), (0, _moment2.default)().endOf('day')],
        '30 дней': [(0, _moment2.default)().startOf('day').subtract(29, 'days'), (0, _moment2.default)().endOf('day')],
        'Текущая неделя': [(0, _moment2.default)().startOf('week'), (0, _moment2.default)().endOf('week')],
        'Текущий месяц': [(0, _moment2.default)().startOf('month'), (0, _moment2.default)().endOf('month')],
        'Текущий год': [(0, _moment2.default)().startOf('year'), (0, _moment2.default)().endOf('year')]
      };
    }
  }]);

  return DatePickerController;
}();

var DatePickerComponent = exports.DatePickerComponent = {
  template: __webpack_require__(769),
  controller: DatePickerController,
  bindings: {
    timeFrom: '=',
    timeTo: '='
  }
};

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_require__(768);

/**
 * @version: 2.1.19
 * @author: Dan Grossman http://www.dangrossman.info/
 * @copyright: Copyright (c) 2012-2015 Dan Grossman. All rights reserved.
 * @license: Licensed under the MIT license. See http://www.opensource.org/licenses/mit-license.php
 * @website: https://www.improvely.com/
 */

(function (root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(199), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function (momentjs, $, exports) {
      root.daterangepicker = factory(root, exports, momentjs, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    var momentjs = require('moment');
    var jQuery = typeof window != 'undefined' ? window.jQuery : undefined; //isomorphic issue
    if (!jQuery) {
      try {
        jQuery = require('jquery');
        if (!jQuery.fn) jQuery.fn = {}; //isomorphic issue
      } catch (err) {
        if (!jQuery) throw new Error('jQuery dependency not found');
      }
    }

    factory(root, exports, momentjs, jQuery);

    // Finally, as a browser global.
  } else {
    root.daterangepicker = factory(root, {}, root.moment || moment, root.jQuery || root.Zepto || root.ender || root.$);
  }
})(undefined || {}, function (root, daterangepicker, moment, $) {
  // 'this' doesn't exist on a server

  var DateRangePicker = function DateRangePicker(element, options, cb) {

    moment.locale(options.selectedLang);

    //default settings for options
    this.parentEl = 'body';
    this.element = $(element);
    this.startDate = moment().startOf('day');
    this.endDate = moment().endOf('day');
    this.minDate = false;
    this.maxDate = false;
    this.dateLimit = false;
    this.autoApply = false;
    this.singleDatePicker = false;
    this.showDropdowns = false;
    this.showWeekNumbers = false;
    this.showISOWeekNumbers = false;
    this.timePicker = false;
    this.timePicker24Hour = false;
    this.timePickerIncrement = 1;
    this.timePickerSeconds = false;
    this.linkedCalendars = true;
    this.autoUpdateInput = true;
    this.alwaysShowCalendars = false;
    this.ranges = {};

    this.opens = 'right';
    if (this.element.hasClass('pull-right')) this.opens = 'left';

    this.drops = 'down';
    if (this.element.hasClass('dropup')) this.drops = 'up';

    this.buttonClasses = 'btn btn-sm';
    this.applyClass = 'btn-success';
    this.cancelClass = 'btn-default';

    this.locale = {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel',
      weekLabel: 'W',
      customRangeLabel: 'Custom Range',
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek()
    };

    this.callback = function () {};

    //some state information
    this.isShowing = false;
    this.leftCalendar = {};
    this.rightCalendar = {};

    //custom options from user
    if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object' || options === null) options = {};

    //allow setting options with data attributes
    //data-api options will be overwritten with custom javascript options
    options = $.extend(this.element.data(), options);

    //html template for the picker UI
    if (typeof options.template !== 'string' && !(options.template instanceof $)) options.template = '<div class="daterangepicker dropdown-menu">' + '<div class="calendar left">' + '<div class="daterangepicker_input">' + '<input class="input-mini" type="text" name="daterangepicker_start" value="" />' + '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' + '<div class="calendar-time">' + '<div></div>' + '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' + '</div>' + '</div>' + '<div class="calendar-table"></div>' + '</div>' + '<div class="calendar right">' + '<div class="daterangepicker_input">' + '<input class="input-mini" type="text" name="daterangepicker_end" value="" />' + '<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' + '<div class="calendar-time">' + '<div></div>' + '<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' + '</div>' + '</div>' + '<div class="calendar-table"></div>' + '</div>' + '<div class="ranges">' + '<div class="range_inputs">' + '<button class="applyBtn" disabled="disabled" type="button"></button> ' + '<button class="cancelBtn" type="button"></button>' + '</div>' + '</div>' + '</div>';

    this.parentEl = options.parentEl && $(options.parentEl).length ? $(options.parentEl) : $(this.parentEl);
    this.container = $(options.template).appendTo(this.parentEl);

    //
    // handle all the possible options overriding defaults
    //

    if (_typeof(options.locale) === 'object') {

      if (typeof options.locale.format === 'string') this.locale.format = options.locale.format;

      if (typeof options.locale.separator === 'string') this.locale.separator = options.locale.separator;

      if (_typeof(options.locale.daysOfWeek) === 'object') this.locale.daysOfWeek = options.locale.daysOfWeek.slice();

      if (_typeof(options.locale.monthNames) === 'object') this.locale.monthNames = options.locale.monthNames.slice();

      if (typeof options.locale.firstDay === 'number') this.locale.firstDay = options.locale.firstDay;

      if (typeof options.locale.applyLabel === 'string') this.locale.applyLabel = options.locale.applyLabel;

      if (typeof options.locale.cancelLabel === 'string') this.locale.cancelLabel = options.locale.cancelLabel;

      if (typeof options.locale.weekLabel === 'string') this.locale.weekLabel = options.locale.weekLabel;

      if (typeof options.locale.customRangeLabel === 'string') this.locale.customRangeLabel = options.locale.customRangeLabel;
    }

    if (typeof options.startDate === 'string') this.startDate = moment(options.startDate, this.locale.format);

    if (typeof options.endDate === 'string') this.endDate = moment(options.endDate, this.locale.format);

    if (typeof options.minDate === 'string') this.minDate = moment(options.minDate, this.locale.format);

    if (typeof options.maxDate === 'string') this.maxDate = moment(options.maxDate, this.locale.format);

    if (_typeof(options.startDate) === 'object') this.startDate = moment(options.startDate);

    if (_typeof(options.endDate) === 'object') this.endDate = moment(options.endDate);

    if (_typeof(options.minDate) === 'object') this.minDate = moment(options.minDate);

    if (_typeof(options.maxDate) === 'object') this.maxDate = moment(options.maxDate);

    // sanity check for bad options
    if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate.clone();

    // sanity check for bad options
    if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate.clone();

    if (typeof options.applyClass === 'string') this.applyClass = options.applyClass;

    if (typeof options.cancelClass === 'string') this.cancelClass = options.cancelClass;

    if (_typeof(options.dateLimit) === 'object') this.dateLimit = options.dateLimit;

    if (typeof options.opens === 'string') this.opens = options.opens;

    if (typeof options.drops === 'string') this.drops = options.drops;

    if (typeof options.showWeekNumbers === 'boolean') this.showWeekNumbers = options.showWeekNumbers;

    if (typeof options.showISOWeekNumbers === 'boolean') this.showISOWeekNumbers = options.showISOWeekNumbers;

    if (typeof options.buttonClasses === 'string') this.buttonClasses = options.buttonClasses;

    if (_typeof(options.buttonClasses) === 'object') this.buttonClasses = options.buttonClasses.join(' ');

    if (typeof options.showDropdowns === 'boolean') this.showDropdowns = options.showDropdowns;

    if (typeof options.singleDatePicker === 'boolean') {
      this.singleDatePicker = options.singleDatePicker;
      if (this.singleDatePicker) this.endDate = this.startDate.clone();
    }

    if (typeof options.timePicker === 'boolean') this.timePicker = options.timePicker;

    if (typeof options.timePickerSeconds === 'boolean') this.timePickerSeconds = options.timePickerSeconds;

    if (typeof options.timePickerIncrement === 'number') this.timePickerIncrement = options.timePickerIncrement;

    if (typeof options.timePicker24Hour === 'boolean') this.timePicker24Hour = options.timePicker24Hour;

    if (typeof options.autoApply === 'boolean') this.autoApply = options.autoApply;

    if (typeof options.autoUpdateInput === 'boolean') this.autoUpdateInput = options.autoUpdateInput;

    if (typeof options.linkedCalendars === 'boolean') this.linkedCalendars = options.linkedCalendars;

    if (typeof options.isInvalidDate === 'function') this.isInvalidDate = options.isInvalidDate;

    if (typeof options.alwaysShowCalendars === 'boolean') this.alwaysShowCalendars = options.alwaysShowCalendars;

    // update day names order to firstDay
    if (this.locale.firstDay != 0) {
      var iterator = this.locale.firstDay;
      while (iterator > 0) {
        this.locale.daysOfWeek.push(this.locale.daysOfWeek.shift());
        iterator--;
      }
    }

    var start, end, range;

    //if no start/end dates set, check if an input element contains initial values
    if (typeof options.startDate === 'undefined' && typeof options.endDate === 'undefined') {
      if ($(this.element).is('input[type=text]')) {
        var val = $(this.element).val(),
            split = val.split(this.locale.separator);

        start = end = null;

        if (split.length == 2) {
          start = moment(split[0], this.locale.format);
          end = moment(split[1], this.locale.format);
        } else if (this.singleDatePicker && val !== '') {
          start = moment(val, this.locale.format);
          end = moment(val, this.locale.format);
        }
        if (start !== null && end !== null) {
          this.setStartDate(start);
          this.setEndDate(end);
        }
      }
    }

    if (_typeof(options.ranges) === 'object') {
      for (range in options.ranges) {

        if (typeof options.ranges[range][0] === 'string') start = moment(options.ranges[range][0], this.locale.format);else start = moment(options.ranges[range][0]);

        if (typeof options.ranges[range][1] === 'string') end = moment(options.ranges[range][1], this.locale.format);else end = moment(options.ranges[range][1]);

        // If the start or end date exceed those allowed by the minDate or dateLimit
        // options, shorten the range to the allowable period.
        if (this.minDate && start.isBefore(this.minDate)) start = this.minDate.clone();

        var maxDate = this.maxDate;
        if (maxDate && this.dateLimit && start.clone().add(this.dateLimit).isAfter(maxDate)) maxDate = start.clone().add(this.dateLimit);
        if (maxDate && end.isAfter(maxDate)) end = maxDate.clone();

        // If the end of the range is before the minimum or the start of the range is
        // after the maximum, don't display this range option at all.
        if (this.minDate && end.isBefore(this.minDate) || maxDate && start.isAfter(maxDate)) continue;

        //Support unicode chars in the range names.
        var elem = document.createElement('textarea');
        elem.innerHTML = gettext(range);
        var rangeHtml = elem.value;

        this.ranges[rangeHtml] = [start, end];
      }

      var list = '<ul>';
      for (range in this.ranges) {
        list += '<li>' + gettext(range) + '</li>';
      }
      list += '<li>' + this.locale.customRangeLabel + '</li>';
      list += '</ul>';
      this.container.find('.ranges').prepend(list);
    }

    if (typeof cb === 'function') {
      this.callback = cb;
    }

    if (!this.timePicker) {
      this.startDate = this.startDate.startOf('day');
      this.endDate = this.endDate.endOf('day');
      this.container.find('.calendar-time').hide();
    }

    //can't be used together for now
    if (this.timePicker && this.autoApply) this.autoApply = false;

    if (this.autoApply && _typeof(options.ranges) !== 'object') {
      this.container.find('.ranges').hide();
    } else if (this.autoApply) {
      this.container.find('.applyBtn, .cancelBtn').addClass('hide');
    }

    if (this.singleDatePicker) {
      this.container.addClass('single');
      this.container.find('.calendar.left').addClass('single');
      this.container.find('.calendar.left').show();
      this.container.find('.calendar.right').hide();
      this.container.find('.daterangepicker_input input, .daterangepicker_input i').hide();
      if (!this.timePicker) {
        this.container.find('.ranges').hide();
      }
    }

    if (typeof options.ranges === 'undefined' && !this.singleDatePicker || this.alwaysShowCalendars) {
      this.container.addClass('show-calendar');
    }

    this.container.addClass('opens' + this.opens);

    //swap the position of the predefined ranges if opens right
    if (typeof options.ranges !== 'undefined' && this.opens == 'right') {
      var ranges = this.container.find('.ranges');
      var html = ranges.clone();
      ranges.remove();
      this.container.find('.calendar.left').parent().prepend(html);
    }

    //apply CSS classes and labels to buttons
    this.container.find('.applyBtn, .cancelBtn').addClass(this.buttonClasses);
    if (this.applyClass.length) this.container.find('.applyBtn').addClass(this.applyClass);
    if (this.cancelClass.length) this.container.find('.cancelBtn').addClass(this.cancelClass);
    this.container.find('.applyBtn').html(this.locale.applyLabel);
    this.container.find('.cancelBtn').html(this.locale.cancelLabel);

    //
    // event listeners
    //

    this.container.find('.calendar').on('click.daterangepicker', '.prev', $.proxy(this.clickPrev, this)).on('click.daterangepicker', '.next', $.proxy(this.clickNext, this)).on('click.daterangepicker', 'td.available', $.proxy(this.clickDate, this)).on('mouseenter.daterangepicker', 'td.available', $.proxy(this.hoverDate, this)).on('mouseleave.daterangepicker', 'td.available', $.proxy(this.updateFormInputs, this)).on('change.daterangepicker', 'select.yearselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.monthselect', $.proxy(this.monthOrYearChanged, this)).on('change.daterangepicker', 'select.hourselect,select.minuteselect,select.secondselect,select.ampmselect', $.proxy(this.timeChanged, this)).on('click.daterangepicker', '.daterangepicker_input input', $.proxy(this.showCalendars, this)).on('keyup.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsKeyup, this)).on('change.daterangepicker', '.daterangepicker_input input', $.proxy(this.formInputsChanged, this));

    this.container.find('.ranges').on('click.daterangepicker', 'button.applyBtn', $.proxy(this.clickApply, this)).on('click.daterangepicker', 'button.cancelBtn', $.proxy(this.clickCancel, this)).on('click.daterangepicker', 'li', $.proxy(this.clickRange, this)).on('mouseenter.daterangepicker', 'li', $.proxy(this.hoverRange, this)).on('mouseleave.daterangepicker', 'li', $.proxy(this.updateFormInputs, this));

    if (this.element.is('input')) {
      this.element.on({
        'click.daterangepicker': $.proxy(this.show, this),
        'focus.daterangepicker': $.proxy(this.show, this),
        'keyup.daterangepicker': $.proxy(this.elementChanged, this),
        'keydown.daterangepicker': $.proxy(this.keydown, this)
      });
    } else {
      this.element.on('click.daterangepicker', $.proxy(this.toggle, this));
    }

    //
    // if attached to a text input, set the initial value
    //

    if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
      this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
      this.element.trigger('change');
    } else if (this.element.is('input') && this.autoUpdateInput) {
      this.element.val(this.startDate.format(this.locale.format));
      this.element.trigger('change');
    }
  };

  DateRangePicker.prototype = {

    constructor: DateRangePicker,

    setStartDate: function setStartDate(startDate) {
      if (typeof startDate === 'string') {
        if (moment(startDate, this.locale.format).isValid()) this.startDate = moment(startDate, this.locale.format);else if (moment(startDate).isValid()) this.startDate = moment(startDate);
      }
      if ((typeof startDate === 'undefined' ? 'undefined' : _typeof(startDate)) === 'object') this.startDate = moment(startDate);

      if (!this.timePicker) this.startDate = this.startDate.startOf('day');

      if (this.timePicker && this.timePickerIncrement) this.startDate.minute(Math.round(this.startDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

      if (this.minDate && this.startDate.isBefore(this.minDate)) this.startDate = this.minDate;

      if (this.maxDate && this.startDate.isAfter(this.maxDate)) this.startDate = this.maxDate;

      if (!this.isShowing) this.updateElement();

      this.updateMonthsInView();
    },

    setEndDate: function setEndDate(endDate) {
      if (typeof endDate === 'string') {
        if (moment(endDate, this.locale.format).isValid()) this.endDate = moment(endDate, this.locale.format);else if (moment(endDate).isValid()) this.endDate = moment(endDate);
      }
      if ((typeof endDate === 'undefined' ? 'undefined' : _typeof(endDate)) === 'object') this.endDate = moment(endDate);

      if (!this.timePicker) this.endDate = this.endDate.endOf('day');

      if (this.timePicker && this.timePickerIncrement) this.endDate.minute(Math.round(this.endDate.minute() / this.timePickerIncrement) * this.timePickerIncrement);

      if (this.endDate.isBefore(this.startDate)) this.endDate = this.startDate.clone();

      if (this.maxDate && this.endDate.isAfter(this.maxDate)) this.endDate = this.maxDate;

      if (this.dateLimit && this.startDate.clone().add(this.dateLimit).isBefore(this.endDate)) this.endDate = this.startDate.clone().add(this.dateLimit);

      this.previousRightTime = this.endDate.clone();

      if (!this.isShowing) this.updateElement();

      this.updateMonthsInView();
    },

    isInvalidDate: function isInvalidDate() {
      return false;
    },

    updateView: function updateView() {
      if (this.timePicker) {
        this.renderTimePicker('left');
        this.renderTimePicker('right');
        if (!this.endDate) {
          this.container.find('.right .calendar-time select').attr('disabled', 'disabled').addClass('disabled');
        } else {
          this.container.find('.right .calendar-time select').removeAttr('disabled').removeClass('disabled');
        }
      }
      if (this.endDate) {
        this.container.find('input[name="daterangepicker_end"]').removeClass('active');
        this.container.find('input[name="daterangepicker_start"]').addClass('active');
      } else {
        this.container.find('input[name="daterangepicker_end"]').addClass('active');
        this.container.find('input[name="daterangepicker_start"]').removeClass('active');
      }
      this.updateMonthsInView();
      this.updateCalendars();
      this.updateFormInputs();
    },

    updateMonthsInView: function updateMonthsInView() {
      if (this.endDate) {

        //if both dates are visible already, do nothing
        if (!this.singleDatePicker && this.leftCalendar.month && this.rightCalendar.month && (this.startDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.startDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM')) && (this.endDate.format('YYYY-MM') == this.leftCalendar.month.format('YYYY-MM') || this.endDate.format('YYYY-MM') == this.rightCalendar.month.format('YYYY-MM'))) {
          return;
        }

        this.leftCalendar.month = this.startDate.clone().date(2);
        if (!this.linkedCalendars && (this.endDate.month() != this.startDate.month() || this.endDate.year() != this.startDate.year())) {
          this.rightCalendar.month = this.endDate.clone().date(2);
        } else {
          this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
        }
      } else {
        if (this.leftCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM') && this.rightCalendar.month.format('YYYY-MM') != this.startDate.format('YYYY-MM')) {
          this.leftCalendar.month = this.startDate.clone().date(2);
          this.rightCalendar.month = this.startDate.clone().date(2).add(1, 'month');
        }
      }
    },

    updateCalendars: function updateCalendars() {

      if (this.timePicker) {
        var hour, minute, second;
        if (this.endDate) {
          hour = parseInt(this.container.find('.left .hourselect').val(), 10);
          minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
          second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.left .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
        } else {
          hour = parseInt(this.container.find('.right .hourselect').val(), 10);
          minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
          second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.right .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
        }
        this.leftCalendar.month.hour(hour).minute(minute).second(second);
        this.rightCalendar.month.hour(hour).minute(minute).second(second);
      }

      this.renderCalendar('left');
      this.renderCalendar('right');

      //highlight any predefined range matching the current start and end dates
      this.container.find('.ranges li').removeClass('active');
      if (this.endDate == null) return;

      this.calculateChosenLabel();
    },

    renderCalendar: function renderCalendar(side) {

      //
      // Build the matrix of dates that will populate the calendar
      //

      var calendar = side == 'left' ? this.leftCalendar : this.rightCalendar;
      var month = calendar.month.month();
      var year = calendar.month.year();
      var hour = calendar.month.hour();
      var minute = calendar.month.minute();
      var second = calendar.month.second();
      var daysInMonth = moment([year, month]).daysInMonth();
      var firstDay = moment([year, month, 1]);
      var lastDay = moment([year, month, daysInMonth]);
      var lastMonth = moment(firstDay).subtract(1, 'month').month();
      var lastYear = moment(firstDay).subtract(1, 'month').year();
      var daysInLastMonth = moment([lastYear, lastMonth]).daysInMonth();
      var dayOfWeek = firstDay.day();

      //initialize a 6 rows x 7 columns array for the calendar
      var calendar = [];
      calendar.firstDay = firstDay;
      calendar.lastDay = lastDay;

      for (var i = 0; i < 6; i++) {
        calendar[i] = [];
      }

      //populate the calendar with date objects
      var startDay = daysInLastMonth - dayOfWeek + this.locale.firstDay + 1;
      if (startDay > daysInLastMonth) startDay -= 7;

      if (dayOfWeek == this.locale.firstDay) startDay = daysInLastMonth - 6;

      var curDate = moment([lastYear, lastMonth, startDay, 12, minute, second]);

      var col, row;
      for (var i = 0, col = 0, row = 0; i < 42; i++, col++, curDate = moment(curDate).add(24, 'hour')) {
        if (i > 0 && col % 7 === 0) {
          col = 0;
          row++;
        }
        calendar[row][col] = curDate.clone().hour(hour).minute(minute).second(second);
        curDate.hour(12);

        if (this.minDate && calendar[row][col].format('YYYY-MM-DD') == this.minDate.format('YYYY-MM-DD') && calendar[row][col].isBefore(this.minDate) && side == 'left') {
          calendar[row][col] = this.minDate.clone();
        }

        if (this.maxDate && calendar[row][col].format('YYYY-MM-DD') == this.maxDate.format('YYYY-MM-DD') && calendar[row][col].isAfter(this.maxDate) && side == 'right') {
          calendar[row][col] = this.maxDate.clone();
        }
      }

      //make the calendar object available to hoverDate/clickDate
      if (side == 'left') {
        this.leftCalendar.calendar = calendar;
      } else {
        this.rightCalendar.calendar = calendar;
      }

      //
      // Display the calendar
      //

      var minDate = side == 'left' ? this.minDate : this.startDate;
      var maxDate = this.maxDate;
      var selected = side == 'left' ? this.startDate : this.endDate;

      var html = '<table class="table-condensed">';
      html += '<thead>';
      html += '<tr>';

      // add empty cell for week number
      if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th></th>';

      if ((!minDate || minDate.isBefore(calendar.firstDay)) && (!this.linkedCalendars || side == 'left')) {
        html += '<th class="prev available"><i class="fa fa-chevron-left glyphicon glyphicon-chevron-left"></i></th>';
      } else {
        html += '<th></th>';
      }

      var dateHtml = this.locale.monthNames[calendar[1][1].month()] + calendar[1][1].format(" YYYY");

      if (this.showDropdowns) {
        var currentMonth = calendar[1][1].month();
        var currentYear = calendar[1][1].year();
        var maxYear = maxDate && maxDate.year() || currentYear + 5;
        var minYear = minDate && minDate.year() || currentYear - 50;
        var inMinYear = currentYear == minYear;
        var inMaxYear = currentYear == maxYear;

        var monthHtml = '<select class="monthselect">';
        for (var m = 0; m < 12; m++) {
          if ((!inMinYear || m >= minDate.month()) && (!inMaxYear || m <= maxDate.month())) {
            monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + ">" + this.locale.monthNames[m] + "</option>";
          } else {
            monthHtml += "<option value='" + m + "'" + (m === currentMonth ? " selected='selected'" : "") + " disabled='disabled'>" + this.locale.monthNames[m] + "</option>";
          }
        }
        monthHtml += "</select>";

        var yearHtml = '<select class="yearselect">';
        for (var y = minYear; y <= maxYear; y++) {
          yearHtml += '<option value="' + y + '"' + (y === currentYear ? ' selected="selected"' : '') + '>' + y + '</option>';
        }
        yearHtml += '</select>';

        dateHtml = monthHtml + yearHtml;
      }

      html += '<th colspan="5" class="month">' + dateHtml + '</th>';
      if ((!maxDate || maxDate.isAfter(calendar.lastDay)) && (!this.linkedCalendars || side == 'right' || this.singleDatePicker)) {
        html += '<th class="next available"><i class="fa fa-chevron-right glyphicon glyphicon-chevron-right"></i></th>';
      } else {
        html += '<th></th>';
      }

      html += '</tr>';
      html += '<tr>';

      // add week number label
      if (this.showWeekNumbers || this.showISOWeekNumbers) html += '<th class="week">' + this.locale.weekLabel + '</th>';

      $.each(this.locale.daysOfWeek, function (index, dayOfWeek) {
        html += '<th>' + dayOfWeek + '</th>';
      });

      html += '</tr>';
      html += '</thead>';
      html += '<tbody>';

      //adjust maxDate to reflect the dateLimit setting in order to
      //grey out end dates beyond the dateLimit
      if (this.endDate == null && this.dateLimit) {
        var maxLimit = this.startDate.clone().add(this.dateLimit).endOf('day');
        if (!maxDate || maxLimit.isBefore(maxDate)) {
          maxDate = maxLimit;
        }
      }

      for (var row = 0; row < 6; row++) {
        html += '<tr>';

        // add week number
        if (this.showWeekNumbers) html += '<td class="week">' + calendar[row][0].week() + '</td>';else if (this.showISOWeekNumbers) html += '<td class="week">' + calendar[row][0].isoWeek() + '</td>';

        for (var col = 0; col < 7; col++) {

          var classes = [];

          //highlight today's date
          if (calendar[row][col].isSame(new Date(), "day")) classes.push('today');

          //highlight weekends
          if (calendar[row][col].isoWeekday() > 5) classes.push('weekend');

          //grey out the dates in other months displayed at beginning and end of this calendar
          if (calendar[row][col].month() != calendar[1][1].month()) classes.push('off');

          //don't allow selection of dates before the minimum date
          if (this.minDate && calendar[row][col].isBefore(this.minDate, 'day')) classes.push('off', 'disabled');

          //don't allow selection of dates after the maximum date
          if (maxDate && calendar[row][col].isAfter(maxDate, 'day')) classes.push('off', 'disabled');

          //don't allow selection of date if a custom function decides it's invalid
          if (this.isInvalidDate(calendar[row][col])) classes.push('off', 'disabled');

          //highlight the currently selected start date
          if (calendar[row][col].format('YYYY-MM-DD') == this.startDate.format('YYYY-MM-DD')) classes.push('active', 'start-date');

          //highlight the currently selected end date
          if (this.endDate != null && calendar[row][col].format('YYYY-MM-DD') == this.endDate.format('YYYY-MM-DD')) classes.push('active', 'end-date');

          //highlight dates in-between the selected dates
          if (this.endDate != null && calendar[row][col] > this.startDate && calendar[row][col] < this.endDate) classes.push('in-range');

          var cname = '',
              disabled = false;
          for (var i = 0; i < classes.length; i++) {
            cname += classes[i] + ' ';
            if (classes[i] == 'disabled') disabled = true;
          }
          if (!disabled) cname += 'available';

          html += '<td class="' + cname.replace(/^\s+|\s+$/g, '') + '" data-title="' + 'r' + row + 'c' + col + '">' + calendar[row][col].date() + '</td>';
        }
        html += '</tr>';
      }

      html += '</tbody>';
      html += '</table>';

      this.container.find('.calendar.' + side + ' .calendar-table').html(html);
    },

    renderTimePicker: function renderTimePicker(side) {

      var html,
          selected,
          minDate,
          maxDate = this.maxDate;

      if (this.dateLimit && (!this.maxDate || this.startDate.clone().add(this.dateLimit).isAfter(this.maxDate))) maxDate = this.startDate.clone().add(this.dateLimit);

      if (side == 'left') {
        selected = this.startDate.clone();
        minDate = this.minDate;
      } else if (side == 'right') {
        selected = this.endDate ? this.endDate.clone() : this.previousRightTime.clone();
        minDate = this.startDate;

        //Preserve the time already selected
        var timeSelector = this.container.find('.calendar.right .calendar-time div');
        if (timeSelector.html() != '') {

          selected.hour(timeSelector.find('.hourselect option:selected').val() || selected.hour());
          selected.minute(timeSelector.find('.minuteselect option:selected').val() || selected.minute());
          selected.second(timeSelector.find('.secondselect option:selected').val() || selected.second());

          if (!this.timePicker24Hour) {
            var ampm = timeSelector.find('.ampmselect option:selected').val();
            if (ampm === 'PM' && selected.hour() < 12) selected.hour(selected.hour() + 12);
            if (ampm === 'AM' && selected.hour() === 12) selected.hour(0);
          }

          if (selected.isBefore(this.startDate)) selected = this.startDate.clone();

          if (maxDate && selected.isAfter(maxDate)) selected = maxDate.clone();
        }
      }

      //
      // hours
      //

      html = '<select class="hourselect">';

      var start = this.timePicker24Hour ? 0 : 1;
      var end = this.timePicker24Hour ? 23 : 12;

      for (var i = start; i <= end; i++) {
        var i_in_24 = i;
        if (!this.timePicker24Hour) i_in_24 = selected.hour() >= 12 ? i == 12 ? 12 : i + 12 : i == 12 ? 0 : i;

        var time = selected.clone().hour(i_in_24);
        var disabled = false;
        if (minDate && time.minute(59).isBefore(minDate)) disabled = true;
        if (maxDate && time.minute(0).isAfter(maxDate)) disabled = true;

        if (i_in_24 == selected.hour() && !disabled) {
          html += '<option value="' + i + '" selected="selected">' + i + '</option>';
        } else if (disabled) {
          html += '<option value="' + i + '" disabled="disabled" class="disabled">' + i + '</option>';
        } else {
          html += '<option value="' + i + '">' + i + '</option>';
        }
      }

      html += '</select> ';

      //
      // minutes
      //

      html += ': <select class="minuteselect">';

      for (var i = 0; i < 60; i += this.timePickerIncrement) {
        var padded = i < 10 ? '0' + i : i;
        var time = selected.clone().minute(i);

        var disabled = false;
        if (minDate && time.second(59).isBefore(minDate)) disabled = true;
        if (maxDate && time.second(0).isAfter(maxDate)) disabled = true;

        if (selected.minute() == i && !disabled) {
          html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
        } else if (disabled) {
          html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
        } else {
          html += '<option value="' + i + '">' + padded + '</option>';
        }
      }

      html += '</select> ';

      //
      // seconds
      //

      if (this.timePickerSeconds) {
        html += ': <select class="secondselect">';

        for (var i = 0; i < 60; i++) {
          var padded = i < 10 ? '0' + i : i;
          var time = selected.clone().second(i);

          var disabled = false;
          if (minDate && time.isBefore(minDate)) disabled = true;
          if (maxDate && time.isAfter(maxDate)) disabled = true;

          if (selected.second() == i && !disabled) {
            html += '<option value="' + i + '" selected="selected">' + padded + '</option>';
          } else if (disabled) {
            html += '<option value="' + i + '" disabled="disabled" class="disabled">' + padded + '</option>';
          } else {
            html += '<option value="' + i + '">' + padded + '</option>';
          }
        }

        html += '</select> ';
      }

      //
      // AM/PM
      //

      if (!this.timePicker24Hour) {
        html += '<select class="ampmselect">';

        var am_html = '';
        var pm_html = '';

        if (minDate && selected.clone().hour(12).minute(0).second(0).isBefore(minDate)) am_html = ' disabled="disabled" class="disabled"';

        if (maxDate && selected.clone().hour(0).minute(0).second(0).isAfter(maxDate)) pm_html = ' disabled="disabled" class="disabled"';

        if (selected.hour() >= 12) {
          html += '<option value="AM"' + am_html + '>AM</option><option value="PM" selected="selected"' + pm_html + '>PM</option>';
        } else {
          html += '<option value="AM" selected="selected"' + am_html + '>AM</option><option value="PM"' + pm_html + '>PM</option>';
        }

        html += '</select>';
      }

      this.container.find('.calendar.' + side + ' .calendar-time div').html(html);
    },

    updateFormInputs: function updateFormInputs() {

      //ignore mouse movements while an above-calendar text input has focus
      if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus")) return;

      this.container.find('input[name=daterangepicker_start]').val(this.startDate.format(this.locale.format));
      if (this.endDate) this.container.find('input[name=daterangepicker_end]').val(this.endDate.format(this.locale.format));

      if (this.singleDatePicker || this.endDate && (this.startDate.isBefore(this.endDate) || this.startDate.isSame(this.endDate))) {
        this.container.find('button.applyBtn').removeAttr('disabled');
      } else {
        this.container.find('button.applyBtn').attr('disabled', 'disabled');
      }
    },

    move: function move() {
      var parentOffset = {
        top: 0,
        left: 0
      },
          containerTop;
      var parentRightEdge = $(window).width();
      if (!this.parentEl.is('body')) {
        parentOffset = {
          top: this.parentEl.offset().top - this.parentEl.scrollTop(),
          left: this.parentEl.offset().left - this.parentEl.scrollLeft()
        };
        parentRightEdge = this.parentEl[0].clientWidth + this.parentEl.offset().left;
      }

      if (this.drops == 'up') containerTop = this.element.offset().top - this.container.outerHeight() - parentOffset.top;else containerTop = this.element.offset().top + this.element.outerHeight() - parentOffset.top;
      this.container[this.drops == 'up' ? 'addClass' : 'removeClass']('dropup');

      if (this.opens == 'left') {
        this.container.css({
          top: containerTop,
          right: parentRightEdge - this.element.offset().left - this.element.outerWidth(),
          left: 'auto'
        });
        if (this.container.offset().left < 0) {
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else if (this.opens == 'center') {
        this.container.css({
          top: containerTop,
          left: this.element.offset().left - parentOffset.left + this.element.outerWidth() / 2 - this.container.outerWidth() / 2,
          right: 'auto'
        });
        if (this.container.offset().left < 0) {
          this.container.css({
            right: 'auto',
            left: 9
          });
        }
      } else {
        this.container.css({
          top: containerTop,
          left: this.element.offset().left - parentOffset.left,
          right: 'auto'
        });
        if (this.container.offset().left + this.container.outerWidth() > $(window).width()) {
          this.container.css({
            left: 'auto',
            right: 0
          });
        }
      }
    },

    show: function show(e) {
      if (this.isShowing) return;

      // Create a click proxy that is private to this instance of datepicker, for unbinding
      this._outsideClickProxy = $.proxy(function (e) {
        this.outsideClick(e);
      }, this);

      // Bind global datepicker mousedown for hiding and
      $(document).on('mousedown.daterangepicker', this._outsideClickProxy)
      // also support mobile devices
      .on('touchend.daterangepicker', this._outsideClickProxy)
      // also explicitly play nice with Bootstrap dropdowns, which stopPropagation when clicking them
      .on('click.daterangepicker', '[data-toggle=dropdown]', this._outsideClickProxy)
      // and also close when focus changes to outside the picker (eg. tabbing between controls)
      .on('focusin.daterangepicker', this._outsideClickProxy);

      // Reposition the picker if the window is resized while it's open
      $(window).on('resize.daterangepicker', $.proxy(function (e) {
        this.move(e);
      }, this));

      this.oldStartDate = this.startDate.clone();
      this.oldEndDate = this.endDate.clone();
      this.previousRightTime = this.endDate.clone();

      this.updateView();
      this.container.show();
      this.move();
      this.element.trigger('show.daterangepicker', this);
      this.isShowing = true;
    },

    hide: function hide(e) {
      if (!this.isShowing) return;

      //incomplete date selection, revert to last values
      if (!this.endDate) {
        this.startDate = this.oldStartDate.clone();
        this.endDate = this.oldEndDate.clone();
      }

      //if a new date range was selected, invoke the user callback function
      // if (!this.startDate.isSame(this.oldStartDate) || !this.endDate.isSame(this.oldEndDate))
      this.callback(this.startDate, this.endDate, this.chosenLabel);

      //if picker is attached to a text input, update it
      this.updateElement();

      $(document).off('.daterangepicker');
      $(window).off('.daterangepicker');
      this.container.hide();
      this.element.trigger('hide.daterangepicker', this);
      this.isShowing = false;
    },

    toggle: function toggle(e) {
      if (this.isShowing) {
        this.hide();
      } else {
        this.show();
      }
    },

    outsideClick: function outsideClick(e) {
      var target = $(e.target);
      // if the page is clicked anywhere except within the daterangerpicker/button
      // itself then call this.hide()
      if (
      // ie modal dialog fix
      e.type == "focusin" || target.closest(this.element).length || target.closest(this.container).length || target.closest('.calendar-table').length) return;
      this.hide();
    },

    showCalendars: function showCalendars() {
      this.container.addClass('show-calendar');
      this.move();
      this.element.trigger('showCalendar.daterangepicker', this);
    },

    hideCalendars: function hideCalendars() {
      this.container.removeClass('show-calendar');
      this.element.trigger('hideCalendar.daterangepicker', this);
    },

    hoverRange: function hoverRange(e) {

      //ignore mouse movements while an above-calendar text input has focus
      if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus")) return;

      var label = e.target.innerHTML;
      if (label == this.locale.customRangeLabel) {
        this.updateView();
      } else {
        var dates = this.ranges[label];
        this.container.find('input[name=daterangepicker_start]').val(dates[0].format(this.locale.format));
        this.container.find('input[name=daterangepicker_end]').val(dates[1].format(this.locale.format));
      }
    },

    clickRange: function clickRange(e) {
      var label = e.target.innerHTML;
      this.chosenLabel = label;
      if (label == this.locale.customRangeLabel) {
        this.showCalendars();
      } else {
        var dates = this.ranges[label];
        this.startDate = dates[0];
        this.endDate = dates[1];

        if (!this.timePicker) {
          this.startDate.startOf('day');
          this.endDate.endOf('day');
        }

        if (!this.alwaysShowCalendars) this.hideCalendars();
        this.clickApply();
      }
    },

    clickPrev: function clickPrev(e) {
      var cal = $(e.target).parents('.calendar');
      if (cal.hasClass('left')) {
        this.leftCalendar.month.subtract(1, 'month');
        if (this.linkedCalendars) this.rightCalendar.month.subtract(1, 'month');
      } else {
        this.rightCalendar.month.subtract(1, 'month');
      }
      this.updateCalendars();
    },

    clickNext: function clickNext(e) {
      var cal = $(e.target).parents('.calendar');
      if (cal.hasClass('left')) {
        this.leftCalendar.month.add(1, 'month');
      } else {
        this.rightCalendar.month.add(1, 'month');
        if (this.linkedCalendars) this.leftCalendar.month.add(1, 'month');
      }
      this.updateCalendars();
    },

    hoverDate: function hoverDate(e) {

      //ignore mouse movements while an above-calendar text input has focus
      if (this.container.find('input[name=daterangepicker_start]').is(":focus") || this.container.find('input[name=daterangepicker_end]').is(":focus")) return;

      //ignore dates that can't be selected
      if (!$(e.target).hasClass('available')) return;

      //have the text inputs above calendars reflect the date being hovered over
      var title = $(e.target).attr('data-title');
      var row = title.substr(1, 1);
      var col = title.substr(3, 1);
      var cal = $(e.target).parents('.calendar');
      var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

      if (this.endDate) {
        this.container.find('input[name=daterangepicker_start]').val(date.format(this.locale.format));
      } else {
        this.container.find('input[name=daterangepicker_end]').val(date.format(this.locale.format));
      }

      //highlight the dates between the start date and the date being hovered as a potential end date
      var leftCalendar = this.leftCalendar;
      var rightCalendar = this.rightCalendar;
      var startDate = this.startDate;
      if (!this.endDate) {
        this.container.find('.calendar td').each(function (index, el) {

          //skip week numbers, only look at dates
          if ($(el).hasClass('week')) return;

          var title = $(el).attr('data-title');
          var row = title.substr(1, 1);
          var col = title.substr(3, 1);
          var cal = $(el).parents('.calendar');
          var dt = cal.hasClass('left') ? leftCalendar.calendar[row][col] : rightCalendar.calendar[row][col];

          if (dt.isAfter(startDate) && dt.isBefore(date)) {
            $(el).addClass('in-range');
          } else {
            $(el).removeClass('in-range');
          }
        });
      }
    },

    clickDate: function clickDate(e) {

      if (!$(e.target).hasClass('available')) return;

      var title = $(e.target).attr('data-title');
      var row = title.substr(1, 1);
      var col = title.substr(3, 1);
      var cal = $(e.target).parents('.calendar');
      var date = cal.hasClass('left') ? this.leftCalendar.calendar[row][col] : this.rightCalendar.calendar[row][col];

      //
      // this function needs to do a few things:
      // * alternate between selecting a start and end date for the range,
      // * if the time picker is enabled, apply the hour/minute/second from the select boxes to the clicked date
      // * if autoapply is enabled, and an end date was chosen, apply the selection
      // * if single date picker mode, and time picker isn't enabled, apply the selection immediately
      //

      if (this.endDate || date.isBefore(this.startDate, 'day')) {
        if (this.timePicker) {
          var hour = parseInt(this.container.find('.left .hourselect').val(), 10);
          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.left .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
          var minute = parseInt(this.container.find('.left .minuteselect').val(), 10);
          var second = this.timePickerSeconds ? parseInt(this.container.find('.left .secondselect').val(), 10) : 0;
          date = date.clone().hour(hour).minute(minute).second(second);
        }
        this.endDate = null;
        this.setStartDate(date.clone());
      } else if (!this.endDate && date.isBefore(this.startDate)) {
        //special case: clicking the same date for start/end,
        //but the time of the end date is before the start date
        this.setEndDate(this.startDate.clone());
      } else {
        if (this.timePicker) {
          var hour = parseInt(this.container.find('.right .hourselect').val(), 10);
          if (!this.timePicker24Hour) {
            var ampm = this.container.find('.right .ampmselect').val();
            if (ampm === 'PM' && hour < 12) hour += 12;
            if (ampm === 'AM' && hour === 12) hour = 0;
          }
          var minute = parseInt(this.container.find('.right .minuteselect').val(), 10);
          var second = this.timePickerSeconds ? parseInt(this.container.find('.right .secondselect').val(), 10) : 0;
          date = date.clone().hour(hour).minute(minute).second(second);
        }
        this.setEndDate(date.clone());
        if (this.autoApply) {
          this.calculateChosenLabel();
          this.clickApply();
        }
      }

      if (this.singleDatePicker) {
        this.setEndDate(this.startDate);
        if (!this.timePicker) this.clickApply();
      }

      this.updateView();
    },

    calculateChosenLabel: function calculateChosenLabel() {
      var customRange = true;
      var i = 0;
      for (var range in this.ranges) {
        if (this.timePicker) {
          if (this.startDate.isSame(this.ranges[range][0]) && this.endDate.isSame(this.ranges[range][1])) {
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
            break;
          }
        } else {
          //ignore times when comparing dates if time picker is not enabled
          if (this.startDate.format('YYYY-MM-DD') == this.ranges[range][0].format('YYYY-MM-DD') && this.endDate.format('YYYY-MM-DD') == this.ranges[range][1].format('YYYY-MM-DD')) {
            customRange = false;
            this.chosenLabel = this.container.find('.ranges li:eq(' + i + ')').addClass('active').html();
            break;
          }
        }
        i++;
      }
      if (customRange) {
        this.chosenLabel = this.container.find('.ranges li:last').addClass('active').html();
        this.showCalendars();
      }
    },

    clickApply: function clickApply(e) {
      this.hide();
      this.element.trigger('apply.daterangepicker', this);
    },

    clickCancel: function clickCancel(e) {
      this.startDate = this.oldStartDate;
      this.endDate = this.oldEndDate;
      this.hide();
      this.element.trigger('cancel.daterangepicker', this);
    },

    monthOrYearChanged: function monthOrYearChanged(e) {
      var isLeft = $(e.target).closest('.calendar').hasClass('left'),
          leftOrRight = isLeft ? 'left' : 'right',
          cal = this.container.find('.calendar.' + leftOrRight);

      // Month must be Number for new moment versions
      var month = parseInt(cal.find('.monthselect').val(), 10);
      var year = cal.find('.yearselect').val();

      if (!isLeft) {
        if (year < this.startDate.year() || year == this.startDate.year() && month < this.startDate.month()) {
          month = this.startDate.month();
          year = this.startDate.year();
        }
      }

      if (this.minDate) {
        if (year < this.minDate.year() || year == this.minDate.year() && month < this.minDate.month()) {
          month = this.minDate.month();
          year = this.minDate.year();
        }
      }

      if (this.maxDate) {
        if (year > this.maxDate.year() || year == this.maxDate.year() && month > this.maxDate.month()) {
          month = this.maxDate.month();
          year = this.maxDate.year();
        }
      }

      if (isLeft) {
        this.leftCalendar.month.month(month).year(year);
        if (this.linkedCalendars) this.rightCalendar.month = this.leftCalendar.month.clone().add(1, 'month');
      } else {
        this.rightCalendar.month.month(month).year(year);
        if (this.linkedCalendars) this.leftCalendar.month = this.rightCalendar.month.clone().subtract(1, 'month');
      }
      this.updateCalendars();
    },

    timeChanged: function timeChanged(e) {

      var cal = $(e.target).closest('.calendar'),
          isLeft = cal.hasClass('left');

      var hour = parseInt(cal.find('.hourselect').val(), 10);
      var minute = parseInt(cal.find('.minuteselect').val(), 10);
      var second = this.timePickerSeconds ? parseInt(cal.find('.secondselect').val(), 10) : 0;

      if (!this.timePicker24Hour) {
        var ampm = cal.find('.ampmselect').val();
        if (ampm === 'PM' && hour < 12) hour += 12;
        if (ampm === 'AM' && hour === 12) hour = 0;
      }

      if (isLeft) {
        var start = this.startDate.clone();
        start.hour(hour);
        start.minute(minute);
        start.second(second);
        this.setStartDate(start);
        if (this.singleDatePicker) {
          this.endDate = this.startDate.clone();
        } else if (this.endDate && this.endDate.format('YYYY-MM-DD') == start.format('YYYY-MM-DD') && this.endDate.isBefore(start)) {
          this.setEndDate(start.clone());
        }
      } else if (this.endDate) {
        var end = this.endDate.clone();
        end.hour(hour);
        end.minute(minute);
        end.second(second);
        this.setEndDate(end);
      }

      //update the calendars so all clickable dates reflect the new time component
      this.updateCalendars();

      //update the form inputs above the calendars with the new time
      this.updateFormInputs();

      //re-render the time pickers because changing one selection can affect what's enabled in another
      this.renderTimePicker('left');
      this.renderTimePicker('right');
    },

    formInputsKeyup: function formInputsKeyup(e) {
      if (e.keyCode == 13) {
        if (this.autoApply) {
          this.calculateChosenLabel();
          this.clickApply();
        }
      }
    },

    formInputsChanged: function formInputsChanged(e) {

      var isRight = $(e.target).closest('.calendar').hasClass('right');
      var start = moment(this.container.find('input[name="daterangepicker_start"]').val(), this.locale.format);
      var end = moment(this.container.find('input[name="daterangepicker_end"]').val(), this.locale.format);

      if (start.isValid() && end.isValid()) {

        if (isRight && end.isBefore(start)) start = end.clone();

        this.setStartDate(start);
        this.setEndDate(end);

        if (isRight) {
          this.container.find('input[name="daterangepicker_start"]').val(this.startDate.format(this.locale.format));
        } else {
          this.container.find('input[name="daterangepicker_end"]').val(this.endDate.format(this.locale.format));
        }
      }

      this.updateCalendars();
      if (this.timePicker) {
        this.renderTimePicker('left');
        this.renderTimePicker('right');
      }
    },

    elementChanged: function elementChanged() {
      if (!this.element.is('input')) return;
      if (!this.element.val().length) return;
      if (this.element.val().length < this.locale.format.length) return;

      var dateString = this.element.val().split(this.locale.separator),
          start = null,
          end = null;

      if (dateString.length === 2) {
        start = moment(dateString[0], this.locale.format);
        end = moment(dateString[1], this.locale.format);
      }

      if (this.singleDatePicker || start === null || end === null) {
        start = moment(this.element.val(), this.locale.format);
        end = start;
      }

      if (!start.isValid() || !end.isValid()) return;

      this.setStartDate(start);
      this.setEndDate(end);
      this.updateView();
    },

    keydown: function keydown(e) {
      //hide on tab or enter
      if (e.keyCode === 9 || e.keyCode === 13) {
        this.hide();
      }
    },

    updateElement: function updateElement() {
      if (this.element.is('input') && !this.singleDatePicker && this.autoUpdateInput) {
        this.element.val(this.startDate.format(this.locale.format) + this.locale.separator + this.endDate.format(this.locale.format));
        this.element.trigger('change');
      } else if (this.element.is('input') && this.autoUpdateInput) {
        this.element.val(this.startDate.format(this.locale.format));
        this.element.trigger('change');
      }
    },

    remove: function remove() {
      this.container.remove();
      this.element.off('.daterangepicker');
      this.element.removeData();
    }

  };

  $.fn.daterangepicker = function (options, callback) {
    this.each(function () {
      var el = $(this);
      if (el.data('daterangepicker')) el.data('daterangepicker').remove();
      el.data('daterangepicker', new DateRangePicker(el, options, callback));
    });
    return this;
  };

  return DateRangePicker;
});

/***/ }),
/* 768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "<div ng-click=\"$ctrl.setInitRanges()\" id=\"reportrange\" class=\"datepicker\" title=\"{{::'Нажмите для выбора периода' | gettext}}\"><i class=\"icon-calendar\"></i> <span class=\"hideable\">{{:: 'Период с' | gettext }} <b>{{ $ctrl.timeFrom | date: 'dd MMMM yyyy HH:mm' }} </b>{{:: 'по' | gettext }} <b>{{ $ctrl.timeTo | date: 'dd MMMM yyyy HH:mm' }}</b></span></div>"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterDimensionComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _iconClass = __webpack_require__(38);

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {
//   AlertModalController
// } from './editor/alert-modal.component';

__webpack_require__(771);

var FilterDimensionController = function () {
  function FilterDimensionController($scope, $q, $element, $timeout, $http, $modal, CurrentFilterService, AggregateDataService, CurrentModelService, $rootScope, ErrorHandlerService, RouterService, CurrentFilterDataService, PermissionService, FilterResource, LayoutService) {
    var _this = this;

    _classCallCheck(this, FilterDimensionController);

    this.$scope = $scope;
    this.$http = $http;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$modal = $modal;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.ErrorHandlerService = ErrorHandlerService;
    this.router = RouterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.permission = PermissionService;
    this.FilterResource = FilterResource;
    this.panelWidth = 1000;
    this.LayoutService = LayoutService;
    this.$scope.$on('splitter1Changed', function (e, d) {
      return _this.updatePanelWidth(e);
    });
    this.$scope.$on('splitter2Changed', function (e, d) {
      return _this.updatePanelWidth(e);
    });
    this.updateAggregate = this.updateAggregate.bind(this);

    this.startUpdateAggregate = function () {
      if (_this.timerId) _this.$timeout.cancel(_this.timerId);
      var renewTime = _this.LayoutService && _this.LayoutService.options.renewAggregateSeconds.value * 1000;
      if (renewTime) _this.timerId = _this.$timeout(_this.updateAggregate, renewTime);
    };

    this.$scope.$on('init', function (e, d) {
      _this.updatePanelWidth(e, d);
      _this.startUpdateAggregate();
    });

    this.$scope.$on('optionsChanged', function (e, d) {
      return _this.startUpdateAggregate();
    });
  }

  _createClass(FilterDimensionController, [{
    key: 'updateAggregate',
    value: function updateAggregate() {
      var renewTime = this && this.LayoutService && this.LayoutService.options.renewAggregateSeconds.value * 1000;
      if (renewTime) {
        this.AggregateDataService.aggregateCheck(this.findScreenDimIndex());
      }
      this.timerId = this.$timeout(this.updateAggregate, renewTime);
    }
  }, {
    key: 'findScreenDimIndex',
    value: function findScreenDimIndex() {
      var drill = this.currentFilter.filterBar.drilldown[0];
      if (drill !== 'agent_agent@computer_name:computer_name' && drill !== 'agent_account@user_name:user_name') return 0;
      var ch = this.$element.find('sc-filter-dimension-node .nav-list').children();
      var index = 0;
      ch.each(function (i) {
        index = i;
        return $(ch[i]).offset().top < 0;
      });
      return index;
    }
  }, {
    key: 'updatePanelWidth',
    value: function updatePanelWidth(e) {
      this.panelWidth = this.$element[0].offsetWidth;
      if (e.targetScope.$$phase) return;
      this.$scope.$digest();
    }
  }, {
    key: 'selectAll',
    value: function selectAll(cmd) {
      var _this2 = this;

      if (!this.aggregate || !this.aggregate.cells) {
        return;
      }
      var drill = this.filterBar.drilldown[0];
      var cells = this.AggregateDataService.aggregate.cells;
      cells.forEach(function (cell) {
        var filter = _this2.model.getCellFilter(drill, cell);
        if (cmd === 'select all') _this2.filter.addCut(filter);else if (cmd === 'deselect all') _this2.filter.removeFilter(filter.dimension, filter.value);else _this2.filter.toggleFilter(filter);
      });
      this.currentFilter.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }, {
    key: 'searchAggregate',
    value: function searchAggregate(event) {
      if (event && event.keyCode !== 13) {
        return false;
      }
      this.router.lookup(this.filterBar.lookup);
    }
  }, {
    key: 'aggregate_more',
    value: function aggregate_more() {
      if (!this.filter || !this.filterBar) {
        return;
      }
      return this.AggregateDataService.aggregate_more(false);
    }
  }, {
    key: 'toggleSkipStat',
    value: function toggleSkipStat() {
      this.filterBar.toggleSkipStat();
      return this.AggregateDataService.init(false);
    }
  }, {
    key: 'toggleAutoUpdate',
    value: function toggleAutoUpdate() {
      this.CurrentFilterDataService.autoUpdate = !this.CurrentFilterDataService.autoUpdate;
      if (this.CurrentFilterDataService.autoUpdate) {
        this.$scope.$root.$broadcast('reload');
      }
    }
  }, {
    key: 'hasCellFilter',
    value: function hasCellFilter(cell) {
      var filter = this.model.getCellFilter(this.filterBar.drilldown[0], cell);
      return this.filter.hasFilter(filter);
    }
  }, {
    key: 'panel',
    get: function get() {
      return this.currentFilter.panel;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    }
  }, {
    key: 'aggregate',
    get: function get() {
      return this.AggregateDataService.aggregate;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.AggregateDataService.loading;
    }
  }, {
    key: 'isLoadingMore',
    get: function get() {
      return this.AggregateDataService.loadingMore;
    }
  }]);

  return FilterDimensionController;
}();

var FilterDimensionComponent = exports.FilterDimensionComponent = {
  template: __webpack_require__(772),
  controller: FilterDimensionController
};

/***/ }),
/* 771 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "<div id=\"dimension\" class=\"dimension\"><div class=\"input-append aggregate-header toolbar-color\"><span class=\"aggregate-header-left lead\"><i class=\"pointer\" ng-class=\"$ctrl.DIM2CLASS[($ctrl.filterBar.drilldown[0] || '').split('@')[0]]\" ng-click=\"$ctrl.selectAll()\"></i> <i ng-class=\"$ctrl.DIM2CLASS[($ctrl.filterBar.drilldown[0] || '').split('@')[0]]\"></i> &nbsp;</span><span class=\"aggregate-header-center\"><input type=\"text\" id=\"aggregate-search\" ng-keyup=\"$ctrl.searchAggregate($event)\" ng-model=\"$ctrl.currentFilter.filterBar.lookup\" placeholder=\"{{::'Поиск' | gettext}} - {{$ctrl.filterBar.drilldown[0] && $ctrl.model.getDrillLabel($ctrl.filterBar.drilldown[0])}}\"> </span><a class=\"add-on aggregate-header-right\" ng-click=\"$ctrl.searchAggregate()\"><i class=\"icon-search\"></i> </a><span class=\"aggregate-header-right2 dropdown\"><i data-toggle=\"dropdown\" class=\"icon-menu dropdown-toggle\"></i><ul class=\"dropdown-menu pull-right\" sc-ul><li><a ng-click=\"$ctrl.selectAll('select all')\"><i class=\"icon-check\"></i> {{::'Выделить все' | gettext }}</a></li><li><a ng-click=\"$ctrl.selectAll('deselect all')\"><i class=\"icon-check-empty\"></i> {{::'Снять выделение' | gettext }}</a></li><li ng-if=\"!$ctrl.filterBar.skipStat\" class=\"divider\"></li><li ng-if=\"!$ctrl.filterBar.skipStat\"><a ng-click=\"$ctrl.router.aggregateOrder = 'statDesc'\"><i class=\"icon-sort-alt-down\"></i> {{::'Больше событий' | gettext }}</a></li><li ng-if=\"!$ctrl.filterBar.skipStat\"><a ng-click=\"$ctrl.router.aggregateOrder = 'statAsc'\"><i class=\"icon-sort-alt-up\"></i> {{::'Меньше событий' | gettext }}</a></li><li class=\"divider\"></li><li><a ng-click=\"$ctrl.router.aggregateOrder = 'nameAsc'\"><i class=\"icon-sort-alt-up\"></i> {{::'По алфавиту возр.' | gettext }}</a></li><li><a ng-click=\"$ctrl.router.aggregateOrder = 'nameDesc'\"><i class=\"icon-sort-alt-down\"></i> {{::'По алфавиту убыв.' | gettext }}</a></li></ul></span></div><sc-hspinner ng-show=\"$ctrl.isLoading\"></sc-hspinner><div class=\"aggregate-container\" infinite-scrollfork=\"$ctrl.aggregate_more()\" infinite-scroll-distance=\"1\" infinite-scroll-disabled=\"!$ctrl.aggregate || $ctrl.aggregate.isComplete || $ctrl.AggregateDataService.loading || $ctrl.AggregateDataService.loadingMore\"><sc-filter-dimension-node></sc-filter-dimension-node></div><div class=\"pane-tab stat-pane-tab\"><ul class=\"filter-ops nav nav-pills\"><li ng-show=\"$ctrl.permission.showStatistics\" class=\"panel-tab pull-right\"><a ng-click=\"$ctrl.toggleSkipStat();\" title=\"{{::'Переключить режим отображения измерений' | gettext }}\"><i ng-class=\"{'icon-check-empty': $ctrl.filterBar.skipStat, 'icon-check': !$ctrl.filterBar.skipStat}\"></i> <span ng-if=\"$ctrl.panelWidth > 170\">{{::'Статистика' | gettext}}</span></a></li><li class=\"panel-tab pull-right\"><a ng-click=\"$ctrl.toggleAutoUpdate();\" title=\"{{::'Автообновление данных при изменении фильтра' | gettext }}\"><i ng-class=\"{'icon-check-empty': !$ctrl.CurrentFilterDataService.autoUpdate, 'icon-check': $ctrl.CurrentFilterDataService.autoUpdate}\"></i> <span ng-if=\"$ctrl.panelWidth > 170\">{{::'Авто' | gettext}}</span></a></li></ul></div></div>"

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterDimensionNodeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _iconClass = __webpack_require__(38);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {
//   AlertModalController
// } from './editor/alert-modal.component';

__webpack_require__(774);

var FilterDimensionNodeController = function () {
  function FilterDimensionNodeController($element, $timeout, $scope, CurrentFilterService, PermissionService, $rootScope, RouterService, FilterResource, $modal, AggregateDataService, CurrentModelService, StatusCheckerService, ErrorHandlerService) {
    var _this = this;

    _classCallCheck(this, FilterDimensionNodeController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.permission = PermissionService;
    this.currentFilter = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.filterBar = CurrentFilterService.filterBar;
    this.TYPE2CLASS = _iconClass.TYPE2CLASS;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.$modal = $modal;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.StatusCheckerService = StatusCheckerService;
    this.AggregateDataService.filterData$.subscribe(function () {
      _this.initDimensions();
    });
  }

  _createClass(FilterDimensionNodeController, [{
    key: 'initDimensions',
    value: function initDimensions() {
      // this.$timeout(() => {
      var dim = this.filterBar.drilldown[0];
      this.hasRules = this.isHasRules;
      this.isAssignSchedule = dim.indexOf('agent_agent@computer_name:computer_name') === 0 || dim.indexOf('agent_account@user_name:user_name') || dim.indexOf('agent_account@full_name:full_name') || dim.indexOf('agent_account@office:office');

      this.isAccountUserName = dim.indexOf('agent_account@user_name:user_name') === 0;
      this.isAccountFullName = dim.indexOf('agent_account@full_name:full_name') === 0;
      this.isAddToFilter = dim.indexOf('agent_application@app_name:app_name') != -1 || dim.indexOf('agent_web@site:site') != -1;

      this.isAgentComputerName = dim.indexOf('agent_agent@computer_name:computer_name') === 0;

      this.showProperties = dim.indexOf('agent_account@user_name:user_name') != -1 || dim.indexOf('agent_agent@computer_name:computer_name') != -1 || dim.indexOf('agent_account@office:office') != -1 || this.hasRules;

      this.isHasCard = this.hasCard();

      // }, 0);
    }
  }, {
    key: 'getAssignScheduleRef',
    value: function getAssignScheduleRef(cell) {
      return 'admin/work_calendar/weekscheduledimension/add/?dimension=' + this.filterBar.drilldown[0] + '&value=' + this.getCellLabel(cell);
    }
  }, {
    key: 'shadowWidth',
    value: function shadowWidth(cell) {
      if (!cell.record_count || !this.total.max) return '0';
      return cell.record_count / this.total.max * 100 + '%';
    }
  }, {
    key: 'hasData',
    value: function hasData() {
      return this.aggregate && this.aggregate.cells && this.aggregate.cells.length > 0;
    }

    // get isAddToFilter() {
    //   const dim = this.filterBar.drilldown[0];
    //   return dim.indexOf('agent_application@app_name:app_name') != -1 ||
    //     dim.indexOf('agent_web@site:site') != -1;
    // }

  }, {
    key: 'addToFilter',
    value: function addToFilter(cell) {
      this.router.changeCut(this.filterBar.drilldown[0], this.getCellLabel(cell), 'cut-edit');
    }
  }, {
    key: 'hasCellFilter',


    // get showProperties() {
    //   return this.filterBar.drilldown[0].indexOf('agent_account@user_name:user_name') != -1 ||
    //     this.filterBar.drilldown[0].indexOf('agent_agent@computer_name:computer_name') != -1 ||
    //     this.filterBar.drilldown[0].indexOf('agent_account@office:office') != -1 ||
    //     this.hasRules;
    // }

    value: function hasCellFilter(cell) {
      var filter = this.model.getCellFilter(this.filterBar.drilldown[0], cell);
      return this.filter.hasFilter(filter);
    }
  }, {
    key: 'getCellFilter',
    value: function getCellFilter(cell) {
      return this.model.getCellFilter(this.filterBar.drilldown[0], cell);
    }
  }, {
    key: 'getCellLabel',
    value: function getCellLabel(cell) {
      // return this.model.getCellLabel(this.filterBar.drilldown[0], cell);
      return cell.cellLabel;
    }
  }, {
    key: 'setCellFilter',
    value: function setCellFilter(cell) {
      var filter = this.getCellFilter(cell);
      this.filter.toggleFilter(filter);
      this.$scope.$root.$broadcast('dimensionToggle');
      this.currentFilter.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }, {
    key: 'hasCard',
    value: function hasCard() {
      var _this2 = this;

      return ['agent_agent', 'agent_account', 'agent_application', 'agent_web', 'agent_networkconnection', 'agent_attachedfile', 'agent_device', 'agent_dialog', 'agent_appinstallation', 'analytics_filter'].some(function (dim) {
        return _this2.filterBar.drilldown[0].startsWith(dim);
      });
    }
  }, {
    key: 'openCard',
    value: function openCard(cell) {
      var filter = this.getCellFilter(cell);
      this.router.openCard(filter);
    }
  }, {
    key: 'openRules',
    value: function openRules(cell) {
      var cutObj = this.getCellFilter(cell);
      this.router.changeCut(cutObj.dimension, cutObj.label, 'rules-edit');
    }
  }, {
    key: 'connectRemote',
    value: function connectRemote(cell, i) {
      if (this.menuItem == cell) {
        this.menuItem = null;
        return;
      }
      if (cell.remote && cell.remote.length === 1) this.connectRemoteUser(cell.remote[0]);else if (i >= 0) this.connectRemoteUser(cell.remote[i]);
    }
  }, {
    key: 'connectRemoteUser',
    value: function connectRemoteUser(user) {
      this.menuItem = null;
      if (user.sid) this.router.openFrame('/remote/?hwid=' + user.hwid + '/' + user.sid);else this.router.openFrame('/remote/?hwid=' + user.hwid);
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    }
  }, {
    key: 'isNameOrdered',
    get: function get() {
      return this.router.aggregateOrder === 'nameAsc' || this.router.aggregateOrder === 'nameDesc';
    }
  }, {
    key: 'aggregate',
    get: function get() {
      return this.AggregateDataService.aggregate;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.AggregateDataService.loading;
    }
  }, {
    key: 'isLoadingMore',
    get: function get() {
      return this.AggregateDataService.loadingMore;
    }
  }, {
    key: 'cells',
    get: function get() {
      return this.aggregate && this.aggregate.cells || [];
    }
  }, {
    key: 'total',
    get: function get() {
      return this.hasData() ? {
        cells: this.aggregate.cells.length,
        events: this.AggregateDataService.events.total,
        max: this.AggregateDataService.events.max
      } : {
        cells: 0,
        events: 0,
        max: 0
      };
    }
  }, {
    key: 'isHasRules',
    get: function get() {
      var dimArr = this.filterBar.drilldown[0].split('@');
      var dimName = dimArr[0];
      var dim = this.model.dimensions.find(function (dm) {
        return dm.name === dimName;
      });
      if (!dim) return false;
      var dimHierarchy = dimArr[1].split(':')[0];
      var hierarchy = dim.hierarchies.find(function (h) {
        return h.name === dimHierarchy;
      });
      if (!hierarchy) return false;
      return hierarchy.rule_groups.length > 0;
    }
  }]);

  return FilterDimensionNodeController;
}();

var FilterDimensionNodeComponent = exports.FilterDimensionNodeComponent = {
  template: __webpack_require__(775),
  controller: FilterDimensionNodeController
};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-list\" ng-if=\"!$ctrl.isLoading\"><li ng-repeat=\"cell in $ctrl.cells track by $index\" ng-if=\"!$ctrl.AggregateDataService.cancelled && $ctrl.hasData()\"><div class=\"dimension-list-item\"><div class=\"shadoved-strip\" ng-style=\"{'width': $ctrl.shadowWidth(cell)}\"></div><div class=\"dimension-item\"><div class=\"dimension-list-icons\"><i class=\"pointer\" ng-class=\"{'icon-check': $ctrl.hasCellFilter(cell), 'icon-check-empty': !$ctrl.hasCellFilter(cell)}\" ng-click=\"$ctrl.setCellFilter(cell)\"></i> <i class=\"{{$ctrl.TYPE2CLASS[cell['agent_eventtype.name']]}}\" ng-show=\"cell['agent_eventtype.name']\"></i> <i ng-show=\"cell['agent_agent.id']||cell['agent_account.user_name']\" ng-class=\"$ctrl.StatusCheckerService.check(cell)['cssClass']\" title=\"{{$ctrl.StatusCheckerService.check(cell)['text']}}\"></i></div><div class=\"dimension-list-label\" ng-class=\"{'first-letter': cell.isFirstLetter && $ctrl.isNameOrdered}\" ng-click=\"$ctrl.setCellFilter(cell)\" title=\"{{$ctrl.getCellLabel(cell)}}\">{{$ctrl.getCellLabel(cell)}}</div><div class=\"dimension-list-actions\"><span class=\"badge\">{{cell['record_count']}}</span> <i ng-click=\"$ctrl.openCard(cell)\" ng-show=\"$ctrl.isHasCard\" class=\"icon-stat\" style=\"color:gray\" title=\"{{::'Карточка измерения' | gettext }}\"></i><span class=\"dropdown menu-list\"><i ng-if=\"($ctrl.isAgentComputerName || $ctrl.isAccountUserName || $ctrl.isAccountFullName) &&\n                    ($ctrl.permission.remote_control || $ctrl.permission.remote_view)\" ng-click=\"$ctrl.connectRemote(cell, -1)\" ng-style=\"!!cell.remote && {'color':'green'}\" class=\"icon-desktop agg-action disable_remote_admin dropdown-toggle\" title=\"{{::'Удалённый рабочий стол' | gettext}}\"></i><ul ng-if=\"cell.remote.length > 1\" class=\"dropdown-menu pull-right\" sc-ul><li ng-repeat=\"rm in cell.remote  track by $index\"><a ng-click=\"$ctrl.connectRemote(cell, $index)\">{{rm.user}}</a></li></ul></span><span ng-if=\"$ctrl.permission.filterConstructor\" class=\"dropdown\"><i data-toggle=\"dropdown\" ng-if=\"$ctrl.permission.filterConstructor && $ctrl.showProperties\" class=\"icon-cogs dropdown-toggle\" style=\"color:gray\"></i><ul class=\"dropdown-menu pull-right\" sc-ul><li ng-show=\"$ctrl.isAccountUserName\"><a sc-xref=\"{{::'/admin/agent/account/' + cell['agent_account.id'] }}/\">{{::'Профиль пользователя' | gettext }}</a></li><li ng-show=\"$ctrl.isAgentComputerName && $ctrl.permission.groupSystemAdministrator\"><a ng-href=\"/agent/edit_config/?agent={{ cell['agent_agent.guid'] }}\" target=\"_top\">{{::'Конфигурация агента' | gettext}}</a></li><li ng-show=\"$ctrl.isAgentComputerName && $ctrl.permission.groupSystemAdministrator\"><a ng-href=\"admin/agent/agent/{{ cell['agent_agent.id'] }}/\" target=\"_top\">{{::'Профиль агента' | gettext}}</a></li><li ng-show=\"$ctrl.isAssignSchedule && $ctrl.permission.schedule\"><a sc-xref=\"{{$ctrl.getAssignScheduleRef(cell)}}\" target=\"_top\">{{::'Назначение расписания' | gettext}}</a></li><li ng-if=\"$ctrl.isAddToFilter\"><a ng-click=\"$ctrl.addToFilter(cell)\">{{::'Добавить в фильтр' | gettext }}</a></li><li ng-if=\"$ctrl.hasRules && $ctrl.permission.policies\"><a ng-click=\"$ctrl.openRules(cell)\">{{::'Редактирование правил' | gettext }}</a></li><li ng-show=\"$ctrl.isAccountUserName && $ctrl.permission.groupSystemAdministrator\"><a ng-href=\"/agent/edit_accountconfig/?account={{ cell['agent_account.id'] }}\">{{::'Конфигурация пользователя' | gettext}}</a></li></ul></span></div></div></div></li><li class=\"total\" ng-if=\"!$ctrl.AggregateDataService.cancelled && $ctrl.hasData() && !$ctrl.isLoadingMore\">{{::'Всего' | gettext}}:{{' '}}{{$ctrl.total.cells}} <span ng-if=\"!$ctrl.filterBar.skipStat\">,{{' '}}{{::'событий' | gettext}}:{{' '}}{{$ctrl.total.events}}</span></li><li class=\"text-center\" ng-if=\"!$ctrl.AggregateDataService.cancelled && !$ctrl.hasData()\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</li><li class=\"text-center\" ng-if=\"$ctrl.AggregateDataService.cancelled\">{{::'Загрузка прервана' | gettext}}</li><li class=\"text-center\" ng-if=\"$ctrl.AggregateDataService.error\">{{::'Ошибка загрузки' | gettext}}</li><li class=\"text-center spinner-container\" ng-if=\"$ctrl.isLoadingMore\"><sc-hspinner></sc-hspinner></li></ul>"

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterEditorModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterEditorModal = __webpack_require__(777);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterEditorModalService = exports.FilterEditorModalService = function () {
  function FilterEditorModalService($timeout, $modal, $window) {
    _classCallCheck(this, FilterEditorModalService);

    this.$timeout = $timeout;
    this.$modal = $modal;
    this.window = angular.element($window);
    this.window.bind('resize', this.updateModalSize);
  }

  _createClass(FilterEditorModalService, [{
    key: 'updateModalSize',
    value: function updateModalSize() {
      $('.modal-body1').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight() + 5);
      var baseheight = $('.modal-body1').height() - $('#myTab').height();
      $('.aggregate-modal').height(baseheight);
    }
  }, {
    key: 'open',
    value: function open(_model, _filter, _asNew, _tabName) {
      var _this = this;

      this.modalInstance = this.$modal.open({
        // backdrop: 'static',
        // keyboard: false,
        templateUrl: 'filterDialog.html',
        controller: _filterEditorModal.FilterEditorModalController,
        resolve: {
          asNew: function asNew() {
            return _asNew;
          },
          filter: function filter() {
            return _filter;
          },
          model: function model() {
            return _model;
          },
          tabName: function tabName() {
            return _tabName;
          }
        },
        windowClass: 'filterDialog filterDialogLarge'
      });

      this.modalInstance.opened.then(function () {
        _this.$timeout(function () {
          _this.updateModalSize();
        }, 100);
      }).catch(function (err) {
        console.error(err);
      });
      return this.modalInstance.result;
    }
  }]);

  return FilterEditorModalService;
}();

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterEditorModalController = undefined;

var _iconClass = __webpack_require__(38);

var _filter = __webpack_require__(28);

var _modals = __webpack_require__(69);

var _filterMode = __webpack_require__(88);

__webpack_require__(332);

var FilterEditorModalController = exports.FilterEditorModalController = function FilterEditorModalController($scope, $http, $modal, $timeout, $modalInstance, FilterResource, Aggregates, filter, CurrentFilterService, FilterDataFactory, CurrentModelService, model, asNew, globalAlert, ErrorHandlerService, StatusCheckerService, AlertModalService, RouterService, tabName) {
  var _this = this;

  $scope.AlertModalService = AlertModalService;
  $scope.testMail = true;
  $scope.notify2 = {};
  $scope.$timeout = $timeout;
  $scope.successSended = false;
  var jastOpened = true;
  $scope.model = model;
  $scope.$http = $http;
  $scope.ErrorHandlerService = ErrorHandlerService;
  $scope.CurrentFilterService = CurrentFilterService;
  $scope.RouterService = RouterService;
  this.CurrentModelService = CurrentModelService;
  $scope.visibleDimensions = model.dimensions;
  $scope.DIM2CLASS = _iconClass.DIM2CLASS;
  $scope.cube = model.cubes[0];
  $scope.filterAsText = {};
  $scope.awaiting = false;
  $scope.errorMessage = $scope.ErrorHandlerService.filterErrorMessage;
  $scope.errorMessage.filterUnchecked = false;
  $scope.errorMessage.notReload = true;
  $scope.ErrorHandlerService.notShowErrorMessageBox = true;
  $scope.filterBar = new _filter.Filter('DialogBar');
  $scope.filter = angular.copy(filter);
  $scope.filterData = FilterDataFactory(true);
  if (asNew) {
    delete $scope.filter.id;
    $scope.CurrentFilterService.setFilterName($scope.filter);
  }

  if ($scope.filter.isCardFilter && $scope.CurrentFilterService.filter.id === $scope.filter.id) $scope.filter.children = $scope.CurrentFilterService.filter.children;
  $scope.filterBar.skipStat = true;
  $scope.filterBar.limit = 100;
  $scope.serverPolicies = false;
  $scope.showDeleteButton = true;
  $scope.StatusChecker = StatusCheckerService;
  $scope.currentTab = tabName == 'QueryTab' ? 'filters' : 'prop';
  $scope.filterTab = tabName == 'QueryTab' ? 'query' : 'filter';

  $scope.setTab = function (tab) {
    $scope.currentTab = tab;
    $scope.$broadcast('changeTab');
  };

  $scope.getOriginalFilter = function (id) {
    if ($scope.originalFilter) return $scope.originalFilter;
    if (!id) id = $scope.filter.id;
    if (!id) return null;
    $scope.originalFilter = CurrentFilterService.FiltersService.findById(id);
    return $scope.originalFilter;
  };

  $scope.emailTemplete = {
    show: false
  };
  $scope.setTrueemailTemplete = function () {
    return $scope.emailTemplete.show = true;
  };

  $scope.isFilterChanged = function () {
    if (!$scope.filter.id) {
      $scope.filter.isChanged = true;
      return true;
    }
    $scope.filter.isChanged = false;
    var f = new _filter.Filter();
    $scope.filter.isChanged = !angular.equals($scope.getOriginalFilter(), $scope.filter);
    return $scope.filter.isChanged;
  };

  $scope.showApplyType = function () {
    return $scope.filter.content_type !== 'filter' && $scope.filter.content_type !== 'dashboard' && $scope.filter.content_type !== 'folder' && $scope.filter.content_type !== 'backupfilter';
  };
  var initApplyType = function initApplyType() {
    return $scope.filter.applyType = $scope.filter.id && !$scope.filter.applyType ? 'continue' : 'new';
  };

  if ($scope.showApplyType()) initApplyType();
  $scope.toggleDo_scan = function () {
    if ($scope.filter.do_scan) {
      $scope.filter.notify = false;
      $scope.filter.report_if_filter_data_exists = false;
    } else {
      if ($scope.showApplyType()) initApplyType();
    }
  };

  $scope.filterIcon = function () {
    return (0, _filterMode.getFilterIcon)($scope.filter);
  };

  $scope.filterHeader = function () {
    if (!$scope.filter.content_type) return $scope.filter.name;
    var type = $scope.CurrentFilterService.PermissionService.types[$scope.filter.content_type];
    return type && $scope.filter.name !== type.name ? type.name + ': ' + $scope.filter.name : '' + $scope.filter.name;
  };

  $scope.updateAsText = function () {
    var filtersText = $scope.filter.as_text();
    var queryText = $scope.filter.query ? JSON.stringify(JSON.parse(angular.toJson($scope.filter.query)), null, ' ') : '';

    $scope.filterAsText.code = filtersText + '\n' + queryText;
    if ($scope.errorMessage.sourse !== 'query-text') {
      $scope.findFilterError('query-filter');
    }
  };

  $scope.findFilterError = function (type) {
    $scope.errorMessage.sourse = type;
    if (!$scope.ErrorHandlerService.isWrongCuts($scope.filter.filters)) {
      $scope.errorMessage.text = $scope.filter.getFilterError();
      if (!$scope.errorMessage.text) $scope.errorMessage.text = _this.CurrentModelService.model.checkIsFilterCutsValueAllowed($scope.filter);
    }
    $scope.errorMessage.filterUnchecked = false;
  };

  $scope.$watch('filter', function () {
    $scope.updateAsText();
    if (jastOpened) jastOpened = false;else if ($scope.filter.isPolitic) $scope.filterData.update($scope.filter);
  }, true);

  var getNotJson = function getNotJson(text) {
    var regExp = /{[^{}]*}/gm;
    var prevText = void 0;
    do {
      prevText = text;
      text = prevText.replace(regExp, '');
    } while (text != prevText);
    return text;
  };

  var getJson = function getJson(text) {
    var i1 = -1;
    var counter = 0;
    for (var i = 0; i < text.length; i++) {
      if (text[i] === '{') {
        counter++;
        if (i1 === -1) i1 = i;
      } else if (text[i] === '}') {
        counter--;
        if (!counter && i > i1) return text.substring(i1, i + 1);
      }
    }
    return '';
  };

  $scope.updateFromText = function () {
    $scope.filter.from_text(getNotJson($scope.filterAsText.code));
    $scope.findFilterError('data-filter');
    queryAsTextChange();
  };

  $scope.onQueryTextCotFocus = function () {
    $scope.errorMessage.filterUnchecked = true;
    $scope.errorMessage.text = gettext('Для сохранения кода фильтра переместите фокус мышки из текстового редактора на любую другую часть формы');
  };

  var isValidQueryText = function isValidQueryText(text) {
    return !!text.match(/(?=.*\boperator\b)*(?=.*\brules\b)/);
  };

  var queryAsTextChange = function queryAsTextChange() {
    var textQuery = getJson($scope.filterAsText.code);
    if (!isValidQueryText(textQuery)) {
      textQuery = '{\n  "operator": "AND",\n  "rules": []\n }';
    }

    try {
      var query = JSON.parse(textQuery);
      if (!angular.equals($scope.filter.query, query)) $scope.filter.query = query;
    } catch (err) {
      $scope.errorMessage.text = err.message;
      $scope.errorMessage.sourse = 'query-text';
      console.error(err.message);
    }
  };

  $scope.openNodes = {};

  $scope.locLabel = _filter.Filter.locLabel;

  $scope.isNodeOpen = function (type, obj) {
    return $scope.openNodes[type] == obj;
  };

  $scope.closeNode = function (type, obj) {
    $scope.openNodes[type] = false;
  };

  $scope.switchNode = function (type, obj, $event) {
    if ($scope.isNodeOpen(type, obj)) $scope.closeNode(type, obj);else $scope.openNode(type, obj);
    if ($event) $event.stopPropagation();
  };

  $scope.openNode = function (type, obj) {
    $scope.closeNode(type, obj);
    $scope.openNodes[type] = obj;
  };

  $scope.cells = function () {
    return $scope.aggregate ? $scope.aggregate.cells : [];
  };

  $scope.loadAggregate = function (callback, resetCache) {
    var _this2 = this;

    if ($scope.aggregate) {
      $scope.aggregate.blocked = true;
    }
    if (resetCache) $scope.filterBar.page = 0;
    var canceler = null;
    $scope.filterBar.copyFrom($scope.filter, true);
    delete $scope.filterBar.timeFrom;
    delete $scope.filterBar.timeTo;
    $scope.drill = $scope.filterBar.drilldown[0];

    if ($scope.filter.content_type === 'backupfilter') {
      $scope.serverPolicies = true;
    }

    if (!$scope.filter.id || $scope.filter.id < 1000 || $scope.serverPolicies) {
      $scope.showDeleteButton = false;
    }

    if ($scope.aggregate && $scope.filterBar.page === 0) {
      $scope.aggregate = null;
    }
    $scope.drill = $scope.filterBar.drilldown[0];
    Aggregates.load($scope.cube.name, $scope.filterBar, resetCache, canceler).then(function (aggregate) {
      if (aggregate) {
        if (!$scope.aggregate || !$scope.filterBar.page) {
          $scope.aggregate = aggregate;
          $scope.aggregate.isComplete = false;
        } else {
          $scope.aggregate.isComplete = aggregate.cells.length == 0;
          aggregate.cells.forEach(function (cell) {
            $scope.aggregate.cells.push(cell);
          }, _this2);
        }
      }
      if ($scope.aggregate) {
        $scope.aggregate.blocked = false;
      }
      $scope.$broadcast('aggregateLoaded');
    }).catch(function (error) {
      ErrorHandlerService.handle(error);
    });
  };

  $scope.aggregate_more = function () {
    if (!$scope.filterBar) return;
    var blocked = $scope.aggregate ? $scope.aggregate.blocked : true;
    $scope.filterBar.page = blocked ? $scope.filterBar.page : $scope.filterBar.page + 1;
    if (!blocked) $scope.loadAggregate(function (error) {
      if (error) globalAlert(error.message);
    }, false);
  };

  $scope.searchAggregate = function (event) {
    if (event && event.keyCode != 13) return false;
    var keyword = angular.element('#aggregate-search-modal').val();
    $scope.filterBar.lookup = keyword;
    $scope.loadAggregate(function (error) {
      if (error) globalAlert(error.message);
    }, true);
  };

  $scope.loadAggregate(null, true);

  $scope.isAggregateLoading = function () {
    return !$scope.aggregate || $scope.aggregate.blocked;
  };

  $scope.hasData = function () {
    return $scope.aggregate && $scope.aggregate.cells && $scope.aggregate.cells.length > 0;
  };

  $scope.select = function (dim) {
    if (dim.dimension) {
      $scope.openNode('hierarhy', dim.toString());
      $scope.openNode('dimension', dim.dimension.toString());
    } else {
      $scope.openNode('dimension', dim.toString());
    }
    $scope.filterBar.setDrilldown(dim.toString());
    $scope.filterBar.setKeyword('');
    $scope.filterBar.page = 0;
    $scope.filterBar.lookup = null;
    $scope.loadAggregate();
  };

  $scope.$on('reload', function () {
    return $scope.loadAggregate(null, true);
  });

  $scope.hasCellFilter = function (drill, cell) {
    var filter = $scope.model.getCellFilter(drill, cell);
    return $scope.filter.hasFilter(filter);
  };

  $scope.focusName = function () {
    // if (!$scope.filter.saved) {
    //   $scope.filter.name = '';
    // }
  };

  $scope.cleanName = function () {
    $scope.filter.name = '';
  };

  $scope.invertFilter = function (f) {
    $scope.filter.invertFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.keyWordClick = function (keyWords) {
    if (!keyWords.trim()) {
      return;
    }
    var re = keyWords.match(/["'](.*)["']/);

    if (re) {
      $scope.filter.addKeyword(re[1]);
    } else {
      keyWords.split(' ').forEach(function (keyword) {
        $scope.filter.addKeyword(keyword);
      });
    }
    $scope.updateAsText();
  };

  $scope.removeFilter = function (f) {
    $scope.filter.removeFilter(f);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.setCellFilter = function (drill, cell) {
    var filter = $scope.model.getCellFilter(drill, cell);
    $scope.filter.toggleFilter(filter);
    $scope.updateAsText();
    $scope.findFilterError('data-filter');
  };

  $scope.selectAll = function () {
    if (!$scope.aggregate || !$scope.aggregate.cells) {
      return;
    }
    var drill = $scope.filterBar.drilldown[0];
    var cells = $scope.aggregate.cells;
    cells.forEach(function (cell) {
      var filter = $scope.model.getCellFilter(drill, cell);
      $scope.filter.toggleFilter(filter);
    });
    $scope.CurrentFilterService.rebuildVisibleDimensions();
    $scope.RouterService.filterChanged();
  };

  $scope.ok = function (testMail) {

    $scope.awaiting = true;
    if (testMail) {
      $scope.testMail = false;
      $scope.filter.testmail = true;
      if (!$scope.filter.emails) $scope.filter.emails = $scope.notify2.adminMail;
    } else {
      delete $scope.filter.testmail;
    }

    if (filter.switch_to && !filter.switch_to.accountConf && !filter.switch_to.agentConf) delete filter.switch_to;
    $scope.successSended = false;
    var errorStatus = '';
    var errorText = '';

    if ($scope.CurrentFilterService.iFrameParams) Object.assign($scope.filter, $scope.CurrentFilterService.iFrameParams);

    if ($scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter') {
      if (!angular.isNumber($scope.filter.timeout)) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Введите целое положительное число в поле "Задержка (часов)"');
      }
    }

    if ($scope.filter.content_type === 'ocrparser' && $scope.filter.action === 'abbyy') {
      if ($scope.filter.ocr_app_id == '' || $scope.filter.ocr_app_password == '') {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Укажите AppID и пароль');
      }
    }

    if ($scope.filter.content_type === 'corpusprocessfilter') {
      if (!$scope.filter.corpus_data) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Заполните словарь');
      }
    }

    if (filter.content_type === 'backupfilter') {
      if (!angular.isNumber($scope.filter.hdd_alarm_percentage) || !angular.isNumber($scope.filter.hdd_hard_percentage)) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Введите целое число');
      }
      if ($scope.filter.hdd_backup_path == '') {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Задайте путь резервного копирования');
      }
      if ($scope.filter.hdd_alarm_percentage < 0 || $scope.filter.hdd_hard_percentage < 0) {
        errorStatus = gettext('Ошибка');
        errorText = gettext('Значения должны быть больше нуля');
      }
    }

    if ($scope.filter.name == '') {
      errorStatus = gettext('Ошибка');
      errorText = gettext('Задайте имя фильтра');
    }

    if (testMail && errorText) {
      $scope.testMail = true;
    }

    if (errorText !== '' && errorStatus !== '') {
      $scope.awaiting = false;
      $scope.errorMessage.sourse = 'save-filter';
      $scope.errorMessage.text = errorText;

      // $scope.ErrorHandlerService.showErrorMessageBox(errorStatus, errorText);
      return;
    }

    if (asNew) {
      $scope.filter.id = 0;
    }

    if ($scope.filter.isCardFilter) {
      delete $scope.filter.cardFilter;
      delete $scope.filter.children;
    }
    if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);else FilterResource.save($scope.filter, function (status, data, error) {
      $scope.awaiting = false;
      if (error) {
        if (testMail) $scope.testMail = true;
        $scope.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка') + ': ' + status, data, null, true);
      } else {
        if (testMail) $scope.testMail = true;
        if (status === 200) {
          if (!testMail) {
            $scope.ErrorHandlerService.notShowErrorMessageBox = false;
            $modalInstance.close(data);
          } else {
            var originalFilter = $scope.getOriginalFilter(data.id);
            if (!originalFilter) {
              originalFilter = new _filter.Filter();
              Object.assign(originalFilter, data);
              CurrentFilterService.FiltersService.filters.push(originalFilter);
            } else {
              Object.keys(originalFilter).map(function (k) {
                return delete originalFilter[k];
              });
              Object.assign(originalFilter, data);
            }
            $scope.filter = data;
            if (filter.notify || filter.reporting_schedule_type) {
              $scope.successSended = true;
              $scope.$timeout(function () {
                return $scope.successSended = false;
              }, 3000);
            }
            // RouterService.selectFilter(data.id);
          }
        }
        if (status === 422) {
          if (data && '__all__' in data) $scope.errorMessage.text = data['__all__'][0];else if (data && data.corpus_data && data.corpus_data[0]) $scope.errorMessage.text = data.corpus_data[0];else $scope.errorMessage.text = gettext('Заполните необходимые поля.');
          $scope.errorMessage.sourse = 'save-filter';
          $scope.errors = data;
        }
      }
    });
  };

  $scope.cancel = function () {
    $scope.ErrorHandlerService.notShowErrorMessageBox = false;
    $modalInstance.dismiss('cancel');
    $scope.ErrorHandlerService.filterErrorMessage = {};
  };

  $scope.delete = function () {
    $modal.open({
      templateUrl: 'boolDialog.html',
      controller: _modals.boolDialogCtrl
    }).result.then(function (result) {
      $scope.awaiting = true;
      if (result) {
        $scope.filter.deleted = true;
        if ($scope.RouterService.isEditDasboard) $modalInstance.close($scope.filter);else return FilterResource.delete($scope.filter).then(function () {
          $scope.awaiting = false;
          $scope.ErrorHandlerService.notShowErrorMessageBox = false;
          $modalInstance.close($scope.filter);
        }).catch(function (error) {
          $scope.awaiting = false;
          globalAlert(error);
        });
      }
    }).catch(function (error) {
      $scope.awaiting = false;
      console.error(error);
    });
  };

  $scope.show = {
    notify: function notify() {
      return !$scope.filter.send_threshold;
    },
    threshold: function threshold() {
      return $scope.filter.send_threshold && $scope.filter.isAnalysis && !$scope.filter.isEventRiver;
    },
    sendPdf: function sendPdf() {
      return $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter';
    },
    sendOptions: function sendOptions() {
      return $scope.filter.content_type !== 'policy' && $scope.filter.content_type !== 'corpusprocessfilter';
    },
    notifyTab: function notifyTab() {
      return $scope.filter.content_type === 'filter' || $scope.filter.content_type === 'policy' || $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.isDashboard || $scope.filter.isCard || $scope.filter.content_type === 'filteraggregatealertfilter';
    },
    filtersTab: function filtersTab() {
      return !($scope.serverPolicies || $scope.filter.content_type === 'folder' || $scope.filter.content_type === 'mailgrabber' || $scope.filter.content_type === 'msgraphgrabber');
    },
    category: function category() {
      return $scope.filter.content_type === 'policy' || $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'letteryourself';
    },
    politicOptions: function politicOptions() {
      return $scope.filter.content_type !== 'mailgrabber' && $scope.filter.content_type !== 'msgraphgrabber' && $scope.filter.content_type !== 'filter' && $scope.filter.content_type !== 'dashboard' && $scope.filter.content_type !== 'folder' && $scope.filter.content_type !== 'filteraggregatealertfilter';
    },
    lateUploadFilter: function lateUploadFilter() {
      return $scope.filter.content_type === 'lateuploadfilter' || $scope.filter.content_type === 'inactiveagentfilter';
    },
    corpusprocessfilter: function corpusprocessfilter() {
      return $scope.filter.content_type === 'corpusprocessfilter';
    },
    incidentTab: function incidentTab() {
      return $scope.filter.content_type === 'corpusprocessfilter' || $scope.filter.content_type === 'policy';
    },
    backupfilter: function backupfilter() {
      return $scope.filter.content_type === 'backupfilter';
    },
    mailgrabber: function mailgrabber() {
      return $scope.filter.content_type === 'mailgrabber';
    },
    msgraphgrabber: function msgraphgrabber() {
      return $scope.filter.content_type === 'msgraphgrabber';
    },
    ocrparser: function ocrparser() {
      return $scope.filter.content_type === 'ocrparser';
    },
    emailTemplete: function emailTemplete() {
      return $scope.emailTemplete.show;
    },
    newEventsNotify: function newEventsNotify() {
      return !$scope.filter.isDashboard && !$scope.filter.isCard;
    },
    lens: function lens() {
      return ($scope.filter.content_type === 'filter' || $scope.filter.content_type === 'filteraggregatealertfilter') && !$scope.filter.isPolitic && !$scope.filter.isDashboard;
    }

  };

  $scope.updateAsText();
};

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(779);

var CatalogController = function CatalogController(CatalogNodeDragService, $element) {
  _classCallCheck(this, CatalogController);

  this.drag = CatalogNodeDragService;
};

var CatalogComponent = exports.CatalogComponent = {
  template: __webpack_require__(780),
  bindings: {
    model: '<',
    filter: '<',
    filters: '<'
  },
  controller: CatalogController,
  transclude: true
};

/***/ }),
/* 779 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<div class=\"catalog\"><div dnd-list dnd-effect-allowed=\"move\" dnd-drop=\"callback({ target: { list: $ctrl.filters, id: null}, targetIndex: index })\" dnd-dragover=\"$ctrl.drag.dragoverCallback(event, $ctrl.filters, index, callback)\"><div ng-repeat=\"filter in $ctrl.filters\" class=\"filter-node\"><dnd-nodrag><sc-catalog-node dnd-draggable=\"null\" dnd-dragstart=\"$ctrl.drag.dragStart($index, $ctrl.filters)\" dnd-callback=\"$ctrl.drag.onDrop($ctrl.filters, $index, target, targetIndex)\" model=\"$ctrl.model\" filter=\"filter\"></sc-catalog-node><dnd-nodrag></dnd-nodrag></dnd-nodrag></div><li class=\"dndPlaceholder\"></li></div></div>"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogNodeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterMode = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(782);

var CatalogNodeController = function () {
  function CatalogNodeController($q, $scope, FilterEditorService, FilterCardEditorModalService, PermissionService, RouterService, LayoutService, CatalogNodeDragService, CurrentFilterService, FilterResource) {
    _classCallCheck(this, CatalogNodeController);

    this.$q = $q;
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.FilterResource = FilterResource;
    // this.filterProps = {};
  }

  _createClass(CatalogNodeController, [{
    key: 'count',
    value: function count(propName) {

      return this.filter ? this.filter.count(propName) : 0;
    }
  }, {
    key: 'hasProp',
    value: function hasProp(propName) {
      return this.filter.hasProp(propName);
    }
  }, {
    key: 'setFilterProps',
    value: function setFilterProps() {
      for (var p in this.filterProps) {
        this.filterProps[p].value = this.filterProps[p].count ? this.filter.count(p) : this.filter.hasProp(p);
      }
    }
  }, {
    key: 'selectFilter',
    value: function selectFilter() {
      var _this = this;

      if (this.filter.content_type === 'folder') this.toggleNode();
      if (this.filter.isPolitic && !this.filter.isAnalyticPolitic && !this.filter.isDashboard && !this.filter.isCard && this.permission.policies) {
        this.editFilter();
        return;
      }

      this.router.selectFilter(this.filter.id);

      var resetCount = true;
      if (this.filter.facts_count && resetCount) {
        this.FilterResource.save(this.filter).then(function () {
          _this.filter.facts_count = 0;
        }).catch(function (error) {
          console.error(!error);
        });
      }

      this.showReport = true;
    }
  }, {
    key: 'toggleNode',
    value: function toggleNode() {
      this.showReport = !this.showReport;
    }
  }, {
    key: 'needToShowFilter1',
    value: function needToShowFilter1(filter) {
      return false;
    }
  }, {
    key: 'needToShowFilter',
    value: function needToShowFilter(filter) {

      if (!this.layout.searchedFilters.all) {
        if (this.layout.searchedFilters[filter.id]) {
          this.showReport = true;
          return true;
        } else return false;
      }
      return true;
    }
  }, {
    key: 'editFilter',
    value: function editFilter() {
      return this.FilterEditorService.editModal({
        filter: this.filter,
        asNew: false,
        selectFilter: false
      });
    }
  }, {
    key: 'initiated',
    get: function get() {
      return window.status === 'INIT_COMPLETE';
    }
  }, {
    key: 'showReport',
    get: function get() {
      if (this.layout.openedFilters.all && !this.layout.openedFilters[this.filter.id]) this.layout.openedFilters[this.filter.id] = true;
      return this.layout.openedFilters[this.filter.id];
    },
    set: function set(val) {
      if (!val) this.layout.openedFilters.all = false;
      this.layout.openedFilters[this.filter.id] = val;
    }
  }, {
    key: 'isActive',
    get: function get() {
      return this.CurrentFilterService.filter && this.CurrentFilterService.filter.id === this.filter.id;
    }
  }, {
    key: 'isEditCatalog',
    get: function get() {
      return this.layout.editCatalog;
    }
  }, {
    key: 'filterIcon',
    get: function get() {
      return (0, _filterMode.getFilterIcon)(this.filter);
    }
  }, {
    key: 'folderIcon',
    get: function get() {
      if (this.filter.content_type === 'folder') {
        if (this.showReport) return 'icon-folder-open-empty';else return 'icon-folder-empty';
      }
      if (this.showReport) return 'icon-folder-open-empty';else return this.filterIcon;
    }
  }]);

  return CatalogNodeController;
}();

var CatalogNodeComponent = exports.CatalogNodeComponent = {
  template: __webpack_require__(783),
  // require: {
  //   parentNode: '^scCatalogNode'
  // },
  // replace: true,
  bindings: {
    index: '<',
    model: '<',
    filter: '<'
    // parentFilter: '<',
    // parentScope: '<',
    // filterBar: '<',
  },
  controller: CatalogNodeController
};

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

module.exports = "<div class=\"catalog-node\" ng-if=\"$ctrl.needToShowFilter($ctrl.filter)\"><div id=\"{{$ctrl.filter.id}}\" class=\"catalog-node-header catalog-normal\" iscontainer=\"{{$ctrl.filter.isContainer? 'true': 'false' }}\" class=\"lines\" ng-click=\"$ctrl.selectFilter()\"><div ng-class=\"{'parent': $ctrl.filter.children.length,\n                    'child': !$ctrl.filter.children.length,\n                    'active': $ctrl.isActive}\"><i ng-if=\"$ctrl.isEditCatalog\" title=\"{{:: 'Перетаскивание' | gettext }}\" dnd-handle class=\"icon icon-move drag-handle\"></i> <i class=\"icon\" ng-click=\"$ctrl.toggleNode(); $event.stopPropagation();\" ng-class=\"$ctrl.folderIcon\" ng-if=\"$ctrl.filter.children.length\"></i> <i ng-if=\"!$ctrl.filter.children.length\" class=\"child-icon\" ng-class=\"$ctrl.filterIcon\"></i> <span class=\"filterName\">{{$ctrl.filter.name}}</span> <span ng-if=\"$ctrl.count('facts_count')\" class=\"badge badge-important\">{{$ctrl.count('facts_count')}} </span><i ng-if=\"($ctrl.permission.filterConstructor || $ctrl.filter.isAnalyticPolitic)\n                && $ctrl.permission.policies && $ctrl.isActive\" style=\"padding-right:5px\" class=\"icon-cog\" ng-click=\"$ctrl.editFilter(filter); $event.stopPropagation();\" title=\"{{:: 'Свойства фильтра' | gettext }}\"></i> <span ng-if=\"$ctrl.isEditCatalog\" title=\"{{:: 'Отправка оповещения' | gettext }}\" style=\"right:30px\" class=\"table-col\"><i ng-if=\"$ctrl.hasProp('notify')\" class=\"icon-megaphone\" alt=\"notify\"></i> <i ng-if=\"!$ctrl.hasProp('notify') && $ctrl.hasProp('reporting_schedule_type')\" title=\"Отправка PDF-отчёта.\" class=\"icon-mail-1\" alt=\"notify\"></i> </span><span ng-if=\"$ctrl.isEditCatalog\" title=\"{{:: 'Действия над фактами' | gettext }}\" style=\"right:60px\" class=\"table-col\"><i ng-if=\"$ctrl.hasProp('do_scan')\" class=\"icon-tools\" alt=\"facts\"></i></span></div></div><div ng-if=\"$ctrl.showReport &&  $ctrl.filter.children\" dnd-list dnd-effect-allowed=\"move\" dnd-drop=\"callback({target:{list: $ctrl.filter.children, id: $ctrl.filter.id }, targetIndex: index})\" dnd-dragover=\"$ctrl.drag.dragoverCallback(event, $ctrl.filter.children, index, callback)\"><div ng-repeat=\"filter in $ctrl.filter.children\" class=\"filter-node\"><dnd-nodrag><sc-catalog-node dnd-draggable=\"null\" dnd-dragstart=\"$ctrl.drag.dragStart($index, $ctrl.filter.children)\" dnd-callback=\"$ctrl.drag.onDrop($ctrl.filter.children, $index, target, targetIndex)\" index=\"$index\" model=\"$ctrl.model\" filter=\"filter\"></sc-catalog-node></dnd-nodrag></div><li class=\"dndPlaceholder\"></li></div></div>"

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(785);

var CatalogSearchController = function () {
  function CatalogSearchController(CurrentFilterService, LayoutService, CatalogNodeDragService) {
    _classCallCheck(this, CatalogSearchController);

    // this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.currentFilter = CurrentFilterService;
    // this.value = '';
    this.previousValue = '-';
    this.searchFilters();
  }

  _createClass(CatalogSearchController, [{
    key: 'searchKeyup',
    value: function searchKeyup(event) {
      if (event.keyCode === 13) {
        this.searchFilters();
      }
    }
  }, {
    key: 'searchClean',
    value: function searchClean() {
      this.layout.searchTrim = '';
      this.searchFilters();
    }
  }, {
    key: 'searchFilters',
    value: function searchFilters() {
      var _this = this;

      if (this.layout.searchTrim === this.previousValue) return;
      this.previousValue = this.layout.searchTrim;
      if (this.layout.searchTrim) {
        this.layout.searchedFilters = this.currentFilter.FiltersService.searchFilters(function (f) {
          return f.name.toLowerCase().indexOf(_this.layout.searchTrim.toLowerCase()) !== -1 || f.emails && f.emails.toLowerCase().indexOf(_this.layout.searchTrim.toLowerCase()) !== -1;
        });
      } else this.layout.searchedFilters = this.currentFilter.FiltersService.searchFilters();
    }
  }]);

  return CatalogSearchController;
}();

var CatalogSearchComponent = exports.CatalogSearchComponent = {
  template: __webpack_require__(786),
  bindings: {},
  controller: CatalogSearchController
};

/***/ }),
/* 785 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<i class=\"icon-filter\"></i> <input class=\"search-input\" type=\"text\" ng-change=\"$ctrl.searchFilters()\" placeholder=\"{{:: 'Поиск - имя фильтра или эл.почта' | gettext }}\" ng-model=\"$ctrl.layout.searchTrim\"><div class=\"clear-buttom\"><button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"$ctrl.searchClean()\">&times;</button></div>"

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.FilterSearchComponent = FilterSearchComponent;

var _iconClass = __webpack_require__(38);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterSearchController = function () {
  function FilterSearchController($scope, CurrentFilterService, AggregateDataService, CurrentModelService, RouterService) {
    _classCallCheck(this, FilterSearchController);

    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.value = '';
    this.previousValue = this.value;
    // this.title = gettext('Поиск - Ключевые слова');
    // this.titleCatalog = gettext('Поиск - Имя фильтра');
  }

  _createClass(FilterSearchController, [{
    key: 'searchKeyup',
    value: function searchKeyup(event) {
      if (event.keyCode !== 13) {
        return;
      }

      return this.search();
    }
  }, {
    key: 'searchClean',
    value: function searchClean() {
      this.value = '';
      this.search();
    }

    // searchFilters() {
    //   if (this.value === this.previousValue) return;
    //   this.previousValue = this.value;
    //   if (this.value) {
    //     this.currentFilter.FiltersService.searchFilters(f =>
    //       f.name.toLowerCase().indexOf(this.value.toLowerCase()) !== -1
    //     );
    //   } else this.currentFilter.FiltersService.searchFilters();
    //
    // }

  }, {
    key: 'search',
    value: function search() {
      var _this = this;

      // if (this.panel === 'catalog') return this.searchFilters();
      if (this.router.isFilterEditModal) {
        this.$scope.runClick({
          keyWord: this.value
        });
        // this.$scope.runClick(this.value);
      } else {
        var keywords = this.value;
        if (!keywords.trim()) {
          return;
        }
        var re = keywords.match(/["'](.*)["']/);
        if (re) {
          this.router.addKeyword(re[1]);
        } else {
          keywords.split(' ').forEach(function (keyword) {
            _this.router.addKeyword(keyword);
          });
        }
      }
      this.value = '';
    }
  }, {
    key: 'panel',
    get: function get() {
      return this.currentFilter.panel;
    },
    set: function set(panel) {
      this.currentFilter.panel = panel;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    },
    set: function set(filter) {
      this.currentFilter.filter = filter;
    }
  }]);

  return FilterSearchController;
}();

function FilterSearchComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(788),
    // scope: true,
    scope: {
      runClick: '&'
    },
    controller: FilterSearchController,
    controllerAs: '$ctrl'
  };
}

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "<span class=\"aggregate-header-left lead\"><i class=\"icon-filter\"></i>&nbsp; </span><span class=\"dimensions-header-center\"><input type=\"text\" class=\"search-keyword\" ng-keyup=\"$ctrl.searchKeyup($event)\" ng-model=\"$ctrl.value\" placeholder=\"{{:: 'Поиск - Ключевые слова' | gettext }}\"> </span><span class=\"ztop add-on dimensions-header-right\"><a title=\"{{:: 'Полнотекстовый поиск' | gettext }}\"><i class=\"icon-search\" ng-click=\"$ctrl.search()\"></i> </a></span>"

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.FilterDimensionsComponent = FilterDimensionsComponent;

var _iconClass = __webpack_require__(38);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(790);

var FilterDimensionsController = function () {
  function FilterDimensionsController($scope, CurrentFilterService, AggregateDataService, CurrentModelService, $rootScope, RouterService, ErrorHandlerService, FilterResource) {
    var _this = this;

    _classCallCheck(this, FilterDimensionsController);

    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.router = RouterService;
    this.FilterResource = FilterResource;
    this.ErrorHandlerService = ErrorHandlerService;

    this.openNodes = {};

    $scope.$on('aggregateLoaded', function () {
      _this.currentFilter.rebuildVisibleDimensions();
    });
    $scope.$watch('$ctrl.model', function () {
      _this.currentFilter.rebuildVisibleDimensions();
    });
    $scope.$watch('$ctrl.filter', function () {
      _this.currentFilter.rebuildVisibleDimensions();
    });
    $scope.$watch('$ctrl.dim', function () {
      _this.updateDim();
    });
    $scope.$watch('$ctrl.model', function () {
      _this.updateDim();
    });
  }

  _createClass(FilterDimensionsController, [{
    key: 'cleanCuts',
    value: function cleanCuts(dim) {
      if (!this.filter || !this.filter.filters) return;
      this.filter.filters = this.filter.filters.filter(function (cut) {
        return !dim.toString().startsWith(cut.dimension.split('@')[0]);
      });
      this.currentFilter.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }, {
    key: 'cleanHie',
    value: function cleanHie(dim) {
      if (!this.filter || !this.filter.filters) return;
      this.filter.filters = this.filter.filters.filter(function (cut) {
        return cut.dimension !== dim.toString();
      });
      this.currentFilter.rebuildVisibleDimensions();
      this.router.filterChanged();
    }
  }, {
    key: 'updateDim',
    value: function updateDim() {
      if (!this.model || !this.dim) {
        return;
      }
      var hie = this.model.getHierarchy(this.dim);
      if (hie.dimension) {
        this.openNode('hierarhy', hie.toString());
        this.openNode('dimension', hie.dimension.toString());
      } else {
        this.openNode('dimension', hie.toString());
      }
    }
  }, {
    key: 'closeNode',
    value: function closeNode(type, obj) {
      this.openNodes[type] = false;
    }
  }, {
    key: 'openNode',
    value: function openNode(type, obj) {
      this.closeNode(type, obj);
      this.openNodes[type] = obj;
    }
  }, {
    key: 'isNodeOpen',
    value: function isNodeOpen(type, obj) {
      return this.openNodes[type] === obj;
    }
  }, {
    key: 'select',
    value: function select(dim) {
      this.router.barDim = dim.toString();
    }
  }, {
    key: 'cutsForDim',
    value: function cutsForDim(dim) {
      return this.filter && this.filter.filters.filter(function (cut) {
        return dim.toString().startsWith(cut.dimension.split('@')[0]);
      });
    }
  }, {
    key: 'cutsForHie',
    value: function cutsForHie(dim) {
      return this.filter && this.filter.filters.filter(function (cut) {
        return cut.dimension === dim.toString();
      });
    }
  }, {
    key: 'panel',
    get: function get() {
      return this.currentFilter.panel;
    },
    set: function set(panel) {
      this.currentFilter.panel = panel;
    }
  }, {
    key: 'visibleDimensions',
    get: function get() {
      return this.currentFilter.visibleDimensions;
    }
  }, {
    key: 'filter',
    set: function set(filter) {
      this.currentFilter.filter = filter;
    },
    get: function get() {
      return this.currentFilter.filter;
    }
  }]);

  return FilterDimensionsController;
}();

function FilterDimensionsComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(791),
    scope: true,
    controller: FilterDimensionsController,
    controllerAs: '$ctrl',
    bindToController: {
      dim: '<',
      model: '<'
    }
  };
}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-list panel-dark\"><li ng-repeat=\"dim in $ctrl.visibleDimensions\" ng-class=\"{'active': $ctrl.filterBar.drilldown[0].startsWith(dim.name)}\"><a ng-click=\"$ctrl.select(dim)\"><i ng-if=\"!dim.is_flat\" ng-class=\"{'icon-plus-1': !$ctrl.isNodeOpen('dimension', dim.toString()),\n        'icon-check-1': $ctrl.isNodeOpen('dimension',dim.toString())}\"></i> <i ng-if=\"dim.is_flat\" ng-class=\"$ctrl.DIM2CLASS[dim.name]\"></i> <span>&nbsp;{{ dim.label }}</span> <span ng-if=\"$ctrl.cutsForDim(dim).length\" ng-click=\"$ctrl.cleanCuts(dim)\" class=\"badge badge-info\" title=\"{{:: 'Очистить фильтр' | gettext}}\"><span>{{ $ctrl.cutsForDim(dim).length }} </span><span class=\"filter-right-menu\">&nbsp;×</span></span></a><ul class=\"nav nav-list\" ng-if=\"$ctrl.isNodeOpen('dimension', dim.toString())\"><li ng-repeat=\"hie in dim.hierarchies\" ng-class=\"{'active': $ctrl.filterBar.drilldown[0] === hie.toString()}\"><a ng-if=\"!dim.is_flat\" ng-click=\"$ctrl.select(hie)\">&nbsp;&nbsp;&nbsp;&nbsp; <i ng-class=\"$ctrl.DIM2CLASS[dim.name]\"></i> <span>&nbsp;{{ hie.label }}</span> <i ng-if=\"$ctrl.filterBar.drilldown[0] === hie.toString()\" class=\"icon-check-1\"></i> <span ng-if=\"$ctrl.cutsForHie(hie).length\" class=\"badge badge-info\" ng-click=\"$ctrl.cleanHie(hie)\" title=\"{{:: 'Очистить фильтр' | gettext}}\"><span>{{ $ctrl.cutsForHie(hie).length }} </span><span class=\"filter-right-menu\">&nbsp;×</span></span></a></li></ul></li></ul>"

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterDrillDownDraggableComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _measure = __webpack_require__(39);

var _iconClass = __webpack_require__(38);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(793);

var FilterDrillDownDraggableController = function () {
  function FilterDrillDownDraggableController($scope, CurrentFilterService, RouterService, CurrentModelService) {
    _classCallCheck(this, FilterDrillDownDraggableController);

    this.$scope = $scope;
    this.getMeasure = _measure.Measure.getMeasure;
    this.getMeasureLabel = _measure.Measure.getMeasureLabel;
    this.getMeasures = _measure.Measure.getMeasures;
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.CurrentFilterService.rebuildVisibleDimensions();
  }

  _createClass(FilterDrillDownDraggableController, [{
    key: 'selectDim',
    value: function selectDim(dim) {
      if (this.router.isFilterEditModal) {
        if (this.filter.hasDrilldown(dim.toString())) {
          return;
        }
        this.filter.addDrilldown(dim.toString());
        // this.filter.changed();
        this.$onChanges(this);
      } else this.router.selectDim(dim);
    }
  }, {
    key: 'setMeasure',
    value: function setMeasure(measure) {
      if (this.router.isFilterEditModal) this.filter.measure = measure;else this.router.setMeasure(measure);
    }
  }, {
    key: 'removeDim',
    value: function removeDim(dim) {
      if (this.router.isFilterEditModal) {

        if (!this.filter.hasDrilldown(dim.toString())) {
          return;
        }
        this.filter.removeDrilldown(dim.toString());
        this.$onChanges(this);
        // this.filter.changed();
        // this.filterChanged();
      } else this.router.removeDim(dim);
    }
  }, {
    key: 'toggleSortDirs',


    // toggleSortDrillSorterOrder(drill) {
    //   const filter = this.filterData.filter;
    //   if (!filter.orders || !filter.orderDirs) {
    //     filter.orders = [];
    //     filter.orderDirs = [];
    //   }
    //   if (!filter.hasOwnProperty('orders')) {
    //     filter.orders = angular.copy(filter.orders);
    //   }
    //   if (!filter.hasOwnProperty('orderDirs')) {
    //     filter.orderDirs = angular.copy(filter.orderDirs);
    //   }
    //
    //   const columnName = this.getOrderColumnName(drill);
    //   if (!filter.orders.includes(columnName)) {
    //     filter.orders.push(columnName);
    //     filter.orderDirs.push(columnName.split(',').map(o => 'asc').join(','));
    //     // filter.orderDirs.push('asc');
    //   } else {
    //     const sortIndex = this.getOrderDirIndex(drill);
    //     const sortDir = this.getSortDir(drill);
    //     if (sortDir === 'desc') {
    //       filter.orders.splice(sortIndex, 1);
    //       filter.orderDirs.splice(sortIndex, 1);
    //     } else {
    //       filter.orderDirs[sortIndex] = 'desc';
    //     }
    //   }
    //   filter.orders = angular.copy(filter.orders);
    //   filter.orderDirs = angular.copy(filter.orderDirs);
    //
    //   if (this.router.isFilterEditModal) this.filterData.update(filter);
    //   else this.router.filter = filter;
    // }

    value: function toggleSortDirs(columnName) {
      var colOrders = columnName.split(',');
      var filter = this.filterData.filter;

      var _loop = function _loop(i) {
        var j = 0;
        if (colOrders.every(function (o) {
          var res = o === filter.orders[i + j];
          j++;
          return res;
        })) {
          var dir = filter.orderDirs[i];
          if (dir === 'asc') {
            colOrders.map(function (o, j) {
              return filter.orderDirs[i + j] = 'desc';
            });
          } else {
            filter.orders.splice(i, colOrders.length);
            filter.orderDirs.splice(i, colOrders.length);
          }
        }
      };

      for (var i = 0; i < filter.orders.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: 'toggleSortDrillSorterOrder',
    value: function toggleSortDrillSorterOrder(drill) {
      var filter = this.filterData.filter;
      if (!filter.orders || !filter.orderDirs) {
        filter.orders = [];
        filter.orderDirs = [];
      }
      if (!filter.hasOwnProperty('orders')) {
        filter.orders = angular.copy(filter.orders);
      }
      if (!filter.hasOwnProperty('orderDirs')) {
        filter.orderDirs = angular.copy(filter.orderDirs);
      }

      var columnName = this.getOrderColumnName(drill);
      if (filter.orders.join(',').indexOf(columnName) === -1) {
        filter.orders = filter.orders.concat(columnName.split(','));
        filter.orderDirs = filter.orderDirs.concat(columnName.split(',').map(function (o) {
          return 'asc';
        }));
      } else {
        this.toggleSortDirs(columnName);
      }
      filter.orders = angular.copy(filter.orders);
      filter.orderDirs = angular.copy(filter.orderDirs);

      if (this.router.isFilterEditModal) this.filterData.update(filter);
      this.router.filter = filter;
    }
  }, {
    key: 'toggleSortMeasureSorterOrder',
    value: function toggleSortMeasureSorterOrder() {
      var filter = this.filterData.filter;
      if (!filter.hasOwnProperty('orders')) {
        filter.orders = angular.copy(filter.orders);
      }
      if (!filter.hasOwnProperty('orderDirs')) {
        filter.orderDirs = angular.copy(filter.orderDirs);
      }

      var columnName = 'measure';
      if (!filter.orders.includes(columnName)) {
        filter.orders.push(columnName);
        filter.orderDirs.push('asc');
      } else {
        var sortIndex = this.getMeasureOrderDirIndex();
        var sortDir = this.getMeasureSortDir();
        if (sortDir === 'desc') {
          filter.orders.splice(sortIndex, 1);
          filter.orderDirs.splice(sortIndex, 1);
        } else {
          filter.orderDirs[sortIndex] = 'desc';
        }
      }
      filter.orders = angular.copy(filter.orders);
      filter.orderDirs = angular.copy(filter.orderDirs);

      if (this.router.isFilterEditModal) this.filterData.update(filter);else this.router.filter = filter;
    }

    // isSortable(drill) {
    //   const columnName = this.getOrderColumnName(drill);
    //   const filter = this.filterData.filter;
    //   return filter.orders && filter.orders.includes(columnName);
    // }

  }, {
    key: 'isSortable',
    value: function isSortable(drill) {
      var columnName = this.getOrderColumnName(drill);
      var filter = this.filterData.filter;
      return filter.orders && filter.orders.join(',').includes(columnName);
    }
  }, {
    key: 'isMesureSortable',
    value: function isMesureSortable() {
      var filter = this.filterData.filter;
      var columnName = 'measure';
      if (!filter) {
        return false;
      }
      return filter.orders && filter.orders.includes(columnName);
    }
  }, {
    key: 'getSortDir',
    value: function getSortDir(drill) {
      var sortIndex = this.getOrderDirIndex(drill);
      return this.filterData.filter.orderDirs[sortIndex];
    }
  }, {
    key: 'getMeasureSortDir',
    value: function getMeasureSortDir() {
      var sortIndex = this.getMeasureOrderDirIndex();
      if (sortIndex === -1) {
        return null;
      }
      return this.filterData.filter.orderDirs[sortIndex];
    }

    // getOrderDirIndex(drill) {
    //   const filter = this.filterData.filter;
    //   const columnName = this.getOrderColumnName(drill);
    //   const sortIndex = filter.orders.findIndex(e => e === columnName);
    //   return sortIndex;
    // }

  }, {
    key: 'getOrderDirIndex',
    value: function getOrderDirIndex(drill) {
      var filter = this.filterData.filter;
      var columnOrders = this.getOrderColumnName(drill).split(',');

      var sortIndex = filter.orders.findIndex(function (e, i) {
        return columnOrders.every(function (o, j) {
          return filter.orders[i + j] === columnOrders[j];
        });
      });
      return sortIndex;
    }
  }, {
    key: 'getMeasureOrderDirIndex',
    value: function getMeasureOrderDirIndex() {
      var filter = this.filterData.filter;
      var columnName = 'measure';
      if (!filter) {
        return -1;
      }
      var sortIndex = filter.orders.findIndex(function (e) {
        return e === columnName;
      });
      return sortIndex;
    }
  }, {
    key: 'getOrderColumnName',
    value: function getOrderColumnName(drill) {
      var dimension = this.CurrentModelService.model.getDimensionParts(drill);
      if (dimension.hierarchy.name === 'ym' || dimension.hierarchy.name === 'ymd' || dimension.hierarchy.name === 'ymdh' || dimension.hierarchy.name === 'ymdhm') return dimension.hierarchy.levels.map(function (l) {
        return dimension.dimension.name + '.' + l;
      }).join(',');
      return dimension.dimension.name + '.' + dimension.level.label_attribute;
    }
  }, {
    key: 'dropMove',
    value: function dropMove(index) {
      var _filter$drilldown;

      this.$scope.list.splice(index, 1);
      var filter = this.filter;
      filter.drilldown = [];
      var newDrills = this.$scope.list.filter(function (item) {
        return item.isDrill;
      }).map(function (item) {
        return item.key;
      });
      (_filter$drilldown = filter.drilldown).splice.apply(_filter$drilldown, [0, filter.drilldown.length].concat(_toConsumableArray(newDrills)));
      if (this.router.isFilterEditModal) this.filterData.update(filter);else this.router.filter = filter;
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      var _this = this;

      var currentValue = this.router.isFilterEditModal ? this.filter : changesObj.filter.currentValue;
      if (changesObj.filter && currentValue) {

        var newDrillsList = currentValue.drilldown.slice().map(function (item) {
          return {
            key: item,
            label: _this.model.getDrillLabel(item),
            isDrill: true
          };
        });
        var staticItems = [{
          isDrill: false
        }, {
          isDrill: false
        }];
        this.$scope.list = staticItems.concat(newDrillsList);
      }
    }
  }, {
    key: 'showRemove',
    get: function get() {
      var drillList = this.$scope.list.filter(function (item) {
        return item.isDrill;
      });
      return drillList && drillList.length > 1;
    }
  }, {
    key: 'test',
    get: function get() {
      // console.log(this);
      return true;
    }
  }, {
    key: 'visibleDimensions',
    get: function get() {
      return this.CurrentFilterService.visibleDimensions;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }]);

  return FilterDrillDownDraggableController;
}();

var FilterDrillDownDraggableComponent = exports.FilterDrillDownDraggableComponent = {
  template: __webpack_require__(794),
  bindings: {
    filter: '<',
    filterData: '<'
  },
  scope: {
    list: []
  },
  controller: FilterDrillDownDraggableController
};

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<ul dnd-list=\"list\" dnd-moved=\"$ctrl.dropMove(index)\" dnd-effect-allowed=\"move\" dnd-horizontal-list=\"true\" class=\"menu-list nav nav-tabs overflow drilldown\"><li class=\"dropdown\"><div class=\"measure-sorted\"><div class=\"dropdown-toggle\"><span><b>{{ $ctrl.getMeasureLabel( $ctrl.filter.measure ) }}</b></span> <i class=\"icon-down-dir\"></i></div><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"measure in $ctrl.getMeasures()\"><a ng-click=\"$ctrl.setMeasure( measure )\">{{ $ctrl.getMeasureLabel(measure) }}</a></li></ul><i class=\"pointer sorted\" ng-class=\"{'icon-sort-alt-down': $ctrl.getMeasureSortDir() === 'desc', 'icon-sort-alt-up': $ctrl.getMeasureSortDir() === 'asc', 'icon-resize-vertical': !$ctrl.isMesureSortable() }\" ng-click=\"$ctrl.toggleSortMeasureSorterOrder()\"></i> <span class=\"badge\" ng-click=\"$ctrl.toggleSortMeasureSorterOrder()\" ng-if=\"$ctrl.isMesureSortable()\">{{ $ctrl.getMeasureOrderDirIndex() + 1 }}</span></div></li><li class=\"dropdown\"><a class=\"dropdown-toggle\"><span>{{:: 'Выберите измерение' | gettext }}</span> <i class=\"icon-down-dir\" title=\"{{:: 'Выберите измерение' | gettext }}\"></i></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-repeat=\"dim in $ctrl.visibleDimensions\" ng-class=\"{'dropdown': !dim.is_flat}\"><a class=\"dropdown-toggle\" ng-click=\"$ctrl.selectDim(dim)\"><i ng-class=\"$ctrl.DIM2CLASS[dim.name]\"></i> {{ dim.label }} <span ng-show=\"!dim.is_flat\" class=\"pull-right\">➤</span></a><ul class=\"dropdown-menu sub-menu\" ng-show=\"!dim.is_flat\"><li ng-repeat=\"hie in dim.hierarchies\"><a ng-click=\"$ctrl.selectDim(hie.toString())\">{{ hie.label }}</a></li></ul></li></ul></li><li ng-repeat=\"item in list\" ng-if=\"item.isDrill\" dnd-draggable=\"item\" dnd-moved=\"$ctrl.dropMove($index)\" dnd-effect-allowed=\"move\"><div class=\"drill\"><span class=\"badge move\" ng-class=\"(item.predicates && item.predicates.indexOf('!')>=0) ? 'badge-important': 'badge-info'\"><b ng-click=\"$ctrl.toggleSortDrillSorterOrder(item.key)\" class=\"filter-value\">{{item.label}}</b> <i class=\"pointer sorted-badge\" ng-click=\"$ctrl.toggleSortDrillSorterOrder(item.key)\" ng-class=\"{'icon-sort-alt-down': $ctrl.getSortDir(item.key) === 'desc', 'icon-sort-alt-up': $ctrl.getSortDir(item.key) === 'asc' }\"></i> <span ng-click=\"$ctrl.toggleSortDrillSorterOrder(item.key)\" class=\"badge mini\" ng-if=\"$ctrl.isSortable(item.key)\">{{ $ctrl.getOrderDirIndex(item.key) + 1 }} </span><i ng-if=\"$ctrl.showRemove\" class=\"pointer close-badge icon-cancel\" ng-click=\"$ctrl.removeDim(item.key)\"></i></span></div></li></ul>"

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterCardEditorModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterCardEditorModal = __webpack_require__(796);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterCardEditorModalService = exports.FilterCardEditorModalService = function () {
  function FilterCardEditorModalService($timeout, $modal) {
    _classCallCheck(this, FilterCardEditorModalService);

    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  _createClass(FilterCardEditorModalService, [{
    key: 'open',
    value: function open(_model, _filter, _asNew) {
      var _this = this;

      var updateModalSize = function updateModalSize() {
        $('.modal-body1').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight() - 30);
        var baseheight = $('.modal-body1').height() - $('#myTab').height() - 10;
        $('.aggregate-modal').height(baseheight);
        $('.dimension-list').height(baseheight);
        $('.aggregate-box').height(baseheight - 10);
        $('.filter-filters-list').height(baseheight - 10);
        $('.aggregate-container-modal').height(baseheight - 10 - $('.aggregate-header').height());
      };

      this.modalInstance = this.$modal.open({
        template: __webpack_require__(798),
        controller: _filterCardEditorModal.FilterCardEditorModalController,
        resolve: {
          asNew: function asNew() {
            return _asNew;
          },
          filter: function filter() {
            return _filter;
          },
          model: function model() {
            return _model;
          }
        },
        windowClass: 'sc-filter-card-editor-modal'
      });
      this.modalInstance.opened.then(function () {
        _this.$timeout(function () {
          updateModalSize();
        }, 100);
      }).catch(function (err) {
        console.error(err);
      });
      return this.modalInstance.result;
    }
  }]);

  return FilterCardEditorModalService;
}();

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterCardEditorModalController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

var _modals = __webpack_require__(69);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(797);

var FilterCardEditorModalController = exports.FilterCardEditorModalController = function () {
  function FilterCardEditorModalController($scope, FilterResource, $modalInstance, $modal, globalAlert, filter, CurrentFilterService, AlertModalService) {
    var _this = this;

    _classCallCheck(this, FilterCardEditorModalController);

    this.$scope = $scope;
    this.$modal = $modal;
    this.FilterResource = FilterResource;
    this.CurrentFilterService = CurrentFilterService;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;
    $scope.filter = angular.copy(filter);

    $scope.ok = function () {
      return $scope.filter.children.reduce(function (p, f) {
        return p.then(function () {
          return _this.saveFilter(f);
        });
      }, _this.saveFilter($scope.filter)).then(function () {
        $modalInstance.close($scope.filter);
      }).catch(function (error) {
        _this.globalAlert(error.message);
      });
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.delete = function () {
      console.log('Delete filter!');
      $modal.open({
        templateUrl: 'boolDialog.html',
        controller: _modals.boolDialogCtrl
        //         message:
      }).result.then(function (result) {
        // console.log(result);
        if (result) {
          return FilterResource.delete($scope.filter).then(function () {
            $modalInstance.close(null);
          }).catch(function (error) {
            globalAlert(error);
          });
        }
      }).catch(function (error) {
        console.error(error);
      });
    };
  }

  _createClass(FilterCardEditorModalController, [{
    key: 'saveFilter',
    value: function saveFilter(filter) {
      var _this2 = this;

      return this.FilterResource.save(filter).then(function (_ref) {
        var status = _ref.status,
            data = _ref.data;

        if (status === 422) {
          return _this2.AlertModalService.open(gettext('Ошибка'), gettext(status));
        }
      });
    }
  }]);

  return FilterCardEditorModalController;
}();

/***/ }),
/* 797 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{:: 'Свойства карточки' | gettext }} \"{{filter.name}}\"</h4></div><div class=\"modal-body1\"><div class=\"grouped-row\"><div class=\"column-left\"><div class=\"control-group\" ng-class=\"{'error': errors['name_'+permission.language]}\"><label>{{:: 'Название' | gettext }}:</label><div class=\"controls\"><input type=\"text\" ng-model=\"filter.name\" ng-click=\"focusName()\" class=\"input-xxlarge\"> <span class=\"help-inline\" ng-repeat=\"err in errors['name_'+permission.language]\">{{ err }}</span></div></div></div></div><div class=\"sc-card-layout\"><div class=\"column-left\"><div class=\"control-group\"><label>{{:: 'Расположение' | gettext }}:</label></div></div><div class=\"row-fluid\"><sc-filter-card-editor-cell ng-repeat=\"child in filter.children\" class=\"{{'span' + child.cardWidth}}\" filter=\"child\"></sc-filter-card-editor-cell></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-danger\" ng-click=\"delete()\" title=\"{{:: 'Удалить' | gettext }}\">{{:: 'Удалить' | gettext }}</button> <button class=\"btn btn-primary\" ng-click=\"ok()\" title=\"{{:: 'Cохранить' | gettext }}\">{{:: 'Cохранить' | gettext }}</button> <button class=\"btn\" ng-click=\"cancel()\" title=\"{{:: 'Отмена' | gettext }}\">{{:: 'Отмена' | gettext }}</button></div>"

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersCutEditorModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filtersCutEditorModal = __webpack_require__(800);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FiltersCutEditorModalService = exports.FiltersCutEditorModalService = function () {
  function FiltersCutEditorModalService($timeout, $modal) {
    _classCallCheck(this, FiltersCutEditorModalService);

    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  _createClass(FiltersCutEditorModalService, [{
    key: 'open',
    value: function open(_cut, filterService, _asNew) {
      var _this = this;

      var updateModalSize = function updateModalSize() {
        $('.modal-body1').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.col-headers').outerHeight() - $('.modal-footer').outerHeight());
        document.querySelector('.search-name input').focus();
      };

      this.modalInstance = this.$modal.open({
        template: __webpack_require__(802),
        controller: _filtersCutEditorModal.FiltersCutEditorModalController,
        resolve: {
          asNew: function asNew() {
            return _asNew;
          },
          cut: function cut() {
            return _cut;
          }
        },
        windowClass: 'sc-filters-cut-editor-modal'
      });
      this.modalInstance.opened.then(function () {
        _this.$timeout(function () {
          updateModalSize();
        }, 100);
      }).catch(function (err) {
        console.error(err);
      });
      return this.modalInstance.result;
    }
  }]);

  return FiltersCutEditorModalService;
}();

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersCutEditorModalController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // import { Filter } from '../../common/filter';


var _modals = __webpack_require__(69);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {
//   AlertModalController
// } from '../alert-modal.component';
__webpack_require__(801);

var FiltersCutEditorModalController = exports.FiltersCutEditorModalController = function () {
  function FiltersCutEditorModalController($scope, $modalInstance, $modal, globalAlert, cut, FiltersService, FilterResource, ErrorHandlerService, AlertModalService, $window) {
    var _this = this;

    _classCallCheck(this, FiltersCutEditorModalController);

    this.scope = $scope;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.FilterResource = FilterResource;
    this.FiltersService = FiltersService;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;
    this.scope.cut = cut;
    this.scope.isSaving = false;
    this.scope.fitFilters = true;
    this.scope.cuttedFilters = this.findArrtibutedFilters();
    this.scope.filters = this.searchFilters('');
    this.needChange = {};
    this.scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
    this.window = angular.element($window);
    this.window.bind('resize', function () {
      $('.modal-body1').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.col-headers').outerHeight() - $('.modal-footer').outerHeight());
    });
    this.scope.toggleFitFilters = function () {
      _this.scope.fitFilters = !_this.scope.fitFilters;
      _this.scope.filters = _this.searchFilters(_this.searchName);
    };
    this.scope.searchFilters = function (searchName) {
      return _this.scope.filters = _this.searchFilters(searchName);
    };
    this.scope.objToArry = function (obj) {
      return Object.values(obj);
    };
    this.scope.objLength = function (obj) {
      return Object.keys(obj).length;
    };
    this.scope.addFilterToAttrebuted = function (flt) {
      return _this.addFilterToAttrebuted(flt);
    };
    this.scope.removeFilterFromAttrebuted = function (flt) {
      return _this.removeFilterFromAttrebuted(flt);
    };
    this.scope.needChange = function (flt) {
      return !!_this.needChange[flt.filter.id];
    };
    this.scope.saveFilters = function () {
      return _this.saveFilters();
    };
  }

  _createClass(FiltersCutEditorModalController, [{
    key: 'toggleNeedChange',
    value: function toggleNeedChange(flt) {
      if (this.needChange[flt.filter.id]) delete this.needChange[flt.filter.id];else this.needChange[flt.filter.id] = flt;
    }
  }, {
    key: 'removeFilterFromAttrebuted',
    value: function removeFilterFromAttrebuted(flt) {
      this.toggleNeedChange(flt);
      delete this.scope.cuttedFilters[flt.filter.id];
      this.scope.filters = this.searchFilters(this.searchName);
    }
  }, {
    key: 'addFilterToAttrebuted',
    value: function addFilterToAttrebuted(flt) {
      this.toggleNeedChange(flt);
      this.scope.cuttedFilters[flt.filter.id] = flt;
      this.scope.filters = this.searchFilters(this.searchName);
    }
  }, {
    key: 'hasCut',
    value: function hasCut(filter) {
      var _this2 = this;

      if (filter.hasOwnProperty('filters')) {
        return filter.filters.some(function (attr) {
          return attr.dimension === _this2.scope.cut.dimension && attr.value === _this2.scope.cut.value;
        });
      }
      return false;
    }
  }, {
    key: 'searchFilters',
    value: function searchFilters(searchName) {
      var _this3 = this;

      this.searchName = searchName;
      // if (searchName)
      // console.log(searchName);
      return this.findFiltres(function (filter) {
        return !_this3.scope.cuttedFilters[filter.id] && filter.name.toLowerCase().indexOf(searchName.toLowerCase()) !== -1 && (!_this3.scope.fitFilters || filter.filters.some(function (cut) {
          return _this3.scope.cut.dimension === cut.dimension;
        }));
      });
    }
  }, {
    key: 'findArrtibutedFilters',
    value: function findArrtibutedFilters() {
      var _this4 = this;

      return this.findFiltres(function (filter) {
        return _this4.hasCut(filter);
      }).reduce(function (acc, flt) {
        acc[flt.filter.id] = flt;
        return acc;
      }, {});
    }
  }, {
    key: 'findFiltres',
    value: function findFiltres(predicate) {
      var result = [];
      var findIter = function findIter(filters, parentId, level) {
        filters.map(function (filter) {
          if (predicate(filter)) result.push({
            filter: filter,
            parentId: parentId,
            level: level
          });
          if (filter.children && filter.children.length) {
            findIter(filter.children, filter.id, level + 1);
          }
        });
      };
      findIter(this.FiltersService.filters, null, 0);
      // console.log(this.scope);
      return result;
    }
  }, {
    key: 'setCut',
    value: function setCut(flt) {
      if (!flt.filter.hasOwnProperty('filters')) flt.filter.filters = [];
      flt.filter.filters.push({
        dimension: this.scope.cut.dimension,
        value: this.scope.cut.value,
        label: this.scope.cut.value,
        predicates: []
      });
    }
  }, {
    key: 'removeCut',
    value: function removeCut(flt) {
      var _this5 = this;

      if (!flt.filter.filters) return;
      flt.filter.filters.find(function (attr, i, arr) {
        if (attr.dimension === _this5.scope.cut.dimension && attr.value === _this5.scope.cut.value) {
          arr.splice(i, 1);
          return true;
        } else return false;
      });
    }
  }, {
    key: 'saveFilters',
    value: function saveFilters() {
      var _this6 = this;

      this.scope.isSaving = true;
      var promices = [];

      var _loop = function _loop(key) {
        promices.push(new Promise(function (resolve, reject) {
          var flt = _this6.needChange[key];
          if (_this6.scope.cuttedFilters[key]) {
            _this6.setCut(flt);
          } else {
            _this6.removeCut(flt);
          }
          // console.log(flt);
          flt.error = null;
          flt.statis = null;
          _this6.saveFilter(flt, resolve, reject);
        }));
      };

      for (var key in this.needChange) {
        _loop(key);
      }
      Promise.all(promices).then(function (res) {
        _this6.scope.isSaving = false;
        _this6.$modalInstance.close(null);
      });
    }
  }, {
    key: 'saveFilter',
    value: function saveFilter(flt, resolve, reject) {
      var _this7 = this;

      this.FilterResource.save(flt.filter, function (status, data, error) {
        flt.error = error;
        flt.statis = status;
        if (error) {
          _this7.globalAlert(error.message);
          console.error(error);
          reject(flt);
        } else {
          if (status === 200) {
            resolve(flt);
          }
          if (status === 422) {
            _this7.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка') + ': ' + status, gettext('Заполните необходимые поля.'));
            // this.ErrorHandlerService.handleServerError({
            //   status: 422,
            //   data: gettext('Заполните необходимые поля.')
            // });
            reject(flt);
            // $scope.errors = data;
          }
        }
      });
    }
  }]);

  return FiltersCutEditorModalController;
}();

/***/ }),
/* 801 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{:: 'Добавление' | gettext }}: {{cut.value}}</h4></div><div class=\"col-headers\"><div class=\"col-header\"><div class=\"toolbar-color\"><div class=\"search-name\"><input type=\"text\" ng-model=\"searchName\" ng-keyup=\"searchFilters(searchName);\" placeholder=\"{{:: 'Поиск фильтра' | gettext }}\"></div><div class=\"fit-filters\" ng-click=\"toggleFitFilters()\"><label>{{::'только подходящие фильтры' | gettext }}</label><input type=\"checkbox\" ng-checked=\"fitFilters\" title=\"{{::'только подходящие фильтры' | gettext }}\"></div></div></div><div class=\"toolbar-color col2-header\"><h4>{{:: 'Фильтры с' | gettext }}: {{cut.value}}</h4></div></div><div class=\"modal-body1\"><div class=\"filters-list\" style=\"\"><ul class=\"nav\"><li ng-repeat=\"flt in filters\"><div class=\"agil col1-item\" ng-click=\"addFilterToAttrebuted(flt) \" ng-style=\"{'margin-left': flt.level * 20, 'font-weight': needChange(flt)? 'bold': 'normal' }\"><span class=\"list-value\">{{flt.filter.name}}</span> <i class=\"pointer icon-right-bold\"></i></div></li><li ng-if=\"!filters.length\" class=\"text-center\">{{:: 'Фильтры не найдены' | gettext }}</li></ul></div><div class=\"filters-list\"><ul class=\"nav\"><li ng-repeat=\"flt in objToArry(cuttedFilters)\" class=\"col2-item\"><div class=\"item-button\" ng-click=\"removeFilterFromAttrebuted(flt)\" title=\"{{::'удалить атрибут из фильтра' | gettext }}\"><i class=\"pointer icon-left-bold\"></i> <span ng-style=\"{'font-weight': needChange(flt)? 'bold': 'normal' }\">{{flt.filter.name}}</span></div></li><li ng-if=\"!objLength(cuttedFilters)\" class=\"text-center aggregate-cell\" style=\"list-style:none\">{{:: 'Фильтры еще не добавлены' | gettext }}</li></ul></div></div><div class=\"modal-footer\"><button ng-disabled=\"isSaving\" class=\"btn btn-primary\" ng-click=\"saveFilters()\" title=\"{:: 'Cохранить' | gettext }}\"><span class=\"\">{{:: 'Cохранить' | gettext }}</span></button> <button class=\"btn\" ng-click=\"cancel()\" title=\"{{:: 'Отмена' | gettext }}\"><span class=\"\">{{:: 'Отмена' | gettext }}</span></button></div>"

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RulesEditorModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rulesEditor = __webpack_require__(804);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RulesEditorModalService = exports.RulesEditorModalService = function () {
  function RulesEditorModalService($timeout, $modal) {
    _classCallCheck(this, RulesEditorModalService);

    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  _createClass(RulesEditorModalService, [{
    key: 'open',
    value: function open(_cut, filterService, _asNew) {
      var _this = this;

      var updateModalSize = function updateModalSize() {
        $('.list-body').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.list-head').outerHeight() - $('.modal-footer').outerHeight());
        $('.toolbar-color>div').innerWidth(document.querySelector('.list-body>div').clientWidth);
      };

      this.modalInstance = this.$modal.open({
        template: __webpack_require__(806),
        controller: _rulesEditor.RulesEditorController,
        resolve: {
          asNew: function asNew() {
            return _asNew;
          },
          cut: function cut() {
            return _cut;
          }
        },
        windowClass: 'sc-rules-editor-modal'
      });
      this.modalInstance.opened.then(function () {
        _this.$timeout(function () {
          updateModalSize();
        }, 100);
      }).catch(function (err) {
        console.error(err);
      });
      return this.modalInstance.result;
    }
  }]);

  return RulesEditorModalService;
}();

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RulesEditorController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(69);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {
//   AlertModalController
// } from '../alert-modal.component';
__webpack_require__(805);

var RulesEditorController = exports.RulesEditorController = function () {
  function RulesEditorController($scope, $rootScope, $modalInstance, $modal, globalAlert, cut, ErrorHandlerService, CurrentModelService, AlertModalService, $http, $window) {
    var _this = this;

    _classCallCheck(this, RulesEditorController);

    this.scope = $scope;
    this.rootScope = $rootScope;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;

    this.scope.cut = cut;
    this.scope.rules = [];
    this.scope.term = {
      config: '',
      rule: '',
      useFilter: '',
      useFilterPrev: ''
    };
    this.globalRules = {};
    this.scope.label = CurrentModelService.model.getDrillLabel(cut.dimension);
    this.scope.sortConfigsDirection = 0;
    this.scope.sortRulesDirection = 0;
    this.$http = $http;
    this.window = angular.element($window);
    this.window.bind('resize', function () {
      var listBody = document.querySelector('.list-body>div');

      $('.list-body').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.list-head').outerHeight() - $('.modal-footer').outerHeight());
      if (listBody) $('.toolbar-color>div').innerWidth(listBody.clientWidth);
    });

    this.scope.sortConfigs = function () {
      _this.scope.sortConfigsDirection = _this.scope.sortConfigsDirection === 1 ? -1 : _this.scope.sortConfigsDirection + 1;
      _this.sortConfigs();
    };
    this.scope.sortRules = function () {
      _this.scope.sortRulesDirection = _this.scope.sortRulesDirection === 1 ? -1 : _this.scope.sortRulesDirection + 1;
      _this.sortRules();
    };

    this.scope.useFilterClick = function (useFilter) {
      _this.scope.term.useFilter = _this.scope.term.useFilterPrev === useFilter ? '' : useFilter;
      _this.scope.term.useFilterPrev = _this.scope.term.useFilter;
      _this.search();
    };

    this.scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    this.scope.search = function () {
      return _this.search();
    };

    this.scope.searchRulesClean = function () {
      _this.scope.term.rule = '';
      _this.search();
    };

    this.scope.searchConfigClean = function () {
      _this.scope.term.config = '';
      _this.search();
    };

    this.scope.saveRules = function () {
      return _this.saveRules();
    };

    this.scope.changeRule = function (rule) {
      if (rule.confId === 0) _this.globalRules[rule.name] = rule.use !== 'not';
      _this.search();
    };

    this.scope.hasGpobalRule = function (rule) {
      return rule.confId !== 0 && _this.globalRules[rule.name];
    };

    this.loadData();
  }

  _createClass(RulesEditorController, [{
    key: 'sortRulesComare',
    value: function sortRulesComare(a, b, whenEqual) {
      if (!this.scope.sortRulesDirection) return whenEqual;
      return (a.ruleDescription > b.ruleDescription ? 1 : a.ruleDescription === b.ruleDescription ? whenEqual : -1) * this.scope.sortRulesDirection;
    }
  }, {
    key: 'sortConfigsComare',
    value: function sortConfigsComare(a, b, whenEqual) {
      if (!this.scope.sortConfigsDirection) return whenEqual;
      return (a.confDescription > b.confDescription ? 1 : a.confDescription === b.confDescription ? whenEqual : -1) * this.scope.sortConfigsDirection;
    }
  }, {
    key: 'sortConfigs',
    value: function sortConfigs() {
      var _this2 = this;

      this.scope.rules.sort(function (a, b) {
        return _this2.sortConfigsComare(a, b, _this2.sortRulesComare(a, b, a.index - b.index));
      });
    }
  }, {
    key: 'sortRules',
    value: function sortRules() {
      var _this3 = this;

      this.scope.rules.sort(function (a, b) {
        return _this3.sortRulesComare(a, b, _this3.sortConfigsComare(a, b, a.index - b.index));
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this4 = this;

      var index = 0;
      this.$http.get('analytics/configs/').then(function (response) {
        var config = response.data;
        config.map(function (conf) {
          var confId = conf.id;
          var confDescription = conf.name;
          conf.acl.map(function (rule) {
            if (!rule.dimensions.some(function (dm) {
              return dm === _this4.scope.cut.dimension;
            })) {
              // console.log(rule.dimensions);
              return;
            }

            var item = {
              confId: confId,
              name: rule.name,
              confDescription: confDescription,
              use: 'not',
              show: true,
              ruleDescription: rule.description,
              index: index++
            };
            rule.rules.map(function (rl) {
              var value = rl.values.find(function (val) {
                return val.value === _this4.scope.cut.value;
              });
              if (value) {
                item.valueId = value.id;
                if (item.confId === 0) _this4.globalRules[item.name] = true;
              }
              var nmArr = rl.name.split('_');
              var word = nmArr[nmArr.length - 1];
              switch (word) {
                case 'EXCLUDE':
                case 'BLACKLIST':
                  item.blockName = rl.name;
                  item.blockId = rl.id;
                  if (value) item.use = 'block';
                  break;
                default:
                  item.allowName = rl.name;
                  item.allowId = rl.id;
                  if (value) item.use = 'allow';
              }
            });
            item.useIntial = item.use;
            _this4.scope.rules.push(item);
          });
        });
        // this.search();
      });
    }

    // hideWhenGlobalRule() {
    //   this.scope.rules.filter(rule => rule.confId === 0 && rule.valueId)
    //     .map((glRule) => {
    //       this.scope.rules.filter(rule => rule.confId !== 0 && rule.name === glRule.name)
    //         .map(rule => rule.show = false);
    //     });
    // }


  }, {
    key: 'search',
    value: function search() {
      var _this5 = this;

      var regConfig = new RegExp(this.scope.term.config, 'i');
      var regRule = new RegExp(this.scope.term.rule, 'i');
      this.scope.rules.map(function (rule) {
        rule.show = rule.confDescription.search(regConfig) != -1 && rule.ruleDescription.search(regRule) != -1 && (_this5.scope.term.useFilter ? rule.use === _this5.scope.term.useFilter : true);
      });
      // this.hideWhenGlobalRule();
    }
  }, {
    key: 'sort',
    value: function sort() {
      var _this6 = this;

      this.scope.rules.sort(function (a, b) {
        var resConfig = a.confDescription > b.confDescription ? 1 : a.confDescription === b.confDescription ? 0 : -1;
        var resRule = a.ruleDescription > b.ruleDescription ? 1 : a.ruleDescription === b.ruleDescription ? 0 : -1;
        return resConfig * _this6.scope.sortConfigsDirection;
      });
    }
  }, {
    key: 'saveRules',
    value: function saveRules() {
      var _this7 = this;

      var saveObj = {
        value: this.scope.cut.value
      };
      this.scope.rules.filter(function (rule) {
        return rule.use !== rule.useIntial;
      }).map(function (rule) {
        // console.log(rule);
        if (!saveObj[rule.confId]) {
          saveObj[rule.confId] = {
            addToRule: [],
            delValue: []
          };
        }
        switch (rule.use) {
          case 'allow':

            saveObj[rule.confId].addToRule.push(rule.allowId);
            // console.log('add to', rule.allowName);
            break;
          case 'block':
            saveObj[rule.confId].addToRule.push(rule.blockId);
            // console.log('add to', rule.blockName);
            break;
        }
        if (rule.valueId) {
          saveObj[rule.confId].delValue.push(rule.valueId);
          // console.log('delete', rule.valueId);
        }
      });
      // console.log(saveObj);

      if (Object.keys(saveObj).length < 2) {
        this.$modalInstance.close(null);
        return;
      }

      this.$http.post('analytics/configs/save/', saveObj).then(function (result) {
        // console.log(result);
        _this7.$modalInstance.close(null);
      }, function (error) {
        return console.error(error);
      });
    }
  }]);

  return RulesEditorController;
}();

/***/ }),
/* 805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\"><span>{{:: 'Изменение правил для' | gettext }}: {{label}} : {{cut.value}}</span></h4></div><div class=\"body-win\"><div class=\"toolbar-color\"><div><div class=\"list-head\"><div style=\"width:40%\"><div><div>{{:: 'Конфигурация' | gettext }}:</div><div><input type=\"text\" ng-model=\"term.config\" ng-change=\"search();\" placeholder=\"{{:: 'Поиск конфигурации' | gettext }}\"> <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"searchConfigClean()\">&times;</button> <i ng-if=\"sortConfigsDirection === 1\" class=\"icon-sort-alt-up\" ng-click=\"sortConfigs()\" title=\"{{:: 'Сортировка' | gettext }}\"></i> <i ng-if=\"sortConfigsDirection === 0\" class=\"icon-resize-vertical\" ng-click=\"sortConfigs()\" title=\"{{:: 'Сортировка' | gettext }}\"></i> <i ng-if=\"sortConfigsDirection === -1\" class=\"icon-sort-alt-down\" ng-click=\"sortConfigs()\" title=\"{{:: 'Сортировка' | gettext }}\"></i></div></div></div><div style=\"width:40%\"><div><div class=\"\">{{:: 'Правило' | gettext }}:</div><div class=\"\"><input type=\"text\" ng-model=\"term.rule\" ng-change=\"search();\" placeholder=\"{{:: 'Поиск правила' | gettext }}\"> <button type=\"button\" class=\"close\" aria-hidden=\"true\" ng-click=\"searchRulesClean()\">&times;</button> <i ng-if=\"sortRulesDirection === 1\" class=\"icon-sort-alt-up\" ng-click=\"sortRules()\" title=\"{{:: 'Сортировка' | gettext }}\"></i> <i ng-if=\"sortRulesDirection === 0\" class=\"icon-resize-vertical\" ng-click=\"sortRules()\" title=\"{{:: 'Сортировка' | gettext }}\"></i> <i ng-if=\"sortRulesDirection === -1\" class=\"icon-sort-alt-down\" ng-click=\"sortRules()\" title=\"{{:: 'Сортировка' | gettext }}\"></i></div></div></div><div class=\"use-head\"><div class=\"use-labels\"><div>{{:: 'Разрешить' | gettext }}</div><div>{{:: 'Блокировать' | gettext }}</div><div>{{:: 'Не использовать' | gettext }}</div></div><div class=\"radio\" title=\"{{:: 'Фильтрация' | gettext }}\"><input type=\"radio\" ng-model=\"term.useFilter\" value=\"allow\" ng-click=\"useFilterClick('allow')\"> <input type=\"radio\" ng-model=\"term.useFilter\" value=\"block\" ng-click=\"useFilterClick('block')\"> <input type=\"radio\" ng-model=\"term.useFilter\" value=\"not\" ng-click=\"useFilterClick('not')\"></div></div></div></div></div><div class=\"list-body\"><div><div class=\"list-row\" ng-repeat=\"rule in rules\" ng-style=\"{'font-weight': rule.confId === 0? 'bold' : 'normal'}\" ng-if=\"rule.show\"><div style=\"width:40%\"><div>{{rule.confDescription}}</div></div><div style=\"width:40%\"><div>{{rule.ruleName}} {{rule.ruleDescription}}</div></div><div><div class=\"radio\"><input ng-change=\"changeRule(rule)\" ng-disabled=\"hasGpobalRule(rule)\" type=\"radio\" ng-model=\"rule.use\" value=\"allow\"> <input ng-change=\"changeRule(rule)\" ng-disabled=\"hasGpobalRule(rule) || !rule.blockId\" type=\"radio\" ng-model=\"rule.use\" value=\"block\"> <input ng-change=\"changeRule(rule)\" ng-disabled=\"hasGpobalRule(rule)\" type=\"radio\" ng-model=\"rule.use\" value=\"not\"></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" ng-click=\"saveRules()\">{{:: 'Cохранить' | gettext }}</button> <button class=\"btn\" ng-click=\"cancel()\" title=\"{{:: 'Отмена' | gettext }}\">{{:: 'Отмена' | gettext }}</button></div>"

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(808);

var DLPBuilderController = exports.DLPBuilderController = function () {
  function DLPBuilderController($scope, $rootScope, $element, $timeout) {
    var _this = this;

    _classCallCheck(this, DLPBuilderController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.text = '';
    this.prevText = '';
    this.rules = [];
    this.compex = {};
    this.textOprers = {
      and: {
        type: 'oper',
        reg: '\\band\\b',
        buildKey: 'And'
      },
      '&&': {
        type: 'oper',
        reg: '\\&\\&',
        buildKey: 'And'
      },
      or: {
        type: 'oper',
        reg: '\\bor\\b',
        buildKey: 'Or'
      },
      '||': {
        type: 'oper',
        reg: '\\|\\|',
        buildKey: 'Or'
      },
      xor: {
        type: 'oper',
        reg: '\\bxor\\b',
        buildKey: 'eXclusive Or'
      },
      '^^': {
        type: 'oper',
        reg: '\\^\\^',
        buildKey: 'eXclusive Or'
      },
      '==': {
        type: 'expr',
        reg: '\\=\\=',
        buildKey: 'equals'
      },
      eq: {
        type: 'expr',
        reg: '\\beq\\b',
        buildKey: 'equals'
      },
      matches: {
        type: 'expr',
        reg: '\\bmatches\\b',
        buildKey: 'matches',
        nulti: true
      },
      in: {
        type: 'expr',
        reg: '\\bin\\b',
        buildKey: 'in',
        nulti: true
      },
      ne: {
        type: 'expr',
        reg: '\\bne\\b',
        buildKey: 'not equals'
      },
      '!=': {
        type: 'expr',
        reg: '\\!\\=',
        buildKey: 'not equals'
      },
      '!': {
        type: 'preExpr',
        reg: '\\!',
        buildKey: 'not'
      },
      'not': {
        type: 'preExpr',
        reg: '\\bnot\\b\\s',
        buildKey: 'not'
      }
    };

    this.builderOpers = {
      And: {
        type: 'oper',
        text: 'and'
      },
      Or: {
        type: 'oper',
        text: 'or'
      },
      'eXclusive Or': {
        type: 'oper',
        text: 'xor'
      },
      equals: {
        type: 'expr',
        text: '=='
      },
      'not equals': {
        type: 'expr',
        text: '!='
      },
      matches: {
        type: 'expr',
        text: 'matches',
        multi: true
      },
      'not matches': {
        type: 'expr',
        text: 'matches',
        pre: 'not',
        multi: true
      },
      'in': {
        type: 'expr',
        text: 'in',
        multi: true
      },
      'not in': {
        type: 'expr',
        text: 'in',
        pre: 'not',
        multi: true
      }
    };
    this.arrOper = Object.keys(this.builderOpers).filter(function (k) {
      return _this.builderOpers[k].type == 'oper';
    });
    this.arrExpr = Object.keys(this.builderOpers).filter(function (k) {
      return _this.builderOpers[k].type == 'expr';
    });

    this.fields = {
      'computer_name': {
        dimension: 'agent_agent@computer_name:computer_name',
        name: gettext('Имя компьютера'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'user_name': {
        dimension: 'agent_account@user_name:user_name',
        name: gettext('Имя пользователя'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'user_domain': {
        dimension: 'agent_account@user_domain:user_domain',
        name: gettext('Домен пользователя'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'exe_name': {
        dimension: 'agent_application@app_name:app_name',
        name: gettext('Имя приложения'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'file_name': {
        dimension: 'agent_attachedfile@file_name:file_name',
        name: gettext('Имя файла'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'file_path': {
        dimension: 'agent_attachedfile@file_path:file_path',
        name: gettext('Путь файла'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'file_ext': {
        dimension: 'agent_attachedfile@file_ext:file_ext',
        name: gettext('Расширение файла'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'mime': {
        dimension: 'agent_attachedfile@mime:mime',
        name: gettext('Тип контента'),
        schemeType: 'Bytes',
        inputType: 'select'
      },
      'tag': {
        dimension: 'boolean',
        name: gettext('Признак наличия метки'),
        schemeType: 'Bool',
        inputType: 'checkbox'
      },
      'tag_value': {
        dimension: 'value',
        name: gettext('Значение метки'),
        schemeType: 'Bytes',
        inputType: 'input'
      }
    };

    this.arrFields = Object.keys(this.fields).map(function (k) {
      return _this.getFieldByKey(k);
    });

    this.schemeFields = Object.keys(this.fields).reduce(function (f, k) {
      f[k] = _this.fields[k].schemeType;
      return f;
    }, {});

    this.dlpError = '';

    this.opersStr = Object.keys(this.textOprers).filter(function (k) {
      return _this.textOprers[k].type === 'oper';
    }).map(function (k) {
      return _this.textOprers[k].reg;
    }).join('|');

    this.exprStr = Object.keys(this.textOprers).filter(function (k) {
      return _this.textOprers[k].type === 'expr';
    }).map(function (k) {
      return _this.textOprers[k].reg;
    }).join('|');

    this.preExprStr = Object.keys(this.textOprers).filter(function (k) {
      return _this.textOprers[k].type === 'preExpr';
    }).map(function (k) {
      return _this.textOprers[k].reg;
    }).join('|');

    $timeout(function () {
      _this.textarea = $element.find('.dlp-text textarea')[0];
      _this.textarea.addEventListener('input', function () {
        _this.textChanged = true;
        _this.updateOutput();
        _this.parseRules();
      });
    }, 10);

    this.textChanged = true;
  }

  _createClass(DLPBuilderController, [{
    key: '$onDestroy',
    value: function $onDestroy() {
      this.textarea.target.removeEventListener('blur', this.parseRules);
      this.textarea.target.removeEventListener('onchange', this.updateOutput);
    }
  }, {
    key: 'getFieldByKey',
    value: function getFieldByKey(key) {
      var field = this.fields[key];
      if (!field) return null;
      field.key = key;
      return field;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$timeout(function () {
        _this2.textElement = _this2.$element.find('#id_' + _this2.fieldName);
        if ((typeof WebAssembly === 'undefined' ? 'undefined' : _typeof(WebAssembly)) === 'object') {
          _this2.createScheme().then(function () {
            return _this2.parseRules();
          });
        } else {
          console.warn('DLP config validation diabled');
        }
      }, 100);
    }
  }, {
    key: 'handleError',
    value: function handleError(err) {
      // console.log(err);
      this.dlpError = err;
      // this.errorPanel.html(err.toString());
    }
  }, {
    key: 'deleteExpr',
    value: function deleteExpr(oper, rule) {
      var ruleIndex = this.rules.indexOf(rule);
      if (ruleIndex == -1) return;
      var operIndex = this.rules[ruleIndex].indexOf(oper);
      if (operIndex == -1) return;
      // console.log(operIndex, ruleIndex);
      this.rules[ruleIndex].splice(operIndex, 1);
      if (!this.rules[ruleIndex].length) this.rules.splice(ruleIndex, 1);
      this.onFieldChange();
    }
  }, {
    key: 'updateOutput',
    value: function updateOutput() {
      var valid = true;
      try {
        var lines = this.textElement.val().split('\n');
        for (var i = 0; i < lines.length; i++) {
          var code = lines[i];
          if (code.trim()) {
            var res = this.scheme.parse(code);
            var value = JSON.stringify(res, null, 2);
          }
        }
        this.dlpError = '';
      } catch (err) {
        this.dlpError = err.message;
        if (this.textElement) valid = false;
      }
      $('input[name=_save]').prop('disabled', !valid);
      $('input[name=_saveasnew]').prop('disabled', !valid);
      this.$scope.$apply();
      this.textChanged = true;
    }
  }, {
    key: 'createScheme',
    value: function createScheme() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        delete WebAssembly.instantiateStreaming;

        wasm_bindgen('/static/js/wirefilter_wasm_bg.wasm').then(function () {
          if (!_this3.textElement.length) return;
          _this3.scheme = new wasm_bindgen.Scheme(_this3.schemeFields);
          resolve();
        });
        // const this.textElement = $('#id_dlp_config');
      });
    }
  }, {
    key: 'onFieldChange',
    value: function onFieldChange(expr) {
      if (expr) {
        if (expr.field.key === 'tag') expr.value = [true];else expr.value = [''];
      }
      if (!$(this.textarea).is(':focus')) this.buildText();
    }
  }, {
    key: 'parseValue',
    value: function parseValue(val, oper, field) {
      if (field === 'file_path') val = val.replace(/\\\\/g, '\\');
      if (!val[0]) return oper.trim() == 'not' ? [false] : [true];
      if (this.builderOpers[oper].text == 'matches') return val.match(/"\s*\((.+)\)\s*"/)[1].split('|');
      if (this.builderOpers[oper].text == 'in') return val.match(/([^\{^?"^\}]+)\b/g);
      return [val.match(/"(.+)"/)[1]];
    }
  }, {
    key: 'parseExpr',
    value: function parseExpr(expr, ruleIndex, rule) {
      // detting operator
      var operMatch = expr.match(new RegExp('(' + this.exprStr + ')'));
      var res = void 0;
      var operParts = void 0;
      if (operMatch && operMatch[0]) {
        operParts = expr.split(operMatch[0]);
        res = {
          oper: this.textOprers[operMatch[0].trim()].buildKey,
          value: operParts[1].trim()
        };
      } else {
        operParts = [expr.trim()];
        res = {
          oper: '',
          value: ['']
        };
      }
      //checking is complicate rule
      if (operParts[0].match(/(?:\(|\))/)) {
        this.compex[ruleIndex] = rule;
        return;
      }

      //gettin prefix "not" or "!"
      var pre = operParts[0].match(/^(\s*not\s*|\s*\!\s*)+/);
      var field = void 0;
      if (pre) {
        pre = pre[0];
        //getting  without 'not'
        field = operParts[0].split(RegExp('(' + pre + ')'))[2].trim();
        //replacing '!' with `not`
        pre = pre.replace(/\!/g, 'not ');
        // adding strin with 'not ' to operation
        res.oper = pre + ' ' + res.oper;
        //getting strin with 'not' including 'not' that belog to operation
        var preMatch = res.oper.match(/\s*(not\s+)/g);
        //getting field without 'not'
        var oper = res.oper.match(/\s*(?:not\s+)*(.+)/)[1].trim();
        // removing unnecessary 'not'
        if (preMatch && preMatch.length % 2) res.oper = 'not ' + oper;else res.oper = oper;
      } else {
        field = operParts[0].trim();
      }
      res.field = this.getFieldByKey(field);
      res.value = this.parseValue(res.value, res.oper, field);
      return res;
    }
  }, {
    key: 'parseRules',
    value: function parseRules() {
      var _this4 = this;

      if (this.dlpError || !this.textChanged) return;
      var text = this.textElement.val();
      // if (this.prevText === text) return;
      this.prevText = text;
      this.compex = {};

      this.rules = text.split('\n').filter(function (s) {
        return s;
      }).map(function (s, ruleIndex) {
        // divide by operations (last not inclused)
        var ruleMatch = s.split(new RegExp('(' + _this4.opersStr + ')'));
        var resMatch = [];
        for (var i = 0; i < ruleMatch.length; i += 2) {
          resMatch.push({
            expr: ruleMatch[i],
            oper: i < 1 ? '' : ruleMatch[i - 1]
          });
        }

        var opers = resMatch.map(function (o) {
          return {
            oper: o.oper ? _this4.textOprers[o.oper.trim()].buildKey : '',
            expr: _this4.parseExpr(o.expr, ruleIndex, ruleIndex)
          };
        });

        //getting last operation
        return opers;
      });
      if (!this.$rootScope.$$phase) this.$scope.$apply();
      this.showBuilder = true;
      this.textChanged = false;
    }
  }, {
    key: 'buildText',
    value: function buildText() {
      var _this5 = this;

      var text = this.rules.map(function (r, i) {
        return _this5.compex[i] ? _this5.compex[i] : r.filter(function (oper) {
          var isAll = oper.expr.field && (oper.expr.oper && oper.expr.value[0] || oper.expr.field.dimension === 'boolean');
          return isAll;
        }).map(function (oper, i) {
          if (oper.expr.field.dimension == 'boolean') return (oper.oper && i ? _this5.builderOpers[oper.oper].text + ' ' : '') + (oper.expr.value[0] ? oper.expr.field.key : 'not ' + oper.expr.field.key);

          var exprOper = _this5.builderOpers[oper.expr.oper];
          var value = oper.expr.value;
          if (oper.expr.field.key === 'file_path') value = value.map(function (v) {
            return v.replace(/\\/g, '\\\\');
          });
          // in {“one” “two”}
          if (exprOper.text == 'in') value = '{' + value.map(function (v) {
            return '"' + v + '"';
          }).join(' ') + '}';
          //  matches "(guest|dsasd)"
          else if (exprOper.text == 'matches') value = '"(' + value.map(function (v) {
              return v;
            }).join('|') + ')"';else value = '"' + value[0] + '"';

          return '' + (oper.oper && i ? _this5.builderOpers[oper.oper].text + ' ' : '') + (exprOper.pre ? exprOper.pre + ' ' : '') + oper.expr.field.key + ' ' + exprOper.text + ' ' + value;
        }).join(' ');
      }).join('\n');

      this.textElement.val(text);
      this.prevText = text;
      this.$timeout(function () {
        _this5.updateOutput();
      }, 10);
    }
  }, {
    key: 'isNextIndex',
    value: function isNextIndex(rule, oper) {
      var ruleIndex = this.rules.indexOf(rule);
      var operIndex = this.rules[ruleIndex].indexOf(oper);
      return operIndex > 0;
    }
  }, {
    key: 'addExp',
    value: function addExp(oper, rule) {
      var ruleIndex = this.rules.indexOf(rule);
      this.rules[ruleIndex].push({
        oper: oper,
        expr: {
          field: '',
          oper: '',
          value: ['']
        }
      });
      this.newRuleOper = '';
    }
  }, {
    key: 'addRule',
    value: function addRule() {
      this.rules.push([{
        oper: '',
        expr: {
          field: '',
          oper: '',
          value: ['']
        }
      }]);
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule(rule) {
      var i = this.rules.indexOf(rule);
      if (i === -1) return;
      this.rules.splice(i, 1);
      delete this.compex[i];
      this.buildText();
    }
  }, {
    key: 'isCompex',
    value: function isCompex(rule) {
      return this.compex[this.rules.indexOf(rule)];
    }
  }]);

  return DLPBuilderController;
}();

var DLPBuilderComponent = exports.DLPBuilderComponent = {
  bindings: {
    fieldName: '<'
  },
  transclude: true,
  template: __webpack_require__(809),
  controller: DLPBuilderController
};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports = "<table><tr><th class=\"col-field\">{{::'Поле' | gettext }}</th><th class=\"col-operator\">{{::'Оператор' | gettext }}</th><th class=\"col-value\">{{::'Значение' | gettext }}</th><th class=\"col-add\">{{::'Добавить выражение' | gettext }}</th><th class=\"col-delete\"></th></tr></table><table ng-repeat=\"rule in $ctrl.rules\"><tr><td><span class=\"rule-head\">{{ $index + 1 }} {{::'правило' | gettext }}:</span></td><td colspan=\"2\" style=\"text-align:center\"><span class=\"warning\" ng-if=\"$ctrl.isCompex(rule)\">{{::'Cложное правило не воспроизводится построителем!' | gettext }}</span></td><td class=\"col-add pointer\" style=\"text-align:right\"><span class=\"do-rule\" title=\"{{::'Удалить правило' | gettext }}\" ng-click=\"$ctrl.deleteRule(rule)\">{{::'Удалить правило' | gettext }}</span></td><td class=\"col-delete pointer\"><i ng-click=\"$ctrl.deleteRule(rule)\" class=\"icon-trash\" title=\"{{::'Удалить правило' | gettext }}\"></i></td></tr><tr ng-if=\"!$ctrl.isCompex(rule)\" ng-repeat=\"oper in rule\"><td class=\"col-field\"><span ng-if=\"oper.oper && $ctrl.isNextIndex(rule, oper)\" class=\"stick-top\"></span><div ng-if=\"oper.oper && $ctrl.isNextIndex(rule, oper)\" class=\"view-operator\">{{oper.oper}} <span class=\"stick-bottom\"></span></div><div class=\"\"><select ng-change=\"$ctrl.onFieldChange(oper.expr)\" ng-options=\"fld.name for fld in $ctrl.arrFields\" ng-model=\"oper.expr.field\"></select></div></td><td class=\"col-operator\"><div><select ng-if=\"oper.expr.field.dimension !== 'boolean'\" ng-change=\"$ctrl.buildText()\" ng-options=\"expr for expr in $ctrl.arrExpr\" ng-model=\"oper.expr.oper\"></select></div></td><td class=\"col-value\"><sc-value-builder value=\"oper.expr.value\" multiple=\"$ctrl.builderOpers[oper.expr.oper].multi\" dimension=\"oper.expr.field.dimension\" input-type=\"oper.expr.field.inputType\" on-changed=\"$ctrl.onFieldChange()\"></sc-value-builder></td><td class=\"col-add\"><div ng-if=\"rule[$index + 1]\" class=\"\"><select ng-change=\"$ctrl.buildText()\" ng-options=\"oper for oper in $ctrl.arrOper\" ng-model=\"rule[$index + 1].oper\"></select></div><div ng-if=\"!rule[$index + 1]\" class=\"\"><select ng-options=\"oper for oper in $ctrl.arrOper\" ng-change=\"$ctrl.addExp($ctrl.newRuleOper, rule)\" ng-model=\"$ctrl.newRuleOper\"></select></div></td><td class=\"col-delete\"><i class=\"icon-cancel pointer\" title=\"{{::'Удалить выражение' | gettext }} \" ng-click=\"$ctrl.deleteExpr(oper, rule)\"></i></td></tr></table><div ng-click=\"$ctrl.addRule()\" class=\"do-rule\">{{::'Добавить правило' | gettext }} <i class=\"icon-plus\"></i></div><div class=\"dlp-text\" ng-click=\"$ctrl.parseRules()\"><div ng-if=\"$ctrl.dlpError\" class=\"error-varning\"><i class=\"icon-exclamation\"></i> {{::'Ошибка...' | gettext }}</div><ng-transclude></ng-transclude></div><pre style=\"color:red\" id=\"dlp_validation\">{{$ctrl.dlpError}}</pre>"

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(811);

var QueryBuilderController = exports.QueryBuilderController = function () {
  function QueryBuilderController($scope) {
    _classCallCheck(this, QueryBuilderController);

    this.$scope = $scope;
  }

  _createClass(QueryBuilderController, [{
    key: '$onInit',
    value: function $onInit() {
      if (!this.group) {
        this.group = {
          operator: 'AND',
          rules: []
        };
      }
    }
  }]);

  return QueryBuilderController;
}();

var QueryBuilderComponent = exports.QueryBuilderComponent = {
  bindings: {
    group: '='
  },
  template: __webpack_require__(812),
  controller: QueryBuilderController
};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<sc-query-builder-node node=\"{group: $ctrl.group}\" is-root=\"true\"></sc-query-builder-node>"

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(814);

var ValueBuilderController = exports.ValueBuilderController = function () {
  function ValueBuilderController($scope, $element, $timeout, $http, rx, observeOnScope, CurrentModelService, ErrorHandlerService) {
    var _this = this;

    _classCallCheck(this, ValueBuilderController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$http = $http;
    // this.selecter = this.$element.find('select');
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.search = '';
    this.prevValue = [];
    this.valueObj = {};
    this.setSize(this.valie);

    this.subscriptions = [rx.Observable.merge(observeOnScope($scope, '$ctrl.multiple').do(function () {
      if (_this.multiple) _this.search = '';else _this.search = _this.value[0];
      _this.value = _this.value.filter(function (v) {
        return v;
      });
    }), $scope.$eventToObservable('searchChange').debounce(100).do(function () {
      if (!_this.multiple) _this.toggleValue(_this.search, false);
    })).subscribe(function () {
      if (_this.inputType == 'select') _this.filterSuggestions();
      _this.$timeout(function () {
        return _this.onChanged();
      }, 100);
    }), rx.Observable.merge(observeOnScope($scope, '$ctrl.dimension')).filter(function (value) {
      return value.newValue !== 'value' && value.newValue !== 'boolean';
    }).do(function () {
      _this.value = _this.value.filter(function (v) {
        return v;
      });
      // this.search = '';
      // this.value = [];
      _this.loading = true;
      _this.suggestions = [];
    }).debounce(200).switchMap(function () {
      return _this.getSuggestions();
    }).do(function () {
      _this.loading = false;
    }).subscribe(function (suggestions) {
      _this.suggestions = suggestions;
      _this.filterSuggestions();
      $scope.$digest();
    }, function (error) {
      console.error(error);
      _this.loading = false;
      $scope.$digest();
    })];
    this.error = false;
  }

  _createClass(ValueBuilderController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this2 = this;

      this.$element.find('.select-value').mouseleave(function (e) {
        _this2.setValueObject();
        if (_this2.multiple) {
          _this2.isOptionsOpen = false;
          _this2.$timeout(function () {
            return _this2.onChanged();
          }, 100);
        }
      });
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.subscriptions.forEach(function (s) {
        if (s.dispose) s.dispose();
      });
    }
  }, {
    key: 'setSize',
    value: function setSize(length) {
      return this.size = length > 20 ? 20 : length < 2 ? 2 : length;
    }
  }, {
    key: 'getDropdownValue',
    value: function getDropdownValue(cell) {
      return this.CurrentModelService.model.getCellFilter(this.fullDimension, cell).label;
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions() {
      var _this3 = this;

      return this.rx.Observable.fromPromise(this.$http.get('/analytics/values/' + this.CurrentModelService.cube.name + '/?drill=' + this.fullDimension)).map(function (suggestions) {
        return suggestions.data.cells.map(function (cell) {
          return _this3.getDropdownValue(cell);
        }).filter(function (v) {
          return v;
        }).sort();
      });
    }
  }, {
    key: 'onChangedValue',
    value: function onChangedValue() {
      var _this4 = this;

      this.$timeout(function () {
        return _this4.onChanged();
      }, 100);
    }
  }, {
    key: 'onSearchFocus',
    value: function onSearchFocus() {
      // this.focused = true;
      this.isOptionsOpen = true;
    }
  }, {
    key: 'onSearchBlur',
    value: function onSearchBlur() {
      if (!this.multiple) this.isOptionsOpen = false;
    }
  }, {
    key: 'isSelectedOption',
    value: function isSelectedOption(option) {
      if (!this.valueObj) return false;
      return this.valueObj[option];
    }
  }, {
    key: 'onSearchEnter',
    value: function onSearchEnter(e) {
      if (e && e.keyCode != 13) return;
      this.toggleValue(this.search, false);
      if (this.multiple) this.search = '';
      this.$scope.$emit('searchChange');
    }
  }, {
    key: 'onSearchChange',
    value: function onSearchChange() {
      this.$scope.$emit('searchChange');
    }
  }, {
    key: 'cleanSearch',
    value: function cleanSearch() {
      this.search = '';
      this.value = [];
      this.$scope.$emit('searchChange');
    }
  }, {
    key: 'toggleValue',
    value: function toggleValue(value, needDelete) {
      if (!value) return;
      if (!this.valueObj) this.setValueObject();
      if (this.multiple) {
        var hasValue = this.isSelectedOption(value);
        if (hasValue) {
          if (needDelete) this.value = this.value.filter(function (V) {
            return V !== value;
          });
        } else {
          if (!this.value[0]) this.value[0] = value;else this.value.push(value);
        }
      } else {
        this.search = value;
        this.value[0] = value;
      }
      this.setValueObject();
      this.$scope.$emit('searchChange');
    }
  }, {
    key: 'setValueObject',
    value: function setValueObject() {
      this.valueObj = this.value ? this.value.reduce(function (res, v) {
        if (v) res[v] = true;
        return res;
      }, {}) : {};
    }
  }, {
    key: 'filterSuggestions',
    value: function filterSuggestions() {
      var _this5 = this;

      var reg = new RegExp(this.search, 'i');
      this.filteredSuggestions = this.suggestions.filter(function (suggestion) {
        return (_this5.search ? suggestion.match(reg) : true) && !_this5.valueObj[suggestion];
      });
      this.$scope.$emit('searchChange');
    }
  }, {
    key: 'fullDimension',
    get: function get() {
      return this.dimension ? this.dimension : 'agent_agent@computer_name:computer_name';
    }
  }, {
    key: 'hasfilteredSuggestions',
    get: function get() {
      return this.filteredSuggestions.length > 0;
    }
  }]);

  return ValueBuilderController;
}();

var ValueBuilderComponent = exports.ValueBuilderComponent = {
  bindings: {
    value: '=',
    dimension: '<',
    inputType: '<',
    multiple: '<',
    onChanged: '&'
  },
  template: __webpack_require__(815),
  controller: ValueBuilderController
};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports = "<input ng-if=\"$ctrl.inputType == 'checkbox'\" class=\"checkbox\" type=\"checkbox\" ng-model=\"$ctrl.value[0]\" ng-change=\"$ctrl.onChangedValue()\"><div ng-if=\"$ctrl.inputType != 'checkbox' && $ctrl.multiple\" class=\"selected-value\"><span class=\"badge\" title=\"{{::'Удалить' | gettext }}\" ng-click=\"$ctrl.toggleValue(val, true)\" ng-repeat=\"val in $ctrl.value  track by $index\">{{val}} <i class=\"icon-cancel\"></i></span></div><div ng-show=\"$ctrl.inputType != 'checkbox'\" class=\"select-value\"><input ng-model=\"$ctrl.search\" class=\"search\" ng-keydown=\"$ctrl.onSearchEnter($event)\" ng-change=\"$ctrl.onSearchChange()\" ng-focus=\"$ctrl.onSearchFocus()\" ng-blur=\"$ctrl.onSearchBlur()\"> <i ng-if=\"$ctrl.loading\" class=\"icon-loading animate-spin\"></i> <i ng-if=\"!$ctrl.loading && $ctrl.multiple\" class=\"icon-enter\" title=\"{{::'Добавить значение' | gettext }}\" ng-click=\"$ctrl.onSearchEnter()\"></i> <i ng-if=\"!$ctrl.loading && !$ctrl.multiple\" class=\"icon-cancel\" title=\"{{::'Очистить' | gettext }}\" ng-click=\"$ctrl.cleanSearch()\"></i><div ng-if=\"$ctrl.inputType == 'select' && $ctrl.hasfilteredSuggestions\" ng-show=\"$ctrl.isOptionsOpen\" class=\"select-dropdown\"><div class=\"select-dropdown-option\" ng-repeat=\"suggestion in $ctrl.filteredSuggestions track by $index\" ng-mousedown=\"$ctrl.toggleValue(suggestion, true)\">{{suggestion}}</div></div></div>"

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(817);

var FilterValueInputController = exports.FilterValueInputController = function () {
  function FilterValueInputController($scope, $element, $http, rx, observeOnScope, CurrentModelService, ErrorHandlerService) {
    var _this = this;

    _classCallCheck(this, FilterValueInputController);

    this.$scope = $scope;
    this.$element = $element;
    this.$http = $http;
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.current = {
      label: this.label,
      value: this.value
    };
    this.subscriptions = [rx.Observable.merge(observeOnScope($scope, '$ctrl.dimension'), observeOnScope($scope, '$ctrl.hierarchy')).filter(function (value) {
      return value;
    }).debounce(200).do(function () {
      _this.loading = true;
      _this.suggestions = [];
      $scope.$digest();
    }).switchMap(function () {
      return _this.getSuggestions();
    }).do(function () {
      _this.loading = false;
      _this.current = {
        label: _this.label,
        value: _this.value
      };
    }).subscribe(function (suggestions) {
      _this.suggestions = suggestions;
      // if (suggestions.length) {
      //   this.value = suggestions[0]['agent_eventtype.id'];
      //   this.label = suggestions[0]['agent_eventtype.description'];
      // }
      _this.filterSuggestions();
      $scope.$digest();
    }, function (error) {
      console.error(error);
      _this.loading = false;
      $scope.$digest();
    })];
    this.error = false;
  }

  _createClass(FilterValueInputController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.subscriptions.forEach(function (s) {
        return s.dispose();
      });
    }
  }, {
    key: 'setValue',
    value: function setValue(suggestion) {
      var cellFilter = this.CurrentModelService.model.getCellFilter(this.fullDimension, suggestion);
      this.value = cellFilter.value;
      this.label = cellFilter.label;
      this.current = {
        label: this.label,
        value: this.value
      };
    }
  }, {
    key: 'getDropdownLabel',
    value: function getDropdownLabel(suggestion) {
      return suggestion.dropdownLabel || (suggestion.dropdownLabel = this.CurrentModelService.model.getCellLabel(this.fullDimension, suggestion));
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions() {
      return this.rx.Observable.fromPromise(this.$http.get('/analytics/values/' + this.CurrentModelService.cube.name + '/?drill=' + this.fullDimension)).map(function (suggestions) {
        return suggestions.data.cells;
      });
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.focused = true;
      this.isOpen = true;
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      // this.ErrorHandlerService.filterErrorMessage.text = null;
      // this.ErrorHandlerService.filterErrorMessage.sourse = 'query-dimention';
      this.focused = false;
      this.isOpen = false;
      if (this.current.value) {
        this.value = this.current.value;
        this.label = this.current.label;
        return;
      }
      if (this.filteredSuggestions.length) {
        this.setValue(this.filteredSuggestions[0]);
        return;
      }
      this.value = this.current.value ? this.current.value : this.current.label;
      this.label = this.current.label;
    }
  }, {
    key: 'filterSuggestions',
    value: function filterSuggestions() {
      var _this2 = this;

      // if(!this.value) this.setValue(this.suggestions[0]);
      this.current.value = null;
      this.filteredSuggestions = this.current.label ? this.suggestions.filter(function (suggestion) {
        return _this2.getDropdownLabel(suggestion).toLowerCase().startsWith(_this2.current.label.toLowerCase());
      }) : this.suggestions;
      // if (!this.filteredSuggestions.length) this.filteredSuggestions = angular.copy(this.suggestions);
    }
  }, {
    key: 'fullDimension',
    get: function get() {

      try {
        var hierarchy = this.CurrentModelService.model.getHierarchy(this.dimension + '@' + this.hierarchy).toString();
        this.prevDimension = this.dimension;
        this.prevHierarchy = this.hierarchy;
        return hierarchy;
      } catch (err) {

        this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильные параметры') + (' "dimension" : "' + this.dimension + '" ') + gettext('или') + (' "hierarchy" : "' + this.hierarchy + '"');
        this.ErrorHandlerService.filterErrorMessage.sourse = 'query-dimention';

        console.error(this.ErrorHandlerService.filterErrorMessage.text);
        // console.error(err);
        return 'agent_eventtype@default:agent_eventtype';
      }
    }
  }]);

  return FilterValueInputController;
}();

var FilterValueInputComponent = exports.FilterValueInputComponent = {
  bindings: {
    value: '=',
    label: '=',
    dimension: '<',
    multiple: '<',
    hierarchy: '<'
  },
  template: __webpack_require__(818),
  controller: FilterValueInputController
};

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-control\" ng-class=\"{loading: $ctrl.loading, focused: $ctrl.focused, open: $ctrl.isOpen}\"><input autocomplete=\"off\" class=\"input-xlarge\" ng-model=\"$ctrl.current.label\" ng-change=\"$ctrl.filterSuggestions()\" ng-focus=\"$ctrl.onFocus()\" ng-blur=\"$ctrl.onBlur()\"></div><div ng-show=\"$ctrl.isOpen\" class=\"select-dropdown\"><div class=\"select-dropdown-option\" ng-repeat=\"suggestion in $ctrl.filteredSuggestions\" ng-mousedown=\"$ctrl.setValue(suggestion, $index)\" ng-bind-html=\"$ctrl.getDropdownLabel(suggestion)\"></div></div>"

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QueryBuilderNodeComponent = exports.QueryBuilderNodeController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeDimensions = __webpack_require__(147);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(820);

var conditionsMeta = {
  '=': {
    name: '=',
    label: gettext('Равно'),
    controlType: 'value'
  },
  '!': {
    name: '!',
    label: gettext('Не равно'),
    controlType: 'value'
  },
  '^': {
    name: '^',
    label: gettext('Содержит'),
    controlType: 'text'
  },
  '!^': {
    name: '!^',
    label: gettext('Не содержит'),
    controlType: 'text'
  }
};

var QueryBuilderNodeController = exports.QueryBuilderNodeController = function () {
  function QueryBuilderNodeController($scope, CurrentModelService, ErrorHandlerService) {
    _classCallCheck(this, QueryBuilderNodeController);

    this.$scope = $scope;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;

    this.operators = ['AND', 'OR'];
    this.operatorLabels = {
      'AND': gettext('И'),
      'OR': gettext('ИЛИ')
    };
    this.conditionsMeta = conditionsMeta;
    this.dimension = this.dimensions[0];
    this.node = null;
    this.nodeValue = '';
  }

  _createClass(QueryBuilderNodeController, [{
    key: '$postLink',
    value: function $postLink() {
      var _this = this;

      if (this.isCondition) {
        this.dimension = this.dimensions.find(function (dimension) {
          return dimension.name.startsWith(_this.node.dimension);
        });
        if (!this.dimension) {
          this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильный параметр') + (' "dimension" : "' + this.node.dimension + '" ');
          this.ErrorHandlerService.filterErrorMessage.sourse = 'query-builder';
        }
        this.updateConditions();
        this.$scope.$watch('$ctrl.node.condition', function (newValue, oldValue) {
          if (!newValue) return;
          try {
            var newType = _this.conditionsMeta[newValue].controlType;
            var oldType = oldValue ? _this.conditionsMeta[oldValue].controlType : null;
            if (newType !== oldType) {
              _this.resetNodeValue();
            }
            _this.nodeValue = _this.node.value;
          } catch (err) {//
          }
        });
      }
    }
  }, {
    key: 'addCondition',
    value: function addCondition() {
      // if (this.isQueryError) return;
      var dimension = this.dimensions[0];
      this.node.group.rules.push({
        condition: '=',
        dimension: dimension.name,
        hierarchy: dimension.getDefaultHierarchy().name,
        value: ''
      });
    }
  }, {
    key: 'addGroup',
    value: function addGroup() {
      // if (this.isQueryError) return;
      this.node.group.rules.push(this.createGroup());
    }
  }, {
    key: 'createGroup',
    value: function createGroup() {
      return {
        group: {
          operator: this.operators[0],
          rules: []
        }
      };
    }
  }, {
    key: 'remove',
    value: function remove() {
      var _this2 = this;

      if ('node' in this.$scope.$parent.$ctrl) {
        this.$scope.$parent.$ctrl.node.group.rules = this.$scope.$parent.$ctrl.node.group.rules.filter(function (r) {
          return r !== _this2.node;
        });
      }
    }
  }, {
    key: 'onDimensionChange',
    value: function onDimensionChange() {
      this.node.dimension = this.dimension.name;
      this.node.hierarchy = this.dimension.getDefaultHierarchy().name;
      this.resetNodeValue();
      this.updateConditions();
    }
  }, {
    key: 'resetNodeValue',
    value: function resetNodeValue() {
      if (this.node.condition === '^' || this.node.condition === '!^') {
        this.node.value = this.nodeValue;
        this.node.label = this.nodeValue;
      } else {
        this.node.value = '';
        this.node.label = '';
      }
    }
  }, {
    key: 'onHierarchyChange',
    value: function onHierarchyChange() {
      this.resetNodeValue();
      this.updateConditions();
    }
  }, {
    key: 'onConditionChange',
    value: function onConditionChange() {}
  }, {
    key: 'isSearchable1',
    value: function isSearchable1() {
      return false;
    }
  }, {
    key: 'isSearchable',
    value: function isSearchable() {
      if ((0, _typeDimensions.isStrictDimention)(this.node.dimension, this.node.hierarchy)) return false;
      try {
        var hierarchy = this.CurrentModelService.model.getHierarchy(this.node.dimension, this.node.hierarchy);
        return hierarchy.levels.some(function (level) {
          return hierarchy.dimension.getLevel(level).attributes.some(function (attr) {
            return attr.search;
          });
        });
      } catch (err) {

        this.ErrorHandlerService.filterErrorMessage.text = gettext('Неправильные параметры') + (' "dimension" : "' + this.node.dimension + '" ') + gettext('или') + (' "hierarchy" : "' + this.node.hierarchy + '"');
        this.ErrorHandlerService.filterErrorMessage.sourse = 'query-builder';

        return null;
      }
    }
  }, {
    key: 'updateConditions',
    value: function updateConditions() {
      if (this.isSearchable()) {
        this.conditions = [conditionsMeta['='], conditionsMeta['!'], conditionsMeta['^'], conditionsMeta['!^']];
      } else {
        this.conditions = [conditionsMeta['='], conditionsMeta['!']];
      }
      if (!this.node.condition) {
        var errMessage = gettext('"condition" обязателен');
        this.$scope.$emit('error', errMessage);
        return;
      }
      if (this.conditions.indexOf(conditionsMeta[this.node.condition]) === -1) {
        this.node.condition = this.conditions[0].name;
      }
    }
  }, {
    key: 'onSelectValue',
    value: function onSelectValue(filter) {
      if (this.node.value) {
        this.node.value.push(filter);
      } else {
        this.node.value = [filter];
      }
    }
  }, {
    key: 'isQueryError',
    get: function get() {
      return !!(this.ErrorHandlerService.filterErrorMessage && this.ErrorHandlerService.filterErrorMessage.text);
    }
  }, {
    key: 'isCondition',
    get: function get() {
      return this.node && !this.node.hasOwnProperty('group');
    }
  }, {
    key: 'isGroup',
    get: function get() {
      return !this.isCondition;
    }
  }, {
    key: 'dimensions',
    get: function get() {
      return this.CurrentModelService.model ? this.CurrentModelService.model.dimensions : '';
    }
  }]);

  return QueryBuilderNodeController;
}();

var QueryBuilderNodeComponent = exports.QueryBuilderNodeComponent = {
  bindings: {
    node: '<',
    isRoot: '<?'
  },
  template: __webpack_require__(821),
  controller: QueryBuilderNodeController
};

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div ng-switch=\"$ctrl.isGroup\"><div ng-switch-when=\"true\"><div class=\"query query-warning query-group\"><div class=\"form-inline\"><select ng-options=\"$ctrl.operatorLabels[o] for o in $ctrl.operators\" ng-model=\"$ctrl.node.group.operator\" class=\"input-mini\"></select><div class=\"btn-group\"><i class=\"icon-plus pointer\" ng-click=\"$ctrl.addCondition()\" title=\"{{:: 'Добавить условие' | gettext }}\"></i> <i class=\"icon-code pointer\" title=\"{{:: 'Добавить группу' | gettext }}\" ng-click=\"$ctrl.addGroup()\"></i> <i class=\"icon-cancel-1\" ng-click=\"$ctrl.remove()\" ng-if=\"!$ctrl.isRoot\" title=\"{{:: 'Удалить группу' | gettext }}\"></i></div></div><div class=\"group-conditions\"><div ng-repeat=\"rule in $ctrl.node.group.rules | orderBy:'index'\" class=\"condition\"><sc-query-builder-node node=\"rule\"></sc-query-builder-node></div></div></div></div><div ng-switch-default=\"ng-switch-default\"><div class=\"query query-warning query-group\"><div class=\"form-inline\"><select ng-model=\"$ctrl.dimension\" ng-options=\"dimension as dimension.label for dimension in $ctrl.dimensions\" ng-change=\"$ctrl.onDimensionChange()\" class=\"input-large\"></select><select ng-if=\"$ctrl.dimension.hierarchies.length > 1\" ng-model=\"$ctrl.node.hierarchy\" ng-class=\"{hidden: $ctrl.dimension.hierarchies.length < 2}\" ng-change=\"$ctrl.onHierarchyChange()\" class=\"input-large\"><option ng-repeat=\"hierarchy in $ctrl.dimension.hierarchies\" value=\"{{hierarchy.name}}\">{{hierarchy.label}}</option></select><select ng-model=\"$ctrl.node.condition\" ng-change=\"$ctrl.onConditionChange()\" class=\"input-medium\"><option ng-repeat=\"condition in $ctrl.conditions\" value=\"{{condition.name}}\">{{condition.label}}</option></select><span ng-switch=\"$ctrl.conditionsMeta[$ctrl.node.condition].controlType\"><sc-filter-value-input ng-switch-when=\"value\" value=\"$ctrl.node.value\" label=\"$ctrl.node.label\" dimension=\"$ctrl.node.dimension\" hierarchy=\"$ctrl.node.hierarchy\" multiple=\"$ctrl.conditionsMeta[$ctrl.node.condition].multiple\" class=\"input-xlarge\"></sc-filter-value-input><input ng-switch-when=\"text\" type=\"text\" class=\"input-xlarge condition-search-value\" ng-model=\"$ctrl.nodeValue\" ng-blur=\"$ctrl.node.value=$ctrl.nodeValue; $ctrl.node.label=$ctrl.nodeValue; \"> </span><i class=\"icon-cancel-1 pointer\" ng-click=\"$ctrl.remove()\" title=\"{{:: 'Удалить условие' | gettext }}\"></i></div></div></div></div>"

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FilterEditorService = exports.FilterEditorService = function () {
  function FilterEditorService($q, $timeout, $rootScope, FilterEditorModalService, FilterCardEditorModalService, FiltersCutEditorModalService, RulesEditorModalService, FiltersService, FilterResource, CurrentModelService, RouterService, CurrentFilterService, CurrentFilterDataService, AdminModalService) {
    _classCallCheck(this, FilterEditorService);

    this.$q = $q;
    this.$rootScope = $rootScope;
    this.$timeout = $timeout;
    this.FilterEditorModalService = FilterEditorModalService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.FiltersCutEditorModalService = FiltersCutEditorModalService;
    this.RulesEditorModalService = RulesEditorModalService;
    this.FiltersService = FiltersService;
    this.FilterResource = FilterResource;
    this.CurrentModelService = CurrentModelService;
    this.RouterService = RouterService;
    this.RouterService.FilterEditorService = this;
    this.modalInstance = null;
    this.isOpened = false;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.needReload = false;
    this.AdminModalService = AdminModalService;
  }

  _createClass(FilterEditorService, [{
    key: 'editModal',
    value: function editModal(_ref) {
      var _this = this;

      var filter = _ref.filter,
          asNew = _ref.asNew,
          selectFilter = _ref.selectFilter,
          type = _ref.type,
          tabName = _ref.tabName;

      if (this.isOpened) return;
      this.isOpened = true;
      if (!this.RouterService.modal) {
        this.RouterService.modal = 'filter-edit';
        this.RouterService.type = type;
      }
      return this.$q.resolve().then(function () {
        if (_this.RouterService.modal === 'cut-edit' && _this.cut) {
          var openRes = _this.FiltersCutEditorModalService.open(_this.cut, _this.FiltersService, asNew);
          _this.modalInstance = _this.FiltersCutEditorModalService.modalInstance;
          return openRes;
        }
        if (_this.RouterService.modal === 'rules-edit' && _this.cut) {
          var rl = _this.RulesEditorModalService;
          var _openRes = _this.RulesEditorModalService.open(_this.cut, _this.FiltersService, asNew);
          _this.modalInstance = _this.RulesEditorModalService.modalInstance;
          return _openRes;
        }
        if (_this.RouterService.isFilterEditModal && _this.RouterService.modal === 'filter-edit' && _this.cut && _this.cut.dimension === 'analytics_filter@name:name') {
          filter = _this.FiltersService.find(function (f) {
            return f.name === _this.cut.value;
          });
          if (!filter) return;
          selectFilter = false;
          _this.needReload = true;
          // this.reloadUrl = this.RouterService
          var _openRes2 = _this.FilterEditorModalService.open(_this.CurrentModelService.model, filter);
          _this.modalInstance = _this.FilterEditorModalService.modalInstance;
          return _openRes2;
        }
        if (_this.RouterService.isFilterEditModal) {
          var _openRes3 = _this.FilterEditorModalService.open(_this.CurrentModelService.model, filter, asNew, tabName);
          _this.modalInstance = _this.FilterEditorModalService.modalInstance;
          return _openRes3;
        }
      }).then(function (filterEdit) {
        if (_this.RouterService.isFilterEditModal) {
          _this.removeModal();
          if (filterEdit.deleted) {
            if (_this.RouterService.isEditDasboard) return filterEdit;else {
              _this.onDeleteFilter(filter);
              return filter;
            }
          }
          filterEdit.isChanged = false;

          if (_this.RouterService.isEditDasboard && _this.CurrentFilterService.filter.id !== filterEdit.id) {
            filterEdit.isChanged = true;
            _this.RouterService.isEditDasboard = false;
            var targetFilter = _this.CurrentFilterService.filter.isCardFilter ? _this.CurrentFilterService.filter.cardFilter : _this.CurrentFilterService.filter;
            if (!filterEdit.dIndex) {
              targetFilter.children.push(filterEdit);
              // this.$timeout(() => this.RouterService.$rootScope.$apply(), 10);
              _this.RouterService.filter = targetFilter;
            }
            return filterEdit;
          }
          _this.RouterService.isEditDasboard = false;

          if (asNew || !filter.id) {
            _this.FiltersService.filters.push(filterEdit);
          } else {
            var originalFilter = _this.FiltersService.findById(filterEdit.id);
            Object.keys(originalFilter).map(function (k) {
              return delete originalFilter[k];
            });
            Object.assign(originalFilter, filterEdit);
          }
          Object.keys(filter).map(function (k) {
            return delete filter[k];
          });
          Object.assign(filter, filterEdit);
          if (selectFilter) {
            _this.RouterService.selectFilter(filterEdit.id, true);
          } else if (_this.needReload) {
            window.CACHE.reset();
            _this.$rootScope.$broadcast('reload');
          }
        } else {
          _this.removeModal();
        }
        _this.RouterService.isEditDasboard = false;
        if (filter.isPolitic && filter.applyType === 'all') _this.AdminModalService.terminalCommand('reset_sessions', gettext('Перестроить отчеты'));
        return filterEdit;
      }).catch(function (error) {
        _this.RouterService.isEditDasboard = false;
        _this.removeModal();
      });
    }
  }, {
    key: 'saveChildrenOrder',
    value: function saveChildrenOrder(filter) {
      var _this2 = this;

      var chain = this.$q.when();

      var _loop = function _loop(i) {
        if (!filter.children[i].deleted) {
          chain = chain.then(function (res) {
            return _this2.FilterResource.changePosition(filter.children[i].id, i ? filter.children[i - 1].id : null, filter.id);
          });
        }
      };

      for (var i = 0; filter.children && i < filter.children.length; i++) {
        _loop(i);
      }
      return chain;
    }
  }, {
    key: 'saveChildren',
    value: function saveChildren(filter) {
      var _this3 = this;

      var chain = this.$q.when();
      if (filter.children) {
        filter.children.filter(function (f) {
          return f.isChanged || f.deleted;
        }).forEach(function (child) {
          chain = chain.then(function () {
            if (child.deleted) {
              return _this3.FiltersService.delete(child);
            }
            return _this3.FiltersService.save(child);
          });
        });
      }
      return chain;
    }
  }, {
    key: 'saveFilter',
    value: function saveFilter(asNew) {
      var _this4 = this;

      var filter = this.CurrentFilterService.filter;
      if ((asNew || !filter.id) && !filter.isDashboard) {
        this.editModal({
          filter: filter,
          asNew: asNew,
          selectFilter: true
        });
        return;
      }

      if (filter.isDashboard) {
        this.FiltersService.save(filter)
        // .then(() => console.log('Сохранил дашборд:', filter.id, filter.name))
        .then(function () {
          return _this4.saveChildren(filter);
        })
        // .then(() => console.log('сохранил всех детей:', filter.id, filter.name))
        .then(function () {
          return _this4.saveChildrenOrder(filter);
        })
        // .then(() => console.log('запомнил порядок:', filter.id, filter.name))
        .then(function () {
          return _this4.RouterService.filterChanged();
        });
      } else {
        this.FiltersService.save(filter).then(function () {
          return _this4.RouterService.filterChanged();
        });
      }
    }
  }, {
    key: 'onDeleteFilter',
    value: function onDeleteFilter(filter) {
      this.FiltersService.onDeleteFilter(filter);
      this.RouterService.onDeleteFilter();
      this.removeModal();
    }
  }, {
    key: 'removeModal',
    value: function removeModal() {
      this.RouterService.removeModal();
      this.isOpened = false;
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      if (this.isOpened && this.modalInstance) this.modalInstance.close();
      // delete this.RulesEditorModalService;
      this.RouterService.type = undefined;
    }
  }]);

  return FilterEditorService;
}();

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(824);

var FilterCardEditorCellController = exports.FilterCardEditorCellController = function () {
  function FilterCardEditorCellController($scope, $element) {
    _classCallCheck(this, FilterCardEditorCellController);

    this.$scope = $scope;
    this.$element = $element;
  }

  _createClass(FilterCardEditorCellController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {}
  }, {
    key: 'getHeight',
    value: function getHeight() {
      if (!this.filter || !this.filter.cardHeight) {
        return 'auto';
      }
      var marginHorz = 0.5; // percent
      var marginVert = 7; // px
      return (this.$element.parent().width() * 0.01 * this.filter.cardHeight * (100 - 13 * marginHorz) / 12 + marginVert * 2 * (this.filter.cardHeight - 1)).toFixed(0) + 'px';
    }
  }]);

  return FilterCardEditorCellController;
}();

var FilterCardEditorCellComponent = exports.FilterCardEditorCellComponent = {
  bindings: {
    filter: '<'
  },
  template: __webpack_require__(825),
  controller: FilterCardEditorCellController
};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sc-card-cell\" ng-style=\"{height: $ctrl.getHeight()}\"><div class=\"sc-card-cell-title\">{{$ctrl.filter.name}}</div><div class=\"sc-card-cell-form\"><div class=\"sc-card-cell-control\"><div>{{:: 'Ширина' | gettext}}</div><input type=\"number\" max=\"12\" min=\"1\" ng-model=\"$ctrl.filter.cardWidth\"></div><div class=\"sc-card-cell-control\"><div>{{:: 'Высота' | gettext}}</div><input type=\"number\" max=\"36\" min=\"0\" ng-model=\"$ctrl.filter.cardHeight\"></div></div></div>"

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(332);
__webpack_require__(827);

var OCR_LANGUAGES = [{ label: gettext('Английский'), value: 'eng' }, { label: gettext('Русский'), value: 'rus' }, { label: gettext('Казахский'), value: 'kaz' }];

var ocrFilterEditorController = exports.ocrFilterEditorController = function () {
  function ocrFilterEditorController($scope, CurrentModelService) {
    _classCallCheck(this, ocrFilterEditorController);

    this.$scope = $scope;
    this.CurrentModelService = CurrentModelService;
  }

  _createClass(ocrFilterEditorController, [{
    key: '$onInit',
    value: function $onInit() {

      this.$scope.filter = this.filter.filter;

      this.$scope.languages = OCR_LANGUAGES;

      if (!this.$scope.filter.languages) {
        this.$scope.filter.languages = [OCR_LANGUAGES[0].value];
      } else {

        var languages = '';

        var originLanguages = [];

        if (typeof this.$scope.filter.languages == 'string') {

          languages = this.$scope.filter.languages.split('+');
        } else {
          languages = this.$scope.filter.languages;
        }

        for (var i = 0; i < OCR_LANGUAGES.length; i++) {
          if (languages.includes(OCR_LANGUAGES[i].value)) {
            originLanguages.push(OCR_LANGUAGES[i].value);
          }
        }
        if (!originLanguages.length) {
          this.$scope.filter.languages = [OCR_LANGUAGES[0].value];
        } else {
          this.$scope.filter.languages = originLanguages;
        }
      }
    }
  }, {
    key: 'filterText',
    get: function get() {
      return JSON.stringify(this.filter, undefined, 2);
    }
  }]);

  return ocrFilterEditorController;
}();

var OcrFilterEditorComponent = exports.OcrFilterEditorComponent = {
  bindings: {
    filter: '<'
    // filter: '=',
  },
  template: __webpack_require__(828),
  controller: ocrFilterEditorController
};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports = "<div class=\"filter-prop-tab form-horizontal\"><div class=\"control-group\"><div class=\"controls\"><label class=\"radio\"><input type=\"radio\" name=\"ocr_engine\" id=\"optionsRadios1\" value=\"nicomsoft\" ng-model=\"filter.action\"> {{:: 'Встроенный OCR' | gettext }}</label><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"filter.orientation\" ng-disabled=\"filter.action !== 'nicomsoft'\"> {{:: 'Распознавать перевёрнутые' | gettext }}</label><label><ui-select multiple=\"multiple\" ng-model=\"filter.languages\" ng-disabled=\"filter.action !== 'nicomsoft'\" close-on-select=\"false\" style=\"width:300px\" title=\"{{:: 'Выберите язык для OCR' | gettext }}\" theme=\"bootstrap\" limit=\"5\"><ui-select-choices repeat=\"language.value as language in languages | filter:$select.search\">{{language.label}}</ui-select-choices><ui-select-match placeholder=\"{{:: 'Выберите язык для OCR' | gettext }}\">{{$item.label}}</ui-select-match></ui-select></label><label class=\"radio\"><input type=\"radio\" name=\"ocr_engine\" id=\"optionsRadios2\" value=\"abbyy\" ng-model=\"filter.action\"> {{:: 'Облако ABBYY' | gettext }}</label></div></div><div class=\"control-group\"><label class=\"control-label\">{{:: 'AppID' | gettext}}</label><div class=\"controls\"><input type=\"text\" ng-model=\"filter.ocr_app_id\" ng-disabled=\"filter.action !== 'abbyy'\"></div></div><div class=\"control-group\"><label class=\"control-label\">{{:: 'Пароль' | gettext}}</label><div class=\"controls\"><input type=\"password\" ng-model=\"filter.ocr_app_password\" ng-disabled=\"filter.action !== 'abbyy'\"><legend class=\"warning\">{{:: 'Для распознавания текста при помощи облака ABBYY, введите ваш App ID и пароль' | gettext}}</legend></div></div></div>"

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CatalogNodeDragService = exports.CatalogNodeDragService = function () {
  function CatalogNodeDragService(
  // $http,
  FilterResource, FiltersService, LayoutService) {
    _classCallCheck(this, CatalogNodeDragService);

    // this.CurrentFilterService = CurrentFilterService;
    this.passedElement = null;
    this.FilterResource = FilterResource;
    this.FiltersService = FiltersService;
    this.layout = LayoutService;
    // this.$http = $http;
    this.dropHistory = {
      currentIndex: -1,
      positions: []
    };
  }

  _createClass(CatalogNodeDragService, [{
    key: 'reDo',
    value: function reDo() {
      if (!this.layout.editCatalog) return false;
      if (this.dropHistory.currentIndex >= this.dropHistory.positions.length - 1) return;
      this.dropHistory.currentIndex += 1;
      this.moveFilterCtrlZ(this.dropHistory.positions[this.dropHistory.currentIndex].target);
    }
  }, {
    key: 'unDo',
    value: function unDo() {
      if (!this.layout.editCatalog) return false;
      if (this.dropHistory.currentIndex < 0) return;
      this.moveFilterCtrlZ(this.dropHistory.positions[this.dropHistory.currentIndex].src);
      this.dropHistory.currentIndex -= 1;
    }
  }, {
    key: 'keyUp',
    value: function keyUp(event) {
      if (event.ctrlKey && event.keyCode === 90) {
        if (event.shiftKey) this.reDo();else this.unDo();
      }
    }
  }, {
    key: 'moveFilterCtrlZ',
    value: function moveFilterCtrlZ(position) {
      var _this = this;

      if (!this.layout.editCatalog) return false;
      this.FilterResource.changePosition(position.id, position.prev_id, position.parent_id).then(function (_ref) {
        var data = _ref.data,
            status = _ref.status;

        var parentFilter = _this.FiltersService.find(function (f) {
          return f.children.some(function (fl) {
            return fl.id === position.id;
          });
        });
        var srcList = parentFilter ? parentFilter.children : _this.FiltersService.filters;
        var srcIndex = srcList.findIndex(function (f) {
          return f.id === position.id;
        });

        var targetList = position.parent_id ? _this.FiltersService.findById(position.parent_id).children : _this.FiltersService.filters;
        var targetIndex = position.prev_id ? targetList.findIndex(function (f) {
          return f.id === position.prev_id;
        }) + 1 : 0;

        targetList.splice(targetIndex, 0, srcList[srcIndex]);
        if (targetList === srcList && targetIndex <= srcIndex) srcIndex += 1;
        srcList.splice(srcIndex, 1);
      }).catch(function (_ref2) {
        var data = _ref2.data,
            status = _ref2.status;

        console.error(status, data);
        _this.setDragoverClass(_this.passedElement, false);
        return false;
      });
    }
  }, {
    key: 'hasFlterSachList',
    value: function hasFlterSachList(filrer, list) {
      var res = false;
      var iter = function iter(children, list) {
        if (children === list) {
          res = true;
          return true;
        }
        return children.some(function (f) {
          return iter(f.children, list);
        });
      };
      iter(filrer.children, list);
      return res;
    }
  }, {
    key: 'onDrop',
    value: function onDrop(srcList, srcIndex, target, targetIndex, parentId) {
      var _this2 = this;

      if (!this.layout.editCatalog) return false;
      if (!this.passedElement || targetIndex === -1 || srcList[srcIndex].children === target.list || this.hasFlterSachList(srcList[srcIndex], target.list)) {
        this.setDragoverClass(this.passedElement, false);
        return false;
      }

      var position = {
        id: srcList[srcIndex].id
      };

      var positionList = target.list;
      var positionIndex = targetIndex;
      var id = Number.parseInt(this.passedElement.id, 0);
      if (Number.isInteger(id)) {
        var filter = null;
        positionList.some(function (fl) {
          if (fl.id === id) {
            filter = fl;
            return true;
          }
          return false;
        });
        if (!filter || !filter.isContainer || srcList[srcIndex] === filter) {
          this.setDragoverClass(this.passedElement, false);
          return false;
        }
        positionList = filter.children;
        positionIndex = filter.children.length;

        position.parent_id = filter.id;
        position.prev_id = positionIndex ? positionList[positionIndex - 1].id : null;
      } else {
        position.parent_id = target.id;
        if (srcList === positionList && positionIndex - 1 === srcIndex) position.prev_id = null;else position.prev_id = positionIndex ? positionList[positionIndex - 1].id : null;
      }
      if (position.prev_id === position.id) return false;
      this.FilterResource.changePosition(position.id, position.prev_id, position.parent_id).then(function (_ref3) {
        var data = _ref3.data,
            status = _ref3.status;

        // save of history
        _this2.dropHistory.currentIndex += 1;
        _this2.dropHistory.positions.splice(_this2.dropHistory.currentIndex, _this2.dropHistory.positions.length);

        var parentFilter = _this2.FiltersService.find(function (f) {
          return f.children === srcList;
        });
        _this2.dropHistory.positions.push({
          src: {
            id: position.id,
            prev_id: srcIndex ? srcList[srcIndex - 1].id : null,
            parent_id: parentFilter ? parentFilter.id : null
          },
          target: {
            id: position.id,
            prev_id: position.prev_id,
            parent_id: position.parent_id
          }
        });
        positionList.splice(positionIndex, 0, srcList[srcIndex]);
        if (srcList === positionList && positionIndex <= srcIndex) srcIndex++;
        // delete filter from old position
        srcList.splice(srcIndex, 1);
        _this2.currentDragOver = -1;
        _this2.setDragoverClass(_this2.passedElement, false);
        _this2.passedElement = null;
      }).catch(function (_ref4) {
        var data = _ref4.data,
            status = _ref4.status;

        console.error(status, data);
        _this2.setDragoverClass(_this2.passedElement, false);
        return false;
      });
      // */
      return true;
    }
  }, {
    key: 'setDragoverClass',
    value: function setDragoverClass(element, isSet) {
      if (!element) return;

      if (element.classList.contains('dndPlaceholder')) {
        if (isSet) element.classList.remove('no-display');else element.classList.add('no-display');
        return;
      }

      if (isSet) {
        element.classList.add('catalog-dragover');
        element.classList.remove('catalog-normal');
      } else {
        element.classList.add('catalog-normal');
        element.classList.remove('catalog-dragover');
      }
    }
  }, {
    key: 'dragoverCallback',
    value: function dragoverCallback(event, targetList, targetIndex, callback) {
      if (!this.layout.editCatalog) return false;
      // if (this.srcList === targetList && this.srcIndex === targetIndex) return false;
      var hidePlaceholder = this.passedElement === event.target || targetList[targetIndex] && !targetList[targetIndex] || this.srcList === targetList && (this.srcIndex === targetIndex || this.srcIndex + 1 === targetIndex);
      if (event.target.classList.contains('dndPlaceholder')) {
        this.setDragoverClass(this.passedElement, false);
        this.passedElement = event.target;

        this.setDragoverClass(this.passedElement, true);
        return true;
      }
      var dndPlaceholder = event.target.closest('div[dnd-list]').querySelector('li.dndPlaceholder');
      if (dndPlaceholder) {
        if (hidePlaceholder) {
          dndPlaceholder.style.height = '0';
          dndPlaceholder.style.display = 'none';
        } else {
          dndPlaceholder.style.height = '25px';
          dndPlaceholder.style.display = 'block';
        }
      }
      var targetElement = event.target.closest('div.catalog-node-header');
      if (targetElement && this.passedElement !== targetElement) {
        this.setDragoverClass(this.passedElement, false);
        this.passedElement = targetElement;
        this.currentDragOver = targetIndex;
        if (targetElement.getAttribute('iscontainer') !== 'true') return false;

        this.setDragoverClass(this.passedElement, true);
      }
      return true;
    }
  }, {
    key: 'dragStart',
    value: function dragStart(srcIndex, srcList) {
      this.srcIndex = srcIndex;
      this.srcList = srcList;
      this.passedElement = document.querySelector('sc-catalog [id=\'' + this.srcList[srcIndex].id + '\']');
    }
  }]);

  return CatalogNodeDragService;
}();

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.EmailTempleteComponent = EmailTempleteComponent;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(831);

var EmailTempleteController = function () {
  function EmailTempleteController($scope, $element, $http, $timeout) {
    var _this = this;

    _classCallCheck(this, EmailTempleteController);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.filterReady = false;
    this.subjectTemplate = this.$scope.filter.email_subject_template;
    this.bodyTemplate = this.$scope.filter.email_body_template;
    $.get('/static/analytics/templates/notify_subject.html', function (data) {
      _this.defaultSubjectTemplate = data;
      if (!_this.$scope.filter.email_subject_template) _this.subjectTemplate = _this.defaultSubjectTemplate;
      _this.$scope.$apply();
      // console.log(data);
    });

    $.get('/static/analytics/templates/notify.html', function (data) {
      _this.defaultBodyTemplate = data;
      if (!_this.$scope.filter.email_body_template) _this.bodyTemplate = _this.defaultBodyTemplate;
      _this.$scope.$apply();
    });
  }

  _createClass(EmailTempleteController, [{
    key: 'acceptTemplete',
    value: function acceptTemplete() {
      if (this.subjectTemplate !== this.defaultSubjectTemplate || this.bodyTemplate !== this.defaultBodyTemplate) {
        this.$scope.filter.email_subject_template = this.subjectTemplate;
        this.$scope.filter.email_body_template = this.bodyTemplate;
      } else {
        delete this.$scope.filter.email_subject_template;
        delete this.$scope.filter.email_body_template;
      }
      this.$scope.emailTemplete.show = false;
    }
  }, {
    key: 'defaultTemplete',
    value: function defaultTemplete() {
      this.subjectTemplate = this.defaultSubjectTemplate;
      this.bodyTemplate = this.defaultBodyTemplate;
      delete this.$scope.filter.email_subject_template;
      delete this.$scope.filter.email_body_template;
    }
  }, {
    key: 'cancelTemplete',
    value: function cancelTemplete() {
      this.$scope.emailTemplete.show = false;
    }
  }]);

  return EmailTempleteController;
}();

function EmailTempleteComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(832),
    scope: false,
    controller: EmailTempleteController,
    controllerAs: '$ctrl'
  };
}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports = "<h4>{{:: 'Шаблон письма:' | gettext}}</h4><div class=\"subject-template\"><div>{{:: 'Тема:' | gettext}}</div><textarea class=\"input-xxlarge\" rows=\"3\" type=\"text\" ng-model=\"$ctrl.subjectTemplate\">\n</textarea></div><div class=\"body-template\"><div>{{:: 'Содержание:' | gettext}}</div><textarea class=\"input-xxlarge\" rows=\"10\" ng-model=\"$ctrl.bodyTemplate\">\n</textarea></div><div class=\"buttons\"><button class=\"btn btn-primary\" ng-click=\"$ctrl.acceptTemplete()\">{{:: 'Завершить редактирование' | gettext}}</button> <button class=\"btn\" ng-click=\"$ctrl.defaultTemplete()\">{{:: 'Восстановить шаблон по умолчанию' | gettext}}</button> <button class=\"btn\" ng-click=\"$ctrl.cancelTemplete()\">{{:: 'Отменить редактирование' | gettext}}</button></div>"

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.ThresholdComponent = ThresholdComponent;

var _measure = __webpack_require__(39);

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(834);

var ThresholdController = function () {
  function ThresholdController($scope, $element, $timeout, rx, observeOnScope) {
    var _this = this;

    _classCallCheck(this, ThresholdController);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.Measure = _measure.Measure;
    this.period = {};
    this.MAX_SAFE_INTEGER = 9007199254740991;

    if (!this.filter.threshold_period) this.filter.threshold_period = 60;
    if (!this.filter.threshold_type) this.filter.threshold_type = this.filter.measure;
    this.threshold = {
      record_count: 100,
      call_duration_sum: 60,
      activity_time_sum: 600000000,
      file_size_sum: 1000000
    };
    this.threshold[this.filter.threshold_type] = this.filter.threshold;

    this.setPeriod();
    this.setTime();
    this.subscriptions = [rx.Observable.merge(
    // observeOnScope($scope, '$ctrl.threshold'),
    observeOnScope($scope, '$ctrl.filter.send_threshold').distinctUntilChanged(null, function (t1, t2) {
      _this.filter.threshold_type = _this.filter.measure;
      _this.initThreshold();
    }), observeOnScope($scope, '$ctrl.filter.threshold_type').distinctUntilChanged(null, function (t1, t2) {
      _this.initThreshold();
    }), observeOnScope($scope, '$ctrl.filter.threshold_period'), observeOnScope($scope, '$ctrl.filter.threshold').distinctUntilChanged(null, function (t1, t2) {
      return t2.oldValue && t2.newValue;
    })).debounce(50).subscribe(function () {
      // this.setThresholdPeriod();
      _this.updateFilterTime();
    })];
  }

  _createClass(ThresholdController, [{
    key: '$onDestroy',
    value: function $onDestroy() {
      this.subscriptions.forEach(function (s) {
        if (s.dispose) s.dispose();
      });
    }
  }, {
    key: 'initThreshold',
    value: function initThreshold() {
      if (!(this.filter.threshold_type in this.threshold)) {
        this.filter.threshold = 1;
        this.threshold[this.filter.threshold_type] = this.filter.threshold;
      } else {
        this.setThreshold();
      }
      this.filter.threshold_period = 60;
      this.period = {};
      this.setPeriod();
      this.setTime();
    }
  }, {
    key: 'setThreshold',
    value: function setThreshold() {
      if (!this.threshold[this.filter.threshold_type]) this.threshold[this.filter.threshold_type] = 1;else this.threshold[this.filter.threshold_type] = this.validNum(this.threshold[this.filter.threshold_type]);
      this.filter.threshold = this.threshold[this.filter.threshold_type];
    }
  }, {
    key: 'updateFilterTime',
    value: function updateFilterTime() {
      if (this.filter.send_threshold && this.filter.threshold_period && this.filter.threshold) {
        var now = new Date();
        this.filter.timeTo = _filter.Filter.dateToUrl(now);
        var dateFrom = new Date(now.getTime() - this.filter.threshold_period * 1000 * 60);
        this.filter.timeFrom = _filter.Filter.dateToUrl(dateFrom);
      }
    }
  }, {
    key: 'setTime',
    value: function setTime() {
      var seconds = this.filter.threshold_type === 'activity_time_sum' ? Math.ceil(this.threshold[this.filter.threshold_type] / 10000000) : this.threshold[this.filter.threshold_type];
      this.hours = Math.floor(seconds / 3600);
      seconds %= 3600;
      this.mins = Math.floor(seconds / 60);
      this.sec = seconds % 60;
    }
  }, {
    key: 'setPeriod',
    value: function setPeriod() {
      var mins = this.filter.threshold_period;
      this.period.days = Math.floor(mins / 1440);
      mins -= this.period.days * 1440;
      this.period.hours = Math.floor(mins / 60);
      this.period.mins = mins - this.period.hours * 60;
    }
  }, {
    key: 'validNum',
    value: function validNum(num) {
      if (!num || num < 0) return 0;
      return num;
    }
  }, {
    key: 'setThresholdPeriod',
    value: function setThresholdPeriod() {
      this.filter.threshold_period = this.validNum(this.period.days) * 1440 + this.validNum(this.period.hours) * 60 + this.validNum(this.period.mins);
      if (this.filter.threshold_period > this.MAX_SAFE_INTEGER) this.filter.threshold_period = this.MAX_SAFE_INTEGER;
    }
  }, {
    key: 'timeChange',
    value: function timeChange() {
      var seconds = (this.sec || 0) + (this.mins || 0) * 60 + (this.hours || 0) * 3600;
      this.timeRes = seconds;

      if (this.filter.threshold_type === 'activity_time_sum') this.threshold[this.filter.threshold_type] = seconds * 10000000;else if (this.filter.threshold_type === 'call_duration_sum') this.threshold[this.filter.threshold_type] = seconds;

      if (this.threshold[this.filter.threshold_type] > this.MAX_SAFE_INTEGER) this.threshold[this.filter.threshold_type] = this.MAX_SAFE_INTEGER;
      this.setThreshold();
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.$scope.filter;
    }
  }, {
    key: 'isTime',
    get: function get() {
      return this.filter.threshold_type === 'activity_time_sum' || this.filter.threshold_type === 'call_duration_sum';
    }

    // get isShow() {
    //   return (this.filter.isReport || this.filter.isStat || this.filter.isSummStat || this.filter.isChartArea ||
    //       this.filter.isChart || this.filter.isTree || this.filter.isRadar ) &&
    //     !this.filter.isDashboard && !this.filter.isCard;
    // }

  }]);

  return ThresholdController;
}();

function ThresholdComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(835),
    scope: false,
    controller: ThresholdController,
    controllerAs: '$ctrl'
  };
}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.filter.send_threshold\" class=\"params\"><div class=\"control-group\" ng-if=\"$ctrl.filter.send_threshold\"><label class=\"control-label\" for=\"id_threshold_type\">{{:: 'По мере' | gettext}}:</label><div class=\"controls\"><select id=\"id_threshold_type\" ng-model=\"$ctrl.filter.threshold_type\"><option ng-repeat=\"measure in $ctrl.Measure.getMeasures()\" value=\"{{measure}}\">{{ $ctrl.Measure.getMeasureLabel(measure)}}</option></select></div></div><div class=\"control-group\" ng-if=\"$ctrl.filter.send_threshold\"><label class=\"control-label\" for=\"id_threshold\">{{:: 'При достижении' | gettext}}:</label><div class=\"controls\"><span ng-if=\"!$ctrl.isTime\"><input id=\"id_threshold\" class=\"num-wide\" ng-blur=\"$ctrl.setThreshold()\" ng-model=\"$ctrl.threshold[$ctrl.filter.threshold_type]\" type=\"number\" min=\"0\"> <span ng-if=\"$ctrl.filter.threshold_type !=='file_size_sum'\">{{:: 'событий' | gettext}}</span> <span ng-if=\"$ctrl.filter.threshold_type ==='file_size_sum'\">{{:: 'байт' | gettext}}</span> </span><span class=\"time-fields\" ng-if=\"$ctrl.isTime\"><input class=\"num-narrow\" ng-model=\"$ctrl.hours\" type=\"number\" min=\"0\" ng-change=\"$ctrl.timeChange()\" ng-blur=\"$ctrl.setTime()\"> <span>{{:: 'часов' | gettext}}</span> <input class=\"num-narrow\" ng-model=\"$ctrl.mins\" type=\"number\" ng-min=\"0\" ng-blur=\"$ctrl.setTime()\" ng-change=\"$ctrl.timeChange()\"> <span>{{:: 'минут' | gettext}}</span> <input class=\"num-narrow\" ng-model=\"$ctrl.sec\" type=\"number\" min=\"0\" ng-blur=\"$ctrl.setTime()\" ng-change=\"$ctrl.timeChange()\"> <span>{{:: 'секунд' | gettext}}<span></span></span></span></div></div><div class=\"control-group\" ng-if=\"$ctrl.filter.send_threshold\"><label class=\"control-label\" for=\"id_threshold_period\">{{:: 'За период' | gettext}}:</label><div class=\"controls\"><input class=\"num-narrow\" ng-model=\"$ctrl.period.days\" type=\"number\" ng-min=\"0\" ng-disabled=\"!$ctrl.filter.threshold\" ng-blur=\"$ctrl.setPeriod()\" ng-change=\"$ctrl.setThresholdPeriod()\"> <span>{{:: 'дней' | gettext}}</span> <input class=\"num-narrow\" ng-model=\"$ctrl.period.hours\" type=\"number\" ng-disabled=\"!$ctrl.filter.threshold\" min=\"0\" ng-blur=\"$ctrl.setPeriod()\" ng-change=\"$ctrl.setThresholdPeriod()\"> <span>{{:: 'часов' | gettext}}</span> <input class=\"num-narrow\" ng-model=\"$ctrl.period.mins\" ng-disabled=\"!$ctrl.filter.threshold\" type=\"number\" min=\"0\" ng-blur=\"$ctrl.setPeriod()\" ng-change=\"$ctrl.setThresholdPeriod()\"> <span>{{:: 'минут' | gettext}}</span></div></div></div>"

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(837);

var UserSearchController = exports.UserSearchController = function () {
  function UserSearchController($scope, $element, $timeout, $http, rx, observeOnScope, CurrentModelService, ErrorHandlerService, PermissionService) {
    var _this = this;

    _classCallCheck(this, UserSearchController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$http = $http;
    this.rx = rx;
    this.ErrorHandlerService = ErrorHandlerService;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestionsAll = [];
    this.searchText = '';
    this.emails = '';
    this.admin = PermissionService.userMail ? {
      user_name: PermissionService.userName,
      mail: PermissionService.userMail
    } : null;

    this.subscriptions = [rx.Observable.merge(observeOnScope($scope, '$ctrl.searchText')).debounce(100).do(function () {
      _this.loading = true;
      _this.suggestionsAll = [];
    }).switchMap(function () {
      return _this.getSuggestions();
    }).subscribe(function (data) {
      _this.suggestionsAll = _this.admin ? [_this.admin].concat(_toConsumableArray(data.data.object_list)) : data.data.object_list;
      _this.loading = false;
      $scope.$digest();
    }, function (error) {
      console.error(error);
      _this.loading = false;
      $scope.$digest();
    }), rx.Observable.merge(this.$scope.$eventToObservable('changeTab'), observeOnScope($scope, '$ctrl.emails')).debounce(50).subscribe(function () {
      if (!_this.emails) _this.filterEmails = '';
      _this.setTextHeight(0);
    })];

    this.error = false;
  }

  _createClass(UserSearchController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setMails();
      // this.setTextHeight(2000);
    }
  }, {
    key: 'setFilterEmails',
    value: function setFilterEmails() {
      this.filterEmails = this.emails.replace(/[,;]+/ig, '\n').split('\n').map(function (m) {
        var r = m.trim().match(/.*@[\S]+/g);
        return r ? r[0] : '';
      }).filter(function (m) {
        return m;
      }).join('\n').replace(/\(/g, '<').replace(/\)/g, '>');
      this.setMails();
    }
  }, {
    key: 'setMails',
    value: function setMails() {
      this.emails = this.filterEmails ? this.filterEmails.split('\n').map(function (m) {
        return m;
      }).join('; ').replace(/\</g, '(').replace(/\>/g, ')') : '';
    }
  }, {
    key: 'isSelected',
    value: function isSelected(user) {
      return this.emails.indexOf(this.getUserMail(user)) != -1;
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.subscriptions.forEach(function (s) {
        if (s.dispose) s.dispose();
      });
    }
  }, {
    key: 'getUserName',
    value: function getUserName(user) {
      return '' + (user.full_name ? user.full_name : user.user_name);
    }
  }, {
    key: 'getUserMail',
    value: function getUserMail(user) {
      return (user.full_name ? user.full_name : user.user_name) + '(' + user.mail + ')';
    }
  }, {
    key: 'getSuggestions',
    value: function getSuggestions() {
      return this.rx.Observable.fromPromise(this.$http.get('/analytics/users/?search=' + this.searchText));
    }
  }, {
    key: 'onSearchFocus',
    value: function onSearchFocus() {
      // this.isOptionsOpen = true;
    }
  }, {
    key: 'onSearchBlur',
    value: function onSearchBlur() {
      // this.isOptionsOpen = false;
    }
  }, {
    key: 'onSearchEnter',
    value: function onSearchEnter(e) {
      if (e && e.keyCode != 13) return;
      this.selectUser(this.searchText);
      this.searchText = '';
    }
  }, {
    key: 'cleanSearch',
    value: function cleanSearch() {
      this.searchText = '';
    }
  }, {
    key: 'selectUser',
    value: function selectUser(user) {
      if (this.disabled) return;
      var email = this.getUserMail(user);

      if (this.emails) {
        if (!this.isSelected(user)) this.emails = email + '; ' + this.emails;else {
          var r = new RegExp(email.replace('(', '\\(').replace(')', '\\)') + '[s,.;,\n]*', 'i');
          this.emails = this.emails.replace(r, '');
        }
      } else this.emails = email;

      this.setFilterEmails();
    }
  }, {
    key: 'setTextHeight',
    value: function setTextHeight(time) {
      var _this2 = this;

      this.$timeout(function () {
        // this.$scope.$root.$apply();
        var el = _this2.$element.find('.selected-mails textarea');

        if (!el[0]) return;
        el.height(26);
        if (el[0].scrollHeight !== el[0].clientHeight) {
          var scrH = el[0].scrollHeight;
          el.height(scrH);
          _this2.$scope.$root.$digest();
        }
      }, time);
    }
  }, {
    key: 'suggestions',
    get: function get() {
      return this.suggestionsAll;
    }
  }, {
    key: 'hasSuggestions',
    get: function get() {
      return this.suggestions.length > 0;
    }
  }]);

  return UserSearchController;
}();

var UserSearchComponent = exports.UserSearchComponent = {
  bindings: {
    filterEmails: '=',
    disabled: '@'
  },
  template: __webpack_require__(838),
  controller: UserSearchController
};

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports = "<div class=\"control-group\"><label for=\"id_emails\" class=\"control-label\">{{:: 'Кому' | gettext}}</label><div class=\"controls\"><textarea id=\"id_emails\" ng-model=\"$ctrl.emails\" ng-blur=\"$ctrl.setFilterEmails()\" ng-focus=\"$ctrl.setTextHeight(0)\" ng-disabled=\"$ctrl.disabled\" rows=\"4\"></textarea></div></div><div class=\"control-group\"><label class=\"control-label\">{{:: 'Адреса' | gettext}}</label><div class=\"controls\"><div class=\"input-append\"><input ng-model=\"$ctrl.searchText\" ng-disabled=\"$ctrl.disabled\" placeholder=\"{{:: 'Поиск адресов' | gettext}}...\" ng-keydown=\"$ctrl.onSearchEnter($event)\" on-user-selected=\"$ctrl.onUserSelected()\" ng-focus=\"$ctrl.onSearchFocus()\" ng-blur=\"$ctrl.onSearchBlur()\" type=\"text\"> <span class=\"add-on\"><i ng-if=\"$ctrl.loading\" class=\"icon-loading animate-spin\"></i> <i ng-if=\"!$ctrl.loading\" class=\"icon-cancel\" title=\"{{::'Очистить' | gettext }}\" ng-click=\"$ctrl.cleanSearch()\"></i></span></div></div></div><div class=\"control-group\"><div class=\"controls\"><div class=\"select-dropdown\"><div class=\"select-dropdown-option\" ng-repeat=\"user in $ctrl.suggestions\" ng-mousedown=\"$ctrl.selectUser(user)\"><div class=\"user-mail\" ng-class=\"{'selected': $ctrl.isSelected(user)}\">{{$ctrl.getUserMail(user)}}</div></div></div></div></div>"

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.IncidentTabComponent = IncidentTabComponent;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(840);

var IncidentTabController = function () {
  function IncidentTabController($scope, $http, PermissionService) {
    var _this = this;

    _classCallCheck(this, IncidentTabController);

    this.$scope = $scope;
    this.permission = PermissionService;
    $scope.configs = {
      // accountConf: [],
      agentConf: []
    };

    if (!$scope.filter.switch_to) {
      $scope.filter.switch_to = {
        // accountConf: null,
        agentConf: null
      };
    }

    $http.get('/analytics/configs_lists/').then(function (data) {
      _this.$scope.configs = {
        // accountConf: this.setName(data.data.object_list.AccountConf),
        agentConf: _this.setName(data.data.object_list.AgentConf)
      };
    });
  }

  _createClass(IncidentTabController, [{
    key: 'setName',
    value: function setName(list) {
      var nameKey = this.permission.selectedLang === 'ru' ? 'name_ru' : 'name_en';
      return list.map(function (c) {
        return {
          id: c.id,
          name: c[nameKey]
        };
      });
    }
  }]);

  return IncidentTabController;
}();

function IncidentTabComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(841),
    scope: false,
    controller: IncidentTabController
  };
}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<div class=\"filter-prop-tab\"><div class=\"control-group switch-to\">{{:: 'При срабатывании фильтра переключать на конфигурацию' | gettext}}:<label for=\"id_agent_configs\"></label><label for=\"id_agent_configs\" class=\"control-label\">{{:: 'агента' | gettext}}:</label><div class=\"controls\"><select id=\"id_agent_configs\" ng-model=\"filter.switch_to.agentConf\"><option value=\"\" selected=\"selected\">---------</option><option ng-repeat=\"conf in configs.agentConf\" value=\"{{conf.id}}\">{{conf.name}}</option></select></div></div></div>"

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersTabComponent = FiltersTabComponent;
function FiltersTabComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(843),
    scope: false
  };
}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-pills filter-nav-pills\"><li ng-class=\"{'active': filterTab=='filter'}\"><a ng-click=\"filterTab = 'filter'\"><i class=\"icon-wrench\"></i>{{:: 'Конструктор' | gettext}}</a></li><li ng-class=\"{'active': filterTab=='query'}\"><a ng-click=\"filterTab = 'query'\"><i class=\"icon-equalizer\"></i> {{:: 'Сложный запрос' | gettext}}</a></li><li ng-class=\"{'active': filterTab=='code'}\"><a ng-click=\"filterTab = 'code'\"><i class=\"icon-edit\"></i>{{:: 'Код фильтра' | gettext}}</a></li></ul><div class=\"filter-constructor-pane\"><div class=\"maximize\" ng-show=\"filterTab === 'filter'\"><div class=\"dimension-list\"><sc-filter-search run-click=\"keyWordClick(keyWord)\" class=\"input-append aggregate-header\"></sc-filter-search><ul class=\"nav nav-list\" ng-init=\"allCuts=true\"><li ng-repeat=\"dim in visibleDimensions\" ng-show=\"allCuts || cutsForDim(dim).length > 0\" ng-class=\"{'active': filterBar.drilldown[0] == dim.toString()}\"><a ng-click=\"select(dim)\"><i ng-show=\"!dim.is_flat\" ng-class=\"{'icon-plus-1': !isNodeOpen('dimension',dim.toString()), 'icon-check-1': isNodeOpen('dimension',dim.toString())}\"></i> <i ng-show=\"dim.is_flat\" ng-class=\"DIM2CLASS[dim.name]\"></i> <span>&nbsp;{{ dim.label }}</span> <span ng-show=\"cutsForDim(dim).length\" class=\"badge badge-info\">{{ cutsForDim(dim).length}}</span></a><ul class=\"nav nav-list\" ng-show=\"isNodeOpen('dimension',dim.toString())\"><li ng-repeat=\"hie in dim.hierarchies\" ng-show=\"allCuts || cutsForDim(hie).length\" ng-class=\"{'active': filterBar.drilldown[0] == hie.toString()}\"><a ng-if=\"!dim.is_flat\" ng-show=\"allCuts || cutsForDim(hie).length\" ng-click=\"select(hie)\">&nbsp;&nbsp;&nbsp;&nbsp; <i ng-class=\"DIM2CLASS[dim.name]\"></i> <span>&nbsp;{{ hie.label }}</span> <i ng-show=\"filterBar.drilldown[0] == hie.toString()\" class=\"icon-check-1\"></i> <span ng-show=\"cutsForDim(hie).length\" class=\"badge badge-info\">{{ cutsForDim(hie).length}}</span></a></li></ul></li></ul></div><div class=\"aggregate-box\"><div class=\"input-append aggregate-header toolbar-color\"><span class=\"lead left-pict\"><i class=\"pointer\" ng-class=\"DIM2CLASS[(filterBar.drilldown[0] || '').split('@')[0]]\" ng-click=\"selectAll(); reload();\"></i> </span><span class=\"\"><input type=\"text\" id=\"aggregate-search-modal\" ng-keyup=\"searchAggregate($event)\" placeholder=\"{{:: 'Поиск' | gettext}} - {{ filterBar.drilldown[0] && model.getDrillLabel( filterBar.drilldown[0] ) }}\"> </span><a class=\"add-on\" ng-click=\"searchAggregate()\"><i class=\"icon-search\"></i></a></div><div class=\"aggregate-container-modal\" infinite-scrollfork=\"aggregate_more()\" infinite-scroll-distance=\"2\" infinite-scroll-disabled=\"aggregate.isComplete\"><ul class=\"\"><li ng-repeat=\"cell in cells() track by $index\" class=\"dimension-list-item aggregate-cell\"><div class=\"agil\"><i class=\"pointer\" ng-class=\"{'icon-check': hasCellFilter(drill, cell), 'icon-check-empty': !hasCellFilter(drill, cell)}\" ng-click=\"setCellFilter(drill, cell)\"></i> <i class=\"{{TYPE2CLASS[cell['agent_eventtype.name']]}}\" ng-show=\"cell['agent_eventtype.name']\"></i> <i ng-show=\"cell['agent_agent.id']||cell['agent_account.user_name']\" ng-class=\"StatusChecker.check(cell)['cssClass']\"></i> <span class=\"list-value\" ng-click=\"setCellFilter(drill, cell)\" title=\"{{model.getCellLabel(drill, cell)}}\">{{model.getCellLabel(drill, cell)}}</span></div><div class=\"agir\"><span class=\"badge pull-right\">{{cell['record_count']}}</span></div></li><li ng-show=\"!hasData() && !isAggregateLoading()\" class=\"text-center aggregate-cell\" style=\"list-style:none\">{{:: 'Нет данных за период, попадающих под фильтр' | gettext}}</li><li ng-show=\"isAggregateLoading()\" class=\"text-center aggregate-cell\" style=\"list-style:none\"><div class=\"test-mail-spinner\"></div></li></ul></div></div><ul class=\"filter-filters-list\"><li ng-repeat=\"f in filter.filters.slice().reverse()\" ng-click=\"removeFilter(f); $emit('reload');\"><a class=\"filter-badge\"><span class=\"badge\" ng-class=\"(f.predicates && f.predicates.indexOf('!')>=0) ? 'badge-important': 'badge-info'\"><span class=\"filter-left-menu\" ng-click=\"invertFilter(f); $event.stopPropagation(); $emit('reload');\">±</span> <span class=\"filter-right-menu\">&nbsp;×</span><div class=\"filter-label might-overflow\">{{ model.getDrillLabel( f.dimension ) }}: <b class=\"filter-value\">{{ locLabel(f) }}</b></div></span></a></li></ul></div><sc-query-builder ng-show=\"filterTab === 'query'\" group=\"filter.query\"></sc-query-builder><textarea class=\"maximize\" ng-show=\"filterTab === 'code'\" ng-focus=\"onQueryTextCotFocus()\" ng-blur=\"updateFromText()\" ng-model=\"filterAsText.code\">\n  </textarea></div>"

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.NotifyTabComponent = NotifyTabComponent;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(845);

var NotifyTabController = function () {
  function NotifyTabController($scope, $http, PermissionService) {
    var _this = this;

    _classCallCheck(this, NotifyTabController);

    this.$scope = $scope;

    if (this.$scope.filter.sendMail === undefined) this.$scope.filter.sendMail = true;
    var schedule = (this.$scope.filter.notify ? 'new' : false) || this.$scope.filter.reporting_schedule_type;

    this.$scope.notify2.adminMailShow = PermissionService.userName + '(' + PermissionService.userMail + ')';
    this.$scope.notify2.adminMail = PermissionService.userMail ? PermissionService.userName + '<' + PermissionService.userMail + '>' : '';
    this.$scope.notify2.active = !!schedule || this.$scope.filter.send_threshold;

    var getShTime = function getShTime() {
      return _this.$scope.filter.notifyShTime ? Math.floor(_this.$scope.filter.notifyShTime / 3600).toString().padStart(2, '0') + ':' + Math.floor(_this.$scope.filter.notifyShTime % 3600 / 60).toString().padStart(2, '0') : '06:00';
    };

    this.$scope.notify2.shTime = getShTime();

    this.$scope.notify2.changeActive = function (v) {
      _this.$scope.filter.notify = v;
      if (!v) {
        _this.$scope.notify2.schedule = '';
        _this.$scope.filter.reporting_schedule_type = '';
      } else {
        _this.$scope.notify2.schedule = 'new';
        _this.$scope.filter.notifyIsHtml = true;
      }
    };

    this.$scope.notify2.schedule = schedule;
    this.$scope.notify2.shTimeBlur = function () {
      var _$scope$notify2$shTim = _this.$scope.notify2.shTime.split(':').map(function (t) {
        return parseInt(t, 0);
      }),
          _$scope$notify2$shTim2 = _slicedToArray(_$scope$notify2$shTim, 2),
          h = _$scope$notify2$shTim2[0],
          m = _$scope$notify2$shTim2[1];

      if (typeof h === 'number' && typeof m === 'number' && (h < 24 && m < 60 || h === 24 && m === 0)) {
        _this.$scope.notify2.shTime = h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0');
      } else {
        console.error('bad shTime', _this.$scope.notify2.shTime);
        _this.$scope.notify2.shTime = getShTime();
      }
      _this.$scope.filter.notifyShTime = getNotifyShTime();
    };

    var getNotifyShTime = function getNotifyShTime() {
      var _$scope$notify2$shTim3 = _this.$scope.notify2.shTime.split(':').map(function (t) {
        return parseInt(t, 0);
      }),
          _$scope$notify2$shTim4 = _slicedToArray(_$scope$notify2$shTim3, 2),
          h = _$scope$notify2$shTim4[0],
          m = _$scope$notify2$shTim4[1];

      return h * 3600 + m * 60;
    };

    this.$scope.notify2.change = function (v) {
      if (!v) return;
      _this.$scope.filter.notify = v === 'new';
      if (v !== 'new') {
        _this.$scope.filter.reporting_schedule_type = v;
        _this.$scope.filter.notifyIsPdf = true;
        _this.$scope.filter.notifyIsHtml = false;
      }
    };

    this.$scope.notify2.isShowSchedule = function () {
      return _this.$scope.notify2.active && _this.$scope.notify2.notifyType !== 'HTML';
    };

    // this.$scope.filter.notifyIsHtml = !!this.$scope.filter.notify;
    this.$scope.notify2.isHtmlChage = function (v) {
      if (!v) {
        _this.$scope.filter.createIncident = false;
        _this.$scope.filter.sendMail = true;
        _this.$scope.filter.notifyIsPdf = true;
      }
      _this.$scope.notify2.setSplitByUsers();
    };
    this.$scope.notify2.isHtmlDisable = function () {
      return !_this.$scope.notify2.active || _this.$scope.notify2.schedule !== 'new';
    };
    // this.$scope.filter.notifyIsPdf = !!this.$scope.filter.reporting_schedule_type;
    this.$scope.notify2.isPdfChange = function (v) {
      if (!v && !_this.$scope.filter.notifyIsHtml) _this.$scope.filter.notifyIsHtml = true;
      if (!v) _this.$scope.filter.save_on_disk = false;else {
        _this.$scope.filter.createIncident = false;
        _this.$scope.filter.sendMail = true;
      }
    };

    this.$scope.notify2.isPdfDisable = function () {
      return !_this.$scope.notify2.active || _this.$scope.notify2.schedule !== 'new';
    };

    this.$scope.notify2.isSendToMe = function () {
      return _this.$scope.notify2.adminMail && !_this.$scope.filter.emails;
    };

    this.$scope.notify2.setSplitByUsers = function () {
      if (!_this.$scope.filter.split_by_user) return;
      if (_this.$scope.filter.notifyIsHtml) _this.$scope.filter.split_by_user = false;
    };

    this.$scope.notify2.isPdfDisable = function () {
      return !_this.$scope.notify2.active || _this.$scope.notify2.schedule !== 'new';
    };

    this.$scope.notify2.splitByUsersDisable = function () {
      return !_this.$scope.notify2.active || _this.$scope.filter.do_scan || _this.$scope.filter.notifyIsHtml;
    };

    this.$scope.responsePatterns = [];
    this.$scope.incidentGroups = [];

    var initcreateIncident = function initcreateIncident() {
      if (_this.$scope.incidentGroups && _this.$scope.incidentGroups[0] && !_this.$scope.filter.createIncidentGroup) _this.$scope.filter.createIncidentGroup = _this.$scope.incidentGroups[0].id.toString();
      if (_this.$scope.responsePatterns && _this.$scope.responsePatterns[0] && !_this.$scope.filter.createIncidentPattern) _this.$scope.filter.createIncidentPattern = _this.$scope.responsePatterns[0].id.toString();
    };

    this.$scope.onSendMail = function () {
      if (!_this.$scope.filter.notifyIsHtml) _this.$scope.filter.sendMail = true;
      if (!_this.$scope.filter.sendMail) _this.$scope.filter.createIncident = true;
    };

    this.$scope.onCreateIncident = function () {
      if (!_this.$scope.filter.createIncident) {
        delete _this.$scope.filter.createIncidentPattern;
        delete _this.$scope.filter.createIncidentGroup;
        _this.$scope.filter.sendMail = true;
      }
      // else if ()
      if (!_this.$scope.responsePatterns.length || !_this.$scope.incidentGroups.length) {
        Promise.all([$http.get('/incident/api/response_pattern/'), $http.get('/incident/api/incident_group/')]).then(function (res) {
          if (res[0] && res[0].data) {
            _this.$scope.responsePatterns = res[0].data;
          }
          if (res[1] && res[1].data) {
            _this.$scope.incidentGroups = res[1].data;
          }
          initcreateIncident();
          _this.$scope.$root.$apply();
        }, function (err) {
          console.error(err);
        });
      } else initcreateIncident();
    };
    if (this.$scope.filter.createIncident) this.$scope.onCreateIncident();
  }

  _createClass(NotifyTabController, [{
    key: '$onInit',
    value: function $onInit() {
      this.$scope.notify2.change(this.$scope.notify2.schedule);
      this.$scope.notify2.setSplitByUsers();
    }
  }]);

  return NotifyTabController;
}();

function NotifyTabComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(846),
    scope: false,
    controller: NotifyTabController
  };
}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<sc-threshold ng-if=\"show.threshold()\"></sc-threshold><sc-email-templete filter=\"{filter}\" ng-if=\"show.emailTemplete()\"></sc-email-templete><div ng-if=\"!emailTemplete.show\" class=\"filter-prop-tab\"><div ng-if=\"show.notify()\" class=\"control-group\" ng-class=\"{'error': errors.notify}\"><label class=\"checkbox\" id=\"id_notify_label\" for=\"id_notify\"><input id=\"id_notify\" ng-model=\"notify2.active\" type=\"checkbox\" ng-change=\"notify2.changeActive(notify2.active)\"> {{:: 'Активировать уведомления' | gettext}}</label></div><div class=\"control-group\"><label ng-if=\"show.notify()\" class=\"control-label\" for=\"id_notify_regularity\">{{:: 'Регулярность' | gettext}}</label><div id=\"id_notify_regularity\" ng-if=\"show.notify()\" class=\"controls\"><div class=\"control-group\" ng-class=\"{'error': errors.reporting_schedule_type, 'shadowed': !notify2.active}\"><label for=\"id_notify1\" title=\"{{:: 'Уведобления о новых событиях' | gettext}}\"><input id=\"id_notify1\" type=\"radio\" ng-model=\"notify2.schedule\" ng-disabled=\"!notify2.active\" value=\"new\" ng-change=\"notify2.change(notify2.schedule)\"> {{:: 'Новые' | gettext}}</label><label for=\"id_notify2\" ng-class=\"{'shadowed': !notify2.isShowSchedule()}\" title=\"{{:: 'Ежедневные уведомления о событиях за последние 24 часа, начиная с 00:00:00' | gettext}}\"><input id=\"id_notify2\" type=\"radio\" ng-model=\"notify2.schedule\" ng-disabled=\"!notify2.isShowSchedule()\" value=\"daily\" ng-change=\"notify2.change(notify2.schedule)\"> {{:: 'Ежедневно' | gettext}}</label><label for=\"id_notify3\" ng-class=\"{'shadowed': !notify2.isShowSchedule()}\" title=\"{{:: 'Еженедельные уведомления о событиях за последние 7 дней, начиная с 00:00:00 пн' | gettext}}\"><input id=\"id_notify3\" type=\"radio\" ng-model=\"notify2.schedule\" ng-disabled=\"!notify2.isShowSchedule()\" value=\"weekly\" ng-change=\"notify2.change(notify2.schedule)\"> {{:: 'Еженедельно' | gettext}}</label><label for=\"id_notify4\" ng-class=\"{'shadowed': !notify2.isShowSchedule()}\" title=\"{{:: 'Ежемесячные уведомления о событиях за прошедший месяц с 1го числа месяца' | gettext}}\"><input id=\"id_notify4\" type=\"radio\" ng-model=\"notify2.schedule\" ng-disabled=\"!notify2.isShowSchedule()\" value=\"monthly\" ng-change=\"notify2.change(notify2.schedule)\"> {{:: 'Ежемесячно' | gettext}}</label></div></div></div><div class=\"control-group\"><label for=\"id_sh_time\" id=\"id_sh_time_label\" title=\"{{:: 'Время отправки' | gettext}}\" class=\"control-label\">{{:: 'Время отправки' | gettext}}</label><div class=\"controls\"><input class=\"span2\" id=\"id_sh_time\" type=\"text\" ng-model=\"notify2.shTime\" ng-disabled=\"!notify2.active || !notify2.schedule || notify2.schedule == 'new'\" value=\"new\" ng-blur=\"notify2.shTimeBlur(notify2.shTime)\"></div></div><div ng-if=\"show.sendOptions()\" class=\"control-group properties\" ng-class=\"{'error': errors.report_if_filter_data_exists}\"><div class=\"controls\"><label for=\"id_is_HTML\" ng-class=\"{'shadowed': notify2.isHtmlDisable()}\"><input class=\"checkbox\" id=\"id_is_HTML\" ng-change=\"notify2.isHtmlChage(filter.notifyIsHtml)\" ng-disabled=\"notify2.isHtmlDisable()\" ng-model=\"filter.notifyIsHtml\" type=\"checkbox\"> {{:: 'HTML' | gettext}} <button class=\"btn btn-info btn-small\" ng-click=\"setTrueemailTemplete()\" ng-disabled=\"notify2.isHtmlDisable()\" title=\"{{:: 'Редактировать шаблон письма' | gettext}}\">{{:: 'Шаблон' | gettext}}</button></label><label class=\"checkbox\" for=\"id_is_PDF\" ng-class=\"{'shadowed': notify2.isPdfDisable()}\"><input id=\"id_is_PDF\" ng-change=\"notify2.isPdfChange(filter.notifyIsPdf)\" ng-disabled=\"notify2.isPdfDisable()\" ng-model=\"filter.notifyIsPdf\" type=\"checkbox\"> {{:: 'PDF' | gettext}}</label><label class=\"checkbox\" ng-if=\"!filter.isCardOrDashboard\" title=\"{{:: 'Разделение по пользователям. Активно если выключен HTML.' | gettext}}\" ng-class=\"{'shadowed': notify2.splitByUsersDisable()}\"><input id=\"id_split_by_user\" ng-disabled=\"notify2.splitByUsersDisable()\" ng-model=\"filter.split_by_user\" type=\"checkbox\"> {{:: 'Разделить по пользователям' | gettext}}</label><label class=\"checkbox\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || notify2.schedule === 'new'}\"><input id=\"id_report_if_filter_data_exists\" ng-disabled=\"filter.do_scan || !notify2.active  || notify2.schedule === 'new'\" ng-model=\"filter.report_if_filter_data_exists\" type=\"checkbox\"> {{:: 'Отправлять только если есть данные' | gettext}}</label><label class=\"checkbox\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || !filter.notifyIsHtml || filter.notifyIsPdf}\"><input id=\"id_send_mail\" ng-disabled=\"filter.do_scan || !notify2.active || !filter.notifyIsHtml || filter.notifyIsPdf\" ng-model=\"filter.sendMail\" ng-change=\"onSendMail()\" type=\"checkbox\"> {{:: 'Отправить по почте' | gettext}}</label><label class=\"checkbox\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || !filter.notifyIsPdf}\"><input id=\"id_save_on_disk\" ng-disabled=\"filter.do_scan || !notify2.active || !filter.notifyIsPdf\" ng-model=\"filter.save_on_disk\" type=\"checkbox\"> {{:: 'Сохранить отчет на диск' | gettext}}</label></div></div><div class=\"control-group\"><label class=\"checkbox\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || !filter.notifyIsHtml || filter.notifyIsPdf}\"><input id=\"id_createIncident\" ng-change=\"onCreateIncident()\" ng-disabled=\"filter.do_scan || !notify2.active || !filter.notifyIsHtml || filter.notifyIsPdf\" ng-model=\"filter.createIncident\" type=\"checkbox\"> {{:: 'Создать инцидент' | gettext}}</label></div><div class=\"control-group\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || !filter.notifyIsHtml || !filter.createIncident}\"><label class=\"control-label\">{{:: 'Шаблон реагирования' | gettext}}</label><div class=\"controls\"><select ng-model=\"filter.createIncidentPattern\" ng-disabled=\"filter.do_scan || !notify2.active || !filter.notifyIsHtml || !filter.createIncident\"><option ng-repeat=\"responsePattern in responsePatterns track by responsePattern.id\" ng-selected=\"{{\n                responsePattern.id == filter.createIncidentPattern\n              }}\" value=\"{{ responsePattern.id }}\">{{ responsePattern.name }}</option></select></div></div><div class=\"control-group\" ng-if=\"!filter.isCardOrDashboard\" ng-class=\"{'shadowed': filter.do_scan || !notify2.active || !filter.notifyIsHtml || !filter.createIncident}\"><label class=\"control-label\">{{:: 'Группа инцидента' | gettext}}</label><div class=\"controls\"><select ng-model=\"filter.createIncidentGroup\" ng-disabled=\"filter.do_scan || !notify2.active || !filter.notifyIsHtml || !filter.createIncident\"><option ng-repeat=\"incidentGroup in incidentGroups track by incidentGroup.id\" ng-selected=\"{{ incidentGroup.id == filter.createIncidentGroup }}\" value=\"{{ incidentGroup.id }}\">{{ incidentGroup.name }}</option></select></div></div><div class=\"control-group\" ng-class=\"{'error': errors.emails, shadowed: !notify2.active || !filter.sendMail}\"><sc-user-search class=\"input-mails\" filter-emails=\"filter.emails\" disabled=\"{{ notify2.active && filter.sendMail  ? '' : 'true'  }}\"></sc-user-search></div><div class=\"control-group send-letter\" ng-show=\"filter.reporting_schedule_type || filter.notify\"><button id=\"id_test_button\" ng-disabled=\"(awaiting || errorMessage.text ||  !filter.emails || !testMail) && !notify2.isSendToMe()\" class=\"btn btn-primary\" ng-click=\"ok(testMail)\" title=\"{{:: 'Сохранить фильтр и проверить отправку' | gettext}}\">{{:: 'Тест отправки' | gettext}}</button><label ng-if=\"notify2.isSendToMe()\" for=\"id_test_button\">{{:: 'Отправить себе' | gettext}}: {{ notify2.adminMailShow }}</label><div ng-show=\"!testMail\" class=\"test-mail-spinner\"></div><p class=\"success-sended\" ng-show=\"successSended\">{{:: 'Письмо успешно отправлено' | gettext}}</p></div></div>"

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(848);

/*@ngInject*/

var AccountController = function () {
  AccountController.$inject = ["$scope", "$element"];
  function AccountController($scope, $element) {
    _classCallCheck(this, AccountController);

    this.$scope = $scope;
    this.$element = $element;
    this.$scope.fact = this.fact;
  }

  _createClass(AccountController, [{
    key: 'showAccounts',
    value: function showAccounts() {
      var rect = this.$element.context.getBoundingClientRect();
      var menu = this.$element.find('div > div');

      menu.css('left', rect.left);
      menu.css('top', rect.top + 10);
      menu.css('visibility', 'visible');
    }
  }, {
    key: 'hideAccounts',
    value: function hideAccounts() {
      this.$element.find('div > div').css('visibility', 'hidden');
    }
  }, {
    key: 'accounts',
    get: function get() {
      return this.fact.accounts ? this.fact.accounts[this.accountKey] || [] : [];
    }
  }, {
    key: 'alias',
    get: function get() {
      // return this.fullName ? this.fullName : (this.userName ? this.userName: this.account);
      return this.fullName || this.userName || this.accountKey;
    }
  }, {
    key: 'id',
    get: function get() {
      return this.accounts.length ? this.accounts[0].id : 0;
    }
  }, {
    key: 'userName',
    get: function get() {
      return this.accounts.length ? this.accounts[0].user_name : '';
    }
  }, {
    key: 'fullName',
    get: function get() {
      return this.accounts.length ? this.accounts[0].full_name : '';
    }
  }]);

  return AccountController;
}();

var AccountComponent = exports.AccountComponent = {
  template: __webpack_require__(849),
  controller: AccountController,
  bindings: {
    accountKey: '<',
    fact: '<',
    dkey: '<'
  }
  // resolve: '^facts'
};

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports = "<div ng-mouseover=\"$ctrl.showAccounts()\" ng-mouseleave=\"$ctrl.hideAccounts()\"><span data-key=\"{{$ctrl.dkey}}\" class=\"\">{{$ctrl.alias}}</span><div><table class=\"account-menu\"><tr><th>{{::'Пользователь' | gettext}}</th><th>{{::'Полное имя' | gettext}}</th><th>{{::'Адрес' | gettext}}</th><th>&nbsp;</th></tr><tr ng-repeat=\"acc in $ctrl.accounts\"><td>{{acc.user_name}}</td><td>{{acc.full_name}}</td><td>{{$ctrl.accountKey}}</td><td><a sc-xref=\"{{'/admin/agent/account/' + acc.id}}/\"><i class=\"icon-cogs\"></i></a></td></tr></table></div></div>"

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(851);

var MEDIA_ERR_ABORTED = 1; // fetching process aborted by user
var MEDIA_ERR_NETWORK = 2; // error occurred when downloading
var MEDIA_ERR_DECODE = 3; // error occurred when decoding
var MEDIA_ERR_SRC_NOT_SUPPORTED = 4; // audio/video not supported

var MEDIA_ERROR_CODE = {
  '1': gettext('Отменено'),
  '2': gettext('Ошибка сети'),
  '3': gettext('Ошибка кодека'),
  '4': gettext('Не поддерживается')
};

/*@ngInject*/

var AudioFileController = function () {
  AudioFileController.$inject = ["$scope", "$http", "$element", "$timeout", "LayoutService", "AudioService"];
  function AudioFileController($scope, $http, $element, $timeout, LayoutService, AudioService) {
    var _this = this;

    _classCallCheck(this, AudioFileController);

    this.$http = $http;
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.layout = LayoutService;
    this.audioService = AudioService;
    this.currentTime = 0;
    this.duration = 0;
    this.audioErrors = MEDIA_ERROR_CODE;
    this.playing = false;
    this.$showTimeRange = true;

    // error occurred during the loading or playing
    $scope.$on('col-resize', function () {
      _this.setTimeRange();
      _this.$scope.$digest();
    });
    $scope.$on('resize', function () {
      return _this.setTimeRange();
    });
    $scope.$on('splitter1Changed', function () {
      return _this.setTimeRange();
    });

    this.onError = function () {
      // if (this.audio.error.code === MEDIA_ERR_NETWORK) {
      //   this.reload();
      // }
      _this.playing = false;
      $scope.$digest();
    };

    // the audio has been started or is no longer paused
    this.onPlay = function () {
      _this.playing = true;
      _this.audioService.stopped = false;
      $scope.$digest();
    };

    // the audio has been paused
    this.onPause = function () {
      _this.playing = false;
      _this.audioService.stopped = true;
      $scope.$digest();
    };

    // the audio is ended
    this.onEnded = function () {
      _this.playing = false;
      $scope.$digest();
    };

    // duration data is changed
    this.onDurationChange = function () {
      _this.updateDuration();
      $scope.$digest();
    };

    // position is changed
    this.onTimeUpdate = function () {
      // console.log('onTimeUpdate', );
      _this.updateCurrentTime();
      $scope.$digest();
    };
  }

  _createClass(AudioFileController, [{
    key: 'reload',
    value: function reload() {
      var _this2 = this;

      if (this.reloading) {
        return;
      }
      this.reloading = true;
      if (this.audio.error.code === MEDIA_ERR_DECODE || this.audio.error.code === MEDIA_ERR_SRC_NOT_SUPPORTED) {
        return this.$http.get(this.audio.src + '&reset=true').catch(function (err) {
          if (err.status === 404) {
            return;
          }
          console.error(err.message);
        }).finally(function () {
          return _this2.reloadAudio();
        });
      }
      this.reloadAudio();
    }
  }, {
    key: 'reloadAudio',
    value: function reloadAudio() {
      this.audio.load();
      this.updateDuration();
      this.updateCurrentTime();
      this.reloading = false;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      this.createAudio();
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.disposeAudio();
    }
  }, {
    key: 'createAudio',
    value: function createAudio() {
      var _this3 = this;

      // let audio = this.audio = this.fact.audio = this.fact.audio || this.audioService.createAudio(this.src);
      this.fact.audio = this.fact.audio || this.audioService.createAudio(this.src);
      this.audio = this.fact.audio;
      var audio = this.audio;
      audio.addEventListener('error', this.onError);
      audio.addEventListener('play', this.onPlay);
      audio.addEventListener('pause', this.onPause);
      audio.addEventListener('ended', this.onEnded);
      audio.addEventListener('timeupdate', this.onTimeUpdate);
      audio.addEventListener('durationchange', this.onDurationChange);

      this.updateDuration();
      this.updateCurrentTime();
      if (this.layout.isFirefox) {
        this.$timeout(function () {
          _this3.timeRangeElement = _this3.$element.find('input.play-audio-time-range')[0];
          if (_this3.timeRangeElement) {
            _this3.timeRangeElement.addEventListener('mousedown', _this3.mouseDown.bind(_this3));
            _this3.timeRangeElement.addEventListener('mouseup', _this3.mouseUp.bind(_this3));
            _this3.$scope.$watch('$ctrl.currentTime', function () {
              return _this3.timeRangeElement.value = _this3.currentTime;
            });
          }
        }, 10);
      }
    }
  }, {
    key: 'mouseDown',
    value: function mouseDown() {
      this.timeRangeElement.addEventListener('mousemove', this.onSeek.bind(this));
      this.onSeek();
    }
  }, {
    key: 'mouseUp',
    value: function mouseUp() {
      this.timeRangeElement.removeEventListener('mousemove', this.onSeek);
      this.updateInputRange();
    }
  }, {
    key: 'onSeek',
    value: function onSeek(e) {
      if (this.layout.isFirefox) {
        var now = new Date().getTime();
        if (this.mouseMoveLastTime && now - this.mouseMoveLastTime < 100) return;
        this.mouseMoveLastTime = now;
        this.currentTime = this.timeRangeElement.value;
      }
      this.audio.currentTime = this.currentTime;
      this.updateCurrentTime();
    }
  }, {
    key: 'updateInputRange',
    value: function updateInputRange() {
      if (this.layout.isFirefox) {
        this.onSeek();
        var newRange = this.timeRangeElement.cloneNode(true);
        var parent = this.timeRangeElement.parentNode;
        parent.replaceChild(newRange, this.timeRangeElement);
        this.timeRangeElement = newRange;
        this.timeRangeElement.addEventListener('mousedown', this.mouseDown.bind(this));
        this.timeRangeElement.addEventListener('mouseup', this.mouseUp.bind(this));
      } else this.onSeek();
    }
  }, {
    key: 'disposeAudio',
    value: function disposeAudio() {
      var audio = this.audio;
      audio.removeEventListener('error', this.onError);
      audio.removeEventListener('play', this.onPlay);
      audio.removeEventListener('pause', this.onPause);
      audio.removeEventListener('ended', this.onEnded);
      audio.removeEventListener('timeupdate', this.onTimeUpdate);
      audio.removeEventListener('durationchange', this.onDurationChange);
      if (this.layout.isFirefox) {
        this.timeRangeElement.removeEventListener('mousedown', this.mouseDown);
        this.timeRangeElement.removeEventListener('mouseup', this.mouseUp);
      }
      if (this.playing && !this.audioService.stopped) {
        this.play();
        this.audioService.stopped = true;
      }
    }
  }, {
    key: 'play',
    value: function play() {
      this.audioService.play(this.audio);
      this.fact.audioLoad = true;
    }
  }, {
    key: 'updateDuration',
    value: function updateDuration() {
      var duration = this.audio.duration;
      this.duration = Math.floor(duration);
    }
  }, {
    key: 'updateCurrentTime',
    value: function updateCurrentTime() {
      this.currentTime = Math.floor(this.audio.currentTime);
    }
  }, {
    key: 'setTimeRange',
    value: function setTimeRange() {
      this.$showTimeRange = this.$element.parent().width() > 280;
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this.fact['agent_agent.computer_name'] + '_' + this.fact.local_time.substring(0, 19).replace(/:/gi, '').replace(/T/gi, '_') + '.' + this.audioService.downloadType;
    }
  }, {
    key: 'downloadSrc',
    get: function get() {
      return this.audioService.getSrcType(this.src, this.audioService.downloadType);
    }
  }, {
    key: 'showTimeRange',
    get: function get() {
      return this.$showTimeRange;
    }
  }, {
    key: 'showTime',
    get: function get() {
      return this.playing || this.isSelected && this.hasDuration;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.fact.selected;
    }
  }, {
    key: 'hasDuration',
    get: function get() {
      return typeof this.audio.duration === 'number' && !isNaN(this.audio.duration) && isFinite(this.audio.duration);
    }
  }]);

  return AudioFileController;
}();

var AudioFileComponent = exports.AudioFileComponent = {
  template: __webpack_require__(852),
  controller: AudioFileController,
  bindings: {
    fact: '<',
    src: '<'
  }
  // resolve: '^facts'
};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "<span class=\"sc-audio-file\"><span class=\"sc-audio-file-download\"><a ng-href=\"{{$ctrl.downloadSrc}}\" download=\"{{$ctrl.fileName}}\">{{::'Скачать'| gettext}} <i class=\"icon icon-download\"></i></a><select class=\"select-download-type\" ng-model=\"$ctrl.audioService.downloadType\" ng-options=\"type for type in $ctrl.audioService.downloadTypes\"></select></span><span class=\"sc-audio-file-error text-danger\" ng-if=\"$ctrl.audio.error.code\">{{$ctrl.audioErrors[$ctrl.audio.error.code]}} <i class=\"icon icon-reload\" ng-click=\"$ctrl.reload()\"></i> </span><span class=\"sc-audio-file-player\" ng-if=\"!$ctrl.audio.error.code\"><span ng-click=\"$ctrl.play()\"><i class=\"icon\" ng-class=\"{'icon-play': $ctrl.audio.paused, 'icon-pause': !$ctrl.audio.paused}\"></i> </span><span ng-show=\"$ctrl.showTime\"><input ng-if=\"$ctrl.layout.isFirefox\" ng-show=\"$ctrl.showTimeRange\" class=\"play-audio-time-range\" type=\"range\" min=\"0\" ng-attr-max=\"{{$ctrl.duration}}\"> <input ng-if=\"!$ctrl.layout.isFirefox\" ng-show=\"$ctrl.showTimeRange\" class=\"play-audio-time-range\" type=\"range\" min=\"0\" ng-attr-max=\"{{$ctrl.duration}}\" ng-model=\"$ctrl.currentTime\" ng-change=\"$ctrl.onSeek()\"> <span class=\"sc-audio-file-info\"><span ng-bind=\"$ctrl.currentTime | timeSpan\"></span> / <span ng-bind=\"$ctrl.duration | timeSpan\"></span> </span></span></span></span>"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localStorage = __webpack_require__(87);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
var AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma'
};

var AudioService = exports.AudioService = function () {
  function AudioService(LocalStorageService) {
    var _this = this;

    _classCallCheck(this, AudioService);

    this.localStorage = LocalStorageService;
    this.current = null;
    this.downloadTypes = AUDIO_TYPES;
    this._downloadType = LocalStorageService.getItem(_localStorage.AUDIO_DOWNLOAD_TYPE);
    if (this.downloadTypes.indexOf(this.downloadType) === -1) {
      this.downloadType = this.downloadTypes[0];
    }

    // fires when current audio has been fully downloaded
    this.onLoaded = function () {
      _this.loadNextAudio();
    };

    // fires when current audio is ended
    this.onEnded = function () {
      _this.playNextAudio();
    };
  }

  _createClass(AudioService, [{
    key: 'createAudio',
    value: function createAudio(src) {
      // console.log('create audio', src);
      var audio = new Audio();
      var type = [this.downloadType].concat(AUDIO_TYPES).find(function (key) {
        return audio.canPlayType(AUDIO_CONTENT_TYPES[key]);
      }) || this.downloadType;
      audio.preload = 'none';
      audio.src = this.getSrcType(src, type);
      return audio;
    }
  }, {
    key: 'play',
    value: function play(audio) {
      // console.log('play audio', audio.src);

      if (this.current) {
        if (this.current === audio) {
          if (audio.error) {
            //
            // } else if (audio.paused) {
          } else if (!this.isPlaying) {
            audio.play();
          } else {
            audio.pause();
          }
          return;
        }
        if (!this.current.error) {
          this.current.pause();
          this.current.currentTime = 0;
        }
      }
      this.current = audio;
      if (audio.error) {
        //
      } else {
        audio.play();
        audio.currentTime = 0;
      }
    }
  }, {
    key: 'getSrcType',
    value: function getSrcType(src, type) {
      return src + (type === 'wma' ? '' : '?type=' + type);
    }
  }, {
    key: 'isPlaying',
    get: function get() {
      return this.current && this.current.currentTime > 0 && !this.current.paused && !this.current.ended && this.current.readyState > 2;
    }
  }, {
    key: 'current',
    set: function set(audio) {
      if (this._current) {
        this._current.removeEventListener('canplaythrough', this.onLoaded);
        this._current.removeEventListener('ended', this.onEnded);
      }
      this._current = audio;
      if (audio) {
        audio.addEventListener('canplaythrough', this.onLoaded);
        audio.addEventListener('ended', this.onEnded);
      }
    },
    get: function get() {
      return this._current;
    }
  }, {
    key: 'downloadType',
    get: function get() {
      return this._downloadType;
    },
    set: function set(value) {
      this.localStorage.setItem(_localStorage.AUDIO_DOWNLOAD_TYPE, value);
      this._downloadType = value;
    }
  }]);

  return AudioService;
}();

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WavesurferComponent = WavesurferComponent;

var _wavesurfer = __webpack_require__(334);

var _wavesurfer2 = _interopRequireDefault(_wavesurfer);

var _wavesurfer3 = __webpack_require__(335);

var _wavesurfer4 = _interopRequireDefault(_wavesurfer3);

var _localStorage = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// console.log('WaveSurfer: ', WaveSurfer);
var AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
var AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma'
};

function WavesurferComponent() {
  return {
    restrict: 'E',
    scope: {
      fact: '=',
      src: '@',
      loading: '='
    },
    controller: function controller($scope, $element, $timeout, AudioWavesService) {
      if (!$scope.fact) return;
      $element.css('display', 'block');
      this.$onDestroy = function () {
        if ($scope.fact.wavesurfer) $scope.fact.wavesurfer.destroy();
        $scope.fact.wavesurfer = null;
      };

      // barHeight: 1,
      if ($scope.fact.wavesurfer) {
        var pluginName = 'minimap';
        var plugin = _wavesurfer4.default.create({
          container: $element[0],
          waveColor: '#004f75',
          progressColor: '#006b9e',
          barHeight: 2,
          height: 50
        });

        if ($scope.fact.wavesurfer[pluginName]) $scope.fact.wavesurfer.destroyPlugin(pluginName);
        $scope.fact.wavesurfer.addPlugin(plugin).initPlugin(pluginName);
        $scope.$emit('wavesurferReady', $scope.fact.wavesurfer);
      } else {
        var options = {
          container: $element[0],
          waveColor: '#004f75',
          progressColor: '#006b9e',
          barHeight: 2,
          height: 50
        };
        $scope.fact.wavesurfer = _wavesurfer2.default.create(options);
        if ($scope.src) {
          $scope.fact.wavesurfer.load($scope.src);
          $scope.loading = true;
          $scope.fact.wavesurfer.on('ready', function () {
            $scope.loading = false;
            if (!$scope.fact.wavesurfer) return;
            $scope.fact.wavesurfer.hasLoaded = true;
            $scope.$emit('wavesurferReady', $scope.fact.wavesurfer);
          });
        }
      }
      $scope.$emit('wavesurferInit', $scope.fact.wavesurfer);
    }
  };
}

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(856);

var MEDIA_ERR_ABORTED = 1; // fetching process aborted by user
var MEDIA_ERR_NETWORK = 2; // error occurred when downloading
var MEDIA_ERR_DECODE = 3; // error occurred when decoding
var MEDIA_ERR_SRC_NOT_SUPPORTED = 4; // audio/video not supported

var MEDIA_ERROR_CODE = {
  '1': gettext('Отменено'),
  '2': gettext('Ошибка сети'),
  '3': gettext('Ошибка кодека'),
  '4': gettext('Не поддерживается')
};

/*@ngInject*/

var AudioWavesController = function () {
  AudioWavesController.$inject = ["$scope", "$http", "$element", "$timeout", "LayoutService", "AudioWavesService"];
  function AudioWavesController($scope, $http, $element, $timeout, LayoutService, AudioWavesService) {
    var _this = this;

    _classCallCheck(this, AudioWavesController);

    this.$http = $http;
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.layout = LayoutService;
    this.AudioWavesService = AudioWavesService;
    this.currentTime = 0;
    this._duration = 0;
    this.audioErrors = MEDIA_ERROR_CODE;
    this.playing = false;
    this.$showTimeRange = true;
    this.loading = false;

    // error occurred during the loading or playing
    $scope.$on('col-resize', function () {
      _this.onResize();
      _this.$scope.$digest();
    });
    $scope.$on('resize', function () {
      return _this.onResize();
    });
    $scope.$on('splitter1Changed', function () {
      return _this.onResize();
    });

    this.$scope.$on('wavesurferInit', function () {
      return _this.wavesurferInit();
    });
    // this.$scope.$on('wavesurferReady', () => this.loading = false);

    this.onError = function (err) {
      if (err) {
        console.error(err, _this.fact.wavesurfer.fullSrc);
        _this.error = err + ', src: ' + _this.fact.wavesurfer.fullSrc;
      }
      _this.playing = false;
      $scope.$digest();
    };

    // the audio has been started or is no longer paused
    this.onPlay = function () {
      // console.log('onPlay CurrentTime:', this.fact.wavesurfer.getCurrentTime());
      _this.playing = true;
      _this.AudioWavesService.stopped = false;
      if (!$scope.$root.$$phase) $scope.$digest();
    };

    // the audio has been paused
    this.onPause = function () {
      // console.log('onPause CurrentTime:', this.fact.wavesurfer.getCurrentTime());
      _this.playing = false;
      _this.AudioWavesService.stopped = true;
    };

    // the audio is ended
    this.onEnded = function () {
      if (!_this.fact.wavesurfer) return;
      if (!_this.fact.wavesurfer.getCurrentTime()) return;
      _this.playing = false;
      _this.AudioWavesService.playNextAudio(_this.fact.id);
    };

    // duration data is changed
    this.onDurationChange = function () {
      _this.updateDuration();
    };

    // position is changed
    this.onTimeUpdate = function () {
      _this.updateCurrentTime();
      $scope.$digest();
    };

    this.$element.ready(function () {
      _this.setScrollElement();
    });
  }

  _createClass(AudioWavesController, [{
    key: 'setScrollElement',
    value: function setScrollElement() {
      var _this2 = this;

      this.$timeout(function () {
        _this2.scrollElement = _this2.$element.closest('[infinite-scrollfork]');
      }, 20);
    }
  }, {
    key: 'reload',
    value: function reload() {
      if (this.reloading) {
        return;
      }
      this.reloading = true;
    }
  }, {
    key: 'reloadAudio',
    value: function reloadAudio() {
      if (!this.fact.wavesurfer) return;
      // console.log('reloadAudio CurrentTime:', this.fact.wavesurfer.getCurrentTime());
      this.fact.wavesurfer.load(this.fullSrc);
      this.updateDuration();
      this.updateCurrentTime();
      this.reloading = false;
    }
  }, {
    key: '$onInit',
    value: function $onInit() {
      // this.createAudio();
    }
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {
      this.disposeAudio();
    }
  }, {
    key: 'wavesurferInit',
    value: function wavesurferInit() {

      this.fact.wavesurfer.on('audioprocess', this.onTimeUpdate);
      this.fact.wavesurfer.on('error', this.onError);
      this.fact.wavesurfer.on('play', this.onPlay);
      this.fact.wavesurfer.on('pause', this.onPause);
      this.fact.wavesurfer.on('finish', this.onEnded);
      this.fact.wavesurfer.on('seek', this.onTimeUpdate);
      this.fact.wavesurfer.on('ready', this.onWavesurferReady.bind(this));
    }
  }, {
    key: 'onWavesurferReady',
    value: function onWavesurferReady() {
      this.updateDuration();
      this.$scope.$digest();
    }
  }, {
    key: 'disposeAudio',
    value: function disposeAudio() {
      if (!this.fact.wavesurfer) return;
      // this.fact.wavesurfer.unAll();
      if (this.fact.wavesurfer.isPlaying()) this.fact.wavesurfer.pause();
      this.fact.wavesurfer.destroy();
    }
  }, {
    key: 'play',
    value: function play() {
      if (!this.fact.wavesurfer) return;
      this.AudioWavesService.play(this.fact.wavesurfer);
      this.fact.audioLoad = true;
    }
  }, {
    key: 'updateDuration',
    value: function updateDuration() {
      if (!this.fact.wavesurfer) return;
      var duration = this.fact.wavesurfer.getDuration();
      this._duration = Math.floor(duration);
    }
  }, {
    key: 'updateCurrentTime',
    value: function updateCurrentTime() {
      if (!this.fact.wavesurfer) return;
      this.currentTime = Math.floor(this.fact.wavesurfer.getCurrentTime());
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if (!this.fact.wavesurfer) return;
      this.$showTimeRange = this.$element.parent().width() > 280;
      this.fact.wavesurfer.drawBuffer();
    }
  }, {
    key: 'fullSrc',
    get: function get() {
      return this.AudioWavesService.getSrcType(this.src, this.AudioWavesService.fileType);
    }
  }, {
    key: 'fileName',
    get: function get() {
      return this.fact['agent_agent.computer_name'] + '_' + this.fact.local_time.substring(0, 19).replace(/:/gi, '').replace(/T/gi, '_') + '.' + this.AudioWavesService.downloadType;
    }
  }, {
    key: 'isPlaying',
    get: function get() {
      return this.fact.wavesurfer && this.fact.wavesurfer.isPlaying();
    }
  }, {
    key: 'duration',
    get: function get() {
      if (!this._duration) this.updateDuration();
      return this._duration;
    }
  }, {
    key: 'downreloadSrc',
    get: function get() {
      return this.AudioWavesService.getSrcType(this.src, this.AudioWavesService.downloadType);
    }
  }, {
    key: 'showTimeRange',
    get: function get() {
      return this.$showTimeRange;
    }
  }, {
    key: 'showTime',
    get: function get() {
      return this.playing || this.isSelected && this.hasDuration;
    }
  }, {
    key: 'isSelected',
    get: function get() {
      return this.fact.selected;
    }
  }, {
    key: 'hasDuration',
    get: function get() {
      if (!this.fact.wavesurfer) return false;
      var duration = this.fact.wavesurfer.getDuration();

      return typeof duration === 'number' && !isNaN(duration) && isFinite(duration);
    }
  }, {
    key: 'isShowWaves',
    get: function get() {
      var res = this.$element.closest('.show-waves')[0] || !this.$element.closest('sc-fact-thumb')[0] && this.scrollElement && this.scrollElement[0] && this.$element.offset().top + 200 > 0 && this.$element.offset().top - 200 < this.scrollElement.height() && this.$element.offset().left + 200 > 0 && this.$element.offset().left - 200 < this.scrollElement.width();
      return res;
    }
  }]);

  return AudioWavesController;
}();

var AudioWavesComponent = exports.AudioWavesComponent = {
  template: __webpack_require__(857),
  controller: AudioWavesController,
  bindings: {
    fact: '<',
    src: '<',
    index: '<'
  }
};

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sc-audio-waves\"><span class=\"sc-audio-waves-download\"><a ng-href=\"{{$ctrl.fullSrc}}\" download=\"{{$ctrl.fileName}}\">{{::'Скачать'| gettext}} <i class=\"icon icon-download\"></i></a><select class=\"select-download-type\" ng-model=\"$ctrl.AudioWavesService.downloadType\" ng-options=\"type for type in $ctrl.AudioWavesService.downloadTypes\"></select></span><span class=\"sc-audio-waves-error text-danger\" ng-if=\"$ctrl.error\">{{$ctrl.error}} <i class=\"icon icon-reload pointer\" ng-click=\"$ctrl.reload()\"></i> </span><span class=\"sc-audio-waves-player\" ng-if=\"!$ctrl.error\"><span ng-click=\"$ctrl.play()\"><i class=\"icon\" ng-class=\"{'icon-play': !$ctrl.isPlaying, 'icon-pause': $ctrl.isPlaying}\"></i> </span><span ng-show=\"$ctrl.showTime\"><span class=\"sc-audio-waves-info\"><span ng-bind=\"$ctrl.currentTime | timeSpan\"></span> / <span ng-bind=\"$ctrl.duration | timeSpan\"></span> </span></span></span><span ng-if=\"$ctrl.isShowWaves\"><span ng-if=\"$ctrl.loading\"><i class=\"icon-loading animate-spin\"></i></span><sc-wavesurfer loading=\"$ctrl.loading\" fact=\"$ctrl.fact\" src=\"{{$ctrl.fullSrc}}\"></sc-wavesurfer></span><div ng-if=\"!$ctrl.isShowWaves\" class=\"empty-place\"></div></div>"

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioWavesService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _localStorage = __webpack_require__(87);

var _wavesurfer = __webpack_require__(334);

var _wavesurfer2 = _interopRequireDefault(_wavesurfer);

var _wavesurfer3 = __webpack_require__(335);

var _wavesurfer4 = _interopRequireDefault(_wavesurfer3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AUDIO_TYPES = ['mp3', 'ogg', 'wav', 'wma'];
var AUDIO_CONTENT_TYPES = {
  'mp3': 'audio/mpeg',
  'ogg': 'audio/ogg',
  'wav': 'audio/wav',
  'wma': 'audio/wma'
};

var AudioWavesService = exports.AudioWavesService = function () {
  function AudioWavesService(LocalStorageService, $timeout, $rootScope, CurrentFilterDataService) {
    _classCallCheck(this, AudioWavesService);

    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.localStorage = LocalStorageService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.current = null;
    this.currentWavesurfer = null;
    this.downloadTypes = AUDIO_TYPES;
    this._downloadType = LocalStorageService.getItem(_localStorage.AUDIO_DOWNLOAD_TYPE);
    this.fileType = this.downloadTypes[0];
    if (this.downloadTypes.indexOf(this.downloadType) === -1) {
      this.downloadType = this.fileType;
    }
    this.lastFinishEventFact = 0;
    this.lastFinishEventDone = false;
    this.wavesurfers = [];
    this.maxLoading = 3;
    this.maxLoaded = 50;
    this.currLoadingCount = 0;
    this.currLoadingIndex = -1;
    this.scrollElement = null;
    this.updatingOffsetTop = false;
  }

  _createClass(AudioWavesService, [{
    key: 'play',
    value: function play(wavesurfer, progress) {
      if (!wavesurfer) {
        console.log('no wavesurfer');
      }
      if (this.currentWavesurfer) {
        if (this.currentWavesurfer === wavesurfer) {
          wavesurfer.playPause();
          return;
        }
        if (this.currentWavesurfer.isPlaying()) this.currentWavesurfer.pause();
      }
      this.currentWavesurfer = wavesurfer;
      if (progress !== undefined) wavesurfer.seekTo(progress);
      this.$timeout(function () {
        wavesurfer.playPause();
      }, 100);
    }
  }, {
    key: 'getSrcType',
    value: function getSrcType(src, type) {
      return src + (type === 'wma' ? '' : '?type=' + type);
    }
  }, {
    key: 'isPlaying',
    get: function get() {
      // return this.current && this.current.currentTime > 0 && !this.current.paused && !this.current.ended && this.current.readyState > 2;
      return this.currentWavesurfer && this.currentWavesurfer.isPlaying();
    }
  }, {
    key: 'downloadType',
    get: function get() {
      return this._downloadType;
    },
    set: function set(value) {
      this.localStorage.setItem(_localStorage.AUDIO_DOWNLOAD_TYPE, value);
      this._downloadType = value;
    }
  }]);

  return AudioWavesService;
}();

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(860);

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactThumbComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _iconClass = __webpack_require__(38);

var _fact = __webpack_require__(89);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FactThumbController = function () {
  function FactThumbController($scope) {
    _classCallCheck(this, FactThumbController);

    this.isImage = _fact.Fact.isImage;
  }

  _createClass(FactThumbController, [{
    key: 'icon',
    get: function get() {
      return this.fact && _iconClass.TYPE2CLASS[this.fact['agent_eventtype.name']];
    }
  }]);

  return FactThumbController;
}();

var FactThumbComponent = exports.FactThumbComponent = {
  bindings: {
    filter: '<',
    fact: '<',
    openImage: '<',
    listType: '<',
    selected: '<'
  },
  controller: FactThumbController,
  template: __webpack_require__(862)
};

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.fact.nextDate\" class=\"timeline-group-title\">{{$ctrl.fact['local_time'] | date:'dd.MM.yyyy' }}</div><span class=\"label label-info timeline-name\">{{$ctrl.fact['agent_account.user_name']}}</span><br><div id=\"thumb_{{$ctrl.fact['id']}}_preloader\" class=\"thumbnail-preloader-container\"><div class=\"thumbnail-preloader\"></div></div><a href=\"#\" onclick=\"return!1\" ng-click=\"$ctrl.openImage($ctrl.fact)\" ng-class=\"$ctrl.selected ? 'timeline-thumbnail-selected' : 'timeline-thumbnail'\"><img ng-if=\"$ctrl.isImage($ctrl.fact)\" id=\"thumb_{{$ctrl.fact['id']}}\" ng-src=\"{{'/media/' + $ctrl.fact['agent_attachedfile.data']}}\" thumblistonload thumbonerror><div ng-if=\"!$ctrl.isImage($ctrl.fact)\"><span class=\"widget-icon\" ng-class=\"$ctrl.icon\"></span> <span>{{$ctrl.fact['agent_eventtype.description']}}</span><br><sc-fact-info filter=\"$ctrl.filter\" fact=\"$ctrl.fact\" open-image=\"$ctrl.openImage\"></div></a><br><span class=\"timeline-label\" style=\"font-weight:400\">{{$ctrl.fact['local_time'] | date:'dd.MM.yyyy' }} </span>&nbsp;&nbsp; <span class=\"timeline-label\">{{$ctrl.fact['local_time'] | date:'HH:mm:ss'}} </span>"

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactSliderComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fact = __webpack_require__(89);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(864);

var FactsSliderController = function () {
  function FactsSliderController($scope, $element, $timeout, $interval) {
    var _this = this;

    _classCallCheck(this, FactsSliderController);

    this.$scope = $scope;
    this.$element = $element;
    this.$interval = $interval;
    this.$timeout = $timeout;
    this.isImage = _fact.Fact.isImage;
    this.getImageFileName = _fact.Fact.getImageFileName;
    this.enableWatchModel = true;
    this.playing = false;
    this.playingDelay = 3;
    this.playingID = null;

    this.keyboardEvents = {
      13: function _() {}, // Enter
      27: function _() {}, // Esc
      32: function _() {
        _this.leaf(1);
      }, // Space
      33: function _() {
        _this.leaf(-5);
      }, // PgUp
      34: function _() {
        _this.leaf(5);
      }, // PgDown
      35: function _() {
        _this.leafToLast();
      }, // End
      36: function _() {
        _this.leafToFirst();
      }, // Home
      37: function _() {
        _this.leaf(-1, true);
      }, // Left
      38: function _() {
        _this.leaf(-1);
      }, // Up
      39: function _() {
        _this.leaf(1, true);
      }, // Right
      40: function _() {
        _this.leaf(1);
      } // Down
    };

    $timeout(function () {
      $('.showImageModal').removeClass('modal');
      var windowHeight = $(window).height();
      var timelineHeight = $('.imageDialogTimeline').height();
      var imageDialogBody = $('.imageDialogBody');
      if (!imageDialogBody[0]) return;
      var imageHeight = windowHeight - imageDialogBody.offset()['top'] - timelineHeight - 10;
      imageDialogBody.height(imageHeight);
      imageDialogBody.find('img').css('max-height', imageHeight + 'px');
      $timeout(function () {
        console.log('SSSSSSSSSSSSSSSSSSS');
        $('.btn-layout-next').css({
          'line-height': '20px'
        });
      }, 100);
    }, 100);
  }

  _createClass(FactsSliderController, [{
    key: '$postLink',
    value: function $postLink() {
      var _this2 = this;

      $('#screenshot-image').bind('load error', function () {
        //console.log("onload");
        _this2.onImageLoad();
        _this2.$timeout(function () {
          _this2.$scope.$digest();
        }, 0);
      });
      this.$element.bind('keydown keypress', function (e) {
        _this2.onKeyDown(e);
      });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var code = e.which;
      // console.log(code);
      if (code in this.keyboardEvents) {
        this.keyboardEvents[code]();
        e.preventDefault();
      }
    }
  }, {
    key: 'scrollPrev',
    value: function scrollPrev() {
      this.enableWatchModel = false;

      var $timelineClip = $('.timeline-container-clip');
      var containerWidth = $('.timeline-container').width();
      var offset = containerWidth - Math.ceil(containerWidth / 5);
      var thumbnalListLeft = -$timelineClip.position().left;

      //console.log("scrollPrev() --|");
      //console.log("               containerWidth=" + containerWidth);
      //console.log("               thumbnalListWidth=" + this.getThumbnalListWidth());
      //console.log("               curPos=" + thumbnalListLeft + ", offset=" + offset + ", newPos=" + (thumbnalListLeft + offset));

      var animateLeft = void 0;
      if (thumbnalListLeft - offset < 0) {
        animateLeft = 0;
      } else {
        animateLeft = '+=' + offset;
      }
      $timelineClip.animate({
        left: animateLeft
      }, {
        // specialEasing: 'slow',
        queue: false
      });
    }
  }, {
    key: 'scrollNext',
    value: function scrollNext() {
      this.enableWatchModel = false;

      var $timelineClip = $('.timeline-container-clip');
      var containerWidth = $('.timeline-container').width();
      var offset = containerWidth - Math.ceil(containerWidth / 5);
      var thumbnalListWidth = this.getThumbnalListWidth();
      var thumbnalListLeft = -$timelineClip.position().left;

      //console.log("scrollNext() --|");
      //console.log("               containerWidth=" + containerWidth);
      //console.log("               thumbnalListWidth=" + thumbnalListWidth);
      //console.log("               curPos=" + thumbnalListLeft + ", offset=" + offset + ", newPos=" + (thumbnalListLeft + offset));

      if (thumbnalListLeft + offset + containerWidth > thumbnalListWidth) {
        if (thumbnalListWidth > containerWidth) {
          offset = thumbnalListWidth - containerWidth - thumbnalListLeft;
        } else {
          offset = -thumbnalListLeft;
        }
        this.moreFacts();
      }
      $timelineClip.animate({
        left: '-=' + offset
      }, {
        // specialEasing: 'slow',
        queue: false
      });
    }
  }, {
    key: 'getThumbnalListWidth',
    value: function getThumbnalListWidth() {
      var thumbListWidth = 0;
      var $thumbnails = $('.thumbnail-layout');
      var marginRight = $thumbnails.css('margin-right') != null ? $thumbnails.css('margin-right') : '0px';
      var offsetWidth = parseInt(marginRight.substr(0, marginRight.length - 2), 10);
      $thumbnails.each(function (index) {
        thumbListWidth += $thumbnails.get(index).offsetWidth + offsetWidth;
      });
      return thumbListWidth;
    }
  }, {
    key: 'getX',
    value: function getX(fact) {
      var $thumbnails = $('.thumbnail-layout');
      var marginRight = $thumbnails.css('margin-right') != null ? $thumbnails.css('margin-right') : '0px';
      var offsetWidth = parseInt(marginRight.substr(0, marginRight.length - 2), 10);
      var containerWidth = $('.timeline-container').width();
      var thumbListWidth = 0;
      var thumbByIndexWidth = 0;
      var eventIndex = this.getIndex();
      $thumbnails.each(function (index) {
        var thumbWidth = $thumbnails.get(index).offsetWidth + offsetWidth;
        thumbListWidth += thumbWidth;
        if (index < eventIndex) {
          thumbByIndexWidth += thumbWidth;
        } else if (index == eventIndex) {
          thumbByIndexWidth += Math.ceil(thumbWidth / 2);
        }
        //console.log(index + " (" + eventIndex + "): thumbWidth: " + thumbWidth + ", thumbListWidth: " + thumbListWidth + ", thumbByIndexWidth: " + thumbByIndexWidth);
      });

      var pos = 0;
      //console.log("container: " + containerWidth + ", offset: " + offsetWidth + ", thumbByIndexWidth: " + thumbByIndexWidth);
      if (thumbByIndexWidth > containerWidth / 2) {
        if (thumbListWidth - thumbByIndexWidth < containerWidth / 2) {
          pos = -(thumbListWidth - containerWidth);
        } else {
          pos = -(thumbByIndexWidth - containerWidth / 2);
        }
      }
      if (pos > 0) {
        pos = 0;
      }

      //console.log("pos: " + pos);
      return pos;
    }
  }, {
    key: 'move',
    value: function move(fact) {
      if (!this.enableWatchModel) {
        return;
      }
      //console.log("move");
      $('.timeline-container-clip').animate({
        'left': this.getX(fact)
      }, {
        // specialEasing: 'slow',
        queue: false
      });
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      var _this3 = this;

      // return this.selectedFact && this.filterData.filterData ?
      // this.filterData.filterData.indexOf(this.selectedFact) : 0;

      return this.selectedFact && this.filterData.filterData ? this.filterData.filterData.findIndex(function (f) {
        return f.id === _this3.selectedFact.id;
      }) : 0;
    }
  }, {
    key: 'next',
    value: function next() {
      this.enableWatchModel = true;
      this.leaf(1);
    }
  }, {
    key: 'prev',
    value: function prev() {
      this.enableWatchModel = true;
      this.leaf(-1);
    }
  }, {
    key: 'selectThumb',
    value: function selectThumb(fact) {
      var _this4 = this;

      if (this.selectedFact && fact.id === this.selectedFact.id) {
        return;
      }
      this.enableWatchModel = true;
      $('#image-spinner').show();

      this.selectedFact = fact;

      if (this.playing) {
        this.pauseUntilLoading();
      }
      if (fact['agent_attachedfile.data']) {
        this.$timeout(function () {
          //console.log($('#screenshot-image').get(0).complete);
          var thumbImage = $('#screenshot-image').get(0);
          if (!thumbImage || thumbImage.complete) {
            _this4.onImageLoad();
          } else {
            _this4.onImageLoad();
          }
        }, 10);
      } else {
        this.onImageLoad();
      }
      this.$timeout(function () {
        _this4.$scope.$digest();
      }, 0);
    }
  }, {
    key: 'onImageLoad',
    value: function onImageLoad() {
      $('#image-spinner').hide();
      if (this.playing) {
        this.play();
      }
    }
  }, {
    key: 'leaf',
    value: function leaf(step, apply) {
      var eventIndex = this.getIndex();
      //                 console.log('leaf started, step: '+step+', apply: '+apply+', eventIndex: '+eventIndex+', filterData.filterData.length: '+this.filterData.filterData.length);
      while (eventIndex < this.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += step;
        if (eventIndex + step >= this.filterData.filterData.length) {
          this.moreFacts();
        }
        if (eventIndex >= 0) {
          var fact = this.filterData.filterData[eventIndex];
          if (fact) {
            this.selectThumb(fact);
            if (apply) {
              this.$scope.$apply();
            }
            break;
          }
        }
      }
    }
  }, {
    key: 'moreFacts',
    value: function moreFacts() {
      return this.filterData.moreFacts();
    }
  }, {
    key: 'onPlayClick',
    value: function onPlayClick() {
      this.playing = !this.playing;
      if (this.playing) {
        this.play();
      } else {
        this.stop();
      }
    }
  }, {
    key: 'play',
    value: function play() {
      var _this5 = this;

      this.playingDelay = $('.showImageModal .player-input').val();
      this.playing = true;

      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }

      this.playingID = this.$interval(function () {
        _this5.next();
      }, this.playingDelay * 1000);
    }
  }, {
    key: 'pauseUntilLoading',
    value: function pauseUntilLoading() {
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.playing = false;
      if (angular.isDefined(this.playingID)) {
        this.$interval.cancel(this.playingID);
      }
    }
  }, {
    key: 'closeDialog',
    value: function closeDialog() {
      this.$scope.$parent.closeDialog();
      $('#image-spinner').hide();
      this.stop();
    }
  }, {
    key: 'hasPrev',
    get: function get() {
      return this.filterData.filterData && this.filterData.filterData.length && this.filterData.filterData[0].id !== this.selectedFact.id;
    }
  }, {
    key: 'hasNext',
    get: function get() {
      // let visible = true;
      // if (!this.filterData.filterData ||
      //   !this.filterData.filterData.length || (!this.filterData.isComplete &&
      //     this.filterData.filterData[this.filterData.filterData.length - 1].id === this.selectedFact.id)) {
      //   visible = false;
      // }
      // return visible;
      return !(this.filterData.filterData && this.filterData.filterData.length && this.filterData.isComplete && this.filterData.filterData[this.filterData.filterData.length - 1].id === this.selectedFact.id);
    }
  }]);

  return FactsSliderController;
}();

var FactSliderComponent = exports.FactSliderComponent = {
  bindings: {
    model: '<',
    filter: '<',
    filterData: '<',
    selectedFact: '<'
  },
  template: __webpack_require__(865),
  controller: FactsSliderController
};

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "<div style=\"width:99%;padding:.5%;display:block;clear:both;height:auto\" class=\"imageDialogHead\"><h4 class=\"pull-left\" style=\"display:inline-block\">{{$ctrl.selectedFact['agent_account.user_name']}}@{{$ctrl.selectedFact['agent_agent.computer_name']}}: {{$ctrl.selectedFact['local_time'] | date:'HH:mm:ss yyyy-MM-dd' }}</h4><div class=\"pull-right\" style=\"clear:right\"><div class=\"player-form\"><span class=\"spinner-container\" ng-if=\"$ctrl.filterData.loading || $ctrl.filterData.loadingMore\"><i class=\"icon-loading animate-spin\"></i> </span><span class=\"player-label\">{{::'Задержка' | gettext}}:</span> <input class=\"player-input\" ng-model=\"$ctrl.playingDelay\"> <span class=\"player-label\">{{::'сек' | gettext}}</span> <a ng-class=\"$ctrl.playing ? 'btn-dialog-pause' : 'btn-dialog-play'\" data-dismiss=\"modal\" ng-click=\"$ctrl.onPlayClick()\"></a></div><a class=\"btn-dialog-close\" data-dismiss=\"modal\" ng-click=\"$ctrl.closeDialog()\"></a></div></div><div class=\"imageDialogBody\"><div class=\"btn-layout-prev\"><div class=\"btn-container-prev btn-image-prev\" ng-click=\"$ctrl.prev()\" ng-class=\"{disable: !$ctrl.hasPrev}\"></div></div><sc-facts-slider-view filter=\"$ctrl.filter\" selected-fact=\"$ctrl.selectedFact\"></sc-facts-slider-view><div class=\"btn-layout-next\"><div class=\"btn-container-next btn-image-next\" ng-click=\"$ctrl.next()\" ng-class=\"{disable: !$ctrl.hasNext}\"></div></div></div><sc-facts-slider-timeline></sc-facts-slider-timeline>"

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.FactsComponent = FactsComponent;

var _factsSliderModal = __webpack_require__(867);

var _tableView = __webpack_require__(62);

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(893);

// /* global gettext */

var FactsController = function () {
  function FactsController($scope, $timeout, $element, AudioWavesService, AudioService, $modal, RouterService, FieldsModalService, LayoutService, CurrentModelService, CurrentFilterService, LocalStorageService) {
    var _this = this;

    _classCallCheck(this, FactsController);

    this.$scope = $scope;
    this.$timeout = $timeout;
    $scope.generateReport = RouterService.generateReport.bind(RouterService);
    $scope.isCollapsed = true;
    $scope.router = RouterService;
    this.dims = CurrentModelService.model._dimensions;
    this.FieldsModalService = FieldsModalService;
    this.CurrentFilterService = CurrentFilterService;
    $scope.setShowSystemKeys = _tableView.setShowSystemKeys;
    $scope.LayoutService = LayoutService;
    $scope.selectedFact = $scope.filterData.filterData && $scope.filterData.filterData.length ? $scope.filterData.filterData[0] : null;
    if ($scope.selectedFact) {
      $scope.selectedFact.selected = true;
    }

    if (_config.IS_IE_BROWSER) {
      AudioService.loadNextAudio = function () {
        var nextFact = $scope.getNextAudio({
          select: false
        });
        if (nextFact && nextFact.audio && !nextFact.audioLoad) {
          // console.log('load audio', nextFact.audio.src);
          nextFact.audio.load();
          nextFact.audioLoad = true;
        }
      };

      AudioService.playNextAudio = function () {
        var nextFact = $scope.getNextAudio({
          select: true
        });
        if (nextFact && nextFact.audio) {
          AudioService.play(nextFact.audio);
          nextFact.audioLoad = true;
        }
      };
    }

    $scope.$on('factsLoaded', function () {
      if (!$scope.router.needToShowFact) return;
      if ($scope.router.needToShowFact.needShowScreenshot) {
        var res = $scope.router.CurrentFilterDataService.filterData.filterData;
        if (res && res.length) {
          var fact = $scope.router.needToShowFact.fact;
          if (!fact && $scope.router.needToShowFact.date) {
            console.log('data:', $scope.router.needToShowFact.date);
            var date = new Date($scope.router.needToShowFact.date).getTime();
            fact = res[0];
            var dateDiff = Math.abs(new Date(fact.local_time).getTime() - date);
            res.forEach(function (f) {
              var d = Math.abs(new Date(f.local_time).getTime() - date);
              if (d < dateDiff) {
                fact = f;
                dateDiff = d;
              }
            });
          } else if (!fact) fact = res[0];

          $scope.showImage(fact);
          delete $scope.router.needToShowFact;
        } else {
          $scope.router.needToShowFact = false;
          $scope.router.modal = null;
        }
      } else if ($scope.router.needToShowFact.needShowtoNeighbours) {
        var _fact = $scope.filterData.filterData.find(function (f) {
          return f.id === $scope.router.needToShowFact.fact.id;
        });
        if (!_fact) return;
        $scope.LayoutService.loading = true;
        $scope.select(_fact);
        _this.$timeout(function () {
          $scope.$apply(function () {
            return $scope.LayoutService.loading = false;
          });
        }, 100);
        delete $scope.router.needToShowFact;
      }
    });

    $scope.showSelectFields = function () {
      return _this.CurrentFilterService && _this.CurrentFilterService.filter && !_this.CurrentFilterService.filter.isDashboard && !_this.CurrentFilterService.filter.isCard;
    };

    $scope.selectFields = function () {
      return _this.FieldsModalService.open('TABLE').then(function (r) {
        if (r) _this.$timeout(function () {
          $scope.filterData.filterData = angular.copy($scope.filterData.filterData);
          _this.$timeout(function () {
            return $scope.$root.$broadcast('resize');
          }, 0);
        }, 200);
      });
    };

    $scope.getNextAudio = function (_ref) {
      var select = _ref.select;

      var eventIndex = $scope.getEventIndex();
      while (eventIndex < $scope.filterData.filterData.length && eventIndex >= 0) {
        eventIndex += 1;
        if (eventIndex + 1 >= $scope.filterData.filterData.length) {
          $scope.more();
        }
        if (eventIndex >= 0) {
          var fact = $scope.filterData.filterData[eventIndex];
          if (fact && fact['agent_eventtype.id'] === 21) {
            if (select) {
              $scope.select(fact);
              $scope.$apply();
            }
            return fact;
          }
        }
      }
    };
    AudioWavesService.loadNextAudio = function () {};

    AudioWavesService.playNextAudio = function (previousPlayedFact) {
      if (previousPlayedFact === _this.previousPlayedFact) return;
      _this.previousPlayedFact = previousPlayedFact;
      var nextFact = $scope.getNextAudio({
        select: true
      });
      if (nextFact && nextFact.wavesurfer) {
        AudioWavesService.play(nextFact.wavesurfer, 0);
        nextFact.audioLoad = true;
      }
    };

    $scope.select = function (fact) {
      if (fact === $scope.selectedFact) {
        return;
      }

      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
      }
      $scope.selectedFact = fact;
      fact.selected = true;
      var position1 = $element.find('#tr' + fact.id).position() || 0;
      var eventTable = $element.find('.fact-table-tbody');
      var current = eventTable.scrollTop();
      var tbody_height = eventTable.height();
      eventTable.animate({
        scrollTop: current + position1.top - tbody_height / 3
      }, 100);
      $scope.$broadcast('showPane2');
    };

    $scope.deselect = function () {
      if ($scope.selectedFact) {
        $scope.selectedFact.selected = false;
        $scope.selectedFact = null;
        $scope.$broadcast('hidePane2');
        $scope.$apply();
      }
    };

    $scope.leaf = function (step) {
      var eventIndex = $scope.getEventIndex();
      if (eventIndex + step >= $scope.filterData.filterData.length) {
        $scope.more();
      } else {
        eventIndex += step;
        if (eventIndex < 0) eventIndex = 0;
        //                 console.log('eventIndex: ' + eventIndex);
        var fact = $scope.filterData.filterData[eventIndex];
        $scope.select(fact);
        $scope.$apply();
      }
    };
    // $scope.getEventIndex = () => $scope.selectedFact ?
    //   $scope.filterData.filterData.indexOf($scope.selectedFact) : 0;
    $scope.getEventIndex = function () {
      return $scope.selectedFact ? $scope.filterData.filterData.findIndex(function (f) {
        return $scope.selectedFact.id === f.id;
      }) : 0;
    };

    $scope.leafToLast = function () {
      var moveTo = $scope.filterData.filterData && $scope.filterData.filterData.length ? $scope.filterData.filterData[$scope.filterData.filterData.length - 1] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };
    $scope.leafToFirst = function () {
      var moveTo = $scope.filterData.filterData && $scope.filterData.filterData.length ? $scope.filterData.filterData[0] : null;
      if (moveTo) {
        $scope.select(moveTo);
        $scope.$apply();
      }
    };

    $scope.openImage = function (fact) {
      $scope.router.needToShowFact = {
        needShowScreenshot: true,
        fact: fact
      };
      $scope.$root.$broadcast('factsLoaded');
    };

    $scope.openFact = function (fact) {
      console.log('Hover', _this);
    };

    $scope.showImage = function (fact) {
      if ($scope.router.isFilterEditModal) return;
      $scope.select(fact);
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
      }
      if ($scope.router.imageDialog) {
        $scope.router.imageDialog.close();
      }

      $scope.imageDialog = $modal.open({
        scope: $scope,
        template: __webpack_require__(894),
        controller: _factsSliderModal.FactSliderModalController,
        windowClass: 'showImageModal'
      });

      $scope.router.CurrentFilterService.modal = null;
      $scope.router.needToShowFact = false;
      $scope.router.imageDialog = $scope.imageDialog;

      $scope.imageDialog.result.catch(function (coseData) {
        return $scope.router.removeModal();
      });
      $scope.imageDialog.result.then(function (coseData) {
        return $scope.router.removeModal();
      });
    };

    $scope.closeDialog = function () {
      if ($scope.imageDialog) {
        $scope.imageDialog.close();
        // $scope.router.removeModal();
      }
    };

    $scope.$watch('viewMode', function (newVal) {
      $scope.$broadcast('viewModeChanged', newVal);
    });

    var changeViewMode = function changeViewMode() {
      var filter = $scope.filter;
      if (filter) {
        $scope.viewMode = (0, _tableView.getTableViewByType)(filter.viewModeType(), filter.filters, filter.fields, _this.dims);
      }
      if (!$scope.filterData.filterData || !$scope.filterData.filterData.length || !$scope.selectedFact || !~$scope.filterData.filterData.findIndex(function (f) {
        return f.id === $scope.selectedFact.id;
      })) {
        $scope.selectedFact = null;
      }
      if (!$scope.selectedFact) {
        $scope.$broadcast('hidePane2');
      }
    };

    $scope.$watch('filterData.filterData', function (newVal, oldVal) {
      changeViewMode();
    }, false);

    var keyboardEvents = {
      13: function _() {
        if ($scope.selectedFact['agent_eventtype.name'] === 'Screenshot') $scope.openImage($scope.selectedFact);
        $scope.$apply();
      }, // Enter
      27: function _() {}, // Esc
      32: function _() {
        $scope.leaf(1);
      }, // Space
      33: function _() {
        $scope.leaf(-5);
      }, // PgUp
      34: function _() {
        $scope.leaf(5);
      }, // PgDown
      35: function _() {
        $scope.leafToLast();
      }, // End
      36: function _() {
        $scope.leafToFirst();
      }, // Home
      37: function _() {
        $scope.leaf(-1, true);
      }, // Left
      38: function _() {
        $scope.leaf(-1);
      }, // Up
      39: function _() {
        $scope.leaf(1, true);
      }, // Right
      40: function _() {
        $scope.leaf(1);
      } // Down
    };

    $scope.bindEvents = function () {
      $element.off('keydown').on('keydown', function (e) {
        var code = e.which;
        //                 console.log(code);
        if (code in keyboardEvents) {
          keyboardEvents[code]();
          e.preventDefault();
        }
      });
    };

    $scope.splitter = {
      pos: _config.WSPLITTER
    };
    Object.defineProperty($scope, 'listType', {
      get: function get() {
        return $scope.filter.listType;
      }
    });
    $scope.more = function () {
      return $scope.loadMore && $scope.filterData.moreFacts();
    };

    // const subscriptions = [$scope.filterData.filterData$.subscribe(() => {
    //   $scope.$root.$broadcast('factsLoaded');
    // })];
    // $scope.$on('$destroy', () => subscriptions.forEach((subscription) =>
    //   subscription.dispose()));
  }

  _createClass(FactsController, [{
    key: 'toggleSortOrder',
    value: function toggleSortOrder(col) {
      if (!col.sortable) return;
      var filter = this.$scope.filter;
      filter.orderDir = filter.orderDir === 'desc' ? 'asc' : 'desc';
      filter.order = col.factKey;
      this.$scope.router.filter = filter;
      // this.$scope.filterData.update(filter);
    }
  }, {
    key: 'isColSorted',
    value: function isColSorted(col) {
      if (!col.sortable) return false;
      var order = this.$scope.filter.order === 'record_count' ? 'local_time' : this.$scope.filter.order;
      return order === col.factKey;
    }
  }]);

  return FactsController;
}();

function FactsComponent($compile, $timeout, RouterService) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      filterData: '<',
      showFactsInfo: '<',
      loadMore: '<'
    },
    template: __webpack_require__(895),
    controller: FactsController,
    controllerAs: '$ctrl',
    link: function link(scope, element, attrs) {
      scope.setShowSystemKeys(scope.LayoutService.options);
      scope.$watch('filter.listType', function (newVal, oldVal) {
        scope.bindEvents();

        // Send event to update table columns
        if (newVal === 'table') {
          $timeout(function () {
            scope.$broadcast('viewModeChanged', scope.viewMode);
          });
        }

        if (newVal === 'table') {
          element.find('.fact-table-tbody').focus();
        } else if (newVal === 'thumblist') {
          element.find('.fact-thumbnail-list').focus();
        }

        element.click('.widget-value', function (event) {
          var el = angular.element(event.target);
          var closestAttr = function closestAttr(elScope, attr) {
            while (!elScope[attr] && elScope.$parent) {
              elScope = elScope.$parent;
            }
            return elScope[attr];
          };
          if (el.attr('data-key')) {
            scope.$apply(function () {
              var key = el.attr('data-key');
              if (key === 'agent_web@url:url') {
                return window.open(el.attr('data-value'));
              }
              if (key === 'id@default:id') {
                RouterService.setFilter(key, el.attr('data-value'), el.attr('data-label'));
                return;
              }
              // todo when $compileProvider.debugInfoEnabled is set to false,
              // calling .scope() on a DOM node will return undefined
              // const elScope = el.scope().$parent;
              var fact = closestAttr(el.scope(), 'fact');
              var model = closestAttr(el.scope(), 'model');
              if (fact && model) {
                var filter = model.getCellFilter(key, fact);
                RouterService.drilldownFilter2(filter);
              }
              // RouterService.drilldownFilter(filter);
            });
          }
        });
      });
    }
  };
}

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FactSliderModalController = exports.FactSliderModalController = function FactSliderModalController() {
  _classCallCheck(this, FactSliderModalController);
};

/***/ }),
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 891 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button> <b class=\"modal-title\">{{:: 'Распознавание лиц' | gettext }}</b></div><div class=\"modal-body\">{{:: 'Данное лицо принадлежит пользователю' | gettext }} <b>{{user_name}}</b>?</div><div class=\"modal-footer\"><div><button class=\"btn btn-success\" ng-click=\"ok(true)\">{{:: 'Да' | gettext }}</button> <button class=\"btn btn-danger\" ng-click=\"ok(false)\">{{:: 'Нет' | gettext }}</button> <button class=\"btn\" ng-click=\"cancel()\">{{:: 'Закрыть' | gettext }}</button></div></div></div>"

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "<sc-fact-slider model=\"model\" filter=\"filter\" filter-data=\"filterData\" selected-fact=\"selectedFact\"></sc-fact-slider>"

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"filter.listType === 'full' || filter.listType === 'brief'\" infinite-scrollfork=\"more()\" infinite-scroll-distance=\"2\" infinite-scroll-disabled=\"filterData.loading || filterData.loadingMore || filterData.isComplete || filterData.cancelled || filterData.cancelledMore\" class=\"for-save-as-image fact-container\"><sc-fact-widget model=\"model\" filter=\"filter\" ng-repeat=\"fact in filterData.filterData\" fact=\"fact\" open-image=\"openImage\" list-type=\"listType\"></sc-fact-widget><div class=\"spinner-widget\" ng-if=\"filterData.loadingMore\"><sc-spinner></sc-spinner></div></div><sc-facts-table ng-if=\"filter.listType === 'table' && !showFactsInfo\"></sc-facts-table><bg-splitter name=\"splitter3\" ng-if=\"filter.listType === 'table' && showFactsInfo\" orientation=\"vertical\" pos=\"splitter.pos\"><bg-pane><sc-facts-table></sc-facts-table></bg-pane><bg-pane><div class=\"fact-table-details\"><pre tabindex=\"2\" sc-fact-bottom filter=\"filter\" fact=\"selectedFact\" open-image=\"openImage\">\n      </pre></div></bg-pane></bg-splitter><div ng-if=\"filter.listType === 'thumblist'\" id=\"fact-thumbnail-container\" infinite-scrollfork=\"more()\" infinite-scroll-distance=\"2\" infinite-scroll-disabled=\"filterData.loading || filterData.loadingMore || filterData.isComplete || filterData.cancelled || filterData.cancelledMore\" infinite-scroll-listen-for-event=\"thumbnail:load\"><div class=\"for-save-as-image fact-thumbnail-list\" tabindex=\"1\"><sc-fact-thumb ng-repeat=\"fact in filterData.filterData\" filter=\"filter\" fact=\"fact\" open-image=\"openImage\" list-type=\"listType\" class=\"thumbnail-container\" selected=\"fact.id === selectedFact.id\"></sc-fact-thumb><div class=\"spinner-widget\" ng-if=\"filterData.loadingMore\"><sc-spinner></sc-spinner></div></div></div>"

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactsWidgetComponent = FactsWidgetComponent;

var _tableView = __webpack_require__(62);

__webpack_require__(897);

function str2ab(str) {
  var buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  var bufView = new Uint16Array(buf);
  for (var i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

function FactsWidgetComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      model: '<',
      filter: '<',
      fact: '<',
      openImage: '<',
      listType: '<'
    },
    controller: function controller($scope, $element, LocalStorageService) {
      $scope.isCollapsed = $scope.listType === 'full';
      $scope.collapse = function () {
        $scope.isCollapsed = !$scope.isCollapsed;
        if ($scope.isCollapsed) {
          $element.addClass('collapsed');
        } else {
          $element.removeClass('collapsed');
        }
      };
      $scope.collapse();

      $scope.copyToClippboard = function (e) {
        e.stopPropagation();
        var text = e.target.closest('.widget-value').innerText;
        LocalStorageService.copyTextToClipboard(text);
      };
    },
    link: function link(scope, element, attrs) {

      if (!scope.openImage) {
        scope.openImage = function () {};
      }
      var widget = (0, _tableView.buildWidget)(scope.fact);
      element.append(widget);
      $compile(element.contents())(scope);
    }
  };
}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactTableRowComponent = FactTableRowComponent;

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(21);

var _incidentsModal = __webpack_require__(899);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FactTableRowComponent($compile) {
  return {
    restrict: 'A',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '=',
      listType: '=',
      select: '='
    },
    controller: function controller($scope, $element, $timeout, RouterService, AlertModalService, $modal, $http, FaceService) {
      $scope.router = RouterService;
      $scope.AlertModalService = AlertModalService;
      $scope.sep = _config.PATH_STRING_SEPARATOR;
      $scope.toUserNearestScreenshot = function () {
        $scope.router.needToShowFact = {
          needShowScreenshot: false,
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toUserNearestScreenshot();
        $scope.router.filterChanged();
      };

      $scope.addToIncidents = function () {
        // console.log($scope.fact);
        $scope.modalInstance = $modal.open({
          template: __webpack_require__(901),
          controller: _incidentsModal.IncidentsModalController,
          scope: $scope
        }).result.then(function () {
          // console.log(res);
        }, function (err) {
          $scope.AlertModalService.open(err.status + ' ' + (err.status ? err.statusText : ''), err.data);
        });
      };

      $scope.toNeighbourEvents = function () {
        $scope.router.needToShowFact = {
          fact: $scope.fact,
          date: $scope.fact.local_time
        };
        $scope.router.toNeighbourEvents();
        $scope.router.filterChanged();
      };

      $scope.findSimular = function () {
        $scope.router.findSimular($scope.fact.id);
      };

      $scope.printerExport = function () {
        window.open('/analytics/printer/export/' + $scope.fact.id, '_blank');
      };

      $scope.openFace = function (fact, index) {
        FaceService.openFace(fact, index);
      };
    },

    link: function link(scope, element, attrs) {
      if (!scope.fact) return '';
      var noAddMenu = scope.filter.toExcel && scope.filter.toExcel.convertToExel;
      scope.viewMode = scope.$parent.viewMode;
      var colQty = scope.viewMode.columns.length;
      var widget = scope.viewMode.columns.map(function (colView, c) {
        var table = element.parent();
        while (table && table[0].nodeName.toLowerCase() !== 'sc-facts-table') {
          table = table[0] === document.body ? null : table.parent();
        }
        if (!table) {
          return;
        }
        var thSelector = table.find('.fact-table th:visible');
        var th = thSelector[c];
        var setWidth = th ? getComputedStyle(th).width : 0;
        var lastCol = !scope.router.isFilterEditModal && c === colQty - 1;

        var findSimularElem = '';
        if (!noAddMenu && scope.fact.text_data && lastCol) {
          findSimularElem = '\n          <li >\n            <a ng-click="findSimular()"> ' + gettext('Найти похожие документы') + '</a>\n          </li>';
        }

        var event_type = scope.fact['agent_eventtype.id'];

        if (!noAddMenu && event_type == 11 && lastCol) {
          findSimularElem += '\n          <li >\n            <a ng-click="printerExport()" target="_new"> ' + gettext('Экспорт в PDF') + '</a>\n          </li>';
        }

        var lastMenuElem = '';
        if (!noAddMenu && lastCol) {
          lastMenuElem = '<span class="dropdown to-screenshot">\n          <i data-toggle="dropdown"\n            ng-if="true"\n            class="icon-wrench dropdown-toggle"\n          ></i>\n          <ul class="dropdown-menu pull-right" sc-ul>\n            <li >\n              <a ng-click="toUserNearestScreenshot()">' + gettext('К ближайшему снимку с экрана') + '</a>\n            </li>\n            <li >\n              <a ng-click="toNeighbourEvents()">' + gettext('События рядом') + '</a>\n            </li> ' + findSimularElem + '\n            <li >\n              <a ng-click="addToIncidents()">' + gettext('Добавить событие в инцидент') + '</a>\n            </li>\n          </ul>\n        </span>';
        }

        return '<td class="' + (colView['cssClass'] ? colView['cssClass'] : '') + ' rc-' + c + ' style="width:' + setWidth + '"> ' + colView.parse(scope.fact, 'short') + ' ' + lastMenuElem + '</td>';
      }).join('', '');
      element.append(widget);
      $compile(element.contents())(scope);
    }
  };
}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncidentsModalController = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _tableView = __webpack_require__(62);

__webpack_require__(900);
var incidentsUrl = '/incident/api/incidents_full/';

var IncidentsModalController = exports.IncidentsModalController = function IncidentsModalController($scope, PermissionService, $modalInstance, $timeout, $http) {
  $scope.incidents = [];
  $scope.selections = {};
  $scope.sort = {
    field: '',
    dir: ''
  };
  $scope.isLoading = true;
  var cols = [];

  $modalInstance.opened.then(function (res, res2) {
    $timeout(function () {
      var wMax = 1000;
      var w = document.body.clientWidth;
      if (w > wMax) {
        var el = document.querySelector('.add-to-incidents');
        el.style.left = 'calc(50% - ' + wMax / 2 + 'px)';
      }
    }, 100);
  });

  var token = function () {
    var tokenCookie = document.cookie.split('; ').find(function (c) {
      return c.startsWith('csrftoken=');
    });
    return tokenCookie && tokenCookie.split('=')[1];
  }();
  var cteatorId = PermissionService.userId;
  var postData = function postData(url, data) {
    return $http.post(url, data, {
      headers: token && {
        'X-CSRFToken': token,
        'Content-Type': 'application/json'
      } || {
        'Content-Type': 'application/json'
      }
    });
  };

  var addComment = function addComment(text, incidentId) {
    $scope.isLoading = true;
    $timeout(function () {
      $scope.$digest();
    }, 10);
    return postData('/incident/api/comment/', {
      date: new Date().toJSON(),
      text: text,
      creator: cteatorId,
      incident: incidentId
    });
  };
  var rebuild = function rebuild(html) {
    return html.replace('ng-src', 'src');
  };

  var incidentsPromice = function incidentsPromice() {
    var url = incidentsUrl;
    if ($scope.sort.field) url = url + '?ordering=' + $scope.sort.dir + $scope.sort.field;
    return $http.get(url);
  };

  var responsePatternsPromice = function responsePatternsPromice() {
    return $http.get('/incident/api/response_pattern/');
  };

  var incidentGroupsPromice = function incidentGroupsPromice() {
    return $http.get('/incident/api/incident_group/');
  };

  var getIncidents = function getIncidents() {
    incidentsPromice().then(function (res) {
      $scope.incidents = res.data;
      $scope.isLoading = false;
      if (!$scope.$root.$$phase) $scope.$digest();
    }, function () {
      $scope.isLoading = false;
      $modalInstance.dismiss(gettext('Ошибка  загрузки'));
    });
  };

  var incidentColsPromice = function incidentColsPromice() {
    var url = '/incident/api/incidents/';
    return $http({
      method: 'OPTIONS',
      url: url
    });
  };

  var incidentStatusesPromice = function incidentStatusesPromice() {
    return $http.get('/incident/api/status/');
  };

  Promise.all([incidentsPromice(), incidentColsPromice(), incidentStatusesPromice(), responsePatternsPromice(), incidentGroupsPromice()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 5),
        incidents = _ref2[0],
        incidentCols = _ref2[1],
        incidentStatuses = _ref2[2],
        responsePatterns = _ref2[3],
        incidentGroups = _ref2[4];

    if (incidents && incidents.data) $scope.incidents = incidents.data;
    if (incidentCols && incidentCols.data && incidentCols.data.actions && incidentCols.data.actions.POST) {
      var colsObj = incidentCols.data.actions.POST;
      cols = Object.keys(colsObj).map(function (k) {
        var col = {
          name: k,
          label: colsObj[k].label,
          type: colsObj[k].type
        };
        if (colsObj[k].choices) col.choices = colsObj[k].choices;
        return col;
      });

      if (incidentStatuses && incidentStatuses.data) {
        $scope.incidentStatus = incidentStatuses.data.find(function (s) {
          return s.name.toLowerCase() === 'new';
        });
        if (!$scope.incidentStatus) $scope.incidentStatus = incidentStatuses.data[0];
      }

      if (responsePatterns && responsePatterns.data) {
        $scope.responsePatterns = responsePatterns.data;
        if ($scope.responsePatterns[0]) $scope.selections.responsePattern = $scope.responsePatterns[0];
      }
      if (incidentGroups && incidentGroups.data) {
        $scope.incidentGroups = incidentGroups.data;
        if ($scope.incidentGroups[0]) $scope.selections.incidentGroup = $scope.incidentGroups[0];
      }
    }
    $scope.isLoading = false;
    if (!$scope.$root.$$phase) $scope.$digest();
  });

  $scope.shownColls = function () {
    return cols.filter(function (c) {
      return c.name !== 'description';
    });
  };

  $scope.addNew = function () {
    $scope.isLoading = true;
    var incident = {
      date: new Date().toJSON(),
      subject: gettext('На основании события') + (': ' + $scope.fact.id),
      description: gettext('Данный инцидент создан на основании события') + (': ' + $scope.fact.id),
      status: $scope.incidentStatus.id,
      creator: cteatorId,
      assignee: cteatorId,
      priority: 'minor',
      pattern: $scope.selections.responsePattern.id,
      group: $scope.selections.incidentGroup.id
    };
    postData('/incident/api/incidents/', incident).then(function (res) {
      if (res.data && res.data.id) {
        $scope.selectIncident(res.data.id, true);
      } else {
        console.error('incident is not created');
      }
    }, function (err) {
      $scope.isLoading = false;
      $modalInstance.dismiss(err);
    });
  };

  $scope.selectIncident = function (incidentId, isNew) {
    var factHtml = '';
    var bottomEl = document.getElementById('id_bottom_' + $scope.fact.id);
    if (bottomEl) factHtml = rebuild(bottomEl.outerHTML);else factHtml = rebuild((0, _tableView.getBottomComponentHtml)($scope.fact));

    addComment(factHtml, incidentId).then(function (res) {
      window.open('/incident/#incident/?id=' + incidentId + (isNew ? '&isEdit=true' : ''));
      $scope.isLoading = false;
      $scope.cancel();
    }, function (err) {
      $scope.isLoading = false;
      $modalInstance.dismiss(err);
    });
  };

  var dateFilter = function dateFilter(d) {
    return d.toString().replace('T', ' ').substring(0, 19);
  };

  $scope.sort = function (field) {
    $scope.isLoading = true;

    if ($scope.sort.field === field) {
      $scope.sort.dir = $scope.sort.dir ? '' : '-';
    } else {
      $scope.sort.field = field;
      $scope.sort.dir = '';
    }
    getIncidents();
  };

  $scope.colValue = function (col, incident) {
    if (col.type === 'datetime') return dateFilter(incident[col.name]);
    if (col.type === 'field' && incident[col.name].username) return getUserName(incident[col.name]);
    if (col.type === 'field') return incident[col.name].name;
    if (col.type === 'choice' && col.choices) {
      var val = col.choices.find(function (ch) {
        return ch.value === incident[col.name];
      }).display_name;
      return val ? val : incident[col.name];
    }
    return incident[col.name];
  };

  var getUserName = function getUserName(user) {
    return user.first_name || user.last_name ? user.first_name + ' ' + user.last_name : user.username;
  };

  $scope.cancel = function () {
    return $modalInstance.close('cancel');
  };
};

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports = "<div class=\"form-horizontal add-to-incidents\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{:: 'Добавить событие в инцидент' | gettext}}</h4></div><div class=\"add-to-incidents-body\"><div class=\"spinner-container\" ng-if=\"isLoading\"><sc-hspinner></sc-hspinner></div><div class=\"add-new\"><table><thead><tr><th></th><th>{{:: 'Шаблон реагирования' | gettext}}</th><th>{{:: 'Группа' | gettext}}</th></tr></thead><tbody><tr><td><button type=\"button\" class=\"addNew\" aria-hidden=\"true\" ng-click=\"addNew()\">{{:: 'Добавить событие в новый инцидент' | gettext}}</button></td><td><select ng-options=\"responsePattern.name for responsePattern in responsePatterns track by responsePattern.id\" ng-model=\"selections.responsePattern\"></select></td><td><select ng-options=\"incidentGroup.name for incidentGroup in incidentGroups track by incidentGroup.id\" ng-model=\"selections.incidentGroup\"></select></td></tr></tbody></table></div>{{:: 'Добавить событие в существующий инцидент' | gettext}}:<div class=\"incidents-table\"><table><thead><tr><th ng-repeat=\"col in shownColls()\" ng-click=\"sort(col.name)\"><span>{{ col.label }} <i class=\"pointer icon-sort-alt-down\" ng-if=\"sort.field === col.name\" ng-class=\"{'icon-sort-alt-down': sort.dir, ' icon-sort-alt-up': !sort.dir}\"></i></span></th></tr></thead><tbody><tr ng-repeat=\"incident in incidents\" ng-click=\"selectIncident(incident.id)\"><td ng-repeat=\"col in shownColls()\">{{ colValue(col, incident) }}</td></tr></tbody></table></div></div></div>"

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactBottomComponent = FactBottomComponent;

var _tableView = __webpack_require__(62);

var _decodeFact = __webpack_require__(336);

__webpack_require__(903);

function FactBottomComponent($compile) {
  return {
    restrict: 'AE',
    scope: {
      filter: '=',
      fact: '=',
      openImage: '='
    },
    controller: function controller($scope, $element, $sce, LocalStorageService, FaceService) {
      $scope.trustAsHtml = $sce.trustAsHtml;
      var setHeight = function setHeight() {
        $element.height($element.parent().height() - 10);
      };

      $scope.$on('dashboardResize', setHeight);
      $scope.$on('resize', setHeight);
      $scope.$on('splitter3Changed', function (e, d, d2, name) {
        setHeight();
      });

      var getTextElement = function getTextElement(e) {
        var widgetElement = e.target.closest('.widget-value');
        var textElement = widgetElement.querySelector('.fact-text');
        return textElement ? textElement : widgetElement;
      };

      $scope.decodeText = function (e, type) {
        var textElement = getTextElement(e);
        if (!textElement.innerTextOriginal) textElement.innerTextOriginal = textElement.innerText;
        var decoders1 = _decodeFact.decoders;
        var decoded = _decodeFact.decoders[type](textElement.innerTextOriginal);
        textElement.innerText = decoded;
        // console.log(decoded);
      };

      $scope.copyToClippboard = function (e) {
        var textElement = getTextElement(e);
        // const text = e.target.closest('.widget-value').innerText;
        LocalStorageService.copyTextToClipboard(textElement.innerText);
      };

      $scope.openFace = function (fact, index) {
        FaceService.openFace(fact, index);
      };
    },
    link: function link(scope, element, attrs) {
      scope.$watch('fact', function (newVal, oldVal) {
        if (!scope.filter) return;
        var fact = newVal ? newVal : {};
        var widget2 = (0, _tableView.getBottomComponentHtml)(fact);
        element.html(widget2);
        $compile(element.contents())(scope);
      });
    }
  };
}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactInfoComponent = FactInfoComponent;

var _tableView = __webpack_require__(62);

function FactInfoComponent($compile) {
  return {
    restrict: 'E',
    scope: {
      filter: '<',
      fact: '<',
      openImage: '<'
    },
    controller: function controller($scope, $element, $sce) {
      $scope.trustAsHtml = $sce.trustAsHtml;
    },
    link: function link(scope, element, attrs) {
      scope.$watch('fact', update);
      scope.$watch('filter', update);

      function update() {
        if (!scope.filter || !scope.fact) return;
        var newVal = scope.fact;
        var fact = newVal ? newVal : {};
        scope.textData = fact ? fact['text_data'] : '';
        scope.event_id = fact ? fact['id'] : 0;
        var viewMode = (0, _tableView.getTableViewByType)(fact['agent_eventtype.id']);
        var widget = viewMode.important.map(function (colView) {
          var data = colView.parse(fact, 'extended');
          var label = data && colView.label ? '<span class="label">' + colView.label + ':</span> ' : '';
          return label + data + (label + data ? '<br/>' : '');
        }).join('', '');
        element.html(widget);
        $compile(element.contents())(scope);
      }
    }
  };
}

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColumnResizeComponent = ColumnResizeComponent;
function ColumnResizeComponent(LayoutService) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var handleContainer = angular.element('<div class=\'rc-handle-container\' />');
      element.before(handleContainer);
      var drag = false;
      var colClass = function colClass(i) {
        return '.rc-' + i.toString();
      };
      var scrollbarWidth = 15;
      var colPadding = 11;
      if (!LayoutService.customFactColsWidth) LayoutService.customFactColsWidth = {};
      var tableContentWidth = 0;
      var thSelector = 'tr th:visible';
      var viewMode = null;
      var tableColumns = void 0;
      var initViewMode = function initViewMode() {
        if (!viewMode) {
          return;
        }

        var tableWidth = element.width();
        if (!element.width()) {
          tableWidth = parseInt(LayoutService.printWidth, 0);
          element.width(tableWidth);
        }
        // take stock of scrollbar and borders
        tableContentWidth = tableWidth - scrollbarWidth - viewMode.columns.length * colPadding;
        element.find('.fact-table-thead').width(tableWidth - scrollbarWidth - 2);
        initColumnWidths();
      };
      var initHandlers = function initHandlers() {
        tableColumns = element.find(thSelector);
        element.find('.rc-handle').remove();
        tableColumns.each(function (index) {
          if (index + 1 === tableColumns.length) {
            return;
          }
          var handle = angular.element('<div class=\'rc-handle\' />');
          handle.data('rc-id', index);
          handle.data('leftCol', this);
          handle.appendTo(handleContainer);
        });
      };
      var syncHandlers = function syncHandlers() {
        var height = element.height();
        handleContainer.find('.rc-handle').each(function () {
          var handler = angular.element(this);
          var column = angular.element(handler.data('leftCol'));
          var left = column.outerWidth() + (column && column.offset() && handleContainer && handleContainer.offset() ? column.offset().left - handleContainer.offset().left : 0);
          handler.css({
            left: left,
            height: height
          });
        });
      };
      var initColumnWidths = function initColumnWidths() {
        if (!viewMode) return;
        // Set column width
        var tableContentWidthRest = tableContentWidth;
        var colWidthSumm = viewMode.colwidths.reduce(function (s, w, i) {
          if (viewMode.columns[i].factKey in LayoutService.customFactColsWidth) {
            tableContentWidthRest -= LayoutService.customFactColsWidth[viewMode.columns[i].factKey];
            return s;
          }
          return s += w;
        }, 0.0);

        viewMode.colwidths.forEach(function (colwidth, i) {
          var width = void 0;
          if (viewMode.columns[i].factKey in LayoutService.customFactColsWidth) {
            width = LayoutService.customFactColsWidth[viewMode.columns[i].factKey];
          } else width = Math.floor(colwidth * tableContentWidthRest / colWidthSumm);
          element.find(colClass(i)).width(width);
        });
      };

      scope.$on('factsLoaded', function () {
        initViewMode();
        syncHandlers();
      });
      scope.$on('splitter1Changed', function (e, d, d2, name) {
        // if (name !== 'splitter1' && name !== 'filter-form-splitter') return; // не работает в QT
        initViewMode();
        syncHandlers();
      });

      scope.$on('resizeBeforePrint', function (e, d, d2, name) {
        initViewMode();
        syncHandlers();
      });

      scope.$on('viewModeChanged', function (e, vm) {
        if (vm.colwidths == undefined) {
          vm.colwidths = vm.columns.map(function (col) {
            return 1 / vm.columns.length;
          });
        } else {
          var prevW = vm.colwidths[vm.colwidths.length - 1];
          var w = 1 - vm.colwidths.reduce(function (p, c, i, a) {
            return i !== a.length - 1 ? p + c : p;
          }, 0);
          vm.colwidths[vm.colwidths.length - 1] = w < prevW ? prevW : w;
        }
        viewMode = vm;
        initViewMode();
        initHandlers();
        syncHandlers();
      });
      var startPosition = void 0;
      var currentGrip = void 0;
      var currentGripPosition = void 0;
      var leftColumn = void 0;
      var leftColumnWidth = void 0;
      var rightColProps = [];
      var leftGroupWidth = 0;
      var pointerdown = function pointerdown(e) {
        startPosition = e.pageX;
        e.preventDefault();
        drag = true;

        currentGrip = angular.element(e.currentTarget);
        currentGripPosition = currentGrip.position().left;

        var id = currentGrip.data('rc-id');

        leftColumn = element.find(colClass(id));
        leftColumnWidth = leftColumn.width();

        // Calculate left block width
        leftGroupWidth = 0;
        for (var i = 0; i <= id; i++) {
          var column = element.find(colClass(i));
          leftGroupWidth += column.width();
        }
        var rightGroupWidth = tableContentWidth - leftGroupWidth;
        for (var _i = id + 1; _i < viewMode.colwidths.length; _i++) {
          rightColProps[_i] = rightGroupWidth ? viewMode.colwidths[_i] / (rightGroupWidth / tableContentWidth) : 0;
        }
      };
      var pointerup = function pointerup(e) {
        if (!drag) {
          return;
        }
        e.preventDefault();
        drag = false;

        if (viewMode) {
          for (var i = 0; i < viewMode.colwidths.length; i++) {
            viewMode.colwidths[i] = element.find(colClass(i)).width() / tableContentWidth;
          }
        }
        rightColProps = [];
        syncHandlers();
      };
      var pointermove = function pointermove(e) {
        if (!drag) {
          return;
        }
        e.preventDefault();

        var delta = e.pageX - startPosition;

        if (leftColumnWidth + delta < 0) {
          delta = -leftColumnWidth;
        }
        if (tableContentWidth - (leftGroupWidth + delta) < 0) {
          delta = tableContentWidth - leftGroupWidth;
        }

        if (viewMode) {
          currentGrip.css({
            left: currentGripPosition + delta
          });
          var lWidth = Math.floor(leftColumnWidth + delta);
          leftColumn.width(lWidth);
          var id = currentGrip.data('rc-id');
          if (!viewMode.columns[id]) return;
          LayoutService.customFactColsWidth[viewMode.columns[id].factKey] = lWidth;
          viewMode.colwidths[id] = (leftColumnWidth + delta) / tableContentWidth;
          var rightColumnWidth = void 0;
          if (_isAllRightColumnsZero(id, rightColProps)) {
            rightColumnWidth = tableContentWidth - (leftGroupWidth + delta);
            element.find(colClass(id + 1)).width(rightColumnWidth);
          } else {
            for (var i = id + 1; i < viewMode.colwidths.length; i++) {
              rightColumnWidth = rightColProps[i] * (tableContentWidth - (leftGroupWidth + delta));
              if (rightColumnWidth < 0) {
                rightColumnWidth = 0;
              }
              element.find(colClass(i)).width(Math.floor(rightColumnWidth));
            }
          }
        }
        scope.$broadcast('col-resize');
      };

      var _isAllRightColumnsZero = function _isAllRightColumnsZero(id, rightColProps) {
        for (var i = id + 1; i < rightColProps.length; i++) {
          if (rightColProps[i] != 0) {
            return false;
          }
        }
        return true;
      };

      var __logProportionsSum = function __logProportionsSum() {
        var reduce = viewMode.colwidths.reduce(function (previousValue, currentValue, currentIndex, array) {
          return previousValue + currentValue;
        });
        return reduce;
      };

      var __logRealColumnWidths = function __logRealColumnWidths() {
        var logText = '';
        for (var i = 0; i < viewMode.colwidths.length; i++) {
          var w = element.find(colClass(i)).width();
          logText += 'w[' + i + ']=' + w + '  |  ';
        }
      };

      handleContainer.on('mousedown', '.rc-handle', pointerdown);

      document.addEventListener('mouseup', pointerup);
      document.addEventListener('mousemove', pointermove);
      scope.$on('$destroy', function () {
        document.removeEventListener('mouseup', pointerup);
        document.removeEventListener('mousemove', pointermove);
      });
    }
  };
}

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeatmapComponent = HeatmapComponent;

var _calHeatmap = __webpack_require__(907);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

__webpack_require__(908);

function HeatmapController($scope, $element, RouterService, LayoutService, $timeout, rx) {
  var _this = this;

  this.renderDebounce = 100;
  $scope.$element = $element;
  this.$timeout = $timeout;
  $scope.isResizeBeforePrint = false;
  $scope.router = RouterService;
  var noRender = false;
  var subscriptions = [rx.Observable.merge($scope.$eventToObservable('resizeBeforePrint'), $scope.$eventToObservable('beforePrint'), $scope.$eventToObservable('afterPrint')).subscribe(function (event) {
    if (event.name === 'beforePrint' && noRender) return false;
    if (event.name === 'resizeBeforePrint' || 'beforePrint' && !noRender) noRender = true;
    if (event.name === 'afterPrint') {
      _this.$timeout(function () {
        return noRender = false;
      }, 200);
      return false;
    }
    $scope.isResizeBeforePrint = event.name === 'resizeBeforePrint';
    if (!$scope.router.pdf) $scope.render(event.name);
  }), rx.Observable.merge($scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(this.renderDebounce) /*.debounce(100)*/
  .subscribe(function (event) {
    $scope.isResizeBeforePrint = false;
    if (!LayoutService.isPrint) $scope.render();
  })];

  $scope.stump = function (cell) {
    var activity = $scope.activity;
    if (!activity) return;
    var days = activity.filter.days;
    if (!cell) return new Date();
    return new Date(cell['agent_time.year'], cell['agent_time.month'] - 1, cell['agent_time.day'], cell['agent_time.hour'], days === 1 ? cell['agent_time.minute'] : 0);
  };
  $scope.parser = function (cells) {
    var stats = {};
    for (var i in cells) {
      var cell = cells[i];
      var at = cell['activity_time_sum'];
      var it = cell['idle_time_sum'];
      var rc = cell['record_count'];
      var st = String($scope.stump(cell).getTime() / 1000);
      stats[st] = rc;
    }
    return stats;
  };
  $scope.data = function () {
    return $scope.parser($scope.activity.cells);
  };
  $scope.getScales = function () {
    var max = Math.max.apply(Math, _toConsumableArray(Object.values($scope.data())));
    return Array.from(new Array(10), function (val, index) {
      return max >= 10 ? (index + 1) * Math.floor(max / 10) : index;
    });
  };
  $scope.initLegend = function () {
    var repLegendId = '#' + this.repLegendId;
    $(repLegendId).empty();
    var scale = $scope.getScales();
    $.each(scale, function (i, item) {
      var text = item;
      if (i == scale.length - 1) {
        text = '> ' + item;
      }
      $(repLegendId).append($('<div class="legend-item">' + text + '</div>'));
    });
  };
  $scope.render = function (evName) {
    var _this2 = this;

    // $scope.router.waitSeconds(2);
    // console.log('рендю! - ', evName);
    if ($scope.router.pdf) {
      if ($scope.router.CurrentFilterService.filter.isDashboard) $element.parent().width(722);else $element.parent().width(1090);
    }
    // $element.text('width=' + $element.parent().width());
    if (!$('#' + this.repId).length) $element.append($('<div id="' + this.repId + '"></div>'));
    if (!$('#' + this.repLegendId).length) $element.append($('<div id="' + this.repLegendId + '"></div>'));
    $element.find('svg').remove();
    var calendar = new _calHeatmap.CalHeatMap();
    var activity = $scope.activity;
    if (!activity) return;
    var days = activity.filter.days;
    $('#' + this.repId).empty();
    var data = $scope.data();
    var scale = $scope.getScales();
    var displayLegend = false;

    var isSelected = function isSelected(d) {
      if (!calendar.options.selectTimeFrom || !calendar.options.selectTimeTo) return false;
      var d1 = calendar.options.selectTimeFrom.getTime();
      var d2 = calendar.options.selectTimeTo.getTime();
      if (d1 < d2) return d >= d1 && d <= d2;
      return d >= d2 && d <= d1;
    };

    calendar.utsDate = function (d) {
      var date = new Date(d);
      return date;
      // return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
      //   date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    };

    calendar.selectRects = function () {
      var rects = $element[0].querySelectorAll('rect.graph-rect');
      rects.forEach(function (r) {
        if (r.__data__ && r.__data__.t && isSelected(r.__data__.t)) {
          r.classList.add('selected');
        } else {
          r.classList.remove('selected');
        }
      });
    };

    if (days === 1) {
      var startDate = activity.filter.timeFrom;
      //let startDate = stump( aggregate.cells[ 0 ] );
      //startDate = new Date( startDate.getTime() - 1000 * 60 * 60 * 24 );
      var cellSize = Math.round(($element.parent().width() - 50) / 61) - 1;
      if (cellSize < 2) return;
      $('.hours').hide();
      calendar.init({
        itemSelector: '#' + this.repId,
        scale: scale,
        legend: scale,
        data: data,
        start: startDate,
        range: 24,
        colLimit: 60,
        cellSize: cellSize,
        cellPadding: 1,
        tooltip: true,
        domain: 'hour',
        subDomain: 'min',
        browsing: true,
        verticalOrientation: true,
        displayLegend: displayLegend,
        selectTimeFrom: null,
        selectTimeTo: null,
        onMousedown: function onMousedown(now) {
          // console.log(now, calendar, $scope);
          calendar.options.selectTimeFrom = now;
        },
        onMouseup: function onMouseup(now, count) {
          $scope.$apply(function () {
            if (!calendar.options.selectTimeFrom || calendar.options.selectTimeFrom.getTime() === now.getTime()) {
              $scope.router.addTimeFilter(now, 5, true); // Add time filter with 4 levels
            } else {
              if (calendar.options.selectTimeFrom < calendar.options.selectTimeTo) {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeFrom.setSeconds(0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeTo.setSeconds(59, 999));
              } else {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeTo.setSeconds(0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeFrom.setSeconds(59, 999));
              }
            }
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown('agent_eventtype@default:agent_eventtype');
            $scope.$emit('reload');
          });
        }
      });
    } else {
      // let startDate = activity.filter.timeTo || (activity.cells && $scope.stump(activity.cells[0]));
      // if (typeof startDate === 'string' &&
      //   startDate.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}/)) {
      //   startDate = new Date(startDate);
      // }
      // if (!startDate) startDate = new Date();
      // startDate = new Date(startDate.getTime() - 1000 * 60 * 60 * 24 * (days - 1));

      var _startDate = activity.filter.timeFrom;
      if (typeof _startDate === 'string' && _startDate.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}/)) {
        _startDate = new Date(_startDate);
      }
      var _cellSize = Math.round(($element.parent().width() - 50) / 24);
      if (_cellSize < 10) return;
      $('.hours').show();
      $('.hours').find('span').width(_cellSize - 2);
      // Limit memory usage
      calendar.init({
        itemSelector: '#' + this.repId,
        scale: scale,
        legend: scale,
        data: data,
        start: _startDate,
        range: days, // Number of days to display
        cellSize: _cellSize - 4,
        cellPadding: 2,
        colLimit: 24,
        domainMargin: [0, 0, 0, 0],
        verticalOrientation: true,
        reverse: true,
        tooltip: true,
        domain: 'day',
        subDomain: 'hour',
        browsing: true,
        displayLegend: displayLegend,
        selectTimeFrom: null,
        selectTimeTo: null,
        onMousedown: function onMousedown(now) {
          // console.log(now, calendar, $scope);
          calendar.options.selectTimeFrom = now;
        },
        onMouseup: function onMouseup(now, count) {
          // console.log(calendar.options.selectTimeFrom);
          // console.log(now, count);
          // return;
          $scope.$apply(function () {
            if (!calendar.options.selectTimeFrom || calendar.options.selectTimeFrom.getTime() === now.getTime()) {
              $scope.router.addTimeFilter(now, 4, true); // Add time filter with 4 levels
            } else {

              if (calendar.options.selectTimeFrom < calendar.options.selectTimeTo) {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeFrom.setMinutes(0, 0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeTo.setMinutes(59, 59, 999));
              } else {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeTo.setMinutes(0, 0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeFrom.setMinutes(59, 59, 999));
              }
            }
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown('agent_eventtype@default:agent_eventtype');
          });
        }
      });
    }
    $scope.initLegend();
    $('.report-time').removeClass('ng-hide');

    if ($scope.isResizeBeforePrint) {
      this.$element.ready(function () {
        $timeout(function () {
          var updateElement = function updateElement(el) {
            var style = getComputedStyle(this);
            var color = void 0;
            if (style.fill !== 'rgb(0, 0, 0)') color = style.fill;else if (style.backgroundColor !== 'rgb(0, 0, 0)') color = style.backgroundColor;
            if (color) {
              this.style.fill = color;
              this.style.backgroundColor = color;
            }
          };
          _this2.$element.find('svg').each(updateElement);
          _this2.$element.find('text').each(updateElement);
          _this2.$element.find('g > rect').each(updateElement);
          $timeout(function () {
            _this2.$root.$broadcast('elementResized');
          }, 1000);
        }, 200);
      });
    }
  };

  $scope.$watch('activity', function () {
    $scope.render();
  });
}

function HeatmapComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(909),
    scope: {
      filter: '<',
      filterBar: '<',
      activity: '<',
      repId: '<',
      repLegendId: '<'
    },

    controller: HeatmapController
  };
}

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.CalHeatMap = CalHeatMap;

var _d = __webpack_require__(86);

var _d2 = _interopRequireDefault(_d);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CalHeatMap() {

  var self = this;

  this.allowedDataType = ['json', 'csv', 'tsv', 'txt'];

  // Default settings
  this.options = {
    // selector string of the container to append the graph to
    // Accept any string value accepted by document.querySelector or CSS3
    // or an Element object
    itemSelector: '#cal-heatmap',

    // Whether to paint the calendar on init()
    // Used by testsuite to reduce testing time
    paintOnLoad: true,

    reverse: false,

    // ================================================
    // DOMAIN
    // ================================================

    // Number of domain to display on the graph
    range: 12,

    // Size of each cell, in pixel
    cellSize: 10,

    // Padding between each cell, in pixel
    cellPadding: 2,

    // For rounded subdomain rectangles, in pixels
    cellRadius: 0,

    domainGutter: 2,

    domainMargin: [0, 0, 0, 0],

    domain: 'hour',

    subDomain: 'min',

    // Number of columns to split the subDomains to
    // If not null, will takes precedence over rowLimit
    colLimit: null,

    // Number of rows to split the subDomains to
    // Will be ignored if colLimit is not null
    rowLimit: null,

    // First day of the week is Monday
    // 0 to start the week on Sunday
    weekStartOnMonday: true,

    // Start date of the graph
    // @default now
    start: new Date(),

    minDate: null,

    maxDate: null,

    // URL, where to fetch the original datas
    data: '',

    dataType: this.allowedDataType[0],

    // Whether to consider missing date:value from the datasource
    // as equal to 0, or just leave them as missing
    considerMissingDataAsZero: false,

    // Load remote data on calendar creation
    // When false, the calendar will be left empty
    loadOnInit: true,

    // Calendar orientation
    // false: display domains side by side
    // true : display domains one under the other
    verticalOrientation: false,

    // Domain dynamic width/height
    // The width on a domain depends on the number of
    domainDynamicDimension: true,

    // Domain Label properties
    label: {
      // valid: top, right, bottom, left
      position: 'left',

      // Valid: left, center, right
      // Also valid are the direct svg values: start, middle, end
      align: 'center',

      // By default, there is no margin/padding around the label
      offset: {
        x: 0,
        y: 0
      },

      rotate: null,

      // Used only on vertical orientation
      width: 50,

      // Used only on horizontal orientation
      height: null
    },

    // ================================================
    // LEGEND
    // ================================================

    // Threshold for the legend
    legend: [0.0, 0.25, 0.5, 0.75, 1.0],

    // Whether to display the legend
    displayLegend: true,

    legendCellSize: 10,

    legendCellPadding: 2,

    legendMargin: [0, 0, 0, 0],

    // Legend vertical position
    // top: place legend above calendar
    // bottom: place legend below the calendar
    legendVerticalPosition: 'bottom',

    // Legend horizontal position
    // accepted values: left, center, right
    legendHorizontalPosition: 'left',

    // Legend rotation
    // accepted values: horizontal, vertical
    legendOrientation: 'horizontal',

    // Objects holding all the heatmap different colors
    // null to disable, and use the default css styles
    //
    // Examples:
    // legendColors: {
    //		min: 'green',
    //		max: 'red',
    //		empty: '#ffffff',
    //		base: 'grey',
    //		overflow: 'red'
    // }
    legendColors: null,

    // ================================================
    // HIGHLIGHT
    // ================================================

    // List of dates to highlight
    // Valid values:
    // - []: don't highlight anything
    // - 'now': highlight the current date
    // - an array of Date objects: highlight the specified dates
    highlight: [],

    // ================================================
    // TEXT FORMATTING / i18n
    // ================================================

    // Name of the items to represent in the calendar
    itemName: [gettext('событие'), gettext('cобытий')],

    // Formatting of the domain label
    // @default: null, will use the formatting according to domain type
    // Accept a string used as specifier by d3.time.format()
    // or a function
    //
    // Refer to https://github.com/mbostock/d3/wiki/Time-Formatting
    // for accepted date formatting used by d3.time.format()
    domainLabelFormat: null,

    // Formatting of the title displayed when hovering a subDomain cell
    subDomainTitleFormat: {
      empty: '{date}<br/>' + gettext('нет событий'),
      filled: '{date}<br/>{count} {name} '
    },

    // Formatting of the {date} used in subDomainTitleFormat
    // @default: null, will use the formatting according to subDomain type
    // Accept a string used as specifier by d3.time.format()
    // or a function
    //
    // Refer to https://github.com/mbostock/d3/wiki/Time-Formatting
    // for accepted date formatting used by d3.time.format()
    subDomainDateFormat: '%d %B %H:%M',

    // Formatting of the text inside each subDomain cell
    // @default: null, no text
    // Accept a string used as specifier by d3.time.format()
    // or a function
    //
    // Refer to https://github.com/mbostock/d3/wiki/Time-Formatting
    // for accepted date formatting used by d3.time.format()
    subDomainTextFormat: null,

    // Formatting of the title displayed when hovering a legend cell
    legendTitleFormat: {
      lower: 'less than {min} {name}',
      inner: 'between {down} and {up} {name}',
      upper: 'more than {max} {name}'
    },

    // Animation duration, in ms
    animationDuration: 500,

    nextSelector: false,

    previousSelector: false,

    itemNamespace: 'cal-heatmap',

    tooltip: false,

    // ================================================
    // EVENTS CALLBACK
    // ================================================

    // Callback when clicking on a time block
    onMouseup: null,
    onMousedown: null,
    // Callback after painting the empty calendar
    // Can be used to trigger an API call, once the calendar is ready to be filled
    afterLoad: null,

    // Callback after loading the next domain in the calendar
    afterLoadNextDomain: null,

    // Callback after loading the previous domain in the calendar
    afterLoadPreviousDomain: null,

    // Callback after finishing all actions on the calendar
    onComplete: null,

    // Callback after fetching the datas, but before applying them to the calendar
    // Used mainly to convert the datas if they're not formatted like expected
    // Takes the fetched 'data' object as argument, must return a json object
    // formatted like {timestamp:count, timestamp2:count2},
    afterLoadData: function afterLoadData(data) {
      return data;
    },

    // Callback triggered after calling next().
    // The `status` argument is equal to true if there is no
    // more next domain to load
    //
    // This callback is also executed once, after calling previous(),
    // only when the max domain is reached
    onMaxDomainReached: null,

    // Callback triggered after calling previous().
    // The `status` argument is equal to true if there is no
    // more previous domain to load
    //
    // This callback is also executed once, after calling next(),
    // only when the min domain is reached
    onMinDomainReached: null
  };

  this._domainType = {
    'min': {
      name: 'minute',
      level: 10,
      maxItemNumber: 60,
      defaultRowNumber: 10,
      defaultColumnNumber: 6,
      row: function row(d) {
        return self.getSubDomainRowNumber(d);
      },
      column: function column(d) {
        return self.getSubDomainColumnNumber(d);
      },
      position: {
        x: function x(d) {
          return Math.floor(d.getMinutes() / self._domainType.min.row(d));
        },
        y: function y(d) {
          return d.getMinutes() % self._domainType.min.row(d);
        }
      },
      format: {
        date: '%H:%M, %A %B %-e, %Y',
        legend: '',
        connector: 'at'
      },
      extractUnit: function extractUnit(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes()).getTime();
      }
    },
    'hour': {
      name: 'hour',
      level: 20,
      maxItemNumber: function maxItemNumber(d) {
        switch (self.options.domain) {
          case 'day':
            return 24;
          case 'week':
            return 24 * 7;
          case 'month':
            return 24 * (self.options.domainDynamicDimension ? self.getDayCountInMonth(d) : 31);
        }
      },
      defaultRowNumber: 6,
      defaultColumnNumber: function defaultColumnNumber(d) {
        switch (self.options.domain) {
          case 'day':
            return 4;
          case 'week':
            return 28;
          case 'month':
            return self.options.domainDynamicDimension ? self.getDayCountInMonth(d) : 31;
        }
      },
      row: function row(d) {
        return self.getSubDomainRowNumber(d);
      },
      column: function column(d) {
        return self.getSubDomainColumnNumber(d);
      },
      position: {
        x: function x(d) {
          if (self.options.domain === 'month') {
            if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
              return Math.floor((d.getHours() + (d.getDate() - 1) * 24) / self._domainType.hour.row(d));
            }
            return Math.floor(d.getHours() / self._domainType.hour.row(d)) + (d.getDate() - 1) * 4;
          } else if (self.options.domain === 'week') {
            if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
              return Math.floor((d.getHours() + self.getWeekDay(d) * 24) / self._domainType.hour.row(d));
            }
            return Math.floor(d.getHours() / self._domainType.hour.row(d)) + self.getWeekDay(d) * 4;
          }
          return Math.floor(d.getHours() / self._domainType.hour.row(d));
        },
        y: function y(d) {
          var p = d.getHours();
          if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
            switch (self.options.domain) {
              case 'month':
                p += (d.getDate() - 1) * 24;
                break;
              case 'week':
                p += self.getWeekDay(d) * 24;
                break;
            }
          }
          return Math.floor(p % self._domainType.hour.row(d));
        }
      },
      format: {
        date: '%Hh, %A %B %-e, %Y',
        legend: '%H:00',
        connector: 'at'
      },
      extractUnit: function extractUnit(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours()).getTime();
      }
    },
    'day': {
      name: 'day',
      level: 30,
      maxItemNumber: function maxItemNumber(d) {
        switch (self.options.domain) {
          case 'week':
            return 7;
          case 'month':
            return self.options.domainDynamicDimension ? self.getDayCountInMonth(d) : 31;
          case 'year':
            return self.options.domainDynamicDimension ? self.getDayCountInYear(d) : 366;
        }
      },
      defaultColumnNumber: function defaultColumnNumber(d) {
        d = new Date(d);
        switch (self.options.domain) {
          case 'week':
            return 1;
          case 'month':
            return self.options.domainDynamicDimension && !self.options.verticalOrientation ? self.getWeekNumber(new Date(d.getFullYear(), d.getMonth() + 1, 0)) - self.getWeekNumber(d) + 1 : 6;
          case 'year':
            return self.options.domainDynamicDimension ? self.getWeekNumber(new Date(d.getFullYear(), 11, 31)) - self.getWeekNumber(new Date(d.getFullYear(), 0)) + 1 : 54;
        }
      },
      defaultRowNumber: 7,
      row: function row(d) {
        return self.getSubDomainRowNumber(d);
      },
      column: function column(d) {
        return self.getSubDomainColumnNumber(d);
      },
      position: {
        x: function x(d) {
          switch (self.options.domain) {
            case 'week':
              return Math.floor(self.getWeekDay(d) / self._domainType.day.row(d));
            case 'month':
              if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
                return Math.floor((d.getDate() - 1) / self._domainType.day.row(d));
              }
              return self.getWeekNumber(d) - self.getWeekNumber(new Date(d.getFullYear(), d.getMonth()));
            case 'year':
              if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
                return Math.floor((self.getDayOfYear(d) - 1) / self._domainType.day.row(d));
              }
              return self.getWeekNumber(d);
          }
        },
        y: function y(d) {
          var p = self.getWeekDay(d);
          if (self.options.colLimit > 0 || self.options.rowLimit > 0) {
            switch (self.options.domain) {
              case 'year':
                p = self.getDayOfYear(d) - 1;
                break;
              case 'week':
                p = self.getWeekDay(d);
                break;
              case 'month':
                p = d.getDate() - 1;
                break;
            }
          }
          return Math.floor(p % self._domainType.day.row(d));
        }
      },
      format: {
        date: '%A %B %-e, %Y',
        legend: '%e %b',
        connector: 'on'
      },
      extractUnit: function extractUnit(d) {
        return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
      }
    },
    'week': {
      name: 'week',
      level: 40,
      maxItemNumber: 54,
      defaultColumnNumber: function defaultColumnNumber(d) {
        d = new Date(d);
        switch (self.options.domain) {
          case 'year':
            return self._domainType.week.maxItemNumber;
          case 'month':
            return self.getWeekNumber(new Date(d.getFullYear(), d.getMonth() + 1, 0)) - self.getWeekNumber(d);
        }
      },
      defaultRowNumber: 1,
      row: function row(d) {
        return self.getSubDomainRowNumber(d);
      },
      column: function column(d) {
        return self.getSubDomainColumnNumber(d);
      },
      position: {
        x: function x(d) {
          switch (self.options.domain) {
            case 'year':
              return Math.floor(self.getWeekNumber(d) / self._domainType.week.row(d));
            case 'month':
              return Math.floor(self.getMonthWeekNumber(d) / self._domainType.week.row(d));
          }
        },
        y: function y(d) {
          return self.getWeekNumber(d) % self._domainType.week.row(d);
        }
      },
      format: {
        date: '%B Week #%W',
        legend: '%B Week #%W',
        connector: 'on'
      },
      extractUnit: function extractUnit(d) {
        var dt = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        // According to ISO-8601, week number computation are based on week starting on Monday
        var weekDay = dt.getDay() - 1;
        if (weekDay < 0) {
          weekDay = 6;
        }
        dt.setDate(dt.getDate() - weekDay);
        return dt.getTime();
      }
    },
    'month': {
      name: 'month',
      level: 50,
      maxItemNumber: 12,
      defaultColumnNumber: 12,
      defaultRowNumber: 1,
      row: function row() {
        return self.getSubDomainRowNumber();
      },
      column: function column() {
        return self.getSubDomainColumnNumber();
      },
      position: {
        x: function x(d) {
          return Math.floor(d.getMonth() / self._domainType.month.row(d));
        },
        y: function y(d) {
          return d.getMonth() % self._domainType.month.row(d);
        }
      },
      format: {
        date: '%B %Y',
        legend: '%B',
        connector: 'on'
      },
      extractUnit: function extractUnit(d) {
        return new Date(d.getFullYear(), d.getMonth()).getTime();
      }
    },
    'year': {
      name: 'year',
      level: 60,
      row: function row() {
        return self.options.rowLimit || 1;
      },
      column: function column() {
        return self.options.colLimit || 1;
      },
      position: {
        x: function x() {
          return 1;
        },
        y: function y() {
          return 1;
        }
      },
      format: {
        date: '%Y',
        legend: '%Y',
        connector: 'on'
      },
      extractUnit: function extractUnit(d) {
        return new Date(d.getFullYear()).getTime();
      }
    }
  };

  for (var type in this._domainType) {
    if (this._domainType.hasOwnProperty(type)) {
      var d = this._domainType[type];
      this._domainType['x_' + type] = {
        name: 'x_' + type,
        level: d.type,
        maxItemNumber: d.maxItemNumber,
        defaultRowNumber: d.defaultRowNumber,
        defaultColumnNumber: d.defaultColumnNumber,
        row: d.column,
        column: d.row,
        position: {
          x: d.position.y,
          y: d.position.x
        },
        format: d.format,
        extractUnit: d.extractUnit
      };
    }
  }

  // Record the address of the last inserted domain when browsing
  this.lastInsertedSvg = null;

  this._completed = false;

  // Record all the valid domains
  // Each domain value is a timestamp in milliseconds
  this._domains = _d2.default.map();

  this.graphDim = {
    width: 0,
    height: 0
  };

  this.legendDim = {
    width: 0,
    height: 0
  };

  this.NAVIGATE_LEFT = 1;
  this.NAVIGATE_RIGHT = 2;

  // Various update mode when using the update() API
  this.RESET_ALL_ON_UPDATE = 0;
  this.RESET_SINGLE_ON_UPDATE = 1;
  this.APPEND_ON_UPDATE = 2;

  this.DEFAULT_LEGEND_MARGIN = 10;

  this.root = null;
  this.tooltip = null;

  this._maxDomainReached = false;
  this._minDomainReached = false;

  this.domainPosition = new DomainPosition();
  this.Legend = null;
  this.legendScale = null;

  // List of domains that are skipped because of DST
  // All times belonging to these domains should be re-assigned to the previous domain
  this.DSTDomain = [];

  /**
   * Display the graph for the first time
   * @return bool True if the calendar is created
   */

  this._init = function () {

    self.getDomain(self.options.start).map(function (d) {
      return d.getTime();
    }).map(function (d) {
      self._domains.set(d, self.getSubDomain(d).map(function (d) {
        return {
          t: self._domainType[self.options.subDomain].extractUnit(d),
          v: null
        };
      }));
    });

    self.root = _d2.default.select(self.options.itemSelector).append('svg').attr('class', 'cal-heatmap-container');

    self.tooltip = _d2.default.select(self.options.itemSelector).attr('style', function () {
      var current = _d2.default.select(self.options.itemSelector).attr('style');
      return (current !== null ? current : '') + 'position:relative;';
    }).append('div').attr('class', 'ch-tooltip');

    self.root.attr('x', 0).attr('y', 0).append('svg').attr('class', 'graph');

    self.Legend = new Legend(self);

    if (self.options.paintOnLoad) {
      _initCalendar();
    }
    return true;
  };

  function _initCalendar() {
    self.verticalDomainLabel = self.options.label.position === 'top' || self.options.label.position === 'bottom';

    self.domainVerticalLabelHeight = self.options.label.height === null ? Math.max(25, self.options.cellSize * 2) : self.options.label.height;
    self.domainHorizontalLabelWidth = 0;

    if (self.options.domainLabelFormat === '' && self.options.label.height === null) {
      self.domainVerticalLabelHeight = 0;
    }

    if (!self.verticalDomainLabel) {
      self.domainVerticalLabelHeight = 0;
      self.domainHorizontalLabelWidth = self.options.label.width;
    }

    self.paint();

    // =========================================================================//
    // ATTACHING DOMAIN NAVIGATION EVENT										//
    // =========================================================================//
    if (self.options.nextSelector !== false) {
      _d2.default.select(self.options.nextSelector).on('click.' + self.options.itemNamespace, function () {
        _d2.default.event.preventDefault();
        return self.loadNextDomain(1);
      });
    }

    if (self.options.previousSelector !== false) {
      _d2.default.select(self.options.previousSelector).on('click.' + self.options.itemNamespace, function () {
        _d2.default.event.preventDefault();
        return self.loadPreviousDomain(1);
      });
    }

    self.Legend.redraw(self.graphDim.width - self.options.domainGutter - self.options.cellPadding);
    self.afterLoad();

    var domains = self.getDomainKeys();

    // Fill the graph with some datas
    if (self.options.loadOnInit) {
      self.getDatas(self.options.data, new Date(domains[0]), self.getSubDomain(domains[domains.length - 1]).pop(), function () {
        self.fill();
        self.onComplete();
      });
    } else {
      self.onComplete();
    }

    self.checkIfMinDomainIsReached(domains[0]);
    var getNextDomain = self.getNextDomain();
    // if (!getNextDomain) console.error('getNextDomain is empty');
    self.checkIfMaxDomainIsReached(getNextDomain ? getNextDomain.getTime() : new Date('1900-01-01').getTime());
  }

  // Return the width of the domain block, without the domain gutter
  // @param int d Domain start timestamp
  function w(d, outer) {
    var width = self.options.cellSize * self._domainType[self.options.subDomain].column(d) + self.options.cellPadding * self._domainType[self.options.subDomain].column(d);
    if (arguments.length === 2 && outer === true) {
      return width += self.domainHorizontalLabelWidth + self.options.domainGutter + self.options.domainMargin[1] + self.options.domainMargin[3];
    }
    return width;
  }

  // Return the height of the domain block, without the domain gutter
  function h(d, outer) {
    var height = self.options.cellSize * self._domainType[self.options.subDomain].row(d) + self.options.cellPadding * self._domainType[self.options.subDomain].row(d);
    if (arguments.length === 2 && outer === true) {
      height += self.options.domainGutter + self.domainVerticalLabelHeight + self.options.domainMargin[0] + self.options.domainMargin[2];
    }
    return height;
  }

  /**
   *
   *
   * @param int navigationDir
   */

  this.paint = function (navigationDir) {

    var options = self.options;

    if (arguments.length === 0) {
      navigationDir = false;
    }

    // Painting all the domains
    var domainSvg = self.root.select('.graph').selectAll('.graph-domain').data(function () {
      var data = self.getDomainKeys();
      return options.reverse ? data.reverse() : data;
    }, function (d) {
      return d;
    });

    var enteringDomainDim = 0;
    var exitingDomainDim = 0;

    // =========================================================================//
    // PAINTING DOMAIN															//
    // =========================================================================//

    var svg = domainSvg.enter().append('svg').attr('width', function (d) {
      return w(d, true);
    }).attr('height', function (d) {
      return h(d, true);
    }).attr('x', function (d) {
      if (options.verticalOrientation) {
        self.graphDim.width = Math.max(self.graphDim.width, w(d, true));
        return 0;
      } else {
        return getDomainPosition(d, self.graphDim, 'width', w(d, true));
      }
    }).attr('y', function (d) {
      if (options.verticalOrientation) {
        return getDomainPosition(d, self.graphDim, 'height', h(d, true));
      } else {
        self.graphDim.height = Math.max(self.graphDim.height, h(d, true));
        return 0;
      }
    }).attr('class', function (d) {
      var classname = 'graph-domain';
      var date = new Date(d);
      switch (options.domain) {
        case 'hour':
          classname += ' h_' + date.getHours();
        // /* falls through */
        case 'day':
          classname += ' d_' + date.getDate() + ' dy_' + date.getDay();
        // /* falls through */
        case 'week':
          classname += ' w_' + self.getWeekNumber(date);
        // /* falls through */
        case 'month':
          classname += ' m_' + (date.getMonth() + 1);
        // /* falls through */
        case 'year':
          classname += ' y_' + date.getFullYear();
      }
      return classname;
    });

    self.lastInsertedSvg = svg;

    function getDomainPosition(domainIndex, graphDim, axis, domainDim) {
      var tmp = 0;
      switch (navigationDir) {
        case false:
          tmp = graphDim[axis];

          graphDim[axis] += domainDim;
          self.domainPosition.setPosition(domainIndex, tmp);
          return tmp;

        case self.NAVIGATE_RIGHT:
          self.domainPosition.setPosition(domainIndex, graphDim[axis]);

          enteringDomainDim = domainDim;
          exitingDomainDim = self.domainPosition.getPositionFromIndex(1);

          self.domainPosition.shiftRightBy(exitingDomainDim);
          return graphDim[axis];

        case self.NAVIGATE_LEFT:
          tmp = -domainDim;

          enteringDomainDim = -tmp;
          exitingDomainDim = graphDim[axis] - self.domainPosition.getLast();

          self.domainPosition.setPosition(domainIndex, tmp);
          self.domainPosition.shiftLeftBy(enteringDomainDim);
          return tmp;
      }
    }

    svg.append('rect').attr('width', function (d) {
      return w(d, true) - options.domainGutter - options.cellPadding;
    }).attr('height', function (d) {
      return h(d, true) - options.domainGutter - options.cellPadding;
    }).attr('class', 'domain-background');

    // =========================================================================//
    // PAINTING SUBDOMAINS														//
    // =========================================================================//
    var subDomainSvgGroup = svg.append('svg').attr('x', function () {
      if (options.label.position === 'left') {
        return self.domainHorizontalLabelWidth + options.domainMargin[3];
      } else {
        return options.domainMargin[3];
      }
    }).attr('y', function () {
      if (options.label.position === 'top') {
        return self.domainVerticalLabelHeight + options.domainMargin[0];
      } else {
        return options.domainMargin[0];
      }
    }).attr('class', 'graph-subdomain-group');

    var rect = subDomainSvgGroup.selectAll('g').data(function (d) {
      return self._domains.get(d);
    }).enter().append('g');

    rect.append('rect').attr('class', function (d) {
      return 'graph-rect' + self.getHighlightClassName(d.t) + (options.onMouseup !== null || options.onMousedown !== null ? ' hover_cursor' : '');
    }).attr('width', options.cellSize).attr('height', options.cellSize).attr('x', function (d) {
      return self.positionSubDomainX(d.t);
    }).attr('y', function (d) {
      return self.positionSubDomainY(d.t);
    }).on('mouseup', function (d) {
      if (options.onMouseup !== null) {
        return self.onMouseup(new Date(d.t), d.v);
      }
    }).on('mousedown', function (d) {
      // if (options.onMousedown !== null) {
      //   return self.onMousedown(new Date(d.t), d.v);
      // }
      self.options.selectTimeFrom = new Date(d.t);
      self.options.selectTimeTo = new Date(d.t);
    }).call(function (selection) {
      if (options.cellRadius > 0) {
        selection.attr('rx', options.cellRadius).attr('ry', options.cellRadius);
      }

      if (self.legendScale !== null && options.legendColors !== null && options.legendColors.hasOwnProperty('base')) {
        selection.attr('fill', options.legendColors.base);
      }

      if (options.tooltip) {
        selection.on('mouseover', function (d) {
          var domainNode = this.parentNode.parentNode.parentNode;
          if (window.isMouseDown && self.options.selectTimeFrom) {
            self.options.selectTimeTo = new Date(d.t);
            self.selectRects();
          } else if (self.options.selectTimeFrom) {
            self.options.selectTimeFrom = null;
            self.options.selectTimeTo = null;
            self.selectRects();
          }

          self.tooltip.html(self.getSubDomainTitle(d)).attr('style', 'display: block;');

          self.tooltip.attr('style', 'display: block; ' + 'left: ' + (self.positionSubDomainX(d.t) + 50 - self.tooltip[0][0].offsetWidth / 2 + options.cellSize / 2 + parseInt(domainNode.getAttribute('x'), 10)) + 'px; ' + 'top: ' + (self.positionSubDomainY(d.t) - self.tooltip[0][0].offsetHeight - options.cellSize / 2 + parseInt(domainNode.getAttribute('y'), 10) + 96 + options.cellSize) + 'px;');
        });

        selection.on('mouseout', function () {
          self.tooltip.attr('style', 'display:none').html('');
        });
      }
    });

    // Appending a title to each subdomain
    if (!options.tooltip) {
      rect.append('title').text(function (d) {
        return self.formatDate(new Date(d.t), options.subDomainDateFormat);
      });
    }

    // =========================================================================//
    // PAINTING LABEL															//
    // =========================================================================//
    if (options.domainLabelFormat !== '') {
      svg.append('text').attr('class', 'graph-label').attr('y', function (d) {
        var y = options.domainMargin[0] - 5;
        switch (options.label.position) {
          case 'top':
            y += self.domainVerticalLabelHeight / 2;
            break;
          case 'bottom':
            y += h(d) + self.domainVerticalLabelHeight / 2;
        }

        return y + options.label.offset.y * (options.label.rotate === 'right' && options.label.position === 'right' || options.label.rotate === 'left' && options.label.position === 'left' ? -1 : 1);
      }).attr('x', function (d) {
        var x = options.domainMargin[3];
        switch (options.label.position) {
          case 'right':
            x += w(d);
            break;
          case 'bottom':
          case 'top':
            x += w(d) / 2;
        }

        if (options.label.align === 'right') {
          return x + self.domainHorizontalLabelWidth - options.label.offset.x * (options.label.rotate === 'right' ? -1 : 1);
        }
        return x + options.label.offset.x;
      }).attr('text-anchor', function () {
        switch (options.label.align) {
          case 'start':
          case 'left':
            return 'start';
          case 'end':
          case 'right':
            return 'end';
          default:
            return 'middle';
        }
      }).attr('dominant-baseline', function () {
        return self.verticalDomainLabel ? 'middle' : 'top';
      }).text(function (d) {
        return self.formatDate(new Date(d), options.domainLabelFormat);
      }).call(domainRotate);
    }

    function domainRotate(selection) {
      switch (options.label.rotate) {
        case 'right':
          selection.attr('transform', function (d) {
            var s = 'rotate(90), ';
            switch (options.label.position) {
              case 'right':
                s += 'translate(-' + w(d) + ' , -' + w(d) + ')';
                break;
              case 'left':
                s += 'translate(0, -' + self.domainHorizontalLabelWidth + ')';
                break;
            }

            return s;
          });
          break;
        case 'left':
          selection.attr('transform', function (d) {
            var s = 'rotate(270), ';
            switch (options.label.position) {
              case 'right':
                s += 'translate(-' + (w(d) + self.domainHorizontalLabelWidth) + ' , ' + w(d) + ')';
                break;
              case 'left':
                s += 'translate(-' + self.domainHorizontalLabelWidth + ' , ' + self.domainHorizontalLabelWidth + ')';
                break;
            }

            return s;
          });
          break;
      }
    }

    // =========================================================================//
    // PAINTING DOMAIN SUBDOMAIN CONTENT										//
    // =========================================================================//
    if (options.subDomainTextFormat !== null) {
      rect.append('text').attr('class', function (d) {
        return 'subdomain-text' + self.getHighlightClassName(d.t);
      }).attr('x', function (d) {
        return self.positionSubDomainX(d.t) + options.cellSize / 2;
      }).attr('y', function (d) {
        return self.positionSubDomainY(d.t) + options.cellSize / 2;
      }).attr('text-anchor', 'middle').attr('dominant-baseline', 'central').text(function (d) {
        return self.formatDate(new Date(d.t), options.subDomainTextFormat);
      });
    }

    // =========================================================================//
    // ANIMATION																//
    // =========================================================================//

    if (navigationDir !== false) {
      domainSvg.transition().duration(options.animationDuration).attr('x', function (d) {
        return options.verticalOrientation ? 0 : self.domainPosition.getPosition(d);
      }).attr('y', function (d) {
        return options.verticalOrientation ? self.domainPosition.getPosition(d) : 0;
      });
    }

    var tempWidth = self.graphDim.width;
    var tempHeight = self.graphDim.height;

    if (options.verticalOrientation) {
      self.graphDim.height += enteringDomainDim - exitingDomainDim;
    } else {
      self.graphDim.width += enteringDomainDim - exitingDomainDim;
    }

    // At the time of exit, domainsWidth and domainsHeight already automatically shifted
    domainSvg.exit().transition().duration(options.animationDuration).attr('x', function (d) {
      if (options.verticalOrientation) {
        return 0;
      } else {
        switch (navigationDir) {
          case self.NAVIGATE_LEFT:
            return Math.min(self.graphDim.width, tempWidth);
          case self.NAVIGATE_RIGHT:
            return -w(d, true);
        }
      }
    }).attr('y', function (d) {
      if (options.verticalOrientation) {
        switch (navigationDir) {
          case self.NAVIGATE_LEFT:
            return Math.min(self.graphDim.height, tempHeight);
          case self.NAVIGATE_RIGHT:
            return -h(d, true);
        }
      } else {
        return 0;
      }
    }).remove();

    // Resize the root container
    self.resize();
  };
}

CalHeatMap.prototype = {

  /**
   * Validate and merge user settings with default settings
   *
   * @param  {object} settings User settings
   * @return {bool} False if settings contains error
   */
  /* jshint maxstatements:false */
  init: function init(settings) {
    'use strict';

    var parent = this;

    parent.options = mergeRecursive(parent.options, settings);
    var options = parent.options;

    // Fatal errors
    // Stop script execution on error
    validateDomainType();
    validateSelector(options.itemSelector, false, 'itemSelector');

    if (parent.allowedDataType.indexOf(options.dataType) === -1) {
      throw new Error('The data type "' + options.dataType + '" is not valid data type');
    }

    if (_d2.default.select(options.itemSelector)[0][0] === null) {
      throw new Error('The node "' + options.itemSelector + '" specified in itemSelector does not exists');
    }

    try {
      validateSelector(options.nextSelector, true, 'nextSelector');
      validateSelector(options.previousSelector, true, 'previousSelector');
    } catch (error) {
      console.error(error.message);
      return false;
    }

    // If other settings contains error, will fallback to default

    if (!settings.hasOwnProperty('subDomain')) {
      this.options.subDomain = getOptimalSubDomain(settings.domain);
    }

    if (typeof options.itemNamespace !== 'string' || options.itemNamespace === '') {
      console.error('itemNamespace can not be empty, falling back to cal-heatmap');
      options.itemNamespace = 'cal-heatmap';
    }

    // Don't touch these settings
    var s = ['data', 'onComplete', 'onMouseup', 'afterLoad', 'afterLoadData', 'afterLoadPreviousDomain', 'afterLoadNextDomain'];

    for (var k in s) {
      if (settings.hasOwnProperty(s[k])) {
        options[s[k]] = settings[s[k]];
      }
    }

    options.subDomainDateFormat = typeof options.subDomainDateFormat === 'string' || typeof options.subDomainDateFormat === 'function' ? options.subDomainDateFormat : this._domainType[options.subDomain].format.date;
    options.domainLabelFormat = typeof options.domainLabelFormat === 'string' || typeof options.domainLabelFormat === 'function' ? options.domainLabelFormat : this._domainType[options.domain].format.legend;
    options.subDomainTextFormat = typeof options.subDomainTextFormat === 'string' && options.subDomainTextFormat !== '' || typeof options.subDomainTextFormat === 'function' ? options.subDomainTextFormat : null;
    options.domainMargin = expandMarginSetting(options.domainMargin);
    options.legendMargin = expandMarginSetting(options.legendMargin);
    options.highlight = parent.expandDateSetting(options.highlight);
    options.itemName = expandItemName(options.itemName);
    options.colLimit = parseColLimit(options.colLimit);
    options.rowLimit = parseRowLimit(options.rowLimit);
    if (!settings.hasOwnProperty('legendMargin')) {
      autoAddLegendMargin();
    }
    autoAlignLabel();

    /**
     * Validate that a queryString is valid
     *
     * @param  {Element|string|bool} selector   The queryString to test
     * @param  {bool}  canBeFalse  Whether false is an accepted and valid value
     * @param  {string} name    Name of the tested selector
     * @throws {Error}        If the selector is not valid
     * @return {bool}        True if the selector is a valid queryString
     */
    function validateSelector(selector, canBeFalse, name) {
      if ((canBeFalse && selector === false || selector instanceof Element || typeof selector === 'string') && selector !== '') {
        return true;
      }
      throw new Error('The ' + name + ' is not valid');
    }

    /**
     * Return the optimal subDomain for the specified domain
     *
     * @param  {string} domain a domain name
     * @return {string}        the subDomain name
     */
    function getOptimalSubDomain(domain) {
      switch (domain) {
        case 'year':
          return 'month';
        case 'month':
          return 'day';
        case 'week':
          return 'day';
        case 'day':
          return 'hour';
        default:
          return 'min';
      }
    }

    /**
     * Ensure that the domain and subdomain are valid
     *
     * @throw {Error} when domain or subdomain are not valid
     * @return {bool} True if domain and subdomain are valid and compatible
     */
    function validateDomainType() {
      if (!parent._domainType.hasOwnProperty(options.domain) || options.domain === 'min' || options.domain.substring(0, 2) === 'x_') {
        throw new Error('The domain "' + options.domain + '" is not valid');
      }

      if (!parent._domainType.hasOwnProperty(options.subDomain) || options.subDomain === 'year') {
        throw new Error('The subDomain "' + options.subDomain + '" is not valid');
      }

      if (parent._domainType[options.domain].level <= parent._domainType[options.subDomain].level) {
        throw new Error('""' + options.subDomain + '" is not a valid subDomain to "' + options.domain + '"');
      }

      return true;
    }

    /**
     * Fine-tune the label alignement depending on its position
     *
     * @return void
     */

    function autoAlignLabel() {
      // Auto-align label, depending on it's position
      if (!settings.hasOwnProperty('label') || settings.hasOwnProperty('label') && !settings.label.hasOwnProperty('align')) {
        switch (options.label.position) {
          case 'left':
            options.label.align = 'right';
            break;
          case 'right':
            options.label.align = 'left';
            break;
          default:
            options.label.align = 'center';
        }

        if (options.label.rotate === 'left') {
          options.label.align = 'right';
        } else if (options.label.rotate === 'right') {
          options.label.align = 'left';
        }
      }

      if (!settings.hasOwnProperty('label') || settings.hasOwnProperty('label') && !settings.label.hasOwnProperty('offset')) {
        if (options.label.position === 'left' || options.label.position === 'right') {
          options.label.offset = {
            x: 10,
            y: 15
          };
        }
      }
    }

    /**
     * If not specified, add some margin around the legend depending on its position
     *
     * @return void
     */

    function autoAddLegendMargin() {
      switch (options.legendVerticalPosition) {
        case 'top':
          options.legendMargin[2] = parent.DEFAULT_LEGEND_MARGIN;
          break;
        case 'bottom':
          options.legendMargin[0] = parent.DEFAULT_LEGEND_MARGIN;
          break;
        case 'middle':
        case 'center':
          options.legendMargin[options.legendHorizontalPosition === 'right' ? 3 : 1] = parent.DEFAULT_LEGEND_MARGIN;
      }
    }

    /**
     * Expand a number of an array of numbers to an usable 4 values array
     *
     * @param  {integer|array} value
     * @return {array}        array
     */

    function expandMarginSetting(value) {
      if (typeof value === 'number') {
        value = [value];
      }

      if (!Array.isArray(value)) {
        console.error('Margin only takes an integer or an array of integers');
        value = [0];
      }

      switch (value.length) {
        case 1:
          return [value[0], value[0], value[0], value[0]];
        case 2:
          return [value[0], value[1], value[0], value[1]];
        case 3:
          return [value[0], value[1], value[2], value[1]];
        case 4:
          return value;
        default:
          return value.slice(0, 4);
      }
    }

    /**
     * Convert a string to an array like [singular-form, plural-form]
     *
     * @param  {string|array} value Date to convert
     * @return {array}       An array like [singular-form, plural-form]
     */
    function expandItemName(value) {
      if (typeof value === 'string') {
        return [value, value + (value !== '' ? 's' : '')];
      }

      if (Array.isArray(value)) {
        if (value.length === 1) {
          return [value[0], value[0] + 's'];
        } else if (value.length > 2) {
          return value.slice(0, 2);
        }

        return value;
      }

      return ['item', 'items'];
    }

    function parseColLimit(value) {
      return value > 0 ? value : null;
    }

    function parseRowLimit(value) {
      if (value > 0 && options.colLimit > 0) {
        console.log('colLimit and rowLimit are mutually exclusive, rowLimit will be ignored');
        return null;
      }
      return value > 0 ? value : null;
    }

    return this._init();
  },

  /**
   * Convert a keyword or an array of keyword/date to an array of date objects
   *
   * @param  {string|array|Date} value Data to convert
   * @return {array}       An array of Dates
   */
  expandDateSetting: function expandDateSetting(value) {
    'use strict';

    if (!Array.isArray(value)) {
      value = [value];
    }

    return value.map(function (data) {
      if (data === 'now') {
        return new Date();
      }
      if (data instanceof Date) {
        return data;
      }
      return false;
    }).filter(function (d) {
      return d !== false;
    });
  },

  /**
   * Fill the calendar by coloring the cells
   *
   * @param array svg An array of html node to apply the transformation to (optional)
   *                  It's used to limit the painting to only a subset of the calendar
   * @return void
   */

  fill: function fill(svg) {
    'use strict';

    var parent = this;
    var options = parent.options;

    if (arguments.length === 0) {
      svg = parent.root.selectAll('.graph-domain');
    }

    var rect = svg.selectAll('svg').selectAll('g').data(function (d) {
      return parent._domains.get(d);
    });

    /**
     * Colorize the cell via a style attribute if enabled
     */

    function addStyle(element) {
      if (parent.legendScale === null) {
        return false;
      }

      element.attr('fill', function (d) {
        if (d.v === 0 && options.legendColors !== null && options.legendColors.hasOwnProperty('empty')) {
          return options.legendColors.empty;
        }

        if (d.v < 0 && options.legend[0] > 0 && options.legendColors !== null && options.legendColors.hasOwnProperty('overflow')) {
          return options.legendColors.overflow;
        }

        return parent.legendScale(Math.min(d.v, options.legend[options.legend.length - 1]));
      });
    }

    rect.transition().duration(options.animationDuration).select('rect').attr('class', function (d) {

      var htmlClass = parent.getHighlightClassName(d.t);

      if (parent.legendScale === null) {
        htmlClass += ' graph-rect';
      }

      if (d.v !== null) {
        htmlClass += ' ' + parent.Legend.getClass(d.v, parent.legendScale === null);
      } else if (options.considerMissingDataAsZero && parent.dateIsLessThan(d.t, new Date())) {
        htmlClass += ' ' + parent.Legend.getClass(0, parent.legendScale === null);
      }

      if (options.onMouseup !== null) {
        htmlClass += ' hover_cursor';
      }

      return htmlClass;
    }).call(addStyle);

    rect.transition().duration(options.animationDuration).select('title').text(function (d) {
      return parent.getSubDomainTitle(d);
    });

    function formatSubDomainText(element) {
      if (typeof options.subDomainTextFormat === 'function') {
        element.text(function (d) {
          return options.subDomainTextFormat(d.t, d.v);
        });
      }
    }

    /**
     * Change the subDomainText class if necessary
     * Also change the text, e.g when text is representing the value
     * instead of the date
     */
    rect.transition().duration(options.animationDuration).select('text').attr('class', function (d) {
      return 'subdomain-text' + parent.getHighlightClassName(d.t);
    }).call(formatSubDomainText);
  },

  // =========================================================================//
  // EVENTS CALLBACK															//
  // =========================================================================//

  /**
   * Helper method for triggering event callback
   *
   * @param  string  eventName       Name of the event to trigger
   * @param  array  successArgs     List of argument to pass to the callback
   * @param  boolean  skip      Whether to skip the event triggering
   * @return mixed  True when the triggering was skipped, false on error, else the callback function
   */

  triggerEvent: function triggerEvent(eventName, successArgs, skip) {
    'use strict';

    if (arguments.length === 3 && skip || this.options[eventName] === null) {
      return true;
    }

    if (typeof this.options[eventName] === 'function') {
      if (typeof successArgs === 'function') {
        successArgs = successArgs();
      }
      return this.options[eventName].apply(this, successArgs);
    } else {
      console.error('Provided callback for ' + eventName + ' is not a function.');
      return false;
    }
  },

  /**
   * Event triggered on a mouse click on a subDomain cell
   *
   * @param  Date    d    Date of the subdomain block
   * @param  int    itemNb  Number of items in that date
   */

  onMousedown: function onMousedown(d, itemNb) {
    'use strict';

    return this.triggerEvent('onMousedown', [d, itemNb]);
  },

  /**
   * Event triggered on a mouse click on a subDomain cell
   *
   * @param  Date    d    Date of the subdomain block
   * @param  int    itemNb  Number of items in that date
   */

  onMouseup: function onMouseup(d, itemNb) {
    'use strict';

    return this.triggerEvent('onMouseup', [d, itemNb]);
  },

  /**
   * Event triggered after drawing the calendar, byt before filling it with data
   */

  afterLoad: function afterLoad() {
    'use strict';

    return this.triggerEvent('afterLoad');
  },

  /**
   * Event triggered after completing drawing and filling the calendar
   */

  onComplete: function onComplete() {
    'use strict';

    var response = this.triggerEvent('onComplete', [], this._completed);
    this._completed = true;
    return response;
  },

  /**
   * Event triggered after shifting the calendar one domain back
   *
   * @param  Date    start  Domain start date
   * @param  Date    end    Domain end date
   */

  afterLoadPreviousDomain: function afterLoadPreviousDomain(start) {
    'use strict';

    var parent = this;
    return this.triggerEvent('afterLoadPreviousDomain', function () {
      var subDomain = parent.getSubDomain(start);
      return [subDomain.shift(), subDomain.pop()];
    });
  },

  /**
   * Event triggered after shifting the calendar one domain above
   *
   * @param  Date    start  Domain start date
   * @param  Date    end    Domain end date
   */

  afterLoadNextDomain: function afterLoadNextDomain(start) {
    'use strict';

    var parent = this;
    return this.triggerEvent('afterLoadNextDomain', function () {
      var subDomain = parent.getSubDomain(start);
      return [subDomain.shift(), subDomain.pop()];
    });
  },

  /**
   * Event triggered after loading the leftmost domain allowed by minDate
   *
   * @param  boolean  reached True if the leftmost domain was reached
   */

  onMinDomainReached: function onMinDomainReached(reached) {
    'use strict';

    this._minDomainReached = reached;
    return this.triggerEvent('onMinDomainReached', [reached]);
  },

  /**
   * Event triggered after loading the rightmost domain allowed by maxDate
   *
   * @param  boolean  reached True if the rightmost domain was reached
   */

  onMaxDomainReached: function onMaxDomainReached(reached) {
    'use strict';

    this._maxDomainReached = reached;
    return this.triggerEvent('onMaxDomainReached', [reached]);
  },

  checkIfMinDomainIsReached: function checkIfMinDomainIsReached(date, upperBound) {
    'use strict';

    if (this.minDomainIsReached(date)) {
      this.onMinDomainReached(true);
    }

    if (arguments.length === 2) {
      if (this._maxDomainReached && !this.maxDomainIsReached(upperBound)) {
        this.onMaxDomainReached(false);
      }
    }
  },

  checkIfMaxDomainIsReached: function checkIfMaxDomainIsReached(date, lowerBound) {
    'use strict';

    if (this.maxDomainIsReached(date)) {
      this.onMaxDomainReached(true);
    }

    if (arguments.length === 2) {
      if (this._minDomainReached && !this.minDomainIsReached(lowerBound)) {
        this.onMinDomainReached(false);
      }
    }
  },

  // =========================================================================//
  // FORMATTER																//
  // =========================================================================//

  formatNumber: _d2.default.format(',g'),

  formatDate: function formatDate(d, format) {
    'use strict';

    if (arguments.length < 2) {
      format = 'title';
    }

    if (typeof format === 'function') {
      return format(d);
    } else {
      var f = _d2.default.time.format(format);
      return f(d);
    }
  },

  getSubDomainTitle: function getSubDomainTitle(d) {
    'use strict';

    if (d.v === null && !this.options.considerMissingDataAsZero) {
      return this.options.subDomainTitleFormat.empty.format({
        date: this.formatDate(new Date(d.t), this.options.subDomainDateFormat)
      });
    } else {
      var value = d.v;
      // Consider null as 0
      if (value === null && this.options.considerMissingDataAsZero) {
        value = 0;
      }

      return this.options.subDomainTitleFormat.filled.format({
        count: this.formatNumber(value),
        name: this.options.itemName[value !== 1 ? 1 : 0],
        connector: this._domainType[this.options.subDomain].format.connector,
        date: this.formatDate(new Date(d.t), this.options.subDomainDateFormat)
      });
    }
  },

  // =========================================================================//
  // DOMAIN NAVIGATION														//
  // =========================================================================//

  /**
   * Shift the calendar one domain forward
   *
   * The new domain is loaded only if it's not beyond maxDate
   *
   * @param int n Number of domains to load
   * @return bool True if the next domain was loaded, else false
   */

  loadNextDomain: function loadNextDomain(n) {
    'use strict';

    if (this._maxDomainReached || n === 0) {
      return false;
    }

    var bound = this.loadNewDomains(this.NAVIGATE_RIGHT, this.getDomain(this.getNextDomain(), n));

    this.afterLoadNextDomain(bound.end);
    this.checkIfMaxDomainIsReached(this.getNextDomain().getTime(), bound.start);

    return true;
  },

  /**
   * Shift the calendar one domain backward
   *
   * The previous domain is loaded only if it's not beyond the minDate
   *
   * @param int n Number of domains to load
   * @return bool True if the previous domain was loaded, else false
   */

  loadPreviousDomain: function loadPreviousDomain(n) {
    'use strict';

    if (this._minDomainReached || n === 0) {
      return false;
    }

    var bound = this.loadNewDomains(this.NAVIGATE_LEFT, this.getDomain(this.getDomainKeys()[0], -n).reverse());

    this.afterLoadPreviousDomain(bound.start);
    this.checkIfMinDomainIsReached(bound.start, bound.end);

    return true;
  },

  loadNewDomains: function loadNewDomains(direction, newDomains) {
    'use strict';

    var parent = this;
    var backward = direction === this.NAVIGATE_LEFT;
    var i = -1;
    var total = newDomains.length;
    var domains = this.getDomainKeys();

    function buildSubDomain(d) {
      return {
        t: parent._domainType[parent.options.subDomain].extractUnit(d),
        v: null
      };
    }

    // Remove out of bound domains from list of new domains to prepend
    while (++i < total) {
      if (backward && this.minDomainIsReached(newDomains[i])) {
        newDomains = newDomains.slice(0, i + 1);
        break;
      }
      if (!backward && this.maxDomainIsReached(newDomains[i])) {
        newDomains = newDomains.slice(0, i);
        break;
      }
    }

    newDomains = newDomains.slice(-this.options.range);

    for (i = 0, total = newDomains.length; i < total; i++) {
      this._domains.set(newDomains[i].getTime(), this.getSubDomain(newDomains[i]).map(buildSubDomain));

      this._domains.remove(backward ? domains.pop() : domains.shift());
    }

    domains = this.getDomainKeys();

    if (backward) {
      newDomains = newDomains.reverse();
    }

    this.paint(direction);

    this.getDatas(this.options.data, newDomains[0], this.getSubDomain(newDomains[newDomains.length - 1]).pop(), function () {
      parent.fill(parent.lastInsertedSvg);
    });

    return {
      start: newDomains[backward ? 0 : 1],
      end: domains[domains.length - 1]
    };
  },

  /**
   * Return whether a date is inside the scope determined by maxDate
   *
   * @param int datetimestamp The timestamp in ms to test
   * @return bool True if the specified date correspond to the calendar upper bound
   */

  maxDomainIsReached: function maxDomainIsReached(datetimestamp) {
    'use strict';

    return this.options.maxDate !== null && this.options.maxDate.getTime() < datetimestamp;
  },

  /**
   * Return whether a date is inside the scope determined by minDate
   *
   * @param int datetimestamp The timestamp in ms to test
   * @return bool True if the specified date correspond to the calendar lower bound
   */

  minDomainIsReached: function minDomainIsReached(datetimestamp) {
    'use strict';

    return this.options.minDate !== null && this.options.minDate.getTime() >= datetimestamp;
  },

  /**
   * Return the list of the calendar's domain timestamp
   *
   * @return Array a sorted array of timestamp
   */

  getDomainKeys: function getDomainKeys() {
    'use strict';

    return this._domains.keys().map(function (d) {
      return parseInt(d, 10);
    }).sort(function (a, b) {
      return a - b;
    });
  },

  // =========================================================================//
  // POSITIONNING																//
  // =========================================================================//

  positionSubDomainX: function positionSubDomainX(d) {
    'use strict';

    var index = this._domainType[this.options.subDomain].position.x(new Date(d));
    return index * this.options.cellSize + index * this.options.cellPadding;
  },

  positionSubDomainY: function positionSubDomainY(d) {
    'use strict';

    var index = this._domainType[this.options.subDomain].position.y(new Date(d));
    return index * this.options.cellSize + index * this.options.cellPadding;
  },

  getSubDomainColumnNumber: function getSubDomainColumnNumber(d) {
    'use strict';

    if (this.options.rowLimit > 0) {
      var i = this._domainType[this.options.subDomain].maxItemNumber;
      if (typeof i === 'function') {
        i = i(d);
      }
      return Math.ceil(i / this.options.rowLimit);
    }

    var j = this._domainType[this.options.subDomain].defaultColumnNumber;
    if (typeof j === 'function') {
      j = j(d);
    }
    return this.options.colLimit || j;
  },

  getSubDomainRowNumber: function getSubDomainRowNumber(d) {
    'use strict';

    if (this.options.colLimit > 0) {
      var i = this._domainType[this.options.subDomain].maxItemNumber;
      if (typeof i === 'function') {
        i = i(d);
      }
      return Math.ceil(i / this.options.colLimit);
    }

    var j = this._domainType[this.options.subDomain].defaultRowNumber;
    if (typeof j === 'function') {
      j = j(d);
    }
    return this.options.rowLimit || j;
  },

  /**
   * Return a classname if the specified date should be highlighted
   *
   * @param  timestamp date Date of the current subDomain
   * @return String the highlight class
   */

  getHighlightClassName: function getHighlightClassName(d) {
    'use strict';

    d = new Date(d);

    if (this.options.highlight.length > 0) {
      for (var i in this.options.highlight) {
        if (this.options.highlight[i] instanceof Date && this.dateIsEqual(this.options.highlight[i], d)) {
          return ' highlight' + (this.isNow(this.options.highlight[i]) ? ' now' : '');
        }
      }
    }
    return '';
  },

  /**
   * Return whether the specified date is now,
   * according to the type of subdomain
   *
   * @param  Date d The date to compare
   * @return bool True if the date correspond to a subdomain cell
   */

  isNow: function isNow(d) {
    'use strict';

    return this.dateIsEqual(d, new Date());
  },

  /**
   * Return whether 2 dates are equals
   * This function is subdomain-aware,
   * and dates comparison are dependent of the subdomain
   *
   * @param  Date dateA First date to compare
   * @param  Date dateB Secon date to compare
   * @return bool true if the 2 dates are equals
   */

  /* jshint maxcomplexity: false */
  dateIsEqual: function dateIsEqual(dateA, dateB) {
    'use strict';

    switch (this.options.subDomain) {
      case 'x_min':
      case 'min':
        return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate() && dateA.getHours() === dateB.getHours() && dateA.getMinutes() === dateB.getMinutes();
      case 'x_hour':
      case 'hour':
        return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate() && dateA.getHours() === dateB.getHours();
      case 'x_day':
      case 'day':
        return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth() && dateA.getDate() === dateB.getDate();
      case 'x_week':
      case 'week':
      case 'x_month':
      case 'month':
        return dateA.getFullYear() === dateB.getFullYear() && dateA.getMonth() === dateB.getMonth();
      default:
        return false;
    }
  },

  /**
   * Returns weather or not dateA is less than or equal to dateB. This function is subdomain aware.
   * Performs automatic conversion of values.
   * @param dateA may be a number or a Date
   * @param dateB may be a number or a Date
   * @returns {boolean}
   */

  dateIsLessThan: function dateIsLessThan(dateA, dateB) {
    'use strict';

    if (!(dateA instanceof Date)) {
      dateA = new Date(dateA);
    }

    if (!(dateB instanceof Date)) {
      dateB = new Date(dateB);
    }

    function normalizedMillis(date, subdomain) {
      switch (subdomain) {
        case 'x_min':
        case 'min':
          return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()).getTime();
        case 'x_hour':
        case 'hour':
          return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours()).getTime();
        case 'x_day':
        case 'day':
          return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
        case 'x_week':
        case 'week':
        case 'x_month':
        case 'month':
          return new Date(date.getFullYear(), date.getMonth()).getTime();
        default:
          return date.getTime();
      }
    }

    return normalizedMillis(dateA, this.options.subDomain) < normalizedMillis(dateB, this.options.subDomain);
  },

  // =========================================================================//
  // DATE COMPUTATION															//
  // =========================================================================//

  /**
   * Return the day of the year for the date
   * @param  Date
   * @return  int Day of the year [1,366]
   */

  getDayOfYear: _d2.default.time.format('%j'),

  /**
   * Return the week number of the year
   * Monday as the first day of the week
   * @return int  Week number [0-53]
   */

  getWeekNumber: function getWeekNumber(d) {
    'use strict';

    var f = this.options.weekStartOnMonday === true ? _d2.default.time.format('%W') : _d2.default.time.format('%U');
    return f(d);
  },

  /**
   * Return the week number, relative to its month
   *
   * @param  int|Date d Date or timestamp in milliseconds
   * @return int Week number, relative to the month [0-5]
   */

  getMonthWeekNumber: function getMonthWeekNumber(d) {
    'use strict';

    if (typeof d === 'number') {
      d = new Date(d);
    }
    var monthFirstWeekNumber = this.getWeekNumber(new Date(d.getFullYear(), d.getMonth()));
    return this.getWeekNumber(d) - monthFirstWeekNumber - 1;
  },

  /**
   * Return the number of weeks in the dates' year
   *
   * @param  int|Date d Date or timestamp in milliseconds
   * @return int Number of weeks in the date's year
   */

  getWeekNumberInYear: function getWeekNumberInYear(d) {
    'use strict';

    if (typeof d === 'number') {
      d = new Date(d);
    }
  },

  /**
   * Return the number of days in the date's month
   *
   * @param  int|Date d Date or timestamp in milliseconds
   * @return int Number of days in the date's month
   */

  getDayCountInMonth: function getDayCountInMonth(d) {
    'use strict';

    return this.getEndOfMonth(d).getDate();
  },

  /**
   * Return the number of days in the date's year
   *
   * @param  int|Date d Date or timestamp in milliseconds
   * @return int Number of days in the date's year
   */

  getDayCountInYear: function getDayCountInYear(d) {
    'use strict';

    if (typeof d === 'number') {
      d = new Date(d);
    }
    return new Date(d.getFullYear(), 1, 29).getMonth() === 1 ? 366 : 365;
  },

  /**
   * Get the weekday from a date
   *
   * Return the week day number (0-6) of a date,
   * depending on whether the week start on monday or sunday
   *
   * @param  Date d
   * @return int The week day number (0-6)
   */

  getWeekDay: function getWeekDay(d) {
    'use strict';

    if (this.options.weekStartOnMonday === false) {
      return d.getDay();
    }
    return d.getDay() === 0 ? 6 : d.getDay() - 1;
  },

  /**
   * Get the last day of the month
   * @param  Date|int  d  Date or timestamp in milliseconds
   * @return Date      Last day of the month
   */

  getEndOfMonth: function getEndOfMonth(d) {
    'use strict';

    if (typeof d === 'number') {
      d = new Date(d);
    }
    return new Date(d.getFullYear(), d.getMonth() + 1, 0);
  },

  /**
   *
   * @param  Date date
   * @param  int count
   * @param  string step
   * @return Date
   */

  jumpDate: function jumpDate(date, count, step) {
    'use strict';

    var d = new Date(date);
    switch (step) {
      case 'hour':
        d.setHours(d.getHours() + count);
        break;
      case 'day':
        d.setHours(d.getHours() + count * 24);
        break;
      case 'week':
        d.setHours(d.getHours() + count * 24 * 7);
        break;
      case 'month':
        d.setMonth(d.getMonth() + count);
        break;
      case 'year':
        d.setFullYear(d.getFullYear() + count);
    }

    return new Date(d);
  },

  // =========================================================================//
  // DOMAIN COMPUTATION														//
  // =========================================================================//

  /**
   * Return all the minutes between 2 dates
   *
   * @param  Date  d  date  A date
   * @param  int|date  range  Number of minutes in the range, or a stop date
   * @return array  An array of minutes
   */

  getMinuteDomain: function getMinuteDomain(d, range) {
    'use strict';

    var start = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours());
    var stop = null;
    if (range instanceof Date) {
      stop = new Date(range.getFullYear(), range.getMonth(), range.getDate(), range.getHours());
    } else {
      stop = new Date(+start + range * 1000 * 60);
    }
    return _d2.default.time.minutes(Math.min(start, stop), Math.max(start, stop));
  },

  /**
   * Return all the hours between 2 dates
   *
   * @param  Date  d  A date
   * @param  int|date  range  Number of hours in the range, or a stop date
   * @return array  An array of hours
   */

  getHourDomain: function getHourDomain(d, range) {
    'use strict';

    if (!d) {
      // console.error(15, 'нету d');
      d = new Date('1900-01-01');
    }

    var start = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours());
    var stop = null;
    if (range instanceof Date) {
      stop = new Date(range.getFullYear(), range.getMonth(), range.getDate(), range.getHours());
    } else {
      stop = new Date(start);
      stop.setHours(stop.getHours() + range);
    }

    var domains = _d2.default.time.hours(Math.min(start, stop), Math.max(start, stop));

    // Passing from DST to standard time
    // If there are 25 hours, let's compress the duplicate hours
    var i = 0;
    var total = domains.length;
    for (i = 0; i < total; i++) {
      if (i > 0 && domains[i].getHours() === domains[i - 1].getHours()) {
        this.DSTDomain.push(domains[i].getTime());
        domains.splice(i, 1);
        break;
      }
    }

    // d3.time.hours is returning more hours than needed when changing
    // from DST to standard time, because there is really 2 hours between
    // 1am and 2am!
    if (typeof range === 'number' && domains.length > Math.abs(range)) {
      domains.splice(domains.length - 1, 1);
    }

    return domains;
  },

  /**
   * Return all the days between 2 dates
   *
   * @param  Date    d    A date
   * @param  int|date  range  Number of days in the range, or a stop date
   * @return array  An array of weeks
   */

  getDayDomain: function getDayDomain(d, range) {
    'use strict';

    var start = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var stop = null;
    if (range instanceof Date) {
      stop = new Date(range.getFullYear(), range.getMonth(), range.getDate());
    } else {
      stop = new Date(start);
      stop = new Date(stop.setDate(stop.getDate() + parseInt(range, 10)));
    }

    return _d2.default.time.days(Math.min(start, stop), Math.max(start, stop));
  },

  /**
   * Return all the weeks between 2 dates
   *
   * @param  Date  d  A date
   * @param  int|date  range  Number of minutes in the range, or a stop date
   * @return array  An array of weeks
   */

  getWeekDomain: function getWeekDomain(d, range) {
    'use strict';

    var weekStart = void 0;
    if (this.options.weekStartOnMonday === false) {
      weekStart = new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay());
    } else {
      if (d.getDay() === 1) {
        weekStart = new Date(d.getFullYear(), d.getMonth(), d.getDate());
      } else if (d.getDay() === 0) {
        weekStart = new Date(d.getFullYear(), d.getMonth(), d.getDate());
        weekStart.setDate(weekStart.getDate() - 6);
      } else {
        weekStart = new Date(d.getFullYear(), d.getMonth(), d.getDate() - d.getDay() + 1);
      }
    }

    var endDate = new Date(weekStart);

    var stop = range;
    if ((typeof range === 'undefined' ? 'undefined' : _typeof(range)) !== 'object') {
      stop = new Date(endDate.setDate(endDate.getDate() + range * 7));
    }

    return this.options.weekStartOnMonday === true ? _d2.default.time.mondays(Math.min(weekStart, stop), Math.max(weekStart, stop)) : _d2.default.time.sundays(Math.min(weekStart, stop), Math.max(weekStart, stop));
  },

  /**
   * Return all the months between 2 dates
   *
   * @param  Date    d    A date
   * @param  int|date  range  Number of months in the range, or a stop date
   * @return array  An array of months
   */

  getMonthDomain: function getMonthDomain(d, range) {
    'use strict';

    var start = new Date(d.getFullYear(), d.getMonth());
    var stop = null;
    if (range instanceof Date) {
      stop = new Date(range.getFullYear(), range.getMonth());
    } else {
      stop = new Date(start);
      stop = stop.setMonth(stop.getMonth() + range);
    }

    return _d2.default.time.months(Math.min(start, stop), Math.max(start, stop));
  },

  /**
   * Return all the years between 2 dates
   *
   * @param  Date  d  date  A date
   * @param  int|date  range  Number of minutes in the range, or a stop date
   * @return array  An array of hours
   */

  getYearDomain: function getYearDomain(d, range) {
    'use strict';

    var start = new Date(d.getFullYear(), 0);
    var stop = null;
    if (range instanceof Date) {
      stop = new Date(range.getFullYear(), 0);
    } else {
      stop = new Date(d.getFullYear() + range, 0);
    }

    return _d2.default.time.years(Math.min(start, stop), Math.max(start, stop));
  },

  /**
   * Get an array of domain start dates
   *
   * @param  int|Date date A random date included in the wanted domain
   * @param  int|Date range Number of dates to get, or a stop date
   * @return Array of dates
   */

  getDomain: function getDomain(date, range) {
    'use strict';

    if (typeof date === 'number' || typeof date === 'string' && date.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}/)) {
      date = new Date(date);
    }

    if (arguments.length < 2) {
      range = this.options.range;
    }

    switch (this.options.domain) {
      case 'hour':
        var domains = this.getHourDomain(date, range);

        // Case where an hour is missing, when passing from standard time to DST
        // Missing hour is perfectly acceptabl in subDomain, but not in domains
        if (typeof range === 'number' && domains.length < range) {
          if (range > 0) {
            domains.push(this.getHourDomain(domains[domains.length - 1], 2)[1]);
          } else {
            domains.shift(this.getHourDomain(domains[0], -2)[0]);
          }
        }
        return domains;
      case 'day':
        return this.getDayDomain(date, range);
      case 'week':
        return this.getWeekDomain(date, range);
      case 'month':
        return this.getMonthDomain(date, range);
      case 'year':
        return this.getYearDomain(date, range);
    }
  },

  /* jshint maxcomplexity: false */

  getSubDomain: function getSubDomain(date) {
    'use strict';

    if (typeof date === 'number') {
      date = new Date(date);
    }

    var parent = this;

    /**
     * @return int
     */

    var computeDaySubDomainSize = function computeDaySubDomainSize(date, domain) {
      switch (domain) {
        case 'year':
          return parent.getDayCountInYear(date);
        case 'month':
          return parent.getDayCountInMonth(date);
        case 'week':
          return 7;
      }
    };

    /**
     * @return int
     */

    var computeMinSubDomainSize = function computeMinSubDomainSize(date, domain) {
      switch (domain) {
        case 'hour':
          return 60;
        case 'day':
          return 60 * 24;
        case 'week':
          return 60 * 24 * 7;
      }
    };

    /**
     * @return int
     */

    var computeHourSubDomainSize = function computeHourSubDomainSize(date, domain) {
      switch (domain) {
        case 'day':
          return 24;
        case 'week':
          return 168;
        case 'month':
          return parent.getDayCountInMonth(date) * 24;
      }
    };

    /**
     * @return int
     */

    var computeWeekSubDomainSize = function computeWeekSubDomainSize(date, domain) {
      if (domain === 'month') {
        var endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        var endWeekNb = parent.getWeekNumber(endOfMonth);
        var startWeekNb = parent.getWeekNumber(new Date(date.getFullYear(), date.getMonth()));

        if (startWeekNb > endWeekNb) {
          startWeekNb = 0;
          endWeekNb++;
        }

        return endWeekNb - startWeekNb + 1;
      } else if (domain === 'year') {
        return parent.getWeekNumber(new Date(date.getFullYear(), 11, 31));
      }
    };

    switch (this.options.subDomain) {
      case 'x_min':
      case 'min':
        return this.getMinuteDomain(date, computeMinSubDomainSize(date, this.options.domain));
      case 'x_hour':
      case 'hour':
        return this.getHourDomain(date, computeHourSubDomainSize(date, this.options.domain));
      case 'x_day':
      case 'day':
        return this.getDayDomain(date, computeDaySubDomainSize(date, this.options.domain));
      case 'x_week':
      case 'week':
        return this.getWeekDomain(date, computeWeekSubDomainSize(date, this.options.domain));
      case 'x_month':
      case 'month':
        return this.getMonthDomain(date, 12);
    }
  },

  /**
   * Get the n-th next domain after the calendar newest (rightmost) domain
   * @param  int n
   * @return Date The start date of the wanted domain
   */

  getNextDomain: function getNextDomain(n) {
    'use strict';

    if (arguments.length === 0) {
      n = 1;
    }
    return this.getDomain(this.jumpDate(this.getDomainKeys().pop(), n, this.options.domain), 1)[0];
  },

  /**
   * Get the n-th domain before the calendar oldest (leftmost) domain
   * @param  int n
   * @return Date The start date of the wanted domain
   */

  getPreviousDomain: function getPreviousDomain(n) {
    'use strict';

    if (arguments.length === 0) {
      n = 1;
    }
    return this.getDomain(this.jumpDate(this.getDomainKeys().shift(), -n, this.options.domain), 1)[0];
  },

  // =========================================================================//
  // DATAS																	//
  // =========================================================================//

  /**
   * Fetch and interpret data from the datasource
   *
   * @param string|object source
   * @param Date startDate
   * @param Date endDate
   * @param function callback
   * @param function|boolean afterLoad function used to convert the data into a json object. Use true to use the afterLoad callback
   * @param updateMode
   *
   * @return mixed
   * - True if there are no data to load
   * - False if data are loaded asynchronously
   */

  getDatas: function getDatas(source, startDate, endDate, callback, afterLoad, updateMode) {
    'use strict';

    var self = this;
    if (arguments.length < 5) {
      afterLoad = true;
    }
    if (arguments.length < 6) {
      updateMode = this.APPEND_ON_UPDATE;
    }
    var _callback = function _callback(data) {
      if (afterLoad !== false) {
        if (typeof afterLoad === 'function') {
          data = afterLoad(data);
        } else if (typeof self.options.afterLoadData === 'function') {
          data = self.options.afterLoadData(data);
        } else {
          console.error('Provided callback for afterLoadData is not a function.');
        }
      } else if (self.options.dataType === 'csv' || self.options.dataType === 'tsv') {
        data = this.interpretCSV(data);
      }
      self.parseDatas(data, updateMode, startDate, endDate);
      if (typeof callback === 'function') {
        return callback();
      }
    };

    switch (typeof source === 'undefined' ? 'undefined' : _typeof(source)) {
      case 'string':
        if (source === '') {
          _callback({});
          return true;
        } else {
          switch (this.options.dataType) {
            case 'json':
              _d2.default.json(this.parseURI(source, startDate, endDate), _callback);
              break;
            case 'csv':
              _d2.default.csv(this.parseURI(source, startDate, endDate), _callback);
              break;
            case 'tsv':
              _d2.default.tsv(this.parseURI(source, startDate, endDate), _callback);
              break;
            case 'txt':
              _d2.default.text(this.parseURI(source, startDate, endDate), 'text/plain', _callback);
              break;
          }
        }
        return false;
      case 'object':
        if (source === Object(source)) {
          _callback(source);
          return false;
        }
      // /* falls through */

      default:
        _callback({});
        return true;
    }
  },

  /**
   * Populate the calendar internal data
   *
   * @param object data
   * @param constant updateMode
   * @param Date startDate
   * @param Date endDate
   *
   * @return void
   */

  parseDatas: function parseDatas(data, updateMode, startDate, endDate) {
    'use strict';

    if (updateMode === this.RESET_ALL_ON_UPDATE) {
      this._domains.forEach(function (key, value) {
        value.forEach(function (element, index, array) {
          array[index].v = null;
        });
      });
    }

    var temp = {};

    var extractTime = function extractTime(d) {
      return d.t;
    };

    /*jshint forin:false */

    for (var d in data) {
      var date = new Date(d * 1000);
      var domainData = this.getDomain(date)[0];
      if (!domainData) return;
      var domainUnit = domainData.getTime();

      // The current data belongs to a domain that was compressed
      // Compress the data for the two duplicate hours into the same hour
      if (this.DSTDomain.indexOf(domainUnit) >= 0) {

        // Re-assign all data to the first or the second duplicate hours
        // depending on which is visible
        if (this._domains.has(domainUnit - 3600 * 1000)) {
          domainUnit -= 3600 * 1000;
        }
      }

      // Skip if data is not relevant to current domain
      if (isNaN(d) || !data.hasOwnProperty(d) || !this._domains.has(domainUnit) || !(domainUnit >= +startDate && domainUnit < +endDate)) {
        continue;
      }

      var subDomainsData = this._domains.get(domainUnit);

      if (!temp.hasOwnProperty(domainUnit)) {
        temp[domainUnit] = subDomainsData.map(extractTime);
      }

      var index = temp[domainUnit].indexOf(this._domainType[this.options.subDomain].extractUnit(date));

      if (updateMode === this.RESET_SINGLE_ON_UPDATE) {
        subDomainsData[index].v = data[d];
      } else {
        if (!isNaN(subDomainsData[index].v)) {
          subDomainsData[index].v += data[d];
        } else {
          subDomainsData[index].v = data[d];
        }
      }
    }
  },

  parseURI: function parseURI(str, startDate, endDate) {
    'use strict';

    // Use a timestamp in seconds

    str = str.replace(/\{\{t:start\}\}/g, startDate.getTime() / 1000);
    str = str.replace(/\{\{t:end\}\}/g, endDate.getTime() / 1000);

    // Use a string date, following the ISO-8601
    str = str.replace(/\{\{d:start\}\}/g, startDate.toISOString());
    str = str.replace(/\{\{d:end\}\}/g, endDate.toISOString());

    return str;
  },

  interpretCSV: function interpretCSV(data) {
    'use strict';

    var d = {};
    var keys = Object.keys(data[0]);
    var i = void 0;
    var total = void 0;
    for (i = 0, total = data.length; i < total; i++) {
      d[data[i][keys[0]]] = +data[i][keys[1]];
    }
    return d;
  },

  /**
   * Handle the calendar layout and dimension
   *
   * Expand and shrink the container depending on its children dimension
   * Also rearrange the children position depending on their dimension,
   * and the legend position
   *
   * @return void
   */

  resize: function resize() {
    'use strict';

    var parent = this;
    var options = parent.options;
    var legendWidth = options.displayLegend ? parent.Legend.getDim('width') + options.legendMargin[1] + options.legendMargin[3] : 0;
    var legendHeight = options.displayLegend ? parent.Legend.getDim('height') + options.legendMargin[0] + options.legendMargin[2] : 0;

    var graphWidth = parent.graphDim.width - options.domainGutter - options.cellPadding;
    var graphHeight = parent.graphDim.height - options.domainGutter - options.cellPadding;
    if (graphHeight < 0) {
      // console.error('отрицательная высота', parent, parent.graphDim.height, );
      graphHeight = 0;
    }
    this.root.transition().duration(options.animationDuration).attr('width', function () {
      if (options.legendVerticalPosition === 'middle' || options.legendVerticalPosition === 'center') {
        return graphWidth + legendWidth;
      }
      return Math.max(graphWidth, legendWidth);
    }).attr('height', function () {
      if (options.legendVerticalPosition === 'middle' || options.legendVerticalPosition === 'center') {
        return Math.max(graphHeight, legendHeight);
      }
      return graphHeight + legendHeight;
    });

    this.root.select('.graph').transition().duration(options.animationDuration).attr('y', function () {
      if (options.legendVerticalPosition === 'top') {
        return legendHeight;
      }
      return 0;
    }).attr('x', function () {
      if ((options.legendVerticalPosition === 'middle' || options.legendVerticalPosition === 'center') && options.legendHorizontalPosition === 'left') {
        return legendWidth;
      }
      return 0;
    });
  },

  // =========================================================================//
  // PUBLIC API																//
  // =========================================================================//

  /**
   * Shift the calendar forward
   */

  next: function next(n) {
    'use strict';

    if (arguments.length === 0) {
      n = 1;
    }
    return this.loadNextDomain(n);
  },

  /**
   * Shift the calendar backward
   */

  previous: function previous(n) {
    'use strict';

    if (arguments.length === 0) {
      n = 1;
    }
    return this.loadPreviousDomain(n);
  },

  /**
   * Jump directly to a specific date
   *
   * JumpTo will scroll the calendar until the wanted domain with the specified
   * date is visible. Unless you set reset to true, the wanted domain
   * will not necessarily be the first (leftmost) domain of the calendar.
   *
   * @param Date date Jump to the domain containing that date
   * @param bool reset Whether the wanted domain should be the first domain of the calendar
   * @param bool True of the calendar was scrolled
   */

  jumpTo: function jumpTo(date, reset) {
    'use strict';

    if (arguments.length < 2) {
      reset = false;
    }
    var domains = this.getDomainKeys();
    var firstDomain = domains[0];
    var lastDomain = domains[domains.length - 1];

    if (date < firstDomain) {
      return this.loadPreviousDomain(this.getDomain(firstDomain, date).length);
    } else {
      if (reset) {
        return this.loadNextDomain(this.getDomain(firstDomain, date).length);
      }

      if (date > lastDomain) {
        return this.loadNextDomain(this.getDomain(lastDomain, date).length);
      }
    }

    return false;
  },

  /**
   * Navigate back to the start date
   *
   * @since  3.3.8
   * @return void
   */

  rewind: function rewind() {
    'use strict';

    this.jumpTo(this.options.start, true);
  },

  /**
   * Update the calendar with new data
   *
   * @param  object|string    dataSource    The calendar's datasource, same type as this.options.data
   * @param  boolean|function    afterLoad    Whether to execute afterLoad() on the data. Pass directly a function
   * if you don't want to use the afterLoad() callback
   */

  update: function update(dataSource, afterLoad, updateMode) {
    'use strict';

    if (arguments.length < 2) {
      afterLoad = true;
    }
    if (arguments.length < 3) {
      updateMode = this.RESET_ALL_ON_UPDATE;
    }

    var domains = this.getDomainKeys();
    var self = this;
    this.getDatas(dataSource, new Date(domains[0]), this.getSubDomain(domains[domains.length - 1]).pop(), function () {
      self.fill();
    }, afterLoad, updateMode);
  },

  /**
   * Set the legend
   *
   * @param array legend an array of integer, representing the different threshold value
   * @param array colorRange an array of 2 hex colors, for the minimum and maximum colors
   */

  setLegend: function setLegend() {
    'use strict';

    var oldLegend = this.options.legend.slice(0);
    if (arguments.length >= 1 && Array.isArray(arguments[0])) {
      this.options.legend = arguments[0];
    }
    if (arguments.length >= 2) {
      if (Array.isArray(arguments[1]) && arguments[1].length >= 2) {
        this.options.legendColors = [arguments[1][0], arguments[1][1]];
      } else {
        this.options.legendColors = arguments[1];
      }
    }

    if (arguments.length > 0 && !arrayEquals(oldLegend, this.options.legend) || arguments.length >= 2) {
      this.Legend.buildColors();
      this.fill();
    }

    this.Legend.redraw(this.graphDim.width - this.options.domainGutter - this.options.cellPadding);
  },

  /**
   * Remove the legend
   *
   * @return bool False if there is no legend to remove
   */

  removeLegend: function removeLegend() {
    'use strict';

    if (!this.options.displayLegend) {
      return false;
    }
    this.options.displayLegend = false;
    this.Legend.remove();
    return true;
  },

  /**
   * Display the legend
   *
   * @return bool False if the legend was already displayed
   */

  showLegend: function showLegend() {
    'use strict';

    if (this.options.displayLegend) {
      return false;
    }
    this.options.displayLegend = true;
    this.Legend.redraw(this.graphDim.width - this.options.domainGutter - this.options.cellPadding);
    return true;
  },

  /**
   * Highlight dates
   *
   * Add a highlight class to a set of dates
   *
   * @since  3.3.5
   * @param  array Array of dates to highlight
   * @return bool True if dates were highlighted
   */

  highlight: function highlight(args) {
    'use strict';

    if ((this.options.highlight = this.expandDateSetting(args)).length > 0) {
      this.fill();
      return true;
    }
    return false;
  },

  /**
   * Destroy the calendar
   *
   * Usage: cal = cal.destroy();
   *
   * @since  3.3.6
   * @param function A callback function to trigger after destroying the calendar
   * @return null
   */

  destroy: function destroy(callback) {
    'use strict';

    this.root.transition().duration(this.options.animationDuration).attr('width', 0).attr('height', 0).remove().each('end', function () {
      if (typeof callback === 'function') {
        return callback();
      } else if (arguments.length > 0) {
        console.error('Provided callback for destroy() is not a function.');
      }
    });

    return null;
  },

  getSVG: function getSVG() {
    'use strict';

    var styles = {
      '.cal-heatmap-container': {},
      '.graph': {},
      '.graph-rect': {},
      'rect.highlight': {},
      'rect.now': {},
      'text.highlight': {},
      'text.now': {},
      '.domain-background': {},
      '.graph-label': {},
      '.subdomain-text': {},
      '.q0': {},
      '.qi': {}
    };

    for (var j = 1, total = this.options.legend.length + 1; j <= total; j++) {
      styles['.q' + j] = {};
    }

    var root = this.root;

    var whitelistStyles = [
    // SVG specific properties
    'stroke', 'stroke-width', 'stroke-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-miterlimit', 'fill', 'fill-opacity', 'fill-rule', 'marker', 'marker-start', 'marker-mid', 'marker-end', 'alignement-baseline', 'baseline-shift', 'dominant-baseline', 'glyph-orientation-horizontal', 'glyph-orientation-vertical', 'kerning', 'text-anchor', 'shape-rendering',

    // Text Specific properties
    'text-transform', 'font-family', 'font', 'font-size', 'font-weight'];

    var filterStyles = function filterStyles(attribute, property, value) {
      if (whitelistStyles.indexOf(property) !== -1) {
        styles[attribute][property] = value;
      }
    };

    var getElement = function getElement(e) {
      return root.select(e)[0][0];
    };

    /* jshint forin:false */

    for (var element in styles) {
      if (!styles.hasOwnProperty(element)) {
        continue;
      }

      var dom = getElement(element);

      if (dom === null) {
        continue;
      }

      // The DOM Level 2 CSS way
      /* jshint maxdepth: false */

      if ('getComputedStyle' in window) {
        var cs = getComputedStyle(dom, null);
        if (cs.length !== 0) {
          for (var i = 0; i < cs.length; i++) {
            filterStyles(element, cs.item(i), cs.getPropertyValue(cs.item(i)));
          }

          // Opera workaround. Opera doesn't support `item`/`length`
          // on CSSStyleDeclaration.
        } else {
          for (var k in cs) {
            if (cs.hasOwnProperty(k)) {
              filterStyles(element, k, cs[k]);
            }
          }
        }

        // The IE way
      } else if ('currentStyle' in dom) {
        var css = dom.currentStyle;
        for (var p in css) {
          filterStyles(element, p, css[p]);
        }
      }
    }

    var string = '<svg xmlns=\'http://www.w3.org/2000/svg\' ' + 'xmlns:xlink=\'http://www.w3.org/1999/xlink\'><style type=\'text/css\'><![CDATA[ ';

    for (var style in styles) {
      string += style + ' {\n';
      for (var l in styles[style]) {
        string += '\t' + l + ':' + styles[style][l] + ';\n';
      }
      string += '}\n';
    }

    string += ']]></style>';
    string += new XMLSerializer().serializeToString(this.root[0][0]);
    string += '</svg>';

    return string;
  }
};

// =========================================================================//
// DOMAIN POSITION COMPUTATION												//
// =========================================================================//

/**
 * Compute the position of a domain, relative to the calendar
 */

var DomainPosition = function DomainPosition() {
  'use strict';

  this.positions = _d2.default.map();
};

DomainPosition.prototype.getPosition = function (d) {
  'use strict';

  return this.positions.get(d);
};

DomainPosition.prototype.getPositionFromIndex = function (i) {
  'use strict';

  var domains = this.getKeys();
  return this.positions.get(domains[i]);
};

DomainPosition.prototype.getLast = function () {
  'use strict';

  var domains = this.getKeys();
  return this.positions.get(domains[domains.length - 1]);
};

DomainPosition.prototype.setPosition = function (d, dim) {
  'use strict';

  this.positions.set(d, dim);
};

DomainPosition.prototype.shiftRightBy = function (exitingDomainDim) {
  'use strict';

  this.positions.forEach(function (key, value) {
    this.set(key, value - exitingDomainDim);
  });

  var domains = this.getKeys();
  this.positions.remove(domains[0]);
};

DomainPosition.prototype.shiftLeftBy = function (enteringDomainDim) {
  'use strict';

  this.positions.forEach(function (key, value) {
    this.set(key, value + enteringDomainDim);
  });

  var domains = this.getKeys();
  this.positions.remove(domains[domains.length - 1]);
};

DomainPosition.prototype.getKeys = function () {
  'use strict';

  return this.positions.keys().sort(function (a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
  });
};

// =========================================================================//
// LEGEND																	//
// =========================================================================//

var Legend = function Legend(calendar) {
  'use strict';

  this.calendar = calendar;
  this.computeDim();

  if (calendar.options.legendColors !== null) {
    this.buildColors();
  }
};

Legend.prototype.computeDim = function () {
  'use strict';

  var options = this.calendar.options; // Shorter accessor for variable name mangling when minifying
  this.dim = {
    width: options.legendCellSize * (options.legend.length + 1) + options.legendCellPadding * options.legend.length,
    height: options.legendCellSize
  };
};

Legend.prototype.remove = function () {
  'use strict';

  this.calendar.root.select('.graph-legend').remove();
  this.calendar.resize();
};

Legend.prototype.redraw = function (width) {
  'use strict';

  if (!this.calendar.options.displayLegend) {
    return false;
  }

  var parent = this;
  var calendar = this.calendar;
  var legend = calendar.root;
  var legendItem = void 0;
  var options = calendar.options; // Shorter accessor for variable name mangling when minifying

  this.computeDim();

  var _legend = options.legend.slice(0);
  _legend.push(_legend[_legend.length - 1] + 1);

  var legendElement = calendar.root.select('.graph-legend');
  if (legendElement[0][0] !== null) {
    legend = legendElement;
    legendItem = legend.select('g').selectAll('rect').data(_legend);
  } else {
    // Creating the new legend DOM if it doesn't already exist
    legend = options.legendVerticalPosition === 'top' ? legend.insert('svg', '.graph') : legend.append('svg');

    legend.attr('x', getLegendXPosition()).attr('y', getLegendYPosition());

    legendItem = legend.attr('class', 'graph-legend').attr('height', parent.getDim('height')).attr('width', parent.getDim('width')).append('g').selectAll().data(_legend);
  }

  legendItem.enter().append('rect').call(legendCellLayout).attr('class', function (d) {
    return calendar.Legend.getClass(d, calendar.legendScale === null);
  }).attr('fill-opacity', 0).call(function (selection) {
    if (calendar.legendScale !== null && options.legendColors !== null && options.legendColors.hasOwnProperty('base')) {
      selection.attr('fill', options.legendColors.base);
    }
  }).append('title');

  legendItem.exit().transition().duration(options.animationDuration).attr('fill-opacity', 0).remove();

  legendItem.transition().delay(function (d, i) {
    return options.animationDuration * i / 10;
  }).call(legendCellLayout).attr('fill-opacity', 1).call(function (element) {
    element.attr('fill', function (d, i) {
      if (calendar.legendScale === null) {
        return '';
      }

      if (i === 0) {
        return calendar.legendScale(d - 1);
      }
      return calendar.legendScale(options.legend[i - 1]);
    });

    element.attr('class', function (d) {
      return calendar.Legend.getClass(d, calendar.legendScale === null);
    });
  });

  function legendCellLayout(selection) {
    selection.attr('width', options.legendCellSize).attr('height', options.legendCellSize).attr('x', function (d, i) {
      return i * (options.legendCellSize + options.legendCellPadding);
    });
  }

  legendItem.select('title').text(function (d, i) {
    if (i === 0) {
      return options.legendTitleFormat.lower.format({
        min: options.legend[i],
        name: options.itemName[1]
      });
    } else if (i === _legend.length - 1) {
      return options.legendTitleFormat.upper.format({
        max: options.legend[i - 1],
        name: options.itemName[1]
      });
    } else {
      return options.legendTitleFormat.inner.format({
        down: options.legend[i - 1],
        up: options.legend[i],
        name: options.itemName[1]
      });
    }
  });

  legend.transition().duration(options.animationDuration).attr('x', getLegendXPosition()).attr('y', getLegendYPosition()).attr('width', parent.getDim('width')).attr('height', parent.getDim('height'));

  legend.select('g').transition().duration(options.animationDuration).attr('transform', function () {
    if (options.legendOrientation === 'vertical') {
      return 'rotate(90 ' + options.legendCellSize / 2 + ' ' + options.legendCellSize / 2 + ')';
    }
    return '';
  });

  function getLegendXPosition() {
    switch (options.legendHorizontalPosition) {
      case 'right':
        if (options.legendVerticalPosition === 'center' || options.legendVerticalPosition === 'middle') {
          return width + options.legendMargin[3];
        }
        return width - parent.getDim('width') - options.legendMargin[1];
      case 'middle':
      case 'center':
        return Math.round(width / 2 - parent.getDim('width') / 2);
      default:
        return options.legendMargin[3];
    }
  }

  function getLegendYPosition() {
    if (options.legendVerticalPosition === 'bottom') {
      return calendar.graphDim.height + options.legendMargin[0] - options.domainGutter - options.cellPadding;
    }
    return options.legendMargin[0];
  }

  calendar.resize();
};

/**
 * Return the dimension of the legend
 *
 * Takes into account rotation
 *
 * @param  string axis Width or height
 * @return int height or width in pixels
 */

Legend.prototype.getDim = function (axis) {
  'use strict';

  var isHorizontal = this.calendar.options.legendOrientation === 'horizontal';

  switch (axis) {
    case 'width':
      return this.dim[isHorizontal ? 'width' : 'height'];
    case 'height':
      return this.dim[isHorizontal ? 'height' : 'width'];
  }
};

Legend.prototype.buildColors = function () {
  'use strict';

  var options = this.calendar.options; // Shorter accessor for variable name mangling when minifying

  if (options.legendColors === null) {
    this.calendar.legendScale = null;
    return false;
  }

  var _colorRange = [];

  if (Array.isArray(options.legendColors)) {
    _colorRange = options.legendColors;
  } else if (options.legendColors.hasOwnProperty('min') && options.legendColors.hasOwnProperty('max')) {
    _colorRange = [options.legendColors.min, options.legendColors.max];
  } else {
    options.legendColors = null;
    return false;
  }

  var _legend = options.legend.slice(0);

  if (_legend[0] > 0) {
    _legend.unshift(0);
  } else if (_legend[0] < 0) {
    // Let's guess the leftmost value, it we have to add one
    _legend.unshift(_legend[0] - (_legend[_legend.length - 1] - _legend[0]) / _legend.length);
  }

  var colorScale = _d2.default.scale.linear().range(_colorRange).interpolate(_d2.default.interpolateHcl).domain([_d2.default.min(_legend), _d2.default.max(_legend)]);

  var legendColors = _legend.map(function (element) {
    return colorScale(element);
  });
  this.calendar.legendScale = _d2.default.scale.threshold().domain(options.legend).range(legendColors);

  return true;
};

/**
 * Return the classname on the legend for the specified value
 *
 * @param integer n Value associated to a date
 * @param bool withCssClass Whether to display the css class used to style the cell.
 *                          Disabling will allow styling directly via html fill attribute
 *
 * @return string Classname according to the legend
 */

Legend.prototype.getClass = function (n, withCssClass) {
  'use strict';

  if (n === null || isNaN(n)) {
    return '';
  }

  var index = [this.calendar.options.legend.length + 1];

  for (var i = 0, total = this.calendar.options.legend.length - 1; i <= total; i++) {

    if (this.calendar.options.legend[0] > 0 && n < 0) {
      index = ['1', 'i'];
      break;
    }

    if (n <= this.calendar.options.legend[i]) {
      index = [i + 1];
      break;
    }
  }

  if (n === 0) {
    index.push(0);
  }

  index.unshift('');
  return (index.join(' r') + (withCssClass ? index.join(' q') : '')).trim();
};

/**
 * Sprintf like function
 * @source http://stackoverflow.com/a/4795914/805649
 * @return String
 */

String.prototype.format = function () {
  'use strict';

  var formatted = this;
  for (var prop in arguments[0]) {
    if (arguments[0].hasOwnProperty(prop)) {
      var regexp = new RegExp('\\{' + prop + '\\}', 'gi');
      formatted = formatted.replace(regexp, arguments[0][prop]);
    }
  }
  return formatted;
};

/**
 * #source http://stackoverflow.com/a/383245/805649
 */

function mergeRecursive(obj1, obj2) {
  'use strict';

  /*jshint forin:false */

  for (var p in obj2) {
    try {
      // Property in destination object set; update its value.
      if (obj2[p].constructor === Object) {
        obj1[p] = mergeRecursive(obj1[p], obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      // Property in destination object not set; create it and set its value.
      obj1[p] = obj2[p];
    }
  }

  return obj1;
}

/**
 * Check if 2 arrays are equals
 *
 * @link http://stackoverflow.com/a/14853974/805649
 * @param  array array the array to compare to
 * @return bool true of the 2 arrays are equals
 */

function arrayEquals(arrayA, arrayB) {
  'use strict';

  // if the other array is a falsy value, return

  if (!arrayB || !arrayA) {
    return false;
  }

  // compare lengths - can save a lot of time
  if (arrayA.length !== arrayB.length) {
    return false;
  }

  for (var i = 0; i < arrayA.length; i++) {
    // Check if we have nested arrays
    if (arrayA[i] instanceof Array && arrayB[i] instanceof Array) {
      // recurse into the nested arrays
      if (!arrayEquals(arrayA[i], arrayB[i])) {
        return false;
      }
    } else if (arrayA[i] !== arrayB[i]) {
      // Warning - two different object instances will never be equal: {x:20} != {x:20}
      return false;
    }
  }
  return true;
}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports = "<div class=\"report-time hours ng-hide\"><span>00</span> <span>01</span> <span>02</span> <span>03</span> <span>04</span> <span>05</span> <span>06</span> <span>07</span> <span>08</span> <span>09</span> <span>10</span> <span>11</span> <span>12</span> <span>13</span> <span>14</span> <span>15</span> <span>16</span> <span>17</span> <span>18</span> <span>19</span> <span>20</span> <span>21</span> <span>22</span> <span>23</span></div><br>"

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(911);

var FactsMenuController = function () {
  function FactsMenuController(CurrentFilterService, RouterService, PermissionService) {
    _classCallCheck(this, FactsMenuController);

    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  _createClass(FactsMenuController, [{
    key: 'setMode',
    value: function setMode(mode) {
      if (this.isFilterEdit && this.filterData) this.filterData.filter.mode = mode;else this.router.mode = mode;
    }
  }, {
    key: 'setListType',
    value: function setListType(listType) {
      if (this.isFilterEdit && this.filterData) this.filterData.filter.listType = listType;else this.router.listType = listType;
    }
  }, {
    key: 'isFilterEdit',
    get: function get() {
      return this.router.isFilterEditModal;
    }
  }, {
    key: 'filter',
    get: function get() {
      // return this.CurrentFilterService.filter;
      return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
    }
  }]);

  return FactsMenuController;
}();

var FactsMenuComponent = exports.FactsMenuComponent = {
  template: __webpack_require__(912),
  bindings: {
    filterData: '<'
  },
  controller: FactsMenuController
};

/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-pills\"><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'table'}\"><a ng-click=\"$ctrl.setListType('table'); $ctrl.setMode('explore')\" title=\"{{::'Таблица' | gettext}}\"><i class=\"icon-table\"></i> <span class=\"hideable\">{{::'Таблица' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'brief'}\" style=\"margin-left:-3px\"><a ng-click=\"$ctrl.setListType('brief'); $ctrl.setMode('explore')\" title=\"{{::'Cписок' | gettext}}\"><i class=\"icon-th-list\"></i> <span class=\"hideable\">{{::'Cписок' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'thumblist'}\" style=\"margin-left:-2px\"><a ng-click=\"$ctrl.setListType('thumblist'); $ctrl.setMode('explore')\" title=\"{{::'Снимки экрана' | gettext}}\"><i class=\"icon-file-image\"></i> <span class=\"hideable\">{{::'Cнимки' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isReport}\" style=\"margin-left:-2px\"><a ng-click=\"$ctrl.setMode('report')\" title=\"{{::'Тепловая диаграмма' | gettext}}\"><i class=\"icon-grid\"></i> <span class=\"hideable\">{{::'Активность' | gettext}}</span></a></li></ul>"

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactsSliderTimelineComponent = undefined;

var _fact = __webpack_require__(89);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(914);

var FactsSliderTimelineController = function FactsSliderTimelineController($scope, $element) {
  _classCallCheck(this, FactsSliderTimelineController);

  this.$scope = $scope;
  this.isImage = _fact.Fact.isImage;
};

var FactsSliderTimelineComponent = exports.FactsSliderTimelineComponent = function FactsSliderTimelineComponent() {
  return {
    restrict: 'E',
    scope: false,
    // bindings  : {
    //   model       : '<',
    //   filter      : '<',
    //   facts       : '<',
    //   more        : '<',
    // },
    template: __webpack_require__(915),
    // controller: FactsSliderTimelineController,
    link: function link(scope, element, attrs) {
      var onWheel = function onWheel(e) {
        var delta = e.originalEvent.deltaY;
        if (delta > 0) {
          scope.$ctrl.leaf(1);
        } else {
          scope.$ctrl.leaf(-1);
        }
      };
      element.bind('wheel', onWheel);
    }
  };
};

/***/ }),
/* 914 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "<div class=\"imageDialogTimeline\"><div class=\"timeline-layout-left\"><div class=\"timeline-container-prev\" ng-click=\"$ctrl.scrollPrev()\" style=\"\"><a href=\"#\" class=\"btn-thumb-prev\" onclick=\"return!1\"></a></div></div><div class=\"timeline-layout-middle\"><div class=\"timeline-container\"><div class=\"timeline-container-clip\" move=\"{{$ctrl.move($ctrl.selectedFact)}}\"><div class=\"thumbnail-layout\" ng-repeat=\"fact in $ctrl.filterData.filterData\"><div class=\"thumbnail-container\"><div id=\"thumb_{{fact['id']}}_preloader\" class=\"thumbnail-preloader-container\" style=\"display:none\"><div class=\"thumbnail-preloader\"></div></div><a href=\"#\" onclick=\"return!1\" ng-click=\"$ctrl.selectThumb(fact)\" ng-class=\"fact.id === $ctrl.selectedFact.id ? 'timeline-thumbnail-selected' : 'timeline-thumbnail'\"><img ng-if=\"$ctrl.isImage(fact)\" id=\"thumb_{{fact['id']}}\" ng-src=\"{{'/media/' + $ctrl.getImageFileName(fact)}}\" thumbonload thumbonerror><div ng-if=\"!$ctrl.isImage(fact)\"><sc-fact-info filter=\"$ctrl.filter\" fact=\"fact\" open-image=\"$ctrl.openImage\"></div></a><br><span class=\"timeline-label\" style=\"color:#6f6f6f\">{{fact['local_time'] | date:'dd.MM.yyyy' }} </span>&nbsp;&nbsp; <span class=\"timeline-label\" style=\"color:#fff\">{{fact['local_time'] | date:'HH:mm:ss' }}</span></div></div></div></div></div><div class=\"timeline-layout-right\"><div class=\"timeline-container-next\" ng-click=\"$ctrl.scrollNext()\" style=\"\"><a href=\"#\" class=\"btn-thumb-next\" onclick=\"return!1\"></a></div></div></div>"

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactsSliderViewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fact = __webpack_require__(89);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(917);

var FactsSliderViewController = function () {
  function FactsSliderViewController($scope, $element) {
    _classCallCheck(this, FactsSliderViewController);

    this.$scope = $scope;
    this.isImage = _fact.Fact.isImage;
    this.getImageFileName = _fact.Fact.getImageFileName;
  }

  _createClass(FactsSliderViewController, [{
    key: 'selectedImage',
    get: function get() {
      if (!this.selectedFact) return null;
      var fileName = this.getImageFileName(this.selectedFact);
      if (!fileName) return null;
      return '/media/' + fileName;
    }
  }]);

  return FactsSliderViewController;
}();

var FactsSliderViewComponent = exports.FactsSliderViewComponent = {
  bindings: {
    filter: '<',
    selectedFact: '<'
  },
  template: __webpack_require__(918),
  controller: FactsSliderViewController
};

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports = "<div class=\"btn-layout-middle show-waves\"><a target=\"_blank\" ng-href=\"{{$ctrl.selectedImage}}\" ng-show=\"$ctrl.isImage($ctrl.selectedFact)\"><img id=\"screenshot-image\" ng-src=\"{{$ctrl.selectedImage}}\" err-src=\"/static/img/default.png\"></a><div ng-if=\"!$ctrl.isImage($ctrl.selectedFact)\" class=\"btn-layout-middle-content\"><sc-fact-info filter=\"$ctrl.filter\" fact=\"$ctrl.selectedFact\"></sc-fact-info></div></div>"

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FactsTableComponent = FactsTableComponent;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// /* global gettext */

var FactsTableController = function FactsTableController() {
  _classCallCheck(this, FactsTableController);
};

function FactsTableComponent() {
  return {
    restrict: 'E',
    scope: false,
    template: __webpack_require__(920),
    controller: FactsTableController
  };
}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "<i ng-if=\"showSelectFields()\" class=\"icon-cogs fields\" title=\"{{::'Выбор колонок' | gettext }}\" ng-click=\"selectFields()\"></i><table id=\"datatable\" class=\"fact-table table table-bordered table-condensed header-fixed\" col-resize><thead class=\"fact-table-thead\"><tr><th ng-repeat=\"col in viewMode.columns\" ng-click=\"$ctrl.toggleSortOrder(col)\" ng-class=\"{pointer: col.sortable, [col.cssClass]: 1, ['rc-' + $index]: 1}\">{{col.label}} <i class=\"pointer\" ng-if=\"$ctrl.isColSorted(col)\" ng-class=\"{'icon-sort-alt-down': filter.orderDir === 'desc', ' icon-sort-alt-up': filter.orderDir !== 'desc'}\"></i></th></tr></thead><tbody infinite-scrollfork=\"more()\" infinite-scroll-distance=\"2\" infinite-scroll-disabled=\"filterData.loading || filterData.loadingMore || filterData.isComplete || filterData.cancelled || filterData.cancelledMore\" tabindex=\"1\" ng-class=\"{'fact-table-tbody': !router.pdf, 'fact-table-tbody-pdf': router.pdf}\"><tr sc-fact-table-row filter=\"filter\" ng-repeat=\"fact in filterData.filterData\" fact=\"fact\" open-image=\"openImage\" select=\"select\" list-type=\"listType\" ng-click=\"select(fact)\" ng-class=\"{'widget-body-selected': fact.selected}\" id=\"tr{{fact.id}}\"></tr><tr ng-if=\"filterData.loadingMore\"><td colspan=\"999\" class=\"text-center spinner-cell\"><sc-hspinner></sc-hspinner></td></tr></tbody></table>"

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatTableComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _measure = __webpack_require__(39);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(922);

/*@ngInject*/

var StatTableController = function () {
  StatTableController.$inject = ["$scope", "$element", "$timeout", "CurrentModelService", "CurrentFilterService", "RouterService", "LayoutService"];
  function StatTableController($scope, $element, $timeout, CurrentModelService, CurrentFilterService, RouterService, LayoutService) {
    _classCallCheck(this, StatTableController);

    this.$scope = $scope;
    this.$element = $element;
    this.CurrentModelService = CurrentModelService;
    this.filterBar = CurrentFilterService.filterBar;
    this.router = RouterService;
    this.getMeasure = _measure.Measure.getMeasure;
    this.getMeasureLabel = _measure.Measure.getMeasureLabel;
    this.LayoutService = LayoutService;
  }

  _createClass(StatTableController, [{
    key: 'drilldown',
    value: function drilldown(drill, cell) {
      var cuts = [].concat(_toConsumableArray(this.filterData.filter.filters));
      for (var i = 0; i < this.filterData.filter.drilldown.length; ++i) {
        var drilldown = this.filterData.filter.drilldown[i];
        var cut = this.CurrentModelService.model.getCellFilter(drilldown, cell);
        cuts.push(cut);
        if (drill === drilldown) {
          break;
        }
      }
      this.router.drilldownCuts(cuts);
    }
  }, {
    key: 'barWidth',
    value: function barWidth(cell) {
      var measure = this.filterData.filter.measure;
      var width = cell[measure] * 100 / this.filterData.filterData.maxMeasure + '%';
      return width;
    }
  }, {
    key: 'isDownload',
    get: function get() {
      return this.LayoutService.download;
    }
  }, {
    key: 'isFilters',
    get: function get() {
      return this.filter.filters && this.filter.filters.length;
    }
  }, {
    key: 'appiedFilters',
    get: function get() {
      var _this = this;

      if (!this.isFilters) return '';
      return this.filter.filters.map(function (f) {
        return _this.CurrentModelService.model.getDrillLabel(f.dimension) + ': ' + f.label;
      });
    }
  }, {
    key: 'total',
    get: function get() {
      var _this2 = this;

      return this.filterData && this.filterData.filterData.cells.length ? {
        cells: this.filterData.filterData.cells.length,
        name: this.getMeasureLabel(this.filter.measure),
        value: this.getMeasure(this.filterData.filterData.cells.reduce(function (sum, cell) {
          return sum + cell[_this2.filter.measure];
        }, 0), this.filter.measure)
      } : {};
    }
  }]);

  return StatTableController;
}();

var StatTableComponent = exports.StatTableComponent = {
  template: __webpack_require__(923),
  bindings: {
    model: '<',
    filterData: '<',
    filter: '<'
  },
  controller: StatTableController
};

/***/ }),
/* 922 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "<div class=\"for-save-as-image\"><table id=\"datatable\" cellpadding=\"0\" cellspacing=\"0\" border=\"0\" class=\"table table-striped sortable-theme-bootstrap\" data-sortable><thead ng-if=\"$ctrl.isDownload\"><tr><th colspan=\"{{$ctrl.filterData.filter.drilldown.length + 1}}\">{{::'Выгрузка данных' | gettext}} \"{{$ctrl.filterBar.name}}\"</th></tr><tr><th colspan=\"{{$ctrl.filterData.filter.drilldown.length + 1}}\">{{::'за период c' | gettext}} {{$ctrl.filterBar.timeFrom | date : \"dd MMMM yyyy\"}} {{::'по' | gettext}} {{$ctrl.filterBar.timeTo | date : \"dd MMMM yyyy\"}}</th></tr><tr ng-if=\"$ctrl.isFilters\"></tr><tr ng-if=\"$ctrl.isFilters\"><th colspan=\"{{$ctrl.filterData.filter.drilldown.length + 1}}\">{{::'Примененные фильтры: ' | gettext}}</th></tr><tr ng-if=\"$ctrl.isFilters\" ng-repeat=\"flt in $ctrl.appiedFilters\"><th colspan=\"{{$ctrl.filterData.filter.drilldown.length + 1}}\">{{flt}}</th></tr><tr></tr><tr><th ng-repeat=\"drill in $ctrl.filterData.filter.drilldown\">{{$ctrl.model.getDrillLabel(drill)}}</th><th>{{ $ctrl.getMeasureLabel( $ctrl.filter.measure ) }}</th></tr></thead><thead ng-if=\"!$ctrl.isDownload\" sc-stat-header filter-data=\"$ctrl.filterData\" filter=\"$ctrl.filter\"></thead><tbody ng-if=\"$ctrl.filterData.filterData.cells.length\"><tr ng-repeat=\"cell in $ctrl.filterData.filterData.cells\"><td ng-repeat=\"drill in $ctrl.filterData.filter.drilldown\" class=\"aggregate-cell btn-link\" ng-click=\"$ctrl.drilldown(drill, cell)\" ng-class=\"{'long-cell-value': drill === 'agent_web@url:url'}\">{{:: $ctrl.model.getCellLabel(drill, cell) }}</td><td class=\"aggregate-cell aggregate-cell-measure\">{{:: $ctrl.getMeasure(cell, $ctrl.filterData.filter.measure) }}</td><td class=\"aggregate-cell\"><div class=\"aggregate-cell-bar-container\"><div class=\"aggregate-cell-bar\" ng-style=\"{ width: $ctrl.barWidth(cell) }\"></div></div></td></tr></tbody></table><div class=\"text-center\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n  && !$ctrl.filterData.cancelled\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div><div class=\"total\" ng-if=\"!$ctrl.filterData.cancelled && $ctrl.filterData.filterData.cells.length\">{{::'Всего' | gettext}}:{{' '}}{{$ctrl.total.cells}},{{' '}}{{$ctrl.total.name}}:{{' '}}{{$ctrl.total.value}}</div><sc-filter-stamp filter=\"$ctrl.filter\"></sc-filter-stamp></div>"

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummStatComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _measure = __webpack_require__(39);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(925);

/*@ngInject*/

var SummStatController = function () {
  SummStatController.$inject = ["$scope", "$element", "$timeout", "CurrentModelService", "CurrentFilterService", "RouterService", "LayoutService", "rx"];
  function SummStatController($scope, $element, $timeout, CurrentModelService, CurrentFilterService, RouterService, LayoutService, rx) {
    var _this = this;

    _classCallCheck(this, SummStatController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.LayoutService = LayoutService;
    this.LayoutService.drilldownMax = 1;
    this.getMeasure = _measure.Measure.getMeasure;
    this.getMeasureLabel = _measure.Measure.getMeasureLabel;
    this.CurrentModelService = CurrentModelService;
    this.filterBar = CurrentFilterService.filterBar;
    this.router = RouterService;
    this.totalStyle = {
      'font-size': '18px',
      'line-height': '18px'
    };
    this.LayoutService = LayoutService;
    this.resize();
    var subscription = rx.Observable.merge($scope.$eventToObservable('resizeBeforePrint'),
    // $scope.$eventToObservable('init'),
    rx.Observable.merge($scope.$eventToObservable('beforePrint'), $scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(100)).subscribe(function (e) {
      return _this.resize(e);
    });

    $scope.$on('$destroy', function () {
      subscription.dispose();
      _this.LayoutService.drilldownMax = 0;
    });
  }

  _createClass(SummStatController, [{
    key: 'resize',
    value: function resize() {
      var _this2 = this;

      var size = this.$element[0].getClientRects()[0];
      var fontSize = size ? Math.min((size.width - 30) / 20, size.height - 30) + 'px' : '18px';
      this.totalStyle['font-size'] = fontSize;
      this.totalStyle['line-height'] = fontSize;
      this.$timeout(function () {
        _this2.$scope.$apply();
      }, 10);
    }
  }, {
    key: 'measureLabel',
    get: function get() {
      if (!this.filterData || !this.filterData.filterData.cells.length) return '';
      if (this.filter.measure === 'total_elements') return gettext('Всего');
      return this.getMeasureLabel(this.filter.measure);
    }
  }, {
    key: 'total',
    get: function get() {
      var _this3 = this;

      if (!this.filterData || !this.filterData.filterData.cells.length) return '-';
      if (this.filter.measure === 'total_elements') return '' + this.filterData.filterData.cells.length;
      var summ = this.filterData.filterData.cells.reduce(function (sum, cell) {
        return sum + cell[_this3.filter.measure];
      }, 0);
      // const label = this.getMeasureLabel(this.filter.measure);
      return this.measureLabel + ': ' + this.getMeasure(summ, this.filter.measure);
    }
  }]);

  return SummStatController;
}();

var SummStatComponent = exports.SummStatComponent = {
  template: __webpack_require__(926),
  bindings: {
    model: '<',
    filterData: '<',
    filter: '<'
  },
  controller: SummStatController
};

/***/ }),
/* 925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "<div class=\"for-save-as-image\"><div class=\"text-center\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n  && !$ctrl.filterData.cancelled\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div><div class=\"total\" ng-style=\"$ctrl.totalStyle\" title=\"{{$ctrl.measureLabel}}\" ng-if=\"!$ctrl.filterData.cancelled && $ctrl.filterData.filterData.cells.length\">{{$ctrl.total}}</div></div>"

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PieComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _d = __webpack_require__(86);

var _d2 = _interopRequireDefault(_d);

var _measure = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(928);

/*@ngInject*/
var other = gettext('Всё остальное');
var maxLegends = 20;

var PieController = function () {
  function PieController($scope, $rootScope, $element, RouterService, rx, $timeout) {
    var _this2 = this;

    _classCallCheck(this, PieController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.router = RouterService;
    this.legendWidth = 0;
    this.$timeout = $timeout;

    var subscriptions = [rx.Observable.merge(rx.Observable.merge($scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(100), rx.Observable.merge($scope.$toObservable('$ctrl.filter.orders'), $scope.$toObservable('$ctrl.filter.orderDirs'), $scope.$toObservable('$ctrl.aggregate')).debounce(100), $scope.$eventToObservable('resizeBeforePrint'), $scope.$eventToObservable('afterPrint'), $scope.$eventToObservable('init')).subscribe(function (e) {
      _this2.render();
    })];

    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (subscription) {
        subscription.dispose();
      });
    });
  }

  _createClass(PieController, [{
    key: '$postLink',
    value: function $postLink() {}
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var statChart = this.$element[0].querySelector('.stat-chart');
      var statSequence = this.$element[0].querySelector('.stat-sequence');
      var statLegend = this.$element[0].querySelector('.stat-legend');

      var aggregate = this.aggregate;
      var sortKeys = {
        orders: this.filter.orders,
        orderDirs: this.filter.orderDirs,
        drill1: this.model.getDrillAttr(this.filter.drilldown[0])
      };

      if (!aggregate || !aggregate.cells) {
        return;
      }

      this.$element.find('svg').remove();

      var width = this.$element.width();

      var dims = {};

      function getLegendWidth(g) {
        return g[0].reduce(function (mw, l) {
          var w = l.getBoundingClientRect().width;
          if (mw < w) mw = w;
          return mw;
        }, 0);
      }

      // Dimensions of sunburst.
      var height = Math.min(this.$element.width() - _this.legendWidth, this.$element.height() - 100);
      if (height < 50) height = 50;
      var radius = Math.min(width, height) / 2;
      if (height < 50 || width < 50) return;

      // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
      var b = {
        w: 175,
        h: 30,
        s: 3,
        t: 10
      };

      // Mapping of step names to colors.
      var colors = {};
      var getColor = function getColor(label) {
        if (label in colors) return colors[label];
        return colors[other];
      };

      // Total size of all segments; we set this later, after loading the data.
      var totalSize = aggregate.cells.reduce(function (acc, c) {
        return acc + c[aggregate.filter.measure];
      }, 0);

      var vis = _d2.default.select(statChart).append('svg:svg').attr('width', radius * 2).attr('height', radius * 2).append('svg:g').attr('id', 'stat-container').attr('transform', 'translate(' + radius + ',' + radius + ')');

      var partition = _d2.default.layout.partition().size([2 * Math.PI, radius * radius]).value(function (d) {
        return d.size;
      });

      var arc = _d2.default.svg.arc().startAngle(function (d) {
        return d.x;
      }).endAngle(function (d) {
        return d.x + d.dx;
      }).innerRadius(function (d) {
        return Math.sqrt(d.y - d.dy);
      }).outerRadius(function (d) {
        return Math.sqrt(d.y);
      });

      // Main function to draw and set up the visualization, once we have the data.
      function createVisualization(json) {
        // Basic setup of page elements.
        initializeBreadcrumbTrail();
        drawLegend();

        // Bounding circle underneath the sunburst, to make it easier to detect
        // when the mouse leaves the parent g.
        vis.append('svg:circle').attr('r', radius).style('opacity', 0);

        // For efficiency, filter nodes to keep only those large enough to see.
        var nodes = partition.nodes(json).filter(function (d) {
          return d.dx > 0.005; // 0.005 radians = 0.29 degrees
        });

        var path = vis.data([json]).selectAll('path').data(nodes).enter().append('svg:path').attr('display', function (d) {
          return d.depth ? null : 'none';
        }).attr('d', arc).attr('fill-rule', 'evenodd').style('fill', function (d) {
          return getColor(d.name);
        }).style('opacity', 1).style('cursor', 'pointer').on('mouseover', mouseover).on('click', mouseclick);

        // Add the mouseleave handler to the bounding circle.
        vis.on('mouseleave', mouseleave);

        // Get total size of the tree = value of root node from partition.
        totalSize = path.node() ? path.node().__data__.value : 0;
      }

      function mouseclick(d) {
        _this.router.drilldownFilter(d.filter);
        _this.$rootScope.$digest();
      }

      // Fade all but the current sequence, and show it in the breadcrumb trail.
      function mouseover(d) {
        var sequenceArray = getAncestors(d);
        var cell = {};
        cell[_this.aggregate.filter.measure] = d.value;
        var val = _measure.Measure.getMeasure(cell, _this.aggregate.filter.measure);
        updateBreadcrumbs(sequenceArray, val, d.value);

        // Fade all the segments.
        _d2.default.selectAll('path').style('opacity', 0.3);

        // Then highlight only those that are an ancestor of the current segment.
        vis.selectAll('path').filter(function (node) {
          return sequenceArray.indexOf(node) >= 0;
        }).style('opacity', 1);
      }

      // Restore everything to full opacity when moving off the visualization.
      function mouseleave() {
        // Hide the breadcrumb trail
        _d2.default.select(statSequence).select('#stat-trail').style('visibility', 'hidden');

        // Deactivate all segments during transition.
        //               d3.selectAll("path").on("mouseover", null);

        // Transition each segment to full opacity and then reactivate it.
        _d2.default.select(statChart).selectAll('path').transition().duration(1000).style('opacity', 1).each('end', function () {
          _d2.default.select(this).on('mouseover', mouseover);
        });
      }

      // Given a node in a partition layout, return an array of all of its ancestor
      // nodes, highest first, but excluding the root.
      function getAncestors(node) {
        var path = [];
        var current = node;
        while (current.parent) {
          path.unshift(current);
          current = current.parent;
        }
        return path;
      }

      function initializeBreadcrumbTrail() {
        // Add the svg area.
        var trail = _d2.default.select(statSequence).append('svg:svg').attr('width', width).attr('height', 50).attr('id', 'stat-trail');
        // Add the label at the end, for the percentage.
        trail.append('svg:text').attr('id', 'stat-endlabel').style('fill', '#000');
      }

      // Generate a string that describes the points of a breadcrumb polygon.
      function breadcrumbPoints(d, i) {
        var points = [];
        points.push('0,0');
        points.push(b.w + ',0');
        points.push(b.w + b.t + ',' + b.h / 2);
        points.push(b.w + ',' + b.h);
        points.push('0,' + b.h);
        if (i > 0) {
          // Leftmost breadcrumb; don't include 6th vertex.
          points.push(b.t + ',' + b.h / 2);
        }
        return points.join(' ');
      }

      // Update the breadcrumb trail to show the current sequence and percentage.
      function updateBreadcrumbs(nodeArray, total, size) {
        // Data join; key function combines name and depth (= position in sequence).
        var g = _d2.default.select(statSequence).select('#stat-trail').selectAll('g').data(nodeArray, function (d) {
          return d.name + d.depth;
        });

        // Add breadcrumb and label for entering nodes.
        var entering = g.enter().append('svg:g');

        entering.append('svg:polygon').attr('points', breadcrumbPoints).style('fill', function (d) {
          return getColor(d.name);
        });

        var labelText = function labelText(d) {
          var max = 22;
          if (d.name.length > max) {
            return d.name.substr(0, max - 3) + '...';
          }
          return d.name;
        };

        entering.append('svg:text').attr('x', (b.w + b.t) / 2).attr('y', b.h / 2).attr('width', b.w).attr('dy', '0.35em').attr('text-anchor', 'middle').text(function (d) {
          return labelText(d);
        });

        // Set position for entering and updating nodes.
        g.attr('transform', function (d, i) {
          return 'translate(' + i * (b.w + b.s) + ', 0)';
        });

        // Remove exiting nodes.
        g.exit().remove();

        // Now move and update the percentage at the end.
        _d2.default.select(statSequence).select('#stat-trail').select('#stat-endlabel').attr('x', (nodeArray.length + 0.5) * (b.w + b.s)).attr('y', b.h / 2).attr('dy', '0.35em').attr('text-anchor', 'middle').text(function () {
          if (size && totalSize) return total + ' (' + Math.round(size * 1000 / totalSize) / 10 + '%)';
          return total;
        });

        // Make the breadcrumb trail visible, if it's hidden.
        _d2.default.select(statSequence).select('#stat-trail').style('visibility', '');
      }

      function drawLegend() {
        // Dimensions of legend item: width, height, spacing, radius of rounded rect.
        var cR = width / 50;
        var r = cR > 15 ? 15 : cR < 6 ? 6 : cR;
        var li = {
          // w: Math.min(width - height, width / 3),
          w: width,
          h: r * 2,
          s: 3,
          r: r
        };

        var sortFunc = function sortFunc(a, b) {
          return b.value.data - a.value.data;
        };
        if (sortKeys.orderDirs && sortKeys.orders) {
          if (sortKeys.orders[0] === 'measure' && sortKeys.orderDirs[0] === 'asc') {
            sortFunc = function sortFunc(a, b) {
              return a.value.data - b.value.data;
            };
          } else if (sortKeys.orders[0] === sortKeys.drill1 && sortKeys.orderDirs[0] === 'asc') {
            sortFunc = function sortFunc(a, b) {
              return a.key > b.key ? 1 : a.key == b.key ? 0 : -1;
            };
          } else if (sortKeys.orders[0] === sortKeys.drill1 && sortKeys.orderDirs[0] === 'desc') {
            sortFunc = function sortFunc(a, b) {
              return a.key > b.key ? -1 : a.key == b.key ? 0 : 1;
            };
          }
        }

        var dimIndex = 0; //(d3.keys(dims[0]).length == 1) ? 1 : 0
        var entries = _d2.default.entries(dims[dimIndex]).map(function (entry) {
          entry.val = getColor(entry.key);
          return entry;
        }).sort(sortFunc);
        // const heightLegend = angular.element(statLegend).height() - 10;
        // const maxFits = Math.min(
        //   entries.length,
        //   Math.floor(heightLegend / (li.h + li.s))
        // );
        // entries = entries.slice(0, maxFits);

        var mlen = entries.length * (li.h + li.s);
        // if (mlen > heightLegend) mlen = heightLegend;

        var legend = _d2.default.select(statLegend).append('svg:svg').attr('width', li.w).attr('height', mlen);

        var g = legend.selectAll('g').data(entries).enter().append('svg:g').attr('transform', function (d, i) {
          return 'translate(0,' + i * (li.h + li.s) + ')';
        }).style('pointer-events', 'all').style('cursor', 'pointer').on('click', function (d) {
          console.log('pie legend click');
          if (d.key == other) return;
          _this.router.drilldownFilter(d.value);
          _this.$rootScope.$digest();
        });

        g.append('svg:rect').attr('x', '10px').attr('rx', li.r).attr('ry', li.r).attr('width', li.h) //"20px"//li.w)
        .attr('height', li.h).style('stroke', 'white').style('stroke-width', '1').style('fill', function (d) {
          return d.val;
        }).style('opacity', 1);

        g.append('svg:text').attr('x', li.h + 15).attr('y', li.h / 2).attr('dy', '0.35em').attr('width', li.w - li.h).attr('text-anchor', 'left').text(function (d) {
          return _measure.Measure.getMeasure(d.value.data, _this.aggregate.filter.measure);
        });
        // find max legend

        g.append('svg:text').attr('x', li.h + 10 + getLegendWidth(g)).attr('y', li.h / 2).attr('dy', '0.35em').attr('width', li.w - li.h).attr('text-anchor', 'left').text(function (d) {
          return d.value.text;
        });

        if (!_this.maxLegendWidth) _this.maxLegendWidth = getLegendWidth(g);
        _this.legendWidth = width / 3;

        var minLegendWidth = Math.max(_this.legendWidth, width - height);
        var fontMin = 6;
        var fontMax = 14;
        var font = 14;
        var k = (minLegendWidth - _this.maxLegendWidth / 2) / minLegendWidth;
        if (_this.maxLegendWidth > minLegendWidth) {
          if (k > 0) font = fontMin + (fontMax - fontMin) * k;else font = fontMin;
        }
        statLegend.style.fontSize = font + 'px';
      }

      // Take a 2-column CSV and transform it into a hierarchical structure suitable
      // for a partition layout. The first column is a sequence of step names, from
      // root to leaf, separated by hyphens. The second column is a count of how
      // often that sequence occurred.
      function buildHierarchy(csv) {
        if (!aggregate || !aggregate.filter || !aggregate.filter.drilldown) {
          return null;
        }
        var root = {
          name: 'root',
          children: []
        };

        dims = [];
        for (var i = 0; i < csv.length; i++) {
          var size = csv[i][_this.aggregate.filter.measure];
          var parts = [];

          var drills = aggregate.filter.drilldown;
          for (var j = 0; j < drills.length; j++) {
            dims.push({});
            var filter = _this.model.getCellFilter(drills[j], csv[i]);
            filter.data = size;
            if (!filter.label) {
              filter.label = gettext('Значение не указано');
            }
            // filter.label = `${filter.label} (${csv[i].percentage})`;
            if (dims[j][filter.label]) dims[j][filter.label].data += size;else dims[j][filter.label] = filter;
            if (totalSize) dims[j][filter.label].text = filter.label + ' (' + Math.round(dims[j][filter.label].data * 1000 / totalSize) / 10 + '%)';else dims[j][filter.label].text = filter.label;
            parts.push(filter);
          }
          var currentNode = root;
          for (var _j = 0; _j < parts.length; _j++) {
            var children = currentNode['children'];
            var _filter = parts[_j];
            var nodeName = _filter.label;
            var childNode = void 0;
            if (_j + 1 < parts.length) {
              // Not yet at the end of the sequence; move down the tree.
              var foundChild = false;
              for (var k = 0; k < children.length; k++) {
                if (children[k]['name'] === nodeName) {
                  childNode = children[k];
                  foundChild = true;
                  break;
                }
              }
              // If we don't already have a child node for this branch, create it.
              if (!foundChild) {
                childNode = {
                  name: nodeName,
                  filter: _filter,
                  children: []
                };
                children.push(childNode);
              }
              currentNode = childNode;
            } else {
              // Reached the end of the sequence; create a leaf node.
              childNode = {
                name: nodeName,
                filter: _filter,
                size: size
              };
              children.push(childNode);
            }
          }
        }

        var dim0 = dims[0];
        dim0 = Object.keys(dim0).sort(function (a, b) {
          return dim0[b].data - dim0[a].data;
        }).reduce(function (acc, k, i) {
          if (i < maxLegends - 1) {
            acc[k] = dim0[k];
            if (totalSize) acc[k].text = k + ' (' + Math.round(acc[k].data * 1000 / totalSize) / 10 + '%)';else acc[k].text = k;
          } else {
            if (!acc[other]) {
              acc[other] = dim0[k];
              acc[other].label = other;
            } else acc[other].data += dim0[k].data;
          }
          return acc;
        }, {});
        if (dim0[other]) {
          if (totalSize) dim0[other].text = other + ' (' + Math.round(dim0[other].data * 1000 / totalSize) / 10 + '%)';else dim0[other].text = other;
        }

        dims[0] = dim0;
        var color = [_d2.default.scale.category10(), function () {
          return '#0088cc';
        }];
        for (var di = 0; di < dims.length; di++) {
          var dim = dims[di];
          var index = 0;
          var single = Object.keys(dims[0]).length === 1;
          for (var d in dim) {
            if (single && di === 0 || !single && di > 0) colors[d] = color[1](index++ % 10);else colors[d] = color[0](index++ % 10);
          }
        }
        return root;
      }

      var json = buildHierarchy(aggregate.cells);
      if (json) createVisualization(json);
    }
  }, {
    key: 'aggregate',
    get: function get() {
      return this._aggregate;
    },
    set: function set(value) {
      this._aggregate = value;
      if (!this.legendWidth) {
        this.render();
        this.$timeout(this.render(), 0);
      } else this.render();
    }
  }]);

  return PieController;
}();

var PieComponent = exports.PieComponent = {
  template: __webpack_require__(929),
  bindings: {
    model: '<',
    filter: '<',
    aggregate: '<'
  },
  controller: PieController
};

/***/ }),
/* 928 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports = "<div class=\"stat-legend\"></div><div class=\"stat-sequence\"></div><div class=\"stat-chart\"></div>"

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _d = __webpack_require__(86);

var _d2 = _interopRequireDefault(_d);

var _measure = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeController = function () {
  function TreeController($scope, $element, rx, TreeService, LayoutService, CurrentModelService, RouterService) {
    var _this = this;

    _classCallCheck(this, TreeController);

    this.$element = $element;
    this.LayoutService = LayoutService;
    this.TreeService = TreeService;
    this.renderDebounce = 100;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;

    var subscriptions = [rx.Observable.merge(rx.Observable.merge($scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed'), $scope.$toObservable('$ctrl.aggregate')).debounce(this.renderDebounce), $scope.$eventToObservable('resizeBeforePrint'), $scope.$eventToObservable('afterPrint'), $scope.$eventToObservable('init')).map(function (e) {
      if (e.name === 'resizeBeforePrint' || _this.router.pdf && _this.router.CurrentFilterService.filter.isDashboard) _this.needCalcHeight = true;else _this.needCalcHeight = false;
    }).subscribe(function () {
      return _this.render();
    })];

    $scope.$on('$destroy', function () {
      return subscriptions.forEach(function (subscription) {
        return subscription.dispose();
      });
    });
  }

  _createClass(TreeController, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var aggregate = this.aggregate;

      //console.log("TREE", aggregate);

      this.$element.find('svg').remove();

      if (!aggregate || !this.aggregate.filter) {
        return;
      }

      var animate = !this.LayoutService.isPrint && !this.router.pdf;
      var profileChart = this.$element[0];
      // const root = this.getRoot(aggregate, this.aggregate.filter);
      var root = this.TreeService.getRoot(this.model, aggregate);

      var width = this.$element.width();
      var height = this.needCalcHeight ? this.TreeService.getRowsQuantity(root) * this.TreeService.oneRow : this.$element.height();

      root.x0 = height / 2;
      root.y0 = 0;

      var margin = {
        'left': 100,
        'top': 0
      };

      var i = 0;
      var duration = 750;

      var tree = _d2.default.layout.tree().size([height, width]);

      var diagonal = _d2.default.svg.diagonal().projection(function (d) {
        return [d.y, d.x];
      });

      var svg = _d2.default.select(profileChart).append('svg').attr('width', width).attr('height', height).append('g').attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      //d3.select(self.frameElement).style("height", "800px");

      var update = function update(source) {

        // Compute the new tree layout.
        var nodes = tree.nodes(root).reverse();
        var links = tree.links(nodes);

        // Normalize for fixed-depth.
        nodes.forEach(function (d) {
          d.y = d.depth * 180;
        });

        // Update the nodes…
        var node = svg.selectAll('g.node').data(nodes, function (d) {
          return d.id || (d.id = ++i);
        });

        if (animate) {
          // Enter any new nodes at the parent's previous position.
          var nodeEnter = node.enter().append('g').attr('class', 'node').attr('transform', function (d) {
            return 'translate(' + source.y0 + ',' + source.x0 + ')';
          }).on('click', click);

          nodeEnter.append('circle').attr('r', 1e-6).style('fill', function (d) {
            return d._children ? 'lightsteelblue' : '#fff';
          });

          nodeEnter.append('text').attr('x', function (d) {
            return d.children || d._children ? -10 : 10;
          }).attr('dy', '.35em').attr('text-anchor', function (d) {
            return d.children || d._children ? 'end' : 'start';
          }).text(function (d) {
            return d.name;
          }).style('fill-opacity', 1e-6);

          // Transition nodes to their new position.
          var nodeUpdate = node.transition().duration(duration).attr('transform', function (d) {
            return 'translate(' + d.y + ',' + d.x + ')';
          });

          nodeUpdate.select('circle').attr('r', 4.5).style('fill', function (d) {
            return d._children ? 'lightsteelblue' : '#fff';
          });

          nodeUpdate.select('text').style('fill-opacity', 1);

          // Transition exiting nodes to the parent's new position.
          var nodeExit = node.exit().transition().duration(duration).attr('transform', function (d) {
            return 'translate(' + source.y + ',' + source.x + ')';
          }).remove();

          nodeExit.select('circle').attr('r', 1e-6);

          nodeExit.select('text').style('fill-opacity', 1e-6);
        } else {
          // Enter any new nodes at the parent's previous position.
          var _nodeEnter = node.enter().append('g').attr('class', 'node').attr('transform', function (d) {
            return 'translate(' + d.y + ',' + d.x + ')';
          }).on('click', click);

          _nodeEnter.append('circle').attr('r', 4.5).style('fill', function (d) {
            return d._children ? 'lightsteelblue' : '#fff';
          });

          _nodeEnter.append('text').attr('x', function (d) {
            return d.children || d._children ? -10 : 10;
          }).attr('dy', '.35em').attr('text-anchor', function (d) {
            return d.children || d._children ? 'end' : 'start';
          }).text(function (d) {
            return d.name;
          }).style('fill-opacity', 1);
        }

        // Update the links…
        var link = svg.selectAll('path.node-link').data(links, function (d) {
          return d.target.id;
        });

        if (animate) {
          // Enter any new links at the parent's previous position.
          link.enter().insert('path', 'g')
          // .attr('class', 'node-link')
          .attr('style', 'fill: none; stroke: #ccc; stroke-width: 1.5px;').attr('d', function (d) {
            var o = {
              x: source.x0,
              y: source.y0
            };
            return diagonal({
              source: o,
              target: o
            });
          });

          // Transition links to their new position.
          link.transition().duration(duration).attr('d', diagonal);

          // Transition exiting nodes to the parent's new position.
          link.exit().transition().duration(duration).attr('d', function (d) {
            var o = {
              x: source.x,
              y: source.y
            };
            return diagonal({
              source: o,
              target: o
            });
          }).remove();
        } else {
          // Enter any new links at the parent's previous position.
          link.enter().insert('path', 'g').attr('class', 'node-link').attr('d', function (d) {
            return diagonal({
              source: {
                x: d.source.x,
                y: d.source.y
              },
              target: {
                x: d.target.x,
                y: d.target.y
              }
            });
          });
        }

        // Stash the old positions for transition.
        nodes.forEach(function (d) {
          d.x0 = d.x;
          d.y0 = d.y;
        });
      };

      function updateFast(source) {

        // Compute the new tree layout.
        var nodes = tree.nodes(root).reverse();
        var links = tree.links(nodes);

        // Normalize for fixed-depth.
        nodes.forEach(function (d) {
          d.y = d.depth * 180;
          // d.y = d.depth * 360;
        });

        // Update the nodes…
        var node = svg.selectAll('g.node').data(nodes, function (d) {
          return d.id || (d.id = ++i);
        });
        // Enter any new nodes at the parent's previous position.
        var nodeEnter = node.enter().append('g').attr('class', 'node').attr('transform', function (d) {
          return 'translate(' + d.y + ',' + d.x + ')';
        }).on('click', click);

        nodeEnter.append('circle').attr('r', 4.5).style('fill', function (d) {
          return d._children ? 'lightsteelblue' : '#fff';
        });

        nodeEnter.append('text').attr('x', function (d) {
          return d.children || d._children ? -10 : 10;
        }).attr('dy', '.35em').attr('text-anchor', function (d) {
          return d.children || d._children ? 'end' : 'start';
        }).text(function (d) {
          return d.name;
        }).style('fill-opacity', 1);

        // Update the links…
        var link = svg.selectAll('path.node-link').data(links, function (d) {
          return d.target.id;
        });

        // Enter any new links at the parent's previous position.
        link.enter().insert('path', 'g').attr('class', 'node-link').attr('d', function (d) {
          return diagonal({
            source: {
              x: d.source.x,
              y: d.source.y
            },
            target: {
              x: d.target.x,
              y: d.target.y
            }
          });
        });
      }

      var drilldown = function drilldown(drill, cell) {
        var neddDelete = !drill;
        var cuts = [];

        var _loop = function _loop(_i) {
          var drilldown = _this2.aggregate.filter.drilldown[_i];

          var cut = cell ? _this2.CurrentModelService.model.getCellFilter(drilldown, cell) : _this2.router.CurrentFilterService.filter.filters.find(function (fCut) {
            return fCut.dimension === drilldown;
          });
          if (neddDelete) window.removeCut(cut);else cuts.push(cut);
          if (drill === drilldown) {
            neddDelete = true;
          }
        };

        for (var _i = 0; _i < _this2.aggregate.filter.drilldown.length; ++_i) {
          _loop(_i);
        }
        _this2.RouterService.drilldownCuts(cuts);
      };

      // Toggle children on click.
      function click(d) {
        drilldown(d.dd, d.cell);
      }

      update(root);
    }
  }]);

  return TreeController;
}();

var TreeComponent = exports.TreeComponent = {
  template: '',
  bindings: {
    model: '<',
    aggregate: '<'
  },
  controller: TreeController
};

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _measure = __webpack_require__(39);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TreeService = exports.TreeService = function () {
  function TreeService() {
    _classCallCheck(this, TreeService);

    this.oneRow = 15;
  }

  _createClass(TreeService, [{
    key: 'getRoot',
    value: function getRoot(model, aggregate) {
      var rows = aggregate.cells.map(function (cell, c) {
        cell.rowIndex = c;
        return aggregate.filter.drilldown.map(function (dd, d) {
          var measureLabel = _measure.Measure.getMeasure(cell, aggregate.filter.measure);
          var field = model.getCellLabel(dd, cell);
          if (cell.record_count && aggregate.filter.drilldown[aggregate.filter.drilldown.length - 1] === dd) {
            field = field + ' (' + measureLabel + ')';
          }
          return {
            name: field,
            dd: dd,
            cell: cell
          };
        });
      });

      // console.log("ROWS", rows);

      var children = aggregate.cells.map(function (cell) {
        return {
          'name': model.getCellLabel(aggregate.filter.drilldown[0], cell)
        };
      });

      var root = {
        'name': gettext('Все события'),
        'children': []
      };

      var updateTree = function updateTree(node, row) {
        if (!row[0]) return;
        var child = node.children.find(function (child) {
          return child.name === row[0].name;
        });
        if (!child) {
          child = {
            'name': row[0].name,
            'dd': row[0].dd,
            'cell': row[0].cell,
            'children': []
          };
          node.children.push(child);
        }
        updateTree(child, row.splice(1));
      };

      rows.forEach(function (row) {
        return updateTree(root, row);
      });

      //console.log("ROOT", root);

      function collapse(d) {
        if (d.children) {
          d._children = d.children;
          d._children.forEach(collapse);
          d.children = null;
        }
      }

      //root.children.forEach(collapse);
      return root;
    }
  }, {
    key: 'getRowsQuantity',
    value: function getRowsQuantity(root) {
      var calc = 0;
      var iter = function iter(el) {
        if (!el.children || !el.children.length) {
          calc += 1;
          return;
        }
        el.children.map(function (ch) {
          iter(ch);
        });
      };
      iter(root);
      return calc;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(model, data) {
      return this.getRowsQuantity(this.getRoot(model, data)) * this.oneRow;
    }
  }]);

  return TreeService;
}();

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _chartBuilder = __webpack_require__(933);

__webpack_require__(150);

var _datetime = __webpack_require__(61);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/line';

/*@ngInject*/

var maxXDataStingLenght = 77;
var oneCharacterWidth = 6;

var ChartController = function () {
  function ChartController($scope, $element, RouterService, LayoutService, rx) {
    var _this = this;

    _classCallCheck(this, ChartController);

    this.$scope = $scope;
    this.$element = $element;
    this.router = RouterService;
    this.currentFilter = this.router.CurrentFilterService.filter;
    this.LayoutService = LayoutService;
    this.container = null;
    this.chart = null;
    this.chartType = 'bar';
    this.LayoutService.drilldownMax = 2;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.aggregate = null;
    this.filter = null;

    var subscriptions = [rx.Observable.merge($scope.$eventToObservable('resizeBeforePrint'), rx.Observable.merge($scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(100)).subscribe(function () {
      _this.resize();
    }), rx.Observable.merge(rx.Observable.merge($scope.$toObservable('$ctrl.filter.orders'), $scope.$toObservable('$ctrl.filter.orderDirs'), $scope.$toObservable('$ctrl.aggregate')).debounce(this.renderDebounce)
    // $scope.$eventToObservable('beforePrint'),
    // $scope.$eventToObservable('afterPrint'),
    // $scope.$eventToObservable('init'),
    ).subscribe(function (e) {
      _this.render(e);
    })];
    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (subscription) {
        subscription.dispose();
      });
    });
  }

  _createClass(ChartController, [{
    key: 'labelRotate',
    value: function labelRotate(len) {
      var w = this.container.clientWidth / len;
      var d = 20;
      if (d > w) return -90;
      if (w >= this.xDataWidth) return 0;
      return -Math.asin(d / w) * 180 / Math.PI;
    }
  }, {
    key: 'gridHeight',
    value: function gridHeight(len) {
      var h = this.xDataWidth * Math.abs(Math.sin(Math.PI / 180 * this.labelRotate(len)));
      return this.container.clientHeight - h - 120;
    }
  }, {
    key: 'resize',
    value: function resize() {
      if (this.chart.chart.bar) this.chart.chart.bar.option.animation = !this.isPrint;
      if (this.chart && this.$element.height() > this.minHeight && this.$element.width() > this.minWidth) {
        this.chart._option.xAxis[0].axisLabel.rotate = this.labelRotate(this.chart.getOption().xAxis[0].data.length);
        this.chart._option.grid.height = this.gridHeight(this.chart.getOption().xAxis[0].data.length);
        this.chart.resize();
      }
    }
  }, {
    key: 'render',
    value: function render(e) {
      var _this2 = this;

      if (!this.aggregate || !this.filter) {
        return;
      }

      if (this.$element.height() <= this.minHeight || this.$element.width() <= this.minWidth) {
        return;
      }

      var builder = new _chartBuilder.ChartBuilder(this.aggregate, this.filter, this.filter.chartAreaType, this.filter.chartAreaIsStacked === undefined ? true : this.filter.chartAreaIsStacked, this.model);
      builder.build();

      var maxLen = 0;
      builder.xData = builder.xData.map(function (d) {
        var s = String(d);
        var l = s.length;
        if (l > maxXDataStingLenght) {
          s = s.substr(0, maxXDataStingLenght) + '...';
        }
        if (s.length > maxLen) maxLen = s.length;
        return s;
      });
      this.xDataWidth = maxLen * oneCharacterWidth;

      var axisLabelFormatter = this.filter.measure === 'activity_time_sum' ? function (value) {
        return (0, _datetime.hoursToTime)(value);
      } : function (value) {
        return value;
      };

      this.container = this.$element[0];
      this.chart = echarts.init(this.container);
      var options = {
        // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
        tooltip: {
          trigger: 'item',
          formatter: this.filter.measure === 'activity_time_sum' ? function (params) {
            return params.name + '<br/>' + (0, _datetime.ticksFormat)(params.value * _datetime.ticksToHours);
          } : null
        },
        toolbox: {
          show: !this.isPrint,
          feature: {
            magicType: {
              show: true,
              type: ['bar', 'line', 'tiled', 'stack'],
              title: {
                bar: gettext('Гистограмма'),
                line: gettext('Линейный График'),
                tiled: gettext('Без накопления'),
                stack: gettext('С накоплением')
              }
            },
            // restore: {show: true},
            saveAsImage: {
              show: true,
              title: gettext('Сохранить'),
              lang: [gettext('Нажмите кнопку [Сохранить]')]
            }
          }
        },
        noDataLoadingOption: {
          text: gettext('Нет данных.\nВыберите пользователей, либо измените параметры фильтра.'),
          effect: 'bubble'
        },
        // calculable : true,
        dataZoom: {
          show: !this.isPrint,
          realtime: true,
          start: 0,
          end: 100
        },
        legend: {
          // type: 'scroll',
          show: true,
          data: builder.legendData,
          display: true,
          y: 25,
          orient: 'horizontal',
          textStyle: {
            fontFamily: 'arial', // 'sans-serif',
            fontSize: 10,
            fontWeight: 'lighter'
          }
        },
        grid: {
          height: this.gridHeight(builder.xData.length)
        },
        xAxis: [{
          type: 'category',
          axisLabel: {
            show: true,
            interval: 0,
            rotate: this.labelRotate(builder.xData.length)
          },
          data: builder.xData
        }],
        yAxis: [{
          type: 'value',
          splitArea: {
            show: true
          },
          axisLabel: {
            formatter: axisLabelFormatter
          }
        }],
        series: builder.yData,
        animation: !this.isPrint,
        addDataAnimation: !this.isPrint
      };
      this.chart.setOption(options);
      this.chart.on('magicTypeChanged', function (e) {
        var magicType = e.magicType;

        if (magicType.bar) {
          // if (this.router.isFilterEditModal)
          _this2.filter.chartAreaType = 'bar';
          // else
          // this.router.chartAreaType = 'bar';
        }
        if (magicType.line) {
          // if (this.router.isFilterEditModal)
          _this2.filter.chartAreaType = 'line';
          // else this.router.chartAreaType = 'line';
        }
        // if (this.router.isFilterEditModal)
        _this2.filter.chartAreaIsStacked = !!e.magicType.stack;
        // else this.router.chartAreaIsStacked = !!e.magicType.stack;

        if (_this2.router.isFilterEditModal) _this2.filterData.update(_this2.filter);else {
          _this2.router.filter = _this2.filter;
          _this2.$scope.$root.$digest();
        }
      });

      var addCutToFilter = function addCutToFilter(filter, cut) {
        filter.filters.push({
          label: cut.label,
          dimension: cut.dimension,
          value: cut.value
        });
      };

      this.chart.on('click', function (e) {
        if (!_this2.filter.drilldown.length) return;
        var filter = angular.copy(_this2.filter);
        if (_this2.filter.drilldown.length > 0) {
          var filterValue = builder.filterValues[e.dataIndex];
          addCutToFilter(filter, filterValue);
          // this.router.drilldownFilter(filterValue);
        }
        if (_this2.filter.drilldown.length > 1) {
          var _filterValue = builder.filterYValues[e.seriesIndex];
          addCutToFilter(filter, _filterValue);
          // this.router.drilldownFilter(filterValue);
        }
        filter.mode = 'explore';
        _this2.router.filter = filter;
        _this2.$scope.$root.$digest();
      });
      this.chart.resize();
    }
  }, {
    key: 'isPrint',
    get: function get() {
      return this.router.pdf || this.LayoutService.isPrint;
    }
  }]);

  return ChartController;
}();

var ChartComponent = exports.ChartComponent = {
  template: __webpack_require__(934),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<'
  },

  controller: ChartController
};

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChartBuilder = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

var _datetime = __webpack_require__(61);

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChartBuilder = exports.ChartBuilder = function () {
  function ChartBuilder(aggregate, filter, chartType, chartAreaIsStacked, model) {
    _classCallCheck(this, ChartBuilder);

    this.aggregate = aggregate;
    this.filter = filter;
    this.chartType = chartType;
    this.chartAreaIsStacked = chartAreaIsStacked;
    this.model = model;
  }

  _createClass(ChartBuilder, [{
    key: 'reset',
    value: function reset() {
      this.xData = [];
      this.yData = [];
      this.legendData = [];
      this.filterValues = [];
      this.filterYValues = [];
    }
  }, {
    key: 'build',
    value: function build() {
      this.reset();
      if (!this.aggregate || !this.aggregate.filter || !this.aggregate.filter.drilldown || !this.aggregate.filter.drilldown.length || !this.aggregate.cells || !this.aggregate.cells.length) {
        return;
      }
      var isSingleDim = this.filter.drilldown.length === 1;
      if (isSingleDim && !this.shouldSortDimension(this.filter.drilldown[0])) {
        this.legendData = [''];
        this.buildChartSingleDim();
      } else {
        this.buildChartData();
      }
    }

    /**
     * single dimension case
     */

  }, {
    key: 'buildChartSingleDim',
    value: function buildChartSingleDim() {
      var _this = this;

      var drill = this.filter.drilldown[0];
      this.filterValues = this.aggregate.cells.map(function (cell) {
        return _this.model.getCellFilter(drill, cell);
      });
      this.xData = this.filterValues.map(function (filter) {
        return filter.label || '';
      });
      this.yData = [{
        name: '',
        type: this.chartType,
        stack: this.chartAreaIsStacked,
        data: this.aggregate.cells.map(function (cell) {
          return _this.getMeasureValue(cell);
        })
      }];
    }
  }, {
    key: 'buildChartData',
    value: function buildChartData() {
      this.yKeysSet = {};
      var data = this.buildData();
      if (!data) {
        return;
      }

      this.buildXData(data);
      this.buildYData(data);
    }
  }, {
    key: 'buildXData',


    /**
     * xData builder
     * @returns {undefined}
     */
    value: function buildXData(data) {
      var xDim = this.filter.drilldown[0];
      if (_filter.Filter.isTimeDimension(xDim)) {
        this.buildTimeLine(xDim, data);
        this.sortKeys(xDim, this.xData, data);
      } else {
        this.xData = Object.keys(data);
        this.sortKeys(xDim, this.xData, data);
        this.filterValues = this.xData.map(function (key) {
          return {
            value: data[key].value,
            label: key,
            dimension: xDim
          };
        });
      }
    }

    /**
     * yData builder
     */

  }, {
    key: 'limitString',
    value: function limitString(str) {
      // const maxLen = 15;
      // if (str.length && str.length > maxLen) return `${str.substring(0, maxLen)}...`;
      return str;
    }
  }, {
    key: 'buildYData',
    value: function buildYData(data) {
      var _this2 = this;

      if (this.isSingleDim) {
        this.legendData = [''];
        var values = this.xData.map(function (key) {
          return (data[key] || {
            data: 0
          }).data;
        });
        this.yData = [{
          name: '',
          type: this.chartType,
          stack: this.chartAreaIsStacked,
          data: values
        }];
      } else {
        var yDim = this.filter.drilldown[1];
        var yKeys = Object.keys(this.yKeysSet);
        this.sortKeys(yDim, yKeys, this.yKeysSet);
        this.legendData = yKeys;
        this.filterYValues = yKeys.map(function (key) {
          return _this2.yKeysSet[key];
        });
        var yValues = this.xData.map(function (key) {
          return (data[key] || {
            data: {}
          }).data;
        });
        this.yData = yKeys.map(function (yKey) {
          var accData = 0;
          var values = yValues.map(function (yValue) {
            var val = yValue[yKey] || 0;
            accData += val;
            return val;
          });
          // this.yKeysSet[yKey].accData = accData;
          return {
            name: yKey,
            type: _this2.chartType,
            stack: _this2.chartAreaIsStacked,
            data: values,
            accData: accData
          };
        });
        // this.sortKeys(yDim, yKeys, this.yKeysSet);
      }
    }

    /**
     * aggregate data object
     * @returns {undefined | Object.<string, {value: *, data: Object.<string, *>}>}
     */

  }, {
    key: 'buildData',
    value: function buildData() {
      var data = {};

      var cells = this.aggregate.cells;
      for (var i = 0; i < cells.length; i++) {

        var cell = cells[i];
        var size = this.getMeasureValue(cell);
        var drills = this.filter.drilldown;
        var xFilter = this.model.getCellFilter(drills[0], cell);
        var xlabel = xFilter.label || xFilter.value;
        if (drills.length === 1) {
          data[xlabel] = {
            value: xFilter.value,
            data: size,
            accData: size
          };
          continue;
        }
        var yFilter = this.model.getCellFilter(drills[1], cell);
        var xFilterData = data[xlabel];
        if (!xFilterData) {
          xFilterData = {
            value: xFilter.value,
            data: {},
            filter: xFilter,
            accData: 0
          };
          data[xlabel] = xFilterData;
        }
        var ylabel = this.limitString(yFilter.label || yFilter.value);
        var value = size + (xFilterData.data[ylabel] || 0);
        xFilterData.data[ylabel] = value;
        xFilterData.accData += value;
        value = size + (this.yKeysSet[ylabel] && this.yKeysSet[ylabel].accData ? this.yKeysSet[ylabel].accData : 0);
        this.yKeysSet[ylabel] = yFilter;
        this.yKeysSet[ylabel].accData = value;
      }

      return data;
    }

    /**
     * build linear time-line
     */

  }, {
    key: 'buildTimeLine',
    value: function buildTimeLine(dim, data) {
      var startDate = typeof this.aggregate.filter.timeFrom === 'string' ? new Date(this.aggregate.filter.timeFrom) : this.aggregate.filter.timeFrom;
      var endDate = typeof this.aggregate.filter.timeTo === 'string' ? new Date(this.aggregate.filter.timeTo) : this.aggregate.filter.timeTo;

      var count = endDate.getTime() - startDate.getTime();
      var timeGetter = void 0;
      var timeSetter = void 0;
      var dimParts = this.model.getDimensionParts(dim);
      var level = dimParts.hierarchy.levels.length;
      var quantity = dimParts.hierarchy.levels[level - 1];
      switch (quantity) {
        case 'minute':
          timeGetter = Date.prototype.getMinutes;
          timeSetter = Date.prototype.setMinutes;
          count = Math.floor(count / (60 * 1000));
          break;
        case 'hour':
          timeGetter = Date.prototype.getHours;
          timeSetter = Date.prototype.setHours;
          count = Math.floor(count / (60 * 60 * 1000));
          break;
        case 'day':
          timeGetter = Date.prototype.getDate;
          timeSetter = Date.prototype.setDate;
          count = Math.floor(count / (24 * 60 * 60 * 1000));
          break;
        case 'month':
          timeGetter = Date.prototype.getMonth;
          timeSetter = Date.prototype.setMonth;
          count = 12 * (endDate.getFullYear() - startDate.getFullYear()) + endDate.getMonth() - startDate.getMonth();
          break;
        case 'year':
          timeGetter = Date.prototype.getFullYear;
          timeSetter = Date.prototype.setFullYear;
          count = endDate.getYear() - startDate.getYear();
          break;
        default:
          console.error(quantity, 'is unknown time line quantity, use day by default');
          timeGetter = Date.prototype.getDate;
          timeSetter = Date.prototype.setDate;
          count = Math.floor(count / (24 * 60 * 60 * 1000));
          break;
      }
      count++;

      // trim left

      var date = new Date(startDate.getTime());
      while (!data[this.getTimeLabel(date, level)] && count) {
        timeSetter.call(date, timeGetter.call(date) + 1);
        --count;
      }

      // trim right

      var edate = new Date(endDate.getTime());
      while (count && !data[this.getTimeLabel(edate, level)]) {
        timeSetter.call(edate, timeGetter.call(edate) - 1);
        --count;
      }

      // build

      this.xData = new Array(count);
      for (var i = 0; i < count; ++i) {
        this.xData[i] = this.getTimeLabel(date, level);
        var label = this.xData[i];
        this.filterValues[i] = {
          dimension: dim,
          label: label,
          value: this.getTimeValue(date, level)
        };
        timeSetter.call(date, timeGetter.call(date) + 1);
      }
    }

    /**
     * convert date to string like '2016,10,11'
     * @param {Date} date
     * @param {number} level
     */

  }, {
    key: 'getTimeValue',
    value: function getTimeValue(date, level) {
      return _filter.Filter.valueForTime(date, level, true);
    }

    /**
     * format time regarding dimension levels
     * @param {Date} date
     * @param {number} level
     */

  }, {
    key: 'getTimeLabel',
    value: function getTimeLabel(date, level) {
      return _filter.Filter.labelForTime(date, level);
    }

    /**
     * sort keys array
     * @param {string} dim dimension string
     * @param {string[]} keys keys array to sort
     * @param {Object.<string, {value: *}>} values
     */
    // sortKeys1(dim, keys, values) {
    //   if (Filter.isTimeDimension(dim)) {
    //     // Convert time values to number,
    //     // in order to optimize sorting
    //     // values = this.filterValues;
    //     keys.forEach(key => {
    //
    //       const value = values[key].value;
    //       // values[key].timeValue = value.split(',')
    //       values[key].timeValue = value.split(PATH_STRING_SEPARATOR)
    //         .reduce((prev, cur) => 100 * prev + Number(cur), 0);
    //     });
    //   } else if (dim === 'agent_time@weekday:weekday') {
    //     keys.forEach((key) => {
    //       values[key].timeValue = WEEKDAYS.indexOf(key);
    //     });
    //   } else if (dim === 'agent_time@hour:hour') {
    //     keys.forEach((key) => {
    //       values[key].timeValue = Number(key);
    //     });
    //   }
    //   keys.sort(this.compareFilter(dim, values));
    // }


  }, {
    key: 'sortKeys',
    value: function sortKeys(dim, keys, values) {
      var _this3 = this;

      if (_filter.Filter.isTimeDimension(dim)) {
        // Convert time values to number,
        // in order to optimize sorting
        // values = this.filterValues;
        keys.forEach(function (key) {
          var valueFata = values[key];
          if (!valueFata) valueFata = _this3.filterValues.find(function (fv) {
            return fv.label === key;
          });
          var value = valueFata.value;
          // values[key].timeValue = value.split(',')
          valueFata.timeValue = value.split(_config.PATH_STRING_SEPARATOR).reduce(function (prev, cur) {
            return 100 * prev + Number(cur);
          }, 0);
        });
      } else if (dim === 'agent_time@weekday:weekday') {
        keys.forEach(function (key) {
          values[key].timeValue = _datetime.WEEKDAYS.indexOf(key);
        });
      } else if (dim === 'agent_time@hour:hour') {
        keys.forEach(function (key) {
          values[key].timeValue = Number(key);
        });
      }
      keys.sort(this.compareFilter(dim, values));
    }

    /**
     * returns comparator for sorting
     * @param {string} dim dimension string
     * @param {Object.<string, {value: *}>} values
     * @returns {function} | {undefined}
     */

  }, {
    key: 'compareFilter',
    value: function compareFilter(dim, values) {
      var _this4 = this;

      var sortType = this.shouldSortDimension(dim);
      var isDataEquial = function isDataEquial(a, b) {
        return (values[a] && values[a].accData ? values[a].accData : 0) === (values[b] && values[b].accData ? values[b].accData : 0);
      };

      // const ascDim_Time = (a, b) => values[a].timeValue - values[b].timeValue;
      var ascDim_Time = function ascDim_Time(a, b) {
        var aVal = values[a];
        if (!aVal) aVal = _this4.filterValues.find(function (fv) {
          return fv.label === a;
        });
        var bVal = values[b];
        if (!bVal) bVal = _this4.filterValues.find(function (fv) {
          return fv.label === b;
        });

        aVal.timeValue - bVal.timeValue;
      };
      var descDim_Time = function descDim_Time(a, b) {
        return ascDim_Time(b, a);
      };
      var ascDim = function ascDim(a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      };
      var descDim = function descDim(a, b) {
        return ascDim(b, a);
      };

      var ascMeasure = function ascMeasure(a, b) {
        return (values[a] && values[a].accData ? values[a].accData : 0) - (values[b] && values[b].accData ? values[b].accData : 0);
      };
      var descMeasure = function descMeasure(a, b) {
        return ascMeasure(b, a);
      };

      var ascMeasure_ascDim = function ascMeasure_ascDim(a, b) {
        if (isDataEquial(a, b)) return ascDim(a, b);
        return ascMeasure(a, b);
      };
      var descMeasure_ascDim = function descMeasure_ascDim(a, b) {
        if (isDataEquial(a, b)) return ascDim(a, b);
        return descMeasure(a, b);
      };
      var ascMeasure_descDim = function ascMeasure_descDim(a, b) {
        return descMeasure_ascDim(b, a);
      };
      var descMeasure_descDim = function descMeasure_descDim(a, b) {
        return ascMeasure_ascDim(b, a);
      };

      var ascMeasure_ascDim_Time = function ascMeasure_ascDim_Time(a, b) {
        if (isDataEquial(a, b)) return ascDim_Time(a, b);
        return ascMeasure(a, b);
      };
      var descMeasure_ascDim_Time = function descMeasure_ascDim_Time(a, b) {
        if (isDataEquial(a, b)) return ascDim_Time(a, b);
        return descMeasure(a, b);
      };

      var ascMeasure_descDim_Time = function ascMeasure_descDim_Time(a, b) {
        return descMeasure_ascDim_Time(b, a);
      };
      var descMeasure_descDim_Time = function descMeasure_descDim_Time(a, b) {
        return ascMeasure_ascDim_Time(b, a);
      };

      var ascDim_ascMeasure = function ascDim_ascMeasure(a, b) {
        return a === b ? ascMeasure(a, b) : ascDim(a, b);
      };
      var descDim_ascMeasure = function descDim_ascMeasure(a, b) {
        return a === b ? ascMeasure(a, b) : descDim(a, b);
      };
      var ascDim_descMeasure = function ascDim_descMeasure(a, b) {
        return a === b ? descMeasure(a, b) : ascDim(a, b);
      };
      var descDim_descMeasure = function descDim_descMeasure(a, b) {
        return a === b ? descMeasure(a, b) : descDim(a, b);
      };

      var ascDim_ascMeasure_Time = function ascDim_ascMeasure_Time(a, b) {
        return values[a].timeValue === values[b].timeValue ? ascMeasure(a, b) : ascDim_Time(a, b);
      };
      var descDim_ascMeasure_Time = function descDim_ascMeasure_Time(a, b) {
        return values[a].timeValue === values[b].timeValue ? ascMeasure(a, b) : descDim_Time(a, b);
      };
      var ascDim_descMeasure_Time = function ascDim_descMeasure_Time(a, b) {
        return values[a].timeValue === values[b].timeValue ? descMeasure(a, b) : ascDim_Time(a, b);
      };
      var descDim_descMeasure_Time = function descDim_descMeasure_Time(a, b) {
        return values[a].timeValue === values[b].timeValue ? descMeasure(a, b) : descDim_Time(a, b);
      };

      var compareRules = {
        ascDim: ascDim,
        descDim: descDim,
        ascDim_Time: ascDim_Time,
        descDim_Time: descDim_Time,

        ascMeasure: ascMeasure,
        descMeasure: descMeasure,
        ascMeasure_Time: ascMeasure,
        descMeasure_Time: descMeasure,

        ascMeasure_ascDim: ascMeasure_ascDim,
        descMeasure_ascDim: descMeasure_ascDim,
        ascMeasure_descDim: ascMeasure_descDim,
        descMeasure_descDim: descMeasure_descDim,

        ascMeasure_ascDim_Time: ascMeasure_ascDim_Time,
        descMeasure_ascDim_Time: descMeasure_ascDim_Time,
        ascMeasure_descDim_Time: ascMeasure_descDim_Time,
        descMeasure_descDim_Time: descMeasure_descDim_Time,

        ascDim_ascMeasure: ascDim_ascMeasure,
        descDim_ascMeasure: descDim_ascMeasure,
        ascDim_descMeasure: ascDim_descMeasure,
        descDim_descMeasure: descDim_descMeasure,

        ascDim_ascMeasure_Time: ascDim_ascMeasure_Time,
        descDim_ascMeasure_Time: descDim_ascMeasure_Time,
        ascDim_descMeasure_Time: ascDim_descMeasure_Time,
        descDim_descMeasure_Time: descDim_descMeasure_Time,

        '': function _(a, b) {
          return 0;
        }
      };
      // console.log(sortType, compareRules[sortType]);
      return compareRules[sortType] || compareRules[''];
    }
  }, {
    key: 'getOrderColumnName',
    value: function getOrderColumnName(drill) {
      var dimension = this.model.getDimensionParts(drill);
      return dimension.dimension.name + '.' + dimension.level.label_attribute;
    }
  }, {
    key: 'shouldSortDimension',
    value: function shouldSortDimension(dim) {
      var _this5 = this;

      var orderDir = '';
      var oName = this.getOrderColumnName(dim);

      if (this.filter && this.filter.orders.length) {
        this.filter.orders.map(function (d, i) {
          if (d === oName) {
            if (orderDir) orderDir += '_';
            orderDir += _this5.filter.orderDirs[i] + 'Dim';
          }
          if (d === 'measure') {
            if (orderDir) orderDir += '_';
            orderDir += _this5.filter.orderDirs[i] + 'Measure';
          }
        });
        // const i = this.filter.orders.findIndex(d => d === oName);
        // if (i !== -1) orderDir = this.filter.orderDirs[i];
      }

      if (_filter.Filter.isTimeDimension(dim) || dim === 'agent_time@weekday:weekday' || dim === 'agent_time@hour:hour') orderDir += '_Time';
      return orderDir;
    }
  }, {
    key: 'getMeasureValue',
    value: function getMeasureValue(cell) {
      var name = this.filter.measure;
      var val = (typeof cell === 'undefined' ? 'undefined' : _typeof(cell)) === 'object' ? cell && cell[name] || 0 : cell;
      if (name === 'activity_time_sum') {
        return val / _datetime.ticksToHours;
      } else if (name === 'call_duration_sum') {
        return Math.floor(val / 60);
      } else {
        return val;
      } //bytesToHuman(val, true );
    }
  }, {
    key: 'isSingleDim',
    get: function get() {
      return this.filter.drilldown.length === 1;
    }
  }]);

  return ChartBuilder;
}();

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports = ""

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadarComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(150);

var _measure = __webpack_require__(39);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {
//   hoursToTime,
//   ticksFormat,
//   ticksToHours
// } from '../../common/datetime';

// import echarts from 'echarts/lib/echarts'
// import 'echarts/lib/chart/bar';
// import 'echarts/lib/chart/line';

/*@ngInject*/
var RadarController = function () {
  RadarController.$inject = ["$scope", "$element", "$timeout", "RouterService", "LayoutService", "rx"];
  function RadarController($scope, $element, $timeout, RouterService, LayoutService, rx) {
    var _this = this;

    _classCallCheck(this, RadarController);

    this.$scope = $scope;
    this.$element = $element;
    this.router = RouterService;
    this.LayoutService = LayoutService;
    this.LayoutService.drilldownMax = 2;
    this.getMeasure = _measure.Measure.getMeasure;
    this.container = null;
    this.chart = null;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.drill1Limit = 20;
    this.drill2Limit = 30;
    this.aggregate = null;
    this.filter = null;

    var subscriptions = [rx.Observable.merge($scope.$eventToObservable('resizeBeforePrint'), rx.Observable.merge($scope.$eventToObservable('afterPrint'), $scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(this.renderDebounce)).subscribe(function () {
      return _this.resize();
    }), rx.Observable.merge(
    // $scope.$eventToObservable('beforePrint'),
    rx.Observable.merge($scope.$toObservable('$ctrl.filter.orders'), $scope.$toObservable('$ctrl.filter.orderDirs'), $scope.$toObservable('$ctrl.aggregate')).debounce(this.renderDebounce)).subscribe(function (e) {
      return _this.render(e);
    })];

    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (subscription) {
        subscription.dispose();
      });
      _this.LayoutService.drilldownMax = 0;
    });
  }

  _createClass(RadarController, [{
    key: 'resize',
    value: function resize() {
      if (this.chart && this.$element.height() > this.minHeight && this.$element.width() > this.minWidth) {
        this.chart.resize();
      }
    }
  }, {
    key: 'getSortPredicate',
    value: function getSortPredicate(sortName, data) {
      var sortPredicates = {
        drill1_asc: function drill1_asc(a, b) {
          return a < b ? 1 : -1;
        },
        drill1_desc: function drill1_desc(a, b) {
          return a > b ? 1 : -1;
        },
        drill1_measure_asc: function drill1_measure_asc(a, b) {
          return data.drill1[a] - data.drill1[b];
        },
        drill1_measure_desc: function drill1_measure_desc(a, b) {
          return data.drill1[b] - data.drill1[a];
        },
        drill2_asc: function drill2_asc(a, b) {
          return a > b ? 1 : -1;
        },
        drill2_desc: function drill2_desc(a, b) {
          return a < b ? 1 : -1;
        },
        drill2_measure_asc: function drill2_measure_asc(a, b) {
          return data.drill2[a].summ - data.drill2[b].summ;
        },
        drill2_measure_desc: function drill2_measure_desc(a, b) {
          return data.drill2[b].summ - data.drill2[a].summ;
        }
      };
      return sortPredicates[sortName];
    }
  }, {
    key: 'getDrillSortKey',
    value: function getDrillSortKey(prefix, drill) {
      var index = this.filter.orders.indexOf(this.model.getDrillAttr(drill));
      var indexMeasure = this.filter.orders.indexOf('measure');
      if (index !== -1 && (indexMeasure === -1 || index < indexMeasure)) {
        if (this.filter.orderDirs && this.filter.orderDirs[index]) return prefix + '_' + this.filter.orderDirs[index];
        return prefix + '_asc';
      }
      if (indexMeasure !== -1 && (index === -1 || index > indexMeasure)) {
        if (this.filter.orderDirs && this.filter.orderDirs[indexMeasure]) return prefix + '_measure_' + this.filter.orderDirs[indexMeasure];
      }
      return prefix + '_measure_desc';
    }
  }, {
    key: 'limitTo40',
    value: function limitTo40(s) {
      return s.length > 40 ? s.substring(0, 40) + '...' : s;
    }
  }, {
    key: 'updateOptions',
    value: function updateOptions(options) {
      var _this2 = this;

      var getValue = function getValue(cell) {
        if (_this2.filterData.filter.measure === 'activity_time_sum' || _this2.filterData.filter.measure === 'call_duration_sum') return cell[_this2.filterData.filter.measure];
        return cell.record_count;
      };

      var drill1 = this.filterData.filter.drilldown[0];
      var drill2 = this.filterData.filter.drilldown[1] ? this.filterData.filter.drilldown[1] : this.filterData.filter.drilldown[0];
      if (drill2 === drill1) {
        options.title.text = this.model.getDrillLabel(drill2);
        options.title.subtext = '';
      } else {
        options.title.text = this.model.getDrillLabel(drill2) + ' -> ' + this.model.getDrillLabel(drill1);
        options.title.subtext = '';
      }

      // collecting data
      var data = this.filterData.filterData.cells.reduce(function (data, cell) {
        var keyDrill1 = _this2.model.getCellLabel(drill1, cell);
        var keyDrill2 = _this2.limitTo40(_this2.model.getCellLabel(drill2, cell));
        var value = getValue(cell);
        if (drill2 !== drill1) {
          if (!(keyDrill2 in data.drill2)) data.drill2[keyDrill2] = {
            values: {},
            summ: 0
          };
          data.drill2[keyDrill2].values[keyDrill1] = value;
          data.drill2[keyDrill2].summ += value;
        }
        if (!(keyDrill1 in data.drill1)) data.drill1[keyDrill1] = value;
        if (data.drill1[keyDrill1] < value) data.drill1[keyDrill1] = value;
        return data;
      }, {
        maxValue: 0,
        drill2: {},
        drill1: {}
      });
      if (drill2 === drill1) {
        data.drill2 = _defineProperty({}, options.title.text, {
          values: angular.copy(data.drill1),
          summ: Object.keys(data.drill1).reduce(function (s, v) {
            return s += data.drill1[v];
          }, 0)
        });
      }

      // cat data up to top drill1Limit itims
      var keyOther = gettext('Другое');
      if (Object.keys(data.drill1).length > this.drill1Limit) {
        var _drill1Arr = Object.keys(data.drill1);
        // drill1ArrCutted[this.dril2Limit] = keyOther;
        var _drill = _drill1Arr.sort(function (a, b) {
          return data.drill1[b] - data.drill1[a];
        }).slice(0, this.drill1Limit).concat(keyOther).reduce(function (dr1, keyDrill1) {
          dr1[keyDrill1] = 0;
          return dr1;
        }, {});

        _drill1Arr.map(function (keyDrill1) {
          if (keyDrill1 in _drill) _drill[keyDrill1] = data.drill1[keyDrill1];else _drill[keyOther] += data.drill1[keyDrill1];
        });
        data.drill1 = _drill;
      }

      var drill1SortKey = this.getDrillSortKey('drill1', drill1);
      var sortDrill1Predicate = this.getSortPredicate(drill1SortKey, data);
      var drill1Arr = Object.keys(data.drill1).sort(sortDrill1Predicate);

      var drill2SortKey = this.getDrillSortKey('drill2', drill2);
      var sortDrill2Predicate = this.getSortPredicate(drill2SortKey, data);
      var drill2Arr = Object.keys(data.drill2).sort(sortDrill1Predicate);

      options.series[0].data = drill2Arr.sort(sortDrill2Predicate).slice(0, this.drill2Limit).map(function (keyDrill2) {
        return {
          name: keyDrill2,
          value: drill1Arr.sort(sortDrill1Predicate).map(function (keyDrill1) {
            var serVal = 0;
            if (keyDrill1 in data.drill2[keyDrill2].values) serVal = data.drill2[keyDrill2].values[keyDrill1];else if (keyDrill1 === keyOther) serVal = Object.keys(data.drill2[keyDrill2].values).reduce(function (dr2Summ, keyDr2) {
              return dr2Summ += keyDr2 in data.drill1 ? 0 : data.drill2[keyDrill2].values[keyDr2];
            }, 0);
            if (data.maxValue < serVal) data.maxValue = serVal;
            return serVal ? serVal : '-';
          })
        };
      });

      options.polar[0] = {
        indicator: drill1Arr.sort(sortDrill1Predicate).map(function (keyDrill1) {
          return {
            text: keyDrill1,
            max: data.maxValue
          };
        })
      };
      options.series[0].name = options.title.text;

      options.legend.data = drill2Arr.sort(sortDrill2Predicate).slice(0, this.drill2Limit);
    }
  }, {
    key: 'render',
    value: function render(e) {
      if (!this.aggregate || !this.filter || !this.filterData.filterData.cells.length) {
        return;
      }
      if (this.$element.height() <= this.minHeight || this.$element.width() <= this.minWidth) {
        return;
      }

      this.container = this.$element[0];
      this.chart = echarts.init(this.container);
      var options = {
        animation: !this.isPrint,
        // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
        title: {
          text: 'Компы',
          subtext: 'Сайт'
        },
        tooltip: {
          show: false,
          trigger: 'axis'
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: 'bottom',
          data: ['Комп 1', 'Комп 2', 'Комп 3']
        },
        toolbox: {
          show: this.isPrint,
          feature: {
            mark: {
              show: false
            },
            dataView: {
              show: false
            },
            restore: {
              show: true,
              title: gettext('Обновить'),
              lang: ['rus']
            },
            saveAsImage: {
              show: true,
              title: gettext('Сохранить'),
              type: 'png',
              lang: [gettext('Сохранить'), '']
            }
          }
        },
        polar: [{
          indicator: []
        }],
        calculable: true,
        series: [{
          type: 'radar'
        }]
      };
      this.updateOptions(options);
      this.chart.setOption(options);
    }
  }, {
    key: 'isPrint',
    get: function get() {
      return this.router.pdf || this.LayoutService.isPrint;
    }
  }]);

  return RadarController;
}();

var RadarComponent = exports.RadarComponent = {
  template: __webpack_require__(936),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<'
  },

  controller: RadarController
};

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\" ng-if=\"!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n     && !$ctrl.filterData.cancelled\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div>"

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventRiverComponent = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global gettext */


__webpack_require__(150);

var _measure = __webpack_require__(39);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var eventRiverController = function () {
  function eventRiverController($scope, $element, $timeout, RouterService, LayoutService, rx) {
    var _this = this;

    _classCallCheck(this, eventRiverController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.router = RouterService;
    this.LayoutService = LayoutService;
    // this.LayoutService.drilldownMax = 2;
    this.getMeasure = _measure.Measure.getMeasure;
    this.container = null;
    this.hasData = false;
    this.chart = null;
    this.chartAreaIsStacked = true;
    this.minHeight = 1;
    this.minWidth = 1;
    this.renderDebounce = 100;
    this.drill1Limit = 20;
    this.drill2Limit = 30;
    this.aggregate = null;
    this.filter = null;
    this.timeRange = 200;
    this.other = gettext('Другое');

    var subscriptions = [rx.Observable.merge($scope.$eventToObservable('resizeBeforePrint'), rx.Observable.merge($scope.$eventToObservable('afterPrint'), $scope.$eventToObservable('dashboardResize'), $scope.$eventToObservable('resize'), $scope.$eventToObservable('splitter1Changed')).debounce(this.renderDebounce)).subscribe(function (e) {
      return _this.resize(e);
    }), rx.Observable.merge(
    // $scope.$eventToObservable('beforePrint'),
    rx.Observable.merge($scope.$toObservable('$ctrl.filter.orders'), $scope.$toObservable('$ctrl.filter.orderDirs'), $scope.$toObservable('$ctrl.aggregate')).debounce(this.renderDebounce)).subscribe(function (e) {
      return _this.render(e);
    })];

    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (subscription) {
        subscription.dispose();
      });
      delete _this.chart;
      // this.LayoutService.drilldownMax = 0;
    });
    // $timeout(() => {});

    // $scope.$on('$init', () => {
    //   // this.$element.height(500);
    //   this.render('$init');
    // });
  }

  _createClass(eventRiverController, [{
    key: 'resize',
    value: function resize(e) {
      if (this.chart && this.$element.height() > this.minHeight && this.$element.width() > this.minWidth) {
        this.chart.resize();
      }
    }
  }, {
    key: 'limitTo40',
    value: function limitTo40(s) {
      return s.length > 40 ? s.substring(0, 40) + '...' : s;
    }
  }, {
    key: 'goToDimEvents',
    value: function goToDimEvents(cut) {
      this.router.drilldownFilter2(cut);
    }

    // эта приблуда нужна для qtWeb

  }, {
    key: 'parseNewDate',
    value: function parseNewDate(dStr) {
      if (typeof dStr.getMonth === 'function') return dStr;
      // new Date('2019-06-02T23:59:59.999')

      var _dStr$split = dStr.split('T'),
          _dStr$split2 = _slicedToArray(_dStr$split, 2),
          dt = _dStr$split2[0],
          t = _dStr$split2[1];

      var _dt$split = dt.split('-'),
          _dt$split2 = _slicedToArray(_dt$split, 3),
          y = _dt$split2[0],
          m = _dt$split2[1],
          d = _dt$split2[2];

      y = parseInt(y, 0);
      m = parseInt(m, 0) - 1;
      d = parseInt(d, 0);

      var _t$split = t.split(':'),
          _t$split2 = _slicedToArray(_t$split, 3),
          h = _t$split2[0],
          min = _t$split2[1],
          s = _t$split2[2];

      h = parseInt(h, 0);
      min = parseInt(min, 0);
      s = parseInt(s, 0);
      var date = new Date(y, m, d, h, min, s);
      return date;
    }
  }, {
    key: 'updateOptions',
    value: function updateOptions(options) {
      var _this2 = this;

      // console.log(this.filterData.filterData.cells);
      // console.log(this.filterData.filterData.cells.map(cell => cell['agent_application.app_name']).sort());

      this.hasData = false;
      // const dFrom = (new Date(this.router.CurrentFilterService.timeFrom));
      var dFrom = this.parseNewDate(this.router.CurrentFilterService.timeFrom);
      var tFrom = dFrom.getTime();
      // const dTo = (new Date(this.router.CurrentFilterService.timeTo));
      var dTo = this.parseNewDate(this.router.CurrentFilterService.timeTo);
      var tTo = dTo.getTime();

      var getFormatedDate = function getFormatedDate(date) {
        return date.getFullYear() + '-' + pad2(date.getMonth() + 1) + '-' + pad2(date.getDate()) + ' ' + pad2(date.getHours()) + ':00';
      };

      var timeStep = Math.floor((tTo - tFrom) / this.timeRange);
      var pad2 = function pad2(n) {
        return '' + (n < 10 ? '0' : '') + n;
      };
      var getDate = function getDate(cell) {
        var hour = cell['agent_time.hour'] ? cell['agent_time.hour'] : 0;
        var d = new Date(cell['agent_time.year'], cell['agent_time.month'] - 1, cell['agent_time.day'], hour).getTime();

        var stepsQty = Math.floor((d - tFrom) / timeStep);

        var time = tFrom + timeStep * stepsQty + timeStep / 2;
        if (time > tTo) time = tTo;
        // return time;
        var date = new Date(time);
        return getFormatedDate(date);
      };

      var getValue = function getValue(cell) {
        if (_this2.isTimeMeasure) return cell[_this2.filterData.filter.measure];
        return cell.record_count;
      };

      var sortIndexMeasure = this.filter.orders.indexOf('measure');
      // if (sortIndexMeasure === -1)  sortIndexMeasure = 9999;

      // collecting all data
      var data = this.filterData.filter.drilldown.map(function (drill) {
        var drillLabel = _this2.model.getDrillLabel(drill);

        var sortIndexDimension = _this2.filter.orders.indexOf(_this2.model.getDrillAttr(drill));
        var order = 'measure_asc';
        if (sortIndexDimension !== -1 && sortIndexMeasure !== -1 && sortIndexDimension < sortIndexMeasure || sortIndexDimension !== -1 && sortIndexMeasure === -1) order = 'dimension_' + _this2.filter.orderDirs[sortIndexDimension];else if (sortIndexMeasure !== -1) order = 'measure_' + _this2.filter.orderDirs[sortIndexMeasure];else order = 'measure_desc';

        // console.log(this.filterData.filterData.cells.map(cell => this.model.getCellLabel(drill, cell)).sort());
        var currentDate = null;
        return _this2.filterData.filterData.cells.reduce(function (dt, cell, i) {
          // const xFilter = this.model.getCellFilter(drill, cell);
          var value = getValue(cell);
          if (value) {
            var kDr = _this2.model.getCellLabel(drill, cell);
            dt.name = drillLabel;
            dt.value += value;
            dt.order = order;
            if (!(kDr in dt.data)) {
              dt.data[kDr] = {
                cut: _this2.model.getCellFilter(drill, cell),
                value: value,
                data: {}
              };
            } else dt.data[kDr].value += value;

            var date = getDate(cell);
            if (!currentDate) currentDate = date;else if (currentDate != date) _this2.hasData = true;
            if (!(date in dt.data[kDr].data)) dt.data[kDr].data[date] = value;else dt.data[kDr].data[date] += value;
          }
          return dt;
        }, {
          value: 0,
          data: {}
        });
      });

      //  move small data value to "this.other"
      data = data.map(function (drill) {
        return {
          name: drill.name,
          order: drill.order,
          value: drill.value,
          data: Object.keys(drill.data).reduce(function (dt, dim) {
            if (drill.data[dim].value / drill.value < 0.005) {
              if (_this2.other in dt) {
                dt[_this2.other].value += drill.data[dim].value;
                Object.keys(drill.data[dim].data).map(function (time) {
                  if (time in dt[_this2.other].data) dt[_this2.other].data[time] += drill.data[dim].data[time];else dt[_this2.other].data[time] = drill.data[dim].data[time];
                });
              } else {
                dt[_this2.other] = {
                  value: drill.data[dim].value,
                  data: drill.data[dim].data
                };
              }
            } else {
              dt[dim] = drill.data[dim];
            }
            return dt;
          }, {})
        };
      });

      var sortPredicate = function sortPredicate(order, data) {
        var sortPredicates = {
          measure_asc: function measure_asc(a, b) {
            return data[a].value - data[b].value;
          },
          measure_desc: function measure_desc(a, b) {
            return data[b].value - data[a].value;
          },
          dimension_asc: function dimension_asc(a, b) {
            return b < a ? 1 : -1;
          },
          dimension_desc: function dimension_desc(a, b) {
            return b > a ? 1 : -1;
          }
        };

        return sortPredicates[order];
      };
      // create options
      options.legend.data = [];

      options.series = data.map(function (ser, index) {
        var dataLength = Object.keys(ser.data).length;
        options.legend.data.push(ser.name);
        return {
          type: 'eventRiver',
          name: ser.name,
          index: index,
          itemStyle: {
            normal: {
              label: {
                textStyle: {
                  color: 'gray'
                }
              }
            },
            emphasis: {
              label: {
                textStyle: {
                  color: '#555'
                }
              }
            }
          },
          data: Object.keys(ser.data).sort(sortPredicate(ser.order, ser.data))
          // .slice(0, 10)
          .map(function (dim, index) {
            return {
              name: ser.data[dim].value ? dim : '',
              index: index,
              weight: (dataLength - index) * (dataLength - index),
              cut: ser.data[dim].cut,
              dimValue: ser.data[dim].value,
              tooltip: {
                show: true //!(dim === this.other),
              },
              evolution: Object.keys(ser.data[dim].data).sort(function (a, b) {
                return b <= a ? 1 : -1;
              }).map(function (time) {
                return {
                  // time: new Date(+time),
                  time: time,
                  value: ser.data[dim].data[time]
                  // detail: {
                  //   text: ser.data[dim].data[time] ? `${dim} - ${ser.data[dim].data[time]}` : '',
                  // }
                };
              })
            };
          })
        };
      });
    }
  }, {
    key: 'render',
    value: function render(e) {
      var _this3 = this;

      if (!this.aggregate || !this.filter || !this.filterData.filterData.cells.length) {
        return;
      }

      if (this.$element.height() <= this.minHeight || this.$element.width() <= this.minWidth) {
        return;
      }

      this.container = this.$element[0];

      //-------------------------------------------
      var options = {
        // animation: false,
        animation: !this.isPrint,
        // animation: e.name !== 'beforePrint' && e.name !== 'resizeBeforePrint',
        title: {
          text: '',
          subtext: ''
        },
        tooltip: {
          show: !this.isPrint,
          trigger: 'item',
          enterable: true,
          showDelay: 50,
          hideDelay: 1000,
          transitionDuration: 20,
          backgroundColor: '#ddd',
          textStyle: {
            color: '#555'
          },
          formatter: function formatter(params, ticket, callback) {
            var tag = params.name === _this3.other ? 'div' : 'a';
            var id = 'id_' + params.series.index + '_' + params.data.index;
            var valueText = _this3.isTimeMeasure ? _this3.getMeasure(params.value.dimValue, _this3.filter.measure) : params.value.dimValue + ' ' + gettext('событий');
            var res = '<' + tag + ' id="' + id + '" >' + params.name + ' : ' + valueText + '</' + tag + '>';
            if (params.name === _this3.other) return res;
            _this3.$timeout(function () {
              callback(ticket, res);
              _this3.$timeout(function () {
                $('#' + id).click(function () {
                  _this3.goToDimEvents(params.data.cut);
                  // return false;
                });
              }, 200);
            }, 10);
            return 'loading';
          }
        },
        legend: {
          data: ['Событие 1', 'Событие 2']
        },
        toolbox: {
          show: !this.isPrint,
          feature: {
            mark: {
              show: false
            },
            restore: {
              show: false
            },
            saveAsImage: {
              show: true,
              title: gettext('Сохранить как изображение'),
              lang: [gettext('Сохранить как изображение')]
            }
          }
        },
        xAxis: [{
          type: 'time'
          // boundaryGap: [0.05, 0.05]
        }],
        series: []
      };

      this.updateOptions(options);
      if (this.hasData) {
        this.chart = echarts.init(this.container);
        this.chart.setOption(options);
      }
      // this.chart.resize();
    }
  }, {
    key: 'isPrint',
    get: function get() {
      return this.router.pdf || this.LayoutService.isPrint;
    }
  }, {
    key: 'isTimeMeasure',
    get: function get() {
      return this.filterData.filter.measure === 'activity_time_sum' || this.filterData.filter.measure === 'call_duration_sum';
    }
  }]);

  return eventRiverController;
}();

var EventRiverComponent = exports.EventRiverComponent = {
  template: __webpack_require__(938),
  bindings: {
    model: '<',
    aggregate: '<',
    filter: '<',
    filterData: '<'
  },

  controller: eventRiverController
};

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-center\" ng-if=\"(!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n     && !$ctrl.filterData.cancelled) || !$ctrl.hasData\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div>"

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatMenuComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _excellentexport = __webpack_require__(342);

var _excellentexport2 = _interopRequireDefault(_excellentexport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(940);

var StatMenuController = function () {
  function StatMenuController(CurrentFilterService, RouterService, PermissionService) {
    _classCallCheck(this, StatMenuController);

    this.CurrentFilterService = CurrentFilterService;
    this.router = RouterService;
    this.permission = PermissionService;
  }

  _createClass(StatMenuController, [{
    key: 'setMode',
    value: function setMode(mode) {
      if (this.isFilterEdit && this.filterData) this.filterData.filter.mode = mode;else this.router.mode = mode;
    }
  }, {
    key: 'generateReport',
    value: function generateReport(url) {
      if (this.isFilterEdit && this.filterData) {
        this.setMode('reports');
        this.filterData.filter.url = url;
      } else this.router.generateReport(url);
    }
  }, {
    key: 'download',
    value: function download($event) {
      _excellentexport2.default.excel($event.currentTarget, 'datatable');
      return true;
    }
  }, {
    key: 'filter',
    get: function get() {
      // return this.CurrentFilterService.filter;
      return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
    }
  }, {
    key: 'isFilterEdit',
    get: function get() {
      return this.router.isFilterEditModal;
    }
  }]);

  return StatMenuController;
}();

var StatMenuComponent = exports.StatMenuComponent = {
  template: __webpack_require__(941),
  bindings: {
    filterData: '<'
  },
  controller: StatMenuController
};

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-pills\"><li ng-class=\"{'pane-tab-active': $ctrl.filter.isStat}\"><a ng-click=\"$ctrl.setMode('stat')\"><i class=\"icon-table\"></i> <span class=\"hideable\">{{::'ТаблицаXXX' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isChartArea}\" style=\"margin-left:-3px\"><a ng-click=\"$ctrl.setMode('chart-area')\"><i class=\"icon-chart-bar\"></i> <span class=\"hideable\">{{::'Линейный график' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isChart}\" style=\"margin-left:-3px\"><a ng-click=\"$ctrl.setMode('chart')\"><i class=\"icon-chart\"></i> <span class=\"hideable\">{{::'Круговая диаграмма' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.mode === 'reports'}\" style=\"margin-left:-3px\"><a ng-click=\"$ctrl.generateReport('/analytics/report/graph/wizard/')\"><i class=\"icon-share\"></i> <span class=\"hideable\">{{::'Граф' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isTree}\" style=\"margin-left:-3px\"><a ng-click=\"$ctrl.setMode('tree')\"><i class=\"icon-flow-split\"></i> <span class=\"hideable\">{{::'Дерево' | gettext}}</span></a></li></ul>"

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.StatHeaderComponent = StatHeaderComponent;

var _measure = __webpack_require__(39);

var _iconClass = __webpack_require__(38);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(943);

var StatHeaderController = function () {
  function StatHeaderController($scope, CurrentFilterService, RouterService, $element, $timeout, CurrentModelService, LayoutService) {
    _classCallCheck(this, StatHeaderController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.$scope.list = [];
    this.LayoutService = LayoutService;
    this.Measure = _measure.Measure;
    // this.getMeasure = Measure.getMeasure;
    // this.getMeasureLabel = Measure.getMeasureLabel;
    // this.getMeasures = Measure.getMeasures;
    this.totalElements = 'total_elements';
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.CurrentFilterService.rebuildVisibleDimensions();
  }

  _createClass(StatHeaderController, [{
    key: 'getMeasureLabel',
    value: function getMeasureLabel(measure) {
      if (measure === this.totalElements) return gettext('Всего');
      return this.Measure.getMeasureLabel(measure);
    }
  }, {
    key: 'getMeasures',
    value: function getMeasures() {
      if (this.filter.isSummStat) return [this.totalElements].concat(this.Measure.getMeasures());
      return this.Measure.getMeasures();
    }
  }, {
    key: 'scrollToEnd',
    value: function scrollToEnd() {
      var _this = this;

      this.$timeout(function () {
        var parentEl = _this.$element.closest('.sc-view-container');
        if (parentEl[0]) parentEl.scrollLeft(parentEl[0].scrollWidth);
      }, 10);
    }
  }, {
    key: 'selectDim',
    value: function selectDim(dim) {
      if (this.router.isFilterEditModal) {
        if (this.filter.hasDrilldown(dim.toString())) {
          return;
        }
        this.filter.addDrilldown(dim.toString());
        // this.filter.changed();
        this.$onChanges(this);
      } else this.router.selectDim(dim);
    }
  }, {
    key: 'replaceDim',
    value: function replaceDim(newDim, oldDim) {
      if (this.router.isFilterEditModal) {
        if (this.filter.hasDrilldown(newDim.toString())) {
          return;
        }
        this.filter.replaceDrilldown(newDim.toString(), oldDim.toString());
        // this.filter.changed();
        this.$onChanges(this);
      } else this.router.replaceDim(newDim, oldDim);
    }
  }, {
    key: 'setMeasure',
    value: function setMeasure(measure) {
      if (this.router.isFilterEditModal) this.filter.measure = measure;else this.router.setMeasure(measure);
    }
  }, {
    key: 'removeDim',
    value: function removeDim(dim) {
      if (this.router.isFilterEditModal) {

        if (!this.filter.hasDrilldown(dim.toString())) {
          return;
        }
        this.filter.removeDrilldown(dim.toString());
        this.$onChanges(this);
        // this.filter.changed();
        // this.filterChanged();
      } else this.router.removeDim(dim);
    }
  }, {
    key: 'toggleSortDirs',
    value: function toggleSortDirs(columnName) {
      if (this.isReadOnly) return;
      var colOrders = columnName.split(',');
      var filter = this.filter;

      var _loop = function _loop(i) {
        var j = 0;
        if (colOrders.every(function (o) {
          var res = o === filter.orders[i + j];
          j++;
          return res;
        })) {
          var dir = filter.orderDirs[i];
          if (dir === 'asc') {
            colOrders.map(function (o, j) {
              return filter.orderDirs[i + j] = 'desc';
            });
          } else {
            filter.orders.splice(i, colOrders.length);
            filter.orderDirs.splice(i, colOrders.length);
          }
        }
      };

      for (var i = 0; i < filter.orders.length; i++) {
        _loop(i);
      }
    }
  }, {
    key: 'toggleSortDrillSorterOrder',
    value: function toggleSortDrillSorterOrder(drill) {
      if (this.isReadOnly) return;

      var filter = this.filter;
      if (!filter.orders || !filter.orderDirs) {
        filter.orders = [];
        filter.orderDirs = [];
      }
      if (!filter.hasOwnProperty('orders')) {
        filter.orders = angular.copy(filter.orders);
      }
      if (!filter.hasOwnProperty('orderDirs')) {
        filter.orderDirs = angular.copy(filter.orderDirs);
      }

      var columnName = this.getOrderColumnName(drill);
      if (filter.orders.join(',').indexOf(columnName) === -1) {
        filter.orders = filter.orders.concat(columnName.split(','));
        filter.orderDirs = filter.orderDirs.concat(columnName.split(',').map(function (o) {
          return 'asc';
        }));
      } else {
        this.toggleSortDirs(columnName);
      }
      filter.orders = angular.copy(filter.orders);
      filter.orderDirs = angular.copy(filter.orderDirs);

      if (this.router.isFilterEditModal) this.filterData.update(filter);
      this.router.filter = filter;
    }
  }, {
    key: 'toggleSortMeasureSorterOrder',
    value: function toggleSortMeasureSorterOrder() {
      if (this.isReadOnly) return;
      var filter = this.filter;
      if (!filter.hasOwnProperty('orders')) {
        filter.orders = angular.copy(filter.orders);
      }
      if (!filter.hasOwnProperty('orderDirs')) {
        filter.orderDirs = angular.copy(filter.orderDirs);
      }

      var columnName = 'measure';
      if (!filter.orders.includes(columnName)) {
        filter.orders.push(columnName);
        filter.orderDirs.push('asc');
      } else {
        var sortIndex = this.getMeasureOrderDirIndex();
        var sortDir = this.getMeasureSortDir();
        if (sortDir === 'desc') {
          filter.orders.splice(sortIndex, 1);
          filter.orderDirs.splice(sortIndex, 1);
        } else {
          filter.orderDirs[sortIndex] = 'desc';
        }
      }
      filter.orders = angular.copy(filter.orders);
      filter.orderDirs = angular.copy(filter.orderDirs);

      if (this.router.isFilterEditModal) this.filterData.update(filter);else this.router.filter = filter;
    }
  }, {
    key: 'isSortable',
    value: function isSortable(drill) {
      var columnName = this.getOrderColumnName(drill);
      var filter = this.filter;
      return filter.orders && filter.orders.join(',').includes(columnName);
    }
  }, {
    key: 'isMesureSortable',
    value: function isMesureSortable() {
      var filter = this.filter;
      var columnName = 'measure';
      if (!filter || !filter.measure || filter.measure === this.totalElements) {
        return false;
      }
      return filter.orders && filter.orders.includes(columnName);
    }
  }, {
    key: 'getSortDir',
    value: function getSortDir(drill) {
      var sortIndex = this.getOrderDirIndex(drill);
      if (sortIndex === -1) return 'none';
      return this.filter.orderDirs[sortIndex];
    }
  }, {
    key: 'getMeasureSortDir',
    value: function getMeasureSortDir() {
      var sortIndex = this.getMeasureOrderDirIndex();
      if (sortIndex === -1) {
        return null;
      }
      return this.filter.orderDirs[sortIndex];
    }
  }, {
    key: 'getOrderDirIndex',
    value: function getOrderDirIndex(drill) {
      var filter = this.filter;
      var columnOrders = this.getOrderColumnName(drill).split(',');

      var sortIndex = filter.orders.findIndex(function (e, i) {
        return columnOrders.every(function (o, j) {
          return filter.orders[i + j] === columnOrders[j];
        });
      });
      return sortIndex;
    }
  }, {
    key: 'getMeasureOrderDirIndex',
    value: function getMeasureOrderDirIndex() {
      var filter = this.filter;
      var columnName = 'measure';
      if (!filter) {
        return -1;
      }
      var sortIndex = filter.orders.findIndex(function (e) {
        return e === columnName;
      });
      return sortIndex;
    }
  }, {
    key: 'getOrderColumnName',
    value: function getOrderColumnName(drill) {
      var dimension = this.CurrentModelService.model.getDimensionParts(drill);
      if (dimension.hierarchy.name === 'ym' || dimension.hierarchy.name === 'ymd' || dimension.hierarchy.name === 'ymdh' || dimension.hierarchy.name === 'ymdhm') return dimension.hierarchy.levels.map(function (l) {
        return dimension.dimension.name + '.' + l;
      }).join(',');
      return dimension.dimension.name + '.' + dimension.level.label_attribute;
    }
  }, {
    key: 'dropMove',
    value: function dropMove(index) {
      var _filter$drilldown;

      this.$scope.list.splice(index, 1);
      var filter = this.filter;
      filter.drilldown = [];
      var newDrills = this.$scope.list.filter(function (item) {
        return item.isDrill;
      }).map(function (item) {
        return item.key;
      });
      (_filter$drilldown = filter.drilldown).splice.apply(_filter$drilldown, [0, filter.drilldown.length].concat(_toConsumableArray(newDrills)));
      if (this.router.isFilterEditModal) this.filterData.update(filter);else this.router.filter = filter;
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changesObj) {
      var _this2 = this;

      var currentValue = this.router.isFilterEditModal ? this.filter : changesObj.filter.currentValue;
      if (changesObj.filter && currentValue) {

        var newDrillsList = currentValue.drilldown.slice().map(function (item) {
          return {
            key: item,
            label: _this2.model.getDrillLabel(item),
            isDrill: true
          };
        });
        // const staticItems = [{
        //     isDrill: false
        //   },
        //   {
        //     isDrill: false
        //   }
        // ];
        // this.$scope.list = staticItems.concat(newDrillsList);
        this.$scope.list = newDrillsList;
      }
    }
  }, {
    key: 'isShowAddDimensionBtn',
    get: function get() {
      return !this.LayoutService.drilldownMax || this.filter.drilldown.length < this.LayoutService.drilldownMax;
    }
  }, {
    key: 'isReadOnly',
    get: function get() {
      if (this.router.isFilterEditModal) return false;
      return this.CurrentFilterService.filter.isDashboard || this.CurrentFilterService.filter.isCard;
    }
  }, {
    key: 'showRemove',
    get: function get() {
      var drillList = this.$scope.list.filter(function (item) {
        return item.isDrill;
      });
      return drillList && drillList.length > 1;
    }
  }, {
    key: 'test',
    get: function get() {
      // console.log(this);
      return true;
    }
  }, {
    key: 'visibleDimensions',
    get: function get() {
      return this.CurrentFilterService.visibleDimensions;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }]);

  return StatHeaderController;
}();

function StatHeaderComponent(CurrentFilterService, RouterService, CurrentModelService) {
  return {
    template: __webpack_require__(944),
    restrict: 'A',
    scope: {
      //      list: [],
      // readOnly: '<',
    },
    bindToController: {
      filter: '<',
      filterData: '<'
    },
    controller: StatHeaderController,
    controllerAs: '$ctrl'
  };
}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports = "<tr ng-if=\"$ctrl.isReadOnly\" class=\"read-only-header\"><th ng-repeat=\"item in list\"><div class=\"not-drill\"><span class=\"not-badge\"><b class=\"read-value\">{{item.label}}</b> <span class=\"\"><i class=\"pointer sorted-badge\" title=\"{{:: 'Сортировка'  | gettext }}\" ng-class=\"{'icon-resize-vertical': $ctrl.getSortDir(item.key) === 'none',\n                          'icon-sort-alt-down': $ctrl.getSortDir(item.key) === 'desc',\n                          'icon-sort-alt-up': $ctrl.getSortDir(item.key) === 'asc' }\"></i> <span class=\"badge mini\" title=\"{{:: 'Порядок сортировки'  | gettext }}\" ng-if=\"$ctrl.isSortable(item.key)\">{{ $ctrl.getOrderDirIndex(item.key) + 1 }}</span></span></span></div></th><th class=\"last-col\" colspan=\"2\"><div class=\"header not-drill change-measure\"><span class=\"not-badge\"><div><b class=\"read-value\">{{ $ctrl.getMeasureLabel( $ctrl.filter.measure ) }}</b></div><span class=\"\"><i class=\"pointer sorted\" title=\"{{:: 'Сортировка'  | gettext }}\" ng-class=\"{'icon-sort-alt-down': $ctrl.getMeasureSortDir() === 'desc',\n              'icon-sort-alt-up': $ctrl.getMeasureSortDir() === 'asc',\n              'icon-resize-vertical': !$ctrl.isMesureSortable() }\"></i> <span class=\"badge mini\" title=\"{{:: 'Порядок сортировки'  | gettext }}\" ng-if=\"$ctrl.isMesureSortable()\">{{ $ctrl.getMeasureOrderDirIndex() + 1 }}</span></span></span></div></th></tr><tr ng-if=\"!$ctrl.isReadOnly\" dnd-list=\"list\" dnd-disable-if=\"$ctrl.isReadOnly\" dnd-moved=\"$ctrl.dropMove(index)\" dnd-effect-allowed=\"move\" dnd-horizontal-list=\"true\" class=\"drilldown\"><th ng-repeat=\"item in list\" ng-if=\"item.isDrill\" dnd-draggable=\"item\" dnd-moved=\"$ctrl.dropMove($index)\" dnd-effect-allowed=\"move\"><div class=\"drill\"><span class=\"badge move\" ng-class=\"(item.predicates && item.predicates.indexOf('!')>=0) ? 'badge-important': 'badge-info'\"><div class=\"dropdown-toggle\" title=\"{{:: 'Выбор измерения'  | gettext }}\"><b class=\"filter-value pointer\">{{item.label}}</b> <i class=\"icon-down-dir pointer\"></i></div><ul ng-if=\"!$ctrl.isReadOnly\" class=\"dropdown-menu\" sc-ul role=\"menu\"><li ng-repeat=\"dim in $ctrl.visibleDimensions\" class=\"dropdown-submenu\" ng-class=\"{'dropdown': !dim.is_flat}\"><a class=\"dropdown-toggle\" ng-click=\"$ctrl.replaceDim(dim, item.key)\"><i ng-class=\"$ctrl.DIM2CLASS[dim.name]\"></i> {{ dim.label }} <span ng-show=\"!dim.is_flat\"></span></a><ul class=\"dropdown-menu sub-menu\" ng-show=\"!dim.is_flat\"><li ng-repeat=\"hie in dim.hierarchies\"><a ng-click=\"$ctrl.replaceDim(hie.toString(), item.key)\">{{ hie.label }}</a></li></ul></li></ul><span class=\"dimension-sorted\" ng-click=\"$ctrl.toggleSortDrillSorterOrder(item.key)\"><i class=\"pointer sorted-badge\" title=\"{{:: 'Сортировка'  | gettext }}\" ng-class=\"{'icon-resize-vertical': $ctrl.getSortDir(item.key) === 'none',\n                          'icon-sort-alt-down': $ctrl.getSortDir(item.key) === 'desc',\n                          'icon-sort-alt-up': $ctrl.getSortDir(item.key) === 'asc' }\"></i> <span ng-click=\"$ctrl.toggleSortDrillSorterOrder(item.key)\" class=\"badge mini\" title=\"{{:: 'Порядок сортировки'  | gettext }}\" ng-if=\"$ctrl.isSortable(item.key)\">{{ $ctrl.getOrderDirIndex(item.key) + 1 }} </span></span><i ng-if=\"$ctrl.showRemove\" class=\"pointer close-badge icon-cancel hide-on-print\" title=\"{{:: 'Удалить измерение'  | gettext }}\" ng-click=\"$ctrl.removeDim(item.key)\"></i></span></div></th><th class=\"last-col\" colspan=\"2\"><div ng-class=\"{'dropdown': $ctrl.isShowAddDimensionBtn, 'disabled': !$ctrl.isShowAddDimensionBtn }\" class=\"measure-sorted header add-dimension\"><div class=\"dropdown-toggle pointer\" ng-click=\"$ctrl.scrollToEnd()\" title=\"{{:: 'Добавить измерение' | gettext }}\"><i class=\"icon-plus hide-on-print\"></i> <i class=\"icon-down-dir hide-on-print\"></i></div><ul ng-if=\"$ctrl.isShowAddDimensionBtn && !$ctrl.isReadOnly\" sc-ul class=\"pull-right dropdown-menu\" role=\"menu\"><li ng-repeat=\"dim in $ctrl.visibleDimensions\" class=\"dropdown-submenu pull-left\" ng-class=\"{'dropdown': !dim.is_flat}\"><a class=\"dropdown-toggle\" ng-click=\"$ctrl.selectDim(dim)\"><i ng-class=\"$ctrl.DIM2CLASS[dim.name]\"></i> {{ dim.label }} <span ng-show=\"!dim.is_flat\" class=\"pull-right\">➤</span></a><ul class=\"dropdown-menu sub-menu\" ng-show=\"!dim.is_flat\"><li ng-repeat=\"hie in dim.hierarchies\"><a ng-click=\"$ctrl.selectDim(hie.toString())\">{{ hie.label }}</a></li></ul></li></ul></div><div class=\"dropdown header measure-sorted change-measure\"><div class=\"dropdown-toggle pointer\" title=\"{{:: 'Выбор меры'  | gettext }}\"><span><b>{{ $ctrl.getMeasureLabel( $ctrl.filter.measure ) }}</b></span> <i class=\"icon-down-dir hide-on-print\"></i></div><ul ng-if=\"!$ctrl.isReadOnly\" class=\"dropdown-menu pull-right\" sc-ul role=\"menu\"><li ng-repeat=\"measure in $ctrl.getMeasures()\"><a ng-click=\"$ctrl.setMeasure( measure )\">{{ $ctrl.getMeasureLabel(measure) }}</a></li></ul><i class=\"pointer sorted\" title=\"{{:: 'Сортировка'  | gettext }}\" ng-class=\"{'icon-sort-alt-down': $ctrl.getMeasureSortDir() === 'desc', 'icon-sort-alt-up': $ctrl.getMeasureSortDir() === 'asc', 'icon-resize-vertical': !$ctrl.isMesureSortable() }\" ng-click=\"$ctrl.toggleSortMeasureSorterOrder()\"></i> <span class=\"badge mini\" title=\"{{:: 'Порядок сортировки'  | gettext }}\" ng-click=\"$ctrl.toggleSortMeasureSorterOrder()\" ng-if=\"$ctrl.isMesureSortable()\">{{ $ctrl.getMeasureOrderDirIndex() + 1 }}</span></div></th></tr>"

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RefDirective = undefined;

var _iframeModal = __webpack_require__(946);

var RefDirective = exports.RefDirective = function RefDirective($modal, $timeout) {
  return {
    restrict: 'A',
    scope: {
      scTitle: '@',
      scRef: '@'
    },
    link: function link(scope, element, attrs) {
      var onClick = function onClick() {
        scope.scText = element.text();
        var modal = $modal.open({
          template: __webpack_require__(948),
          controller: _iframeModal.IFrameModal,
          windowClass: 'iframe-modal',
          scope: scope
        });
        modal.opened.then(function () {
          $timeout(function () {
            $('.modal-body1').height(window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight() - 30);
          }, 100);
        }).catch(function (err) {
          console.error(err);
        });
        modal.result.catch(function (err) {
          console.error(err);
        });
      };
      element.bind('click', onClick);
      // scope.$on('$destroy', () => {});
    }
  };
};

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(947);

var IFrameModal = exports.IFrameModal = function IFrameModal($scope, $modalInstance) {
  _classCallCheck(this, IFrameModal);

  $scope.ok = function () {
    $modalInstance.close();
  };
  $scope.cancel = function () {
    $modalInstance.close();
  };
};

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\" ng-bind=\"scTitle || scText\"></h4></div><div class=\"modal-body1\"><sc-iframe src=\"scRef\"></sc-iframe></div><div class=\"modal-footer\"></div>"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UlComponent = UlComponent;
function UlComponent($timeout) {
  var closeEl = function closeEl(el) {
    if (el && el[0] && el[0].clientHeight) el.parent().click();
  };

  var updateEl = function updateEl(el, container) {
    if (!el || !el[0] || !el.parent() || !el.parent()[0]) return;
    // console.log(el);
    closeEl(null, el);
    // if (el[0].clientHeight) el.parent().click();
    if (!el.parent()[0]) return;
    var rect = el.parent()[0].getClientRects()[0];
    if (!rect) return;
    var left = el.hasClass('pull-right') ? rect.left - el.width() + rect.width - 2 : rect.left;
    var top = rect.bottom + 3;

    if (container && container[0] && top + el.height() - container.position().top - 70 > container.height()) {
      top = rect.top - el.height() - 10;
    }

    el.css({
      position: 'fixed',
      top: top,
      left: left
    });
  };

  return {
    link: function link(scope, el) {
      var _this = this;

      el[0].addEventListener('mouseleave', closeEl.bind(this, el), false);
      var container = el.closest('.aggregate-container');
      var btn = void 0;
      $timeout(function () {
        btn = el.parent().find('[data-toggle]');
        if (btn[0]) btn[0].addEventListener('click', updateEl.bind(_this, el, container), false);else {
          scope.$on('splitter1Changed', updateEl.bind(_this, el, container), false);
          scope.$on('splitter2Changed', closeEl.bind(_this, el), false);
        }
        $timeout(function () {
          updateEl(el, container);
        }, 100);
      }, 100);

      el.on('$destroy', function () {
        try {
          el[0].removeEventListener('mouseleave', closeEl);
          if (btn[0]) btn[0].removeEventListener('click', updateEl);
        } catch (err) {//
        }
      });
    }
  };
}

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
__webpack_require__(951);

var IFrameComponent = exports.IFrameComponent = {
  template: __webpack_require__(952),
  bindings: {
    src: '='
  },
  controller: function controller($scope) {

    // hooking up the onload event - calling the callback on load event
    // const onLoad = () => {
    //   const contentLocation = element.length > 0 && element[0].contentWindow ?
    //     element[0].contentWindow.location :
    //     undefined;
    //
    //   scope.callback({
    //     contentLocation
    //   });
    // };
    // element.on("load", onLoad);
    // scope.$on('$destroy', () => {
    //   element.off("load", onLoad);
    // });

  }
};

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports = "<iframe frameborder=\"0\" class=\"maximize iframe-frame\" ng-attr-src=\"{{$ctrl.src | trusted}}\"></iframe>"

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var XRefDirective = exports.XRefDirective = function XRefDirective(RouterService, $rootScope) {
  return {
    restrict: 'A',
    scope: {
      scTitle: '@',
      scXref: '@'
    },
    link: function link(scope, element, attrs) {
      var onClick = function onClick() {
        RouterService.openFrame(scope.scXref);
        $rootScope.$digest();
      };
      element.bind('click', onClick);
      // scope.$on('$destroy', () => {});
    }
  };
};

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(955);

var SpinnerController = function SpinnerController() {
  _classCallCheck(this, SpinnerController);
};

var SpinnerComponent = exports.SpinnerComponent = {
  template: __webpack_require__(956),
  bindings: {},
  controller: SpinnerController
};

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "<div class=\"spinner-icon\"><i class=\"icon-loading animate-spin\"></i></div>"

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(958);

var HSpinnerController = function () {
  function HSpinnerController(CurrentFilterService) {
    _classCallCheck(this, HSpinnerController);

    this.limit = CurrentFilterService.filter && CurrentFilterService.filter.limit || 50;
  }

  _createClass(HSpinnerController, [{
    key: 'isShowWarinig',
    get: function get() {
      return this.limit > 200;
    }
  }]);

  return HSpinnerController;
}();

var HSpinnerComponent = exports.HSpinnerComponent = {
  template: __webpack_require__(959),
  bindings: {},
  controller: HSpinnerController
};

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports = "<div class=\"image-hspinner\"><div ng-if=\"$ctrl.isShowWarinig\" class=\"text\"><h5>{{::'Подождите несколько минут. Всего может быть загружено до' | gettext}} {{$ctrl.limit}} {{::'строк...' | gettext}}</h5></div></div>"

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SilterStampComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(961);

var SilterStampController = function () {
  function SilterStampController(CurrentModelService) {
    _classCallCheck(this, SilterStampController);

    this.CurrentModelService = CurrentModelService;
    this.locLabel = _filter.Filter.locLabel;
  }

  _createClass(SilterStampController, [{
    key: 'cutDimension',
    value: function cutDimension(cut) {
      return this.CurrentModelService.model.getDrillLabel(cut.dimension);
    }
  }, {
    key: 'cutValue',
    value: function cutValue(cut) {
      return this.locLabel(cut);
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }]);

  return SilterStampController;
}();

var SilterStampComponent = exports.SilterStampComponent = {
  template: __webpack_require__(962),
  bindings: {
    filter: '<'
  },
  controller: SilterStampController
};

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports = "<div><br><div class=\"filter-cut\" ng-repeat=\"cut in $ctrl.filter.filters\">{{$ctrl.cutDimension(cut)}}:<b>{{$ctrl.cutValue(cut)}}</b></div></div>"

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RootCtrl = undefined;

var _config = __webpack_require__(21);

var _modals = __webpack_require__(69);

var _filter = __webpack_require__(28);

var _iconClass = __webpack_require__(38);

var _measure = __webpack_require__(39);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(964);

/*
 * Main analytics controller
 */

var RootCtrl = exports.RootCtrl = function RootCtrl($scope, $timeout, CurrentFilterService, CurrentModelService, RouterService, FiltersService, AggregateDataService, PermissionService, CurrentFilterDataService, CatalogNodeDragService, LocalStorageService, LayoutService) {
  _classCallCheck(this, RootCtrl);

  $scope.currentFilter = CurrentFilterService;
  $scope.filterBar = CurrentFilterService.filterBar;
  $scope.currentModel = CurrentModelService;
  $scope.generateReport = RouterService.generateReport.bind(RouterService);
  $scope.locLabel = _filter.Filter.locLabel;
  $scope.FiltersService = FiltersService;
  $scope.permission = PermissionService;
  $scope.getMeasure = _measure.Measure.getMeasure;
  $scope.getMeasureLabel = _measure.Measure.getMeasureLabel;
  $scope.getMeasures = _measure.Measure.getMeasures;
  $scope.TYPE2CLASS = _iconClass.TYPE2CLASS;
  $scope.DIM2CLASS = _iconClass.DIM2CLASS;
  $scope.newFilter = function () {
    return RouterService.newFilter();
  };
  $scope.getCellFilter = function () {
    var _CurrentModelService$;

    return (_CurrentModelService$ = CurrentModelService.model).getCellFilter.apply(_CurrentModelService$, arguments);
  };
  $scope.getCellLabel = function () {
    var _CurrentModelService$2;

    return (_CurrentModelService$2 = CurrentModelService.model).getCellLabel.apply(_CurrentModelService$2, arguments);
  };
  $scope.setMeasure = RouterService.setMeasure.bind(RouterService);
  $scope.selectDim = RouterService.selectDim.bind(RouterService);
  $scope.removeDim = RouterService.removeDim.bind(RouterService);
  $scope.drilldown = RouterService.drilldown.bind(RouterService);
  $scope.router = RouterService;
  $scope.CatalogNodeDragService = CatalogNodeDragService;
  $scope.LayoutService = LayoutService;
  // $scope.localStorage = LocalStorageService;

  Object.defineProperty($scope, 'filter', {
    get: function get() {
      return $scope.currentFilter.filter;
    }
  });
  Object.defineProperty($scope, 'model', {
    get: function get() {
      return $scope.currentModel.model;
    }
  });
  Object.defineProperty($scope, 'cube', {
    get: function get() {
      return $scope.currentModel.cube;
    }
  });
  Object.defineProperty($scope, 'filters', {
    get: function get() {
      return FiltersService.filters;
    }
  });
  Object.defineProperty($scope, 'visibleDimensions', {
    get: function get() {
      return $scope.currentFilter.visibleDimensions;
    }
  });

  if ($scope.LayoutService.options.saveInterface.value) {
    var splitter1Pos = parseInt(LocalStorageService.getItem('splitter1', _config.HSPLITTER), 0);
    var splitter2Pos = parseInt(LocalStorageService.getItem('splitter2', _config.HSPLITTER / 2), 0);
    $scope.splitters = splitter1Pos ? [splitter1Pos] : [_config.HSPLITTER];
    $scope.splitters.push(splitter2Pos ? splitter2Pos : _config.HSPLITTER / 2);
  } else $scope.splitters = [_config.HSPLITTER, _config.HSPLITTER / 2];
  $scope.LayoutService.splitters = $scope.splitters;

  /* Escape loading */
  $('#image-spinner-cancel').on('click', function () {
    $('#image-spinner').hide();
  });

  window.updateSize = function () {
    $scope.$root.$broadcast('resize');
  };

  // TODO: find out the reason for the appearance of nulls in url
  window.onhashchange = function () {
    if (window.location.href.match(/\/#!\/null\?/)) {
      console.error('wrong url:', window.location.href);
      window.location.assign(window.location.href.replace(/\/#!\/null\?/, '/#!/?'));
    }
  };

  window.addEventListener('resize', function () {
    $scope.$root.$broadcast('resize');
  });

  window.addEventListener('sortTimeTracker', function (e, p) {
    // console.log(e, p);
  });

  window.onmousedown = function () {
    return window.isMouseDown = true;
  };
  window.onmouseup = function () {
    return window.isMouseDown = false;
  };

  window.addEventListener('mouseup', function (e) {
    if (e && (e.which == 2 || e.button == 4)) {
      var oldUrl = window.location.href;
      var newUrl = oldUrl;
      $(e.target).click();
      $timeout(function () {
        newUrl = window.location.href;
        window.location.href = oldUrl;
        var win = window.open(newUrl);
      }, 100);
    }
  });

  window.addEventListener('keyup', function (e) {
    if (e.ctrlKey && e.keyCode === 90) {
      if ($scope.router.layout.editCatalog) {
        $scope.CatalogNodeDragService.keyUp(e);
        e.preventDefault();
      }
    } else if (e.ctrlKey && e.shiftKey && (e.key === 'L' || e.key === 'l')) {
      $scope.LayoutService.openOptions();
    } else if (e.ctrlKey && e.shiftKey && (e.key === 'S' || e.key === 's')) {
      $scope.LayoutService.openServerInfo();
    }
  });

  $scope.$on('reload', function () {
    if ($scope.currentFilter.lastScreenshots) $scope.currentFilter.lastScreenshots = {
      timeFrom: $scope.currentFilter.timeFrom
    };
    CurrentFilterDataService.reload(true);
  });

  window.addFilter = function (name, value, label) {
    if (!name || !value) return;
    $scope.router.addFilter(name, value, label);
    $timeout(function () {}, 10);
    return false;
  };

  window.selectFilter = function (name, value, label) {
    if ((!name || !value) && value !== '') return;
    $scope.router.cleanFilter(name, value, label);
    $scope.router.addFilter(name, value, label);
    // $timeout(() => {}, 10);
    return false;
  };

  window.setPeriod = function (timeFrom, timeTo) {
    $scope.router.timeFrom = timeFrom;
    $scope.router.timeTo = timeTo;
  };

  // window.drilldownFilter = (dimension, value, label) => {
  window.drilldownFilter = function () {
    var _$scope$router;

    (_$scope$router = $scope.router).drilldownFilter.apply(_$scope$router, arguments);
    // $timeout(() => {}, 10);
    return false;
  };

  window.drilldownFilter2 = function () {
    var _$scope$router2;

    (_$scope$router2 = $scope.router).drilldownFilter2.apply(_$scope$router2, arguments);
    // $timeout(() => {}, 10);
    return false;
  };

  window.drilldownFilterHTML = function () {
    var _$scope$router3;

    (_$scope$router3 = $scope.router).drilldownFilterHTML.apply(_$scope$router3, arguments);
    // $timeout(() => {}, 10);
    return false;
  };

  window.drilldownCut = function () {
    var _$scope$router4;

    (_$scope$router4 = $scope.router).drilldownCut.apply(_$scope$router4, arguments);
    // $timeout(() => {}, 10);
    return false;
  };

  window.removeCut = function () {
    var _$scope$router5;

    (_$scope$router5 = $scope.router).removeCut.apply(_$scope$router5, arguments);
    $timeout(function () {}, 10);
    return false;
  };

  window.changeCut = function () {
    var _$scope$router6;

    (_$scope$router6 = $scope.router).changeCut.apply(_$scope$router6, arguments);
    $timeout(function () {}, 10);
    return false;
  };

  window.mode = function (mode) {
    $scope.router.mode = mode;
    $scope.$root.$digest();
  };

  window.reload = function () {
    $scope.$root.$broadcast('reload');
  };

  window.setCellFilter = function (drill, cell) {
    var filter = $scope.getCellFilter(drill, cell);
    $scope.router.toggleFilter(filter);
    $scope.currentFilter.rebuildVisibleDimensions();
    $scope.router.filterChanged();
  };

  $('[data-toggle=\'tooltip\']').tooltip();

  window.changeThreshold = function (thresholdTag) {
    var threshold = thresholdTag.value;
    if (!threshold || threshold < 1) {
      return;
    }
    RouterService.threshold = threshold;
    RouterService.update();
    window.reload();
  };

  $scope.router.init();
};

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.SidebarComponent = SidebarComponent;

var _iconClass = __webpack_require__(38);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(966);

var SidebarController = function () {
  function SidebarController($scope, $element, $timeout, CurrentFilterService, AggregateDataService, CurrentModelService, $rootScope, PermissionService, RouterService, FiltersService, LayoutService, LocalStorageService) {
    var _this = this;

    _classCallCheck(this, SidebarController);

    this.$scope = $scope;
    this.$element = $element;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = _iconClass.DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.layout = LayoutService;
    this.layout.openAll = 0;
    this.localStorage = LocalStorageService;
    this.$timeout = $timeout;
    this.isShowFootWord = true;
    this.panelWidth = 0;

    this.$scope.$on('init', function (e) {
      return _this.$timeout(function () {
        _this.panelWidth = _this.$element[0].offsetWidth;
        _this.setIsShowFootWord(e, _this.$element.find('.aggregate-left')[0].offsetWidth);
      }, 10);
    });

    this.$scope.$on('splitter1Mouseup', function (e, d1, d2, name) {
      _this.panelWidth = d1;
      if (d1 && _this.layout.options.saveInterface.value) _this.$timeout(function () {
        return _this.localStorage.setItem(name, d1);
      }, 100);
    });

    this.$scope.$on('splitter1Changed', function (e, d1, d2, name) {
      _this.panelWidth = d1;
      _this.$scope.$broadcast('resize');
    });

    this.$scope.$on('splitter2Changed', function (e, d1, d2, name) {
      _this.setIsShowFootWord(e, d1);
    });

    this.$scope.$on('splitter2Mouseup', function (e, d1, d2, name) {
      if (_this.layout.options.saveInterface.value) _this.$timeout(function () {
        return _this.localStorage.setItem(name, d1);
      }, 100);
      _this.setIsShowFootWord(e, d1);
    });
  }

  _createClass(SidebarController, [{
    key: 'setIsShowFootWord',
    value: function setIsShowFootWord(e, d) {
      d = Math.min(d, this.panelWidth);
      this.isShowFootWord = d > 240;
      if (e.targetScope.$$phase) return;
      this.$scope.$apply();
    }
  }, {
    key: 'openAll',
    value: function openAll() {
      this.layout.openedFilters.all = true;
    }
  }, {
    key: 'closeAll',
    value: function closeAll() {
      this.layout.openedFilters = {
        all: false
      };
    }
  }, {
    key: 'toggleEditCatalog',
    value: function toggleEditCatalog() {
      this.layout.editCatalog = !this.layout.editCatalog;
    }
  }, {
    key: 'viewReport',
    value: function viewReport() {
      this.router.panel = 'catalog';
      this.$rootScope.$broadcast('resize');
    }
  }, {
    key: 'viewFilter',
    value: function viewFilter() {
      this.router.panel = 'constructor';
      this.$rootScope.$broadcast('resize');
    }
  }, {
    key: 'isEditCatalog',
    get: function get() {
      return !!this.layout.editCatalog && this.panel === 'catalog';
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'panel',
    get: function get() {
      return this.currentFilter.panel;
    },
    set: function set(panel) {
      this.currentFilter.panel = panel;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    },
    set: function set(filter) {
      this.currentFilter.filter = filter;
    }
  }, {
    key: 'filters',
    get: function get() {
      return this.FiltersService.filters;
    }
  }]);

  return SidebarController;
}();

function SidebarComponent() {
  return {
    restrict: 'E',
    template: __webpack_require__(967),
    scope: true,
    controller: SidebarController,
    controllerAs: '$ctrl'
  };
}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports = "<div class=\"overflow panel-color\" ng-class=\"{'panel-color-2': $ctrl.panel === 'constructor'}\"><ul class=\"nav nav-pills toolbar-color panel-light\"><li><sc-date-picker time-from=\"$ctrl.currentFilter.timeFrom\" time-to=\"$ctrl.currentFilter.timeTo\"></sc-date-picker></li></ul></div><div class=\"dimensions-super panel-color\" ng-class=\"{'panel-color-2': $ctrl.panel === 'constructor'}\"><sc-sidebar-left ng-if=\"$ctrl.isEditCatalog\"></sc-sidebar-left><bg-splitter ng-if=\"!$ctrl.isEditCatalog\" orientation=\"horizontal\" pos=\"$ctrl.layout.splitters[1]\" name=\"splitter2\"><bg-pane class=\"aggregate-left\" min-size=\"0\"><sc-sidebar-left ng-if=\"!$ctrl.isEditCatalog\"></sc-sidebar-left></bg-pane><bg-pane class=\"aggregate-right\" min-size=\"0\"><sc-filter-dimension ng-if=\"!$ctrl.isEditCatalog\" ng-show=\"$ctrl.panel === 'constructor' || $ctrl.panel === 'catalog'\"></sc-filter-dimension></bg-pane></bg-splitter></div>"

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scViewModule = undefined;

var _core = __webpack_require__(60);

var _filter = __webpack_require__(331);

var _catalogViewNode = __webpack_require__(969);

var _catalogView = __webpack_require__(972);

var _frameView = __webpack_require__(975);

var _quadView = __webpack_require__(979);

var _quadLastScreenshots = __webpack_require__(982);

var _facts = __webpack_require__(333);

var _stat = __webpack_require__(341);

var _shared = __webpack_require__(343);

var _reportFrameView = __webpack_require__(985);

var _view = __webpack_require__(987);

var _viewTabs = __webpack_require__(990);

var _dashboard = __webpack_require__(993);

var _dashboardNode = __webpack_require__(996);

var _resizeHandler = __webpack_require__(999);

var _filterPreview = __webpack_require__(1002);

var _card = __webpack_require__(1005);

var _cardAccount = __webpack_require__(1008);

var _filterView = __webpack_require__(1011);

var _onScroll = __webpack_require__(1014);

var _chatViewerNode = __webpack_require__(1015);

var _chatViewer = __webpack_require__(1018);

// import { CatalogViewSearchComponent } from '../view/catalog/catalog-view-search.component';
// import { CatalogNodeDragService } from '../view/catalog/catalog-node-drag.service';

var scViewModule = exports.scViewModule = 'sc-view';

angular.module(scViewModule, [_facts.scFactsModule, _stat.scStatModule, _core.scCoreModule, _filter.scFilterModule, _shared.scSharedModule])
// .service('CatalogNodeDragService', CatalogNodeDragService)
// .component('scCatalogViewSearch', CatalogViewSearchComponent)
.component('scCatalogViewNode', _catalogViewNode.CatalogViewNodeComponent).component('scCatalogView', _catalogView.CatalogViewComponent).component('scQuadView', _quadView.QuadViewComponent).component('scQuadLastScreenshots', _quadLastScreenshots.QuadLastScreenshotsComponent).component('scFrameView', _frameView.FrameViewComponent).component('scReportFrameView', _reportFrameView.ReportFrameViewComponent).component('scView', _view.ViewComponent).component('scViewTabs', _viewTabs.ViewTabsComponent).component('scDashboard', _dashboard.DashboardComponent).component('scDashboardNode', _dashboardNode.DashboardNodeComponent).component('scResizeHandler', _resizeHandler.ResizeHandlerComponent).component('scFilterPreview', _filterPreview.FilterPreviewComponent).component('scCard', _card.CardComponent).component('scCardAccount', _cardAccount.CardAccountComponent).component('scFilterView', _filterView.FilterViewComponent).directive('onScroll', _onScroll.OnScroll).directive('scChatViewerNode', _chatViewerNode.ChatViewerNodeComponent).component('scChatViewer', _chatViewer.ChatViewerComponent);

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogViewNodeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterMode = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(970);

var CatalogViewNodeController = function () {
  function CatalogViewNodeController($q, $scope, FilterEditorService, FilterCardEditorModalService, FilterDataFactory, PermissionService, RouterService, LayoutService, CatalogNodeDragService) {
    var _this = this;

    _classCallCheck(this, CatalogViewNodeController);

    this.$q = $q;
    this.FilterEditorService = FilterEditorService;
    this.FilterCardEditorModalService = FilterCardEditorModalService;
    this.filterData = FilterDataFactory();
    this.permission = PermissionService;
    this.router = RouterService;
    this.drag = CatalogNodeDragService;
    this.layout = LayoutService;
    this.showReport = this.layout.openAll;
    // this.searchedFilters = CatalogNodeDragService.searchedFilters;
    $scope.$watch('$ctrl.layout.openAll', function () {
      return _this.showReport = _this.layout.openAll > 0;
    });
  }

  _createClass(CatalogViewNodeController, [{
    key: '$postLink',
    value: function $postLink() {
      this.showReport = this.filter && this.filter.isCatalog;
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.showReport = !this.showReport;
    }
  }, {
    key: 'needToShowFilter',
    value: function needToShowFilter(filter) {
      if (!this.layout.searchedFilters.all) {
        if (this.layout.searchedFilters[filter.id]) {
          this.showReport = true;
          return true;
        } else return false;
      }
      return true;
    }
  }, {
    key: 'editFilter',
    value: function editFilter() {
      return this.FilterEditorService.editModal({
        filter: this.filter,
        asNew: false,
        selectFilter: false
      });
    }
  }, {
    key: 'isEditCatalog',
    get: function get() {
      return this.layout.editCatalog;
    }
  }, {
    key: 'filterIcon',
    get: function get() {
      return (0, _filterMode.getFilterIcon)(this.filter);
    }
  }, {
    key: 'filter',
    get: function get() {
      return this._filter;
    },
    set: function set(filter) {
      this._filter = filter;
      this.filterData.update(filter);
    }
  }, {
    key: 'isEditFilter',
    get: function get() {
      // return true;
      return this.permission.policies && (this.permission.filterConstructor || this.filter.isPolitic);
    }
  }]);

  return CatalogViewNodeController;
}();

var CatalogViewNodeComponent = exports.CatalogViewNodeComponent = {
  template: __webpack_require__(971),
  bindings: {
    index: '<',
    model: '<',
    filter: '<'
    // filterBar: '<',
  },
  controller: CatalogViewNodeController
};

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports = "<div class=\"catalog-view-node\"><div id=\"{{$ctrl.filter.id}}\" class=\"catalog-view-node-header catalog-view-normal\" iscontainer=\"{{$ctrl.filter.isContainer? 'true': 'false' }}\" ng-click=\"$ctrl.toggle()\"><div ng-class=\"{'parent': $ctrl.filter.children.length, 'child': !$ctrl.filter.children.length}\"><i class=\"icon\" ng-class=\"{'icon-plus-1': !$ctrl.showReport, 'icon-minus': $ctrl.showReport}\" ng-if=\"$ctrl.filter.children.length\"></i> <i ng-if=\"!$ctrl.filter.children.length\" class=\"child-icon\" ng-class=\"$ctrl.filterIcon\"></i> <span>{{$ctrl.filter.name}}</span> <i ng-if=\"$ctrl.isEditFilter\" style=\"padding-right:5px\" class=\"icon-cog\" ng-click=\"$ctrl.editFilter(filter); $event.stopPropagation();\" title=\"{{:: 'Свойства фильтра' | gettext }}\"></i></div></div><div class=\"filter-view-container\" ng-if=\"$ctrl.showReport && !$ctrl.filter.isCatalog \"><sc-filter-view filter=\"$ctrl.filter\" ng-if=\"!$ctrl.filter.isCard\" filter-data=\"$ctrl.filterData\" maximize-frame=\"true\" show-facts-info=\"false\" load-more=\"false\"></sc-filter-view></div><div ng-if=\"$ctrl.showReport &&  $ctrl.filter.children\"><div ng-repeat=\"filter in $ctrl.filter.children\" class=\"filter-node\"><sc-catalog-view-node index=\"$index\" model=\"$ctrl.model\" filter=\"filter\"></sc-catalog-view-node></div></div></div>"

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(973);

var CatalogViewController = function CatalogViewController(CatalogNodeDragService, $element) {
  _classCallCheck(this, CatalogViewController);

  this.drag = CatalogNodeDragService;
};

var CatalogViewComponent = exports.CatalogViewComponent = {
  template: __webpack_require__(974),
  bindings: {
    model: '<',
    filter: '<',
    filters: '<'
  },
  controller: CatalogViewController,
  transclude: true
};

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports = "<div class=\"for-save-as-image catalog-view container-fluid\"><sc-catalog-view-node ng-repeat=\"filter in $ctrl.filter.children\" model=\"$ctrl.model\" filter=\"filter\"></sc-catalog-view-node></div>"

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrameViewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-template-curly-in-string: "off"*/
var waitHtml = __webpack_require__(976).replace('${message}', gettext('Пожалуйста, подождите.'));

__webpack_require__(977);

var FrameViewController = function () {
  function FrameViewController($scope, $timeout, $element, $compile, $http, $cookies, md5, rx, RouterService, FrameLoadService) {
    var _this = this;

    _classCallCheck(this, FrameViewController);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.$compile = $compile;
    this.RouterService = RouterService;
    this.FrameLoadService = FrameLoadService;
    this.$http = $http;
    this.$cookies = $cookies;
    this.md5 = md5;

    this.handleOnLoad = false;
    this.reload = false;

    this.$scope.$on('beforePrint', function () {
      _this.beforePrint();
    });

    // $('sc-frame-view iframe').contents().on('click', e => jQuery( "body" ).trigger( jQuery.Event( "click" ) ))

    this.$scope.$on('afterPrint', function () {
      _this.afterPrint();
    });
    var subscriptions = [rx.Observable.merge($scope.$toObservable('$ctrl.src'), $scope.$toObservable('$ctrl.maximize'), $scope.$eventToObservable('reload').do(function () {
      _this.reload = true;
      //console.log('frame reload');
    })).debounce(200).subscribe(function () {
      _this.updateSrc();
    })];
    // $scope.$watch('$ctrl.src', (value) => {
    //   console.log('frame source changed', value);
    // });
    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (s) {
        return s.dispose();
      });
      if (_this.iframe) {
        _this.FrameLoadService.removeFrame(_this.iframe[0]);
      }
    });
  }

  _createClass(FrameViewController, [{
    key: '$onInit',
    value: function $onInit() {}
  }, {
    key: '$onDestroy',
    value: function $onDestroy() {}
  }, {
    key: 'updateSrc',
    value: function updateSrc() {
      var _this2 = this;

      //console.log('frame update src');
      if (this.iframe) {
        var src = this.iframe[0].contentWindow.document.location.pathname + this.iframe[0].contentWindow.document.location.search;
        if (this.src === src && !this.reload) {
          return;
        }
        //console.log('frame removed');
        this.iframe[0].removeEventListener('load', this.onload);
        this.FrameLoadService.removeFrame(this.iframe[0]);
        this.iframe.remove();
        this.iframe = null;
      }
      this.reload = false;
      if (!this.src || typeof this.maximize === 'undefined') {
        return;
      }
      if (this.maximize) {
        this.iframe = angular.element('<iframe id= "iframe" frameborder="0" scrolling="no"></iframe>');
      } else {
        this.iframe = angular.element('<iframe id= "iframe" frameborder="0" class="maximize"></iframe>');
      }
      this.$element.append(this.iframe);
      var frame = this.iframe[0];
      this.FrameLoadService.addFrame(frame);
      frame.contentWindow.document.body.innerHTML = waitHtml;
      frame.RouterService = this.RouterService;

      if (_config.IS_IE_BROWSER) {

        // For IE we doing following trick:
        // POST QueryString to separate handler with by md5 hash as key
        // This handler will store QueryString to cache
        // After that load frame with ?hash=XXXX param
        // This param handled by django middleware and change request.GET to cached value

        var parts = this.src.split('?');
        var url = parts[0];
        var body = parts[1];

        if (body) {
          var hash = this.md5.createHash(body);
          var req_params = {};

          req_params['headers'] = {
            'X-CSRFToken': this.$cookies.get('csrftoken'),
            'Content-Type': 'application/x-www-form-urlencoded'
          };

          this.$http.post('/analytics/reg_body/?h=' + hash, body, req_params).then(function (_ref) {
            var data = _ref.data,
                status = _ref.status,
                headers = _ref.headers,
                config = _ref.config;

            frame.src = url + '?hash=' + hash;
          });
        } else {
          frame.src = this.src;
        }
      } else {
        frame.src = this.src;
      }

      this.onload = function () {

        //***************************************** // in order to close menu
        frame.contentWindow.document.addEventListener('click', function (e) {

          $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu
        });

        if (_this2.onFrameLoad) {
          _this2.onFrameLoad({
            frame: frame
          });
        }

        frame.setAttribute('sc-loaded', true);
        if (_this2.maximize) {
          frame.style['min-height'] = Math.max(_this2.minHeight || 0, frame.contentDocument.body.scrollHeight) + 'px';
          frame.style['min-width'] = frame.contentDocument.body.scrollWidth + 'px';
        }
        if (!frame.contentWindow) {
          return;
        }

        if (_this2.handleOnLoad) {
          var _src = frame.contentWindow.document.location.pathname + frame.contentWindow.document.location.search;
          if (_this2.src !== _src) {
            _this2.src = _src;
            _this2.RouterService.openFrame(_src);
            _this2.$scope.$root.$digest();
          }

          frame.contentWindow.document.addEventListener('click', function (e) {
            $('body sc-header').trigger($.Event('mousedown')).trigger($.Event('click')); // in order to close menu
            var node = e.target;
            while (node && node.localName !== 'a') {
              node = node.parentNode;
            }
            if (node && node.href && (node.href.startsWith('/') || node.href.startsWith('http'))) {
              var _src2 = node.pathname + node.search;
              _this2.RouterService.openFrame(_src2);
              e.preventDefault();
              _this2.$scope.$root.$digest();
              return false; // stop handling the click
            }
            return true;
          });
        }
      };

      this.iframe[0].addEventListener('load', this.onload, false);

      if (this.onFrameCreate) {
        this.onFrameCreate({
          frame: frame
        });
      }
    }
  }, {
    key: 'beforePrint',
    value: function beforePrint() {
      if (!this.iframe) {
        return;
      }
      if (this.maximize) {
        this.iframe[0].style.height = this.iframe[0].contentDocument.body.scrollHeight + 'px';
        this.iframe[0].style.width = this.iframe[0].contentDocument.body.scrollWidth + 'px';
        this.iframe[0].setAttribute('scrolling', 'no');
      } else {
        this.iframe[0].style.height = this.iframe.width() * 0.618 + 'px';
      }
    }
  }, {
    key: 'afterPrint',
    value: function afterPrint() {
      if (!this.iframe) {
        return;
      }
      this.iframe[0].style.removeProperty('height');
      this.iframe[0].style.removeProperty('width');
      if (this.maximize) {
        this.iframe[0].removeAttribute('scrolling');
      }
    }
  }]);

  return FrameViewController;
}();

var FrameViewComponent = exports.FrameViewComponent = {
  template: __webpack_require__(978),
  bindings: {
    src: '<',
    maximize: '<',
    minHeight: '<?',
    onFrameCreate: '&?',
    onFrameLoad: '&?',
    handleOnLoad: '<?'
  },
  controller: FrameViewController
};

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports = "<!DOCTYPE html><html><head><meta http-equiv=\"content-type\" content=\"text/html; charset=utf-8\"><style>body,html{height:100%;overflow:hidden}.center{position:absolute;top:40%;text-align:center;width:100%;margin:0 auto;font-family:arial,sans-serif;font-size:14px}.spinner{width:40px;height:40px;background-color:#333;margin:0 auto;-webkit-animation:sk-rotateplane 1.2s infinite ease-in-out;animation:sk-rotateplane 1.2s infinite ease-in-out}@-webkit-keyframes sk-rotateplane{0%{-webkit-transform:perspective(120px)}50%{-webkit-transform:perspective(120px) rotateY(180deg)}100%{-webkit-transform:perspective(120px) rotateY(180deg) rotateX(180deg)}}@keyframes sk-rotateplane{0%{transform:perspective(120px) rotateX(0) rotateY(0);-webkit-transform:perspective(120px) rotateX(0) rotateY(0)}50%{transform:perspective(120px) rotateX(-180.1deg) rotateY(0);-webkit-transform:perspective(120px) rotateX(-180.1deg) rotateY(0)}100%{transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg);-webkit-transform:perspective(120px) rotateX(-180deg) rotateY(-179.9deg)}}</style></head><body><div class=\"center\"><div class=\"spinner\"></div><br>${message}</div></body></html>"

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports = "<div style=\"z-index:-1\" class=\"maximize frameOverlay\"></div>"

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuadViewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(980);

var QuadViewController = function () {
  function QuadViewController($scope, $timeout, $element, FrameLoadService, AggregateDataService, RouterService) {
    var _this = this;

    _classCallCheck(this, QuadViewController);

    this.sep = _config.PATH_STRING_SEPARATOR;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$element = $element;
    this.AggregateDataService = AggregateDataService;
    this.router = RouterService;
    this.maxFrameInndex = -1;
    this.$scope.$watch('$ctrl.AggregateDataService.remoteUsers', function () {
      _this.frames = _this.getFrames();
    });
    this.frames = this.getFrames();
  }

  _createClass(QuadViewController, [{
    key: 'maximizeToggle',
    value: function maximizeToggle(e, i) {
      this.maxFrameInndex = this.maxFrameInndex == -1 ? i : -1;
      this.$scope.$apply();
    }
  }, {
    key: 'removeFrame',
    value: function removeFrame(frame) {
      this.AggregateDataService.allRemoteUsers = this.AggregateDataService.allRemoteUsers.filter(function (u) {
        return !(u.hwid === frame.hwid && u.sid === frame.sid);
      });
      this.AggregateDataService.updateRemoteUsers();
    }
  }, {
    key: 'getFrames',
    value: function getFrames() {
      var frames = [];
      var maxLen = this.framesQty;
      // let i = 0;
      this.AggregateDataService.remoteUsers.forEach(function (u, i) {
        if (i >= maxLen) return;
        var name = u['full_name'] ? u.user + ' (' + u['full_name'] + ')' : u.user;
        if (u['computer_name']) name = u['computer_name'] + ' -> ' + name;
        frames.push({
          name: name,
          uName: u.user,
          hwid: u.hwid,
          computer: u.computer,
          sid: u.sid,
          url: '/remote/?hwid=' + u.hwid + '/' + u.sid
        });
      });

      frames.fill({
        name: null,
        url: null
      }, this.AggregateDataService.remoteUsers.length, maxLen);
      // this.showData();
      return frames.sort(function (a, b) {
        return a.uName < b.uName ? -1 : a.uName > b.uName ? 1 : a.computer < b.computer ? -1 : 1;
      });
    }
  }, {
    key: 'frameClass',
    value: function frameClass(i) {
      // return 'size-' + this.framesQty;
      if (this.maxFrameInndex === -1) return 'size-' + this.framesQty;
      return this.maxFrameInndex === i ? 'size-1' : 'size-0';
    }
  }, {
    key: 'framesQty',
    get: function get() {
      if (this.AggregateDataService.remoteUsers.length < 3) return this.AggregateDataService.remoteUsers.length;
      if (this.AggregateDataService.remoteUsers.length < 5) return 4;
      if (this.AggregateDataService.remoteUsers.length < 7) return 6;
      if (this.AggregateDataService.remoteUsers.length < 9) return 8;
      if (this.AggregateDataService.remoteUsers.length < 13) return 12;
      return 15;
    }
  }]);

  return QuadViewController;
}();

var QuadViewComponent = exports.QuadViewComponent = {
  template: __webpack_require__(981),
  bindings: {},
  controller: QuadViewController
};

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports = "<div ng-repeat=\"frame in $ctrl.frames\" ng-class=\" $ctrl.frameClass($index)\" class=\"f-col span\"><div class=\"frame-head\"><b>{{frame.name}}</b> <i ng-click=\"$ctrl.removeFrame(frame)\" class=\"icon-cancel\" title=\"{{:: 'Закрыть' | gettext }}\"></i> <i ng-click=\"$ctrl.maxFrameInndex = -1\" ng-if=\"$ctrl.maxFrameInndex != -1\" class=\"icon-resize-small-alt\" title=\"{{:: 'Восстановить' | gettext }}\"></i> <i ng-click=\"$ctrl.maxFrameInndex = $index\" ng-if=\"$ctrl.maxFrameInndex == -1\" class=\"icon-resize-full-alt\" title=\"{{:: 'Развернуть' | gettext }}\"></i></div><sc-frame-view ng-if=\"frame.url\" src=\"frame.url\" class=\"sc-view-container\" maximize=\"true\" handle-on-load=\"false\"></sc-frame-view></div>"

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuadLastScreenshotsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _config = __webpack_require__(21);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(983);

var QuadLastScreenshotsController = function () {
  function QuadLastScreenshotsController($scope, $rootScope, $interval, $element, CurrentFilterDataService, FrameLoadService, CurrentFilterService, RouterService) {
    var _this = this;

    _classCallCheck(this, QuadLastScreenshotsController);

    this.sep = _config.PATH_STRING_SEPARATOR;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.RouterService = RouterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.reloading = false;

    $scope.$on('reload', function () {
      _this.reloading = false;
      _this.data = null;
    });

    this.$scope.$watch('$ctrl.CurrentFilterService.filter.filters', function () {
      _this.reloading = false;
      _this.data = null;
    }, true);

    this.$scope.$watch('$ctrl.CurrentFilterService.timeFrom', function () {
      _this.reloading = false;
      _this.data = null;
    }, true);

    this.CurrentFilterService = CurrentFilterService;
    this.subscription = this.CurrentFilterDataService.filterData.filterData$.subscribe(function () {
      if (!_this.CurrentFilterService || !_this.CurrentFilterService.lastScreenshots) return;
      _this.setData();
    });
    this.$scope.$on('$destroy', function () {
      return _this.subscription.dispose();
    });
    $interval(function () {
      return _this.reload();
    }, 7000);
  }

  _createClass(QuadLastScreenshotsController, [{
    key: 'reload',
    value: function reload() {
      if (!this.reloading || !this.CurrentFilterService || !this.CurrentFilterService.lastScreenshots) return;
      this.CurrentFilterService.lastScreenshots.timeFrom = new Date(new Date() - 1000 * 60 * 60);
      // console.log('lastScreenshots = ', this.CurrentFilterService.lastScreenshots);
      this.CurrentFilterDataService.reload();
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _this2 = this;

      if (this.data) {
        var keys = Object.keys(this.CurrentFilterDataService.filterData.filterData);
        keys.map(function (key) {
          if (!_this2.reloading || _this2.data[key]) _this2.data[key] = _this2.CurrentFilterDataService.filterData.filterData[key];
        });
      } else {
        this.data = angular.copy(this.CurrentFilterDataService.filterData.filterData);
        this.reloading = true;
      }
    }
  }, {
    key: 'getHead',
    value: function getHead(key) {
      if (!this.data || !this.data[key]) return '';
      var d = this.data[key];
      return (d.computerName ? d.computerName + ' -> ' : '') + (d.fullName ? d.userName + ' (' + d.fullName + ')' : d.userName);
    }
  }, {
    key: 'getUrl',
    value: function getUrl(key) {
      if (!this.data || !this.data[key]) return '';
      return 'media/' + this.data[key].url;
    }
  }, {
    key: 'getTime',
    value: function getTime(key) {
      if (!this.data || !this.data[key]) return '';
      return this.data[key].localTime;
    }
  }, {
    key: 'removeScreen',
    value: function removeScreen(key) {
      if (this.dataKeys && this.dataKeys.length < 2) {
        this.RouterService.cleanRemoteUsers();
        window.CACHE.reset();
        this.$rootScope.$broadcast('reload');
      } else {
        delete this.data[key];
      }
    }
  }, {
    key: 'isNotLsatScreen',
    get: function get() {
      return this.dataKeys && this.dataKeys.length > 1;
    }
  }, {
    key: 'dataKeys',
    get: function get() {
      return this.data ? Object.keys(this.data) : 0;
    }
  }, {
    key: 'screensQty',
    get: function get() {
      var qty = this.dataKeys.length;
      if (qty < 3) return qty;
      if (qty < 5) return 4;
      if (qty < 7) return 6;
      if (qty < 9) return 8;
      if (qty < 13) return 12;
      return 15;
    }
  }, {
    key: 'screenClass',
    get: function get() {
      return 'size-' + this.screensQty;
    }
  }]);

  return QuadLastScreenshotsController;
}();

var QuadLastScreenshotsComponent = exports.QuadLastScreenshotsComponent = {
  template: __webpack_require__(984),
  bindings: {},
  controller: QuadLastScreenshotsController
};

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports = "<div ng-repeat=\"key in $ctrl.dataKeys\" ng-class=\"$ctrl.screenClass\" class=\"f-col span\"><div class=\"screen\"><div class=\"screen-head\"><b>{{$ctrl.getHead(key)}}</b> <i ng-click=\"$ctrl.removeScreen(key)\" class=\"icon-cancel\" title=\"{{:: 'Закрыть' | gettext }}\"></i></div><img ng-src=\"{{$ctrl.getUrl(key)}}\" alt=\"last screenshot\"><div class=\"time\">{{$ctrl.getTime(key)}}</div></div></div>"

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportFrameViewController = function () {
  function ReportFrameViewController($scope, rx, CurrentFilterService) {
    var _this = this;

    _classCallCheck(this, ReportFrameViewController);

    var subscriptions = [$scope.$toObservable('$ctrl.filterData').switchMap(function (_ref) {
      var newValue = _ref.newValue;

      if (!newValue) {
        return rx.Observable.empty();
      }
      return rx.Observable.of(_this.filterData.loading).concat(newValue.loading$);
    }).do(function (loading) {
      _this.src = CurrentFilterService.getReportUrl(_this.filterData.filter);
      if (loading) {
        _this.frameLoad = _this.filterData.frameLoad;
        // this.src = CurrentFilterService.getReportUrl(this.filterData.filter);
      }
    }).subscribe(function () {})];
    $scope.$on('$destroy', function () {
      subscriptions.forEach(function (s) {
        return s.dispose();
      });
    });
  }

  _createClass(ReportFrameViewController, [{
    key: 'onFrameCreate',
    value: function onFrameCreate(frame) {
      frame.scClickToUse = this.clickToUse;
    }
  }, {
    key: 'onFrameLoad',
    value: function onFrameLoad(frame) {
      if (this.frameLoad === this.filterData.frameLoad) {
        this.filterData.frameLoad.resolve(null);
      }
    }
  }]);

  return ReportFrameViewController;
}();

var ReportFrameViewComponent = exports.ReportFrameViewComponent = {
  template: __webpack_require__(986),
  bindings: {
    filterData: '<',
    maximize: '<',
    minHeight: '<?',
    clickToUse: '<?'
  },
  controller: ReportFrameViewController
};

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports = "<sc-frame-view class=\"maximize\" src=\"$ctrl.src\" maximize=\"$ctrl.maximize\" min-height=\"$ctrl.minHeight\" on-frame-create=\"$ctrl.onFrameCreate(frame)\" on-frame-load=\"$ctrl.onFrameLoad(frame)\"></sc-frame-view>"

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(988);

var ViewController = function () {
  function ViewController($scope, $element, $rootScope, CurrentFilterService, CurrentModelService, CurrentFilterDataService, PermissionService, RouterService, LayoutService) {
    _classCallCheck(this, ViewController);

    this.$scope = $scope;
    this.$element = $element;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  _createClass(ViewController, [{
    key: 'getHeightPx',
    value: function getHeightPx() {
      if (this.layout.isPrint && this.filter.isAnalysis) {
        return this.$element.width() * 0.618;
      }
    }
  }, {
    key: 'getHeight',
    value: function getHeight() {
      var height = this.getHeightPx();
      if (!height) {
        return '100%';
      }
      return height + 'px';
    }
  }, {
    key: 'isDashbordOrCard',
    get: function get() {
      return this.filter && (this.filter.isCard || this.filter.isDashboard);
    }
  }, {
    key: 'filter',
    get: function get() {
      // console.log(this.CurrentFilterService.filter);
      return this.CurrentFilterService.filter;
    }
  }, {
    key: 'filterBar',
    get: function get() {
      return this.CurrentFilterService.filterBar;
    }
  }, {
    key: 'isShowFilter',
    get: function get() {
      return this.filterEdit && this.router.isFilterEditModal || !this.filterEdit && !this.router.isFilterEditModal;
    }
  }, {
    key: 'isShowStatHeader',
    get: function get() {
      return !this.frameUrl && !this.isRemoteUsers && this.filter && !this.filter.isDashboard && !this.filter.isCard && !this.filter.isReport && (this.filter.isGraph || this.filter.isAnalysis) && !this.filter.isStat;
    }

    // get isReadOnlyStatHeader() {
    //   return this.filter.isDashboard || this.filter.isCard;
    // }


  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'filterData',
    get: function get() {
      return this.CurrentFilterDataService.filterData;
    }
  }, {
    key: 'frameUrl',
    get: function get() {
      return this.CurrentFilterService.frameUrl;
    },
    set: function set(value) {
      this.CurrentFilterService.frameUrl = value;
    }
  }, {
    key: 'isCatalog',
    get: function get() {
      if (!this.filter) {
        return false;
      }
      return this.CurrentFilterService.panel !== 'constructor' && this.filter.isCatalog;
    }
  }, {
    key: 'isShowQuad',
    get: function get() {
      return this.router && (this.router.isRemoteUsers || this.router.isLastScreenshots);
    }
  }]);

  return ViewController;
}();

var ViewComponent = exports.ViewComponent = {
  template: __webpack_require__(989),
  bindings: {
    filterEdit: '<'
  },
  controller: ViewController
};

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports = "<sc-view-tabs></sc-view-tabs><table ng-if=\"$ctrl.isShowStatHeader && !$ctrl.isShowQuad\"><thead sc-stat-header filter-data=\"$ctrl.filterData\" filter=\"$ctrl.filter\"></thead></table><div ng-if=\"!$ctrl.frameUrl && !$ctrl.isShowQuad\" class=\"sc-view-container\" ng-style=\"{'height': $ctrl.getHeight()}\" ng-class=\"{'sc-view-container-fit': ($ctrl.filter.isReport  || $ctrl.isCatalog ),\n              'sc-view-container-fit-card' :  $ctrl.isDashbordOrCard}\"><sc-filter-view ng-if=\"!$ctrl.isCatalog && !$ctrl.isDashbordOrCard\" model=\"$ctrl.model\" filter-data=\"$ctrl.filterData\" maximize-frame=\"false\" show-facts-info=\"true\" load-more=\"true\" class=\"maximize\" print-resize=\"true\"></sc-filter-view><sc-catalog-view ng-if=\"($ctrl.isCatalog) && !$ctrl.isDashbordOrCard\" model=\"$ctrl.model\" filter=\"$ctrl.filter\" filter-bar=\"$ctrl.filterBar\" filters=\"$ctrl.CurrentFilterService.FiltersService.filters\"></sc-catalog-view><sc-dashboard ng-if=\"$ctrl.isDashbordOrCard\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" class=\"for-save-as-image maximize\"></sc-dashboard></div><sc-frame-view ng-if=\"$ctrl.frameUrl\" src=\"$ctrl.frameUrl\" class=\"sc-view-container\" maximize=\"false\" handle-on-load=\"true\"></sc-frame-view><sc-quad-view ng-if=\"$ctrl.router.isRemoteUsers\"></sc-quad-view><sc-quad-last-screenshots ng-if=\"$ctrl.router.isLastScreenshots\"></sc-quad-last-screenshots>"

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewTabsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(991);

var ViewTabsController = function () {
  function ViewTabsController($scope, $q, $element, FilterEditorService, CurrentFilterService, PermissionService, LayoutService, RouterService, ErrorHandlerService, AggregateDataService) {
    var _this = this;

    _classCallCheck(this, ViewTabsController);

    this.$scope = $scope;
    this.$q = $q;
    this.$element = $element;
    this.FilterEditorService = FilterEditorService;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.AggregateDataService = AggregateDataService;
    this.layout.openAll = false;
    this.limit = '';
    this.limitTitle = '';
    this.typeDim = 'agent_eventtype@default:agent_eventtype';
    this.$scope.$watch('$ctrl.filter.customLimit', function () {
      if (!_this.filter) return;
      _this.limitTitle = gettext('Ограничение записей в запросе: ') + _this.filter.limit;
      _this.customLimit = _this.filter.customLimit;
    });
  }

  _createClass(ViewTabsController, [{
    key: 'setThumblistFilters',
    value: function setThumblistFilters() {
      var _this2 = this;

      var typeCount = 0;
      this.filter.filters = this.filter.filters.filter(function (f) {
        var goodType = f.dimension === _this2.typeDim && (f.value === '4' || f.value === '20');
        if (goodType) typeCount += 1;
        return goodType || f.dimension !== _this2.typeDim;
      });
      if (!typeCount) {
        this.filter.cleanFilter('agent_eventtype@default:agent_eventtype');
        this.filter.addFilter('agent_eventtype@default:agent_eventtype', '4', gettext('Снимок экрана'));
        this.filter.addFilter('agent_eventtype@default:agent_eventtype', '20', gettext('Снимок с веб-камеры'));
        this.CurrentFilterService.rebuildVisibleDimensions();
        this.router.filterChanged();
      }
    }
  }, {
    key: 'pressEnter',
    value: function pressEnter(event) {
      if (event.keyCode === 13) {
        this.updateCustomLimit();
      }
    }
  }, {
    key: 'updateCustomLimit',
    value: function updateCustomLimit() {
      if (this.isFilterEdit) this.filter.customLimit = this.customLimit;else this.router.setLimit(this.limit);
    }
  }, {
    key: 'nop',
    value: function nop(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: 'renewFilter',
    value: function renewFilter() {
      var _this3 = this;

      this.CurrentFilterService.reset();
      Object.keys(this.filter).map(function (k) {
        if (k != 'filters') delete _this3.filter[k];
      });
      Object.assign(this.filter, new _filter.Filter());
    }
  }, {
    key: 'setMode',
    value: function setMode(mode) {
      // if (this.isFilterEdit && this.filterData) this.filterData.filter.setMode(mode);
      // else {
      // this.router.mode = mode;
      if (this.isDashbordOrCard || this.frameUrl) this.renewFilter();
      this.filter.setMode(mode);
      this.router.filter = this.filter;
      // }
    }
  }, {
    key: 'setList',
    value: function setList(listType) {
      // if (this.isFilterEdit && this.filterData) {
      //   this.setMode('explore');
      //   this.filterData.filter.listType = listType;
      // } else {
      if (this.isDashbordOrCard || this.frameUrl) this.renewFilter();
      if (listType === 'thumblist') this.setThumblistFilters();
      this.filter.listType = listType;
      this.filter.mode = 'explore';
      this.router.filter = this.filter;

      // else this.router.listType = listType;
      // }
    }
  }, {
    key: 'setChatViewer',
    value: function setChatViewer() {
      this.setList('chat-viewer');
    }
  }, {
    key: 'generateReport',
    value: function generateReport(url) {
      if (this.isDashbordOrCard) this.renewFilter();
      if (this.isFilterEdit && this.filterData) {
        this.setMode('reports');
        this.filterData.filter.url = url;
      } else this.router.generateReport(url);
    }
  }, {
    key: 'openAll',
    value: function openAll() {
      if (this.layout.openAll < 0) this.layout.openAll = 0;
      this.layout.openAll += 1;
    }
  }, {
    key: 'closeAll',
    value: function closeAll() {
      if (this.layout.openAll > 0) this.layout.openAll = 0;
      this.layout.openAll -= 1;
    }

    // toggleEditDasboard() {
    //   this.router.isEditDasboard = !this.router.isEditDasboard;
    // }

  }, {
    key: 'toggleEditCatalog',
    value: function toggleEditCatalog() {
      this.layout.editCatalog = !this.layout.editCatalog;
    }
  }, {
    key: 'newFilterToDasboard',
    value: function newFilterToDasboard() {
      var _this4 = this;

      var filter = this.CurrentFilterService.createNewFilter();
      filter.cardWidth = 12;
      filter.cardHeight = 6;
      // filter.filters = angular.copy(this.CurrentFilterService.filter.filters);
      this.router.isEditDasboard = true;
      // this.CurrentFilterService.newDasboardFilter = filter;
      return this.$q.resolve().then(function () {
        return _this4.FilterEditorService.editModal({
          filter: filter,
          asNew: false,
          selectFilter: false
        });
      }).then(function (newFilter) {});
    }
  }, {
    key: 'showWords',
    get: function get() {
      return this.$element.width() > 638;
    }
  }, {
    key: 'customLimit',
    set: function set(limit) {
      var l = parseInt(limit, 10);
      if (isNaN(l) || !l) this.limit = '';else this.limit = l;
    },
    get: function get() {
      return this.limit;
    }
  }, {
    key: 'isFilterEdit',
    get: function get() {
      return this.router.isFilterEditModal;
    }
  }, {
    key: 'isDashbordOrCard',
    get: function get() {
      return this.filter && this.filter.id && (this.filter.isCard || this.filter.isDashboard);
    }
  }, {
    key: 'filter',
    get: function get() {
      // return this.CurrentFilterService.filter;
      return this.isFilterEdit && this.filterData ? this.filterData.filter : this.CurrentFilterService.filter;
    }
  }, {
    key: 'mode',
    get: function get() {
      return this.isFilterEdit && this.filterData ? this.filterData.filter.mode : this.router.mode;
    }
  }, {
    key: 'isShowLimit',
    get: function get() {
      return true;
    }
  }, {
    key: 'frameUrl',
    get: function get() {
      return this.CurrentFilterService.frameUrl;
    }
  }, {
    key: 'showFacts',
    get: function get() {
      return !!(this.permission.fact && this.filter && !this.filter.send_threshold);
    }
  }, {
    key: 'showAnalyses',
    get: function get() {
      return this.permission.analyses;
    }
  }, {
    key: 'showTimeTracking',
    get: function get() {
      return !!(this.permission.schedule && this.filter && !this.filter.send_threshold);
    }
  }, {
    key: 'showReports',
    get: function get() {
      return !!(this.permission.reports && this.filter && !this.filter.send_threshold);
    }
  }, {
    key: 'listType',
    get: function get() {
      return this.isFilterEdit && this.filterData ? this.filterData.filter.listType : this.router.listType;
    }
  }, {
    key: 'isEditCatalog',
    get: function get() {
      return !!this.layout.editCatalog;
    }
  }]);

  return ViewTabsController;
}();

var ViewTabsComponent = exports.ViewTabsComponent = {
  template: __webpack_require__(992),
  bindings: {
    filterData: '<'
  },
  controller: ViewTabsController
};

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"nav nav-pills container-fluid toolbar-color\"><li ng-if=\"$ctrl.showFacts\" class=\"dropdown\"><a class=\"dropdown-toggle\"><i class=\"icon-list-bullet\"></i> <span ng-if=\"$ctrl.showWords\" class=\"hideable\">{{:: 'События' | gettext }}</span> <i class=\"icon-down-dir\"></i></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'table'}\"><a ng-click=\"$ctrl.setList('table')\" title=\"{{::'Таблица' | gettext}}\"><i class=\"icon-table\"></i> <span>{{::'Таблица' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'brief'}\"><a ng-click=\"$ctrl.setList('brief')\" title=\"{{::'Cписок' | gettext}}\"><i class=\"icon-th-list\"></i> <span>{{::'Cписок' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isExplore && $ctrl.filter.listType === 'thumblist'}\"><a ng-click=\"$ctrl.setList('thumblist')\" title=\"{{::'Снимки экрана' | gettext}}\"><i class=\"icon-file-image\"></i> <span>{{::'Cнимки' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isReport}\"><a ng-click=\"$ctrl.setMode('report')\" title=\"{{::'Тепловая диаграмма' | gettext}}\"><i class=\"icon-grid\"></i> <span>{{::'Активность' | gettext}}</span></a></li><li><a ng-click=\"$ctrl.setChatViewer();\" title=\"{{::'Посмотреть переписку пользователя' | gettext}}\"><i class=\"icon-chat\"></i> <span>{{::'Переписка' | gettext}}</span></a></li></ul></li><li ng-if=\"$ctrl.showAnalyses\" class=\"dropdown\"><a class=\"dropdown-toggle\"><i class=\"icon-chart-line\"></i> <span ng-if=\"$ctrl.showWords\" class=\"hideable\">{{:: 'Анализ' | gettext }}</span> <i class=\"icon-down-dir\"></i></a><ul class=\"dropdown-menu\" role=\"menu\"><li ng-class=\"{'pane-tab-active': $ctrl.filter.isStat}\"><a ng-click=\"$ctrl.setMode('stat')\"><i class=\"icon-table\"></i> <span>{{::'Таблица' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isChartArea}\"><a ng-click=\"$ctrl.setMode('chart-area')\"><i class=\"icon-chart-bar\"></i> <span>{{::'Линейный график' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isChart}\"><a ng-click=\"$ctrl.setMode('chart')\"><i class=\"icon-chart\"></i> <span>{{::'Круговая диаграмма' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isRadar}\"><a ng-click=\"$ctrl.setMode('radar')\"><i class=\"icon-radar\"></i> <span>{{::'Радар' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isEventRiver}\"><a ng-click=\"$ctrl.setMode('event-river')\"><i class=\"icon-river\"></i> <span>{{::'Река событий' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.mode === 'reports'}\"><a ng-click=\"$ctrl.generateReport('/analytics/report/graph/wizard/')\"><i class=\"icon-share\"></i> <span>{{::'Граф' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isTree}\"><a ng-click=\"$ctrl.setMode('tree')\"><i class=\"icon-flow-split\"></i> <span>{{::'Дерево' | gettext}}</span></a></li><li ng-class=\"{'pane-tab-active': $ctrl.filter.isSummStat}\"><a ng-click=\"$ctrl.setMode('summ-stat')\"><i class=\"icon-summ\"></i> <span>{{::'Статистика' | gettext}}</span></a></li></ul></li><li ng-if=\"$ctrl.showTimeTracking\" class=\"dropdown\"><a class=\"dropdown-toggle\"><i class=\"icon-clock\"></i> <span ng-if=\"$ctrl.showWords\" class=\"hideable\">{{:: 'Учет времени' | gettext }}</span> <i class=\"icon-down-dir\"></i></a><ul class=\"dropdown-menu\"><li><a ng-click=\"$ctrl.generateReport('/analytics/report/aggregate/index/')\">{{:: 'Комбинированный отчет' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/aggregate/index/?table=false')\">{{:: 'Ленточный график' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/aggregate/index/?lenta=false')\">{{:: 'Таблица' | gettext }}</a></li><li class=\"divider\"></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/activity/')\">{{:: 'Отчет по активности за период' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/product_time_report/')\">{{:: 'Продуктивное время по отделам' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/active_time_report/')\">{{:: 'Активное время по отделам' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/unproductive_time/')\">{{:: 'Топ непродуктивности по отделам' | gettext }}</a></li><li class=\"divider\"></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/summary/')\">{{:: 'Сводный отчёт' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/summary_by_group/')\">{{:: 'Сводный отчёт по группам' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/summary_statistic/')\">{{:: 'Сводный статистический отчёт' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/latecomers/')\">{{:: 'Отчёт по опозданиям' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/departure_time_report/')\">{{:: 'Учёт ранних уходов и приходов' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/departure_time_report_by_group/')\">{{:: 'Учёт ранних уходов и приходов по группам' | gettext }}</a></li><li class=\"divider\"></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/tabel/extended/')\">{{:: 'Расширенный табель учёта рабочего времени' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/tabel/workinghours/')\">{{:: 'Табель рабочего времени' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/tabel/activetime/')\">{{:: 'Табель активного времени' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/tabel/torturernocount/')\">{{:: 'Табель отсутствия на рабочем месте' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/tabel/printerusage/')\">{{:: 'Табель использования принтера' | gettext }}</a></li></ul></li><li ng-if=\"$ctrl.showReports\" class=\"dropdown\"><a class=\"dropdown-toggle\"><i class=\"icon-reports\"></i> <span ng-if=\"$ctrl.showWords\" class=\"hideable\">{{:: 'Отчеты' | gettext }}</span> <i class=\"icon-down-dir\"></i></a><ul class=\"dropdown-menu\"><li ng-if=\"$ctrl.permission.fact\"><a ng-click=\"$ctrl.generateReport('/analytics/report/facts/')\">{{:: 'Лента событий' | gettext }}</a></li><li ng-if=\"$ctrl.permission.fact\"><a ng-click=\"$ctrl.generateReport('/analytics/report/sites/')\">{{:: 'Подробный отчет по активности' | gettext }}</a></li><li class=\"divider\"></li><li><a ng-click=\"$ctrl.generateReport('/analytics/inventory/devices/')\">{{:: 'Инвентаризация - Устройства' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/inventory/apps/')\">{{:: 'Инвентаризация - Приложения' | gettext }}</a></li><li ng-if=\"$ctrl.permission.fact\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.fact\"><a ng-click=\"$ctrl.generateReport('/analytics/report/anomaly/')\">{{:: 'Детектор аномалий' | gettext }}</a></li><li ng-if=\"$ctrl.permission.fact\" class=\"divider\"></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/stat/')\">{{:: 'Сводная статистика' | gettext }}</a></li><li><a ng-click=\"$ctrl.generateReport('/analytics/report/stat/daily/')\">{{:: 'Статистика по дням' | gettext }}</a></li></ul></li><li ng-if=\"$ctrl.isDashbordOrCard && !$ctrl.router.isFilterEditModal\" title=\"{{:: 'Добавить фильтр в дашборд или карточку' | gettext }}\"><a ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" ng-click=\"$ctrl.newFilterToDasboard()\"><i class=\"icon-doc-new\"></i> <span ng-if=\"$ctrl.showWords \" class=\"hideable\">{{:: 'Добавить' | gettext }}</span></a></li><li style=\"float:right\" ng-if=\"$ctrl.isShowLimit\" class=\"control-group\" title=\"{{$ctrl.limitTitle}}\"><span style=\"color:#01174b;vertical-align:sub\" class=\"control-label\">{{:: 'Лимит' | gettext }}:</span> <input style=\"margin:5px 0 0;padding:2px 6px 4px 6px\" type=\"text\" class=\"controls input-mini\" ng-model=\"$ctrl.customLimit\" ng-keyup=\"$ctrl.pressEnter($event)\" ng-blur=\"$ctrl.updateCustomLimit()\"></li></ul>"

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(994);

var DashboardController = function () {
  function DashboardController($scope, $element, $timeout, CurrentFilterService, FilterResource, CurrentFilterDataService, PermissionService, LayoutService, RouterService) {
    var _this = this;

    _classCallCheck(this, DashboardController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.CurrentFilterService = CurrentFilterService;
    this.FilterResource = FilterResource;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.graggingFilter = {};
    this.currentDIndex = 0;
    this.indexes = {};
    this.CurrentFilterDataService = CurrentFilterDataService;
    $scope.$on('$destroy', function () {
      delete _this.CurrentFilterDataService.dashboardData;
    });
    $scope.$on('FilterDataLoaded', function () {
      var el = _this.$element.closest('.sc-view-container');
      if (el[0]) el.scrollTop(0);
    });
  }

  _createClass(DashboardController, [{
    key: 'filterMinimazed',
    value: function filterMinimazed(filter) {
      return filter.cardMinimazed;
    }
  }, {
    key: 'getHeightPx',
    value: function getHeightPx(filter, minimized) {
      if (!filter.cardWidth) return 0;
      if (minimized) return 28;
      var marginHorz = 0.5; // percent
      var marginVert = 7; // px
      if (filter && !filter.cardHeight && !minimized) {
        if (filter.isChart || filter.isChartArea || filter.isTree || filter.isGraph) {
          return Math.round(filter.cardWidth * this.$element.width() * ((1 - 0.01 * marginHorz) / 12) * 0.618);
        }
        return;
      }
      //const marginVert = this.$element.width() * 0.01 * marginHorz; // px
      var headHeight = 41;
      return Math.round(this.$element.width() / 12 * filter.cardHeight - marginVert - 2);

      // return Math.round(this.$element.width() / 12 * (minimized ? 1 : filter.cardHeight) - marginVert - 2);

      // return Math.round(this.$element.width() *
      //   filter.cardHeight * ((1 - 0.13 * marginHorz) / 12) +
      //   marginVert * (filter.cardHeight - 1));
    }
  }, {
    key: 'getHeight',
    value: function getHeight(filter) {
      var height = this.getHeightPx(filter);
      if (!height) {
        return 'auto';
      }
      return height + 'px';
    }
  }, {
    key: 'placeholderHeight',
    value: function placeholderHeight() {
      var height = this.getHeightPx(this.graggingFilter, this.filterMinimazed(this.graggingFilter));
      return height;
    }
  }, {
    key: 'dropCallback',
    value: function dropCallback(srcList, srcIndex, targetList, targetIndex) {
      // console.log(srcList, srcIndex, targetList, targetIndex);

      this.dropPosition = {
        id: srcList[srcIndex].id,
        // parent_id: this.filter.isCard && this.filter.cardFilter? this.filter.cardFilter.id : this.filter.id,
        parent_id: this.filter.id,
        prev_id: targetIndex - 1 >= 0 ? targetList[targetIndex - 1].id : null
      };
      // Copy the item from source to target.
      targetList.splice(targetIndex, 0, srcList[srcIndex]);
      // Remove the item from the source, possibly correcting the index first.
      // We must do this immediately, otherwise ng-repeat complains about duplicates.
      if (srcList == targetList && targetIndex <= srcIndex) srcIndex++;
      srcList.splice(srcIndex, 1);
      // By returning true from dnd-drop we signalize we already inserted the item.
      return true;
    }
  }, {
    key: 'dragStart',
    value: function dragStart(index) {
      // console.log(index);
      this.graggingFilter = this.filter.children[index];
      this.movedIndex = index;
    }
  }, {
    key: 'dragEnd',
    value: function dragEnd() {
      // console.log(this.CurrentFilterService.filter);
      // if (this.filter.isCard && this.filter.cardFilter) this.filter.cardFilter.children = angular.copy(this.filter.children);
      this.router.filter = this.filter;
    }
  }, {
    key: 'showCard',
    get: function get() {
      return !this.filterData.loading && this.filter.filters[0] && !this.filter.isCardAccount;
    }
  }, {
    key: 'showCardAccount',
    get: function get() {
      return !this.filterData.loading && this.filter.filters[0] && this.filter.isCardAccount;
    }
  }, {
    key: 'canChange',
    get: function get() {
      return this.CurrentFilterService.filter.id === this.filter.id;
    }
  }, {
    key: 'isEditDasboard',
    get: function get() {
      return this.router.isEditDasboard && !this.noEdit;
    }
  }]);

  return DashboardController;
}();

var DashboardComponent = exports.DashboardComponent = {
  template: __webpack_require__(995),
  bindings: {
    filter: '<',
    filterData: '<',
    noEdit: '<'
  },
  controller: DashboardController
};

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports = "<div class=\"sc-dashboard-view\"><div ng-if=\"$ctrl.filterData.loading\"><i class=\"icon-loading animate-spin\"></i></div><div ng-if=\"!$ctrl.filterData.loading && !$ctrl.filter.isCardFilter  && $ctrl.filter.isCard\" class=\"err-card\">{{::'Выберите' | gettext }} <u><b>{{::'один' | gettext }}</b></u> {{::'элемент измерения' | gettext }}.</div><sc-card ng-if=\"!$ctrl.filterData.loading && $ctrl.filter.isCardFilter && !$ctrl.filter.isCardAccount\" card=\"$ctrl.filterData.filterData\"></sc-card><sc-card-account ng-if=\"!$ctrl.filterData.loading && $ctrl.filter.isCardFilter && $ctrl.filter.isCardAccount\" card=\"$ctrl.filterData.filterData\"></sc-card-account><div class=\"row-fluid\" dnd-list=\"$ctrl.filter.children\" dnd-disable-if=\"!$ctrl.canChange\" dnd-drop=\"callback({targetList: $ctrl.filter.children, targetIndex: index})\"><sc-dashboard-node ng-repeat=\"filter in $ctrl.filter.children track by $index\" ng-if=\"!filter.deleted\" dnd-draggable=\"filter\" dnd-callback=\"$ctrl.dropCallback($ctrl.filter.children, $index, targetList, targetIndex)\" dnd-dragend=\"$ctrl.dragEnd()\" dnd-dragstart=\"$ctrl.dragStart($index)\" ng-class=\"{'page-break-graph': filter.url==='/analytics/report/graph/wizard/',\n         'page-break-time-tracking': filter.name === 'Карта дня' || filter.name_en === 'Карта дня'}\" class=\"span{{filter.cardWidth}}\" filter=\"filter\"></sc-dashboard-node><div class=\"dndPlaceholder span{{$ctrl.graggingFilter.cardWidth}}\" ng-style=\"{'height': $ctrl.placeholderHeight($ctrl.graggingFilter)}\">{{::'Переместить фильтр сюда' | gettext }}</div></div></div>"

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashboardNodeComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filterMode = __webpack_require__(88);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(997);

var DashboardNodeController = function () {
  function DashboardNodeController($scope, $element, $timeout, $q, CurrentFilterService, CurrentFilterDataService, PermissionService, LayoutService, RouterService, FilterDataFactory, FilterEditorService, FiltersService, $window) {
    _classCallCheck(this, DashboardNodeController);

    this.$scope = $scope;
    this.$element = $element;
    this.$q = $q;
    this.$timeout = $timeout;
    this.$window = $window;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.FilterEditorService = FilterEditorService;
    this.FiltersService = FiltersService;
    if (!CurrentFilterDataService.dashboardData) CurrentFilterDataService.dashboardData = {};
    this.dashboardData = CurrentFilterDataService.dashboardData;
    // this.filterData = FilterDataFactory();
    this.FilterDataFactory = FilterDataFactory;
    // console.log('new node');
  }

  _createClass(DashboardNodeController, [{
    key: 'saveAsPicture',
    value: function saveAsPicture() {
      var _this = this;

      this.layout.saveAsPicture(this.dashboardData[this.filter.dIndex], function (message) {
        _this.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      }, this.$element[0]);
    }
  }, {
    key: 'editFilter',
    value: function editFilter() {
      var _this2 = this;

      this.router.isEditDasboard = true;
      var filter = this.filter;
      return this.$q.resolve().then(function () {
        return _this2.FilterEditorService.editModal({
          filter: filter,
          asNew: false,
          selectFilter: false
        });
      }).then(function (resFilter) {
        _this2.router.isEditDasboard = false;
        if (!resFilter) return;
        _this2.filter = resFilter;
        var index = _this2.dashboard.filter.children.findIndex(function (f) {
          return resFilter.dIndex === f.dIndex;
        });
        if (index == -1) {
          _this2.dashboard.filter.children.push(resFilter);
        } else {
          _this2.dashboard.filter.children[index] = resFilter;
        }
        if (!resFilter.deleted) {
          _this2.dashboardData[_this2.filter.dIndex].update(_this2.filter);
        } else {
          delete _this2.dashboardData[_this2.filter.dIndex];
        }
        _this2.setRouterFilter();
      });
    }
  }, {
    key: 'setRouterFilter',
    value: function setRouterFilter() {
      this.router.filterChanged();
    }
  }, {
    key: 'setFilter',
    value: function setFilter(filter) {
      var _this3 = this;

      // console.log('setFilter', filter.id, filter.name);
      if (filter.id && filter.dIndex && '' + filter.id != filter.dIndex && !filter.deleted) {
        this.dashboardData[filter.id] = this.dashboardData[filter.dIndex];
        // this.dashboardData[this.filter.id].update(this.filter);
        var dIndex = filter.dIndex;
        this.$timeout(function () {
          delete _this3.dashboardData[dIndex];
        }, 500);
      }

      if (filter.id) filter.dIndex = '' + filter.id;
      if (!filter.dIndex || !this._filter) {
        if (!filter.dIndex) {
          this.dashboard.currentDIndex += 1;
          filter.dIndex = this.dashboard.filter.id + '_' + this.dashboard.currentDIndex;
          // console.log('установлен индекс:', filter.id, filter.dIndex);
        }
        this._filter = filter;
        if (!this.minimized) this.filterDataUpdate();
        this.setRouterFilter();
      } else {
        this._filter = filter;
        if (!this.minimized) this.filterDataUpdate();
      }
    }
  }, {
    key: 'filterDataUpdate',
    value: function filterDataUpdate() {
      var _this4 = this;

      if (this.filter.deleted) return;
      this.$timeout(function () {
        if (!_this4.filter.id && !_this4.filter.dIndex) return;
        if (_this4.filter.dIndex && !_this4.dashboardData[_this4.filter.dIndex]) {
          _this4.dashboardData[_this4.filter.dIndex] = _this4.FilterDataFactory();
        }
        if (_this4.filter.id && _this4.filter.dIndex && !_this4.dashboardData[_this4.filter.id] && _this4.dashboardData[_this4.filter.dIndex]) {
          _this4.dashboardData[_this4.filter.id] = _this4.dashboardData[_this4.filter.dIndex];
          var dIndex = _this4.filter.dIndex;
          _this4.$timeout(function () {
            return delete _this4.dashboardData[dIndex];
          }, 500);
          _this4.filter.dIndex = '' + _this4.filter.id;
        }
        if (!_this4.filter.dIndex && _this4.filter.id) {
          _this4.filter.dIndex = _this4.filter.id;
        }
        if ((_this4.filter.isChanged || !_this4.dashboardData[_this4.filter.dIndex].filter) && _this4.filter.dIndex && _this4.dashboardData[_this4.filter.dIndex]) {
          _this4.dashboardData[_this4.filter.dIndex].update(_this4.dashboard.filter.isDashboard ? _this4.dashboardData[_this4.filter.dIndex].filter : _this4.filter);
          // console.log('загрузка данных:', this.filter.id, this.filter.name, this.filter.dIndex);
        }
      }, 100);
    }
  }, {
    key: 'toggleMinimized',
    value: function toggleMinimized() {
      this.minimized = !this.minimized;
    }
  }, {
    key: 'getViewHeight',
    value: function getViewHeight() {
      var height = this.dashboard.getHeightPx(this.filter, this.minimized);
      if (!height) {
        return 'auto';
      }
      height -= this.$element.find('h4').outerHeight(true);
      return (height < 0 ? 0 : height) + 'px';
    }
  }, {
    key: 'isCardOrDashboard',
    get: function get() {
      return this._filter.isDashboard || this._filter.isCard;
    }
  }, {
    key: 'isInCard',
    get: function get() {
      return this.CurrentFilterService.filter.isCard;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this._filter;
    },
    set: function set(filter) {
      var _this5 = this;

      if (!filter) return;
      if (this.dashboard) this.setFilter(filter);
      this.$timeout(function () {
        _this5.setFilter(filter);
      }, 0);
    }
  }, {
    key: 'filterIcon',
    get: function get() {
      if (!this.filter) return '';
      // if (this.filter.children.length) return this.minimized ? 'icon-vcard' : 'icon-folder-open-empty';
      if (this.filter && this.filter.children && this.filter.children.length) return 'icon-vcard';
      return (0, _filterMode.getFilterIcon)(this.filter);
    }
  }, {
    key: 'canChange',
    get: function get() {
      return this.CurrentFilterService.filter && this.dashboard && this.dashboard.filter && this.CurrentFilterService.filter.id === this.dashboard.filter.id;
    }
  }, {
    key: 'minimized',
    set: function set(minimized) {
      if (this.canChange) {
        this.filter.cardMinimazed = minimized;
        if (!minimized) this.filterDataUpdate();
        this.setRouterFilter();
      }
    },
    get: function get() {
      return !!this.filter.cardMinimazed;
    }
  }]);

  return DashboardNodeController;
}();

var DashboardNodeComponent = exports.DashboardNodeComponent = {
  template: __webpack_require__(998),
  require: {
    dashboard: '^scDashboard'
  },
  bindings: {
    filter: '<'
  },
  controller: DashboardNodeController
};

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = "<dnd-nodrag ng-if=\"!!$ctrl.filter\"><h4 ng-if=\"$ctrl.canChange\" dnd-handle class=\"node-drag-head\" title=\"{{::'Переместить' | gettext}}\"><div class=\"\"><i ng-class=\"$ctrl.filterIcon\"></i><div class=\"node-name\">{{$ctrl.filter.name}}</div><span class=\"openable\"><i class=\"icon-picture ng-scope\" ng-if=\"!$ctrl.minimized\" ng-click=\"$ctrl.saveAsPicture()\" title=\"{{:: 'Сохранить как изображение'  | gettext }}\"></i> <i class=\"icon-window-maximize ng-scope\" ng-if=\"$ctrl.minimized\" ng-click=\"$ctrl.toggleMinimized()\" title=\"{{:: 'Развернуть виджет'  | gettext }}\"></i> <i class=\"icon-window-minimize ng-scope\" ng-if=\"!$ctrl.minimized\" ng-click=\"$ctrl.toggleMinimized()\" title=\"{{:: 'Свернуть виджет'  | gettext }}\"></i> <i ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies && !$ctrl.isInCard\" class=\"icon-cog ng-scope\" ng-click=\"$ctrl.editFilter(); $event.stopPropagation();\" title=\"{{:: 'Свойства фильтра'  | gettext }}\"></i></span></div></h4><h4 ng-if=\"!$ctrl.canChange\"><i ng-class=\"$ctrl.filterIcon\"></i> {{$ctrl.filter.name}}</h4><sc-dashboard ng-if=\"$ctrl.isCardOrDashboard && !$ctrl.minimized\" filter=\"$ctrl.filter\" ng-style=\"{height: $ctrl.getViewHeight()}\" no-edit=\"true\" filter-data=\"$ctrl.dashboardData[$ctrl.filter.dIndex]\" class=\"maximize\"></sc-dashboard><sc-catalog-view ng-if=\"$ctrl.filter.isCatalog && !$ctrl.minimized && !$ctrl.isDashbordOrCard\" model=\"$ctrl.model\" filter=\"$ctrl.filter\" filter-bar=\"$ctrl.filterBar\" filters=\"$ctrl.filter.children\"></sc-catalog-view><sc-filter-view ng-if=\"!$ctrl.isCardOrDashboard && !$ctrl.minimized &&  !$ctrl.filter.isCatalog\" ng-style=\"{height: $ctrl.getViewHeight()}\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.dashboardData[$ctrl.filter.dIndex]\" class=\"maximize\" maximize-frame=\"!$ctrl.filter.cardHeight && !$ctrl.filter.isGraph\" show-facts-info=\"false\" load-more=\"false\" click-to-use=\"true\" print-resize=\"false\"></sc-filter-view><sc-resize-handler ng-if=\"!$ctrl.minimized\" filter=\"$ctrl.filter\"></sc-resize-handler></dnd-nodrag>"

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1000);

var ResizeHandlerController = function () {
  function ResizeHandlerController($scope, $rootScope, $element, FilterResource, $window, RouterService) {
    var _this = this;

    _classCallCheck(this, ResizeHandlerController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.FilterResource = FilterResource;
    this.$window = angular.element($window);
    this.init = {};
    this.init.x = 0;
    this.init.y = 0;
    // this.dashboardNode = this.$element.parent()[0];
    if (RouterService.isFilterEditModal) this.container = this.$element.closest('sc-filter-preview sc-dashboard')[0];
    // else this.container = this.$element.closest('sc-view .sc-view-container.sc-view-container-fit')[0];
    // document.querySelector('sc-filter-preview sc-dashboard').scrollTop;
    this.dashboardNode = this.$element.closest('sc-dashboard-node')[0];
    this.dashboard = this.$element.closest('sc-dashboard');
    this.$element.find('.resize-handle').bind('mousedown', function (event) {
      return _this.onMouseDown(event);
    });
  }

  _createClass(ResizeHandlerController, [{
    key: 'getNearestGridWidth',
    value: function getNearestGridWidth(event) {
      var newW = event.clientX - this.init.x + this.init.width;
      this.cardWidth = Math.floor(newW / this.init.stepX);
      if (this.cardWidth < 1) this.cardWidth = 1;
      var steps = this.cardWidth * this.init.stepX;
      if (Math.abs(newW - steps) > Math.abs(newW - steps - this.init.stepX)) this.cardWidth += 1;
      if (this.cardWidth > 12) this.cardWidth = 12;
      return this.cardWidth * this.init.stepX;
    }
  }, {
    key: 'getNearestGridHeight',
    value: function getNearestGridHeight(event) {
      var newH = event.clientY - this.init.y + this.init.height;
      this.cardHeight = Math.floor(newH / this.init.stepY);
      if (this.cardHeight < 0) this.cardHeight = 0;
      var steps = this.cardHeight * this.init.stepY;
      if (Math.abs(newH - steps) > Math.abs(newH - steps - this.init.stepY)) this.cardHeight += 1;
      if (this.cardHeight > 36) this.cardHeight = 36;

      return this.cardHeight * this.init.stepY;
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(event) {
      var _this2 = this;

      var marginVert = 7;
      this.init.height = this.dashboardNode.clientHeight;
      this.init.width = this.dashboardNode.clientWidth;
      this.cardWidth = this.filter.cardWidth;
      this.cardHeight = this.filter.cardHeight;

      // console.log(this.dashboardNode.offsetLeft, this.dashboardNode.offsetTop,);
      // const marginHorz = 0.5;
      this.init.stepX = this.init.width / this.cardWidth;

      if (this.filter.cardHeight) {
        this.init.stepY = (this.init.height + marginVert) / this.cardHeight;
      } else {
        this.init.stepY = Math.round(this.DashboardNodeController.dashboard.$element.width() / 12 + marginVert - 2);
      }
      // this.init.stepY = this.filter.cardHeight ? this.init.height / (this.filter.cardHeight ? this.filter.cardHeight : this.filter.cardWidth);


      this.createResizeBorder();
      this.createGridRectangle();

      this.init.x = event.clientX;
      this.init.y = event.clientY;
      // console.log('bind onMouseDown', event);
      this.$window.bind('mousemove', function (event) {
        return _this2.onMouseMove(event);
      });
      this.$window.bind('mouseup', function (event) {
        return _this2.onMouseUp(event);
      });
    }
  }, {
    key: 'createResizeBorder',
    value: function createResizeBorder() {
      this.resizeBorder = angular.element('<div class="resize-border"></div>');
      this.dashboard.append(this.resizeBorder);
      // this.$element.closest('sc-dashboard').append(this.resizeBorder);
      this.resizeBorder.css('top', this.dashboardNode.offsetTop - (this.container ? this.container.scrollTop : 0) + 'px');
      this.resizeBorder.css('left', this.dashboardNode.offsetLeft + 'px');
      this.resizeBorder.css('height', this.init.height + 'px');
      this.resizeBorder.css('width', this.init.width + 'px');
    }
  }, {
    key: 'createGridRectangle',
    value: function createGridRectangle() {
      this.gridRectangle = angular.element('<div class="grid-rectangle"><div> ' + this.cardWidth + ' X ' + (this.cardHeight == 0 ? 'Auto' : this.cardHeight) + ' </div></div>');
      this.dashboard.append(this.gridRectangle);
      // this.$element.closest('sc-dashboard').append(this.gridRectangle);
      this.gridRectangle.css('top', this.dashboardNode.offsetTop - (this.container ? this.container.scrollTop : 0) + 'px');
      this.gridRectangle.css('left', this.dashboardNode.offsetLeft + 'px');
      this.gridRectangle.css('height', this.init.height + 'px');
      this.gridRectangle.css('width', this.init.width + 'px');
    }
  }, {
    key: 'changeBorderSize',
    value: function changeBorderSize(event) {
      this.resizeBorder.css('height', this.init.height - this.init.y + event.clientY + 'px');
      this.resizeBorder.css('width', this.init.width - this.init.x + event.clientX + 'px');
    }
  }, {
    key: 'changeGridRectangle',
    value: function changeGridRectangle(event) {
      var gridHeight = this.getNearestGridHeight(event);
      if (gridHeight != this.prevGridHeight) {
        this.prevGridHeight = gridHeight;
        this.gridRectangle.css('height', this.getNearestGridHeight(event) + 'px');
        this.gridRectangle[0].querySelector('div').innerText = this.cardWidth + ' X ' + (this.cardHeight == 0 ? 'Auto' : this.cardHeight) + ' ';
      }

      var gridWidth = this.getNearestGridWidth(event);
      if (gridHeight != this.prevGridWidth) {
        this.prevGridWidth = gridWidth;
        this.gridRectangle.css('width', this.getNearestGridWidth(event) + 'px');
        this.gridRectangle[0].querySelector('div').innerText = this.cardWidth + ' X ' + (this.cardHeight == 0 ? 'Auto' : this.cardHeight) + ' ';
      }

      // console.log('height', this.getNearestGridHeight(event) + 'px', 'width', this.getNearestGridWidth(event) + 'px');
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      this.changeBorderSize(event);
      this.changeGridRectangle(event);
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp(event) {
      var _this3 = this;

      this.resizeBorder.remove();
      this.gridRectangle.remove();
      // console.log(' onMouseUp', event);
      this.$window.unbind('mousemove');
      this.$window.unbind('mouseup');
      // this.onMouseMove(event);

      this.filter.cardWidth = this.cardWidth;
      this.filter.cardHeight = this.cardHeight;
      this.filter.isChanged = true;
      // this.filter.isChanged = true;
      this.DashboardNodeController.setRouterFilter();
      // console.log('карточка:',this.filter.id, this.cardWidth, this.cardHeight);
      // const filter = this.DashboardNodeController.FiltersService.findById(this.filter.id);
      // if (filter) {
      //   filter.cardWidth = this.cardWidth;
      //   filter.cardHeight = this.cardHeight;
      // }
      // this.filterData.update(this.filter);
      // this.DashboardNodeController.$scope.$apply();

      if (this.DashboardNodeController.minimized) {
        this.DashboardNodeController.toggleMinimized();
      } else this.$scope.$apply(function () {
        setTimeout(function () {
          // this.$scope.$emit('resize');
          // this.$scope.$parent.$broadcast('dashboardResize');
          _this3.$rootScope.$broadcast('dashboardResize');
          // window.updateSize();
        }, 100);
      });
      // this.saveFilter();
    }
  }, {
    key: 'saveFilter',
    value: function saveFilter() {
      this.FilterResource.save(this.filter, function (status, data, error) {
        if (error) {
          console.error('Filter is not saved. Error statrus:' + status + '.', error, data);
        } else {
          if (status === 422) {
            console.error('Filter is not saved. Error statrus:' + status + '.', data);
          }
        }
      });
    }
  }, {
    key: 'canChange',
    get: function get() {
      return this.DashboardNodeController.canChange;
    }
  }]);

  return ResizeHandlerController;
}();

var ResizeHandlerComponent = exports.ResizeHandlerComponent = {
  template: __webpack_require__(1001),
  require: {
    DashboardNodeController: '^scDashboardNode'
  },
  bindings: {
    filter: '<'
  },
  controller: ResizeHandlerController
};

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"$ctrl.canChange\" class=\"resize-handle\"><div></div></div>"

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1003);

var FilterPreviewController = function () {
  function FilterPreviewController($scope, $element, $q, $timeout, CurrentFilterService, PermissionService, RouterService, FilterDataFactory, CurrentModelService, FilterEditorService, FiltersService) {
    var _this = this;

    _classCallCheck(this, FilterPreviewController);

    this.$scope = $scope;
    this.$element = $element;
    this.$q = $q;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.CurrentModelService = CurrentModelService;
    this.FilterEditorService = FilterEditorService;
    this.FiltersService = FiltersService;
    this.filterData = FilterDataFactory(true);
    $timeout(function () {
      return _this.setHeight();
    });
  }

  _createClass(FilterPreviewController, [{
    key: 'setHeight',
    value: function setHeight() {
      var stat = this.$element[0].querySelector('sc-stat-menu');
      var facts = this.$element[0].querySelector('sc-facts-menu');
      var dragable = this.$element[0].querySelector('sc-filter-drill-down-draggable');
      var menuHeight = this.$element[0].querySelector('sc-view-tabs').offsetHeight + (dragable ? dragable.offsetHeight ? dragable.offsetHeight : 79 : 0) + (stat ? stat.offsetHeight ? stat.offsetHeight : 31 : 0) + (facts ? facts.offsetHeight ? facts.offsetHeight : 31 : 0);
      // this.$element[0].querySelector('sc-filter-view').style.height = `calc(100% - ${menuHeight})`;
      this.$element[0].querySelector('.sc-view-container').style.height = 'calc(100% - ' + menuHeight + 'px)';
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this._filter;
    },
    set: function set(filter) {
      // filter.__proto__ = this.CurrentFilterService.filter;
      this._filter = filter.filter;
      this.filterData.update(this._filter);
    }
  }, {
    key: 'filterBar',
    get: function get() {
      return this.CurrentFilterService.filterBar;
    }
  }]);

  return FilterPreviewController;
}();

var FilterPreviewComponent = exports.FilterPreviewComponent = {
  template: __webpack_require__(1004),
  // require: {dashboard: '^scDashboard'},
  bindings: {
    filter: '<'
  },
  controller: FilterPreviewController
};

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports = "<sc-view-tabs ng-click=\"$ctrl.setHeight()\" filter-data=\"$ctrl.filterData\" class=\"toolbar-color\"></sc-view-tabs><table ng-if=\"!$ctrl.frameUrl && !$ctrl.isRemoteUsers &&\n  ($ctrl.filter.isAnalysis || $ctrl.filter.isGraph) && !$ctrl.filter.isStat \"><thead sc-stat-header filter-data=\"$ctrl.filterData\" filter=\"$ctrl.filter\"></thead></table><div class=\"sc-view-container\" ng-class=\"{'sc-view-container-fit': true}\"><sc-filter-view ng-if=\"!$ctrl.filter.isDashboard &&  !$ctrl.filter.isCard\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" maximize-frame=\"false\" show-facts-info=\"false\" load-more=\"true\" click-to-use=\"false\" print-resize=\"false\"></sc-filter-view><sc-dashboard ng-if=\"$ctrl.filter.isDashboard || $ctrl.filter.isCard\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" class=\"maximize\"></sc-dashboard></div>"

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1006);

var CardController = function CardController($scope, $timeout, $element, CurrentFilterService, PermissionService, LayoutService, RouterService) {
  var _this = this;

  _classCallCheck(this, CardController);

  this.$scope = $scope;
  this.$timeout = $timeout;
  this.$element = $element;
  this.CurrentFilterService = CurrentFilterService;
  this.listOpened = false;
  this.permission = PermissionService;
  this.layout = LayoutService;
  this.router = RouterService;
  this.keysFilter = ['agent_account.guid', 'agent_account.id', 'agent_agent.guid', 'agent_agent.id'];

  $scope.$on('FilterDataLoaded', function () {
    var el = _this.$element.closest('.sc-view-container-fit-card');
    if (el[0]) el.scrollTop(0);
  });
};

var CardComponent = exports.CardComponent = {
  template: __webpack_require__(1007),
  bindings: {
    filter: '<',
    card: '<'
  },
  controller: CardController
};

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports = "<h1>{{ $ctrl.card.title | gettext }}</h1><button ng-if=\"$ctrl.card.items.length > 1\" ng-click=\"$ctrl.listOpened = !$ctrl.listOpened\" class=\"list-btn btn\" type=\"button\" name=\"list-btn\"><span ng-if=\"!$ctrl.listOpened\">{{:: 'Показать весь список' | gettext}} <span class=\"badge\">{{$ctrl.card.items.length}}</span> </span><span ng-if=\"$ctrl.listOpened\">{{:: 'Скрыть список' | gettext}}</span></button><table ng-if=\"!$ctrl.listOpened\"><tr ng-repeat=\"key in $ctrl.card.keys track by $index\" ng-if=\"$ctrl.keysFilter.indexOf(key) === -1 && $ctrl.card.items[0][key]\"><td width=\"30%\"><b>{{ $ctrl.card.labels[$index] }}</b></td><td>{{:: $ctrl.card.items[0][key] | gettext}}</td></tr></table><div ng-if=\"$ctrl.listOpened\" ng-repeat=\"item in $ctrl.card.items\"><table><tr ng-repeat=\"key in $ctrl.card.keys track by $index\" ng-if=\"$ctrl.keysFilter.indexOf(key) === -1 && item[key]\"><td width=\"30%\"><b>{{ $ctrl.card.labels[$index] }}</b></td><td>{{:: item[key] | gettext}}</td></tr></table></div>"

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1009);

var CardAccountController = function CardAccountController($scope, CurrentFilterService, PermissionService, LayoutService, RouterService) {
  var _this = this;

  _classCallCheck(this, CardAccountController);

  this.$scope = $scope;
  this.CurrentFilterService = CurrentFilterService;
  this.permission = PermissionService;
  this.layout = LayoutService;
  this.router = RouterService;
  this.keysFilter = ['agent_account.guid', 'agent_account.id', 'agent_agent.guid', 'agent_agent.id'];
  $scope.addScreenshot = function () {
    _this.router.drilldownFilter('agent_eventtype@default:agent_eventtype', '4', gettext('Снимок экрана'));
    _this.router.mode = 'explore';
  };
};

var CardAccountComponent = exports.CardAccountComponent = {
  template: __webpack_require__(1010),
  bindings: {
    filter: '<',
    card: '<'
  },
  controller: CardAccountController
};

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "<div ng-repeat=\"item in $ctrl.card.items\"><a ng-click=\"$ctrl.router.openFrame('/admin/agent/account/' + item.model.id + '/')\" class=\"btn pull-right hide-on-print\">{{:: 'Редактировать' | gettext }}</a><h1>{{ item.model.get_full_name }}</h1><div class=\"row-fluid\"><div class=\"span6\"><table><tr ng-repeat=\"key in $ctrl.card.keys track by $index\" ng-if=\"$ctrl.keysFilter.indexOf(key) === -1 && item[key]\"><td width=\"30%\"><strong>{{ $ctrl.card.labels[$index] }}</strong></td><td>{{:: item[key] | gettext }}</td></tr></table></div><div class=\"span6 widget-filter\" ng-click=\"addScreenshot();\"><div ng-if=\"item.model.photo\" class=\"thumbnail account-photo\"><strong>{{:: 'Фото' | gettext }}</strong> <img ng-src=\"{{ item.model.photo }}\"></div><div ng-if=\"item.model.get_last_screen\" class=\"thumbnail account-photo\"><strong>{{:: 'Снимок экрана' | gettext }}</strong> <img ng-src=\"{{ item.model.get_last_screen }}\"></div></div></div></div>"

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1012);

var FilterViewController = function () {
  function FilterViewController($scope, CurrentFilterService, CurrentModelService, PermissionService, RouterService, LayoutService) {
    _classCallCheck(this, FilterViewController);

    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.CurrentModelService = CurrentModelService;
    this.permission = PermissionService;
    this.router = RouterService;
    this.layout = LayoutService;
  }

  // get isShowStatHeader() {
  //   if (!this.filter) return false;
  //   return this.filter.isChartArea || this.filter.isChart || this.filter.isGraph || this.filter.isTree;
  // }
  //
  // get isReadOnlyStatHeader() {
  //   if (!this.CurrentFilterService || !this.CurrentFilterService.filter) return false;
  //   return this.CurrentFilterService.filter.isDashboard ||
  //     this.CurrentFilterService.filter.isCard;
  // }

  _createClass(FilterViewController, [{
    key: 'showMenu',
    value: function showMenu() {
      return this.CurrentFilterService.panel !== 'catalog' && !this.layout.hideMenu;
    }
  }, {
    key: 'elementClass',
    get: function get() {
      if (!this.router.pdf) return 'maximize';else if (!this.CurrentFilterService.filter.isCardOrDashboard) return 'pdf';
      // else if (this.filterView == 'sc-heatmap') return 'pdf-dashboard-200';
      else if (this.filterView == 'sc-chart' || this.filterView == 'sc-radar' || this.filterView == 'sc-tree' || this.filterView == 'sc-event-river') return 'pdf-dashboard-200';else return 'pdf-dashboard-100';
    }
  }, {
    key: 'filterView',
    get: function get() {
      if (!this.filter) return '';
      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isExplore && this.permission.fact && !this.filter.isViewChat) return 'sc-facts';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isReport) return 'sc-heatmap';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isStat) return 'sc-stat-table';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isSummStat) return 'sc-summ-stat';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isChart) return 'sc-pie';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isChartArea) return 'sc-chart';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isRadar) return 'sc-radar';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isEventRiver) return 'sc-event-river';

      if (!this.filterData.loading && !this.filterData.error && !this.filterData.cancelled && this.filter.isTree) return 'sc-tree';

      if (!this.filterData.cancelled && this.filter.isReports && this.filter.isGraph) return 'sc-graph';

      if (!this.filterData.cancelled && this.filter.isReports && !this.filter.isCard) return 'sc-report-frame-view';

      if (!this.filterData.error && !this.filterData.cancelled && this.filter.isViewChat) return 'sc-chat-viewer';

      if (!this.filterData.loading) return 'no-rights';

      return '';
    }
  }, {
    key: 'isShowFilterStamp',
    get: function get() {
      return this.filterView == 'sc-heatmap' || this.filterView == 'sc-pie' || this.filterView == 'sc-chart' || this.filterView == 'sc-event-river' || this.filterView == 'sc-summ-stat' || this.filterView == 'sc-graph' || this.filterView == 'sc-chat-viewer' || this.filterView == 'sc-tree' || this.filterView == 'sc-radar';
    }
  }, {
    key: 'filter',
    get: function get() {
      // return this.router.isFilterEditModal ? this.filterData.filter : this.router.CurrentFilterService.filter;
      return this.filterData ? this.filterData.filter : null;
    }
  }, {
    key: 'isShowHead',
    get: function get() {
      return !this.router.CurrentFilterService.filter;
      // && !this.CurrentFilterService.filter.isDashboard &&
      // !this.CurrentFilterService.filter.isCard;
    }
  }, {
    key: 'filterBar',
    get: function get() {
      return this.CurrentFilterService.filterBar;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'stat',
    get: function get() {
      return this.filterData.filterData;
    }
  }, {
    key: 'activity',
    get: function get() {
      return this.filterData.filterData;
    }
  }, {
    key: 'card',
    get: function get() {
      return this.filterData.filterData;
    }
  }, {
    key: 'repIdSuffix',
    get: function get() {
      return this.router.isFilterEditModal ? '-edit' : '';
    }
  }]);

  return FilterViewController;
}();

var FilterViewComponent = exports.FilterViewComponent = {
  template: __webpack_require__(1013),
  bindings: {
    filterData: '<',
    maximizeFrame: '<',
    showFactsInfo: '<',
    loadMore: '<',
    clickToUse: '<?'
  },
  controller: FilterViewController
};

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.isShowHead\" class=\"head\"><h3>\"{{$ctrl.filterBar.name}}\" {{::'за период c' | gettext}} {{$ctrl.filterBar.timeFrom | date : \"dd MMMM yyyy\"}} {{::'по' | gettext}} {{$ctrl.filterBar.timeTo | date : \"dd MMMM yyyy\"}}</h3></div><sc-hspinner ng-if=\"$ctrl.filterData.loading && !$ctrl.filter.isReports\"></sc-hspinner><div class=\"text-center\" ng-if=\"!$ctrl.filterData.loading && $ctrl.filterData.cancelled\">{{::'Загрузка прервана' | gettext}}</div><div class=\"text-center\" ng-if=\"!$ctrl.filterData.loading && $ctrl.filterData.error\">{{::'Ошибка загрузки' | gettext}}</div><div class=\"text-center\" ng-if=\"$ctrl.filterView === 'no-rights'\">{{::'Недостаточно прав' | gettext}}</div><sc-facts id=\"facts-container\" ng-if=\"$ctrl.filterView === 'sc-facts'\" model=\"$ctrl.model\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" show-facts-info=\"$ctrl.showFactsInfo\" load-more=\"$ctrl.loadMore\" ng-class=\"$ctrl.elementClass\"></sc-facts><sc-heatmap ng-if=\"$ctrl.filterView === 'sc-heatmap'\" filter=\"$ctrl.filter\" filter-bar=\"$ctrl.filterBar\" activity=\"$ctrl.activity\" class=\"for-save-as-image maximize\" rep-id=\"'report-canvas' + $ctrl.repIdSuffix\" rep-legend-id=\"'report-canvas-legend' + $ctrl.repIdSuffix\" ng-class=\"$ctrl.elementClass\"></sc-heatmap><sc-stat-table ng-if=\"$ctrl.filterView === 'sc-stat-table'\" model=\"$ctrl.model\" filter-data=\"$ctrl.filterData\" filter=\"$ctrl.filter\" class=\"maximize\"></sc-stat-table><sc-summ-stat ng-if=\"$ctrl.filterView === 'sc-summ-stat'\" model=\"$ctrl.model\" filter-data=\"$ctrl.filterData\" filter=\"$ctrl.filter\" ng-class=\"$ctrl.elementClass\"></sc-summ-stat><sc-radar ng-if=\"$ctrl.filterView === 'sc-radar'\" model=\"$ctrl.model\" aggregate=\"$ctrl.stat\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" ng-class=\"$ctrl.elementClass\"></sc-radar><sc-event-river ng-if=\"$ctrl.filterView === 'sc-event-river'\" model=\"$ctrl.model\" aggregate=\"$ctrl.stat\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" ng-class=\"$ctrl.elementClass\"></sc-event-river><sc-pie ng-if=\"$ctrl.filterView === 'sc-pie'\" model=\"$ctrl.model\" filter=\"$ctrl.filter\" aggregate=\"$ctrl.stat\" class=\"maximize\" ng-class=\"$ctrl.elementClass\"></sc-pie><sc-chart ng-if=\"$ctrl.filterView === 'sc-chart'\" model=\"$ctrl.model\" aggregate=\"$ctrl.stat\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" ng-class=\"$ctrl.elementClass\"></sc-chart><sc-tree ng-if=\"$ctrl.filterView === 'sc-tree'\" model=\"$ctrl.model\" aggregate=\"$ctrl.stat\" ng-class=\"$ctrl.elementClass\"></sc-tree><sc-report-frame-view ng-if=\"$ctrl.filter.isGraph && $ctrl.filterView === 'sc-graph'\" maximize=\"$ctrl.maximizeFrame\" min-height=\"$ctrl.filter.isGraph ? 640 : 0\" click-to-use=\"$ctrl.clickToUse\" filter-data=\"$ctrl.filterData\" ng-class=\"$ctrl.elementClass\"></sc-report-frame-view><sc-report-frame-view ng-if=\"!$ctrl.filter.isGraph && $ctrl.filterView === 'sc-report-frame-view'\" maximize=\"$ctrl.maximizeFrame\" min-height=\"$ctrl.filter.isGraph ? 640 : 0\" click-to-use=\"$ctrl.clickToUse\" filter-data=\"$ctrl.filterData\" ng-class=\"$ctrl.elementClass\"></sc-report-frame-view><sc-chat-viewer ng-if=\"$ctrl.filterView === 'sc-chat-viewer'\" model=\"$ctrl.model\" data=\"$ctrl.stat\" filter=\"$ctrl.filter\" filter-data=\"$ctrl.filterData\" class=\"for-save-as-image maximize\"></sc-chat-viewer><sc-filter-stamp ng-if=\"$ctrl.isShowFilterStamp\" filter=\"$ctrl.filter\"></sc-filter-stamp>"

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OnScroll = OnScroll;
function OnScroll($timeout) {
  'use strict';

  return {
    scope: {
      onScroll: '&onScroll',
      scrollDelay: '='
    },
    link: function link(scope, element) {
      if (scope.scrollDelay === undefined) scope.scrollDelay = 250;
      var scrollThrottleTimeout = void 0;
      var throttled = false;
      var scrollHandler = function scrollHandler(e) {

        if (!throttled && element[0] === e.target) {
          scope.onScroll(e);
          throttled = true;
          scrollThrottleTimeout = $timeout(function () {
            throttled = false;
          }, scope.scrollDelay);
        }
      };

      element.on('scroll', scrollHandler);

      scope.$on('$destroy', function () {
        element.off('scroll', scrollHandler);
      });
    }
  };
}

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatViewerNodeComponent = ChatViewerNodeComponent;

var _tableView = __webpack_require__(62);

__webpack_require__(1016);

function ChatViewerNodeComponent($compile) {
  return {
    template: __webpack_require__(1017),
    restrict: 'AE',
    scope: {
      filter: '<',
      fact: '<',
      showHead: '<',
      openImage: '&',
      setFilterCut: '&'
    },
    controller: function controller($scope, $element, $sce, $window) {
      $scope.setSender = function () {
        return $scope.setFilterCut({
          dim: 'agent_dialog@sender:sender',
          val: $scope.message().sender
        });
      };
      $scope.setChannel = function () {
        return $scope.setFilterCut({
          dim: 'agent_dialog@dialog_type:dialog_type',
          val: $scope.message().channel
        });
      };
      $scope.setMembers = function () {
        return $scope.setFilterCut({
          dim: 'agent_dialog@members:members',
          val: $scope.message().members
        });
      };
      $scope.setUser = function () {
        return $scope.setFilterCut({
          dim: 'agent_account@user_name:user_name',
          val: $scope.message().user
        });
      };

      // sender:  ATTR2PROP['agent_dialog.sender']($scope.fact).val,
      // members: ATTR2PROP['agent_dialog.members']($scope.fact).val,

      $scope.message = function () {
        return {
          isOut: $scope.fact['agent_dialog.direction'] === 'Outgoing',
          userName: $scope.fact['agent_account.full_name'] ? $scope.fact['agent_account.full_name'] : $scope.fact['agent_account.user_name'],
          user: $scope.fact['agent_account.user_name'],
          sender: $scope.fact['agent_dialog.sender'],
          date: _tableView.ATTR2PROP['local_time']($scope.fact).val,
          members: $scope.fact['agent_dialog.members'],
          channel: $scope.fact['agent_dialog.dialog_type']
        };
      };
    },
    link: function link(scope, element, attrs) {

      scope.$watch('fact', function (newVal, oldVal) {
        if (!scope.filter) return;
        var fact = newVal ? newVal : {};
        var widget = '<div class="widget-data widget-properties">';
        if (fact['agent_dialog.message_format'] === 'Call') {
          widget += '<i class="icon-bell"></i>' + gettext('Звонок');
        } else {
          widget += fact['text_data'] ? _tableView.ATTR2PROP['text_data'](fact).sval : '';
          widget += fact['agent_attachedfile.data'] ? _tableView.ATTR2PROP['agent_attachedfile.data'](fact).val : '';

          if (fact && fact.children) {
            widget += fact.children.map(function (ch) {
              ch['parentName'] = fact['agent_eventtype.name'];
              return ch['agent_attachedfile.data'] ? (0, _tableView.widgetFromProp)(_tableView.ATTR2PROP['agent_attachedfile.data'](ch)) : '';
            }).join('');
          }
        }
        widget += '</div>';
        element.find('.message-body').html(widget);

        widget = _tableView.ATTR2PROP['agent_dialog.members'](fact).val;
        element.find('.members-info').html(widget);

        widget = _tableView.ATTR2PROP['agent_dialog.sender'](fact).val;
        if (!widget.match('<sc-account')) widget += ',';
        element.find('.message-sender').html(widget);

        $compile(element.contents())(scope);
      });
    }
  };
}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports = "<div ng-show=\"showHead\" class=\"head-info\"><span class=\"members-info\" ng-click=\"setMembers()\"></span></div><div class=\"message\" ng-class=\"message(fact).isOut? 'outcome' : 'income'\"><div class=\"message-info\"><span class=\"message-sender\" ng-click=\"setSender()\"></span> <span class=\"message-date\">{{message().date}}</span></div><div class=\"message-body\"></div></div>"

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1019);

var ChatViewerController = function () {
  function ChatViewerController($scope, $window, $element, $timeout, RouterService, CurrentModelService, CurrentFilterService, ErrorHandlerService, AggregateDataService) {
    var _this = this;

    _classCallCheck(this, ChatViewerController);

    this.router = RouterService;
    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.CurrentModelService = CurrentModelService;
    this.CurrentFilterService = CurrentFilterService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.AggregateDataService = AggregateDataService;
    this.typeDim = 'agent_eventtype@default:agent_eventtype';
    this.$element = $element;
    this.previousTop = -1;
    this.dialogBody = this.$element.context.querySelector('.dialog-body');
    this.filterData = this.router.CurrentFilterDataService.filterData;
    this._data = [];
    this.isSuitFilter = true;
    this.needToScroll = false;
    this.headData = {
      canChange: true,
      membersDim: 'agent_dialog@members:members',
      channelDim: 'agent_dialog@dialog_type:dialog_type',
      userDim: 'agent_account@user_name:user_name',
      length: 0
    };
    this.doOnScroll = true;

    this.subscription = this.filterData.filterData$.subscribe(function () {
      _this.setSuitFilter();
      if (!_this.data || !_this.data.length) return;
      if (_this.previousTop === -1) _this.previousTop = _this.dialogBody.scrollTop;
      _this.resortData();
    });

    $scope.$on('$destroy', function () {
      return _this.subscription.dispose();
    });

    $scope.$on('dimensionToggle', function () {
      _this.setSuitFilter();
    });

    $scope.$on('aggregare-loaded', function () {
      _this.setSuitFilter();
      // this.setFilters();
    });

    $scope.$watch('$ctrl.curFilter.listType', function () {
      if (_this.filter.listType === 'chat-viewer') _this.setFilters();
    });

    this.$timeout(function () {
      return _this.resortData();
    }, 10);
  }

  _createClass(ChatViewerController, [{
    key: 'resortData',
    value: function resortData() {
      if (!this.data) return;
      var fVal = function fVal(fact) {
        var date = new Date(fact['local_time']);
        return {
          id: +fact['id'],
          t: date.valueOf() + date.getTimezoneOffset() * 60000,
          u: fact['agent_account.user_name'],
          m: fact['agent_dialog.members']
        };
      };

      this.data = this.data.sort(function (aFact, bFact) {
        var a = fVal(aFact);
        var b = fVal(bFact);

        if (a.u === b.u) {
          if (a.m === b.m) {
            if (a.t === b.t) return a.id - b.id;else return a.t - b.t;
          } else {
            return a.m > b.m ? 1 : -1;
          }
        } else {
          return a.u > b.u ? 1 : -1;
        }
      });

      this.headData.length = this.data.length;
      this.needToScroll = true;
    }
  }, {
    key: 'scrollToFCurrectFact',
    value: function scrollToFCurrectFact(isLast) {
      var _this2 = this;

      if (this.CurrentFilterService.filter.isCardOrDashboard) return true;
      if (!isLast || !this.needToScroll) return true;
      this.needToScroll = false;
      this.$timeout(function () {
        if (!_this2.data) return true;
        if (_this2.headData.id == undefined) _this2.headData.id = _this2.data[_this2.data.length - 1].id;else _this2.headData.canChange = false;

        var el = _this2.$element.find('#' + _this2.headData.id);
        if (!el || !el[0]) return;
        el[0].scrollIntoView();
        _this2.$timeout(function () {
          if (!_this2.headData.user) _this2.onScroll();
          _this2.headData.canChange = true;
        }, 200);
      }, 200);
      return true;
    }
  }, {
    key: 'getCurrentFact',
    value: function getCurrentFact() {
      var _this3 = this;

      var curMessagePos = this.dialogBody.scrollTop + 20;
      var nodes = this.dialogBody.children;
      var prevEl = null;
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var pos = el.children[0].offsetTop - curMessagePos;
        if (pos >= 0) {
          var _ret = function () {
            var id = 0;
            if (pos < 200) id = el.id;else id = prevEl.id;
            return {
              v: _this3.data.find(function (d) {
                return d.id == id;
              })
            };
          }();

          if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
        }
        prevEl = el;
      }
      return this.data && this.data[0];
    }
  }, {
    key: 'setFilterCut',
    value: function setFilterCut(dim, val) {
      this.curFilter.cleanFilter(dim);
      this.curFilter.addFilter(dim, val, val);
      this.router.filterChanged();
    }
  }, {
    key: 'hasAccounts',
    value: function hasAccounts(accountKey) {
      return this.headData.fact.accounts && this.headData.fact.accounts[accountKey];
    }
  }, {
    key: 'setDialogHead',
    value: function setDialogHead(fact) {
      if (!this.headData.canChange) return;
      this.headData.id = fact.id;
      this.headData.userName = fact['agent_account.user_name'];
      this.headData.userFullName = fact['agent_account.full_name'];
      this.headData.user = this.headData.userFullName ? this.headData.userFullName : this.headData.userName;
      this.headData.members = fact['agent_dialog.members'];
      this.headData.membersArr = this.headData.members ? Array.from(new Set(this.headData.members.split(' '))) : [];
      // console.log(this.headData.membersArr);
      this.headData.fact = fact;
      this.headData.channel = fact['agent_dialog.dialog_type'];
      this.headData.length = this.data ? this.data.length : this.filterData.filterData.length;
    }
  }, {
    key: 'onScroll',
    value: function onScroll(e) {
      var _this4 = this;

      if (!this.doOnScroll) return;
      this.doOnScroll = false;
      this.$timeout(function () {

        var fact = _this4.getCurrentFact();
        if (fact) {
          _this4.setDialogHead(fact);
        }
        // console.log('scrollTop: ', this.dialogBody.scrollTop, this.dialogBody.scrollHeight, this.dialogBody.scrollTop / this.dialogBody.scrollHeight * 100);
        if (_this4.headData.canChange && _this4.previousTop < _this4.dialogBody.scrollTop && (_this4.dialogBody.scrollHeight - _this4.dialogBody.scrollTop) / _this4.dialogBody.scrollHeight * 100 < 5) {
          _this4.more();
        }
        _this4.previousTop = _this4.dialogBody.scrollTop;
        _this4.doOnScroll = true;
      }, 200);
    }
  }, {
    key: 'showHead',
    value: function showHead(i) {
      var headData = function headData(fact) {
        return {
          user: fact['agent_account.user_name'],
          channel: fact['agent_dialog.dialog_type'],
          members: fact['agent_dialog.members']
        };
      };
      if (i === 0) return true;
      return !angular.equals(headData(this.data[i - 1]), headData(this.data[i]));
    }
  }, {
    key: 'more',
    value: function more(e) {
      if (this.isLoading) return null;
      return this.filterData.moreFacts();
    }
  }, {
    key: 'openImage',
    value: function openImage(fact) {
      var url = 'media/' + fact['agent_attachedfile.data'];
      // console.log( url);
      this.$window.open(url);
    }
  }, {
    key: 'setSuitFilter',
    value: function setSuitFilter() {
      var _this5 = this;

      var typeCount = 0;
      this.isSuitFilter = this.curFilter.filters.length && this.curFilter.filters.every(function (f) {
        var goodType = f.dimension === _this5.typeDim && (f.value === '8' || f.value === '9');
        if (goodType) typeCount += 1;
        return f.dimension !== _this5.typeDim || goodType;
      }) && !!typeCount;

      return this.isSuitFilter;
    }
  }, {
    key: 'setFilters',
    value: function setFilters() {
      var _this6 = this;

      this.isSuitFilter = true;
      this.headData.length = 0;
      var typeCount = 0;
      this.curFilter.filters = this.curFilter.filters.filter(function (f) {
        var goodType = f.dimension === _this6.typeDim && (f.value === '8' || f.value === '9');
        if (goodType) typeCount += 1;
        return goodType || f.dimension !== _this6.typeDim;
      });
      if (!typeCount) {
        this.curFilter.cleanFilter('agent_eventtype@default:agent_eventtype');
        this.curFilter.addFilter('agent_eventtype@default:agent_eventtype', '8', gettext('Интернет-пейджер'));
        this.curFilter.addFilter('agent_eventtype@default:agent_eventtype', '9', gettext('Почта'));
        this.CurrentFilterService.rebuildVisibleDimensions();
        this.router.filterChanged();
      }
    }
  }, {
    key: 'data',
    get: function get() {
      return this._data;
    },
    set: function set(data) {
      this._data = data;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      var loading = this.CurrentModelService.loading || this.filterData.loading || this.filterData.loadingMore || this.AggregateDataService.loading || this.AggregateDataService.loadingMore;
      return loading;
    }
  }, {
    key: 'curFilter',
    get: function get() {
      if (this.router.isFilterEditModal) return this.filter;
      return this.filter ? this.filter : this.CurrentFilterService.filter;
    }
  }, {
    key: 'participants',
    get: function get() {
      var _this7 = this;

      var dim = this.curFilter.filters.find(function (f) {
        return f.dimension === _this7.threadDim;
      });
      return dim ? dim.label : '';
    }
  }, {
    key: 'firstFact',
    get: function get() {
      if (!this.data || !this.data.length) return {
        userId: 0,
        userName: '',
        channel: ''
      };
      var f1 = this.data[0];
      return {
        userId: f1['agent_account.id'],
        userName: f1['agent_account.user_name'],
        channel: f1['agent_dialog.dialog_type']
      };
    }
  }]);

  return ChatViewerController;
}();

var ChatViewerComponent = exports.ChatViewerComponent = {
  template: __webpack_require__(1020),
  bindings: {
    model: '<',
    data: '<',
    filter: '<',
    filterData: '<'
  },
  controller: ChatViewerController
};

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports = "<div class=\"dialog-head\" ng-if=\"$ctrl.isSuitFilter\"><div><i class=\"icon icon-window\" title=\"{{::'Канал общения' | gettext}}\"></i> <a class=\"dialog-channel\" ng-click=\"$ctrl.setFilterCut($ctrl.headData.channelDim, $ctrl.headData.channel)\">{{$ctrl.headData.channel}}</a></div><div><i class=\"icon icon-user\" title=\"{{::'Пользователь' | gettext}}\"></i> <a ng-click=\"$ctrl.setFilterCut($ctrl.headData.userDim, $ctrl.headData.userName)\">{{$ctrl.headData.user}}</a></div><div><i class=\"icon icon-chat\" title=\"{{::'Чат' | gettext}}\"></i> <a ng-click=\"$ctrl.setFilterCut($ctrl.headData.membersDim, $ctrl.headData.members)\"><span ng-repeat=\"member in $ctrl.headData.membersArr\"><sc-account ng-if=\"$ctrl.hasAccounts(member)\" account-key=\"member\" fact=\"$ctrl.headData.fact\"></sc-account><span ng-if=\"!$ctrl.hasAccounts(member)\">{{member}}</span></span></a></div><span class=\"badge counter\" ng-click=\"$ctrl.more()\" title=\"{{::'Загрузить еще сообщений' | gettext}}\"><i ng-if=\"$ctrl.isLoading\" class=\"icon-loading animate-spin\"></i> <span ng-if=\"!$ctrl.isLoading\">{{$ctrl.data.length}}</span></span></div><div class=\"dialog-body\" on-scroll=\"$ctrl.onScroll($event)\" scroll-delay=\"0\"><sc-chat-viewer-node ng-if=\"$ctrl.isSuitFilter && $ctrl.scrollToFCurrectFact($last)\" id=\"{{fact.id}}\" ng-repeat=\"fact in $ctrl.data\" filter=\"$ctrl.curFilter\" fact=\"fact\" set-filter-cut=\"$ctrl.setFilterCut(dim, val)\" open-image=\"$ctrl.openImage(fact)\" show-head=\"$ctrl.showHead($index)\"></sc-chat-viewer-node><div ng-if=\"!$ctrl.isSuitFilter\" class=\"wrong-cuts\"><h5>{{::'Выбранный фильтр неприменим к отчёту' | gettext}}.<div>{{::'Допустимые типы событий - \"Почта\" и \"Интернет-пейджер\"' | gettext}}.</div></h5></div></div>"

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarLeftComponent = SidebarLeftComponent;
function SidebarLeftComponent() {
  return {
    require: {
      parentCtrl: '^^scSidebar'
    },
    restrict: 'E',
    scope: false,
    template: __webpack_require__(1022)
  };
}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = "<div ng-class=\"$ctrl.isEditCatalog? 'dimensions-all' : 'dimensions'\"><div class=\"aggregate-header\"><sc-filter-search ng-show=\"$ctrl.panel !== 'catalog'\" class=\"input-append aggregate-header\"></sc-filter-search><sc-catalog-search ng-show=\"$ctrl.panel === 'catalog'\" class=\"input-append\"></sc-catalog-search><ul class=\"menu-list edit-catalog pull-right\" ng-show=\"$ctrl.panel === 'catalog'\"><li class=\"dropdown\" ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a class=\"dropdown-toggle\"><i class=\"icon-cogs\" style=\"text-align:right\"></i></a><ul class=\"dropdown-menu pull-right\" role=\"menu\"><li><a ng-click=\"$ctrl.openAll()\"><i title=\"{{:: 'Открыть всё' | gettext }}\" class=\"icon-folder-open-empty\"></i> <span class=\"ng-binding\">{{:: 'Открыть всё' | gettext }}</span></a></li><li><a ng-click=\"$ctrl.closeAll()\"><i title=\"{{:: 'Закрыть всё' | gettext }}\" class=\"icon-folder-empty\"></i> <span class=\"ng-binding\">{{:: 'Закрыть всё' | gettext }}</span></a></li><li ng-if=\"!$ctrl.isEditCatalog\" title=\"{{:: 'Редактировать расположение фильтров' | gettext }}\"><a ng-click=\"$ctrl.toggleEditCatalog()\"><i class=\"icon-edit\"></i> <span class=\"ng-binding\">{{:: 'Редактировать' | gettext }}</span></a></li><li ng-if=\"$ctrl.isEditCatalog\" title=\"{{:: 'Завершить редактирование расположения фильтров' | gettext }}\"><a ng-click=\"$ctrl.toggleEditCatalog()\"><i class=\"icon-cancel-1\"></i> <span class=\"ng-binding\">{{:: 'Завершить редактирование' | gettext }}</span></a></li></ul></li></ul></div><sc-filter-dimensions ng-show=\"$ctrl.panel === 'constructor'\" class=\"aggregate-pane\" dim=\"$ctrl.currentFilter.filterBar.drilldown[0]\" model=\"$ctrl.model\"></sc-filter-dimensions><sc-catalog ng-show=\"$ctrl.panel === 'catalog'\" class=\"aggregate-pane\" filters=\"$ctrl.FiltersService.filters\" is-all-filtres=\"true\"></sc-catalog><div class=\"pane-tab aggregate-pane-tab\"><ul class=\"filter-ops nav nav-pills pull-left\"><li ng-if=\"$ctrl.permission.filterConstructor || $ctrl.router.isFilterEditModal\" class=\"panel-color-2\" ng-class=\"{'inactive': $ctrl.panel !== 'constructor'}\"><a ng-click=\"$ctrl.viewFilter()\" title=\"{{:: 'Выбор условий фильтра' | gettext }}\"><i class=\"icon-wrench\"></i> <span ng-if=\"$ctrl.isShowFootWord\">{{:: 'Конструктор' | gettext }}</span></a></li><li class=\"panel-color\" ng-class=\"{'inactive': $ctrl.panel !== 'catalog'}\"><a ng-click=\"$ctrl.viewReport()\" title=\"{{:: 'Выбор фильтра' | gettext }}\"><i class=\"icon-chart-bar\"></i> <span ng-if=\"$ctrl.isShowFootWord\">{{:: 'Фильтры' | gettext }}</span></a></li></ul></div></div>"

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import { IS_SIDEBAR_OPENED, LocalStorageService  } from '../core/local-storage.service.js';
__webpack_require__(1024);

var SidebarToggleController = function () {
  function SidebarToggleController($scope, $rootScope, PermissionService, RouterService, CurrentFilterService) {
    _classCallCheck(this, SidebarToggleController);

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.CurrentFilterService = CurrentFilterService;
    window.isPaneOpen = this.router.getPane();
  }

  _createClass(SidebarToggleController, [{
    key: 'isPaneOpen',
    value: function isPaneOpen() {
      return window.isPaneOpen;
    }
  }, {
    key: 'switchPanel',
    value: function switchPanel() {
      angular.element(document).trigger('showDimensions');
      this.router.setPane(this.isPaneOpen());
      // this.storageSrv.setItem(IS_SIDEBAR_OPENED, this.isPaneOpen()? 'true' : 'false');
    }
  }, {
    key: 'panel',
    get: function get() {
      return this.CurrentFilterService.panel;
    }
  }]);

  return SidebarToggleController;
}();

var SidebarToggleComponent = exports.SidebarToggleComponent = {
  template: __webpack_require__(1025),
  controller: SidebarToggleController
};

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = "<div class=\"panel-toggle panel-color\" ng-class=\"{\n    'toggle-open': $ctrl.isPaneOpen(),\n    'toggle-close': !$ctrl.isPaneOpen(),\n    'panel-color-2': $ctrl.panel === 'constructor'}\"><a ng-show=\"!$ctrl.isPaneOpen()\" title=\"{{:: 'Открыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\"><i class=\"icon-plus-1\"></i></span> </a><a ng-show=\"$ctrl.isPaneOpen()\" title=\"{{:: 'Закрыть панель' | gettext }}\" ng-click=\"$ctrl.switchPanel()\"><span class=\"panel-close\"><i class=\"icon-cancel\"></i></span></a></div>"

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modals = __webpack_require__(69);

var _terminalCommandModal = __webpack_require__(344);

var _debugInfoModal = __webpack_require__(345);

var _excellentexport = __webpack_require__(342);

var _excellentexport2 = _interopRequireDefault(_excellentexport);

var _config = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1027);

var HeaderController = function () {
  function HeaderController($scope, $element, $window, $timeout, CurrentFilterService, CurrentModelService, $rootScope, PermissionService, RouterService, $cookies, $modal, FilterEditorService, $http, CurrentFilterDataService, $q, FiltersService, LocalStorageService, FieldsModalService, LayoutService, ErrorHandlerService, AggregateDataService, TreeService, $templateCache, AdminModalService) {
    var _this = this;

    _classCallCheck(this, HeaderController);

    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.$window = $window;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.AdminModalService = AdminModalService;
    this.AggregateDataService = AggregateDataService;
    this.ErrorHandlerService = ErrorHandlerService;
    this.langClasses = {
      'ru': 'flag-icon-ru',
      'en': 'flag-icon-gb',
      'cn': 'flag-icon-cn'
    };
    this.selectedLang = $cookies.get('django_language') || PermissionService.selectedLang || PermissionService.defaultLang;
    this.$modal = $modal;
    this.$cookies = $cookies;
    this.FilterEditorService = FilterEditorService;
    this.$http = $http;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.$q = $q;
    this.FiltersService = FiltersService;
    this.CurrentFilterService = CurrentFilterService;
    this.localStorage = LocalStorageService;
    this.FieldsModalService = FieldsModalService;
    this.TreeService = TreeService;
    this.lensePanel = this.$element.find('.lens-panel')[0];
    this.$isShowPanelWords = true;
    this.userNameWaxWidth = 'unset';
    this.$templateCache = $templateCache;
    this.$scope.$watch('$ctrl.filter.isChanged', function () {
      return _this.$timeout(function () {
        return _this.setUserNameWaxWidth();
      }, 10);
    });

    // this.menuSearch = {
    //   '/admin/agent/agent/': this.localStorage.getItem('/admin/agent/agent/', ''),
    //   '/admin/agent/attachedfile/': this.localStorage.getItem('/admin/agent/attachedfile/', ''),
    //   '/admin/auth/user/': this.localStorage.getItem('/admin/auth/user/', ''),
    //   '/admin/agent/device/': this.localStorage.getItem('/admin/agent/device/', ''),
    //   '/admin/agent/account/': this.localStorage.getItem('/admin/agent/account/', ''),
    //   '/admin/agent/application/': this.localStorage.getItem('/admin/agent/application/', ''),
    //   '/admin/agent/config/': this.localStorage.getItem('/admin/agent/config/', ''),
    // };

    this.$scope.$on('factsLoaded', function () {
      if (_this.filter.toExcel && _this.filter.toExcel.convertToExel) {
        var table = document.getElementById('datatable');
        table.innerHTML = table.innerHTML.replace(/<img[^>]+>(<\/img>)?|filter="filter"/g, '');
        var el = document.getElementById('ExcelDownloadItem');
        _excellentexport2.default.excel(el, 'datatable');
        el.click();
        _this.filter.customLimit = _this.filter.toExcel.normalLimit;
        delete _this.filter.toExcel;
        _this.$rootScope.$broadcast('reload');
      }
    });

    this.$rootScope.$on('splitter1Changed', function (e, d, d2, name) {
      _this.moveTab();
      _this.setUserNameWaxWidth();
    });

    this.$scope.$on('init', function (e) {
      _this.updateMenu();
      _this.setUserNameWaxWidth();
    });

    // const uAgent = this.$window.navigator.userAgent;
    // if (!!uAgent.match(/Trident.*rv\:11\./) || !!uAgent.match(/MSIE/)) {
    //   ErrorHandlerService.showErrorMessageBox(
    //     gettext('Ошибка браузера'),
    //     gettext('Ваша версия браузера не поддерживается. Используйте браузеры Chrome, Firefox или Edge'),
    //     null, true
    //   );
    // }
  }

  _createClass(HeaderController, [{
    key: 'updateMenu',
    value: function updateMenu() {
      var _this2 = this;

      var aList = this.$window.document.querySelectorAll('.sorted-menu-item');
      aList.forEach(function (a) {
        return a.search = _this2.localStorage.getItem(a.pathname, '');
      });
    }
  }, {
    key: 'htmlReport',
    value: function htmlReport() {
      this.currentFilter.filter.url = '/analytics/report/facts/';
      if (this.currentFilter.filter.order === 'record_count') {
        this.currentFilter.filter.order = 'local_time';
      }
      this.router.openNewWindow('&limit=1000000000');
    }
  }, {
    key: 'link',
    value: function link() {
      alert(this.$templateCache.get('panel_menu.html'));
    }
  }, {
    key: 'setUserNameWaxWidth',
    value: function setUserNameWaxWidth() {
      if (!this.adminMenuWidth) {
        this.adminMenuWidth = this.$element.find('.admin-menu').width() - (this.$element.find('.lense-admin-width') ? this.$element.find('.lense-admin-width').width() : 0);
      }

      if (this.$isShowPanelWords) {
        var w = 0;
        this.$element.find('.lense-width').each(function () {
          w += this.offsetWidth;
        });
        this.lenseWidth = w;
      }
      var d = 12;
      var spaceWidth = this.lensePanel.offsetWidth - this.lenseWidth - this.adminMenuWidth;
      this.$isShowPanelWords = spaceWidth > d;
      if (this.$isShowPanelWords) {
        this.userNameWaxWidth = spaceWidth - d;
      }
    }
  }, {
    key: 'openOptions',
    value: function openOptions() {
      this.LayoutService.openOptions();
    }
  }, {
    key: 'nop',
    value: function nop(event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }, {
    key: 'openNewDataWindow',
    value: function openNewDataWindow() {
      this.FieldsModalService.open('CSV');
      // this.router.openNewWindow(`&limit=${this.filter.customLimit ? this.filter.customLimit : 1000000000}`);
    }
  }, {
    key: 'moveTab',
    value: function moveTab() {
      var left = $('sc-view').offset().left;
      var winWidth = $(window).width();
      // const max_left = winWidth < 1495 ? 300 : 300;
      var max_left = 520;
      if (left < max_left) left = max_left;
      $('.lens-panel').css({
        'left': left
      });
      // this.$timeout(() => {
      var showScreenPanel = $('.show-screen-panel');
      showScreenPanel.css({
        'right': winWidth - left + 60
      });
      // }, 500);


      if ($('sc-view').width() < 1100) $('.lens-panel .hideable').hide();else $('.lens-panel .hideable').show();
    }
  }, {
    key: 'openNewWindow',
    value: function openNewWindow() {
      this.router.openNewWindow();
      var urlArr = this.router.search().frameUrl.split('/');
      if (urlArr[0] === 'remote' || urlArr[1] === 'remote') {
        var frame = this.LayoutService.getMainFrame();
        if (frame) frame.src = 'about:blank';
      }
    }
  }, {
    key: 'downloadZip',
    value: function downloadZip() {
      var filterUrl = this.CurrentFilterService.filter.url;
      this.CurrentFilterService.filter.url = '/analytics/download/zip/';
      this.zipUrl = this.CurrentFilterService.getReportUrl(this.CurrentFilterService.filter);
      this.CurrentFilterService.filter.url = filterUrl;
      // console.log(this.router);
    }
  }, {
    key: 'printContainer',
    value: function printContainer() {
      this.LayoutService.printContainer(this.CurrentFilterDataService.filterData.filterData);
    }
  }, {
    key: 'saveAsPicture',
    value: function saveAsPicture() {
      var _this3 = this;

      this.LayoutService.saveAsPicture(this.CurrentFilterDataService.filterData.filterData, function (message) {
        _this3.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка при получении изображения'), message, null, true);
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.router.resetFilter();
    }
  }, {
    key: 'debugInfo',
    value: function debugInfo() {
      this.AdminModalService.debugInfo();
    }
  }, {
    key: 'getLinkToPDF',
    value: function getLinkToPDF() {
      var timeFrom = this.CurrentFilterService.getTimeFrom();
      var timeTo = this.CurrentFilterService.getTimeTo();
      return this.filterBar.id ? '/analytics/filter/pdf?id=' + this.filterBar.id + '&time_from=' + timeFrom + '&time_to=' + timeTo : '';
    }
  }, {
    key: 'terminalCommand',
    value: function terminalCommand(terminalCommandValue, commandText) {
      this.AdminModalService.terminalCommand(terminalCommandValue, commandText);
    }
  }, {
    key: 'saveFilter',
    value: function saveFilter(asNew) {
      this.FilterEditorService.saveFilter(asNew);
    }
  }, {
    key: 'editFilter',
    value: function editFilter() {
      if (this.CurrentFilterService.filter.isCardFilter) return;
      var filter = this.CurrentFilterService.filter.id && this.CurrentFilterService.filter.isAnalyticPolitic ? this.FiltersService.findById(this.CurrentFilterService.filter.id) : this.CurrentFilterService.filter;
      this.FilterEditorService.editModal({
        filter: filter,
        asNew: false,
        selectFilter: true
      });
    }
  }, {
    key: 'updateServer',
    value: function updateServer() {
      this.$modal.open({
        templateUrl: 'updatesDialog.html',
        controller: _modals.updatesCtrl
      }).result.then(function (result) {
        // console.log(result);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: 'selectLang',
    value: function selectLang(lang) {
      if (lang !== this.$cookies.get('django_language')) {
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 100);
        this.$cookies.put('django_language', lang, {
          expires: expires
        });
        location.reload();
      }
    }
  }, {
    key: 'newFilter',
    value: function newFilter(type) {
      this.router.isEditDasboard = false;
      this.router.newFilter(type);
    }
  }, {
    key: 'viewReport',
    value: function viewReport() {
      this.router.panel = 'catalog';
      this.$rootScope.$broadcast('resize');
    }
  }, {
    key: 'getEventsLink',
    value: function getEventsLink() {
      var timeFrom = this.CurrentFilterService.getTimeFrom();
      var timeTo = this.CurrentFilterService.getTimeTo();
      return '/analytics/get_events?time_from=' + timeFrom + '&time_to=' + timeTo;
    }
  }, {
    key: 'getEventsFileName',
    value: function getEventsFileName() {
      return 'Events.zip';
    }
  }, {
    key: 'download',
    value: function download($event) {
      var _this4 = this;

      var table = void 0;
      var table_id = 'datatable';
      if (this.filter.mode === 'stat' || this.filter.mode === 'explore') {
        table = document.getElementById(table_id);
      } else {
        if (this.hasGridId) {
          table_id = 'grid';
        }
        var htmlTable = document.getElementById('iframe').contentDocument.getElementById(table_id);
        table = htmlTable ? this.createExcelTable(htmlTable) : null;
      }
      if (!table) return true;
      if (this.filter.mode === 'explore' && !(this.filter.toExcel && this.filter.toExcel.convertToExel)) {
        this.filter.toExcel = {
          normalLimit: this.filter.customLimit,
          convertToExel: true
        };
        if (!this.filter.customLimit) this.filter.limit = 500; // DEFAULT_STAT_LIMIT;
        this.$rootScope.$broadcast('reload');
        return true;
      }
      this.LayoutService.download = true;
      // this.$scope.$apply();
      this.$timeout(function () {
        var a = document.createElement('a');
        a.download = 'Stats.xls';
        document.body.appendChild(a);
        _excellentexport2.default.excel(a, table);

        _this4.$timeout(function () {
          a.click();
          document.body.removeChild(a);
          _this4.LayoutService.download = false;
        }, 0);
        return true;
      }, 0);
      return true;
    }
  }, {
    key: 'createExcelTable',
    value: function createExcelTable(table) {
      // drop hidden rows
      $(table).find('tr:hidden').attr('excel', false);
      var excelTable = table.cloneNode(true);
      $(excelTable).find('[excel=false]').remove();
      return excelTable;
    }

    // "agent_account@user_name:user_name"

  }, {
    key: 'getIsAgent',
    value: function getIsAgent(exect) {
      var AGENTDIM = 'agent_agent@';
      var USERDIM = 'agent_account@';
      var USERFULLDIM = 'agent_account@';
      if (exect) {
        AGENTDIM = 'agent_agent@computer_name:computer_name';
        USERDIM = 'agent_account@user_name:user_name';
        USERFULLDIM = 'agent_account@full_name:full_name';
      }
      var res = (this.filterBar.drilldown[0].indexOf(AGENTDIM) !== -1 || this.filterBar.drilldown[0].indexOf(USERDIM) !== -1 || this.filterBar.drilldown[0].indexOf(USERFULLDIM) !== -1) && this.currentFilter.filter && this.currentFilter.filter.filters && this.currentFilter.filter.filters.some(function (f) {
        return f.dimension.indexOf(AGENTDIM) !== -1 || f.dimension.indexOf(USERDIM) !== -1 || f.dimension.indexOf(USERFULLDIM) !== -1;
      });
      if (!res && !exect && this.currentFilter && this.currentFilter.lastScreenshots) {
        this.stopScreenView();
      }
      return res;
    }
  }, {
    key: 'stopScreenView',
    value: function stopScreenView() {
      this.router.cleanRemoteUsers();
      window.CACHE.reset();
      this.$rootScope.$broadcast('reload');
    }
  }, {
    key: 'connectRemoteUsers',
    value: function connectRemoteUsers() {
      var _this5 = this;

      this.AggregateDataService.loadRemoteUsers().then(function (data) {
        _this5.AggregateDataService.allRemoteUsers = data;
        _this5.AggregateDataService.updateRemoteUsers();
        if (!_this5.AggregateDataService.remoteUsers || !_this5.AggregateDataService.remoteUsers.length) {
          _this5.ErrorHandlerService.showErrorMessageBox(gettext('Ошибка'), gettext('Не удалось установить связь c агентами'), null, true);
        } else _this5.router.setRemoteUsers();
      });
    }
  }, {
    key: 'isUserNameWaxWidth',
    get: function get() {
      return this.userNameWaxWidth > 25;
    }
  }, {
    key: 'adminTitle',
    get: function get() {
      return gettext('Меню') + (this.permission.userName ? ' (' + this.permission.userName[0].toUpperCase() + this.permission.userName.substring(1) + ')' : '');
    }
  }, {
    key: 'isShowPanelWords',
    get: function get() {
      return this.$isShowPanelWords;
    }
  }, {
    key: 'isCardOrDashboard',
    get: function get() {
      return this.filter.isDashboard || this.filter.isCard;
    }
  }, {
    key: 'isFilterChanged',
    get: function get() {
      return this.currentFilter.filter ? this.currentFilter.filter.isChanged : false;
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    },
    set: function set(filter) {
      this.currentFilter.filter = filter;
    }
  }, {
    key: 'isDownloadToExcel',
    get: function get() {
      if (!this.filter || !this.currentFilter) return false;
      return (this.filter.mode === 'stat' || this.filter.isExplore && this.filter.listType === 'table' && this.permission.fact) && !this.currentFilter.frameUrl && this.filter.content_type == 'filter' && !this.filter.isCardOrDashboard || this.filter.mode === 'reports' && this.hasGridId;
    }
  }, {
    key: 'hasGridId',
    get: function get() {
      return this.filter.url === '/analytics/report/departure_time_report/' || this.filter.url === '/analytics/report/departure_time_report_by_group/' || this.filter.url === '/analytics/report/unproductive_time/' || this.filter.url === '/analytics/report/latecomers/' || this.filter.url === '/analytics/report/tabel/workinghours/' || this.filter.url === '/analytics/report/tabel/activetime/' || this.filter.url === '/analytics/report/tabel/torturernocount/' || this.filter.url === '/analytics/report/tabel/printerusage/' || this.filter.url === '/analytics/report/tabel/extended/' || this.filter.url === '/analytics/report/summary/' || this.filter.url === '/analytics/report/summary_by_group/' || this.filter.url === '/analytics/report/aggregate/index/' || this.filter.url === '/analytics/report/summary_statistic/' || this.filter.url === '/analytics/report/product_time_report/' || this.filter.url === '/analytics/report/facts/' || this.filter.url === '/analytics/report/sites/' || this.filter.url === '/analytics/inventory/devices/' || this.filter.url === '/analytics/inventory/apps/' || this.filter.url === '/analytics/report/anomaly/' || this.filter.url === '/analytics/report/stat/' || this.filter.url === '/analytics/report/stat/daily/' || this.filter.url === '/analytics/report/aggregate/index/?lenta=false';
    }
  }, {
    key: 'isScreenViewSelected',
    get: function get() {
      return this.router.isRemoteUsers || this.router.isLastScreenshots;
    }
  }]);

  return HeaderController;
}();

var HeaderComponent = exports.HeaderComponent = {
  template: __webpack_require__(1028),
  controller: HeaderController
};

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports = "<sc-sidebar-toggle></sc-sidebar-toggle><ul class=\"menu-list nav nav-pills pull-left\"><li><a ng-click=\"$ctrl.router.home()\" title=\"{{:: 'Перезагрузка страницы' | gettext }}\"><i class=\"icon-home\"></i> <span class=\"menuitem-menu-hideable\">{{:: 'Домой' | gettext }}</span></a></li><li class=\"dropdown\" role=\"menu\" ng-if=\"$ctrl.permission.policies\"><a class=\"dropdown-toggle\" title=\"{{:: 'Создать' | gettext }}\"><i class=\"icon-doc\"></i> <span class=\"menuitem-menu-hideable hideable\">{{:: 'Создать' | gettext }}</span> <i class=\"icon-down-dir\" style=\"text-align:right;margin-right:0\"></i></a><ul class=\"dropdown-menu dropdown-content\" role=\"menu\"><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('filter')\"><i class=\"icon-filter\"></i> <span>{{:: 'Фильтр' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('dashboard')\"><i class=\"icon-vcard\"></i> <span>{{:: 'Дашборд' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('policy')\"><i class=\"icon-hammer\"></i> <span>{{:: 'Политику' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('corpusprocessfilter')\"><i class=\"icon-search\"></i> <span>{{:: 'Поиск по словарю' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('folder')\"><i class=\"icon-folder-open-empty\"></i> <span>{{:: 'Папку' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\"><a ng-click=\"$ctrl.newFilter('filteraggregatealertfilter')\"><i class=\"icon-attention\"></i> <span>{{:: 'Срабатывание по порогу' | gettext }}</span></a></li></ul></li></ul><ul class=\"menu-list nav nav-pills show-screen-panel\"><li ng-show=\"$ctrl.permission.filterConstructor && $ctrl.isScreenViewSelected\"><a ng-click=\"$ctrl.stopScreenView()\" title=\"{{:: 'Отменить просмотр экранов' | gettext }}\"><i class=\"icon-eye-off\"></i> <span class=\"menuitem-menu-hideable\">{{:: 'Отменить просмотр экранов' | gettext }}</span></a></li><li class=\"dropdown\" role=\"menu\" ng-show=\"$ctrl.permission.filterConstructor && $ctrl.getIsAgent(false) && !$ctrl.isScreenViewSelected\"><a class=\"dropdown-toggle\" title=\"{{:: 'Просмотр экранов' | gettext }}\"><i class=\"icon-eye\"></i> <span class=\"menuitem-menu-hideable\">{{:: 'Просмотр экранов' | gettext }}</span></a><ul class=\"dropdown-menu dropdown-content\" role=\"menu\"><li><a ng-click=\"$ctrl.router.setLastScreenshots(4)\"><i class=\"icon-file-image\"></i> <span>{{::'Последние снимки с экрана' | gettext }}</span></a></li><li><a ng-click=\"$ctrl.router.setLastScreenshots(20)\"><i class=\"icon-file-image\"></i> <span>{{::'Последние снимки с вебкамеры' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.getIsAgent(true)\"><a ng-click=\"$ctrl.connectRemoteUsers()\"><i class=\"icon-desktop\"></i> <span>{{::'Удалённые рабочие столы' | gettext}}</span></a></li></ul></li></ul><ul class=\"menu-list nav nav-pills lens-panel\"><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" class=\"lense-width active lens-tab\" ng-show=\"!$ctrl.currentFilter.frameUrl\"><a ng-click=\"$ctrl.editFilter()\" title=\"{{ $ctrl.filter.name }}\"><i ng-class=\"$ctrl.filter.getIcon()\"></i> <b class=\"report-name\">{{ $ctrl.filter.name }}</b>&nbsp; <span ng-show=\"!$ctrl.filter.saved\" class=\"label label-info\">{{:: 'Не сохранен' | gettext }}</span> <span ng-show=\"$ctrl.filter.isChanged\" class=\"label label-important\">{{:: 'Изменен' | gettext }}</span> <i ng-if=\"!$ctrl.filter.isCardFilter\" class=\"icon-cog pull-right\"></i></a></li><li ng-if=\"!$ctrl.permission.filterConstructor || !$ctrl.permission.policies\" class=\"lense-width active lens-tab\" ng-show=\"!$ctrl.currentFilter.frameUrl\"><a ng-click=\"$strl.nop($event)\"><i ng-class=\"$ctrl.filter.getIcon()\"></i> <b class=\"report-name\">{{ $ctrl.filter.name }}</b>&nbsp;</a></li><li class=\"lense-width\">&nbsp;</li><li class=\"lense-width\" ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" ng-show=\"(!$ctrl.filter.saved || $ctrl.filter.isChanged) && !$ctrl.currentFilter.frameUrl\"><a ng-click=\"$ctrl.saveFilter()\" title=\"{{:: 'Сохранить' | gettext }}\"><i class=\"icon-floppy\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Сохранить' | gettext }}</span></a></li><li class=\"lense-width\" ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" ng-show=\"$ctrl.filter.saved && ($ctrl.filter.isChanged || $ctrl.filter.isCard)\n              && !$ctrl.filter.isDashboard && !$ctrl.currentFilter.frameUrl\"><a ng-click=\"$ctrl.saveFilter(true)\" title=\"{{:: 'Сохранить как...' | gettext }}\"><i class=\"icon-file\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Сохранить как...' | gettext }}</span></a></li><li class=\"lense-width\" ng-if=\"$ctrl.permission.filterConstructor && $ctrl.permission.policies\" ng-show=\"$ctrl.filter.isChanged && !$ctrl.currentFilter.frameUrl\"><a ng-click=\"$ctrl.reset()\" title=\"{{:: 'Отменить изменения' | gettext }}\"><i class=\"icon-cancel\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Отменить' | gettext }}</span></a></li><li class=\"lense-width\" ng-if=\"$ctrl.currentFilter.frameUrl\"><a target=\"_blank\" ng-click=\"$ctrl.openNewWindow()\" title=\"{{:: 'Открыть в окне' | gettext }}\"><i class=\"icon-publish\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Открыть в новом окне' | gettext }}</span></a></li><li class=\"lense-width dropdown\" ng-show=\"!$ctrl.currentFilter.frameUrl\"><a class=\"dropdown-toggle\" title=\"{{:: 'Выгрузка и печать' | gettext }}\"><i class=\"icon-download-1\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Выгрузка и печать' | gettext }}</span> <i class=\"icon-down-dir\" style=\"text-align:right;margin-right:0\"></i></a><ul class=\"dropdown-menu dropdown-content\" role=\"menu\"><li><a ng-click=\"$ctrl.printContainer();\"><span>{{:: 'Распечатать на принтере' | gettext }}</span></a></li><li ng-show=\"$ctrl.isDownloadToExcel\"><a ng-click=\"$ctrl.download($event)\"><span>{{::'Выгрузка в Excel' | gettext}}</span> <a id=\"ExcelDownloadItem\" download=\"Events.xls\">Events.xls</a></a></li><li ng-if=\"$ctrl.filter.saved && !$ctrl.filter.isChanged && !$ctrl.currentFilter.frameUrl && !$ctrl.currentFilter.filter.isCard\"><a title=\"{{:: 'Выгрузка в PDF' | gettext }}\" target=\"_blank\" ng-href=\"{{$ctrl.getLinkToPDF()}}\"><span>{{:: 'Выгрузка в PDF' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.fact\"><a title=\"{{::'Сохранить как изображение' | gettext}}\" ng-click=\"$ctrl.saveAsPicture();\"><span>{{::'Сохранить как изображение' | gettext}}</span></a></li><li ng-if=\"$ctrl.filter.isExplore && $ctrl.permission.fact && !$ctrl.currentFilter.frameUrl\"><a title=\"{{::'Отчет для выгрузки и печати' | gettext}}\" ng-click=\"$ctrl.htmlReport();\"><span>{{::'Выгрузка в HTML' | gettext}}</span></a></li><li ng-if=\"!$ctrl.currentFilter.frameUrl && $ctrl.filter.isReports\n                && $ctrl.currentFilter.filter.url && !$ctrl.currentFilter.filter.isCard\"><a target=\"new\" ng-click=\"$ctrl.router.openNewWindow('&limit=1000000000')\"><span>{{:: 'Выгрузка в HTML' | gettext }}</span></a></li><li ng-if=\"$ctrl.filter.isExplore && $ctrl.permission.fact && !$ctrl.currentFilter.frameUrl\"><a target=\"new\" ng-click=\"$ctrl.currentFilter.filter.url ='/analytics/get_events';\n                    $ctrl.openNewDataWindow();\"><span>{{:: 'Выгрузка в CSV' | gettext }}</span></a></li><li ng-if=\"$ctrl.filter.isExplore && $ctrl.permission.fact && !$ctrl.currentFilter.frameUrl\"><a title=\"{{:: 'Скачать файлы в ZIP архивe' | gettext }}\" href=\"{{$ctrl.zipUrl}}\" ng-click=\"$ctrl.downloadZip()\"><span>{{:: 'Скачать файлы в ZIP архивe' | gettext }}</span></a></li></ul></li><li class=\"dropdown pull-right admin-menu\"><a class=\"dropdown-toggle\" title=\"{{$ctrl.adminTitle}}\"><i class=\"lense-width icon-menu\"></i> <span class=\"lense-admin-width\" ng-if=\"$ctrl.isShowPanelWords\" style=\"display:inline-flex\"><span class=\"lense-width menu\">{{:: 'Меню' | gettext }} </span><span ng-if=\"$ctrl.isUserNameWaxWidth\" style=\"display:inline-flex\">(<div class=\"lense-admin-width\" ng-style=\"{'overflow': 'hidden', 'text-overflow': 'ellipsis',  'max-width': $ctrl.userNameWaxWidth + 'px'}\">{{$ctrl.permission.userName}}</div>) </span></span><i class=\"lense-width icon-down-dir\" style=\"text-align:right;margin-right:0\"></i></a><ul class=\"dropdown-menu\" role=\"menu\"><li><a ng-click=\"$ctrl.updateServer();\">{{:: 'О программе' | gettext }}</a></li><li ng-if=\"$ctrl.permission.selectedLang == 'en'\"><a href=\"/static/staffcop/docs_en/\" target=\"_blank\">User manual</a></li><li ng-if=\"$ctrl.permission.selectedLang === 'en'\"><a href=\"https://help.staffcop.com/?lang=en_US\" target=\"_blank\">{{:: 'Поддержка' | gettext }}</a></li><li ng-if=\"$ctrl.permission.selectedLang == 'ru'\"><a href=\"/static/staffcop/docs_ru/\" target=\"_blank\">{{:: 'Документация' | gettext }}</a></li><li ng-if=\"$ctrl.permission.selectedLang !== 'en'\"><a href=\"https://help.staffcop.ru/?lang=ru\" target=\"_blank\">{{:: 'Поддержка' | gettext }}</a></li><li ng-if=\"$ctrl.permission.backends.length > 1\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.backends.length > 1\" class=\"dropdown-submenu pull-left\"><a class=\"dropdown-toggle\">{{:: 'База данных' | gettext }}:&nbsp; <span style=\"text-transform:capitalize\">{{ $ctrl.permission.getBackend() }}</span> <img class=\"backend-icon\" ng-src=\"/static/img/{{ $ctrl.permission.getBackend() }}.png\"></a><ul class=\"dropdown-menu\"><li ng-repeat=\"backend in $ctrl.permission.backends\"><a ng-click=\"$ctrl.permission.selectBackend(backend)\" style=\"text-transform:capitalize\"><img class=\"backend-icon\" ng-src=\"/static/img/{{ backend }}.png\">{{ backend }}</a></li></ul></li><li ng-if=\"$ctrl.permission.languagesCount > 1\" class=\"dropdown-submenu pull-left\"><a class=\"dropdown-toggle\">{{:: 'Язык интерфейса' | gettext }}:&nbsp; <span>{{ $ctrl.permission.languages[$ctrl.permission.selectedLang] }}</span> <span class=\"flag-icon\" ng-class=\"$ctrl.langClasses[$ctrl.permission.selectedLang]\"></span></a><ul class=\"dropdown-menu\"><li ng-repeat=\"(code, name) in $ctrl.permission.languages\"><a ng-click=\"$ctrl.selectLang(code)\"><span class=\"flag-icon\" ng-class=\"$ctrl.langClasses[code]\"></span> {{ name }}</a></li></ul></li><li><a ng-click=\"$ctrl.openOptions()\">{{:: 'Локальные настройки' | gettext }}</a></li><li class=\"divider\"></li><li><a sc-xref=\"/admin/password_change/\">{{:: 'Сменить пароль' | gettext }}</a></li><li><a href=\"/accounts/logout/\">{{:: 'Завершить работу' | gettext }}</a></li></ul></li><li ng-if=\"$ctrl.permission.config || $ctrl.permission.schedule || $ctrl.permission.agent_install\" class=\"lense-width dropdown pull-right\"><a class=\"dropdown-toggle\" title=\"{{:: 'Администрирование' | gettext }}\"><i class=\"icon-cogs\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Админ' | gettext }}</span> <i class=\"icon-down-dir\" style=\"text-align:right;margin-right:0\"></i></a><ul id=\"panel_menu\" class=\"dropdown-menu\" role=\"menu\"><li ng-if=\"$ctrl.permission.console\"><a target=\"_blank\" href=\"/console/console/\"><span>{{:: 'Консоль терминала' | gettext }}</span></a></li><li ng-if=\"$ctrl.permission.schedule\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.schedule\"><a sc-xref=\"/admin/work_calendar/weekschedule/\">{{:: 'Рабочее расписание' | gettext }}</a></li><li ng-if=\"$ctrl.permission.schedule\"><a sc-xref=\"/admin/work_calendar/weekscheduledimension/\">{{:: 'Назначение расписаний' | gettext }}</a></li><li ng-if=\"$ctrl.permission.schedule\"><a sc-xref=\"/work_calendar/calendar/\">{{:: 'Календарь' | gettext }}</a></li><li ng-if=\"$ctrl.permission.admin\"><a target=\"_blank\" href=\"/incident/\">{{:: 'Инциденты' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.config\"><a sc-xref=\"/analytics/recent_actions/\">{{:: 'Последние действия' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\"><a sc-xref=\"/analytics/status/\">{{:: 'Cтатус сервера' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\"><a href=\"#\" ng-click=\"$ctrl.debugInfo(); $event.preventDefault();\">{{ 'Отладочная информация' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\"><a href=\"#\" ng-click=\"$ctrl.LayoutService.openServerInfo(); $event.preventDefault();\">{{ 'Общая информация о сервере' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\"><a sc-xref=\"/license/\">{{:: 'Информация о лицензии' | gettext }}</a></li><li ng-if=\"$ctrl.permission.config\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.config\" ng-repeat=\"(code, name) in $ctrl.permission.terminalCommands\"><a ng-click=\"$ctrl.terminalCommand(code, name)\">{{name}}</a></li><li ng-if=\"$ctrl.permission.config\" class=\"divider\"></li><li ng-if=\"$ctrl.permission.admin && $ctrl.permission.is_staff\"><a href=\"/accounts/logout_everyone/\">{{:: 'Завершить все сеансы работы' | gettext }}</a></li></ul></li><li ng-if=\"$ctrl.permission.config || $ctrl.permission.schedule || $ctrl.permission.agent_install\" class=\"lense-width dropdown pull-right\"><a class=\"dropdown-toggle\" title=\"{{:: 'Панель управления' | gettext }}\"><i class=\"icon-explore\"></i> <span ng-if=\"$ctrl.isShowPanelWords\">{{:: 'Панель управления' | gettext }}</span> <i class=\"icon-down-dir\" style=\"text-align:right;margin-right:0\"></i></a><ul class=\"dropdown-menu\" ng-include src=\"'panel_menu.html'\"></ul></li></ul>"

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(28);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1030);

var FooterController = function () {
  function FooterController($scope, CurrentFilterService, CurrentModelService, $rootScope, PermissionService, RouterService, FiltersService, CurrentFilterDataService, CancelersService, LayoutService, AggregateDataService, ServerInformationService, FilterEditorService, AdminModalService) {
    _classCallCheck(this, FooterController);

    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.CurrentModelService = CurrentModelService;
    this.LayoutService = LayoutService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.CancelersService = CancelersService;
    this.locLabel = _filter.Filter.locLabel;
    this.AggregateDataService = AggregateDataService;
    this.ServerInformationService = ServerInformationService;
    this.FilterEditorService = FilterEditorService;
    this.AdminModalService = AdminModalService;
  }

  _createClass(FooterController, [{
    key: 'reload',
    value: function reload() {
      window.CACHE.reset();
      this.$rootScope.$broadcast('reload');
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.AggregateDataService.cancel();
      this.CurrentFilterDataService.filterData.cancel();
    }
  }, {
    key: 'hddStatus',
    value: function hddStatus() {
      this.AdminModalService.hddStatus();
    }
  }, {
    key: 'databaseStatus',
    value: function databaseStatus() {
      this.AdminModalService.databaseStatus();
    }
  }, {
    key: 'editQueryFilter',
    value: function editQueryFilter() {
      return this.FilterEditorService.editModal({
        filter: this.filter,
        asNew: false,
        selectFilter: false,
        tabName: 'QueryTab'
      });
    }
  }, {
    key: 'model',
    get: function get() {
      return this.CurrentModelService.model;
    }
  }, {
    key: 'filter',
    get: function get() {
      return this.currentFilter.filter;
    },
    set: function set(filter) {
      this.currentFilter.filter = filter;
    }
  }, {
    key: 'hddUsage',
    get: function get() {
      return this.ServerInformationService.hddUsage;
    }
  }, {
    key: 'hddAlarm',
    get: function get() {
      return this.ServerInformationService.hddAlarm;
    }
  }, {
    key: 'databaseAlarm',
    get: function get() {
      return this.ServerInformationService.databaseAlarm;
    }
  }, {
    key: 'isEventsLoading',
    get: function get() {
      return this.CurrentFilterDataService.filterData.loading || this.CurrentFilterDataService.filterData.loadingMore || this.FiltersService.loading;
    }
  }, {
    key: 'isLoading',
    get: function get() {
      return this.CurrentModelService.loading || this.CurrentFilterDataService.filterData.loading || this.currentFilter.imageLoading || this.CurrentFilterDataService.filterData.loadingMore || this.AggregateDataService.loading || this.AggregateDataService.loadingMore || this.FiltersService.loading || this.LayoutService.loading;
    }
  }, {
    key: 'databaseUsage',
    get: function get() {
      return this.ServerInformationService.databaseUsage;
    }
  }, {
    key: 'loadTime',
    get: function get() {
      var _this = this;

      if (this.currentFilter.filter && this.currentFilter.filter.isCardOrDashboard) {
        var dd = this.CurrentFilterDataService.dashboardData;
        var keys = Object.keys(dd);
        var minStart = 0;
        var maxFinish = 0;
        keys.forEach(function (key) {
          if (dd[key].currentFilterId && dd[key].currentFilterId != _this.currentFilter.filter.id) return;
          if (dd[key].startLoad < minStart || !minStart) minStart = dd[key].startLoad;
          if (dd[key].finishLoad > maxFinish || !maxFinish) maxFinish = dd[key].finishLoad;
        });
        return maxFinish > minStart ? Math.round((maxFinish - minStart) / 10) / 100 : 0;
      } else {
        var fd = this.CurrentFilterDataService.filterData;
        return fd.finishLoad > fd.startLoad ? Math.round((fd.finishLoad - fd.startLoad) / 10) / 100 : 0;
      }
    }
  }]);

  return FooterController;
}();

var FooterComponent = exports.FooterComponent = {
  template: __webpack_require__(1031),
  controller: FooterController
};

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports = "<ul class=\"filter-ops nav nav-pills pull-left\"><li class=\"global-reload\" ng-if=\"!$ctrl.isLoading\"><a ng-click=\"$ctrl.reload()\"><i class=\"icon-reload\"></i> <span class=\"hideable\" ng-if=\"!$ctrl.CurrentFilterDataService.needReload\">{{:: 'Обновить' | gettext }} </span><span class=\"hideable\" ng-if=\"$ctrl.CurrentFilterDataService.needReload\">{{:: 'Применить' | gettext }}</span></a></li><li class=\"global-spinner\" ng-if=\"$ctrl.isLoading\"><a ng-click=\"$ctrl.cancel()\"><i class=\"icon-loading animate-spin\" title=\"{{:: 'Отмена' | gettext }}\"></i> <span class=\"hideable\">{{:: 'Отмена' | gettext }}</span></a></li></ul><ul class=\"filter-list nav nav-pills pull-left\"><li ng-if=\"$ctrl.permission.filterConstructor && $ctrl.filter.hasQuery\"><a class=\"filter-badge\"><span class=\"badge badge-warning\"><span class=\"filter-right-menu\" ng-click=\"$ctrl.router.removeConditions()\">×</span><div class=\"filter-label\" ng-click=\"$ctrl.editQueryFilter(); $event.stopPropagation();\"><i class=\"icon-cog\"></i> {{:: 'Сложный фильтр' | gettext }}</div></span></a></li><li ng-if=\"$ctrl.permission.filterConstructor\" ng-repeat=\"f in $ctrl.filter.filters.slice().reverse()\" ng-click=\"$ctrl.router.removeFilter(f);\"><a class=\"filter-badge\"><span class=\"badge\" ng-class=\"(f.predicates && f.predicates.indexOf('!')>=0) ? 'badge-important': 'badge-info'\"><span class=\"filter-left-menu\" ng-click=\"$ctrl.router.invertFilter(f); $event.stopPropagation();\">±</span> <span class=\"filter-right-menu\">&nbsp;×</span><div class=\"filter-label might-overflow\">{{ $ctrl.model.getDrillLabel( f.dimension ) }}: <b class=\"filter-value\">{{ $ctrl.locLabel(f)}}</b></div></span></a></li><li class=\"pull-right load-time\" ng-if=\"!$ctrl.isLoading && $ctrl.loadTime\" title=\"{{:: 'Загружено за' | gettext }} {{$ctrl.loadTime}} {{:: 'сек' | gettext }}\"><i class=\"icon-clock-1\"></i> <span class=\"hideable\">{{:: 'Загружено за' | gettext }} {{$ctrl.loadTime}} {{:: 'сек' | gettext }}</span></li><li ng-if=\"($ctrl.permission.sessionDb === 'default' || !$ctrl.permission.sessionDb) &&\n     $ctrl.databaseUsage && $ctrl.databaseAlarm && $ctrl.databaseUsage >= $ctrl.permission.databaseUsageLimit\" class=\"pull-right\"><a class=\"super-alarm\" title=\"{{:: 'Приём данных от агентов приостановлен. Пожалуйста, увеличьте размер диска либо удалите старые данные.' | gettext }}\" ng-click=\"$ctrl.databaseStatus()\"><i class=\"icon-attention\"></i> {{:: 'Диск БД переполнен!' | gettext }}</a></li><li class=\"pull-right\" ng-if=\"$ctrl.permission.sessionDb && $ctrl.permission.sessionDb !== 'default'\"><a><i class=\"icon-attention\"></i> {{:: 'Архивная база данных' | gettext }} {{ $ctrl.permission.sessionDb }}</a></li><li ng-if=\"($ctrl.permission.sessionDb === 'default' || !$ctrl.permission.sessionDb) &&\n     $ctrl.permission.maxAgentsExceeded\" class=\"pull-right\"><a sc-xref=\"/license/\" class=\"alarm\" title=\"{{:: 'Достигнуто максимальное количество компьютеров или пользователей. Щёлкните для просмотра информации о лицензии.' | gettext }}\"><i class=\"icon-attention\"></i> <span class=\"hideable\">{{:: 'Достигнуто ограничение лицензии' | gettext }}.</span></a></li><li ng-if=\"($ctrl.permission.sessionDb === 'default' || !$ctrl.permission.sessionDb) &&\n     $ctrl.hddUsage && $ctrl.hddAlarm && $ctrl.hddUsage >= $ctrl.hddAlarm\" class=\"pull-right\"><a class=\"alarm\" title=\"{{:: 'Диск заполнен на' | gettext }} {{ $ctrl.hddUsage }}%\" ng-click=\"$ctrl.hddStatus()\"><i class=\"icon-attention\"></i> {{:: 'Диск заполнен на' | gettext }} {{ $ctrl.hddUsage }}%</a></li><li ng-if=\"($ctrl.permission.sessionDb === 'default' || !$ctrl.permission.sessionDb) &&\n     $ctrl.databaseUsage && $ctrl.databaseAlarm && $ctrl.databaseUsage >= $ctrl.databaseAlarm &&\n     $ctrl.databaseUsage !== $ctrl.hddUsage\" class=\"pull-right\"><a class=\"alarm\" title=\"{{:: 'Диск БД заполнен на' | gettext }} {{ $ctrl.databaseUsage }}%\" ng-click=\"$ctrl.databaseStatus()\"><i class=\"icon-attention\"></i> {{:: 'Диск БД заполнен на' | gettext }} {{ $ctrl.databaseUsage }}%</a></li></ul>"

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scAdminModule = undefined;

var _core = __webpack_require__(60);

var _adminModal = __webpack_require__(1033);

var scAdminModule = exports.scAdminModule = 'sc-admin';

angular.module(scAdminModule, [_core.scCoreModule]).service('AdminModalService', _adminModal.AdminModalService);

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _terminalCommandModal = __webpack_require__(344);

var _debugInfoModal = __webpack_require__(345);

var _hddUsageModal = __webpack_require__(1034);

var _databaseUsageModal = __webpack_require__(1035);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdminModalService = exports.AdminModalService = function () {
  function AdminModalService($modal) {
    _classCallCheck(this, AdminModalService);

    this.$modal = $modal;
  }

  _createClass(AdminModalService, [{
    key: 'terminalCommand',
    value: function terminalCommand(terminalCommandValue, _commandText) {
      console.log(terminalCommandValue, _commandText);
      this.$modal.open({
        template: __webpack_require__(1037),
        controller: _terminalCommandModal.TerminalCommandModal,
        scope: this.$scope,
        resolve: {
          command: function command() {
            return terminalCommandValue;
          },
          commandText: function commandText() {
            return _commandText;
          }
        }
      }).result.catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: 'debugInfo',
    value: function debugInfo() {
      this.$modal.open({
        template: __webpack_require__(1038),
        controller: _debugInfoModal.DebugInfoModal,
        scope: this.$scope
      }).result.catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: 'hddStatus',
    value: function hddStatus() {
      this.$modal.open({
        template: __webpack_require__(1039),
        controller: _hddUsageModal.HddUsageModalController
      }).result.then(function (result) {
        //console.log(result);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }, {
    key: 'databaseStatus',
    value: function databaseStatus() {
      this.$modal.open({
        template: __webpack_require__(1040),
        controller: _databaseUsageModal.DatabaseUsageModalController
      }).result.then(function (result) {
        //console.log(result);
      }).catch(function (err) {
        console.error(err);
      });
    }
  }]);

  return AdminModalService;
}();

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//require('./debug-info-modal.component.scss');

var HddUsageModalController = exports.HddUsageModalController = function HddUsageModalController($scope, $modalInstance, ServerInformationService) {
  _classCallCheck(this, HddUsageModalController);

  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.hddHardLimit = ServerInformationService.hddHardLimit;
  $scope.hddUsage = ServerInformationService.hddUsage;
};

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//require('./debug-info-modal.component.scss');
__webpack_require__(1036);

var DatabaseUsageModalController = exports.DatabaseUsageModalController = function DatabaseUsageModalController($scope, $modalInstance, ServerInformationService, PermissionService) {
  _classCallCheck(this, DatabaseUsageModalController);

  $scope.close = function () {
    $modalInstance.close();
  };
  $scope.databaseUsage = ServerInformationService.databaseUsage;
  $scope.databasePath = ServerInformationService.databasePath;
  $scope.databaseUsageLimit = PermissionService.databaseUsageLimit;
};

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button ng-show=\"!restarting\" type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"close()\">&times;</button><h3>{{commandText}}</h3></div><div class=\"modal-body\"><div ng-show=\"!(restarting||restartFailed)\">{{::'Выполнить операцию ?'|gettext}}</div><div ng-show=\"restarting\">{{::'Пожалуйста, подождите..'|gettext}}<div class=\"progress progress-striped active\" style=\"width:50%\"><div class=\"bar\" style=\"width:100%\"></div></div></div><div ng-show=\"restartFailed\">{{::'Что-то пошло не так!'|gettext}}</div></div><div class=\"modal-footer\"><div ng-show=\"!(restarting||restartFailed)\"><button class=\"btn btn-default\" ng-click=\"ok()\">{{::'Да'|gettext}}</button> <button class=\"btn btn-cancel\" ng-click=\"close()\">{{::'Нет'|gettext}}</button></div></div>"

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{::'Отладочная информация'|gettext}}</h4></div><div class=\"modal-body-debug\"><div class=\"tab-content form-horizontal aggregate-modal-debug\"><div class=\"control-group\"><div class=\"controls\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"options.log\"> {{::'Логи сервера'|gettext}}</label></div></div><div class=\"control-group\"><div class=\"controls\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"options.agent_config\"> {{::'Конфигурация агентов'|gettext}}</label></div></div><div class=\"control-group\"><div class=\"controls\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"options.agent_acl\"> {{::'Правила мониторинга'|gettext}}</label></div></div><div class=\"control-group\"><div class=\"controls\"><label class=\"checkbox\"><input type=\"checkbox\" ng-model=\"options.analytics_filters\"> {{::'Фильтры и политики'|gettext}}</label></div></div></div></div><div class=\"modal-footer\"><a class=\"btn\" ng-if=\"isOptions()\" ng-href=\"{{getLink()}}\" target=\"_blank\">{{::'Скачать' | gettext }} </a><a class=\"btn\" ng-if=\"!isOptions()\" disabled=\"disabled\">{{::'Скачать' | gettext }} </a><button class=\"btn\" ng-click=\"ok()\">{{::'Закрыть' | gettext }}</button></div>"

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"close()\">&times;</button> <b class=\"modal-title\">{{:: 'Состояние жёсткого диска' | gettext }}</b></div><div class=\"modal-body\"><b>{{:: interpolate(gettext('Занято %s% объема диска.'), [hddUsage]) }}</b><div ng-if=\"hddHardLimit\">{{:: interpolate(gettext('По достижении %s% наиболее старые файлы и скриншоты будут автоматически удаляться для освобождения места.'), [hddHardLimit]) }}</div><div ng-if=\"!hddHardLimit\">{{:: 'Автоочистка дискового пространства отключена. Пожалуйста, сделайте резервную копию и удалите старые файлы самостоятельно, либо включите автоочистку, установив значение параметра hdd_hard_percentage больше значения hdd_alarm_percentage, но меньше 100 в \"Настройках сервера\".' | gettext }}</div></div><div class=\"modal-footer\"><div class=\"btn-group\"><button class=\"btn\" ng-click=\"close()\">{{:: 'Закрыть' | gettext }}</button></div></div>"

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports = "<div class=\"database-usage\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"close()\">&times;</button> <b class=\"modal-title\">{{:: 'Состояние базы данных' | gettext }}</b></div><div class=\"modal-body\"><b>{{:: interpolate(gettext('Занято %s% объема диска.'), [databaseUsage]) }}</b><div>{{:: interpolate(gettext('Путь до базы данных: %s'), [databasePath]) }}</div><div ng-if=\"databaseUsage >= databaseUsageLimit\" class=\"alarm-message\">{{:: 'Приём данных от агентов приостановлен. Пожалуйста, увеличьте размер диска либо удалите старые данные.' | gettext }}</div></div><div class=\"modal-footer\"><div class=\"btn-group\"><button class=\"btn\" ng-click=\"close()\">{{:: 'Закрыть' | gettext }}</button></div></div></div>"

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldsModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fieldsModal = __webpack_require__(1042);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FieldsModalService = exports.FieldsModalService = function () {
  function FieldsModalService($timeout, $modal, RouterService) {
    _classCallCheck(this, FieldsModalService);

    this.router = RouterService;
    this.$timeout = $timeout;
    this.$modal = $modal;
  }

  // purpose = 'CSV' - for CSV export collumns selection
  // purpose = 'TABLE' - for facts table view collumns selection


  _createClass(FieldsModalService, [{
    key: 'open',
    value: function open(_purpose) {
      return this.$modal.open({
        template: __webpack_require__(1044),
        controller: _fieldsModal.FieldsModalController,
        resolve: {
          purpose: function purpose() {
            return _purpose;
          }
        }
      }).result;
    }
  }]);

  return FieldsModalService;
}();

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldsModalController = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tableView = __webpack_require__(62);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(1043);

var FieldsModalController = exports.FieldsModalController = function () {
  function FieldsModalController($scope, $modalInstance, purpose, RouterService, LocalStorageService, CurrentFilterService, CurrentModelService) {
    var _this = this;

    _classCallCheck(this, FieldsModalController);

    this.storageKey = 'SELECTED_FIELDS';
    this.$scope = $scope;
    $scope.okButton = gettext('Ок');
    $scope.cancelButton = gettext('Cancel');
    this.$modalInstance = $modalInstance;
    this.LocalStorageService = LocalStorageService;
    this.router = RouterService;
    this.lang = this.router.PermissionService.selectedLang;
    this.filter = CurrentFilterService.filter;
    this.dims = CurrentModelService.model._dimensions;
    this.measures = CurrentModelService.model.cubes[0].measures;
    this.$scope.isDefaultSelection = true;
    this.factKey = 'fact';
    // this.fields = Object.keys(this.router.CurrentFilterDataService.filterData.filterData[0]);
    $scope.fields = this.getFields();
    $scope.cancel = function () {
      return _this.cancel();
    };
    // $scope.getFieldSelected = (field) => this.getFieldSelected(field);
    $scope.getFieldUnselected = function (field) {
      return _this.getFieldUnselected(field);
    };
    $scope.setLevelSelected = function (level) {
      return _this.setLevelSelected(level);
    };
    $scope.setFieldSelected = function (field) {
      return _this.setFieldSelected(field);
    };
    $scope.removeSelection = function (selection) {
      return _this.removeSelection(selection);
    };
    $scope.setAllSelection = function (bool) {
      return _this.setAllSelection(bool);
    };
    $scope.setDefaultSelection = function () {
      return _this.setDefaultFields();
    };

    var selections = void 0;
    if (purpose === 'CSV') {
      $scope.ok = function () {
        return _this.okCSV();
      };
      $scope.modalTitle = gettext('Выберите поля для выгрузки в CSV');
      selections = this.LocalStorageService.getItem(this.storageKey);
    } else if (purpose === 'TABLE') {
      $scope.modalTitle = gettext('Выберите поля для вывода в таблице');
      $scope.ok = function () {
        return _this.okTable();
      };
      if (this.filter.fields && this.filter.fields.length) selections = this.filter.fields.join(',');
    } else $scope.ok = function () {
      return null;
    };

    this.$scope.isDefaultSelection = !selections;
    if (!this.$scope.isDefaultSelection) {
      $scope.selectedItems = selections.split(',').map(function (s) {
        var _s$split = s.split('.'),
            _s$split2 = _slicedToArray(_s$split, 2),
            parentKey = _s$split2[0],
            levelKey = _s$split2[1];

        return _this.getSelectedItem(parentKey, levelKey);
      }).filter(function (item) {
        return !!item;
      });
    } else {
      $scope.selectedItems = [];
      this.setDefaultFields();
    }
  }

  _createClass(FieldsModalController, [{
    key: 'setDefaultFields',
    value: function setDefaultFields() {
      var _this2 = this;

      this.setAllSelection(false);
      var viewMode = (0, _tableView.getTableViewByType)(this.filter.viewModeType(), this.filter.filters);
      if (!viewMode.columns || !viewMode.columns.length) return;
      viewMode.columns.map(function (v) {
        var _v$factKey$split = v.factKey.split('.'),
            _v$factKey$split2 = _slicedToArray(_v$factKey$split, 2),
            parentKey = _v$factKey$split2[0],
            levelKey = _v$factKey$split2[1];

        _this2.addSelection(parentKey, levelKey);
      });
      this.$scope.isDefaultSelection = true;
    }
  }, {
    key: 'setAllSelection',
    value: function setAllSelection(bool) {
      var _this3 = this;

      this.$scope.fields.map(function (f) {
        if (f.levels) f.levels.map(function (l) {
          l.selected = bool;
          if (bool) _this3.addSelection(l.parentKey, l.key);
        });else {
          f.selected = bool;
          _this3.addSelection(f.key);
        }
      });
      if (!bool) this.$scope.selectedItems = [];
      this.$scope.isDefaultSelection = false;
    }
  }, {
    key: 'getSelectedItem',
    value: function getSelectedItem(parentKey, levelKey) {
      if (!levelKey) {
        levelKey = parentKey;
        parentKey = this.factKey;
      }
      var res = {};
      var field = this.$scope.fields.find(function (f) {
        return f.key === parentKey;
      });
      if (!field) return null;
      res.parentKey = field.key;
      res.parentLabel = field.label;
      if (levelKey && field.levels) {
        var level = field.levels.find(function (l) {
          return l.key === levelKey;
        });
        if (level) {
          res.levelKey = level.key;
          res.levelLabel = level.label;
          if (level.lang) res.lang = level.lang;
          level.selected = true;
        }
      } else if (!field.levels) field.selected = true;
      return res;
    }
  }, {
    key: 'renameLabel',
    value: function renameLabel(name, label) {
      if (name === 'file_size') return gettext('Размер файла');
      if (name === 'activity_time') return gettext('Длительность');
      if (name === 'call_duration') return gettext('Время разовора / страницы');
      return label;
    }
  }, {
    key: 'getFields',
    value: function getFields() {
      var _this4 = this;

      var isLevels = function isLevels(dim) {
        return dim.levels && dim.levels.length && (dim.levels.length > 1 || dim.levels[0].attributes && dim.levels[0].attributes.length > 1);
      };

      return this.dims.filter(function (dim) {
        return isLevels(dim);
      }).map(function (dim) {
        return {
          key: dim.name,
          label: dim.label,
          selected: false,
          levels: dim.levels.reduce(function (accLevel, level) {
            if (level.attributes && level.attributes.length > 1) {
              return accLevel.concat(level.attributes.map(function (arrt) {
                return {
                  key: arrt.name,
                  lang: arrt.locales && arrt.locales.length ? _this4.lang : null,
                  parentKey: dim.name,
                  label: arrt.label,
                  selected: false
                };
              }).filter(function (f) {
                return f.label;
              }));
            }
            return accLevel.concat({
              key: level.key,
              lang: level.attributes && level.attributes[0] && level.attributes[0].locales && level.attributes[0].locales.length ? _this4.lang : null,
              parentKey: dim.name,
              label: level.label,
              selected: false
            });
          }, []).filter(function (f) {
            return !(f.parentKey === 'agent_dialog' && f.key === 'contact' || f.parentKey === 'agent_dialog' && f.key === 'domain');
          })
        };
      }).concat({
        key: this.factKey,
        label: gettext('Факт'),
        selected: false,
        levels: this.dims.filter(function (dim) {
          return !isLevels(dim);
        }).map(function (dim) {
          return {
            key: dim.name,
            parentKey: _this4.factKey,
            label: dim.label,
            selected: false
          };
        }).concat(this.measures.filter(function (m) {
          return m.name !== 'idle_time' && _this4.dims.every(function (d) {
            return d.name !== m.name;
          });
        }).map(function (m) {
          return {
            key: m.name,
            parentKey: _this4.factKey,
            label: _this4.renameLabel(m.name, m.label),
            selected: false
          };
        }))
      });
    }
  }, {
    key: 'setLevelSelected',
    value: function setLevelSelected(level) {
      level.selected = true;
      this.addSelection(level.parentKey, level.key);
    }
  }, {
    key: 'setFieldSelected',
    value: function setFieldSelected(field) {
      var _this5 = this;

      if (field.levels) field.levels.map(function (level) {
        level.selected = true;
        _this5.addSelection(level.parentKey, level.key);
      });else {
        field.selected = true;
        this.addSelection(field.key);
      }
    }

    // getFieldSelected(field) {
    //   if (field.levels) return field.levels.some(level => level.selected);
    //   return field.selected;
    // }

  }, {
    key: 'getFieldUnselected',
    value: function getFieldUnselected(field) {
      if (field.levels) return field.levels.some(function (level) {
        return !level.selected;
      });
      return !field.selected;
    }
  }, {
    key: 'findSelectionIndex',
    value: function findSelectionIndex(parentKey, levelKey) {
      return this.$scope.selectedItems.findIndex(function (s) {
        return s.parentKey === parentKey && (s.levelKey === levelKey || !levelKey && !s.levelKey);
      });
    }
  }, {
    key: 'setLevelUnselected',
    value: function setLevelUnselected(parentKey, levelKey) {
      var field = this.$scope.fields.find(function (f) {
        return f.key === parentKey;
      });
      if (!field) return;
      if (field.levels && levelKey) {
        var level = field.levels.find(function (l) {
          return l.key === levelKey;
        });
        if (level) level.selected = false;
      } else if (!field.levels) {
        field.selected = false;
      }
      this.$scope.isDefaultSelection = false;
    }
  }, {
    key: 'removeSelection',
    value: function removeSelection(selection) {
      var i = this.findSelectionIndex(selection.parentKey, selection.levelKey);
      if (i === -1) return;
      this.$scope.selectedItems.splice(i, 1);
      this.setLevelUnselected(selection.parentKey, selection.levelKey);
      this.$scope.isDefaultSelection = false;
    }
  }, {
    key: 'addSelection',
    value: function addSelection(parentKey, levelKey) {
      if (!levelKey) {
        levelKey = parentKey;
        parentKey = this.factKey;
      }
      var i = this.findSelectionIndex(parentKey, levelKey);
      if (i === -1) this.$scope.selectedItems.push(this.getSelectedItem(parentKey, levelKey));
      this.$scope.isDefaultSelection = false;
    }
  }, {
    key: 'getSelections',
    value: function getSelections(withLang) {
      var _this6 = this;

      return this.$scope.selectedItems.map(function (s) {
        return s.parentKey === _this6.factKey ? s.levelKey + (withLang && s.lang ? '.' + s.lang : '') : s.parentKey + '.' + (s.levelKey + (withLang && s.lang ? '.' + s.lang : ''));
      }).join(',');
    }
  }, {
    key: 'okCSV',
    value: function okCSV() {
      if (this.$scope.isDefaultSelection) this.LocalStorageService.removeItem(this.storageKey);else this.LocalStorageService.setItem(this.storageKey, this.$scope.selectedItems ? this.getSelections(false) : null);
      this.router.openNewWindow( true ? '&fields=' + this.getSelections(true) : '');
      this.$modalInstance.close();
    }
  }, {
    key: 'okTable',
    value: function okTable() {
      if (this.$scope.isDefaultSelection) {
        this.router.fields = null;
        if (this.filter.fields) {
          this.filter.fields = '';
          this.filter.changed();
        }
      } else if (this.$scope.selectedItems) this.router.fields = this.getSelections(false);

      this.$modalInstance.close(true);
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.$modalInstance.close(false);
    }
  }]);

  return FieldsModalController;
}();

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports = "<div class=\"fields-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\">{{modalTitle}}</h4></div><div class=\"modal-body\"><div style=\"border-right:solid thin #ddd\"><div class=\"col-head\">{{:: 'Доступные поля' | gettext }}</div><div class=\"col-body\"><div ng-repeat=\"field in fields\" title=\"{{:: 'Добавить поле' | gettext }}\" ng-if=\"getFieldUnselected(field)\" ng-class=\"field.levels ? 'field' : 'level'\" ng-click=\"setFieldSelected(field);\">{{field.label}}<div ng-repeat=\"level in field.levels\" ng-click=\"setLevelSelected(level); $event.stopPropagation();\" ng-if=\"field.levels && !level.selected\" class=\"level\">{{level.label}}</div></div></div></div><div><div class=\"col-head\">{{:: 'Выбранные поля' | gettext }}</div><div class=\"col-body\"><div class=\"selection\" ng-repeat=\"selection in selectedItems\" ng-click=\"removeSelection(selection)\" title=\"{{:: 'Убрать поле' | gettext }}\">{{selection.parentLabel}} <span ng-if=\"selection.levelKey\">- {{selection.levelLabel}}</span></div></div></div></div><div class=\"modal-footer\"><div style=\"display:flex\"><a class=\"selector-all\" ng-click=\"setAllSelection(true)\" title=\"{{:: 'Выбрать все' | gettext }}\">{{:: 'Выбрать все' | gettext }} <i class=\"icon-right-dir\"></i> </a><a class=\"selector-all\" ng-click=\"setAllSelection(false)\" title=\"{{:: 'Убрать все' | gettext }}\"><i class=\"icon-left-dir\"></i> {{:: 'Удалить все' | gettext }}</a></div><div style=\"position:relative\"><a ng-if=\"!isDefaultSelection\" class=\"default-selection\" ng-click=\"setDefaultSelection()\" title=\"{{:: 'Поля по умолчанию' | gettext }}\"><i class=\"icon-th-list\"></i> {{:: 'Поля по умолчанию' | gettext }} </a><span ng-if=\"isDefaultSelection\" style=\"color:#676767\" class=\"default-selection\"><i class=\"icon-th-list\"></i> {{:: 'Поля по умолчанию' | gettext }}</span><div class=\"\"><button class=\"btn\" ng-click=\"ok()\">{{ okButton }}</button> <button class=\"btn\" ng-click=\"cancel()\">{{ cancelButton }}</button></div></div></div></div>"

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scFaceModule = undefined;

var _core = __webpack_require__(60);

var _face = __webpack_require__(340);

var scFaceModule = exports.scFaceModule = 'sc-face';

angular.module(scFaceModule, []).service('FaceService', _face.FaceService);

/***/ }),
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import { IS_SIDEBAR_OPENED, LocalStorageService  } from '../core/local-storage.service.js';

angular.module('bgDirectives', []).directive('bgSplitter', ["$rootScope", "$timeout", function ($rootScope, $timeout) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      pos: '=',
      orientation: '@',
      name: '@'
    },
    template: '<div class="maximize split-panes {{orientation}}" ng-transclude></div>',
    controller: ["$scope", function controller($scope) {
      $scope.panes = [];
      this.addPane = function (pane) {
        if ($scope.panes.length > 1) throw 'splitters can only have two panes';
        $scope.panes.push(pane);
        return $scope.panes.length;
      };
      $scope.showDimensions = false;
    }],
    link: function link(scope, element) {
      var handler = angular.element('<div class="split-handler"></div>');
      var pane1 = scope.panes[0];
      var pane2 = scope.panes[1];
      var vertical = scope.orientation == 'vertical';
      var pane1Min = pane1.minSize || 0;
      var pane2Min = pane2.minSize || 0;

      if (pane2.hide) {
        pane1.elem.css('width', '100%');
        pane2.elem.hide();
      }

      if (pane1.hide) {
        pane2.elem.css('width', '100%');
        pane1.elem.hide();
      }

      if (pane1.hide || pane2.hide) return;

      var drag = false;
      pane1.elem.after(handler);

      // const storageSrv = new LocalStorageService();

      if (vertical) {
        var oldHeight = void 0;
        var setSplitter = function setSplitter(pos, limit) {
          oldHeight = element.height();
          var height = oldHeight;
          var pane1Height = pos;
          if (limit) {
            if (pos < pane1Min) pane1Height = pane1Min;
            if (pos > height - pane2Min) pane1Height = height - pane2Min;
          }
          pane1.elem.css('height', pane1Height + 'px');
          handler.css('top', pane1Height + 'px');
          var heightHandler = handler.height();
          pane2.elem.css('top', pane1Height + heightHandler + 'px');
          var pane2Height = height - pane1Height - heightHandler;
          pane2.elem.css('height', pane2Height + 'px');
          // console.log(scope.name + 'Changed', pane1Height, pane2Height, scope.name);
          $rootScope.$broadcast(scope.name + 'Changed', pane1Height, pane2Height, scope.name);
        };

        var setUp = function setUp() {
          if (!pane1.elem.height()) {
            return;
          }
          var newHeight = element.height();
          var ratio = oldHeight && newHeight ? newHeight / oldHeight : 1;
          var pos = pane1.elem.height() * ratio;
          setSplitter(pos);
        };

        scope.$on('resize', setUp);

        var pane1Initial = Math.round($('#facts-container').height() / 5 * 4);

        element.bind('mousemove', function (ev) {
          if (!drag) return;
          var bounds = element[0].getBoundingClientRect();
          var pos = ev.clientY - bounds.top;
          var maxPos = element.height() - handler.height();
          if (pos > maxPos) {
            pos = maxPos;
          }
          setSplitter(pos, true);
        });
        var togglePane2 = function togglePane2(setstate) {
          var oldState = scope.showPane2;
          var newState = setstate != undefined ? setstate : !scope.showPane2;
          if (oldState == newState) return;
          scope.showPane2 = newState;
          var state = scope.showPane2;
          if (state == false) {
            scope.pane1ElemHeight = pane1.elem.height();
            setSplitter(element.height() - handler.height());
          } else {
            if (scope.pane1ElemHeight) {
              setSplitter(scope.pane1ElemHeight);
            } else {
              setSplitter(pane1Initial);
            }
          }
        };
        handler.bind('dblclick', function () {
          togglePane2();
        });
        handler.bind('click', function () {
          if (pane1.elem.height() == element.height() - handler.height()) {
            togglePane2();
          }
        });
        scope.$on('showPane2', function () {
          scope.pane1ElemHeight = $(window).height() / 2;
          togglePane2(true);
        });
        scope.$on('hidePane2', function () {
          togglePane2(false);
        });
        scope.$watch('pos', function (pos) {
          if (pos) setSplitter(pos, 0);
        });
      } else {
        // let lastPos;
        var _setSplitter = function _setSplitter(pos, limit) {
          // if (pos === lastPos) return;
          // lastPos = pos;
          var bounds = element[0].getBoundingClientRect();
          var width = bounds.right - bounds.left;
          scope.pane1Width = pos;
          if (limit) {
            if (pos < pane1Min) scope.pane1Width = pane1Min;
            if (pos > width - pane2Min) scope.pane1Width = width - pane2Min;
          }
          pane1.elem.css('width', scope.pane1Width + 'px');
          handler.css('left', scope.pane1Width + 'px');
          pane2.elem.css('left', scope.pane1Width + handler.width() + 'px');
          scope.pane2Width = width - scope.pane1Width - handler.width();
          pane2.elem.css('width', scope.pane2Width + 'px');
          // console.log(scope.name + 'Changed', scope.pane1Width, scope.pane2Width, scope.name);
          $rootScope.$broadcast(scope.name + 'Changed', scope.pane1Width, scope.pane2Width, scope.name);
        };
        element.bind('mousemove', function (ev) {
          if (!drag) return;
          var bounds = element[0].getBoundingClientRect();
          var pos = ev.clientX - bounds.left;
          _setSplitter(pos, true);
        });

        var togglePane1 = function togglePane1(setState) {
          var oldState = scope.showDimensions;
          var newState = setState != undefined ? setState : !scope.showDimensions;
          // console.log(oldState, newState);
          if (oldState == newState) return;
          scope.showDimensions = newState;
          var state = scope.showDimensions;
          if (state == false) {
            if (pane1.elem.width()) scope.pane1ElemWidth = pane1.elem.width();
            _setSplitter(0);
          } else {
            if (scope.pane1ElemWidth) _setSplitter(scope.pane1ElemWidth);
          }
          window.isPaneOpen = state;
        };

        handler.bind('click', function (ev) {
          // if (scope.name !== 'splitter1') return;
          if (pane1.elem.width() == 0) {
            togglePane1(true);
          }
          ev.preventDefault();
        });

        handler.bind('mousemove', function (ev) {
          // if (scope.name !== 'splitter1') return;
          if (pane1.elem.width() == 0) {
            //togglePane1(true);
            window.isPaneOpen = true;
          }
          ev.preventDefault();
        });

        angular.element(document).on('showDimensions', function (src, state, pos) {
          if (scope.name !== 'splitter1') return;
          togglePane1(state);
          if (pos != undefined) {
            _setSplitter(pos, 0);
          }
        });

        scope.$watch('pos', function (pos) {
          scope.pane1ElemWidth = pos;
          if (scope.name === 'splitter1') {
            scope.showDimensions = window.isPaneOpen;
            if (!scope.showDimensions) {
              pos = 0;
            }
          }
          _setSplitter(pos, 0);
        });

        scope.$on('resize', function () {
          _setSplitter(pane1.elem.width());
        });
      }

      handler.bind('mousedown', function (ev) {
        // Fix for frame
        $('.frameOverlay').css('z-index', 2);
        drag = true;
        ev.preventDefault();
      });

      angular.element(document).bind('mouseup', function () {
        // Fix for frame
        if (!vertical) {
          // console.log(scope.name + 'Mouseup', scope.pane1Width, scope.pane2Width, scope.name);
          $rootScope.$broadcast(scope.name + 'Mouseup', scope.pane1Width, scope.pane2Width, scope.name);
        }
        $('.frameOverlay').css('z-index', -1);
        // if (drag) window.updateSize();
        drag = false;
      });
    }
  };
}]).directive('bgPane', function () {
  return {
    restrict: 'E',
    require: '^bgSplitter',
    replace: true,
    transclude: true,
    scope: {
      minSize: '=',
      hide: '='
    },
    template: '<div class="split-pane{{index}}" ng-transclude></div>',
    link: function link(scope, element, attrs, bgSplitterCtrl) {
      scope.elem = element;
      scope.index = bgSplitterCtrl.addPane(scope);
    }
  };
});

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[346]);


// WEBPACK FOOTER //
// app.js